
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var $5b38727783012434$exports = {};
/*! p5.js v1.11.13 April 08, 2026 */ !function(e1) {
    $5b38727783012434$exports = e1();
}(function() {
    var s, t, r;
    return (function o(n, s, i) {
        function a(t, e1) {
            if (!s[t]) {
                if (!n[t]) {
                    var r = undefined;
                    if (!e1 && r) return r(t, !0);
                    if (l) return l(t, !0);
                    throw (e1 = new Error("Cannot find module '" + t + "'")).code = "MODULE_NOT_FOUND", e1;
                }
                r = s[t] = {
                    exports: {}
                }, n[t][0].call(r.exports, function(e1) {
                    return a(n[t][1][e1] || e1);
                }, r, r.exports, o, n, s, i);
            }
            return s[t].exports;
        }
        for(var l = undefined, e1 = 0; e1 < i.length; e1++)a(i[e1]);
        return a;
    })({
        1: [
            function(e1, t, r) {
                "use strict";
                r.byteLength = function(e1) {
                    var e1 = c(e1), t = e1[0], e1 = e1[1];
                    return 3 * (t + e1) / 4 - e1;
                }, r.toByteArray = function(e1) {
                    var t, r, o = c(e1), n = o[0], o = o[1], s = new u(function(e1, t) {
                        return 3 * (e1 + t) / 4 - t;
                    }(n, o)), i = 0, a = 0 < o ? n - 4 : n;
                    for(r = 0; r < a; r += 4)t = l[e1.charCodeAt(r)] << 18 | l[e1.charCodeAt(r + 1)] << 12 | l[e1.charCodeAt(r + 2)] << 6 | l[e1.charCodeAt(r + 3)], s[i++] = t >> 16 & 255, s[i++] = t >> 8 & 255, s[i++] = 255 & t;
                    2 === o && (t = l[e1.charCodeAt(r)] << 2 | l[e1.charCodeAt(r + 1)] >> 4, s[i++] = 255 & t);
                    1 === o && (t = l[e1.charCodeAt(r)] << 10 | l[e1.charCodeAt(r + 1)] << 4 | l[e1.charCodeAt(r + 2)] >> 2, s[i++] = t >> 8 & 255, s[i++] = 255 & t);
                    return s;
                }, r.fromByteArray = function(e1) {
                    for(var t, r = e1.length, o = r % 3, n = [], s = 0, i = r - o; s < i; s += 16383)n.push(function(e1, t, r) {
                        for(var o, n = [], s = t; s < r; s += 3)o = (e1[s] << 16 & 16711680) + (e1[s + 1] << 8 & 65280) + (255 & e1[s + 2]), n.push(function(e1) {
                            return a[e1 >> 18 & 63] + a[e1 >> 12 & 63] + a[e1 >> 6 & 63] + a[63 & e1];
                        }(o));
                        return n.join("");
                    }(e1, s, i < s + 16383 ? i : s + 16383));
                    1 == o ? (t = e1[r - 1], n.push(a[t >> 2] + a[t << 4 & 63] + "==")) : 2 == o && (t = (e1[r - 2] << 8) + e1[r - 1], n.push(a[t >> 10] + a[t >> 4 & 63] + a[t << 2 & 63] + "="));
                    return n.join("");
                };
                for(var a = [], l = [], u = "undefined" != typeof Uint8Array ? Uint8Array : Array, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", n = 0, s = o.length; n < s; ++n)a[n] = o[n], l[o.charCodeAt(n)] = n;
                function c(e1) {
                    var t = e1.length;
                    if (0 < t % 4) throw new Error("Invalid string. Length must be a multiple of 4");
                    e1 = e1.indexOf("="), t = (e1 = -1 === e1 ? t : e1) === t ? 0 : 4 - e1 % 4;
                    return [
                        e1,
                        t
                    ];
                }
                l["-".charCodeAt(0)] = 62, l["_".charCodeAt(0)] = 63;
            },
            {}
        ],
        2: [
            function(e1, t, r) {},
            {}
        ],
        3: [
            function(e1, t, r) {},
            {}
        ],
        4: [
            function(A, e1, L) {
                (function(d) {
                    "use strict";
                    var S = A("base64-js"), s = A("ieee754"), e1 = "function" == typeof Symbol && "function" == typeof Symbol.for ? Symbol.for("nodejs.util.inspect.custom") : null, t = (L.Buffer = d, L.SlowBuffer = function(e1) {
                        +e1 != e1 && (e1 = 0);
                        return d.alloc(+e1);
                    }, L.INSPECT_MAX_BYTES = 50, 2147483647);
                    function l(e1) {
                        if (t < e1) throw new RangeError('The value "' + e1 + '" is invalid for option "size"');
                        e1 = new Uint8Array(e1);
                        return Object.setPrototypeOf(e1, d.prototype), e1;
                    }
                    function d(e1, t, r) {
                        if ("number" != typeof e1) return o(e1, t, r);
                        if ("string" == typeof t) throw new TypeError('The "string" argument must be of type string. Received type number');
                        return i(e1);
                    }
                    function o(e1, t, r) {
                        if ("string" == typeof e1) {
                            var o = e1, n = t;
                            if (d.isEncoding(n = "string" == typeof n && "" !== n ? n : "utf8")) return s = 0 | h(o, n), i = l(s), i = (o = i.write(o, n)) !== s ? i.slice(0, o) : i;
                            throw new TypeError("Unknown encoding: " + n);
                        }
                        if (ArrayBuffer.isView(e1)) return u(e1);
                        if (null != e1) {
                            if (O(e1, ArrayBuffer) || e1 && O(e1.buffer, ArrayBuffer)) {
                                var s = e1, o = t, i = r;
                                if (o < 0 || s.byteLength < o) throw new RangeError('"offset" is outside of buffer bounds');
                                if (s.byteLength < o + (i || 0)) throw new RangeError('"length" is outside of buffer bounds');
                                return s = void 0 === o && void 0 === i ? new Uint8Array(s) : void 0 === i ? new Uint8Array(s, o) : new Uint8Array(s, o, i), Object.setPrototypeOf(s, d.prototype), s;
                            }
                            if ("number" == typeof e1) throw new TypeError('The "value" argument must not be of type number. Received type number');
                            n = e1.valueOf && e1.valueOf();
                            if (null != n && n !== e1) return d.from(n, t, r);
                            var a = function(e1) {
                                var t, r;
                                if (d.isBuffer(e1)) return t = 0 | c(e1.length), 0 !== (r = l(t)).length && e1.copy(r, 0, 0, t), r;
                                if (void 0 !== e1.length) return "number" != typeof e1.length || C(e1.length) ? l(0) : u(e1);
                                if ("Buffer" === e1.type && Array.isArray(e1.data)) return u(e1.data);
                            }(e1);
                            if (a) return a;
                            if ("undefined" != typeof Symbol && null != Symbol.toPrimitive && "function" == typeof e1[Symbol.toPrimitive]) return d.from(e1[Symbol.toPrimitive]("string"), t, r);
                        }
                        throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e1);
                    }
                    function n(e1) {
                        if ("number" != typeof e1) throw new TypeError('"size" argument must be of type number');
                        if (e1 < 0) throw new RangeError('The value "' + e1 + '" is invalid for option "size"');
                    }
                    function i(e1) {
                        return n(e1), l(e1 < 0 ? 0 : 0 | c(e1));
                    }
                    function u(e1) {
                        for(var t = e1.length < 0 ? 0 : 0 | c(e1.length), r = l(t), o = 0; o < t; o += 1)r[o] = 255 & e1[o];
                        return r;
                    }
                    function c(e1) {
                        if (t <= e1) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + t.toString(16) + " bytes");
                        return 0 | e1;
                    }
                    function h(e1, t) {
                        if (d.isBuffer(e1)) return e1.length;
                        if (ArrayBuffer.isView(e1) || O(e1, ArrayBuffer)) return e1.byteLength;
                        if ("string" != typeof e1) throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof e1);
                        var r = e1.length, o = 2 < arguments.length && !0 === arguments[2];
                        if (!o && 0 === r) return 0;
                        for(var n = !1;;)switch(t){
                            case "ascii":
                            case "latin1":
                            case "binary":
                                return r;
                            case "utf8":
                            case "utf-8":
                                return E(e1).length;
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                return 2 * r;
                            case "hex":
                                return r >>> 1;
                            case "base64":
                                return M(e1).length;
                            default:
                                if (n) return o ? -1 : E(e1).length;
                                t = ("" + t).toLowerCase(), n = !0;
                        }
                    }
                    function r(e1, t, r) {
                        var o, n = !1;
                        if ((t = void 0 === t || t < 0 ? 0 : t) > this.length) return "";
                        if ((r = void 0 === r || r > this.length ? this.length : r) <= 0) return "";
                        if ((r >>>= 0) <= (t >>>= 0)) return "";
                        for(e1 = e1 || "utf8";;)switch(e1){
                            case "hex":
                                var s = this, i = t, a = r, l = s.length;
                                (!a || a < 0 || l < a) && (a = l);
                                for(var u = "", c = i = !i || i < 0 ? 0 : i; c < a; ++c)u += P[s[c]];
                                return u;
                            case "utf8":
                            case "utf-8":
                                return T(this, t, r);
                            case "ascii":
                                var d = this, l = t, h = r, f = "";
                                h = Math.min(d.length, h);
                                for(var p = l; p < h; ++p)f += String.fromCharCode(127 & d[p]);
                                return f;
                            case "latin1":
                            case "binary":
                                var m = this, i = t, y = r, g = "";
                                y = Math.min(m.length, y);
                                for(var v = i; v < y; ++v)g += String.fromCharCode(m[v]);
                                return g;
                            case "base64":
                                return b = this, o = r, 0 === (_ = t) && o === b.length ? S.fromByteArray(b) : S.fromByteArray(b.slice(_, o));
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                for(var b = t, _ = r, j = this.slice(b, _), x = "", w = 0; w < j.length; w += 2)x += String.fromCharCode(j[w] + 256 * j[w + 1]);
                                return x;
                            default:
                                if (n) throw new TypeError("Unknown encoding: " + e1);
                                e1 = (e1 + "").toLowerCase(), n = !0;
                        }
                    }
                    function a(e1, t, r) {
                        var o = e1[t];
                        e1[t] = e1[r], e1[r] = o;
                    }
                    function f(e1, t, r, o, n) {
                        if (0 === e1.length) return -1;
                        if ("string" == typeof r ? (o = r, r = 0) : 2147483647 < r ? r = 2147483647 : r < -2147483648 && (r = -2147483648), (r = (r = C(r = +r) ? n ? 0 : e1.length - 1 : r) < 0 ? e1.length + r : r) >= e1.length) {
                            if (n) return -1;
                            r = e1.length - 1;
                        } else if (r < 0) {
                            if (!n) return -1;
                            r = 0;
                        }
                        if ("string" == typeof t && (t = d.from(t, o)), d.isBuffer(t)) return 0 === t.length ? -1 : p(e1, t, r, o, n);
                        if ("number" == typeof t) return t &= 255, "function" == typeof Uint8Array.prototype.indexOf ? (n ? Uint8Array.prototype.indexOf : Uint8Array.prototype.lastIndexOf).call(e1, t, r) : p(e1, [
                            t
                        ], r, o, n);
                        throw new TypeError("val must be string, number or Buffer");
                    }
                    function p(e1, t, r, o, n) {
                        var s = 1, i = e1.length, a = t.length;
                        if (void 0 !== o && ("ucs2" === (o = String(o).toLowerCase()) || "ucs-2" === o || "utf16le" === o || "utf-16le" === o)) {
                            if (e1.length < 2 || t.length < 2) return -1;
                            i /= s = 2, a /= 2, r /= 2;
                        }
                        function l(e1, t) {
                            return 1 === s ? e1[t] : e1.readUInt16BE(t * s);
                        }
                        if (n) for(var u = -1, c = r; c < i; c++)if (l(e1, c) === l(t, -1 === u ? 0 : c - u)) {
                            if (c - (u = -1 === u ? c : u) + 1 === a) return u * s;
                        } else -1 !== u && (c -= c - u), u = -1;
                        else for(c = r = i < r + a ? i - a : r; 0 <= c; c--){
                            for(var d = !0, h = 0; h < a; h++)if (l(e1, c + h) !== l(t, h)) {
                                d = !1;
                                break;
                            }
                            if (d) return c;
                        }
                        return -1;
                    }
                    function y(e1, t, r, o) {
                        return k(function(e1) {
                            for(var t = [], r = 0; r < e1.length; ++r)t.push(255 & e1.charCodeAt(r));
                            return t;
                        }(t), e1, r, o);
                    }
                    function g(e1, t, r, o) {
                        return k(function(e1, t) {
                            for(var r, o, n = [], s = 0; s < e1.length && !((t -= 2) < 0); ++s)o = e1.charCodeAt(s), r = o >> 8, o = o % 256, n.push(o), n.push(r);
                            return n;
                        }(t, e1.length - r), e1, r, o);
                    }
                    function T(e1, t, r) {
                        r = Math.min(e1.length, r);
                        for(var o = [], n = t; n < r;){
                            var s, i, a, l, u = e1[n], c = null, d = 239 < u ? 4 : 223 < u ? 3 : 191 < u ? 2 : 1;
                            if (n + d <= r) switch(d){
                                case 1:
                                    u < 128 && (c = u);
                                    break;
                                case 2:
                                    128 == (192 & (s = e1[n + 1])) && 127 < (l = (31 & u) << 6 | 63 & s) && (c = l);
                                    break;
                                case 3:
                                    s = e1[n + 1], i = e1[n + 2], 128 == (192 & s) && 128 == (192 & i) && 2047 < (l = (15 & u) << 12 | (63 & s) << 6 | 63 & i) && (l < 55296 || 57343 < l) && (c = l);
                                    break;
                                case 4:
                                    s = e1[n + 1], i = e1[n + 2], a = e1[n + 3], 128 == (192 & s) && 128 == (192 & i) && 128 == (192 & a) && 65535 < (l = (15 & u) << 18 | (63 & s) << 12 | (63 & i) << 6 | 63 & a) && l < 1114112 && (c = l);
                            }
                            null === c ? (c = 65533, d = 1) : 65535 < c && (c -= 65536, o.push(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), o.push(c), n += d;
                        }
                        var h = o, f = h.length;
                        if (f <= v) return String.fromCharCode.apply(String, h);
                        for(var p = "", m = 0; m < f;)p += String.fromCharCode.apply(String, h.slice(m, m += v));
                        return p;
                    }
                    L.kMaxLength = t, (d.TYPED_ARRAY_SUPPORT = function() {
                        try {
                            var e1 = new Uint8Array(1), t = {
                                foo: function() {
                                    return 42;
                                }
                            };
                            return Object.setPrototypeOf(t, Uint8Array.prototype), Object.setPrototypeOf(e1, t), 42 === e1.foo();
                        } catch (e1) {
                            return !1;
                        }
                    }()) || "undefined" == typeof console || "function" != typeof console.error || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(d.prototype, "parent", {
                        enumerable: !0,
                        get: function() {
                            if (d.isBuffer(this)) return this.buffer;
                        }
                    }), Object.defineProperty(d.prototype, "offset", {
                        enumerable: !0,
                        get: function() {
                            if (d.isBuffer(this)) return this.byteOffset;
                        }
                    }), "undefined" != typeof Symbol && null != Symbol.species && d[Symbol.species] === d && Object.defineProperty(d, Symbol.species, {
                        value: null,
                        configurable: !0,
                        enumerable: !1,
                        writable: !1
                    }), d.poolSize = 8192, d.from = o, Object.setPrototypeOf(d.prototype, Uint8Array.prototype), Object.setPrototypeOf(d, Uint8Array), d.alloc = function(e1, t, r) {
                        return t, r, n(e1), !(e1 <= 0) && void 0 !== t ? "string" == typeof r ? l(e1).fill(t, r) : l(e1).fill(t) : l(e1);
                    }, d.allocUnsafe = i, d.allocUnsafeSlow = i, d.isBuffer = function(e1) {
                        return null != e1 && !0 === e1._isBuffer && e1 !== d.prototype;
                    }, d.compare = function(e1, t) {
                        if (O(e1, Uint8Array) && (e1 = d.from(e1, e1.offset, e1.byteLength)), O(t, Uint8Array) && (t = d.from(t, t.offset, t.byteLength)), !d.isBuffer(e1) || !d.isBuffer(t)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                        if (e1 === t) return 0;
                        for(var r = e1.length, o = t.length, n = 0, s = Math.min(r, o); n < s; ++n)if (e1[n] !== t[n]) {
                            r = e1[n], o = t[n];
                            break;
                        }
                        return r < o ? -1 : o < r ? 1 : 0;
                    }, d.isEncoding = function(e1) {
                        switch(String(e1).toLowerCase()){
                            case "hex":
                            case "utf8":
                            case "utf-8":
                            case "ascii":
                            case "latin1":
                            case "binary":
                            case "base64":
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                return !0;
                            default:
                                return !1;
                        }
                    }, d.concat = function(e1, t) {
                        if (!Array.isArray(e1)) throw new TypeError('"list" argument must be an Array of Buffers');
                        if (0 === e1.length) return d.alloc(0);
                        if (void 0 === t) for(n = t = 0; n < e1.length; ++n)t += e1[n].length;
                        for(var r = d.allocUnsafe(t), o = 0, n = 0; n < e1.length; ++n){
                            var s = e1[n];
                            if (O(s, Uint8Array) && (s = d.from(s)), !d.isBuffer(s)) throw new TypeError('"list" argument must be an Array of Buffers');
                            s.copy(r, o), o += s.length;
                        }
                        return r;
                    }, d.byteLength = h, d.prototype._isBuffer = !0, d.prototype.swap16 = function() {
                        var e1 = this.length;
                        if (e1 % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                        for(var t = 0; t < e1; t += 2)a(this, t, t + 1);
                        return this;
                    }, d.prototype.swap32 = function() {
                        var e1 = this.length;
                        if (e1 % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                        for(var t = 0; t < e1; t += 4)a(this, t, t + 3), a(this, t + 1, t + 2);
                        return this;
                    }, d.prototype.swap64 = function() {
                        var e1 = this.length;
                        if (e1 % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                        for(var t = 0; t < e1; t += 8)a(this, t, t + 7), a(this, t + 1, t + 6), a(this, t + 2, t + 5), a(this, t + 3, t + 4);
                        return this;
                    }, d.prototype.toLocaleString = d.prototype.toString = function() {
                        var e1 = this.length;
                        return 0 === e1 ? "" : 0 === arguments.length ? T(this, 0, e1) : r.apply(this, arguments);
                    }, d.prototype.equals = function(e1) {
                        if (d.isBuffer(e1)) return this === e1 || 0 === d.compare(this, e1);
                        throw new TypeError("Argument must be a Buffer");
                    }, d.prototype.inspect = function() {
                        var e1 = "", t = L.INSPECT_MAX_BYTES, e1 = this.toString("hex", 0, t).replace(/(.{2})/g, "$1 ").trim();
                        return this.length > t && (e1 += " ... "), "<Buffer " + e1 + ">";
                    }, e1 && (d.prototype[e1] = d.prototype.inspect), d.prototype.compare = function(e1, t, r, o, n) {
                        if (O(e1, Uint8Array) && (e1 = d.from(e1, e1.offset, e1.byteLength)), !d.isBuffer(e1)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof e1);
                        if (void 0 === r && (r = e1 ? e1.length : 0), void 0 === o && (o = 0), void 0 === n && (n = this.length), (t = void 0 === t ? 0 : t) < 0 || r > e1.length || o < 0 || n > this.length) throw new RangeError("out of range index");
                        if (n <= o && r <= t) return 0;
                        if (n <= o) return -1;
                        if (r <= t) return 1;
                        if (this === e1) return 0;
                        for(var s = (n >>>= 0) - (o >>>= 0), i = (r >>>= 0) - (t >>>= 0), a = Math.min(s, i), l = this.slice(o, n), u = e1.slice(t, r), c = 0; c < a; ++c)if (l[c] !== u[c]) {
                            s = l[c], i = u[c];
                            break;
                        }
                        return s < i ? -1 : i < s ? 1 : 0;
                    }, d.prototype.includes = function(e1, t, r) {
                        return -1 !== this.indexOf(e1, t, r);
                    }, d.prototype.indexOf = function(e1, t, r) {
                        return f(this, e1, t, r, !0);
                    }, d.prototype.lastIndexOf = function(e1, t, r) {
                        return f(this, e1, t, r, !1);
                    }, d.prototype.write = function(e1, t, r, o) {
                        if (void 0 === t) o = "utf8", r = this.length, t = 0;
                        else if (void 0 === r && "string" == typeof t) o = t, r = this.length, t = 0;
                        else {
                            if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                            t >>>= 0, isFinite(r) ? (r >>>= 0, void 0 === o && (o = "utf8")) : (o = r, r = void 0);
                        }
                        var n = this.length - t;
                        if ((void 0 === r || n < r) && (r = n), 0 < e1.length && (r < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                        o = o || "utf8";
                        for(var s, i, a, l = !1;;)switch(o){
                            case "hex":
                                var u = this, c = e1, d = t, h = r, f = (d = Number(d) || 0, u.length - d);
                                (!h || f < (h = Number(h))) && (h = f), (f = c.length) / 2 < h && (h = f / 2);
                                for(var p = 0; p < h; ++p){
                                    var m = parseInt(c.substr(2 * p, 2), 16);
                                    if (C(m)) return p;
                                    u[d + p] = m;
                                }
                                return p;
                            case "utf8":
                            case "utf-8":
                                return f = t, a = r, k(E(e1, (i = this).length - f), i, f, a);
                            case "ascii":
                                return y(this, e1, t, r);
                            case "latin1":
                            case "binary":
                                return y(this, e1, t, r);
                            case "base64":
                                return i = this, a = t, s = r, k(M(e1), i, a, s);
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                return g(this, e1, t, r);
                            default:
                                if (l) throw new TypeError("Unknown encoding: " + o);
                                o = ("" + o).toLowerCase(), l = !0;
                        }
                    }, d.prototype.toJSON = function() {
                        return {
                            type: "Buffer",
                            data: Array.prototype.slice.call(this._arr || this, 0)
                        };
                    };
                    var v = 4096;
                    function m(e1, t, r) {
                        if (e1 % 1 != 0 || e1 < 0) throw new RangeError("offset is not uint");
                        if (r < e1 + t) throw new RangeError("Trying to access beyond buffer length");
                    }
                    function b(e1, t, r, o, n, s) {
                        if (!d.isBuffer(e1)) throw new TypeError('"buffer" argument must be a Buffer instance');
                        if (n < t || t < s) throw new RangeError('"value" argument is out of bounds');
                        if (r + o > e1.length) throw new RangeError("Index out of range");
                    }
                    function _(e1, t, r, o) {
                        if (r + o > e1.length) throw new RangeError("Index out of range");
                        if (r < 0) throw new RangeError("Index out of range");
                    }
                    function j(e1, t, r, o, n) {
                        return t = +t, r >>>= 0, n || _(e1, 0, r, 4), s.write(e1, t, r, o, 23, 4), r + 4;
                    }
                    function x(e1, t, r, o, n) {
                        return t = +t, r >>>= 0, n || _(e1, 0, r, 8), s.write(e1, t, r, o, 52, 8), r + 8;
                    }
                    d.prototype.slice = function(e1, t) {
                        var r = this.length, r = ((e1 = ~~e1) < 0 ? (e1 += r) < 0 && (e1 = 0) : r < e1 && (e1 = r), (t = void 0 === t ? r : ~~t) < 0 ? (t += r) < 0 && (t = 0) : r < t && (t = r), t < e1 && (t = e1), this.subarray(e1, t));
                        return Object.setPrototypeOf(r, d.prototype), r;
                    }, d.prototype.readUIntLE = function(e1, t, r) {
                        e1 >>>= 0, t >>>= 0, r || m(e1, t, this.length);
                        for(var o = this[e1], n = 1, s = 0; ++s < t && (n *= 256);)o += this[e1 + s] * n;
                        return o;
                    }, d.prototype.readUIntBE = function(e1, t, r) {
                        e1 >>>= 0, t >>>= 0, r || m(e1, t, this.length);
                        for(var o = this[e1 + --t], n = 1; 0 < t && (n *= 256);)o += this[e1 + --t] * n;
                        return o;
                    }, d.prototype.readUInt8 = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 1, this.length), this[e1];
                    }, d.prototype.readUInt16LE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 2, this.length), this[e1] | this[e1 + 1] << 8;
                    }, d.prototype.readUInt16BE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 2, this.length), this[e1] << 8 | this[e1 + 1];
                    }, d.prototype.readUInt32LE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 4, this.length), (this[e1] | this[e1 + 1] << 8 | this[e1 + 2] << 16) + 16777216 * this[e1 + 3];
                    }, d.prototype.readUInt32BE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 4, this.length), 16777216 * this[e1] + (this[e1 + 1] << 16 | this[e1 + 2] << 8 | this[e1 + 3]);
                    }, d.prototype.readIntLE = function(e1, t, r) {
                        e1 >>>= 0, t >>>= 0, r || m(e1, t, this.length);
                        for(var o = this[e1], n = 1, s = 0; ++s < t && (n *= 256);)o += this[e1 + s] * n;
                        return (n *= 128) <= o && (o -= Math.pow(2, 8 * t)), o;
                    }, d.prototype.readIntBE = function(e1, t, r) {
                        e1 >>>= 0, t >>>= 0, r || m(e1, t, this.length);
                        for(var o = t, n = 1, s = this[e1 + --o]; 0 < o && (n *= 256);)s += this[e1 + --o] * n;
                        return (n *= 128) <= s && (s -= Math.pow(2, 8 * t)), s;
                    }, d.prototype.readInt8 = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 1, this.length), 128 & this[e1] ? -1 * (255 - this[e1] + 1) : this[e1];
                    }, d.prototype.readInt16LE = function(e1, t) {
                        e1 >>>= 0, t || m(e1, 2, this.length);
                        t = this[e1] | this[e1 + 1] << 8;
                        return 32768 & t ? 4294901760 | t : t;
                    }, d.prototype.readInt16BE = function(e1, t) {
                        e1 >>>= 0, t || m(e1, 2, this.length);
                        t = this[e1 + 1] | this[e1] << 8;
                        return 32768 & t ? 4294901760 | t : t;
                    }, d.prototype.readInt32LE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 4, this.length), this[e1] | this[e1 + 1] << 8 | this[e1 + 2] << 16 | this[e1 + 3] << 24;
                    }, d.prototype.readInt32BE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 4, this.length), this[e1] << 24 | this[e1 + 1] << 16 | this[e1 + 2] << 8 | this[e1 + 3];
                    }, d.prototype.readFloatLE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 4, this.length), s.read(this, e1, !0, 23, 4);
                    }, d.prototype.readFloatBE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 4, this.length), s.read(this, e1, !1, 23, 4);
                    }, d.prototype.readDoubleLE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 8, this.length), s.read(this, e1, !0, 52, 8);
                    }, d.prototype.readDoubleBE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 8, this.length), s.read(this, e1, !1, 52, 8);
                    }, d.prototype.writeUIntLE = function(e1, t, r, o) {
                        e1 = +e1, t >>>= 0, r >>>= 0, o || b(this, e1, t, r, Math.pow(2, 8 * r) - 1, 0);
                        var n = 1, s = 0;
                        for(this[t] = 255 & e1; ++s < r && (n *= 256);)this[t + s] = e1 / n & 255;
                        return t + r;
                    }, d.prototype.writeUIntBE = function(e1, t, r, o) {
                        e1 = +e1, t >>>= 0, r >>>= 0, o || b(this, e1, t, r, Math.pow(2, 8 * r) - 1, 0);
                        var n = r - 1, s = 1;
                        for(this[t + n] = 255 & e1; 0 <= --n && (s *= 256);)this[t + n] = e1 / s & 255;
                        return t + r;
                    }, d.prototype.writeUInt8 = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 1, 255, 0), this[t] = 255 & e1, t + 1;
                    }, d.prototype.writeUInt16LE = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 2, 65535, 0), this[t] = 255 & e1, this[t + 1] = e1 >>> 8, t + 2;
                    }, d.prototype.writeUInt16BE = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 2, 65535, 0), this[t] = e1 >>> 8, this[t + 1] = 255 & e1, t + 2;
                    }, d.prototype.writeUInt32LE = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 4, 4294967295, 0), this[t + 3] = e1 >>> 24, this[t + 2] = e1 >>> 16, this[t + 1] = e1 >>> 8, this[t] = 255 & e1, t + 4;
                    }, d.prototype.writeUInt32BE = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 4, 4294967295, 0), this[t] = e1 >>> 24, this[t + 1] = e1 >>> 16, this[t + 2] = e1 >>> 8, this[t + 3] = 255 & e1, t + 4;
                    }, d.prototype.writeIntLE = function(e1, t, r, o) {
                        e1 = +e1, t >>>= 0, o || b(this, e1, t, r, (o = Math.pow(2, 8 * r - 1)) - 1, -o);
                        var n = 0, s = 1, i = 0;
                        for(this[t] = 255 & e1; ++n < r && (s *= 256);)e1 < 0 && 0 === i && 0 !== this[t + n - 1] && (i = 1), this[t + n] = (e1 / s >> 0) - i & 255;
                        return t + r;
                    }, d.prototype.writeIntBE = function(e1, t, r, o) {
                        e1 = +e1, t >>>= 0, o || b(this, e1, t, r, (o = Math.pow(2, 8 * r - 1)) - 1, -o);
                        var n = r - 1, s = 1, i = 0;
                        for(this[t + n] = 255 & e1; 0 <= --n && (s *= 256);)e1 < 0 && 0 === i && 0 !== this[t + n + 1] && (i = 1), this[t + n] = (e1 / s >> 0) - i & 255;
                        return t + r;
                    }, d.prototype.writeInt8 = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 1, 127, -128), this[t] = 255 & (e1 = e1 < 0 ? 255 + e1 + 1 : e1), t + 1;
                    }, d.prototype.writeInt16LE = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 2, 32767, -32768), this[t] = 255 & e1, this[t + 1] = e1 >>> 8, t + 2;
                    }, d.prototype.writeInt16BE = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 2, 32767, -32768), this[t] = e1 >>> 8, this[t + 1] = 255 & e1, t + 2;
                    }, d.prototype.writeInt32LE = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 4, 2147483647, -2147483648), this[t] = 255 & e1, this[t + 1] = e1 >>> 8, this[t + 2] = e1 >>> 16, this[t + 3] = e1 >>> 24, t + 4;
                    }, d.prototype.writeInt32BE = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 4, 2147483647, -2147483648), this[t] = (e1 = e1 < 0 ? 4294967295 + e1 + 1 : e1) >>> 24, this[t + 1] = e1 >>> 16, this[t + 2] = e1 >>> 8, this[t + 3] = 255 & e1, t + 4;
                    }, d.prototype.writeFloatLE = function(e1, t, r) {
                        return j(this, e1, t, !0, r);
                    }, d.prototype.writeFloatBE = function(e1, t, r) {
                        return j(this, e1, t, !1, r);
                    }, d.prototype.writeDoubleLE = function(e1, t, r) {
                        return x(this, e1, t, !0, r);
                    }, d.prototype.writeDoubleBE = function(e1, t, r) {
                        return x(this, e1, t, !1, r);
                    }, d.prototype.copy = function(e1, t, r, o) {
                        if (!d.isBuffer(e1)) throw new TypeError("argument should be a Buffer");
                        if (r = r || 0, o || 0 === o || (o = this.length), t >= e1.length && (t = e1.length), (o = 0 < o && o < r ? r : o) === r) return 0;
                        if (0 === e1.length || 0 === this.length) return 0;
                        if ((t = t || 0) < 0) throw new RangeError("targetStart out of bounds");
                        if (r < 0 || r >= this.length) throw new RangeError("Index out of range");
                        if (o < 0) throw new RangeError("sourceEnd out of bounds");
                        o > this.length && (o = this.length);
                        var n = (o = e1.length - t < o - r ? e1.length - t + r : o) - r;
                        if (this === e1 && "function" == typeof Uint8Array.prototype.copyWithin) this.copyWithin(t, r, o);
                        else if (this === e1 && r < t && t < o) for(var s = n - 1; 0 <= s; --s)e1[s + t] = this[s + r];
                        else Uint8Array.prototype.set.call(e1, this.subarray(r, o), t);
                        return n;
                    }, d.prototype.fill = function(e1, t, r, o) {
                        if ("string" == typeof e1) {
                            if ("string" == typeof t ? (o = t, t = 0, r = this.length) : "string" == typeof r && (o = r, r = this.length), void 0 !== o && "string" != typeof o) throw new TypeError("encoding must be a string");
                            if ("string" == typeof o && !d.isEncoding(o)) throw new TypeError("Unknown encoding: " + o);
                            var n;
                            1 === e1.length && (n = e1.charCodeAt(0), ("utf8" === o && n < 128 || "latin1" === o) && (e1 = n));
                        } else "number" == typeof e1 ? e1 &= 255 : "boolean" == typeof e1 && (e1 = Number(e1));
                        if (t < 0 || this.length < t || this.length < r) throw new RangeError("Out of range index");
                        var s;
                        if (!(r <= t)) {
                            if (t >>>= 0, r = void 0 === r ? this.length : r >>> 0, "number" == typeof (e1 = e1 || 0)) for(s = t; s < r; ++s)this[s] = e1;
                            else {
                                var i = d.isBuffer(e1) ? e1 : d.from(e1, o), a = i.length;
                                if (0 === a) throw new TypeError('The value "' + e1 + '" is invalid for argument "value"');
                                for(s = 0; s < r - t; ++s)this[s + t] = i[s % a];
                            }
                        }
                        return this;
                    };
                    var w = /[^+/0-9A-Za-z-_]/g;
                    function E(e1, t) {
                        t = t || 1 / 0;
                        for(var r, o = e1.length, n = null, s = [], i = 0; i < o; ++i){
                            if (55295 < (r = e1.charCodeAt(i)) && r < 57344) {
                                if (!n) {
                                    if (56319 < r) {
                                        -1 < (t -= 3) && s.push(239, 191, 189);
                                        continue;
                                    }
                                    if (i + 1 === o) {
                                        -1 < (t -= 3) && s.push(239, 191, 189);
                                        continue;
                                    }
                                    n = r;
                                    continue;
                                }
                                if (r < 56320) {
                                    -1 < (t -= 3) && s.push(239, 191, 189), n = r;
                                    continue;
                                }
                                r = 65536 + (n - 55296 << 10 | r - 56320);
                            } else n && -1 < (t -= 3) && s.push(239, 191, 189);
                            if (n = null, r < 128) {
                                if (--t < 0) break;
                                s.push(r);
                            } else if (r < 2048) {
                                if ((t -= 2) < 0) break;
                                s.push(r >> 6 | 192, 63 & r | 128);
                            } else if (r < 65536) {
                                if ((t -= 3) < 0) break;
                                s.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
                            } else {
                                if (!(r < 1114112)) throw new Error("Invalid code point");
                                if ((t -= 4) < 0) break;
                                s.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
                            }
                        }
                        return s;
                    }
                    function M(e1) {
                        return S.toByteArray(function(e1) {
                            if ((e1 = (e1 = e1.split("=")[0]).trim().replace(w, "")).length < 2) return "";
                            for(; e1.length % 4 != 0;)e1 += "=";
                            return e1;
                        }(e1));
                    }
                    function k(e1, t, r, o) {
                        for(var n = 0; n < o && !(n + r >= t.length || n >= e1.length); ++n)t[n + r] = e1[n];
                        return n;
                    }
                    function O(e1, t) {
                        return e1 instanceof t || null != e1 && null != e1.constructor && null != e1.constructor.name && e1.constructor.name === t.name;
                    }
                    function C(e1) {
                        return e1 != e1;
                    }
                    var P = function() {
                        for(var e1 = "0123456789abcdef", t = new Array(256), r = 0; r < 16; ++r)for(var o = 16 * r, n = 0; n < 16; ++n)t[o + n] = e1[r] + e1[n];
                        return t;
                    }();
                }).call(this, A("buffer").Buffer);
            },
            {
                "base64-js": 1,
                buffer: 4,
                ieee754: 254
            }
        ],
        5: [
            function(e1, t, r) {
                t.exports = function(e1) {
                    if ("function" != typeof e1) throw TypeError(String(e1) + " is not a function");
                    return e1;
                };
            },
            {}
        ],
        6: [
            function(e1, t, r) {
                var o = e1("../internals/is-object");
                t.exports = function(e1) {
                    if (o(e1) || null === e1) return e1;
                    throw TypeError("Can't set " + String(e1) + " as a prototype");
                };
            },
            {
                "../internals/is-object": 75
            }
        ],
        7: [
            function(e1, t, r) {
                var o = e1("../internals/well-known-symbol"), n = e1("../internals/object-create"), e1 = e1("../internals/object-define-property"), s = o("unscopables"), i = Array.prototype;
                null == i[s] && e1.f(i, s, {
                    configurable: !0,
                    value: n(null)
                }), t.exports = function(e1) {
                    i[s][e1] = !0;
                };
            },
            {
                "../internals/object-create": 91,
                "../internals/object-define-property": 93,
                "../internals/well-known-symbol": 150
            }
        ],
        8: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/string-multibyte").charAt;
                t.exports = function(e1, t, r) {
                    return t + (r ? o(e1, t).length : 1);
                };
            },
            {
                "../internals/string-multibyte": 125
            }
        ],
        9: [
            function(e1, t, r) {
                t.exports = function(e1, t, r) {
                    if (e1 instanceof t) return e1;
                    throw TypeError("Incorrect " + (r ? r + " " : "") + "invocation");
                };
            },
            {}
        ],
        10: [
            function(e1, t, r) {
                var o = e1("../internals/is-object");
                t.exports = function(e1) {
                    if (o(e1)) return e1;
                    throw TypeError(String(e1) + " is not an object");
                };
            },
            {
                "../internals/is-object": 75
            }
        ],
        11: [
            function(e1, t, r) {
                t.exports = "undefined" != typeof ArrayBuffer && "undefined" != typeof DataView;
            },
            {}
        ],
        12: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return l(e1) && u(E, c(e1));
                }
                var n, s = e1("../internals/array-buffer-native"), i = e1("../internals/descriptors"), a = e1("../internals/global"), l = e1("../internals/is-object"), u = e1("../internals/has"), c = e1("../internals/classof"), d = e1("../internals/create-non-enumerable-property"), h = e1("../internals/redefine"), f = e1("../internals/object-define-property").f, p = e1("../internals/object-get-prototype-of"), m = e1("../internals/object-set-prototype-of"), y = e1("../internals/well-known-symbol"), e1 = e1("../internals/uid"), g = a.Int8Array, v = g && g.prototype, b = a.Uint8ClampedArray, b = b && b.prototype, _ = g && p(g), j = v && p(v), x = Object.prototype, w = x.isPrototypeOf, y = y("toStringTag"), S = e1("TYPED_ARRAY_TAG"), T = s && !!m && "Opera" !== c(a.opera), e1 = !1, E = {
                    Int8Array: 1,
                    Uint8Array: 1,
                    Uint8ClampedArray: 1,
                    Int16Array: 2,
                    Uint16Array: 2,
                    Int32Array: 4,
                    Uint32Array: 4,
                    Float32Array: 4,
                    Float64Array: 8
                };
                for(n in E)a[n] || (T = !1);
                if ((!T || "function" != typeof _ || _ === Function.prototype) && (_ = function() {
                    throw TypeError("Incorrect invocation");
                }, T)) for(n in E)a[n] && m(a[n], _);
                if ((!T || !j || j === x) && (j = _.prototype, T)) for(n in E)a[n] && m(a[n].prototype, j);
                if (T && p(b) !== j && m(b, j), i && !u(j, y)) for(n in e1 = !0, f(j, y, {
                    get: function() {
                        return l(this) ? this[S] : void 0;
                    }
                }), E)a[n] && d(a[n], S, n);
                t.exports = {
                    NATIVE_ARRAY_BUFFER_VIEWS: T,
                    TYPED_ARRAY_TAG: e1 && S,
                    aTypedArray: function(e1) {
                        if (o(e1)) return e1;
                        throw TypeError("Target is not a typed array");
                    },
                    aTypedArrayConstructor: function(e1) {
                        if (m) {
                            if (w.call(_, e1)) return e1;
                        } else for(var t in E)if (u(E, n)) {
                            t = a[t];
                            if (t && (e1 === t || w.call(t, e1))) return e1;
                        }
                        throw TypeError("Target is not a typed array constructor");
                    },
                    exportTypedArrayMethod: function(e1, t, r) {
                        if (i) {
                            if (r) for(var o in E){
                                o = a[o];
                                o && u(o.prototype, e1) && delete o.prototype[e1];
                            }
                            j[e1] && !r || h(j, e1, !r && T && v[e1] || t);
                        }
                    },
                    exportTypedArrayStaticMethod: function(e1, t, r) {
                        var o, n;
                        if (i) {
                            if (m) {
                                if (r) for(o in E)(n = a[o]) && u(n, e1) && delete n[e1];
                                if (_[e1] && !r) return;
                                try {
                                    return h(_, e1, !r && T && g[e1] || t);
                                } catch (e1) {}
                            }
                            for(o in E)!(n = a[o]) || n[e1] && !r || h(n, e1, t);
                        }
                    },
                    isView: function(e1) {
                        e1 = c(e1);
                        return "DataView" === e1 || u(E, e1);
                    },
                    isTypedArray: o,
                    TypedArray: _,
                    TypedArrayPrototype: j
                };
            },
            {
                "../internals/array-buffer-native": 11,
                "../internals/classof": 29,
                "../internals/create-non-enumerable-property": 38,
                "../internals/descriptors": 43,
                "../internals/global": 60,
                "../internals/has": 61,
                "../internals/is-object": 75,
                "../internals/object-define-property": 93,
                "../internals/object-get-prototype-of": 98,
                "../internals/object-set-prototype-of": 102,
                "../internals/redefine": 110,
                "../internals/uid": 147,
                "../internals/well-known-symbol": 150
            }
        ],
        13: [
            function(e1, t, D) {
                "use strict";
                function r(e1) {
                    return [
                        255 & e1
                    ];
                }
                function o(e1) {
                    return [
                        255 & e1,
                        e1 >> 8 & 255
                    ];
                }
                function n(e1) {
                    return [
                        255 & e1,
                        e1 >> 8 & 255,
                        e1 >> 16 & 255,
                        e1 >> 24 & 255
                    ];
                }
                function s(e1) {
                    return e1[3] << 24 | e1[2] << 16 | e1[1] << 8 | e1[0];
                }
                function i(e1) {
                    return C(e1, 23, 4);
                }
                function F(e1) {
                    return C(e1, 52, 8);
                }
                function a(e1, t) {
                    H(e1[w], t, {
                        get: function() {
                            return b(this)[t];
                        }
                    });
                }
                function l(e1, t, r, o) {
                    if (r = m(r), e1 = b(e1), r + t > e1.byteLength) throw O(S);
                    var n = b(e1.buffer).bytes, r = r + e1.byteOffset, e1 = n.slice(r, r + t);
                    return o ? e1 : e1.reverse();
                }
                function u(e1, t, r, o, n, s) {
                    if (r = m(r), e1 = b(e1), r + t > e1.byteLength) throw O(S);
                    for(var i = b(e1.buffer).bytes, a = r + e1.byteOffset, l = o(+n), u = 0; u < t; u++)i[a + u] = l[s ? u : t - u - 1];
                }
                var c = e1("../internals/global"), d = e1("../internals/descriptors"), U = e1("../internals/array-buffer-native"), N = e1("../internals/create-non-enumerable-property"), h = e1("../internals/redefine-all"), f = e1("../internals/fails"), p = e1("../internals/an-instance"), B = e1("../internals/to-integer"), G = e1("../internals/to-length"), m = e1("../internals/to-index"), y = e1("../internals/ieee754"), V = e1("../internals/object-get-prototype-of"), g = e1("../internals/object-set-prototype-of"), z = e1("../internals/object-get-own-property-names").f, H = e1("../internals/object-define-property").f, W = e1("../internals/array-fill"), v = e1("../internals/set-to-string-tag"), e1 = e1("../internals/internal-state"), b = e1.get, _ = e1.set, j = "ArrayBuffer", x = "DataView", w = "prototype", S = "Wrong index", T = c[j], E = T, M = c[x], e1 = M && M[w], k = Object.prototype, O = c.RangeError, C = y.pack, P = y.unpack;
                if (U) {
                    if (!f(function() {
                        T(1);
                    }) || !f(function() {
                        new T(-1);
                    }) || f(function() {
                        return new T, new T(1.5), new T(NaN), T.name != j;
                    })) {
                        for(var A, c = (E = function(e1) {
                            return p(this, E), new T(m(e1));
                        })[w] = T[w], L = z(T), R = 0; L.length > R;)(A = L[R++]) in E || N(E, A, T[A]);
                        c.constructor = E;
                    }
                    g && V(e1) !== k && g(e1, k);
                    var y = new M(new E(2)), I = e1.setInt8;
                    y.setInt8(0, 2147483648), y.setInt8(1, 2147483649), !y.getInt8(0) && y.getInt8(1) || h(e1, {
                        setInt8: function(e1, t) {
                            I.call(this, e1, t << 24 >> 24);
                        },
                        setUint8: function(e1, t) {
                            I.call(this, e1, t << 24 >> 24);
                        }
                    }, {
                        unsafe: !0
                    });
                } else E = function(e1) {
                    p(this, E, j);
                    e1 = m(e1);
                    _(this, {
                        bytes: W.call(new Array(e1), 0),
                        byteLength: e1
                    }), d || (this.byteLength = e1);
                }, M = function(e1, t, r) {
                    p(this, M, x), p(e1, E, x);
                    var o = b(e1).byteLength, t = B(t);
                    if (t < 0 || o < t) throw O("Wrong offset");
                    if (o < t + (r = void 0 === r ? o - t : G(r))) throw O("Wrong length");
                    _(this, {
                        buffer: e1,
                        byteLength: r,
                        byteOffset: t
                    }), d || (this.buffer = e1, this.byteLength = r, this.byteOffset = t);
                }, d && (a(E, "byteLength"), a(M, "buffer"), a(M, "byteLength"), a(M, "byteOffset")), h(M[w], {
                    getInt8: function(e1) {
                        return l(this, 1, e1)[0] << 24 >> 24;
                    },
                    getUint8: function(e1) {
                        return l(this, 1, e1)[0];
                    },
                    getInt16: function(e1) {
                        e1 = l(this, 2, e1, 1 < arguments.length ? arguments[1] : void 0);
                        return (e1[1] << 8 | e1[0]) << 16 >> 16;
                    },
                    getUint16: function(e1) {
                        e1 = l(this, 2, e1, 1 < arguments.length ? arguments[1] : void 0);
                        return e1[1] << 8 | e1[0];
                    },
                    getInt32: function(e1) {
                        return s(l(this, 4, e1, 1 < arguments.length ? arguments[1] : void 0));
                    },
                    getUint32: function(e1) {
                        return s(l(this, 4, e1, 1 < arguments.length ? arguments[1] : void 0)) >>> 0;
                    },
                    getFloat32: function(e1) {
                        return P(l(this, 4, e1, 1 < arguments.length ? arguments[1] : void 0), 23);
                    },
                    getFloat64: function(e1) {
                        return P(l(this, 8, e1, 1 < arguments.length ? arguments[1] : void 0), 52);
                    },
                    setInt8: function(e1, t) {
                        u(this, 1, e1, r, t);
                    },
                    setUint8: function(e1, t) {
                        u(this, 1, e1, r, t);
                    },
                    setInt16: function(e1, t) {
                        u(this, 2, e1, o, t, 2 < arguments.length ? arguments[2] : void 0);
                    },
                    setUint16: function(e1, t) {
                        u(this, 2, e1, o, t, 2 < arguments.length ? arguments[2] : void 0);
                    },
                    setInt32: function(e1, t) {
                        u(this, 4, e1, n, t, 2 < arguments.length ? arguments[2] : void 0);
                    },
                    setUint32: function(e1, t) {
                        u(this, 4, e1, n, t, 2 < arguments.length ? arguments[2] : void 0);
                    },
                    setFloat32: function(e1, t) {
                        u(this, 4, e1, i, t, 2 < arguments.length ? arguments[2] : void 0);
                    },
                    setFloat64: function(e1, t) {
                        u(this, 8, e1, F, t, 2 < arguments.length ? arguments[2] : void 0);
                    }
                });
                v(E, j), v(M, x), t.exports = {
                    ArrayBuffer: E,
                    DataView: M
                };
            },
            {
                "../internals/an-instance": 9,
                "../internals/array-buffer-native": 11,
                "../internals/array-fill": 15,
                "../internals/create-non-enumerable-property": 38,
                "../internals/descriptors": 43,
                "../internals/fails": 51,
                "../internals/global": 60,
                "../internals/ieee754": 66,
                "../internals/internal-state": 71,
                "../internals/object-define-property": 93,
                "../internals/object-get-own-property-names": 96,
                "../internals/object-get-prototype-of": 98,
                "../internals/object-set-prototype-of": 102,
                "../internals/redefine-all": 109,
                "../internals/set-to-string-tag": 119,
                "../internals/to-index": 135,
                "../internals/to-integer": 137,
                "../internals/to-length": 138
            }
        ],
        14: [
            function(e1, t, r) {
                "use strict";
                var l = e1("../internals/to-object"), u = e1("../internals/to-absolute-index"), c = e1("../internals/to-length"), d = Math.min;
                t.exports = [].copyWithin || function(e1, t) {
                    var r = l(this), o = c(r.length), n = u(e1, o), s = u(t, o), e1 = 2 < arguments.length ? arguments[2] : void 0, i = d((void 0 === e1 ? o : u(e1, o)) - s, o - n), a = 1;
                    for(s < n && n < s + i && (a = -1, s += i - 1, n += i - 1); 0 < i--;)s in r ? r[n] = r[s] : delete r[n], n += a, s += a;
                    return r;
                };
            },
            {
                "../internals/to-absolute-index": 134,
                "../internals/to-length": 138,
                "../internals/to-object": 139
            }
        ],
        15: [
            function(e1, t, r) {
                "use strict";
                var i = e1("../internals/to-object"), a = e1("../internals/to-absolute-index"), l = e1("../internals/to-length");
                t.exports = function(e1) {
                    for(var t = i(this), r = l(t.length), o = arguments.length, n = a(1 < o ? arguments[1] : void 0, r), o = 2 < o ? arguments[2] : void 0, s = void 0 === o ? r : a(o, r); n < s;)t[n++] = e1;
                    return t;
                };
            },
            {
                "../internals/to-absolute-index": 134,
                "../internals/to-length": 138,
                "../internals/to-object": 139
            }
        ],
        16: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-iteration").forEach, n = e1("../internals/array-method-is-strict"), e1 = e1("../internals/array-method-uses-to-length"), n = n("forEach"), e1 = e1("forEach");
                t.exports = n && e1 ? [].forEach : function(e1) {
                    return o(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                };
            },
            {
                "../internals/array-iteration": 19,
                "../internals/array-method-is-strict": 22,
                "../internals/array-method-uses-to-length": 23
            }
        ],
        17: [
            function(e1, t, r) {
                "use strict";
                var f = e1("../internals/function-bind-context"), p = e1("../internals/to-object"), m = e1("../internals/call-with-safe-iteration-closing"), y = e1("../internals/is-array-iterator-method"), g = e1("../internals/to-length"), v = e1("../internals/create-property"), b = e1("../internals/get-iterator-method");
                t.exports = function(e1) {
                    var t, r, o, n, s, i, a = p(e1), e1 = "function" == typeof this ? this : Array, l = arguments.length, u = 1 < l ? arguments[1] : void 0, c = void 0 !== u, d = b(a), h = 0;
                    if (c && (u = f(u, 2 < l ? arguments[2] : void 0, 2)), null == d || e1 == Array && y(d)) for(r = new e1(t = g(a.length)); h < t; h++)i = c ? u(a[h], h) : a[h], v(r, h, i);
                    else for(s = (n = d.call(a)).next, r = new e1; !(o = s.call(n)).done; h++)i = c ? m(n, u, [
                        o.value,
                        h
                    ], !0) : o.value, v(r, h, i);
                    return r.length = h, r;
                };
            },
            {
                "../internals/call-with-safe-iteration-closing": 26,
                "../internals/create-property": 40,
                "../internals/function-bind-context": 55,
                "../internals/get-iterator-method": 58,
                "../internals/is-array-iterator-method": 72,
                "../internals/to-length": 138,
                "../internals/to-object": 139
            }
        ],
        18: [
            function(e1, t, r) {
                function o(a) {
                    return function(e1, t, r) {
                        var o, n = l(e1), s = u(n.length), i = c(r, s);
                        if (a && t != t) {
                            for(; i < s;)if ((o = n[i++]) != o) return !0;
                        } else for(; i < s; i++)if ((a || i in n) && n[i] === t) return a || i || 0;
                        return !a && -1;
                    };
                }
                var l = e1("../internals/to-indexed-object"), u = e1("../internals/to-length"), c = e1("../internals/to-absolute-index");
                t.exports = {
                    includes: o(!0),
                    indexOf: o(!1)
                };
            },
            {
                "../internals/to-absolute-index": 134,
                "../internals/to-indexed-object": 136,
                "../internals/to-length": 138
            }
        ],
        19: [
            function(e1, t, r) {
                function o(h) {
                    var f = 1 == h, p = 2 == h, m = 3 == h, y = 4 == h, g = 6 == h, v = 5 == h || g;
                    return function(e1, t, r, o) {
                        for(var n, s, i = j(e1), a = _(i), l = b(t, r, 3), u = x(a.length), c = 0, t = o || w, d = f ? t(e1, u) : p ? t(e1, 0) : void 0; c < u; c++)if ((v || c in a) && (s = l(n = a[c], c, i), h)) {
                            if (f) d[c] = s;
                            else if (s) switch(h){
                                case 3:
                                    return !0;
                                case 5:
                                    return n;
                                case 6:
                                    return c;
                                case 2:
                                    S.call(d, n);
                            }
                            else if (y) return !1;
                        }
                        return g ? -1 : m || y ? y : d;
                    };
                }
                var b = e1("../internals/function-bind-context"), _ = e1("../internals/indexed-object"), j = e1("../internals/to-object"), x = e1("../internals/to-length"), w = e1("../internals/array-species-create"), S = [].push;
                t.exports = {
                    forEach: o(0),
                    map: o(1),
                    filter: o(2),
                    some: o(3),
                    every: o(4),
                    find: o(5),
                    findIndex: o(6)
                };
            },
            {
                "../internals/array-species-create": 25,
                "../internals/function-bind-context": 55,
                "../internals/indexed-object": 67,
                "../internals/to-length": 138,
                "../internals/to-object": 139
            }
        ],
        20: [
            function(e1, t, r) {
                "use strict";
                var n = e1("../internals/to-indexed-object"), s = e1("../internals/to-integer"), i = e1("../internals/to-length"), o = e1("../internals/array-method-is-strict"), e1 = e1("../internals/array-method-uses-to-length"), a = Math.min, l = [].lastIndexOf, u = !!l && 1 / [
                    1
                ].lastIndexOf(1, -0) < 0, o = o("lastIndexOf"), e1 = e1("indexOf", {
                    ACCESSORS: !0,
                    1: 0
                });
                t.exports = u || !o || !e1 ? function(e1) {
                    if (u) return l.apply(this, arguments) || 0;
                    var t = n(this), r = i(t.length), o = r - 1;
                    for((o = 1 < arguments.length ? a(o, s(arguments[1])) : o) < 0 && (o = r + o); 0 <= o; o--)if (o in t && t[o] === e1) return o || 0;
                    return -1;
                } : l;
            },
            {
                "../internals/array-method-is-strict": 22,
                "../internals/array-method-uses-to-length": 23,
                "../internals/to-indexed-object": 136,
                "../internals/to-integer": 137,
                "../internals/to-length": 138
            }
        ],
        21: [
            function(e1, t, r) {
                var o = e1("../internals/fails"), n = e1("../internals/well-known-symbol"), s = e1("../internals/engine-v8-version"), i = n("species");
                t.exports = function(t) {
                    return 51 <= s || !o(function() {
                        var e1 = [];
                        return (e1.constructor = {})[i] = function() {
                            return {
                                foo: 1
                            };
                        }, 1 !== e1[t](Boolean).foo;
                    });
                };
            },
            {
                "../internals/engine-v8-version": 48,
                "../internals/fails": 51,
                "../internals/well-known-symbol": 150
            }
        ],
        22: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/fails");
                t.exports = function(e1, t) {
                    var r = [][e1];
                    return !!r && o(function() {
                        r.call(null, t || function() {
                            throw 1;
                        }, 1);
                    });
                };
            },
            {
                "../internals/fails": 51
            }
        ],
        23: [
            function(e1, t, r) {
                function i(e1) {
                    throw e1;
                }
                var a = e1("../internals/descriptors"), l = e1("../internals/fails"), u = e1("../internals/has"), c = Object.defineProperty, d = {};
                t.exports = function(e1, t) {
                    var r, o, n, s;
                    return u(d, e1) ? d[e1] : (r = [][e1], o = !!u(t = t || {}, "ACCESSORS") && t.ACCESSORS, n = u(t, 0) ? t[0] : i, s = u(t, 1) ? t[1] : void 0, d[e1] = !!r && !l(function() {
                        if (o && !a) return !0;
                        var e1 = {
                            length: -1
                        };
                        o ? c(e1, 1, {
                            enumerable: !0,
                            get: i
                        }) : e1[1] = 1, r.call(e1, n, s);
                    }));
                };
            },
            {
                "../internals/descriptors": 43,
                "../internals/fails": 51,
                "../internals/has": 61
            }
        ],
        24: [
            function(e1, t, r) {
                function o(u) {
                    return function(e1, t, r, o) {
                        c(t);
                        var n = d(e1), s = h(n), i = f(n.length), a = u ? i - 1 : 0, l = u ? -1 : 1;
                        if (r < 2) for(;;){
                            if (a in s) {
                                o = s[a], a += l;
                                break;
                            }
                            if (a += l, u ? a < 0 : i <= a) throw TypeError("Reduce of empty array with no initial value");
                        }
                        for(; u ? 0 <= a : a < i; a += l)a in s && (o = t(o, s[a], a, n));
                        return o;
                    };
                }
                var c = e1("../internals/a-function"), d = e1("../internals/to-object"), h = e1("../internals/indexed-object"), f = e1("../internals/to-length");
                t.exports = {
                    left: o(!1),
                    right: o(!0)
                };
            },
            {
                "../internals/a-function": 5,
                "../internals/indexed-object": 67,
                "../internals/to-length": 138,
                "../internals/to-object": 139
            }
        ],
        25: [
            function(e1, t, r) {
                var o = e1("../internals/is-object"), n = e1("../internals/is-array"), s = e1("../internals/well-known-symbol")("species");
                t.exports = function(e1, t) {
                    var r;
                    return new (void 0 === (r = n(e1) && ("function" == typeof (r = e1.constructor) && (r === Array || n(r.prototype)) || o(r) && null === (r = r[s])) ? void 0 : r) ? Array : r)(0 === t ? 0 : t);
                };
            },
            {
                "../internals/is-array": 73,
                "../internals/is-object": 75,
                "../internals/well-known-symbol": 150
            }
        ],
        26: [
            function(e1, t, r) {
                var n = e1("../internals/an-object");
                t.exports = function(t, e1, r, o) {
                    try {
                        return o ? e1(n(r)[0], r[1]) : e1(r);
                    } catch (e1) {
                        o = t.return;
                        throw void 0 !== o && n(o.call(t)), e1;
                    }
                };
            },
            {
                "../internals/an-object": 10
            }
        ],
        27: [
            function(e1, t, r) {
                var n = e1("../internals/well-known-symbol")("iterator"), s = !1;
                try {
                    var o = 0, i = {
                        next: function() {
                            return {
                                done: !!o++
                            };
                        },
                        return: function() {
                            s = !0;
                        }
                    };
                    i[n] = function() {
                        return this;
                    }, Array.from(i, function() {
                        throw 2;
                    });
                } catch (e1) {}
                t.exports = function(e1, t) {
                    if (!t && !s) return !1;
                    var r = !1;
                    try {
                        var o = {};
                        o[n] = function() {
                            return {
                                next: function() {
                                    return {
                                        done: r = !0
                                    };
                                }
                            };
                        }, e1(o);
                    } catch (e1) {}
                    return r;
                };
            },
            {
                "../internals/well-known-symbol": 150
            }
        ],
        28: [
            function(e1, t, r) {
                var o = {}.toString;
                t.exports = function(e1) {
                    return o.call(e1).slice(8, -1);
                };
            },
            {}
        ],
        29: [
            function(e1, t, r) {
                var o = e1("../internals/to-string-tag-support"), n = e1("../internals/classof-raw"), s = e1("../internals/well-known-symbol")("toStringTag"), i = "Arguments" == n(function() {
                    return arguments;
                }());
                t.exports = o ? n : function(e1) {
                    var t;
                    return void 0 === e1 ? "Undefined" : null === e1 ? "Null" : "string" == typeof (t = function(e1, t) {
                        try {
                            return e1[t];
                        } catch (e1) {}
                    }(e1 = Object(e1), s)) ? t : i ? n(e1) : "Object" == (t = n(e1)) && "function" == typeof e1.callee ? "Arguments" : t;
                };
            },
            {
                "../internals/classof-raw": 28,
                "../internals/to-string-tag-support": 143,
                "../internals/well-known-symbol": 150
            }
        ],
        30: [
            function(e1, t, r) {
                "use strict";
                var u = e1("../internals/object-define-property").f, c = e1("../internals/object-create"), d = e1("../internals/redefine-all"), h = e1("../internals/function-bind-context"), f = e1("../internals/an-instance"), p = e1("../internals/iterate"), i = e1("../internals/define-iterator"), a = e1("../internals/set-species"), m = e1("../internals/descriptors"), y = e1("../internals/internal-metadata").fastKey, e1 = e1("../internals/internal-state"), g = e1.set, v = e1.getterFor;
                t.exports = {
                    getConstructor: function(e1, r, o, n) {
                        function s(e1, t, r) {
                            var o, n = l(e1), s = i(e1, t);
                            return s ? s.value = r : (n.last = s = {
                                index: o = y(t, !0),
                                key: t,
                                value: r,
                                previous: t = n.last,
                                next: void 0,
                                removed: !1
                            }, n.first || (n.first = s), t && (t.next = s), m ? n.size++ : e1.size++, "F" !== o && (n.index[o] = s)), e1;
                        }
                        function i(e1, t) {
                            var r, e1 = l(e1), o = y(t);
                            if ("F" !== o) return e1.index[o];
                            for(r = e1.first; r; r = r.next)if (r.key == t) return r;
                        }
                        var a = e1(function(e1, t) {
                            f(e1, a, r), g(e1, {
                                type: r,
                                index: c(null),
                                first: void 0,
                                last: void 0,
                                size: 0
                            }), m || (e1.size = 0), null != t && p(t, e1[n], e1, o);
                        }), l = v(r);
                        return d(a.prototype, {
                            clear: function() {
                                for(var e1 = l(this), t = e1.index, r = e1.first; r;)r.removed = !0, r.previous && (r.previous = r.previous.next = void 0), delete t[r.index], r = r.next;
                                e1.first = e1.last = void 0, m ? e1.size = 0 : this.size = 0;
                            },
                            delete: function(e1) {
                                var t, r, o = l(this), e1 = i(this, e1);
                                return e1 && (t = e1.next, r = e1.previous, delete o.index[e1.index], e1.removed = !0, r && (r.next = t), t && (t.previous = r), o.first == e1 && (o.first = t), o.last == e1 && (o.last = r), m ? o.size-- : this.size--), !!e1;
                            },
                            forEach: function(e1) {
                                for(var t, r = l(this), o = h(e1, 1 < arguments.length ? arguments[1] : void 0, 3); t = t ? t.next : r.first;)for(o(t.value, t.key, this); t && t.removed;)t = t.previous;
                            },
                            has: function(e1) {
                                return !!i(this, e1);
                            }
                        }), d(a.prototype, o ? {
                            get: function(e1) {
                                e1 = i(this, e1);
                                return e1 && e1.value;
                            },
                            set: function(e1, t) {
                                return s(this, 0 === e1 ? 0 : e1, t);
                            }
                        } : {
                            add: function(e1) {
                                return s(this, e1 = 0 === e1 ? 0 : e1, e1);
                            }
                        }), m && u(a.prototype, "size", {
                            get: function() {
                                return l(this).size;
                            }
                        }), a;
                    },
                    setStrong: function(e1, t, r) {
                        var o = t + " Iterator", n = v(t), s = v(o);
                        i(e1, t, function(e1, t) {
                            g(this, {
                                type: o,
                                target: e1,
                                state: n(e1),
                                kind: t,
                                last: void 0
                            });
                        }, function() {
                            for(var e1 = s(this), t = e1.kind, r = e1.last; r && r.removed;)r = r.previous;
                            return e1.target && (e1.last = r = r ? r.next : e1.state.first) ? "keys" == t ? {
                                value: r.key,
                                done: !1
                            } : "values" == t ? {
                                value: r.value,
                                done: !1
                            } : {
                                value: [
                                    r.key,
                                    r.value
                                ],
                                done: !1
                            } : {
                                value: e1.target = void 0,
                                done: !0
                            };
                        }, r ? "entries" : "values", !r, !0), a(t);
                    }
                };
            },
            {
                "../internals/an-instance": 9,
                "../internals/define-iterator": 41,
                "../internals/descriptors": 43,
                "../internals/function-bind-context": 55,
                "../internals/internal-metadata": 70,
                "../internals/internal-state": 71,
                "../internals/iterate": 78,
                "../internals/object-create": 91,
                "../internals/object-define-property": 93,
                "../internals/redefine-all": 109,
                "../internals/set-species": 118
            }
        ],
        31: [
            function(e1, t, r) {
                "use strict";
                function l(e1) {
                    return e1.frozen || (e1.frozen = new o);
                }
                function o() {
                    this.entries = [];
                }
                function n(e1, t) {
                    return i(e1.entries, function(e1) {
                        return e1[0] === t;
                    });
                }
                var u = e1("../internals/redefine-all"), c = e1("../internals/internal-metadata").getWeakData, d = e1("../internals/an-object"), h = e1("../internals/is-object"), f = e1("../internals/an-instance"), p = e1("../internals/iterate"), s = e1("../internals/array-iteration"), m = e1("../internals/has"), e1 = e1("../internals/internal-state"), y = e1.set, g = e1.getterFor, i = s.find, a = s.findIndex, v = 0;
                o.prototype = {
                    get: function(e1) {
                        e1 = n(this, e1);
                        if (e1) return e1[1];
                    },
                    has: function(e1) {
                        return !!n(this, e1);
                    },
                    set: function(e1, t) {
                        var r = n(this, e1);
                        r ? r[1] = t : this.entries.push([
                            e1,
                            t
                        ]);
                    },
                    delete: function(t) {
                        var e1 = a(this.entries, function(e1) {
                            return e1[0] === t;
                        });
                        return ~e1 && this.entries.splice(e1, 1), !!~e1;
                    }
                }, t.exports = {
                    getConstructor: function(e1, r, o, n) {
                        function s(e1, t, r) {
                            var o = a(e1), n = c(d(t), !0);
                            return !0 === n ? l(o).set(t, r) : n[o.id] = r, e1;
                        }
                        var i = e1(function(e1, t) {
                            f(e1, i, r), y(e1, {
                                type: r,
                                id: v++,
                                frozen: void 0
                            }), null != t && p(t, e1[n], e1, o);
                        }), a = g(r);
                        return u(i.prototype, {
                            delete: function(e1) {
                                var t, r = a(this);
                                return !!h(e1) && (!0 === (t = c(e1)) ? l(r).delete(e1) : t && m(t, r.id) && delete t[r.id]);
                            },
                            has: function(e1) {
                                var t, r = a(this);
                                return !!h(e1) && (!0 === (t = c(e1)) ? l(r).has(e1) : t && m(t, r.id));
                            }
                        }), u(i.prototype, o ? {
                            get: function(e1) {
                                var t, r = a(this);
                                if (h(e1)) return !0 === (t = c(e1)) ? l(r).get(e1) : t ? t[r.id] : void 0;
                            },
                            set: function(e1, t) {
                                return s(this, e1, t);
                            }
                        } : {
                            add: function(e1) {
                                return s(this, e1, !0);
                            }
                        }), i;
                    }
                };
            },
            {
                "../internals/an-instance": 9,
                "../internals/an-object": 10,
                "../internals/array-iteration": 19,
                "../internals/has": 61,
                "../internals/internal-metadata": 70,
                "../internals/internal-state": 71,
                "../internals/is-object": 75,
                "../internals/iterate": 78,
                "../internals/redefine-all": 109
            }
        ],
        32: [
            function(e1, t, r) {
                "use strict";
                var y = e1("../internals/export"), g = e1("../internals/global"), v = e1("../internals/is-forced"), b = e1("../internals/redefine"), _ = e1("../internals/internal-metadata"), j = e1("../internals/iterate"), x = e1("../internals/an-instance"), w = e1("../internals/is-object"), S = e1("../internals/fails"), T = e1("../internals/check-correctness-of-iteration"), E = e1("../internals/set-to-string-tag"), M = e1("../internals/inherit-if-required");
                t.exports = function(r, e1, t) {
                    function o(e1) {
                        var r = f[e1];
                        b(f, e1, "add" == e1 ? function(e1) {
                            return r.call(this, 0 === e1 ? 0 : e1), this;
                        } : "delete" == e1 ? function(e1) {
                            return !(c && !w(e1)) && r.call(this, 0 === e1 ? 0 : e1);
                        } : "get" == e1 ? function(e1) {
                            return c && !w(e1) ? void 0 : r.call(this, 0 === e1 ? 0 : e1);
                        } : "has" == e1 ? function(e1) {
                            return !(c && !w(e1)) && r.call(this, 0 === e1 ? 0 : e1);
                        } : function(e1, t) {
                            return r.call(this, 0 === e1 ? 0 : e1, t), this;
                        });
                    }
                    var n, s, i, a, l, u = -1 !== r.indexOf("Map"), c = -1 !== r.indexOf("Weak"), d = u ? "set" : "add", h = g[r], f = h && h.prototype, p = h, m = {};
                    return v(r, "function" != typeof h || !(c || f.forEach && !S(function() {
                        (new h).entries().next();
                    }))) ? (p = t.getConstructor(e1, r, u, d), _.REQUIRED = !0) : v(r, !0) && (s = (n = new p)[d](c ? {} : -0, 1) != n, i = S(function() {
                        n.has(1);
                    }), a = T(function(e1) {
                        new h(e1);
                    }), l = !c && S(function() {
                        for(var e1 = new h, t = 5; t--;)e1[d](t, t);
                        return !e1.has(-0);
                    }), a || (((p = e1(function(e1, t) {
                        x(e1, p, r);
                        e1 = M(new h, e1, p);
                        return null != t && j(t, e1[d], e1, u), e1;
                    })).prototype = f).constructor = p), (i || l) && (o("delete"), o("has"), u && o("get")), (l || s) && o(d), c && f.clear && delete f.clear), m[r] = p, y({
                        global: !0,
                        forced: p != h
                    }, m), E(p, r), c || t.setStrong(p, r, u), p;
                };
            },
            {
                "../internals/an-instance": 9,
                "../internals/check-correctness-of-iteration": 27,
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/global": 60,
                "../internals/inherit-if-required": 68,
                "../internals/internal-metadata": 70,
                "../internals/is-forced": 74,
                "../internals/is-object": 75,
                "../internals/iterate": 78,
                "../internals/redefine": 110,
                "../internals/set-to-string-tag": 119
            }
        ],
        33: [
            function(e1, t, r) {
                var a = e1("../internals/has"), l = e1("../internals/own-keys"), u = e1("../internals/object-get-own-property-descriptor"), c = e1("../internals/object-define-property");
                t.exports = function(e1, t) {
                    for(var r = l(t), o = c.f, n = u.f, s = 0; s < r.length; s++){
                        var i = r[s];
                        a(e1, i) || o(e1, i, n(t, i));
                    }
                };
            },
            {
                "../internals/has": 61,
                "../internals/object-define-property": 93,
                "../internals/object-get-own-property-descriptor": 94,
                "../internals/own-keys": 105
            }
        ],
        34: [
            function(e1, t, r) {
                var o = e1("../internals/well-known-symbol")("match");
                t.exports = function(t) {
                    var r = /./;
                    try {
                        "/./"[t](r);
                    } catch (e1) {
                        try {
                            return r[o] = !1, "/./"[t](r);
                        } catch (e1) {}
                    }
                    return !1;
                };
            },
            {
                "../internals/well-known-symbol": 150
            }
        ],
        35: [
            function(e1, t, r) {
                e1 = e1("../internals/fails");
                t.exports = !e1(function() {
                    function e1() {}
                    return e1.prototype.constructor = null, Object.getPrototypeOf(new e1) !== e1.prototype;
                });
            },
            {
                "../internals/fails": 51
            }
        ],
        36: [
            function(e1, t, r) {
                var s = e1("../internals/require-object-coercible"), i = /"/g;
                t.exports = function(e1, t, r, o) {
                    var e1 = String(s(e1)), n = "<" + t;
                    return "" !== r && (n += " " + r + '="' + String(o).replace(i, "&quot;") + '"'), n + ">" + e1 + "</" + t + ">";
                };
            },
            {
                "../internals/require-object-coercible": 115
            }
        ],
        37: [
            function(e1, t, r) {
                "use strict";
                function o() {
                    return this;
                }
                var n = e1("../internals/iterators-core").IteratorPrototype, s = e1("../internals/object-create"), i = e1("../internals/create-property-descriptor"), a = e1("../internals/set-to-string-tag"), l = e1("../internals/iterators");
                t.exports = function(e1, t, r) {
                    t += " Iterator";
                    return e1.prototype = s(n, {
                        next: i(1, r)
                    }), a(e1, t, !1, !0), l[t] = o, e1;
                };
            },
            {
                "../internals/create-property-descriptor": 39,
                "../internals/iterators": 80,
                "../internals/iterators-core": 79,
                "../internals/object-create": 91,
                "../internals/set-to-string-tag": 119
            }
        ],
        38: [
            function(e1, t, r) {
                var o = e1("../internals/descriptors"), n = e1("../internals/object-define-property"), s = e1("../internals/create-property-descriptor");
                t.exports = o ? function(e1, t, r) {
                    return n.f(e1, t, s(1, r));
                } : function(e1, t, r) {
                    return e1[t] = r, e1;
                };
            },
            {
                "../internals/create-property-descriptor": 39,
                "../internals/descriptors": 43,
                "../internals/object-define-property": 93
            }
        ],
        39: [
            function(e1, t, r) {
                t.exports = function(e1, t) {
                    return {
                        enumerable: !(1 & e1),
                        configurable: !(2 & e1),
                        writable: !(4 & e1),
                        value: t
                    };
                };
            },
            {}
        ],
        40: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/to-primitive"), n = e1("../internals/object-define-property"), s = e1("../internals/create-property-descriptor");
                t.exports = function(e1, t, r) {
                    t = o(t);
                    t in e1 ? n.f(e1, t, s(0, r)) : e1[t] = r;
                };
            },
            {
                "../internals/create-property-descriptor": 39,
                "../internals/object-define-property": 93,
                "../internals/to-primitive": 142
            }
        ],
        41: [
            function(e1, t, r) {
                "use strict";
                function m() {
                    return this;
                }
                var y = e1("../internals/export"), g = e1("../internals/create-iterator-constructor"), v = e1("../internals/object-get-prototype-of"), b = e1("../internals/object-set-prototype-of"), _ = e1("../internals/set-to-string-tag"), j = e1("../internals/create-non-enumerable-property"), x = e1("../internals/redefine"), o = e1("../internals/well-known-symbol"), w = e1("../internals/is-pure"), S = e1("../internals/iterators"), e1 = e1("../internals/iterators-core"), T = e1.IteratorPrototype, E = e1.BUGGY_SAFARI_ITERATORS, M = o("iterator"), k = "values", O = "entries";
                t.exports = function(e1, t, r, o, n, s, i) {
                    g(r, t, o);
                    function a(e1) {
                        if (e1 === n && f) return f;
                        if (!E && e1 in d) return d[e1];
                        switch(e1){
                            case "keys":
                            case k:
                            case O:
                                return function() {
                                    return new r(this, e1);
                                };
                        }
                        return function() {
                            return new r(this);
                        };
                    }
                    var l, u, o = t + " Iterator", c = !1, d = e1.prototype, h = d[M] || d["@@iterator"] || n && d[n], f = !E && h || a(n), p = "Array" == t && d.entries || h;
                    if (p && (p = v(p.call(new e1)), T !== Object.prototype && p.next && (w || v(p) === T || (b ? b(p, T) : "function" != typeof p[M] && j(p, M, m)), _(p, o, !0, !0), w && (S[o] = m))), n == k && h && h.name !== k && (c = !0, f = function() {
                        return h.call(this);
                    }), w && !i || d[M] === f || j(d, M, f), S[t] = f, n) {
                        if (l = {
                            values: a(k),
                            keys: s ? f : a("keys"),
                            entries: a(O)
                        }, i) for(u in l)!E && !c && u in d || x(d, u, l[u]);
                        else y({
                            target: t,
                            proto: !0,
                            forced: E || c
                        }, l);
                    }
                    return l;
                };
            },
            {
                "../internals/create-iterator-constructor": 37,
                "../internals/create-non-enumerable-property": 38,
                "../internals/export": 50,
                "../internals/is-pure": 76,
                "../internals/iterators": 80,
                "../internals/iterators-core": 79,
                "../internals/object-get-prototype-of": 98,
                "../internals/object-set-prototype-of": 102,
                "../internals/redefine": 110,
                "../internals/set-to-string-tag": 119,
                "../internals/well-known-symbol": 150
            }
        ],
        42: [
            function(e1, t, r) {
                var o = e1("../internals/path"), n = e1("../internals/has"), s = e1("../internals/well-known-symbol-wrapped"), i = e1("../internals/object-define-property").f;
                t.exports = function(e1) {
                    var t = o.Symbol || (o.Symbol = {});
                    n(t, e1) || i(t, e1, {
                        value: s.f(e1)
                    });
                };
            },
            {
                "../internals/has": 61,
                "../internals/object-define-property": 93,
                "../internals/path": 106,
                "../internals/well-known-symbol-wrapped": 149
            }
        ],
        43: [
            function(e1, t, r) {
                e1 = e1("../internals/fails");
                t.exports = !e1(function() {
                    return 7 != Object.defineProperty({}, 1, {
                        get: function() {
                            return 7;
                        }
                    })[1];
                });
            },
            {
                "../internals/fails": 51
            }
        ],
        44: [
            function(e1, t, r) {
                var o = e1("../internals/global"), e1 = e1("../internals/is-object"), n = o.document, s = e1(n) && e1(n.createElement);
                t.exports = function(e1) {
                    return s ? n.createElement(e1) : {};
                };
            },
            {
                "../internals/global": 60,
                "../internals/is-object": 75
            }
        ],
        45: [
            function(e1, t, r) {
                t.exports = {
                    CSSRuleList: 0,
                    CSSStyleDeclaration: 0,
                    CSSValueList: 0,
                    ClientRectList: 0,
                    DOMRectList: 0,
                    DOMStringList: 0,
                    DOMTokenList: 1,
                    DataTransferItemList: 0,
                    FileList: 0,
                    HTMLAllCollection: 0,
                    HTMLCollection: 0,
                    HTMLFormElement: 0,
                    HTMLSelectElement: 0,
                    MediaList: 0,
                    MimeTypeArray: 0,
                    NamedNodeMap: 0,
                    NodeList: 1,
                    PaintRequestList: 0,
                    Plugin: 0,
                    PluginArray: 0,
                    SVGLengthList: 0,
                    SVGNumberList: 0,
                    SVGPathSegList: 0,
                    SVGPointList: 0,
                    SVGStringList: 0,
                    SVGTransformList: 0,
                    SourceBufferList: 0,
                    StyleSheetList: 0,
                    TextTrackCueList: 0,
                    TextTrackList: 0,
                    TouchList: 0
                };
            },
            {}
        ],
        46: [
            function(e1, t, r) {
                e1 = e1("../internals/engine-user-agent");
                t.exports = /(iphone|ipod|ipad).*applewebkit/i.test(e1);
            },
            {
                "../internals/engine-user-agent": 47
            }
        ],
        47: [
            function(e1, t, r) {
                e1 = e1("../internals/get-built-in");
                t.exports = e1("navigator", "userAgent") || "";
            },
            {
                "../internals/get-built-in": 57
            }
        ],
        48: [
            function(e1, t, r) {
                var o, n, s = e1("../internals/global"), e1 = e1("../internals/engine-user-agent"), s = s.process, s = s && s.versions, s = s && s.v8;
                s ? n = (o = s.split("."))[0] + o[1] : e1 && (!(o = e1.match(/Edge\/(\d+)/)) || 74 <= o[1]) && (o = e1.match(/Chrome\/(\d+)/)) && (n = o[1]), t.exports = n && +n;
            },
            {
                "../internals/engine-user-agent": 47,
                "../internals/global": 60
            }
        ],
        49: [
            function(e1, t, r) {
                t.exports = [
                    "constructor",
                    "hasOwnProperty",
                    "isPrototypeOf",
                    "propertyIsEnumerable",
                    "toLocaleString",
                    "toString",
                    "valueOf"
                ];
            },
            {}
        ],
        50: [
            function(e1, t, r) {
                var u = e1("../internals/global"), c = e1("../internals/object-get-own-property-descriptor").f, d = e1("../internals/create-non-enumerable-property"), h = e1("../internals/redefine"), f = e1("../internals/set-global"), p = e1("../internals/copy-constructor-properties"), m = e1("../internals/is-forced");
                t.exports = function(e1, t) {
                    var r, o, n, s = e1.target, i = e1.global, a = e1.stat, l = i ? u : a ? u[s] || f(s, {}) : (u[s] || {}).prototype;
                    if (l) for(r in t){
                        if (o = t[r], n = e1.noTargetGet ? (n = c(l, r)) && n.value : l[r], !m(i ? r : s + (a ? "." : "#") + r, e1.forced) && void 0 !== n) {
                            if (typeof o == typeof n) continue;
                            p(o, n);
                        }
                        (e1.sham || n && n.sham) && d(o, "sham", !0), h(l, r, o, e1);
                    }
                };
            },
            {
                "../internals/copy-constructor-properties": 33,
                "../internals/create-non-enumerable-property": 38,
                "../internals/global": 60,
                "../internals/is-forced": 74,
                "../internals/object-get-own-property-descriptor": 94,
                "../internals/redefine": 110,
                "../internals/set-global": 117
            }
        ],
        51: [
            function(e1, t, r) {
                t.exports = function(e1) {
                    try {
                        return !!e1();
                    } catch (e1) {
                        return !0;
                    }
                };
            },
            {}
        ],
        52: [
            function(e1, t, r) {
                "use strict";
                e1("../modules/es.regexp.exec");
                var u = e1("../internals/redefine"), c = e1("../internals/fails"), d = e1("../internals/well-known-symbol"), h = e1("../internals/regexp-exec"), f = e1("../internals/create-non-enumerable-property"), p = d("species"), m = !c(function() {
                    var e1 = /./;
                    return e1.exec = function() {
                        var e1 = [];
                        return e1.groups = {
                            a: "7"
                        }, e1;
                    }, "7" !== "".replace(e1, "$<a>");
                }), y = "$0" === "a".replace(/./, "$0"), e1 = d("replace"), g = !!/./[e1] && "" === /./[e1]("a", "$0"), v = !c(function() {
                    var e1 = /(?:)/, t = e1.exec, e1 = (e1.exec = function() {
                        return t.apply(this, arguments);
                    }, "ab".split(e1));
                    return 2 !== e1.length || "a" !== e1[0] || "b" !== e1[1];
                });
                t.exports = function(r, e1, t, o) {
                    var s, n, i = d(r), a = !c(function() {
                        var e1 = {};
                        return e1[i] = function() {
                            return 7;
                        }, 7 != ""[r](e1);
                    }), l = a && !c(function() {
                        var e1 = !1, t = /a/;
                        return "split" === r && ((t = {
                            constructor: {}
                        }).constructor[p] = function() {
                            return t;
                        }, t.flags = "", t[i] = /./[i]), t.exec = function() {
                            return e1 = !0, null;
                        }, t[i](""), !e1;
                    });
                    a && l && ("replace" !== r || m && y && !g) && ("split" !== r || v) || (s = /./[i], t = (l = t(i, ""[r], function(e1, t, r, o, n) {
                        return t.exec === h ? a && !n ? {
                            done: !0,
                            value: s.call(t, r, o)
                        } : {
                            done: !0,
                            value: e1.call(r, t, o)
                        } : {
                            done: !1
                        };
                    }, {
                        REPLACE_KEEPS_$0: y,
                        REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: g
                    }))[0], n = l[1], u(String.prototype, r, t), u(RegExp.prototype, i, 2 == e1 ? function(e1, t) {
                        return n.call(e1, this, t);
                    } : function(e1) {
                        return n.call(e1, this);
                    })), o && f(RegExp.prototype[i], "sham", !0);
                };
            },
            {
                "../internals/create-non-enumerable-property": 38,
                "../internals/fails": 51,
                "../internals/redefine": 110,
                "../internals/regexp-exec": 112,
                "../internals/well-known-symbol": 150,
                "../modules/es.regexp.exec": 195
            }
        ],
        53: [
            function(e1, t, r) {
                "use strict";
                function h(e1, t, r, o, n, s, i, a) {
                    for(var l, u = n, c = 0, d = !!i && m(i, a, 3); c < o;){
                        if (c in r) {
                            if (l = d ? d(r[c], c, t) : r[c], 0 < s && f(l)) u = h(e1, t, l, p(l.length), u, s - 1) - 1;
                            else {
                                if (9007199254740991 <= u) throw TypeError("Exceed the acceptable array length");
                                e1[u] = l;
                            }
                            u++;
                        }
                        c++;
                    }
                    return u;
                }
                var f = e1("../internals/is-array"), p = e1("../internals/to-length"), m = e1("../internals/function-bind-context");
                t.exports = h;
            },
            {
                "../internals/function-bind-context": 55,
                "../internals/is-array": 73,
                "../internals/to-length": 138
            }
        ],
        54: [
            function(e1, t, r) {
                e1 = e1("../internals/fails");
                t.exports = !e1(function() {
                    return Object.isExtensible(Object.preventExtensions({}));
                });
            },
            {
                "../internals/fails": 51
            }
        ],
        55: [
            function(e1, t, r) {
                var s = e1("../internals/a-function");
                t.exports = function(o, n, e1) {
                    if (s(o), void 0 === n) return o;
                    switch(e1){
                        case 0:
                            return function() {
                                return o.call(n);
                            };
                        case 1:
                            return function(e1) {
                                return o.call(n, e1);
                            };
                        case 2:
                            return function(e1, t) {
                                return o.call(n, e1, t);
                            };
                        case 3:
                            return function(e1, t, r) {
                                return o.call(n, e1, t, r);
                            };
                    }
                    return function() {
                        return o.apply(n, arguments);
                    };
                };
            },
            {
                "../internals/a-function": 5
            }
        ],
        56: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/a-function"), n = e1("../internals/is-object"), c = [].slice, d = {};
                t.exports = Function.bind || function(i) {
                    var a = o(this), l = c.call(arguments, 1), u = function() {
                        var e1 = l.concat(c.call(arguments));
                        if (this instanceof u) {
                            var t = a, r = e1.length, o = e1;
                            if (!(r in d)) {
                                for(var n = [], s = 0; s < r; s++)n[s] = "a[" + s + "]";
                                d[r] = Function("C,a", "return new C(" + n.join(",") + ")");
                            }
                            return d[r](t, o);
                        }
                        return a.apply(i, e1);
                    };
                    return n(a.prototype) && (u.prototype = a.prototype), u;
                };
            },
            {
                "../internals/a-function": 5,
                "../internals/is-object": 75
            }
        ],
        57: [
            function(e1, t, r) {
                function o(e1) {
                    return "function" == typeof e1 ? e1 : void 0;
                }
                var n = e1("../internals/path"), s = e1("../internals/global");
                t.exports = function(e1, t) {
                    return arguments.length < 2 ? o(n[e1]) || o(s[e1]) : n[e1] && n[e1][t] || s[e1] && s[e1][t];
                };
            },
            {
                "../internals/global": 60,
                "../internals/path": 106
            }
        ],
        58: [
            function(e1, t, r) {
                var o = e1("../internals/classof"), n = e1("../internals/iterators"), s = e1("../internals/well-known-symbol")("iterator");
                t.exports = function(e1) {
                    if (null != e1) return e1[s] || e1["@@iterator"] || n[o(e1)];
                };
            },
            {
                "../internals/classof": 29,
                "../internals/iterators": 80,
                "../internals/well-known-symbol": 150
            }
        ],
        59: [
            function(e1, t, r) {
                var o = e1("../internals/an-object"), n = e1("../internals/get-iterator-method");
                t.exports = function(e1) {
                    var t = n(e1);
                    if ("function" != typeof t) throw TypeError(String(e1) + " is not iterable");
                    return o(t.call(e1));
                };
            },
            {
                "../internals/an-object": 10,
                "../internals/get-iterator-method": 58
            }
        ],
        60: [
            function(e1, r, t) {
                (function(e1) {
                    function t(e1) {
                        return e1 && e1.Math == Math && e1;
                    }
                    r.exports = t("object" == typeof globalThis && globalThis) || t("object" == typeof window && window) || t("object" == typeof self && self) || t("object" == typeof e1 && e1) || Function("return this")();
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        61: [
            function(e1, t, r) {
                var o = {}.hasOwnProperty;
                t.exports = function(e1, t) {
                    return o.call(e1, t);
                };
            },
            {}
        ],
        62: [
            function(e1, t, r) {
                t.exports = {};
            },
            {}
        ],
        63: [
            function(e1, t, r) {
                var o = e1("../internals/global");
                t.exports = function(e1, t) {
                    var r = o.console;
                    r && r.error && (1 === arguments.length ? r.error(e1) : r.error(e1, t));
                };
            },
            {
                "../internals/global": 60
            }
        ],
        64: [
            function(e1, t, r) {
                e1 = e1("../internals/get-built-in");
                t.exports = e1("document", "documentElement");
            },
            {
                "../internals/get-built-in": 57
            }
        ],
        65: [
            function(e1, t, r) {
                var o = e1("../internals/descriptors"), n = e1("../internals/fails"), s = e1("../internals/document-create-element");
                t.exports = !o && !n(function() {
                    return 7 != Object.defineProperty(s("div"), "a", {
                        get: function() {
                            return 7;
                        }
                    }).a;
                });
            },
            {
                "../internals/descriptors": 43,
                "../internals/document-create-element": 44,
                "../internals/fails": 51
            }
        ],
        66: [
            function(e1, t, r) {
                var h = Math.abs, f = Math.pow, p = Math.floor, m = Math.log, y = Math.LN2;
                t.exports = {
                    pack: function(e1, t, r) {
                        var o, n, s, i = new Array(r), a = 8 * r - t - 1, r = (1 << a) - 1, l = r >> 1, u = 23 === t ? f(2, -24) - f(2, -77) : 0, c = e1 < 0 || 0 === e1 && 1 / e1 < 0 ? 1 : 0, d = 0;
                        for((e1 = h(e1)) != e1 || e1 === 1 / 0 ? (n = e1 != e1 ? 1 : 0, o = r) : (o = p(m(e1) / y), e1 * (s = f(2, -o)) < 1 && (o--, s *= 2), 2 <= (e1 += 1 <= o + l ? u / s : u * f(2, 1 - l)) * s && (o++, s /= 2), r <= o + l ? (n = 0, o = r) : 1 <= o + l ? (n = (e1 * s - 1) * f(2, t), o += l) : (n = e1 * f(2, l - 1) * f(2, t), o = 0)); 8 <= t; i[d++] = 255 & n, n /= 256, t -= 8);
                        for(o = o << t | n, a += t; 0 < a; i[d++] = 255 & o, o /= 256, a -= 8);
                        return i[--d] |= 128 * c, i;
                    },
                    unpack: function(e1, t) {
                        var r, o = e1.length, n = 8 * o - t - 1, s = (1 << n) - 1, i = s >> 1, a = n - 7, l = o - 1, n = e1[l--], u = 127 & n;
                        for(n >>= 7; 0 < a; u = 256 * u + e1[l], l--, a -= 8);
                        for(r = u & (1 << -a) - 1, u >>= -a, a += t; 0 < a; r = 256 * r + e1[l], l--, a -= 8);
                        if (0 === u) u = 1 - i;
                        else {
                            if (u === s) return r ? NaN : n ? -1 / 0 : 1 / 0;
                            r += f(2, t), u -= i;
                        }
                        return (n ? -1 : 1) * r * f(2, u - t);
                    }
                };
            },
            {}
        ],
        67: [
            function(e1, t, r) {
                var o = e1("../internals/fails"), n = e1("../internals/classof-raw"), s = "".split;
                t.exports = o(function() {
                    return !Object("z").propertyIsEnumerable(0);
                }) ? function(e1) {
                    return "String" == n(e1) ? s.call(e1, "") : Object(e1);
                } : Object;
            },
            {
                "../internals/classof-raw": 28,
                "../internals/fails": 51
            }
        ],
        68: [
            function(e1, t, r) {
                var o = e1("../internals/is-object"), n = e1("../internals/object-set-prototype-of");
                t.exports = function(e1, t, r) {
                    return n && "function" == typeof (t = t.constructor) && t !== r && o(t = t.prototype) && t !== r.prototype && n(e1, t), e1;
                };
            },
            {
                "../internals/is-object": 75,
                "../internals/object-set-prototype-of": 102
            }
        ],
        69: [
            function(e1, t, r) {
                var e1 = e1("../internals/shared-store"), o = Function.toString;
                "function" != typeof e1.inspectSource && (e1.inspectSource = function(e1) {
                    return o.call(e1);
                }), t.exports = e1.inspectSource;
            },
            {
                "../internals/shared-store": 121
            }
        ],
        70: [
            function(e1, t, r) {
                function o(e1) {
                    a(e1, c, {
                        value: {
                            objectID: "O" + ++d,
                            weakData: {}
                        }
                    });
                }
                var n = e1("../internals/hidden-keys"), s = e1("../internals/is-object"), i = e1("../internals/has"), a = e1("../internals/object-define-property").f, l = e1("../internals/uid"), u = e1("../internals/freezing"), c = l("meta"), d = 0, h = Object.isExtensible || function() {
                    return !0;
                }, f = t.exports = {
                    REQUIRED: !1,
                    fastKey: function(e1, t) {
                        if (!s(e1)) return "symbol" == typeof e1 ? e1 : ("string" == typeof e1 ? "S" : "P") + e1;
                        if (!i(e1, c)) {
                            if (!h(e1)) return "F";
                            if (!t) return "E";
                            o(e1);
                        }
                        return e1[c].objectID;
                    },
                    getWeakData: function(e1, t) {
                        if (!i(e1, c)) {
                            if (!h(e1)) return !0;
                            if (!t) return !1;
                            o(e1);
                        }
                        return e1[c].weakData;
                    },
                    onFreeze: function(e1) {
                        return u && f.REQUIRED && h(e1) && !i(e1, c) && o(e1), e1;
                    }
                };
                n[c] = !0;
            },
            {
                "../internals/freezing": 54,
                "../internals/has": 61,
                "../internals/hidden-keys": 62,
                "../internals/is-object": 75,
                "../internals/object-define-property": 93,
                "../internals/uid": 147
            }
        ],
        71: [
            function(e1, t, r) {
                var o, n, s, i, a, l, u, c, d = e1("../internals/native-weak-map"), h = e1("../internals/global"), f = e1("../internals/is-object"), p = e1("../internals/create-non-enumerable-property"), m = e1("../internals/has"), y = e1("../internals/shared-key"), e1 = e1("../internals/hidden-keys"), h = h.WeakMap;
                u = d ? (o = new h, n = o.get, s = o.has, i = o.set, a = function(e1, t) {
                    return i.call(o, e1, t), t;
                }, l = function(e1) {
                    return n.call(o, e1) || {};
                }, function(e1) {
                    return s.call(o, e1);
                }) : (e1[c = y("state")] = !0, a = function(e1, t) {
                    return p(e1, c, t), t;
                }, l = function(e1) {
                    return m(e1, c) ? e1[c] : {};
                }, function(e1) {
                    return m(e1, c);
                }), t.exports = {
                    set: a,
                    get: l,
                    has: u,
                    enforce: function(e1) {
                        return u(e1) ? l(e1) : a(e1, {});
                    },
                    getterFor: function(t) {
                        return function(e1) {
                            if (f(e1) && (e1 = l(e1)).type === t) return e1;
                            throw TypeError("Incompatible receiver, " + t + " required");
                        };
                    }
                };
            },
            {
                "../internals/create-non-enumerable-property": 38,
                "../internals/global": 60,
                "../internals/has": 61,
                "../internals/hidden-keys": 62,
                "../internals/is-object": 75,
                "../internals/native-weak-map": 86,
                "../internals/shared-key": 120
            }
        ],
        72: [
            function(e1, t, r) {
                var o = e1("../internals/well-known-symbol"), n = e1("../internals/iterators"), s = o("iterator"), i = Array.prototype;
                t.exports = function(e1) {
                    return void 0 !== e1 && (n.Array === e1 || i[s] === e1);
                };
            },
            {
                "../internals/iterators": 80,
                "../internals/well-known-symbol": 150
            }
        ],
        73: [
            function(e1, t, r) {
                var o = e1("../internals/classof-raw");
                t.exports = Array.isArray || function(e1) {
                    return "Array" == o(e1);
                };
            },
            {
                "../internals/classof-raw": 28
            }
        ],
        74: [
            function(e1, t, r) {
                function o(e1, t) {
                    return (e1 = a[i(e1)]) == u || e1 != l && ("function" == typeof t ? n(t) : !!t);
                }
                var n = e1("../internals/fails"), s = /#|\.prototype\./, i = o.normalize = function(e1) {
                    return String(e1).replace(s, ".").toLowerCase();
                }, a = o.data = {}, l = o.NATIVE = "N", u = o.POLYFILL = "P";
                t.exports = o;
            },
            {
                "../internals/fails": 51
            }
        ],
        75: [
            function(e1, t, r) {
                t.exports = function(e1) {
                    return "object" == typeof e1 ? null !== e1 : "function" == typeof e1;
                };
            },
            {}
        ],
        76: [
            function(e1, t, r) {
                t.exports = !1;
            },
            {}
        ],
        77: [
            function(e1, t, r) {
                var o = e1("../internals/is-object"), n = e1("../internals/classof-raw"), s = e1("../internals/well-known-symbol")("match");
                t.exports = function(e1) {
                    var t;
                    return o(e1) && (void 0 !== (t = e1[s]) ? !!t : "RegExp" == n(e1));
                };
            },
            {
                "../internals/classof-raw": 28,
                "../internals/is-object": 75,
                "../internals/well-known-symbol": 150
            }
        ],
        78: [
            function(e1, t, r) {
                function h(e1, t) {
                    this.stopped = e1, this.result = t;
                }
                var f = e1("../internals/an-object"), p = e1("../internals/is-array-iterator-method"), m = e1("../internals/to-length"), y = e1("../internals/function-bind-context"), g = e1("../internals/get-iterator-method"), v = e1("../internals/call-with-safe-iteration-closing");
                (t.exports = function(e1, t, r, o, n) {
                    var s, i, a, l, u, c, d = y(t, r, o ? 2 : 1);
                    if (n) s = e1;
                    else {
                        if ("function" != typeof (t = g(e1))) throw TypeError("Target is not iterable");
                        if (p(t)) {
                            for(i = 0, a = m(e1.length); i < a; i++)if ((l = o ? d(f(c = e1[i])[0], c[1]) : d(e1[i])) && l instanceof h) return l;
                            return new h(!1);
                        }
                        s = t.call(e1);
                    }
                    for(u = s.next; !(c = u.call(s)).done;)if ("object" == typeof (l = v(s, d, c.value, o)) && l && l instanceof h) return l;
                    return new h(!1);
                }).stop = function(e1) {
                    return new h(!0, e1);
                };
            },
            {
                "../internals/an-object": 10,
                "../internals/call-with-safe-iteration-closing": 26,
                "../internals/function-bind-context": 55,
                "../internals/get-iterator-method": 58,
                "../internals/is-array-iterator-method": 72,
                "../internals/to-length": 138
            }
        ],
        79: [
            function(e1, t, r) {
                "use strict";
                var o, n, s = e1("../internals/object-get-prototype-of"), i = e1("../internals/create-non-enumerable-property"), a = e1("../internals/has"), l = e1("../internals/well-known-symbol"), e1 = e1("../internals/is-pure"), l = l("iterator"), u = !1;
                [].keys && ("next" in (n = [].keys()) ? (s = s(s(n))) !== Object.prototype && (o = s) : u = !0), null == o && (o = {}), e1 || a(o, l) || i(o, l, function() {
                    return this;
                }), t.exports = {
                    IteratorPrototype: o,
                    BUGGY_SAFARI_ITERATORS: u
                };
            },
            {
                "../internals/create-non-enumerable-property": 38,
                "../internals/has": 61,
                "../internals/is-pure": 76,
                "../internals/object-get-prototype-of": 98,
                "../internals/well-known-symbol": 150
            }
        ],
        80: [
            function(e1, t, r) {
                t.exports = {};
            },
            {}
        ],
        81: [
            function(e1, t, r) {
                t.exports = Math.sign || function(e1) {
                    return 0 == (e1 = +e1) || e1 != e1 ? e1 : e1 < 0 ? -1 : 1;
                };
            },
            {}
        ],
        82: [
            function(e1, t, r) {
                var o, n, s, i, a, l, u, c, d = e1("../internals/global"), h = e1("../internals/object-get-own-property-descriptor").f, f = e1("../internals/classof-raw"), p = e1("../internals/task").set, e1 = e1("../internals/engine-is-ios"), m = d.MutationObserver || d.WebKitMutationObserver, y = d.process, g = d.Promise, v = "process" == f(y), f = h(d, "queueMicrotask"), h = f && f.value;
                h || (o = function() {
                    var e1, t;
                    for(v && (e1 = y.domain) && e1.exit(); n;){
                        t = n.fn, n = n.next;
                        try {
                            t();
                        } catch (e1) {
                            throw n ? i() : s = void 0, e1;
                        }
                    }
                    s = void 0, e1 && e1.enter();
                }, i = v ? function() {
                    y.nextTick(o);
                } : m && !e1 ? (a = !0, l = document.createTextNode(""), new m(o).observe(l, {
                    characterData: !0
                }), function() {
                    l.data = a = !a;
                }) : g && g.resolve ? (u = g.resolve(void 0), c = u.then, function() {
                    c.call(u, o);
                }) : function() {
                    p.call(d, o);
                }), t.exports = h || function(e1) {
                    e1 = {
                        fn: e1,
                        next: void 0
                    };
                    s && (s.next = e1), n || (n = e1, i()), s = e1;
                };
            },
            {
                "../internals/classof-raw": 28,
                "../internals/engine-is-ios": 46,
                "../internals/global": 60,
                "../internals/object-get-own-property-descriptor": 94,
                "../internals/task": 132
            }
        ],
        83: [
            function(e1, t, r) {
                e1 = e1("../internals/global");
                t.exports = e1.Promise;
            },
            {
                "../internals/global": 60
            }
        ],
        84: [
            function(e1, t, r) {
                e1 = e1("../internals/fails");
                t.exports = !!Object.getOwnPropertySymbols && !e1(function() {
                    return !String(Symbol());
                });
            },
            {
                "../internals/fails": 51
            }
        ],
        85: [
            function(e1, t, r) {
                var o = e1("../internals/fails"), n = e1("../internals/well-known-symbol"), s = e1("../internals/is-pure"), i = n("iterator");
                t.exports = !o(function() {
                    var e1 = new URL("b?a=1&b=2&c=3", "http://a"), r = e1.searchParams, o = "";
                    return e1.pathname = "c%20d", r.forEach(function(e1, t) {
                        r.delete("b"), o += t + e1;
                    }), s && !e1.toJSON || !r.sort || "http://a/c%20d?a=1&c=3" !== e1.href || "3" !== r.get("c") || "a=1" !== String(new URLSearchParams("?a=1")) || !r[i] || "a" !== new URL("https://a@b").username || "b" !== new URLSearchParams(new URLSearchParams("a=b")).get("a") || "xn--e1aybc" !== new URL("http://\u0442\u0435\u0441\u0442").host || "#%D0%B1" !== new URL("http://a#\u0431").hash || "a1c3" !== o || "x" !== new URL("http://x", void 0).host;
                });
            },
            {
                "../internals/fails": 51,
                "../internals/is-pure": 76,
                "../internals/well-known-symbol": 150
            }
        ],
        86: [
            function(e1, t, r) {
                var o = e1("../internals/global"), e1 = e1("../internals/inspect-source"), o = o.WeakMap;
                t.exports = "function" == typeof o && /native code/.test(e1(o));
            },
            {
                "../internals/global": 60,
                "../internals/inspect-source": 69
            }
        ],
        87: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    var r, o;
                    this.promise = new e1(function(e1, t) {
                        if (void 0 !== r || void 0 !== o) throw TypeError("Bad Promise constructor");
                        r = e1, o = t;
                    }), this.resolve = n(r), this.reject = n(o);
                }
                var n = e1("../internals/a-function");
                t.exports.f = function(e1) {
                    return new o(e1);
                };
            },
            {
                "../internals/a-function": 5
            }
        ],
        88: [
            function(e1, t, r) {
                var o = e1("../internals/is-regexp");
                t.exports = function(e1) {
                    if (o(e1)) throw TypeError("The method doesn't accept regular expressions");
                    return e1;
                };
            },
            {
                "../internals/is-regexp": 77
            }
        ],
        89: [
            function(e1, t, r) {
                var o = e1("../internals/global").isFinite;
                t.exports = Number.isFinite || function(e1) {
                    return "number" == typeof e1 && o(e1);
                };
            },
            {
                "../internals/global": 60
            }
        ],
        90: [
            function(e1, t, r) {
                "use strict";
                var h = e1("../internals/descriptors"), o = e1("../internals/fails"), f = e1("../internals/object-keys"), p = e1("../internals/object-get-own-property-symbols"), m = e1("../internals/object-property-is-enumerable"), y = e1("../internals/to-object"), g = e1("../internals/indexed-object"), n = Object.assign, s = Object.defineProperty;
                t.exports = !n || o(function() {
                    var e1, t, r, o;
                    return !(!h || 1 === n({
                        b: 1
                    }, n(s({}, "a", {
                        enumerable: !0,
                        get: function() {
                            s(this, "b", {
                                value: 3,
                                enumerable: !1
                            });
                        }
                    }), {
                        b: 2
                    })).b) || (t = {}, o = "abcdefghijklmnopqrst", (e1 = {})[r = Symbol()] = 7, o.split("").forEach(function(e1) {
                        t[e1] = e1;
                    }), 7 != n({}, e1)[r] || f(n({}, t)).join("") != o);
                }) ? function(e1, t) {
                    for(var r = y(e1), o = arguments.length, n = 1, s = p.f, i = m.f; n < o;)for(var a, l = g(arguments[n++]), u = s ? f(l).concat(s(l)) : f(l), c = u.length, d = 0; d < c;)a = u[d++], h && !i.call(l, a) || (r[a] = l[a]);
                    return r;
                } : n;
            },
            {
                "../internals/descriptors": 43,
                "../internals/fails": 51,
                "../internals/indexed-object": 67,
                "../internals/object-get-own-property-symbols": 97,
                "../internals/object-keys": 100,
                "../internals/object-property-is-enumerable": 101,
                "../internals/to-object": 139
            }
        ],
        91: [
            function(e1, t, r) {
                function o() {}
                var n, s = e1("../internals/an-object"), i = e1("../internals/object-define-properties"), a = e1("../internals/enum-bug-keys"), l = e1("../internals/hidden-keys"), u = e1("../internals/html"), c = e1("../internals/document-create-element"), e1 = e1("../internals/shared-key"), d = "prototype", h = "script", f = e1("IE_PROTO"), p = function(e1) {
                    return "<" + h + ">" + e1 + "</" + h + ">";
                }, m = function() {
                    try {
                        n = document.domain && new ActiveXObject("htmlfile");
                    } catch (e1) {}
                    m = n ? ((e1 = n).write(p("")), e1.close(), t = e1.parentWindow.Object, e1 = null, t) : (e1 = c("iframe"), t = "java" + h + ":", e1.style.display = "none", u.appendChild(e1), e1.src = String(t), (t = e1.contentWindow.document).open(), t.write(p("document.F=Object")), t.close(), t.F);
                    for(var e1, t, r = a.length; r--;)delete m[d][a[r]];
                    return m();
                };
                l[f] = !0, t.exports = Object.create || function(e1, t) {
                    var r;
                    return null !== e1 ? (o[d] = s(e1), r = new o, o[d] = null, r[f] = e1) : r = m(), void 0 === t ? r : i(r, t);
                };
            },
            {
                "../internals/an-object": 10,
                "../internals/document-create-element": 44,
                "../internals/enum-bug-keys": 49,
                "../internals/hidden-keys": 62,
                "../internals/html": 64,
                "../internals/object-define-properties": 92,
                "../internals/shared-key": 120
            }
        ],
        92: [
            function(e1, t, r) {
                var o = e1("../internals/descriptors"), i = e1("../internals/object-define-property"), a = e1("../internals/an-object"), l = e1("../internals/object-keys");
                t.exports = o ? Object.defineProperties : function(e1, t) {
                    a(e1);
                    for(var r, o = l(t), n = o.length, s = 0; s < n;)i.f(e1, r = o[s++], t[r]);
                    return e1;
                };
            },
            {
                "../internals/an-object": 10,
                "../internals/descriptors": 43,
                "../internals/object-define-property": 93,
                "../internals/object-keys": 100
            }
        ],
        93: [
            function(e1, t, r) {
                var o = e1("../internals/descriptors"), n = e1("../internals/ie8-dom-define"), s = e1("../internals/an-object"), i = e1("../internals/to-primitive"), a = Object.defineProperty;
                r.f = o ? a : function(e1, t, r) {
                    if (s(e1), t = i(t, !0), s(r), n) try {
                        return a(e1, t, r);
                    } catch (e1) {}
                    if ("get" in r || "set" in r) throw TypeError("Accessors not supported");
                    return "value" in r && (e1[t] = r.value), e1;
                };
            },
            {
                "../internals/an-object": 10,
                "../internals/descriptors": 43,
                "../internals/ie8-dom-define": 65,
                "../internals/to-primitive": 142
            }
        ],
        94: [
            function(e1, t, r) {
                var o = e1("../internals/descriptors"), n = e1("../internals/object-property-is-enumerable"), s = e1("../internals/create-property-descriptor"), i = e1("../internals/to-indexed-object"), a = e1("../internals/to-primitive"), l = e1("../internals/has"), u = e1("../internals/ie8-dom-define"), c = Object.getOwnPropertyDescriptor;
                r.f = o ? c : function(e1, t) {
                    if (e1 = i(e1), t = a(t, !0), u) try {
                        return c(e1, t);
                    } catch (e1) {}
                    if (l(e1, t)) return s(!n.f.call(e1, t), e1[t]);
                };
            },
            {
                "../internals/create-property-descriptor": 39,
                "../internals/descriptors": 43,
                "../internals/has": 61,
                "../internals/ie8-dom-define": 65,
                "../internals/object-property-is-enumerable": 101,
                "../internals/to-indexed-object": 136,
                "../internals/to-primitive": 142
            }
        ],
        95: [
            function(e1, t, r) {
                var o = e1("../internals/to-indexed-object"), n = e1("../internals/object-get-own-property-names").f, s = {}.toString, i = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
                t.exports.f = function(e1) {
                    if (!i || "[object Window]" != s.call(e1)) return n(o(e1));
                    try {
                        return n(e1);
                    } catch (e1) {
                        return i.slice();
                    }
                };
            },
            {
                "../internals/object-get-own-property-names": 96,
                "../internals/to-indexed-object": 136
            }
        ],
        96: [
            function(e1, t, r) {
                var o = e1("../internals/object-keys-internal"), n = e1("../internals/enum-bug-keys").concat("length", "prototype");
                r.f = Object.getOwnPropertyNames || function(e1) {
                    return o(e1, n);
                };
            },
            {
                "../internals/enum-bug-keys": 49,
                "../internals/object-keys-internal": 99
            }
        ],
        97: [
            function(e1, t, r) {
                r.f = Object.getOwnPropertySymbols;
            },
            {}
        ],
        98: [
            function(e1, t, r) {
                var o = e1("../internals/has"), n = e1("../internals/to-object"), s = e1("../internals/shared-key"), e1 = e1("../internals/correct-prototype-getter"), i = s("IE_PROTO"), a = Object.prototype;
                t.exports = e1 ? Object.getPrototypeOf : function(e1) {
                    return e1 = n(e1), o(e1, i) ? e1[i] : "function" == typeof e1.constructor && e1 instanceof e1.constructor ? e1.constructor.prototype : e1 instanceof Object ? a : null;
                };
            },
            {
                "../internals/correct-prototype-getter": 35,
                "../internals/has": 61,
                "../internals/shared-key": 120,
                "../internals/to-object": 139
            }
        ],
        99: [
            function(e1, t, r) {
                var i = e1("../internals/has"), a = e1("../internals/to-indexed-object"), l = e1("../internals/array-includes").indexOf, u = e1("../internals/hidden-keys");
                t.exports = function(e1, t) {
                    var r, o = a(e1), n = 0, s = [];
                    for(r in o)!i(u, r) && i(o, r) && s.push(r);
                    for(; t.length > n;)!i(o, r = t[n++]) || ~l(s, r) || s.push(r);
                    return s;
                };
            },
            {
                "../internals/array-includes": 18,
                "../internals/has": 61,
                "../internals/hidden-keys": 62,
                "../internals/to-indexed-object": 136
            }
        ],
        100: [
            function(e1, t, r) {
                var o = e1("../internals/object-keys-internal"), n = e1("../internals/enum-bug-keys");
                t.exports = Object.keys || function(e1) {
                    return o(e1, n);
                };
            },
            {
                "../internals/enum-bug-keys": 49,
                "../internals/object-keys-internal": 99
            }
        ],
        101: [
            function(e1, t, r) {
                "use strict";
                var o = {}.propertyIsEnumerable, n = Object.getOwnPropertyDescriptor, s = n && !o.call({
                    1: 2
                }, 1);
                r.f = s ? function(e1) {
                    e1 = n(this, e1);
                    return !!e1 && e1.enumerable;
                } : o;
            },
            {}
        ],
        102: [
            function(e1, t, r) {
                var n = e1("../internals/an-object"), s = e1("../internals/a-possible-prototype");
                t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
                    var r, o = !1, e1 = {};
                    try {
                        (r = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(e1, []), o = e1 instanceof Array;
                    } catch (e1) {}
                    return function(e1, t) {
                        return n(e1), s(t), o ? r.call(e1, t) : e1.__proto__ = t, e1;
                    };
                }() : void 0);
            },
            {
                "../internals/a-possible-prototype": 6,
                "../internals/an-object": 10
            }
        ],
        103: [
            function(e1, t, r) {
                function o(a) {
                    return function(e1) {
                        for(var t, r = c(e1), o = u(r), n = o.length, s = 0, i = []; s < n;)t = o[s++], l && !d.call(r, t) || i.push(a ? [
                            t,
                            r[t]
                        ] : r[t]);
                        return i;
                    };
                }
                var l = e1("../internals/descriptors"), u = e1("../internals/object-keys"), c = e1("../internals/to-indexed-object"), d = e1("../internals/object-property-is-enumerable").f;
                t.exports = {
                    entries: o(!0),
                    values: o(!1)
                };
            },
            {
                "../internals/descriptors": 43,
                "../internals/object-keys": 100,
                "../internals/object-property-is-enumerable": 101,
                "../internals/to-indexed-object": 136
            }
        ],
        104: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/to-string-tag-support"), n = e1("../internals/classof");
                t.exports = o ? ({}).toString : function() {
                    return "[object " + n(this) + "]";
                };
            },
            {
                "../internals/classof": 29,
                "../internals/to-string-tag-support": 143
            }
        ],
        105: [
            function(e1, t, r) {
                var o = e1("../internals/get-built-in"), n = e1("../internals/object-get-own-property-names"), s = e1("../internals/object-get-own-property-symbols"), i = e1("../internals/an-object");
                t.exports = o("Reflect", "ownKeys") || function(e1) {
                    var t = n.f(i(e1)), r = s.f;
                    return r ? t.concat(r(e1)) : t;
                };
            },
            {
                "../internals/an-object": 10,
                "../internals/get-built-in": 57,
                "../internals/object-get-own-property-names": 96,
                "../internals/object-get-own-property-symbols": 97
            }
        ],
        106: [
            function(e1, t, r) {
                e1 = e1("../internals/global");
                t.exports = e1;
            },
            {
                "../internals/global": 60
            }
        ],
        107: [
            function(e1, t, r) {
                t.exports = function(e1) {
                    try {
                        return {
                            error: !1,
                            value: e1()
                        };
                    } catch (e1) {
                        return {
                            error: !0,
                            value: e1
                        };
                    }
                };
            },
            {}
        ],
        108: [
            function(e1, t, r) {
                var o = e1("../internals/an-object"), n = e1("../internals/is-object"), s = e1("../internals/new-promise-capability");
                t.exports = function(e1, t) {
                    return o(e1), n(t) && t.constructor === e1 ? t : ((0, (e1 = s.f(e1)).resolve)(t), e1.promise);
                };
            },
            {
                "../internals/an-object": 10,
                "../internals/is-object": 75,
                "../internals/new-promise-capability": 87
            }
        ],
        109: [
            function(e1, t, r) {
                var n = e1("../internals/redefine");
                t.exports = function(e1, t, r) {
                    for(var o in t)n(e1, o, t[o], r);
                    return e1;
                };
            },
            {
                "../internals/redefine": 110
            }
        ],
        110: [
            function(e1, t, r) {
                var i = e1("../internals/global"), a = e1("../internals/create-non-enumerable-property"), l = e1("../internals/has"), u = e1("../internals/set-global"), o = e1("../internals/inspect-source"), e1 = e1("../internals/internal-state"), n = e1.get, c = e1.enforce, d = String(String).split("String");
                (t.exports = function(e1, t, r, o) {
                    var n = !!o && !!o.unsafe, s = !!o && !!o.enumerable, o = !!o && !!o.noTargetGet;
                    "function" == typeof r && ("string" != typeof t || l(r, "name") || a(r, "name", t), c(r).source = d.join("string" == typeof t ? t : "")), e1 === i ? s ? e1[t] = r : u(t, r) : (n ? !o && e1[t] && (s = !0) : delete e1[t], s ? e1[t] = r : a(e1, t, r));
                })(Function.prototype, "toString", function() {
                    return "function" == typeof this && n(this).source || o(this);
                });
            },
            {
                "../internals/create-non-enumerable-property": 38,
                "../internals/global": 60,
                "../internals/has": 61,
                "../internals/inspect-source": 69,
                "../internals/internal-state": 71,
                "../internals/set-global": 117
            }
        ],
        111: [
            function(e1, t, r) {
                var o = e1("./classof-raw"), n = e1("./regexp-exec");
                t.exports = function(e1, t) {
                    var r = e1.exec;
                    if ("function" == typeof r) {
                        r = r.call(e1, t);
                        if ("object" != typeof r) throw TypeError("RegExp exec method returned something other than an Object or null");
                        return r;
                    }
                    if ("RegExp" !== o(e1)) throw TypeError("RegExp#exec called on incompatible receiver");
                    return n.call(e1, t);
                };
            },
            {
                "./classof-raw": 28,
                "./regexp-exec": 112
            }
        ],
        112: [
            function(e1, t, r) {
                "use strict";
                var o, n, d = e1("./regexp-flags"), e1 = e1("./regexp-sticky-helpers"), h = RegExp.prototype.exec, f = String.prototype.replace, s = h, p = (o = /a/, n = /b*/g, h.call(o, "a"), h.call(n, "a"), 0 !== o.lastIndex || 0 !== n.lastIndex), m = e1.UNSUPPORTED_Y || e1.BROKEN_CARET, y = void 0 !== /()??/.exec("")[1];
                t.exports = s = p || y || m ? function(e1) {
                    var t, r, o, n, s = this, i = m && s.sticky, a = d.call(s), l = s.source, u = 0, c = e1;
                    return i && (-1 === (a = a.replace("y", "")).indexOf("g") && (a += "g"), c = String(e1).slice(s.lastIndex), 0 < s.lastIndex && (!s.multiline || s.multiline && "\n" !== e1[s.lastIndex - 1]) && (l = "(?: " + l + ")", c = " " + c, u++), r = new RegExp("^(?:" + l + ")", a)), y && (r = new RegExp("^" + l + "$(?!\\s)", a)), p && (t = s.lastIndex), o = h.call(i ? r : s, c), i ? o ? (o.input = o.input.slice(u), o[0] = o[0].slice(u), o.index = s.lastIndex, s.lastIndex += o[0].length) : s.lastIndex = 0 : p && o && (s.lastIndex = s.global ? o.index + o[0].length : t), y && o && 1 < o.length && f.call(o[0], r, function() {
                        for(n = 1; n < arguments.length - 2; n++)void 0 === arguments[n] && (o[n] = void 0);
                    }), o;
                } : s;
            },
            {
                "./regexp-flags": 113,
                "./regexp-sticky-helpers": 114
            }
        ],
        113: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/an-object");
                t.exports = function() {
                    var e1 = o(this), t = "";
                    return e1.global && (t += "g"), e1.ignoreCase && (t += "i"), e1.multiline && (t += "m"), e1.dotAll && (t += "s"), e1.unicode && (t += "u"), e1.sticky && (t += "y"), t;
                };
            },
            {
                "../internals/an-object": 10
            }
        ],
        114: [
            function(e1, t, r) {
                "use strict";
                e1 = e1("./fails");
                function o(e1, t) {
                    return RegExp(e1, t);
                }
                r.UNSUPPORTED_Y = e1(function() {
                    var e1 = o("a", "y");
                    return e1.lastIndex = 2, null != e1.exec("abcd");
                }), r.BROKEN_CARET = e1(function() {
                    var e1 = o("^r", "gy");
                    return e1.lastIndex = 2, null != e1.exec("str");
                });
            },
            {
                "./fails": 51
            }
        ],
        115: [
            function(e1, t, r) {
                t.exports = function(e1) {
                    if (null == e1) throw TypeError("Can't call method on " + e1);
                    return e1;
                };
            },
            {}
        ],
        116: [
            function(e1, t, r) {
                t.exports = Object.is || function(e1, t) {
                    return e1 === t ? 0 !== e1 || 1 / e1 == 1 / t : e1 != e1 && t != t;
                };
            },
            {}
        ],
        117: [
            function(e1, t, r) {
                var o = e1("../internals/global"), n = e1("../internals/create-non-enumerable-property");
                t.exports = function(t, r) {
                    try {
                        n(o, t, r);
                    } catch (e1) {
                        o[t] = r;
                    }
                    return r;
                };
            },
            {
                "../internals/create-non-enumerable-property": 38,
                "../internals/global": 60
            }
        ],
        118: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/get-built-in"), n = e1("../internals/object-define-property"), s = e1("../internals/well-known-symbol"), i = e1("../internals/descriptors"), a = s("species");
                t.exports = function(e1) {
                    var e1 = o(e1), t = n.f;
                    i && e1 && !e1[a] && t(e1, a, {
                        configurable: !0,
                        get: function() {
                            return this;
                        }
                    });
                };
            },
            {
                "../internals/descriptors": 43,
                "../internals/get-built-in": 57,
                "../internals/object-define-property": 93,
                "../internals/well-known-symbol": 150
            }
        ],
        119: [
            function(e1, t, r) {
                var o = e1("../internals/object-define-property").f, n = e1("../internals/has"), s = e1("../internals/well-known-symbol")("toStringTag");
                t.exports = function(e1, t, r) {
                    e1 && !n(e1 = r ? e1 : e1.prototype, s) && o(e1, s, {
                        configurable: !0,
                        value: t
                    });
                };
            },
            {
                "../internals/has": 61,
                "../internals/object-define-property": 93,
                "../internals/well-known-symbol": 150
            }
        ],
        120: [
            function(e1, t, r) {
                var o = e1("../internals/shared"), n = e1("../internals/uid"), s = o("keys");
                t.exports = function(e1) {
                    return s[e1] || (s[e1] = n(e1));
                };
            },
            {
                "../internals/shared": 122,
                "../internals/uid": 147
            }
        ],
        121: [
            function(e1, t, r) {
                var o = e1("../internals/global"), e1 = e1("../internals/set-global"), n = "__core-js_shared__", o = o[n] || e1(n, {});
                t.exports = o;
            },
            {
                "../internals/global": 60,
                "../internals/set-global": 117
            }
        ],
        122: [
            function(e1, t, r) {
                var o = e1("../internals/is-pure"), n = e1("../internals/shared-store");
                (t.exports = function(e1, t) {
                    return n[e1] || (n[e1] = void 0 !== t ? t : {});
                })("versions", []).push({
                    version: "3.6.5",
                    mode: o ? "pure" : "global",
                    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
                });
            },
            {
                "../internals/is-pure": 76,
                "../internals/shared-store": 121
            }
        ],
        123: [
            function(e1, t, r) {
                var o = e1("../internals/an-object"), n = e1("../internals/a-function"), s = e1("../internals/well-known-symbol")("species");
                t.exports = function(e1, t) {
                    var e1 = o(e1).constructor;
                    return void 0 === e1 || null == (e1 = o(e1)[s]) ? t : n(e1);
                };
            },
            {
                "../internals/a-function": 5,
                "../internals/an-object": 10,
                "../internals/well-known-symbol": 150
            }
        ],
        124: [
            function(e1, t, r) {
                var o = e1("../internals/fails");
                t.exports = function(t) {
                    return o(function() {
                        var e1 = ""[t]('"');
                        return e1 !== e1.toLowerCase() || 3 < e1.split('"').length;
                    });
                };
            },
            {
                "../internals/fails": 51
            }
        ],
        125: [
            function(e1, t, r) {
                function o(n) {
                    return function(e1, t) {
                        var r, e1 = String(i(e1)), t = s(t), o = e1.length;
                        return t < 0 || o <= t ? n ? "" : void 0 : (r = e1.charCodeAt(t)) < 55296 || 56319 < r || t + 1 === o || (o = e1.charCodeAt(t + 1)) < 56320 || 57343 < o ? n ? e1.charAt(t) : r : n ? e1.slice(t, t + 2) : o - 56320 + (r - 55296 << 10) + 65536;
                    };
                }
                var s = e1("../internals/to-integer"), i = e1("../internals/require-object-coercible");
                t.exports = {
                    codeAt: o(!1),
                    charAt: o(!0)
                };
            },
            {
                "../internals/require-object-coercible": 115,
                "../internals/to-integer": 137
            }
        ],
        126: [
            function(e1, t, r) {
                e1 = e1("../internals/engine-user-agent");
                t.exports = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(e1);
            },
            {
                "../internals/engine-user-agent": 47
            }
        ],
        127: [
            function(e1, t, r) {
                function o(n) {
                    return function(e1, t, r) {
                        var e1 = String(a(e1)), o = e1.length, r = void 0 === r ? " " : String(r), t = s(t);
                        return t <= o || "" == r ? e1 : ((o = i.call(r, l((t = t - o) / r.length))).length > t && (o = o.slice(0, t)), n ? e1 + o : o + e1);
                    };
                }
                var s = e1("../internals/to-length"), i = e1("../internals/string-repeat"), a = e1("../internals/require-object-coercible"), l = Math.ceil;
                t.exports = {
                    start: o(!1),
                    end: o(!0)
                };
            },
            {
                "../internals/require-object-coercible": 115,
                "../internals/string-repeat": 129,
                "../internals/to-length": 138
            }
        ],
        128: [
            function(e1, t, r) {
                "use strict";
                function g(e1) {
                    return e1 + 22 + 75 * (e1 < 26);
                }
                function s(e1) {
                    var t, r = [], o = (e1 = function(e1) {
                        for(var t = [], r = 0, o = e1.length; r < o;){
                            var n, s = e1.charCodeAt(r++);
                            55296 <= s && s <= 56319 && r < o ? 56320 == (64512 & (n = e1.charCodeAt(r++))) ? t.push(((1023 & s) << 10) + (1023 & n) + 65536) : (t.push(s), r--) : t.push(s);
                        }
                        return t;
                    }(e1)).length, n = 128, s = 0, i = 72;
                    for(c = 0; c < e1.length; c++)(t = e1[c]) < 128 && r.push(E(t));
                    var a = r.length, l = a;
                    for(a && r.push("-"); l < o;){
                        for(var u = v, c = 0; c < e1.length; c++)n <= (t = e1[c]) && t < u && (u = t);
                        var d = l + 1;
                        if (u - n > T((v - s) / d)) throw RangeError(w);
                        for(s += (u - n) * d, n = u, c = 0; c < e1.length; c++){
                            if ((t = e1[c]) < n && ++s > v) throw RangeError(w);
                            if (t == n) {
                                for(var h = s, f = b;; f += b){
                                    var p = f <= i ? 1 : i + _ <= f ? _ : f - i;
                                    if (h < p) break;
                                    var m = h - p, y = b - p;
                                    r.push(E(g(p + m % y))), h = T(m / y);
                                }
                                r.push(E(g(h))), i = function(e1, t, r) {
                                    var o = 0;
                                    for(e1 = r ? T(e1 / x) : e1 >> 1, e1 += T(e1 / t); S * _ >> 1 < e1; o += b)e1 = T(e1 / S);
                                    return T(o + (S + 1) * e1 / (e1 + j));
                                }(s, d, l == a), s = 0, ++l;
                            }
                        }
                        ++s, ++n;
                    }
                    return r.join("");
                }
                var v = 2147483647, b = 36, _ = 26, j = 38, x = 700, i = /[^\0-\u007E]/, a = /[.\u3002\uFF0E\uFF61]/g, w = "Overflow: input needs wider integers to process", S = b - 1, T = Math.floor, E = String.fromCharCode;
                t.exports = function(e1) {
                    for(var t, r = [], o = e1.toLowerCase().replace(a, ".").split("."), n = 0; n < o.length; n++)t = o[n], r.push(i.test(t) ? "xn--" + s(t) : t);
                    return r.join(".");
                };
            },
            {}
        ],
        129: [
            function(e1, t, r) {
                "use strict";
                var n = e1("../internals/to-integer"), s = e1("../internals/require-object-coercible");
                t.exports = "".repeat || function(e1) {
                    var t = String(s(this)), r = "", o = n(e1);
                    if (o < 0 || o == 1 / 0) throw RangeError("Wrong number of repetitions");
                    for(; 0 < o; (o >>>= 1) && (t += t))1 & o && (r += t);
                    return r;
                };
            },
            {
                "../internals/require-object-coercible": 115,
                "../internals/to-integer": 137
            }
        ],
        130: [
            function(e1, t, r) {
                var o = e1("../internals/fails"), n = e1("../internals/whitespaces");
                t.exports = function(e1) {
                    return o(function() {
                        return !!n[e1]() || "\u200B\x85\u180E" != "\u200B\x85\u180E"[e1]() || n[e1].name !== e1;
                    });
                };
            },
            {
                "../internals/fails": 51,
                "../internals/whitespaces": 151
            }
        ],
        131: [
            function(e1, t, r) {
                function o(t) {
                    return function(e1) {
                        e1 = String(n(e1));
                        return 1 & t && (e1 = e1.replace(s, "")), e1 = 2 & t ? e1.replace(i, "") : e1;
                    };
                }
                var n = e1("../internals/require-object-coercible"), e1 = "[" + e1("../internals/whitespaces") + "]", s = RegExp("^" + e1 + e1 + "*"), i = RegExp(e1 + e1 + "*$");
                t.exports = {
                    start: o(1),
                    end: o(2),
                    trim: o(3)
                };
            },
            {
                "../internals/require-object-coercible": 115,
                "../internals/whitespaces": 151
            }
        ],
        132: [
            function(e1, t, r) {
                function o(e1) {
                    return function() {
                        x(e1);
                    };
                }
                function n(e1) {
                    x(e1.data);
                }
                function s(e1) {
                    a.postMessage(e1 + "", f.protocol + "//" + f.host);
                }
                var i, a = e1("../internals/global"), l = e1("../internals/fails"), u = e1("../internals/classof-raw"), c = e1("../internals/function-bind-context"), d = e1("../internals/html"), h = e1("../internals/document-create-element"), e1 = e1("../internals/engine-is-ios"), f = a.location, p = a.setImmediate, m = a.clearImmediate, y = a.process, g = a.MessageChannel, v = a.Dispatch, b = 0, _ = {}, j = "onreadystatechange", x = function(e1) {
                    var t;
                    _.hasOwnProperty(e1) && (t = _[e1], delete _[e1], t());
                };
                p && m || (p = function(e1) {
                    for(var t = [], r = 1; r < arguments.length;)t.push(arguments[r++]);
                    return _[++b] = function() {
                        ("function" == typeof e1 ? e1 : Function(e1)).apply(void 0, t);
                    }, i(b), b;
                }, m = function(e1) {
                    delete _[e1];
                }, "process" == u(y) ? i = function(e1) {
                    y.nextTick(o(e1));
                } : v && v.now ? i = function(e1) {
                    v.now(o(e1));
                } : g && !e1 ? (e1 = (u = new g).port2, u.port1.onmessage = n, i = c(e1.postMessage, e1, 1)) : !a.addEventListener || "function" != typeof postMessage || a.importScripts || l(s) || "file:" === f.protocol ? i = j in h("script") ? function(e1) {
                    d.appendChild(h("script"))[j] = function() {
                        d.removeChild(this), x(e1);
                    };
                } : function(e1) {
                    setTimeout(o(e1), 0);
                } : (i = s, a.addEventListener("message", n, !1))), t.exports = {
                    set: p,
                    clear: m
                };
            },
            {
                "../internals/classof-raw": 28,
                "../internals/document-create-element": 44,
                "../internals/engine-is-ios": 46,
                "../internals/fails": 51,
                "../internals/function-bind-context": 55,
                "../internals/global": 60,
                "../internals/html": 64
            }
        ],
        133: [
            function(e1, t, r) {
                var o = e1("../internals/classof-raw");
                t.exports = function(e1) {
                    if ("number" != typeof e1 && "Number" != o(e1)) throw TypeError("Incorrect invocation");
                    return +e1;
                };
            },
            {
                "../internals/classof-raw": 28
            }
        ],
        134: [
            function(e1, t, r) {
                var o = e1("../internals/to-integer"), n = Math.max, s = Math.min;
                t.exports = function(e1, t) {
                    e1 = o(e1);
                    return e1 < 0 ? n(e1 + t, 0) : s(e1, t);
                };
            },
            {
                "../internals/to-integer": 137
            }
        ],
        135: [
            function(e1, t, r) {
                var o = e1("../internals/to-integer"), n = e1("../internals/to-length");
                t.exports = function(e1) {
                    if (void 0 === e1) return 0;
                    var e1 = o(e1), t = n(e1);
                    if (e1 !== t) throw RangeError("Wrong length or index");
                    return t;
                };
            },
            {
                "../internals/to-integer": 137,
                "../internals/to-length": 138
            }
        ],
        136: [
            function(e1, t, r) {
                var o = e1("../internals/indexed-object"), n = e1("../internals/require-object-coercible");
                t.exports = function(e1) {
                    return o(n(e1));
                };
            },
            {
                "../internals/indexed-object": 67,
                "../internals/require-object-coercible": 115
            }
        ],
        137: [
            function(e1, t, r) {
                var o = Math.ceil, n = Math.floor;
                t.exports = function(e1) {
                    return isNaN(e1 = +e1) ? 0 : (0 < e1 ? n : o)(e1);
                };
            },
            {}
        ],
        138: [
            function(e1, t, r) {
                var o = e1("../internals/to-integer"), n = Math.min;
                t.exports = function(e1) {
                    return 0 < e1 ? n(o(e1), 9007199254740991) : 0;
                };
            },
            {
                "../internals/to-integer": 137
            }
        ],
        139: [
            function(e1, t, r) {
                var o = e1("../internals/require-object-coercible");
                t.exports = function(e1) {
                    return Object(o(e1));
                };
            },
            {
                "../internals/require-object-coercible": 115
            }
        ],
        140: [
            function(e1, t, r) {
                var o = e1("../internals/to-positive-integer");
                t.exports = function(e1, t) {
                    e1 = o(e1);
                    if (e1 % t) throw RangeError("Wrong offset");
                    return e1;
                };
            },
            {
                "../internals/to-positive-integer": 141
            }
        ],
        141: [
            function(e1, t, r) {
                var o = e1("../internals/to-integer");
                t.exports = function(e1) {
                    e1 = o(e1);
                    if (e1 < 0) throw RangeError("The argument can't be less than 0");
                    return e1;
                };
            },
            {
                "../internals/to-integer": 137
            }
        ],
        142: [
            function(e1, t, r) {
                var n = e1("../internals/is-object");
                t.exports = function(e1, t) {
                    if (!n(e1)) return e1;
                    var r, o;
                    if (t && "function" == typeof (r = e1.toString) && !n(o = r.call(e1)) || "function" == typeof (r = e1.valueOf) && !n(o = r.call(e1)) || !t && "function" == typeof (r = e1.toString) && !n(o = r.call(e1))) return o;
                    throw TypeError("Can't convert object to primitive value");
                };
            },
            {
                "../internals/is-object": 75
            }
        ],
        143: [
            function(e1, t, r) {
                var o = {};
                o[e1("../internals/well-known-symbol")("toStringTag")] = "z", t.exports = "[object z]" === String(o);
            },
            {
                "../internals/well-known-symbol": 150
            }
        ],
        144: [
            function(e1, t, D) {
                "use strict";
                function f(e1, t) {
                    for(var r = 0, o = t.length, n = new (K(e1))(o); r < o;)n[r] = t[r++];
                    return n;
                }
                function r(e1, t) {
                    E(e1, t, {
                        get: function() {
                            return T(this)[t];
                        }
                    });
                }
                function p(e1) {
                    return e1 instanceof k || "ArrayBuffer" == (e1 = B(e1)) || "SharedArrayBuffer" == e1;
                }
                function o(e1, t) {
                    return L(e1) && "symbol" != typeof t && t in e1 && String(+t) == String(t);
                }
                function n(e1, t) {
                    return o(e1, t = d(t, !0)) ? U(2, e1[t]) : X(e1, t);
                }
                function s(e1, t, r) {
                    return !(o(e1, t = d(t, !0)) && b(r) && h(r, "value")) || h(r, "get") || h(r, "set") || r.configurable || h(r, "writable") && !r.writable || h(r, "enumerable") && !r.enumerable ? E(e1, t, r) : (e1[t] = r.value, e1);
                }
                var a = e1("../internals/export"), l = e1("../internals/global"), i = e1("../internals/descriptors"), F = e1("../internals/typed-array-constructors-require-wrappers"), u = e1("../internals/array-buffer-view-core"), c = e1("../internals/array-buffer"), m = e1("../internals/an-instance"), U = e1("../internals/create-property-descriptor"), y = e1("../internals/create-non-enumerable-property"), N = e1("../internals/to-length"), g = e1("../internals/to-index"), v = e1("../internals/to-offset"), d = e1("../internals/to-primitive"), h = e1("../internals/has"), B = e1("../internals/classof"), b = e1("../internals/is-object"), G = e1("../internals/object-create"), _ = e1("../internals/object-set-prototype-of"), V = e1("../internals/object-get-own-property-names").f, j = e1("../internals/typed-array-from"), z = e1("../internals/array-iteration").forEach, H = e1("../internals/set-species"), x = e1("../internals/object-define-property"), w = e1("../internals/object-get-own-property-descriptor"), S = e1("../internals/internal-state"), W = e1("../internals/inherit-if-required"), T = S.get, q = S.set, E = x.f, X = w.f, Y = Math.round, M = l.RangeError, k = c.ArrayBuffer, Z = c.DataView, O = u.NATIVE_ARRAY_BUFFER_VIEWS, C = u.TYPED_ARRAY_TAG, P = u.TypedArray, A = u.TypedArrayPrototype, K = u.aTypedArrayConstructor, L = u.isTypedArray, R = "BYTES_PER_ELEMENT", I = "Wrong length";
                i ? (O || (w.f = n, x.f = s, r(A, "buffer"), r(A, "byteOffset"), r(A, "byteLength"), r(A, "length")), a({
                    target: "Object",
                    stat: !0,
                    forced: !O
                }, {
                    getOwnPropertyDescriptor: n,
                    defineProperty: s
                }), t.exports = function(e1, t, n) {
                    function u(e1, o) {
                        E(e1, o, {
                            get: function() {
                                var e1 = this, t = o;
                                return (e1 = T(e1)).view[r](t * c + e1.byteOffset, !0);
                            },
                            set: function(e1) {
                                var t = this, r = o;
                                t = T(t), n && (e1 = (e1 = Y(e1)) < 0 ? 0 : 255 < e1 ? 255 : 255 & e1), t.view[s](r * c + t.byteOffset, e1, !0);
                            },
                            enumerable: !0
                        });
                    }
                    var c = e1.match(/\d+$/)[0] / 8, d = e1 + (n ? "Clamped" : "") + "Array", r = "get" + e1, s = "set" + e1, i = l[d], h = i, e1 = h && h.prototype, o = {};
                    O ? F && (h = t(function(e1, t, r, o) {
                        return m(e1, h, d), W(b(t) ? p(t) ? void 0 !== o ? new i(t, v(r, c), o) : void 0 !== r ? new i(t, v(r, c)) : new i(t) : L(t) ? f(h, t) : j.call(h, t) : new i(g(t)), e1, h);
                    }), _ && _(h, P), z(V(i), function(e1) {
                        e1 in h || y(h, e1, i[e1]);
                    }), h.prototype = e1) : (h = t(function(e1, t, r, o) {
                        m(e1, h, d);
                        var n, s, i = 0, a = 0;
                        if (b(t)) {
                            if (!p(t)) return L(t) ? f(h, t) : j.call(h, t);
                            var l = t, a = v(r, c), r = t.byteLength;
                            if (void 0 === o) {
                                if (r % c) throw M(I);
                                if ((n = r - a) < 0) throw M(I);
                            } else if (r < (n = N(o) * c) + a) throw M(I);
                            s = n / c;
                        } else s = g(t), l = new k(n = s * c);
                        for(q(e1, {
                            buffer: l,
                            byteOffset: a,
                            byteLength: n,
                            length: s,
                            view: new Z(l)
                        }); i < s;)u(e1, i++);
                    }), _ && _(h, P), e1 = h.prototype = G(A)), e1.constructor !== h && y(e1, "constructor", h), C && y(e1, C, d), o[d] = h, a({
                        global: !0,
                        forced: h != i,
                        sham: !O
                    }, o), R in h || y(h, R, c), R in e1 || y(e1, R, c), H(d);
                }) : t.exports = function() {};
            },
            {
                "../internals/an-instance": 9,
                "../internals/array-buffer": 13,
                "../internals/array-buffer-view-core": 12,
                "../internals/array-iteration": 19,
                "../internals/classof": 29,
                "../internals/create-non-enumerable-property": 38,
                "../internals/create-property-descriptor": 39,
                "../internals/descriptors": 43,
                "../internals/export": 50,
                "../internals/global": 60,
                "../internals/has": 61,
                "../internals/inherit-if-required": 68,
                "../internals/internal-state": 71,
                "../internals/is-object": 75,
                "../internals/object-create": 91,
                "../internals/object-define-property": 93,
                "../internals/object-get-own-property-descriptor": 94,
                "../internals/object-get-own-property-names": 96,
                "../internals/object-set-prototype-of": 102,
                "../internals/set-species": 118,
                "../internals/to-index": 135,
                "../internals/to-length": 138,
                "../internals/to-offset": 140,
                "../internals/to-primitive": 142,
                "../internals/typed-array-constructors-require-wrappers": 145,
                "../internals/typed-array-from": 146
            }
        ],
        145: [
            function(e1, t, r) {
                var o = e1("../internals/global"), n = e1("../internals/fails"), s = e1("../internals/check-correctness-of-iteration"), e1 = e1("../internals/array-buffer-view-core").NATIVE_ARRAY_BUFFER_VIEWS, i = o.ArrayBuffer, a = o.Int8Array;
                t.exports = !e1 || !n(function() {
                    a(1);
                }) || !n(function() {
                    new a(-1);
                }) || !s(function(e1) {
                    new a, new a(null), new a(1.5), new a(e1);
                }, !0) || n(function() {
                    return 1 !== new a(new i(2), 1, void 0).length;
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/check-correctness-of-iteration": 27,
                "../internals/fails": 51,
                "../internals/global": 60
            }
        ],
        146: [
            function(e1, t, r) {
                var h = e1("../internals/to-object"), f = e1("../internals/to-length"), p = e1("../internals/get-iterator-method"), m = e1("../internals/is-array-iterator-method"), y = e1("../internals/function-bind-context"), g = e1("../internals/array-buffer-view-core").aTypedArrayConstructor;
                t.exports = function(e1) {
                    var t, r, o, n, s, i, a = h(e1), l = arguments.length, u = 1 < l ? arguments[1] : void 0, c = void 0 !== u, d = p(a);
                    if (null != d && !m(d)) for(i = (s = d.call(a)).next, a = []; !(n = i.call(s)).done;)a.push(n.value);
                    for(c && 2 < l && (u = y(u, arguments[2], 2)), r = f(a.length), o = new (g(this))(r), t = 0; t < r; t++)o[t] = c ? u(a[t], t) : a[t];
                    return o;
                };
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/function-bind-context": 55,
                "../internals/get-iterator-method": 58,
                "../internals/is-array-iterator-method": 72,
                "../internals/to-length": 138,
                "../internals/to-object": 139
            }
        ],
        147: [
            function(e1, t, r) {
                var o = 0, n = Math.random();
                t.exports = function(e1) {
                    return "Symbol(" + String(void 0 === e1 ? "" : e1) + ")_" + (++o + n).toString(36);
                };
            },
            {}
        ],
        148: [
            function(e1, t, r) {
                e1 = e1("../internals/native-symbol");
                t.exports = e1 && !Symbol.sham && "symbol" == typeof Symbol.iterator;
            },
            {
                "../internals/native-symbol": 84
            }
        ],
        149: [
            function(e1, t, r) {
                e1 = e1("../internals/well-known-symbol");
                r.f = e1;
            },
            {
                "../internals/well-known-symbol": 150
            }
        ],
        150: [
            function(e1, t, r) {
                var o = e1("../internals/global"), n = e1("../internals/shared"), s = e1("../internals/has"), i = e1("../internals/uid"), a = e1("../internals/native-symbol"), e1 = e1("../internals/use-symbol-as-uid"), l = n("wks"), u = o.Symbol, c = e1 ? u : u && u.withoutSetter || i;
                t.exports = function(e1) {
                    return s(l, e1) || (a && s(u, e1) ? l[e1] = u[e1] : l[e1] = c("Symbol." + e1)), l[e1];
                };
            },
            {
                "../internals/global": 60,
                "../internals/has": 61,
                "../internals/native-symbol": 84,
                "../internals/shared": 122,
                "../internals/uid": 147,
                "../internals/use-symbol-as-uid": 148
            }
        ],
        151: [
            function(e1, t, r) {
                t.exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
            },
            {}
        ],
        152: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/global"), s = e1("../internals/array-buffer"), e1 = e1("../internals/set-species"), i = "ArrayBuffer", s = s[i];
                o({
                    global: !0,
                    forced: n[i] !== s
                }, {
                    ArrayBuffer: s
                }), e1(i);
            },
            {
                "../internals/array-buffer": 13,
                "../internals/export": 50,
                "../internals/global": 60,
                "../internals/set-species": 118
            }
        ],
        153: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/fails"), d = e1("../internals/is-array"), h = e1("../internals/is-object"), f = e1("../internals/to-object"), p = e1("../internals/to-length"), m = e1("../internals/create-property"), y = e1("../internals/array-species-create"), s = e1("../internals/array-method-has-species-support"), i = e1("../internals/well-known-symbol"), e1 = e1("../internals/engine-v8-version"), g = i("isConcatSpreadable"), v = 9007199254740991, b = "Maximum allowed index exceeded", i = 51 <= e1 || !n(function() {
                    var e1 = [];
                    return e1[g] = !1, e1.concat()[0] !== e1;
                }), e1 = s("concat");
                o({
                    target: "Array",
                    proto: !0,
                    forced: !i || !e1
                }, {
                    concat: function(e1) {
                        for(var t, r, o, n, s, i = f(this), a = y(i, 0), l = 0, u = -1, c = arguments.length; u < c; u++)if (s = void 0, !h(n = o = -1 === u ? i : arguments[u]) || (void 0 !== (s = n[g]) ? !s : !d(n))) {
                            if (v <= l) throw TypeError(b);
                            m(a, l++, o);
                        } else {
                            if (r = p(o.length), v < l + r) throw TypeError(b);
                            for(t = 0; t < r; t++, l++)t in o && m(a, l, o[t]);
                        }
                        return a.length = l, a;
                    }
                });
            },
            {
                "../internals/array-method-has-species-support": 21,
                "../internals/array-species-create": 25,
                "../internals/create-property": 40,
                "../internals/engine-v8-version": 48,
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/is-array": 73,
                "../internals/is-object": 75,
                "../internals/to-length": 138,
                "../internals/to-object": 139,
                "../internals/well-known-symbol": 150
            }
        ],
        154: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/array-copy-within"), e1 = e1("../internals/add-to-unscopables");
                o({
                    target: "Array",
                    proto: !0
                }, {
                    copyWithin: n
                }), e1("copyWithin");
            },
            {
                "../internals/add-to-unscopables": 7,
                "../internals/array-copy-within": 14,
                "../internals/export": 50
            }
        ],
        155: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/array-iteration").every, s = e1("../internals/array-method-is-strict"), e1 = e1("../internals/array-method-uses-to-length"), s = s("every"), e1 = e1("every");
                o({
                    target: "Array",
                    proto: !0,
                    forced: !s || !e1
                }, {
                    every: function(e1) {
                        return n(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/array-iteration": 19,
                "../internals/array-method-is-strict": 22,
                "../internals/array-method-uses-to-length": 23,
                "../internals/export": 50
            }
        ],
        156: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/array-fill"), e1 = e1("../internals/add-to-unscopables");
                o({
                    target: "Array",
                    proto: !0
                }, {
                    fill: n
                }), e1("fill");
            },
            {
                "../internals/add-to-unscopables": 7,
                "../internals/array-fill": 15,
                "../internals/export": 50
            }
        ],
        157: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/array-iteration").filter, s = e1("../internals/array-method-has-species-support"), e1 = e1("../internals/array-method-uses-to-length"), s = s("filter"), e1 = e1("filter");
                o({
                    target: "Array",
                    proto: !0,
                    forced: !s || !e1
                }, {
                    filter: function(e1) {
                        return n(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/array-iteration": 19,
                "../internals/array-method-has-species-support": 21,
                "../internals/array-method-uses-to-length": 23,
                "../internals/export": 50
            }
        ],
        158: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/array-iteration").findIndex, s = e1("../internals/add-to-unscopables"), e1 = e1("../internals/array-method-uses-to-length"), i = "findIndex", a = !0, e1 = e1(i);
                i in [] && Array(1)[i](function() {
                    a = !1;
                }), o({
                    target: "Array",
                    proto: !0,
                    forced: a || !e1
                }, {
                    findIndex: function(e1) {
                        return n(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                    }
                }), s(i);
            },
            {
                "../internals/add-to-unscopables": 7,
                "../internals/array-iteration": 19,
                "../internals/array-method-uses-to-length": 23,
                "../internals/export": 50
            }
        ],
        159: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/flatten-into-array"), s = e1("../internals/to-object"), i = e1("../internals/to-length"), a = e1("../internals/a-function"), l = e1("../internals/array-species-create");
                o({
                    target: "Array",
                    proto: !0
                }, {
                    flatMap: function(e1) {
                        var t, r = s(this), o = i(r.length);
                        return a(e1), (t = l(r, 0)).length = n(t, r, r, o, 0, 1, e1, 1 < arguments.length ? arguments[1] : void 0), t;
                    }
                });
            },
            {
                "../internals/a-function": 5,
                "../internals/array-species-create": 25,
                "../internals/export": 50,
                "../internals/flatten-into-array": 53,
                "../internals/to-length": 138,
                "../internals/to-object": 139
            }
        ],
        160: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/flatten-into-array"), s = e1("../internals/to-object"), i = e1("../internals/to-length"), a = e1("../internals/to-integer"), l = e1("../internals/array-species-create");
                o({
                    target: "Array",
                    proto: !0
                }, {
                    flat: function() {
                        var e1 = arguments.length ? arguments[0] : void 0, t = s(this), r = i(t.length), o = l(t, 0);
                        return o.length = n(o, t, t, r, 0, void 0 === e1 ? 1 : a(e1)), o;
                    }
                });
            },
            {
                "../internals/array-species-create": 25,
                "../internals/export": 50,
                "../internals/flatten-into-array": 53,
                "../internals/to-integer": 137,
                "../internals/to-length": 138,
                "../internals/to-object": 139
            }
        ],
        161: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), e1 = e1("../internals/array-for-each");
                o({
                    target: "Array",
                    proto: !0,
                    forced: [].forEach != e1
                }, {
                    forEach: e1
                });
            },
            {
                "../internals/array-for-each": 16,
                "../internals/export": 50
            }
        ],
        162: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/array-from");
                o({
                    target: "Array",
                    stat: !0,
                    forced: !e1("../internals/check-correctness-of-iteration")(function(e1) {
                        Array.from(e1);
                    })
                }, {
                    from: n
                });
            },
            {
                "../internals/array-from": 17,
                "../internals/check-correctness-of-iteration": 27,
                "../internals/export": 50
            }
        ],
        163: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/array-includes").includes, s = e1("../internals/add-to-unscopables");
                o({
                    target: "Array",
                    proto: !0,
                    forced: !e1("../internals/array-method-uses-to-length")("indexOf", {
                        ACCESSORS: !0,
                        1: 0
                    })
                }, {
                    includes: function(e1) {
                        return n(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                    }
                }), s("includes");
            },
            {
                "../internals/add-to-unscopables": 7,
                "../internals/array-includes": 18,
                "../internals/array-method-uses-to-length": 23,
                "../internals/export": 50
            }
        ],
        164: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/array-includes").indexOf, s = e1("../internals/array-method-is-strict"), e1 = e1("../internals/array-method-uses-to-length"), i = [].indexOf, a = !!i && 1 / [
                    1
                ].indexOf(1, -0) < 0, s = s("indexOf"), e1 = e1("indexOf", {
                    ACCESSORS: !0,
                    1: 0
                });
                o({
                    target: "Array",
                    proto: !0,
                    forced: a || !s || !e1
                }, {
                    indexOf: function(e1) {
                        return a ? i.apply(this, arguments) || 0 : n(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/array-includes": 18,
                "../internals/array-method-is-strict": 22,
                "../internals/array-method-uses-to-length": 23,
                "../internals/export": 50
            }
        ],
        165: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/to-indexed-object"), n = e1("../internals/add-to-unscopables"), s = e1("../internals/iterators"), i = e1("../internals/internal-state"), e1 = e1("../internals/define-iterator"), a = "Array Iterator", l = i.set, u = i.getterFor(a);
                t.exports = e1(Array, "Array", function(e1, t) {
                    l(this, {
                        type: a,
                        target: o(e1),
                        index: 0,
                        kind: t
                    });
                }, function() {
                    var e1 = u(this), t = e1.target, r = e1.kind, o = e1.index++;
                    return !t || o >= t.length ? {
                        value: e1.target = void 0,
                        done: !0
                    } : "keys" == r ? {
                        value: o,
                        done: !1
                    } : "values" == r ? {
                        value: t[o],
                        done: !1
                    } : {
                        value: [
                            o,
                            t[o]
                        ],
                        done: !1
                    };
                }, "values"), s.Arguments = s.Array, n("keys"), n("values"), n("entries");
            },
            {
                "../internals/add-to-unscopables": 7,
                "../internals/define-iterator": 41,
                "../internals/internal-state": 71,
                "../internals/iterators": 80,
                "../internals/to-indexed-object": 136
            }
        ],
        166: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/indexed-object"), s = e1("../internals/to-indexed-object"), e1 = e1("../internals/array-method-is-strict"), i = [].join, n = n != Object, e1 = e1("join", ",");
                o({
                    target: "Array",
                    proto: !0,
                    forced: n || !e1
                }, {
                    join: function(e1) {
                        return i.call(s(this), void 0 === e1 ? "," : e1);
                    }
                });
            },
            {
                "../internals/array-method-is-strict": 22,
                "../internals/export": 50,
                "../internals/indexed-object": 67,
                "../internals/to-indexed-object": 136
            }
        ],
        167: [
            function(e1, t, r) {
                var o = e1("../internals/export"), e1 = e1("../internals/array-last-index-of");
                o({
                    target: "Array",
                    proto: !0,
                    forced: e1 !== [].lastIndexOf
                }, {
                    lastIndexOf: e1
                });
            },
            {
                "../internals/array-last-index-of": 20,
                "../internals/export": 50
            }
        ],
        168: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/array-iteration").map, s = e1("../internals/array-method-has-species-support"), e1 = e1("../internals/array-method-uses-to-length"), s = s("map"), e1 = e1("map");
                o({
                    target: "Array",
                    proto: !0,
                    forced: !s || !e1
                }, {
                    map: function(e1) {
                        return n(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/array-iteration": 19,
                "../internals/array-method-has-species-support": 21,
                "../internals/array-method-uses-to-length": 23,
                "../internals/export": 50
            }
        ],
        169: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), u = e1("../internals/is-object"), c = e1("../internals/is-array"), d = e1("../internals/to-absolute-index"), h = e1("../internals/to-length"), f = e1("../internals/to-indexed-object"), p = e1("../internals/create-property"), n = e1("../internals/well-known-symbol"), s = e1("../internals/array-method-has-species-support"), e1 = e1("../internals/array-method-uses-to-length"), s = s("slice"), e1 = e1("slice", {
                    ACCESSORS: !0,
                    0: 0,
                    1: 2
                }), m = n("species"), y = [].slice, g = Math.max;
                o({
                    target: "Array",
                    proto: !0,
                    forced: !s || !e1
                }, {
                    slice: function(e1, t) {
                        var r, o, n, s = f(this), i = h(s.length), a = d(e1, i), l = d(void 0 === t ? i : t, i);
                        if (c(s) && ((r = "function" == typeof (r = s.constructor) && (r === Array || c(r.prototype)) || u(r) && null === (r = r[m]) ? void 0 : r) === Array || void 0 === r)) return y.call(s, a, l);
                        for(o = new (void 0 === r ? Array : r)(g(l - a, 0)), n = 0; a < l; a++, n++)a in s && p(o, n, s[a]);
                        return o.length = n, o;
                    }
                });
            },
            {
                "../internals/array-method-has-species-support": 21,
                "../internals/array-method-uses-to-length": 23,
                "../internals/create-property": 40,
                "../internals/export": 50,
                "../internals/is-array": 73,
                "../internals/is-object": 75,
                "../internals/to-absolute-index": 134,
                "../internals/to-indexed-object": 136,
                "../internals/to-length": 138,
                "../internals/well-known-symbol": 150
            }
        ],
        170: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/array-iteration").some, s = e1("../internals/array-method-is-strict"), e1 = e1("../internals/array-method-uses-to-length"), s = s("some"), e1 = e1("some");
                o({
                    target: "Array",
                    proto: !0,
                    forced: !s || !e1
                }, {
                    some: function(e1) {
                        return n(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/array-iteration": 19,
                "../internals/array-method-is-strict": 22,
                "../internals/array-method-uses-to-length": 23,
                "../internals/export": 50
            }
        ],
        171: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), d = e1("../internals/to-absolute-index"), h = e1("../internals/to-integer"), f = e1("../internals/to-length"), p = e1("../internals/to-object"), m = e1("../internals/array-species-create"), y = e1("../internals/create-property"), n = e1("../internals/array-method-has-species-support"), e1 = e1("../internals/array-method-uses-to-length"), n = n("splice"), e1 = e1("splice", {
                    ACCESSORS: !0,
                    0: 0,
                    1: 2
                }), g = Math.max, v = Math.min;
                o({
                    target: "Array",
                    proto: !0,
                    forced: !n || !e1
                }, {
                    splice: function(e1, t) {
                        var r, o, n, s, i, a, l = p(this), u = f(l.length), c = d(e1, u), e1 = arguments.length;
                        if (0 === e1 ? r = o = 0 : o = 1 === e1 ? (r = 0, u - c) : (r = e1 - 2, v(g(h(t), 0), u - c)), 9007199254740991 < u + r - o) throw TypeError("Maximum allowed length exceeded");
                        for(n = m(l, o), s = 0; s < o; s++)(i = c + s) in l && y(n, s, l[i]);
                        if (r < (n.length = o)) {
                            for(s = c; s < u - o; s++)a = s + r, (i = s + o) in l ? l[a] = l[i] : delete l[a];
                            for(s = u; u - o + r < s; s--)delete l[s - 1];
                        } else if (o < r) for(s = u - o; c < s; s--)a = s + r - 1, (i = s + o - 1) in l ? l[a] = l[i] : delete l[a];
                        for(s = 0; s < r; s++)l[s + c] = arguments[s + 2];
                        return l.length = u - o + r, n;
                    }
                });
            },
            {
                "../internals/array-method-has-species-support": 21,
                "../internals/array-method-uses-to-length": 23,
                "../internals/array-species-create": 25,
                "../internals/create-property": 40,
                "../internals/export": 50,
                "../internals/to-absolute-index": 134,
                "../internals/to-integer": 137,
                "../internals/to-length": 138,
                "../internals/to-object": 139
            }
        ],
        172: [
            function(e1, t, r) {
                e1("../internals/add-to-unscopables")("flatMap");
            },
            {
                "../internals/add-to-unscopables": 7
            }
        ],
        173: [
            function(e1, t, r) {
                e1("../internals/add-to-unscopables")("flat");
            },
            {
                "../internals/add-to-unscopables": 7
            }
        ],
        174: [
            function(e1, t, r) {
                var o = e1("../internals/descriptors"), e1 = e1("../internals/object-define-property").f, n = Function.prototype, s = n.toString, i = /^\s*function ([^ (]*)/;
                !o || "name" in n || e1(n, "name", {
                    configurable: !0,
                    get: function() {
                        try {
                            return s.call(this).match(i)[1];
                        } catch (e1) {
                            return "";
                        }
                    }
                });
            },
            {
                "../internals/descriptors": 43,
                "../internals/object-define-property": 93
            }
        ],
        175: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/collection"), e1 = e1("../internals/collection-strong");
                t.exports = o("Map", function(e1) {
                    return function() {
                        return e1(this, arguments.length ? arguments[0] : void 0);
                    };
                }, e1);
            },
            {
                "../internals/collection": 32,
                "../internals/collection-strong": 30
            }
        ],
        176: [
            function(e1, t, r) {
                var e1 = e1("../internals/export"), o = Math.hypot, l = Math.abs, u = Math.sqrt;
                e1({
                    target: "Math",
                    stat: !0,
                    forced: !!o && o(1 / 0, NaN) !== 1 / 0
                }, {
                    hypot: function(e1, t) {
                        for(var r, o, n = 0, s = 0, i = arguments.length, a = 0; s < i;)a < (r = l(arguments[s++])) ? (n = n * (o = a / r) * o + 1, a = r) : n += 0 < r ? (o = r / a) * o : r;
                        return a === 1 / 0 ? 1 / 0 : a * u(n);
                    }
                });
            },
            {
                "../internals/export": 50
            }
        ],
        177: [
            function(e1, t, r) {
                var e1 = e1("../internals/export"), o = Math.log, n = Math.LN2;
                e1({
                    target: "Math",
                    stat: !0
                }, {
                    log2: function(e1) {
                        return o(e1) / n;
                    }
                });
            },
            {
                "../internals/export": 50
            }
        ],
        178: [
            function(e1, t, r) {
                e1("../internals/export")({
                    target: "Math",
                    stat: !0
                }, {
                    sign: e1("../internals/math-sign")
                });
            },
            {
                "../internals/export": 50,
                "../internals/math-sign": 81
            }
        ],
        179: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    var t, r, o, n, s, i, a, l = d(e1, !1);
                    if ("string" == typeof l && 2 < l.length) {
                        if (43 === (e1 = (l = g(l)).charCodeAt(0)) || 45 === e1) {
                            if (88 === (t = l.charCodeAt(2)) || 120 === t) return NaN;
                        } else if (48 === e1) {
                            switch(l.charCodeAt(1)){
                                case 66:
                                case 98:
                                    r = 2, o = 49;
                                    break;
                                case 79:
                                case 111:
                                    r = 8, o = 55;
                                    break;
                                default:
                                    return +l;
                            }
                            for(s = (n = l.slice(2)).length, i = 0; i < s; i++)if ((a = n.charCodeAt(i)) < 48 || o < a) return NaN;
                            return parseInt(n, r);
                        }
                    }
                    return +l;
                }
                var n = e1("../internals/descriptors"), s = e1("../internals/global"), i = e1("../internals/is-forced"), a = e1("../internals/redefine"), l = e1("../internals/has"), u = e1("../internals/classof-raw"), c = e1("../internals/inherit-if-required"), d = e1("../internals/to-primitive"), h = e1("../internals/fails"), f = e1("../internals/object-create"), p = e1("../internals/object-get-own-property-names").f, m = e1("../internals/object-get-own-property-descriptor").f, y = e1("../internals/object-define-property").f, g = e1("../internals/string-trim").trim, v = "Number", b = s[v], _ = b.prototype, j = u(f(_)) == v;
                if (i(v, !b(" 0o1") || !b("0b1") || b("+0x1"))) {
                    for(var x, w = function(e1) {
                        var e1 = arguments.length < 1 ? 0 : e1, t = this;
                        return t instanceof w && (j ? h(function() {
                            _.valueOf.call(t);
                        }) : u(t) != v) ? c(new b(o(e1)), t, w) : o(e1);
                    }, S = n ? p(b) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), T = 0; S.length > T; T++)l(b, x = S[T]) && !l(w, x) && y(w, x, m(b, x));
                    (w.prototype = _).constructor = w, a(s, v, w);
                }
            },
            {
                "../internals/classof-raw": 28,
                "../internals/descriptors": 43,
                "../internals/fails": 51,
                "../internals/global": 60,
                "../internals/has": 61,
                "../internals/inherit-if-required": 68,
                "../internals/is-forced": 74,
                "../internals/object-create": 91,
                "../internals/object-define-property": 93,
                "../internals/object-get-own-property-descriptor": 94,
                "../internals/object-get-own-property-names": 96,
                "../internals/redefine": 110,
                "../internals/string-trim": 131,
                "../internals/to-primitive": 142
            }
        ],
        180: [
            function(e1, t, r) {
                e1("../internals/export")({
                    target: "Number",
                    stat: !0
                }, {
                    EPSILON: Math.pow(2, -52)
                });
            },
            {
                "../internals/export": 50
            }
        ],
        181: [
            function(e1, t, r) {
                e1("../internals/export")({
                    target: "Number",
                    stat: !0
                }, {
                    isFinite: e1("../internals/number-is-finite")
                });
            },
            {
                "../internals/export": 50,
                "../internals/number-is-finite": 89
            }
        ],
        182: [
            function(e1, t, r) {
                "use strict";
                function c(e1, t, r) {
                    return 0 === t ? r : t % 2 == 1 ? c(e1, t - 1, r * e1) : c(e1 * e1, t / 2, r);
                }
                var o = e1("../internals/export"), d = e1("../internals/to-integer"), h = e1("../internals/this-number-value"), f = e1("../internals/string-repeat"), e1 = e1("../internals/fails"), n = 1..toFixed, p = Math.floor;
                o({
                    target: "Number",
                    proto: !0,
                    forced: n && ("0.000" !== 8e-5.toFixed(3) || "1" !== .9.toFixed(0) || "1.25" !== 1.255.toFixed(2) || "1000000000000000128" !== 0xde0b6b3a7640080.toFixed(0)) || !e1(function() {
                        n.call({});
                    })
                }, {
                    toFixed: function(e1) {
                        function t(e1, t) {
                            for(var r = -1, o = t; ++r < 6;)o += e1 * a[r], a[r] = o % 1e7, o = p(o / 1e7);
                        }
                        function r(e1) {
                            for(var t = 6, r = 0; 0 <= --t;)r += a[t], a[t] = p(r / e1), r = r % e1 * 1e7;
                        }
                        function o() {
                            for(var e1, t = 6, r = ""; 0 <= --t;)"" === r && 0 !== t && 0 === a[t] || (e1 = String(a[t]), r = "" === r ? e1 : r + f.call("0", 7 - e1.length) + e1);
                            return r;
                        }
                        var n, s, i = h(this), e1 = d(e1), a = [
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ], l = "", u = "0";
                        if (e1 < 0 || 20 < e1) throw RangeError("Incorrect fraction digits");
                        if (i != i) return "NaN";
                        if (i <= -1000000000000000000000 || 1e21 <= i) return String(i);
                        if (i < 0 && (l = "-", i = -i), 1e-21 < i) {
                            if (i = (n = function(e1) {
                                for(var t = 0, r = e1; 4096 <= r;)t += 12, r /= 4096;
                                for(; 2 <= r;)t += 1, r /= 2;
                                return t;
                            }(i * c(2, 69, 1)) - 69) < 0 ? i * c(2, -n, 1) : i / c(2, n, 1), i *= 4503599627370496, 0 < (n = 52 - n)) {
                                for(t(0, i), s = e1; 7 <= s;)t(1e7, 0), s -= 7;
                                for(t(c(10, s, 1), 0), s = n - 1; 23 <= s;)r(8388608), s -= 23;
                                r(1 << s), t(1, 1), r(2), u = o();
                            } else t(0, i), t(1 << -n, 0), u = o() + f.call("0", e1);
                        }
                        return u = 0 < e1 ? l + ((i = u.length) <= e1 ? "0." + f.call("0", e1 - i) + u : u.slice(0, i - e1) + "." + u.slice(i - e1)) : l + u;
                    }
                });
            },
            {
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/string-repeat": 129,
                "../internals/this-number-value": 133,
                "../internals/to-integer": 137
            }
        ],
        183: [
            function(e1, t, r) {
                var o = e1("../internals/export"), e1 = e1("../internals/object-assign");
                o({
                    target: "Object",
                    stat: !0,
                    forced: Object.assign !== e1
                }, {
                    assign: e1
                });
            },
            {
                "../internals/export": 50,
                "../internals/object-assign": 90
            }
        ],
        184: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/object-to-array").entries;
                o({
                    target: "Object",
                    stat: !0
                }, {
                    entries: function(e1) {
                        return n(e1);
                    }
                });
            },
            {
                "../internals/export": 50,
                "../internals/object-to-array": 103
            }
        ],
        185: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/iterate"), s = e1("../internals/create-property");
                o({
                    target: "Object",
                    stat: !0
                }, {
                    fromEntries: function(e1) {
                        var r = {};
                        return n(e1, function(e1, t) {
                            s(r, e1, t);
                        }, void 0, !0), r;
                    }
                });
            },
            {
                "../internals/create-property": 40,
                "../internals/export": 50,
                "../internals/iterate": 78
            }
        ],
        186: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/fails"), s = e1("../internals/to-indexed-object"), i = e1("../internals/object-get-own-property-descriptor").f, e1 = e1("../internals/descriptors"), n = n(function() {
                    i(1);
                });
                o({
                    target: "Object",
                    stat: !0,
                    forced: !e1 || n,
                    sham: !e1
                }, {
                    getOwnPropertyDescriptor: function(e1, t) {
                        return i(s(e1), t);
                    }
                });
            },
            {
                "../internals/descriptors": 43,
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/object-get-own-property-descriptor": 94,
                "../internals/to-indexed-object": 136
            }
        ],
        187: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/fails"), e1 = e1("../internals/object-get-own-property-names-external").f;
                o({
                    target: "Object",
                    stat: !0,
                    forced: n(function() {
                        return !Object.getOwnPropertyNames(1);
                    })
                }, {
                    getOwnPropertyNames: e1
                });
            },
            {
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/object-get-own-property-names-external": 95
            }
        ],
        188: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/fails"), s = e1("../internals/to-object"), i = e1("../internals/object-get-prototype-of"), e1 = e1("../internals/correct-prototype-getter");
                o({
                    target: "Object",
                    stat: !0,
                    forced: n(function() {
                        i(1);
                    }),
                    sham: !e1
                }, {
                    getPrototypeOf: function(e1) {
                        return i(s(e1));
                    }
                });
            },
            {
                "../internals/correct-prototype-getter": 35,
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/object-get-prototype-of": 98,
                "../internals/to-object": 139
            }
        ],
        189: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/to-object"), s = e1("../internals/object-keys");
                o({
                    target: "Object",
                    stat: !0,
                    forced: e1("../internals/fails")(function() {
                        s(1);
                    })
                }, {
                    keys: function(e1) {
                        return s(n(e1));
                    }
                });
            },
            {
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/object-keys": 100,
                "../internals/to-object": 139
            }
        ],
        190: [
            function(e1, t, r) {
                var o = e1("../internals/to-string-tag-support"), n = e1("../internals/redefine"), e1 = e1("../internals/object-to-string");
                o || n(Object.prototype, "toString", e1, {
                    unsafe: !0
                });
            },
            {
                "../internals/object-to-string": 104,
                "../internals/redefine": 110,
                "../internals/to-string-tag-support": 143
            }
        ],
        191: [
            function(e1, D, F) {
                "use strict";
                var r, t, o, n, s = e1("../internals/export"), i = e1("../internals/is-pure"), g = e1("../internals/global"), a = e1("../internals/get-built-in"), l = e1("../internals/native-promise-constructor"), U = e1("../internals/redefine"), N = e1("../internals/redefine-all"), B = e1("../internals/set-to-string-tag"), G = e1("../internals/set-species"), V = e1("../internals/is-object"), c = e1("../internals/a-function"), z = e1("../internals/an-instance"), H = e1("../internals/classof-raw"), W = e1("../internals/inspect-source"), d = e1("../internals/iterate"), q = e1("../internals/check-correctness-of-iteration"), X = e1("../internals/species-constructor"), v = e1("../internals/task").set, u = e1("../internals/microtask"), h = e1("../internals/promise-resolve"), Y = e1("../internals/host-report-errors"), f = e1("../internals/new-promise-capability"), b = e1("../internals/perform"), p = e1("../internals/internal-state"), Z = e1("../internals/is-forced"), m = e1("../internals/well-known-symbol"), y = e1("../internals/engine-v8-version"), K = m("species"), _ = "Promise", j = p.get, Q = p.set, J = p.getterFor(_), x = l, w = g.TypeError, S = g.document, T = g.process, E = a("fetch"), M = f.f, $ = M, k = "process" == H(T), ee = !!(S && S.createEvent && g.dispatchEvent), O = "unhandledrejection", te = "rejectionhandled", C = 1, re = 2, P = 1, oe = 2, e1 = Z(_, function() {
                    var e1, t;
                    if (!(W(x) !== String(x))) {
                        if (66 === y) return !0;
                        if (!k && "function" != typeof PromiseRejectionEvent) return !0;
                    }
                    return !(!i || x.prototype.finally) || !(51 <= y && /native code/.test(x)) && (t = function(e1) {
                        e1(function() {}, function() {});
                    }, ((e1 = x.resolve(1)).constructor = {})[K] = t, !(e1.then(function() {}) instanceof t));
                }), m = e1 || !q(function(e1) {
                    x.all(e1).catch(function() {});
                }), ne = function(e1) {
                    var t;
                    return !(!V(e1) || "function" != typeof (t = e1.then)) && t;
                }, A = function(f, p, m) {
                    var y;
                    p.notified || (p.notified = !0, y = p.reactions, u(function() {
                        for(var r, o, e1 = p.value, t = p.state == C, n = 0; y.length > n;){
                            var s, i, a, l = y[n++], u = t ? l.ok : l.fail, c = l.resolve, d = l.reject, h = l.domain;
                            try {
                                u ? (t || (p.rejection === oe && function(e1, t) {
                                    v.call(g, function() {
                                        if (k) T.emit("rejectionHandled", e1);
                                        else se(te, e1, t.value);
                                    });
                                }(f, p), p.rejection = P), !0 === u ? s = e1 : (h && h.enter(), s = u(e1), h && (h.exit(), a = !0)), s === l.promise ? d(w("Promise-chain cycle")) : (i = ne(s)) ? i.call(s, c, d) : c(s)) : d(e1);
                            } catch (e1) {
                                h && !a && h.exit(), d(e1);
                            }
                        }
                        p.reactions = [], p.notified = !1, m && !p.rejection && (r = f, o = p, v.call(g, function() {
                            var e1 = o.value, t = ie(o);
                            if (t && (t = b(function() {
                                k ? T.emit("unhandledRejection", e1, r) : se(O, r, e1);
                            }), o.rejection = k || ie(o) ? oe : P, t.error)) throw t.value;
                        }));
                    }));
                }, se = function(e1, t, r) {
                    var o;
                    ee ? ((o = S.createEvent("Event")).promise = t, o.reason = r, o.initEvent(e1, !1, !0), g.dispatchEvent(o)) : o = {
                        promise: t,
                        reason: r
                    }, (t = g["on" + e1]) ? t(o) : e1 === O && Y("Unhandled promise rejection", r);
                }, ie = function(e1) {
                    return e1.rejection !== P && !e1.parent;
                }, L = function(t, r, o, n) {
                    return function(e1) {
                        t(r, o, e1, n);
                    };
                }, R = function(e1, t, r, o) {
                    t.done || (t.done = !0, (t = o ? o : t).value = r, t.state = re, A(e1, t, !0));
                }, I = function(r, o, e1, t) {
                    if (!o.done) {
                        o.done = !0, t && (o = t);
                        try {
                            if (r === e1) throw w("Promise can't be resolved itself");
                            var n = ne(e1);
                            n ? u(function() {
                                var t = {
                                    done: !1
                                };
                                try {
                                    n.call(e1, L(I, r, t, o), L(R, r, t, o));
                                } catch (e1) {
                                    R(r, t, e1, o);
                                }
                            }) : (o.value = e1, o.state = C, A(r, o, !1));
                        } catch (e1) {
                            R(r, {
                                done: !1
                            }, e1, o);
                        }
                    }
                };
                e1 && (x = function(e1) {
                    z(this, x, _), c(e1), r.call(this);
                    var t = j(this);
                    try {
                        e1(L(I, this, t), L(R, this, t));
                    } catch (e1) {
                        R(this, t, e1);
                    }
                }, (r = function(e1) {
                    Q(this, {
                        type: _,
                        done: !1,
                        notified: !1,
                        parent: !1,
                        reactions: [],
                        rejection: !1,
                        state: 0,
                        value: void 0
                    });
                }).prototype = N(x.prototype, {
                    then: function(e1, t) {
                        var r = J(this), o = M(X(this, x));
                        return o.ok = "function" != typeof e1 || e1, o.fail = "function" == typeof t && t, o.domain = k ? T.domain : void 0, r.parent = !0, r.reactions.push(o), 0 != r.state && A(this, r, !1), o.promise;
                    },
                    catch: function(e1) {
                        return this.then(void 0, e1);
                    }
                }), t = function() {
                    var e1 = new r, t = j(e1);
                    this.promise = e1, this.resolve = L(I, e1, t), this.reject = L(R, e1, t);
                }, f.f = M = function(e1) {
                    return e1 === x || e1 === o ? new t : $(e1);
                }, i || "function" != typeof l || (n = l.prototype.then, U(l.prototype, "then", function(e1, t) {
                    var r = this;
                    return new x(function(e1, t) {
                        n.call(r, e1, t);
                    }).then(e1, t);
                }, {
                    unsafe: !0
                }), "function" == typeof E && s({
                    global: !0,
                    enumerable: !0,
                    forced: !0
                }, {
                    fetch: function(e1) {
                        return h(x, E.apply(g, arguments));
                    }
                }))), s({
                    global: !0,
                    wrap: !0,
                    forced: e1
                }, {
                    Promise: x
                }), B(x, _, !1, !0), G(_), o = a(_), s({
                    target: _,
                    stat: !0,
                    forced: e1
                }, {
                    reject: function(e1) {
                        var t = M(this);
                        return t.reject.call(void 0, e1), t.promise;
                    }
                }), s({
                    target: _,
                    stat: !0,
                    forced: i || e1
                }, {
                    resolve: function(e1) {
                        return h(i && this === o ? x : this, e1);
                    }
                }), s({
                    target: _,
                    stat: !0,
                    forced: m
                }, {
                    all: function(e1) {
                        var a = this, t = M(a), l = t.resolve, u = t.reject, r = b(function() {
                            var o = c(a.resolve), n = [], s = 0, i = 1;
                            d(e1, function(e1) {
                                var t = s++, r = !1;
                                n.push(void 0), i++, o.call(a, e1).then(function(e1) {
                                    r || (r = !0, n[t] = e1, --i || l(n));
                                }, u);
                            }), --i || l(n);
                        });
                        return r.error && u(r.value), t.promise;
                    },
                    race: function(e1) {
                        var r = this, o = M(r), n = o.reject, t = b(function() {
                            var t = c(r.resolve);
                            d(e1, function(e1) {
                                t.call(r, e1).then(o.resolve, n);
                            });
                        });
                        return t.error && n(t.value), o.promise;
                    }
                });
            },
            {
                "../internals/a-function": 5,
                "../internals/an-instance": 9,
                "../internals/check-correctness-of-iteration": 27,
                "../internals/classof-raw": 28,
                "../internals/engine-v8-version": 48,
                "../internals/export": 50,
                "../internals/get-built-in": 57,
                "../internals/global": 60,
                "../internals/host-report-errors": 63,
                "../internals/inspect-source": 69,
                "../internals/internal-state": 71,
                "../internals/is-forced": 74,
                "../internals/is-object": 75,
                "../internals/is-pure": 76,
                "../internals/iterate": 78,
                "../internals/microtask": 82,
                "../internals/native-promise-constructor": 83,
                "../internals/new-promise-capability": 87,
                "../internals/perform": 107,
                "../internals/promise-resolve": 108,
                "../internals/redefine": 110,
                "../internals/redefine-all": 109,
                "../internals/set-species": 118,
                "../internals/set-to-string-tag": 119,
                "../internals/species-constructor": 123,
                "../internals/task": 132,
                "../internals/well-known-symbol": 150
            }
        ],
        192: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/get-built-in"), s = e1("../internals/a-function"), i = e1("../internals/an-object"), a = e1("../internals/is-object"), l = e1("../internals/object-create"), u = e1("../internals/function-bind"), e1 = e1("../internals/fails"), c = n("Reflect", "construct"), d = e1(function() {
                    function e1() {}
                    return !(c(function() {}, [], e1) instanceof e1);
                }), h = !e1(function() {
                    c(function() {});
                }), n = d || h;
                o({
                    target: "Reflect",
                    stat: !0,
                    forced: n,
                    sham: n
                }, {
                    construct: function(e1, t) {
                        s(e1), i(t);
                        var r = arguments.length < 3 ? e1 : s(arguments[2]);
                        if (h && !d) return c(e1, t, r);
                        if (e1 == r) {
                            switch(t.length){
                                case 0:
                                    return new e1;
                                case 1:
                                    return new e1(t[0]);
                                case 2:
                                    return new e1(t[0], t[1]);
                                case 3:
                                    return new e1(t[0], t[1], t[2]);
                                case 4:
                                    return new e1(t[0], t[1], t[2], t[3]);
                            }
                            var o = [
                                null
                            ];
                            return o.push.apply(o, t), new (u.apply(e1, o));
                        }
                        o = r.prototype, r = l(a(o) ? o : Object.prototype), o = Function.apply.call(e1, r, t);
                        return a(o) ? o : r;
                    }
                });
            },
            {
                "../internals/a-function": 5,
                "../internals/an-object": 10,
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/function-bind": 56,
                "../internals/get-built-in": 57,
                "../internals/is-object": 75,
                "../internals/object-create": 91
            }
        ],
        193: [
            function(e1, t, r) {
                var o = e1("../internals/export"), s = e1("../internals/is-object"), i = e1("../internals/an-object"), a = e1("../internals/has"), l = e1("../internals/object-get-own-property-descriptor"), u = e1("../internals/object-get-prototype-of");
                o({
                    target: "Reflect",
                    stat: !0
                }, {
                    get: function e1(t, r) {
                        var o, n = arguments.length < 3 ? t : arguments[2];
                        return i(t) === n ? t[r] : (o = l.f(t, r)) ? a(o, "value") ? o.value : void 0 === o.get ? void 0 : o.get.call(n) : s(o = u(t)) ? e1(o, r, n) : void 0;
                    }
                });
            },
            {
                "../internals/an-object": 10,
                "../internals/export": 50,
                "../internals/has": 61,
                "../internals/is-object": 75,
                "../internals/object-get-own-property-descriptor": 94,
                "../internals/object-get-prototype-of": 98
            }
        ],
        194: [
            function(e1, t, r) {
                var o = e1("../internals/descriptors"), n = e1("../internals/global"), s = e1("../internals/is-forced"), i = e1("../internals/inherit-if-required"), a = e1("../internals/object-define-property").f, l = e1("../internals/object-get-own-property-names").f, u = e1("../internals/is-regexp"), c = e1("../internals/regexp-flags"), d = e1("../internals/regexp-sticky-helpers"), h = e1("../internals/redefine"), f = e1("../internals/fails"), p = e1("../internals/internal-state").set, m = e1("../internals/set-species"), y = e1("../internals/well-known-symbol")("match"), g = n.RegExp, v = g.prototype, b = /a/g, _ = /a/g, j = new g(b) !== b, x = d.UNSUPPORTED_Y;
                if (o && s("RegExp", !j || x || f(function() {
                    return _[y] = !1, g(b) != b || g(_) == _ || "/a/i" != g(b, "i");
                }))) {
                    for(var w = function(e1, t) {
                        var r, o = this instanceof w, n = u(e1), s = void 0 === t;
                        if (!o && n && e1.constructor === w && s) return e1;
                        j ? n && !s && (e1 = e1.source) : e1 instanceof w && (s && (t = c.call(e1)), e1 = e1.source), x && (r = !!t && -1 < t.indexOf("y")) && (t = t.replace(/y/g, ""));
                        n = i(j ? new g(e1, t) : g(e1, t), o ? this : v, w);
                        return x && r && p(n, {
                            sticky: r
                        }), n;
                    }, S = l(g), T = 0; S.length > T;)!function(t) {
                        t in w || a(w, t, {
                            configurable: !0,
                            get: function() {
                                return g[t];
                            },
                            set: function(e1) {
                                g[t] = e1;
                            }
                        });
                    }(S[T++]);
                    (v.constructor = w).prototype = v, h(n, "RegExp", w);
                }
                m("RegExp");
            },
            {
                "../internals/descriptors": 43,
                "../internals/fails": 51,
                "../internals/global": 60,
                "../internals/inherit-if-required": 68,
                "../internals/internal-state": 71,
                "../internals/is-forced": 74,
                "../internals/is-regexp": 77,
                "../internals/object-define-property": 93,
                "../internals/object-get-own-property-names": 96,
                "../internals/redefine": 110,
                "../internals/regexp-flags": 113,
                "../internals/regexp-sticky-helpers": 114,
                "../internals/set-species": 118,
                "../internals/well-known-symbol": 150
            }
        ],
        195: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), e1 = e1("../internals/regexp-exec");
                o({
                    target: "RegExp",
                    proto: !0,
                    forced: /./.exec !== e1
                }, {
                    exec: e1
                });
            },
            {
                "../internals/export": 50,
                "../internals/regexp-exec": 112
            }
        ],
        196: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/redefine"), n = e1("../internals/an-object"), s = e1("../internals/fails"), i = e1("../internals/regexp-flags"), e1 = "toString", a = RegExp.prototype, l = a[e1], s = s(function() {
                    return "/a/b" != l.call({
                        source: "a",
                        flags: "b"
                    });
                }), u = l.name != e1;
                (s || u) && o(RegExp.prototype, e1, function() {
                    var e1 = n(this), t = String(e1.source), r = e1.flags;
                    return "/" + t + "/" + String(void 0 === r && e1 instanceof RegExp && !("flags" in a) ? i.call(e1) : r);
                }, {
                    unsafe: !0
                });
            },
            {
                "../internals/an-object": 10,
                "../internals/fails": 51,
                "../internals/redefine": 110,
                "../internals/regexp-flags": 113
            }
        ],
        197: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/collection"), e1 = e1("../internals/collection-strong");
                t.exports = o("Set", function(e1) {
                    return function() {
                        return e1(this, arguments.length ? arguments[0] : void 0);
                    };
                }, e1);
            },
            {
                "../internals/collection": 32,
                "../internals/collection-strong": 30
            }
        ],
        198: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/object-get-own-property-descriptor").f, s = e1("../internals/to-length"), i = e1("../internals/not-a-regexp"), a = e1("../internals/require-object-coercible"), l = e1("../internals/correct-is-regexp-logic"), e1 = e1("../internals/is-pure"), u = "".endsWith, c = Math.min, l = l("endsWith");
                o({
                    target: "String",
                    proto: !0,
                    forced: !!(e1 || l || !(o = n(String.prototype, "endsWith")) || o.writable) && !l
                }, {
                    endsWith: function(e1) {
                        var t = String(a(this)), r = (i(e1), 1 < arguments.length ? arguments[1] : void 0), o = s(t.length), r = void 0 === r ? o : c(s(r), o), o = String(e1);
                        return u ? u.call(t, o, r) : t.slice(r - o.length, r) === o;
                    }
                });
            },
            {
                "../internals/correct-is-regexp-logic": 34,
                "../internals/export": 50,
                "../internals/is-pure": 76,
                "../internals/not-a-regexp": 88,
                "../internals/object-get-own-property-descriptor": 94,
                "../internals/require-object-coercible": 115,
                "../internals/to-length": 138
            }
        ],
        199: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/not-a-regexp"), s = e1("../internals/require-object-coercible");
                o({
                    target: "String",
                    proto: !0,
                    forced: !e1("../internals/correct-is-regexp-logic")("includes")
                }, {
                    includes: function(e1) {
                        return !!~String(s(this)).indexOf(n(e1), 1 < arguments.length ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/correct-is-regexp-logic": 34,
                "../internals/export": 50,
                "../internals/not-a-regexp": 88,
                "../internals/require-object-coercible": 115
            }
        ],
        200: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/string-multibyte").charAt, n = e1("../internals/internal-state"), e1 = e1("../internals/define-iterator"), s = "String Iterator", i = n.set, a = n.getterFor(s);
                e1(String, "String", function(e1) {
                    i(this, {
                        type: s,
                        string: String(e1),
                        index: 0
                    });
                }, function() {
                    var e1 = a(this), t = e1.string, r = e1.index;
                    return r >= t.length ? {
                        value: void 0,
                        done: !0
                    } : (t = o(t, r), e1.index += t.length, {
                        value: t,
                        done: !1
                    });
                });
            },
            {
                "../internals/define-iterator": 41,
                "../internals/internal-state": 71,
                "../internals/string-multibyte": 125
            }
        ],
        201: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/fix-regexp-well-known-symbol-logic"), c = e1("../internals/an-object"), d = e1("../internals/to-length"), n = e1("../internals/require-object-coercible"), h = e1("../internals/advance-string-index"), f = e1("../internals/regexp-exec-abstract");
                o("match", 1, function(o, l, u) {
                    return [
                        function(e1) {
                            var t = n(this), r = null == e1 ? void 0 : e1[o];
                            return void 0 !== r ? r.call(e1, t) : new RegExp(e1)[o](String(t));
                        },
                        function(e1) {
                            var t = u(l, e1, this);
                            if (t.done) return t.value;
                            var r = c(e1), o = String(this);
                            if (!r.global) return f(r, o);
                            for(var n = r.unicode, s = [], i = r.lastIndex = 0; null !== (a = f(r, o));){
                                var a = String(a[0]);
                                "" === (s[i] = a) && (r.lastIndex = h(o, d(r.lastIndex), n)), i++;
                            }
                            return 0 === i ? null : s;
                        }
                    ];
                });
            },
            {
                "../internals/advance-string-index": 8,
                "../internals/an-object": 10,
                "../internals/fix-regexp-well-known-symbol-logic": 52,
                "../internals/regexp-exec-abstract": 111,
                "../internals/require-object-coercible": 115,
                "../internals/to-length": 138
            }
        ],
        202: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/string-pad").start;
                o({
                    target: "String",
                    proto: !0,
                    forced: e1("../internals/string-pad-webkit-bug")
                }, {
                    padStart: function(e1) {
                        return n(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/export": 50,
                "../internals/string-pad": 127,
                "../internals/string-pad-webkit-bug": 126
            }
        ],
        203: [
            function(e1, t, r) {
                e1("../internals/export")({
                    target: "String",
                    proto: !0
                }, {
                    repeat: e1("../internals/string-repeat")
                });
            },
            {
                "../internals/export": 50,
                "../internals/string-repeat": 129
            }
        ],
        204: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/fix-regexp-well-known-symbol-logic"), T = e1("../internals/an-object"), E = e1("../internals/to-object"), M = e1("../internals/to-length"), k = e1("../internals/to-integer"), s = e1("../internals/require-object-coercible"), O = e1("../internals/advance-string-index"), C = e1("../internals/regexp-exec-abstract"), P = Math.max, A = Math.min, L = Math.floor, R = /\$([$&'`]|\d\d?|<[^>]*>)/g, I = /\$([$&'`]|\d\d?)/g;
                o("replace", 2, function(n, _, j, e1) {
                    var x = e1.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE, w = e1.REPLACE_KEEPS_$0, S = x ? "$" : "$0";
                    return [
                        function(e1, t) {
                            var r = s(this), o = null == e1 ? void 0 : e1[n];
                            return void 0 !== o ? o.call(e1, r, t) : _.call(String(r), e1, t);
                        },
                        function(e1, t) {
                            if (!x && w || "string" == typeof t && -1 === t.indexOf(S)) {
                                var r = j(_, e1, this, t);
                                if (r.done) return r.value;
                            }
                            for(var o, n = T(e1), s = String(this), i = "function" == typeof t, a = (i || (t = String(t)), n.global), l = (a && (o = n.unicode, n.lastIndex = 0), []); null !== (f = C(n, s)) && (l.push(f), a);)"" === String(f[0]) && (n.lastIndex = O(s, M(n.lastIndex), o));
                            for(var u, c = "", d = 0, h = 0; h < l.length; h++){
                                for(var f = l[h], p = String(f[0]), m = P(A(k(f.index), s.length), 0), y = [], g = 1; g < f.length; g++)y.push(void 0 === (u = f[g]) ? u : String(u));
                                var v = f.groups, b = i ? (b = [
                                    p
                                ].concat(y, m, s), void 0 !== v && b.push(v), String(t.apply(void 0, b))) : function(s, i, a, l, u, e1) {
                                    var c = a + s.length, d = l.length, t = I;
                                    void 0 !== u && (u = E(u), t = R);
                                    return _.call(e1, t, function(e1, t) {
                                        var r;
                                        switch(t.charAt(0)){
                                            case "$":
                                                return "$";
                                            case "&":
                                                return s;
                                            case "`":
                                                return i.slice(0, a);
                                            case "'":
                                                return i.slice(c);
                                            case "<":
                                                r = u[t.slice(1, -1)];
                                                break;
                                            default:
                                                var o, n = +t;
                                                if (0 == n) return e1;
                                                if (d < n) return 0 !== (o = L(n / 10)) && o <= d ? void 0 === l[o - 1] ? t.charAt(1) : l[o - 1] + t.charAt(1) : e1;
                                                r = l[n - 1];
                                        }
                                        return void 0 === r ? "" : r;
                                    });
                                }(p, s, m, y, v, t);
                                d <= m && (c += s.slice(d, m) + b, d = m + p.length);
                            }
                            return c + s.slice(d);
                        }
                    ];
                });
            },
            {
                "../internals/advance-string-index": 8,
                "../internals/an-object": 10,
                "../internals/fix-regexp-well-known-symbol-logic": 52,
                "../internals/regexp-exec-abstract": 111,
                "../internals/require-object-coercible": 115,
                "../internals/to-integer": 137,
                "../internals/to-length": 138,
                "../internals/to-object": 139
            }
        ],
        205: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/fix-regexp-well-known-symbol-logic"), i = e1("../internals/an-object"), a = e1("../internals/require-object-coercible"), l = e1("../internals/same-value"), u = e1("../internals/regexp-exec-abstract");
                o("search", 1, function(o, n, s) {
                    return [
                        function(e1) {
                            var t = a(this), r = null == e1 ? void 0 : e1[o];
                            return void 0 !== r ? r.call(e1, t) : new RegExp(e1)[o](String(t));
                        },
                        function(e1) {
                            var t, r = s(n, e1, this);
                            return r.done ? r.value : (r = i(e1), e1 = String(this), t = r.lastIndex, l(t, 0) || (r.lastIndex = 0), e1 = u(r, e1), l(r.lastIndex, t) || (r.lastIndex = t), null === e1 ? -1 : e1.index);
                        }
                    ];
                });
            },
            {
                "../internals/an-object": 10,
                "../internals/fix-regexp-well-known-symbol-logic": 52,
                "../internals/regexp-exec-abstract": 111,
                "../internals/require-object-coercible": 115,
                "../internals/same-value": 116
            }
        ],
        206: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/fix-regexp-well-known-symbol-logic"), c = e1("../internals/is-regexp"), g = e1("../internals/an-object"), d = e1("../internals/require-object-coercible"), v = e1("../internals/species-constructor"), b = e1("../internals/advance-string-index"), _ = e1("../internals/to-length"), j = e1("../internals/regexp-exec-abstract"), h = e1("../internals/regexp-exec"), e1 = e1("../internals/fails"), f = [].push, x = Math.min, w = 4294967295, S = !e1(function() {
                    return !RegExp(w, "y");
                });
                o("split", 2, function(n, p, m) {
                    var y = "c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1).length || 2 != "ab".split(/(?:ab)*/).length || 4 != ".".split(/(.?)(.?)/).length || 1 < ".".split(/()()/).length || "".split(/.?/).length ? function(e1, t) {
                        var r = String(d(this)), o = void 0 === t ? w : t >>> 0;
                        if (0 == o) return [];
                        if (void 0 === e1) return [
                            r
                        ];
                        if (!c(e1)) return p.call(r, e1, o);
                        for(var n, s, i, a = [], t = (e1.ignoreCase ? "i" : "") + (e1.multiline ? "m" : "") + (e1.unicode ? "u" : "") + (e1.sticky ? "y" : ""), l = 0, u = new RegExp(e1.source, t + "g"); (n = h.call(u, r)) && !(l < (s = u.lastIndex) && (a.push(r.slice(l, n.index)), 1 < n.length && n.index < r.length && f.apply(a, n.slice(1)), i = n[0].length, l = s, a.length >= o));)u.lastIndex === n.index && u.lastIndex++;
                        return l === r.length ? !i && u.test("") || a.push("") : a.push(r.slice(l)), a.length > o ? a.slice(0, o) : a;
                    } : "0".split(void 0, 0).length ? function(e1, t) {
                        return void 0 === e1 && 0 === t ? [] : p.call(this, e1, t);
                    } : p;
                    return [
                        function(e1, t) {
                            var r = d(this), o = null == e1 ? void 0 : e1[n];
                            return void 0 !== o ? o.call(e1, r, t) : y.call(String(r), e1, t);
                        },
                        function(e1, t) {
                            var r = m(y, e1, this, t, y !== p);
                            if (r.done) return r.value;
                            var r = g(e1), o = String(this), e1 = v(r, RegExp), n = r.unicode, s = (r.ignoreCase ? "i" : "") + (r.multiline ? "m" : "") + (r.unicode ? "u" : "") + (S ? "y" : "g"), i = new e1(S ? r : "^(?:" + r.source + ")", s), a = void 0 === t ? w : t >>> 0;
                            if (0 == a) return [];
                            if (0 === o.length) return null === j(i, o) ? [
                                o
                            ] : [];
                            for(var l = 0, u = 0, c = []; u < o.length;){
                                i.lastIndex = S ? u : 0;
                                var d, h = j(i, S ? o : o.slice(u));
                                if (null === h || (d = x(_(i.lastIndex + (S ? 0 : u)), o.length)) === l) u = b(o, u, n);
                                else {
                                    if (c.push(o.slice(l, u)), c.length === a) return c;
                                    for(var f = 1; f <= h.length - 1; f++)if (c.push(h[f]), c.length === a) return c;
                                    u = l = d;
                                }
                            }
                            return c.push(o.slice(l)), c;
                        }
                    ];
                }, !S);
            },
            {
                "../internals/advance-string-index": 8,
                "../internals/an-object": 10,
                "../internals/fails": 51,
                "../internals/fix-regexp-well-known-symbol-logic": 52,
                "../internals/is-regexp": 77,
                "../internals/regexp-exec": 112,
                "../internals/regexp-exec-abstract": 111,
                "../internals/require-object-coercible": 115,
                "../internals/species-constructor": 123,
                "../internals/to-length": 138
            }
        ],
        207: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/object-get-own-property-descriptor").f, s = e1("../internals/to-length"), i = e1("../internals/not-a-regexp"), a = e1("../internals/require-object-coercible"), l = e1("../internals/correct-is-regexp-logic"), e1 = e1("../internals/is-pure"), u = "".startsWith, c = Math.min, l = l("startsWith");
                o({
                    target: "String",
                    proto: !0,
                    forced: !!(e1 || l || !(o = n(String.prototype, "startsWith")) || o.writable) && !l
                }, {
                    startsWith: function(e1) {
                        var t = String(a(this)), r = (i(e1), s(c(1 < arguments.length ? arguments[1] : void 0, t.length))), e1 = String(e1);
                        return u ? u.call(t, e1, r) : t.slice(r, r + e1.length) === e1;
                    }
                });
            },
            {
                "../internals/correct-is-regexp-logic": 34,
                "../internals/export": 50,
                "../internals/is-pure": 76,
                "../internals/not-a-regexp": 88,
                "../internals/object-get-own-property-descriptor": 94,
                "../internals/require-object-coercible": 115,
                "../internals/to-length": 138
            }
        ],
        208: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/create-html");
                o({
                    target: "String",
                    proto: !0,
                    forced: e1("../internals/string-html-forced")("sub")
                }, {
                    sub: function() {
                        return n(this, "sub", "", "");
                    }
                });
            },
            {
                "../internals/create-html": 36,
                "../internals/export": 50,
                "../internals/string-html-forced": 124
            }
        ],
        209: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/string-trim").trim;
                o({
                    target: "String",
                    proto: !0,
                    forced: e1("../internals/string-trim-forced")("trim")
                }, {
                    trim: function() {
                        return n(this);
                    }
                });
            },
            {
                "../internals/export": 50,
                "../internals/string-trim": 131,
                "../internals/string-trim-forced": 130
            }
        ],
        210: [
            function(e1, t, r) {
                "use strict";
                var o, n, s, i, a, l = e1("../internals/export"), u = e1("../internals/descriptors"), c = e1("../internals/global"), d = e1("../internals/has"), h = e1("../internals/is-object"), f = e1("../internals/object-define-property").f, e1 = e1("../internals/copy-constructor-properties"), p = c.Symbol;
                !u || "function" != typeof p || "description" in p.prototype && void 0 === p().description || (o = {}, e1(n = function() {
                    var e1 = arguments.length < 1 || void 0 === arguments[0] ? void 0 : String(arguments[0]), t = this instanceof n ? new p(e1) : void 0 === e1 ? p() : p(e1);
                    return "" === e1 && (o[t] = !0), t;
                }, p), (c = n.prototype = p.prototype).constructor = n, s = c.toString, i = "Symbol(test)" == String(p("test")), a = /^Symbol\((.*)\)[^)]+$/, f(c, "description", {
                    configurable: !0,
                    get: function() {
                        var e1 = h(this) ? this.valueOf() : this, t = s.call(e1);
                        return d(o, e1) ? "" : "" === (e1 = i ? t.slice(7, -1) : t.replace(a, "$1")) ? void 0 : e1;
                    }
                }), l({
                    global: !0,
                    forced: !0
                }, {
                    Symbol: n
                }));
            },
            {
                "../internals/copy-constructor-properties": 33,
                "../internals/descriptors": 43,
                "../internals/export": 50,
                "../internals/global": 60,
                "../internals/has": 61,
                "../internals/is-object": 75,
                "../internals/object-define-property": 93
            }
        ],
        211: [
            function(e1, t, r) {
                e1("../internals/define-well-known-symbol")("iterator");
            },
            {
                "../internals/define-well-known-symbol": 42
            }
        ],
        212: [
            function(e1, D, F) {
                "use strict";
                function o(e1, t) {
                    var r = E[e1] = f(w[j]);
                    return ie(r, {
                        type: _,
                        tag: e1,
                        description: t
                    }), s || (r.description = t), r;
                }
                function r(t, e1) {
                    u(t);
                    var r = c(e1), e1 = q(r).concat(I(r));
                    return v(e1, function(e1) {
                        s && !R.call(r, e1) || L(t, e1, r[e1]);
                    }), t;
                }
                function t(e1, t) {
                    var r, e1 = c(e1), t = d(t, !0);
                    if (e1 !== x || !l(E, t) || l(M, t)) return !(r = le(e1, t)) || !l(E, t) || l(e1, b) && e1[b][t] || (r.enumerable = !0), r;
                }
                function U(e1) {
                    var e1 = ue(c(e1)), t = [];
                    return v(e1, function(e1) {
                        l(E, e1) || l(ee, e1) || t.push(e1);
                    }), t;
                }
                var n = e1("../internals/export"), N = e1("../internals/global"), B = e1("../internals/get-built-in"), G = e1("../internals/is-pure"), s = e1("../internals/descriptors"), i = e1("../internals/native-symbol"), V = e1("../internals/use-symbol-as-uid"), a = e1("../internals/fails"), l = e1("../internals/has"), z = e1("../internals/is-array"), H = e1("../internals/is-object"), u = e1("../internals/an-object"), W = e1("../internals/to-object"), c = e1("../internals/to-indexed-object"), d = e1("../internals/to-primitive"), h = e1("../internals/create-property-descriptor"), f = e1("../internals/object-create"), q = e1("../internals/object-keys"), X = e1("../internals/object-get-own-property-names"), Y = e1("../internals/object-get-own-property-names-external"), p = e1("../internals/object-get-own-property-symbols"), Z = e1("../internals/object-get-own-property-descriptor"), K = e1("../internals/object-define-property"), Q = e1("../internals/object-property-is-enumerable"), J = e1("../internals/create-non-enumerable-property"), m = e1("../internals/redefine"), y = e1("../internals/shared"), $ = e1("../internals/shared-key"), ee = e1("../internals/hidden-keys"), te = e1("../internals/uid"), re = e1("../internals/well-known-symbol"), oe = e1("../internals/well-known-symbol-wrapped"), ne = e1("../internals/define-well-known-symbol"), se = e1("../internals/set-to-string-tag"), g = e1("../internals/internal-state"), v = e1("../internals/array-iteration").forEach, b = $("hidden"), _ = "Symbol", j = "prototype", e1 = re("toPrimitive"), ie = g.set, ae = g.getterFor(_), x = Object[j], w = N.Symbol, S = B("JSON", "stringify"), le = Z.f, T = K.f, ue = Y.f, ce = Q.f, E = y("symbols"), M = y("op-symbols"), k = y("string-to-symbol-registry"), O = y("symbol-to-string-registry"), $ = y("wks"), g = N.QObject, C = !g || !g[j] || !g[j].findChild, P = s && a(function() {
                    return 7 != f(T({}, "a", {
                        get: function() {
                            return T(this, "a", {
                                value: 7
                            }).a;
                        }
                    })).a;
                }) ? function(e1, t, r) {
                    var o = le(x, t);
                    o && delete x[t], T(e1, t, r), o && e1 !== x && T(x, t, o);
                } : T, A = V ? function(e1) {
                    return "symbol" == typeof e1;
                } : function(e1) {
                    return Object(e1) instanceof w;
                }, L = function(e1, t, r) {
                    e1 === x && L(M, t, r), u(e1);
                    t = d(t, !0);
                    return u(r), (l(E, t) ? (r.enumerable ? (l(e1, b) && e1[b][t] && (e1[b][t] = !1), r = f(r, {
                        enumerable: h(0, !1)
                    })) : (l(e1, b) || T(e1, b, h(1, {})), e1[b][t] = !0), P) : T)(e1, t, r);
                }, R = function(e1) {
                    var e1 = d(e1, !0), t = ce.call(this, e1);
                    return !(this === x && l(E, e1) && !l(M, e1)) && (!(t || !l(this, e1) || !l(E, e1) || l(this, b) && this[b][e1]) || t);
                }, I = function(e1) {
                    var t = e1 === x, e1 = ue(t ? M : c(e1)), r = [];
                    return v(e1, function(e1) {
                        !l(E, e1) || t && !l(x, e1) || r.push(E[e1]);
                    }), r;
                };
                i || (m((w = function() {
                    if (this instanceof w) throw TypeError("Symbol is not a constructor");
                    var e1 = arguments.length && void 0 !== arguments[0] ? String(arguments[0]) : void 0, t = te(e1), r = function(e1) {
                        this === x && r.call(M, e1), l(this, b) && l(this[b], t) && (this[b][t] = !1), P(this, t, h(1, e1));
                    };
                    return s && C && P(x, t, {
                        configurable: !0,
                        set: r
                    }), o(t, e1);
                })[j], "toString", function() {
                    return ae(this).tag;
                }), m(w, "withoutSetter", function(e1) {
                    return o(te(e1), e1);
                }), Q.f = R, K.f = L, Z.f = t, X.f = Y.f = U, p.f = I, oe.f = function(e1) {
                    return o(re(e1), e1);
                }, s && (T(w[j], "description", {
                    configurable: !0,
                    get: function() {
                        return ae(this).description;
                    }
                }), G || m(x, "propertyIsEnumerable", R, {
                    unsafe: !0
                }))), n({
                    global: !0,
                    wrap: !0,
                    forced: !i,
                    sham: !i
                }, {
                    Symbol: w
                }), v(q($), function(e1) {
                    ne(e1);
                }), n({
                    target: _,
                    stat: !0,
                    forced: !i
                }, {
                    for: function(e1) {
                        var t, e1 = String(e1);
                        return l(k, e1) ? k[e1] : (t = w(e1), k[e1] = t, O[t] = e1, t);
                    },
                    keyFor: function(e1) {
                        if (!A(e1)) throw TypeError(e1 + " is not a symbol");
                        if (l(O, e1)) return O[e1];
                    },
                    useSetter: function() {
                        C = !0;
                    },
                    useSimple: function() {
                        C = !1;
                    }
                }), n({
                    target: "Object",
                    stat: !0,
                    forced: !i,
                    sham: !s
                }, {
                    create: function(e1, t) {
                        return void 0 === t ? f(e1) : r(f(e1), t);
                    },
                    defineProperty: L,
                    defineProperties: r,
                    getOwnPropertyDescriptor: t
                }), n({
                    target: "Object",
                    stat: !0,
                    forced: !i
                }, {
                    getOwnPropertyNames: U,
                    getOwnPropertySymbols: I
                }), n({
                    target: "Object",
                    stat: !0,
                    forced: a(function() {
                        p.f(1);
                    })
                }, {
                    getOwnPropertySymbols: function(e1) {
                        return p.f(W(e1));
                    }
                }), S && n({
                    target: "JSON",
                    stat: !0,
                    forced: !i || a(function() {
                        var e1 = w();
                        return "[null]" != S([
                            e1
                        ]) || "{}" != S({
                            a: e1
                        }) || "{}" != S(Object(e1));
                    })
                }, {
                    stringify: function(e1, t, r) {
                        for(var o, n = [
                            e1
                        ], s = 1; s < arguments.length;)n.push(arguments[s++]);
                        if ((H(o = t) || void 0 !== e1) && !A(e1)) return z(t) || (t = function(e1, t) {
                            if ("function" == typeof o && (t = o.call(this, e1, t)), !A(t)) return t;
                        }), n[1] = t, S.apply(null, n);
                    }
                }), w[j][e1] || J(w[j], e1, w[j].valueOf), se(w, _), ee[b] = !0;
            },
            {
                "../internals/an-object": 10,
                "../internals/array-iteration": 19,
                "../internals/create-non-enumerable-property": 38,
                "../internals/create-property-descriptor": 39,
                "../internals/define-well-known-symbol": 42,
                "../internals/descriptors": 43,
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/get-built-in": 57,
                "../internals/global": 60,
                "../internals/has": 61,
                "../internals/hidden-keys": 62,
                "../internals/internal-state": 71,
                "../internals/is-array": 73,
                "../internals/is-object": 75,
                "../internals/is-pure": 76,
                "../internals/native-symbol": 84,
                "../internals/object-create": 91,
                "../internals/object-define-property": 93,
                "../internals/object-get-own-property-descriptor": 94,
                "../internals/object-get-own-property-names": 96,
                "../internals/object-get-own-property-names-external": 95,
                "../internals/object-get-own-property-symbols": 97,
                "../internals/object-keys": 100,
                "../internals/object-property-is-enumerable": 101,
                "../internals/redefine": 110,
                "../internals/set-to-string-tag": 119,
                "../internals/shared": 122,
                "../internals/shared-key": 120,
                "../internals/to-indexed-object": 136,
                "../internals/to-object": 139,
                "../internals/to-primitive": 142,
                "../internals/uid": 147,
                "../internals/use-symbol-as-uid": 148,
                "../internals/well-known-symbol": 150,
                "../internals/well-known-symbol-wrapped": 149
            }
        ],
        213: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-copy-within"), s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("copyWithin", function(e1, t) {
                    return n.call(s(this), e1, t, 2 < arguments.length ? arguments[2] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-copy-within": 14
            }
        ],
        214: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-iteration").every, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("every", function(e1) {
                    return n(s(this), e1, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-iteration": 19
            }
        ],
        215: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-fill"), s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("fill", function(e1) {
                    return n.apply(s(this), arguments);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-fill": 15
            }
        ],
        216: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), s = e1("../internals/array-iteration").filter, i = e1("../internals/species-constructor"), a = o.aTypedArray, l = o.aTypedArrayConstructor;
                (0, o.exportTypedArrayMethod)("filter", function(e1) {
                    for(var t = s(a(this), e1, 1 < arguments.length ? arguments[1] : void 0), e1 = i(this, this.constructor), r = 0, o = t.length, n = new (l(e1))(o); r < o;)n[r] = t[r++];
                    return n;
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-iteration": 19,
                "../internals/species-constructor": 123
            }
        ],
        217: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-iteration").findIndex, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("findIndex", function(e1) {
                    return n(s(this), e1, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-iteration": 19
            }
        ],
        218: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-iteration").find, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("find", function(e1) {
                    return n(s(this), e1, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-iteration": 19
            }
        ],
        219: [
            function(e1, t, r) {
                e1("../internals/typed-array-constructor")("Float32", function(o) {
                    return function(e1, t, r) {
                        return o(this, e1, t, r);
                    };
                });
            },
            {
                "../internals/typed-array-constructor": 144
            }
        ],
        220: [
            function(e1, t, r) {
                e1("../internals/typed-array-constructor")("Float64", function(o) {
                    return function(e1, t, r) {
                        return o(this, e1, t, r);
                    };
                });
            },
            {
                "../internals/typed-array-constructor": 144
            }
        ],
        221: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-iteration").forEach, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("forEach", function(e1) {
                    n(s(this), e1, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-iteration": 19
            }
        ],
        222: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-includes").includes, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("includes", function(e1) {
                    return n(s(this), e1, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-includes": 18
            }
        ],
        223: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-includes").indexOf, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("indexOf", function(e1) {
                    return n(s(this), e1, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-includes": 18
            }
        ],
        224: [
            function(e1, t, r) {
                e1("../internals/typed-array-constructor")("Int16", function(o) {
                    return function(e1, t, r) {
                        return o(this, e1, t, r);
                    };
                });
            },
            {
                "../internals/typed-array-constructor": 144
            }
        ],
        225: [
            function(e1, t, r) {
                e1("../internals/typed-array-constructor")("Int32", function(o) {
                    return function(e1, t, r) {
                        return o(this, e1, t, r);
                    };
                });
            },
            {
                "../internals/typed-array-constructor": 144
            }
        ],
        226: [
            function(e1, t, r) {
                "use strict";
                function o() {
                    return a.call(c(this));
                }
                var n = e1("../internals/global"), s = e1("../internals/array-buffer-view-core"), i = e1("../modules/es.array.iterator"), e1 = e1("../internals/well-known-symbol")("iterator"), n = n.Uint8Array, a = i.values, l = i.keys, u = i.entries, c = s.aTypedArray, i = s.exportTypedArrayMethod, s = n && n.prototype[e1], n = !!s && ("values" == s.name || null == s.name);
                i("entries", function() {
                    return u.call(c(this));
                }), i("keys", function() {
                    return l.call(c(this));
                }), i("values", o, !n), i(e1, o, !n);
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/global": 60,
                "../internals/well-known-symbol": 150,
                "../modules/es.array.iterator": 165
            }
        ],
        227: [
            function(e1, t, r) {
                "use strict";
                var e1 = e1("../internals/array-buffer-view-core"), o = e1.aTypedArray, e1 = e1.exportTypedArrayMethod, n = [].join;
                e1("join", function(e1) {
                    return n.apply(o(this), arguments);
                });
            },
            {
                "../internals/array-buffer-view-core": 12
            }
        ],
        228: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-last-index-of"), s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("lastIndexOf", function(e1) {
                    return n.apply(s(this), arguments);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-last-index-of": 20
            }
        ],
        229: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-iteration").map, s = e1("../internals/species-constructor"), i = o.aTypedArray, a = o.aTypedArrayConstructor;
                (0, o.exportTypedArrayMethod)("map", function(e1) {
                    return n(i(this), e1, 1 < arguments.length ? arguments[1] : void 0, function(e1, t) {
                        return new (a(s(e1, e1.constructor)))(t);
                    });
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-iteration": 19,
                "../internals/species-constructor": 123
            }
        ],
        230: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-reduce").right, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("reduceRight", function(e1) {
                    return n(s(this), e1, arguments.length, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-reduce": 24
            }
        ],
        231: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-reduce").left, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("reduce", function(e1) {
                    return n(s(this), e1, arguments.length, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-reduce": 24
            }
        ],
        232: [
            function(e1, t, r) {
                "use strict";
                var e1 = e1("../internals/array-buffer-view-core"), n = e1.aTypedArray, e1 = e1.exportTypedArrayMethod, s = Math.floor;
                e1("reverse", function() {
                    for(var e1, t = n(this).length, r = s(t / 2), o = 0; o < r;)e1 = this[o], this[o++] = this[--t], this[t] = e1;
                    return this;
                });
            },
            {
                "../internals/array-buffer-view-core": 12
            }
        ],
        233: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), i = e1("../internals/to-length"), a = e1("../internals/to-offset"), l = e1("../internals/to-object"), e1 = e1("../internals/fails"), u = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("set", function(e1) {
                    u(this);
                    var t = a(1 < arguments.length ? arguments[1] : void 0, 1), r = this.length, o = l(e1), n = i(o.length), s = 0;
                    if (r < n + t) throw RangeError("Wrong length");
                    for(; s < n;)this[t + s] = o[s++];
                }, e1(function() {
                    new Int8Array(1).set({});
                }));
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/fails": 51,
                "../internals/to-length": 138,
                "../internals/to-object": 139,
                "../internals/to-offset": 140
            }
        ],
        234: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), i = e1("../internals/species-constructor"), e1 = e1("../internals/fails"), a = o.aTypedArray, l = o.aTypedArrayConstructor, o = o.exportTypedArrayMethod, u = [].slice;
                o("slice", function(e1, t) {
                    for(var r = u.call(a(this), e1, t), e1 = i(this, this.constructor), o = 0, n = r.length, s = new (l(e1))(n); o < n;)s[o] = r[o++];
                    return s;
                }, e1(function() {
                    new Int8Array(1).slice();
                }));
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/fails": 51,
                "../internals/species-constructor": 123
            }
        ],
        235: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-iteration").some, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("some", function(e1) {
                    return n(s(this), e1, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-iteration": 19
            }
        ],
        236: [
            function(e1, t, r) {
                "use strict";
                var e1 = e1("../internals/array-buffer-view-core"), o = e1.aTypedArray, e1 = e1.exportTypedArrayMethod, n = [].sort;
                e1("sort", function(e1) {
                    return n.call(o(this), e1);
                });
            },
            {
                "../internals/array-buffer-view-core": 12
            }
        ],
        237: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/to-length"), s = e1("../internals/to-absolute-index"), i = e1("../internals/species-constructor"), a = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("subarray", function(e1, t) {
                    var r = a(this), o = r.length, e1 = s(e1, o);
                    return new (i(r, r.constructor))(r.buffer, r.byteOffset + e1 * r.BYTES_PER_ELEMENT, n((void 0 === t ? o : s(t, o)) - e1));
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/species-constructor": 123,
                "../internals/to-absolute-index": 134,
                "../internals/to-length": 138
            }
        ],
        238: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/global"), n = e1("../internals/array-buffer-view-core"), e1 = e1("../internals/fails"), s = o.Int8Array, i = n.aTypedArray, o = n.exportTypedArrayMethod, a = [].toLocaleString, l = [].slice, u = !!s && e1(function() {
                    a.call(new s(1));
                });
                o("toLocaleString", function() {
                    return a.apply(u ? l.call(i(this)) : i(this), arguments);
                }, e1(function() {
                    return [
                        1,
                        2
                    ].toLocaleString() != new s([
                        1,
                        2
                    ]).toLocaleString();
                }) || !e1(function() {
                    s.prototype.toLocaleString.call([
                        1,
                        2
                    ]);
                }));
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/fails": 51,
                "../internals/global": 60
            }
        ],
        239: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core").exportTypedArrayMethod, n = e1("../internals/fails"), e1 = e1("../internals/global").Uint8Array, e1 = e1 && e1.prototype || {}, s = [].toString, i = [].join, n = (n(function() {
                    s.call({});
                }) && (s = function() {
                    return i.call(this);
                }), e1.toString != s);
                o("toString", s, n);
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/fails": 51,
                "../internals/global": 60
            }
        ],
        240: [
            function(e1, t, r) {
                e1("../internals/typed-array-constructor")("Uint16", function(o) {
                    return function(e1, t, r) {
                        return o(this, e1, t, r);
                    };
                });
            },
            {
                "../internals/typed-array-constructor": 144
            }
        ],
        241: [
            function(e1, t, r) {
                e1("../internals/typed-array-constructor")("Uint32", function(o) {
                    return function(e1, t, r) {
                        return o(this, e1, t, r);
                    };
                });
            },
            {
                "../internals/typed-array-constructor": 144
            }
        ],
        242: [
            function(e1, t, r) {
                e1("../internals/typed-array-constructor")("Uint8", function(o) {
                    return function(e1, t, r) {
                        return o(this, e1, t, r);
                    };
                });
            },
            {
                "../internals/typed-array-constructor": 144
            }
        ],
        243: [
            function(e1, t, r) {
                e1("../internals/typed-array-constructor")("Uint8", function(o) {
                    return function(e1, t, r) {
                        return o(this, e1, t, r);
                    };
                }, !0);
            },
            {
                "../internals/typed-array-constructor": 144
            }
        ],
        244: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return function() {
                        return e1(this, arguments.length ? arguments[0] : void 0);
                    };
                }
                var n, s, i, a, l, u = e1("../internals/global"), c = e1("../internals/redefine-all"), d = e1("../internals/internal-metadata"), h = e1("../internals/collection"), f = e1("../internals/collection-weak"), p = e1("../internals/is-object"), m = e1("../internals/internal-state").enforce, e1 = e1("../internals/native-weak-map"), u = !u.ActiveXObject && "ActiveXObject" in u, y = Object.isExtensible, t = t.exports = h("WeakMap", o, f);
                e1 && u && (n = f.getConstructor(o, "WeakMap", !0), d.REQUIRED = !0, h = t.prototype, s = h.delete, i = h.has, a = h.get, l = h.set, c(h, {
                    delete: function(e1) {
                        var t;
                        return p(e1) && !y(e1) ? ((t = m(this)).frozen || (t.frozen = new n), s.call(this, e1) || t.frozen.delete(e1)) : s.call(this, e1);
                    },
                    has: function(e1) {
                        var t;
                        return p(e1) && !y(e1) ? ((t = m(this)).frozen || (t.frozen = new n), i.call(this, e1) || t.frozen.has(e1)) : i.call(this, e1);
                    },
                    get: function(e1) {
                        var t;
                        return !p(e1) || y(e1) || ((t = m(this)).frozen || (t.frozen = new n), i.call(this, e1)) ? a.call(this, e1) : t.frozen.get(e1);
                    },
                    set: function(e1, t) {
                        var r;
                        return !p(e1) || y(e1) || ((r = m(this)).frozen || (r.frozen = new n), i.call(this, e1)) ? l.call(this, e1, t) : r.frozen.set(e1, t), this;
                    }
                }));
            },
            {
                "../internals/collection": 32,
                "../internals/collection-weak": 31,
                "../internals/global": 60,
                "../internals/internal-metadata": 70,
                "../internals/internal-state": 71,
                "../internals/is-object": 75,
                "../internals/native-weak-map": 86,
                "../internals/redefine-all": 109
            }
        ],
        245: [
            function(e1, t, r) {
                var o, n = e1("../internals/global"), s = e1("../internals/dom-iterables"), i = e1("../internals/array-for-each"), a = e1("../internals/create-non-enumerable-property");
                for(o in s){
                    var l = n[o], l = l && l.prototype;
                    if (l && l.forEach !== i) try {
                        a(l, "forEach", i);
                    } catch (e1) {
                        l.forEach = i;
                    }
                }
            },
            {
                "../internals/array-for-each": 16,
                "../internals/create-non-enumerable-property": 38,
                "../internals/dom-iterables": 45,
                "../internals/global": 60
            }
        ],
        246: [
            function(e1, t, r) {
                var o, n = e1("../internals/global"), s = e1("../internals/dom-iterables"), i = e1("../modules/es.array.iterator"), a = e1("../internals/create-non-enumerable-property"), e1 = e1("../internals/well-known-symbol"), l = e1("iterator"), u = e1("toStringTag"), c = i.values;
                for(o in s){
                    var d = n[o], h = d && d.prototype;
                    if (h) {
                        if (h[l] !== c) try {
                            a(h, l, c);
                        } catch (e1) {
                            h[l] = c;
                        }
                        if (h[u] || a(h, u, o), s[o]) {
                            for(var f in i)if (h[f] !== i[f]) try {
                                a(h, f, i[f]);
                            } catch (e1) {
                                h[f] = i[f];
                            }
                        }
                    }
                }
            },
            {
                "../internals/create-non-enumerable-property": 38,
                "../internals/dom-iterables": 45,
                "../internals/global": 60,
                "../internals/well-known-symbol": 150,
                "../modules/es.array.iterator": 165
            }
        ],
        247: [
            function(e1, t, D) {
                "use strict";
                e1("../modules/es.array.iterator");
                function n(t) {
                    try {
                        return decodeURIComponent(t);
                    } catch (e1) {
                        return t;
                    }
                }
                function r(e1) {
                    return B[e1];
                }
                function s(e1) {
                    return encodeURIComponent(e1).replace(N, r);
                }
                function c(e1) {
                    this.entries.length = 0, R(this.entries, e1);
                }
                function u(e1, t) {
                    if (e1 < t) throw TypeError("Not enough arguments");
                }
                function d() {
                    y(this, d, k);
                    var e1, t, r, o, n, s, i, a, l = 0 < arguments.length ? arguments[0] : void 0, u = [];
                    if (C(this, {
                        type: k,
                        entries: u,
                        updateURL: function() {},
                        updateSearchParams: c
                    }), void 0 !== l) {
                        if (j(l)) {
                            if ("function" == typeof (e1 = T(l))) for(r = (t = e1.call(l)).next; !(o = r.call(t)).done;){
                                if ((s = (n = (o = S(_(o.value))).next).call(o)).done || (i = n.call(o)).done || !n.call(o).done) throw TypeError("Expected sequence with length 2");
                                u.push({
                                    key: s.value + "",
                                    value: i.value + ""
                                });
                            }
                            else for(a in l)g(l, a) && u.push({
                                key: a,
                                value: l[a] + ""
                            });
                        } else R(u, "string" == typeof l ? "?" === l.charAt(0) ? l.slice(1) : l : l + "");
                    }
                }
                var o = e1("../internals/export"), i = e1("../internals/get-built-in"), a = e1("../internals/native-url"), l = e1("../internals/redefine"), h = e1("../internals/redefine-all"), f = e1("../internals/set-to-string-tag"), p = e1("../internals/create-iterator-constructor"), m = e1("../internals/internal-state"), y = e1("../internals/an-instance"), g = e1("../internals/has"), v = e1("../internals/function-bind-context"), b = e1("../internals/classof"), _ = e1("../internals/an-object"), j = e1("../internals/is-object"), x = e1("../internals/object-create"), w = e1("../internals/create-property-descriptor"), S = e1("../internals/get-iterator"), T = e1("../internals/get-iterator-method"), e1 = e1("../internals/well-known-symbol"), E = i("fetch"), M = i("Headers"), i = e1("iterator"), k = "URLSearchParams", O = k + "Iterator", C = m.set, P = m.getterFor(k), F = m.getterFor(O), U = /\+/g, A = Array(4), L = function(e1) {
                    var t, r = e1.replace(U, " "), o = 4;
                    try {
                        return decodeURIComponent(r);
                    } catch (e1) {
                        for(; o;)r = r.replace((t = o--, A[t - 1] || (A[t - 1] = RegExp("((?:%[\\da-f]{2}){" + t + "})", "gi"))), n);
                        return r;
                    }
                }, N = /[!'()~]|%20/g, B = {
                    "!": "%21",
                    "'": "%27",
                    "(": "%28",
                    ")": "%29",
                    "~": "%7E",
                    "%20": "+"
                }, R = function(e1, t) {
                    if (t) for(var r, o = t.split("&"), n = 0; n < o.length;)(r = o[n++]).length && (r = r.split("="), e1.push({
                        key: L(r.shift()),
                        value: L(r.join("="))
                    }));
                }, I = p(function(e1, t) {
                    C(this, {
                        type: O,
                        iterator: S(P(e1).entries),
                        kind: t
                    });
                }, "Iterator", function() {
                    var e1 = F(this), t = e1.kind, e1 = e1.iterator.next(), r = e1.value;
                    return e1.done || (e1.value = "keys" === t ? r.key : "values" === t ? r.value : [
                        r.key,
                        r.value
                    ]), e1;
                }), e1 = d.prototype;
                h(e1, {
                    append: function(e1, t) {
                        u(arguments.length, 2);
                        var r = P(this);
                        r.entries.push({
                            key: e1 + "",
                            value: t + ""
                        }), r.updateURL();
                    },
                    delete: function(e1) {
                        u(arguments.length, 1);
                        for(var t = P(this), r = t.entries, o = e1 + "", n = 0; n < r.length;)r[n].key === o ? r.splice(n, 1) : n++;
                        t.updateURL();
                    },
                    get: function(e1) {
                        u(arguments.length, 1);
                        for(var t = P(this).entries, r = e1 + "", o = 0; o < t.length; o++)if (t[o].key === r) return t[o].value;
                        return null;
                    },
                    getAll: function(e1) {
                        u(arguments.length, 1);
                        for(var t = P(this).entries, r = e1 + "", o = [], n = 0; n < t.length; n++)t[n].key === r && o.push(t[n].value);
                        return o;
                    },
                    has: function(e1) {
                        u(arguments.length, 1);
                        for(var t = P(this).entries, r = e1 + "", o = 0; o < t.length;)if (t[o++].key === r) return !0;
                        return !1;
                    },
                    set: function(e1, t) {
                        u(arguments.length, 1);
                        for(var r, o = P(this), n = o.entries, s = !1, i = e1 + "", a = t + "", l = 0; l < n.length; l++)(r = n[l]).key === i && (s ? n.splice(l--, 1) : (s = !0, r.value = a));
                        s || n.push({
                            key: i,
                            value: a
                        }), o.updateURL();
                    },
                    sort: function() {
                        for(var e1, t, r = P(this), o = r.entries, n = o.slice(), s = o.length = 0; s < n.length; s++){
                            for(e1 = n[s], t = 0; t < s; t++)if (o[t].key > e1.key) {
                                o.splice(t, 0, e1);
                                break;
                            }
                            t === s && o.push(e1);
                        }
                        r.updateURL();
                    },
                    forEach: function(e1) {
                        for(var t, r = P(this).entries, o = v(e1, 1 < arguments.length ? arguments[1] : void 0, 3), n = 0; n < r.length;)o((t = r[n++]).value, t.key, this);
                    },
                    keys: function() {
                        return new I(this, "keys");
                    },
                    values: function() {
                        return new I(this, "values");
                    },
                    entries: function() {
                        return new I(this, "entries");
                    }
                }, {
                    enumerable: !0
                }), l(e1, i, e1.entries), l(e1, "toString", function() {
                    for(var e1, t = P(this).entries, r = [], o = 0; o < t.length;)e1 = t[o++], r.push(s(e1.key) + "=" + s(e1.value));
                    return r.join("&");
                }, {
                    enumerable: !0
                }), f(d, k), o({
                    global: !0,
                    forced: !a
                }, {
                    URLSearchParams: d
                }), a || "function" != typeof E || "function" != typeof M || o({
                    global: !0,
                    enumerable: !0,
                    forced: !0
                }, {
                    fetch: function(e1) {
                        var t, r, o, e1 = [
                            e1
                        ];
                        return 1 < arguments.length && (j(t = arguments[1]) && (r = t.body, b(r) === k && ((o = t.headers ? new M(t.headers) : new M).has("content-type") || o.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"), t = x(t, {
                            body: w(0, String(r)),
                            headers: w(0, o)
                        }))), e1.push(t)), E.apply(this, e1);
                    }
                }), t.exports = {
                    URLSearchParams: d,
                    getState: P
                };
            },
            {
                "../internals/an-instance": 9,
                "../internals/an-object": 10,
                "../internals/classof": 29,
                "../internals/create-iterator-constructor": 37,
                "../internals/create-property-descriptor": 39,
                "../internals/export": 50,
                "../internals/function-bind-context": 55,
                "../internals/get-built-in": 57,
                "../internals/get-iterator": 59,
                "../internals/get-iterator-method": 58,
                "../internals/has": 61,
                "../internals/internal-state": 71,
                "../internals/is-object": 75,
                "../internals/native-url": 85,
                "../internals/object-create": 91,
                "../internals/redefine": 110,
                "../internals/redefine-all": 109,
                "../internals/set-to-string-tag": 119,
                "../internals/well-known-symbol": 150,
                "../modules/es.array.iterator": 165
            }
        ],
        248: [
            function(e1, y, F) {
                "use strict";
                e1("../modules/es.string.iterator");
                function c(e1) {
                    var t, r, o, n;
                    if ("number" == typeof e1) {
                        for(t = [], r = 0; r < 4; r++)t.unshift(e1 % 256), e1 = Y(e1 / 256);
                        return t.join(".");
                    }
                    if ("object" != typeof e1) return e1;
                    for(t = "", o = le(e1), r = 0; r < 8; r++)n && 0 === e1[r] || (n = n && !1, o === r ? (t += r ? ":" : "::", n = !0) : (t += e1[r].toString(16), r < 7 && (t += ":")));
                    return "[" + t + "]";
                }
                function n(e1) {
                    return !e1.host || e1.cannotBeABaseURL || "file" == e1.scheme;
                }
                function a(e1, t, r, o) {
                    var n, s, i, a = r || me, l = 0, u = "", c = !1, d = !1, h = !1;
                    for(r || (e1.scheme = "", e1.username = "", e1.password = "", e1.host = null, e1.port = null, e1.path = [], e1.query = null, e1.fragment = null, e1.cannotBeABaseURL = !1, t = t.replace(ie, "")), t = t.replace(ae, ""), n = b(t); l <= n.length;){
                        switch(s = n[l], a){
                            case me:
                                if (!s || !J.test(s)) {
                                    if (r) return _;
                                    a = ge;
                                    continue;
                                }
                                u += s.toLowerCase(), a = ye;
                                break;
                            case ye:
                                if (s && ($.test(s) || "+" == s || "-" == s || "." == s)) u += s.toLowerCase();
                                else {
                                    if (":" != s) {
                                        if (r) return _;
                                        u = "", a = ge, l = 0;
                                        continue;
                                    }
                                    if (r && (k(e1) != v(M, u) || "file" == u && (O(e1) || null !== e1.port) || "file" == e1.scheme && !e1.host)) return;
                                    if (e1.scheme = u, r) return void (k(e1) && M[e1.scheme] == e1.port && (e1.port = null));
                                    u = "", "file" == e1.scheme ? a = Ee : k(e1) && o && o.scheme == e1.scheme ? a = ve : k(e1) ? a = xe : "/" == n[l + 1] ? (a = be, l++) : (e1.cannotBeABaseURL = !0, e1.path.push(""), a = Oe);
                                }
                                break;
                            case ge:
                                if (!o || o.cannotBeABaseURL && "#" != s) return _;
                                if (o.cannotBeABaseURL && "#" == s) {
                                    e1.scheme = o.scheme, e1.path = o.path.slice(), e1.query = o.query, e1.fragment = "", e1.cannotBeABaseURL = !0, a = D;
                                    break;
                                }
                                a = "file" == o.scheme ? Ee : _e;
                                continue;
                            case ve:
                                if ("/" != s || "/" != n[l + 1]) {
                                    a = _e;
                                    continue;
                                }
                                a = P, l++;
                                break;
                            case be:
                                if ("/" == s) {
                                    a = A;
                                    break;
                                }
                                a = R;
                                continue;
                            case _e:
                                if (e1.scheme = o.scheme, s == g) e1.username = o.username, e1.password = o.password, e1.host = o.host, e1.port = o.port, e1.path = o.path.slice(), e1.query = o.query;
                                else if ("/" == s || "\\" == s && k(e1)) a = je;
                                else if ("?" == s) e1.username = o.username, e1.password = o.password, e1.host = o.host, e1.port = o.port, e1.path = o.path.slice(), e1.query = "", a = I;
                                else {
                                    if ("#" != s) {
                                        e1.username = o.username, e1.password = o.password, e1.host = o.host, e1.port = o.port, e1.path = o.path.slice(), e1.path.pop(), a = R;
                                        continue;
                                    }
                                    e1.username = o.username, e1.password = o.password, e1.host = o.host, e1.port = o.port, e1.path = o.path.slice(), e1.query = o.query, e1.fragment = "", a = D;
                                }
                                break;
                            case je:
                                if (!k(e1) || "/" != s && "\\" != s) {
                                    if ("/" != s) {
                                        e1.username = o.username, e1.password = o.password, e1.host = o.host, e1.port = o.port, a = R;
                                        continue;
                                    }
                                    a = A;
                                } else a = P;
                                break;
                            case xe:
                                if (a = P, "/" != s || "/" != u.charAt(l + 1)) continue;
                                l++;
                                break;
                            case P:
                                if ("/" == s || "\\" == s) break;
                                a = A;
                                continue;
                            case A:
                                if ("@" == s) {
                                    c && (u = "%40" + u);
                                    for(var c = !0, f = b(u), p = 0; p < f.length; p++){
                                        var m = f[p];
                                        ":" != m || h ? (m = E(m, T), h ? e1.password += m : e1.username += m) : h = !0;
                                    }
                                    u = "";
                                } else if (s == g || "/" == s || "?" == s || "#" == s || "\\" == s && k(e1)) {
                                    if (c && "" == u) return K;
                                    l -= b(u).length + 1, u = "", a = we;
                                } else u += s;
                                break;
                            case we:
                            case Se:
                                if (r && "file" == e1.scheme) {
                                    a = ke;
                                    continue;
                                }
                                if (":" != s || d) {
                                    if (s == g || "/" == s || "?" == s || "#" == s || "\\" == s && k(e1)) {
                                        if (k(e1) && "" == u) return j;
                                        if (r && "" == u && (O(e1) || null !== e1.port)) return;
                                        if (i = w(e1, u)) return i;
                                        if (u = "", a = L, r) return;
                                        continue;
                                    }
                                    "[" == s ? d = !0 : "]" == s && (d = !1), u += s;
                                } else {
                                    if ("" == u) return j;
                                    if (i = w(e1, u)) return i;
                                    if (u = "", a = Te, r == Se) return;
                                }
                                break;
                            case Te:
                                if (!x.test(s)) {
                                    if (s == g || "/" == s || "?" == s || "#" == s || "\\" == s && k(e1) || r) {
                                        if ("" != u) {
                                            var y = parseInt(u, 10);
                                            if (65535 < y) return Q;
                                            e1.port = k(e1) && y === M[e1.scheme] ? null : y, u = "";
                                        }
                                        if (r) return;
                                        a = L;
                                        continue;
                                    }
                                    return Q;
                                }
                                u += s;
                                break;
                            case Ee:
                                if (e1.scheme = "file", "/" == s || "\\" == s) a = Me;
                                else {
                                    if (!o || "file" != o.scheme) {
                                        a = R;
                                        continue;
                                    }
                                    if (s == g) e1.host = o.host, e1.path = o.path.slice(), e1.query = o.query;
                                    else if ("?" == s) e1.host = o.host, e1.path = o.path.slice(), e1.query = "", a = I;
                                    else {
                                        if ("#" != s) {
                                            de(n.slice(l).join("")) || (e1.host = o.host, e1.path = o.path.slice(), he(e1)), a = R;
                                            continue;
                                        }
                                        e1.host = o.host, e1.path = o.path.slice(), e1.query = o.query, e1.fragment = "", a = D;
                                    }
                                }
                                break;
                            case Me:
                                if ("/" == s || "\\" == s) {
                                    a = ke;
                                    break;
                                }
                                o && "file" == o.scheme && !de(n.slice(l).join("")) && (C(o.path[0], !0) ? e1.path.push(o.path[0]) : e1.host = o.host), a = R;
                                continue;
                            case ke:
                                if (s == g || "/" == s || "\\" == s || "?" == s || "#" == s) {
                                    if (!r && C(u)) a = R;
                                    else {
                                        if ("" == u) {
                                            if (e1.host = "", r) return;
                                        } else {
                                            if (i = w(e1, u)) return i;
                                            if ("localhost" == e1.host && (e1.host = ""), r) return;
                                            u = "";
                                        }
                                        a = L;
                                    }
                                    continue;
                                }
                                u += s;
                                break;
                            case L:
                                if (k(e1)) {
                                    if (a = R, "/" != s && "\\" != s) continue;
                                } else if (r || "?" != s) {
                                    if (r || "#" != s) {
                                        if (s != g && (a = R, "/" != s)) continue;
                                    } else e1.fragment = "", a = D;
                                } else e1.query = "", a = I;
                                break;
                            case R:
                                if (s == g || "/" == s || "\\" == s && k(e1) || !r && ("?" == s || "#" == s)) {
                                    if (pe(u) ? (he(e1), "/" == s || "\\" == s && k(e1) || e1.path.push("")) : fe(u) ? "/" == s || "\\" == s && k(e1) || e1.path.push("") : ("file" == e1.scheme && !e1.path.length && C(u) && (e1.host && (e1.host = ""), u = u.charAt(0) + ":"), e1.path.push(u)), u = "", "file" == e1.scheme && (s == g || "?" == s || "#" == s)) for(; 1 < e1.path.length && "" === e1.path[0];)e1.path.shift();
                                    "?" == s ? (e1.query = "", a = I) : "#" == s && (e1.fragment = "", a = D);
                                } else u += E(s, ce);
                                break;
                            case Oe:
                                "?" == s ? (e1.query = "", a = I) : "#" == s ? (e1.fragment = "", a = D) : s != g && (e1.path[0] += E(s, S));
                                break;
                            case I:
                                r || "#" != s ? s != g && ("'" == s && k(e1) ? e1.query += "%27" : e1.query += "#" == s ? "%23" : E(s, S)) : (e1.fragment = "", a = D);
                                break;
                            case D:
                                s != g && (e1.fragment += E(s, ue));
                        }
                        l++;
                    }
                }
                function l(e1) {
                    var t, r, o = G(this, l, "URL"), n = 1 < arguments.length ? arguments[1] : void 0, e1 = String(e1), s = X(o, {
                        type: "URL"
                    });
                    if (void 0 !== n) {
                        if (n instanceof l) t = p(n);
                        else if (r = a(t = {}, String(n))) throw TypeError(r);
                    }
                    if (r = a(s, e1, null, t)) throw TypeError(r);
                    var i = s.searchParams = new q;
                    (n = f(i)).updateSearchParams(s.query), n.updateURL = function() {
                        s.query = String(i) || null;
                    }, u || (o.href = m.call(o), o.origin = Ce.call(o), o.protocol = Pe.call(o), o.username = Ae.call(o), o.password = Le.call(o), o.host = Re.call(o), o.hostname = Ie.call(o), o.port = De.call(o), o.pathname = Fe.call(o), o.search = Ue.call(o), o.searchParams = Ne.call(o), o.hash = Be.call(o));
                }
                function t(e1, t) {
                    return {
                        get: e1,
                        set: t,
                        configurable: !0,
                        enumerable: !0
                    };
                }
                var g, r, o, U = e1("../internals/export"), u = e1("../internals/descriptors"), N = e1("../internals/native-url"), s = e1("../internals/global"), B = e1("../internals/object-define-properties"), i = e1("../internals/redefine"), G = e1("../internals/an-instance"), v = e1("../internals/has"), d = e1("../internals/object-assign"), b = e1("../internals/array-from"), V = e1("../internals/string-multibyte").codeAt, z = e1("../internals/string-punycode-to-ascii"), H = e1("../internals/set-to-string-tag"), W = e1("../modules/web.url-search-params"), e1 = e1("../internals/internal-state"), h = s.URL, q = W.URLSearchParams, f = W.getState, X = e1.set, p = e1.getterFor("URL"), Y = Math.floor, Z = Math.pow, K = "Invalid authority", _ = "Invalid scheme", j = "Invalid host", Q = "Invalid port", J = /[A-Za-z]/, $ = /[\d+-.A-Za-z]/, x = /\d/, ee = /^(0x|0X)/, te = /^[0-7]+$/, re = /^\d+$/, oe = /^[\dA-Fa-f]+$/, ne = /[\u0000\u0009\u000A\u000D #%/:?@[\\]]/, se = /[\u0000\u0009\u000A\u000D #/:?@[\\]]/, ie = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g, ae = /[\u0009\u000A\u000D]/g, w = function(e1, t) {
                    var r, o, n;
                    if ("[" == t.charAt(0)) return "]" == t.charAt(t.length - 1) && (r = function(e1) {
                        var t = [
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ], r = 0, o = null, n = 0, s, i, a, l, u, c, d, h = function() {
                            return e1.charAt(n);
                        };
                        if (h() == ":") {
                            if (e1.charAt(1) != ":") return;
                            n += 2;
                            r++;
                            o = r;
                        }
                        while(h()){
                            if (r == 8) return;
                            if (h() == ":") {
                                if (o !== null) return;
                                n++;
                                r++;
                                o = r;
                                continue;
                            }
                            s = i = 0;
                            while(i < 4 && oe.test(h())){
                                s = s * 16 + parseInt(h(), 16);
                                n++;
                                i++;
                            }
                            if (h() == ".") {
                                if (i == 0) return;
                                n -= i;
                                if (r > 6) return;
                                a = 0;
                                while(h()){
                                    l = null;
                                    if (a > 0) {
                                        if (h() == "." && a < 4) n++;
                                        else return;
                                    }
                                    if (!x.test(h())) return;
                                    while(x.test(h())){
                                        u = parseInt(h(), 10);
                                        if (l === null) l = u;
                                        else if (l == 0) return;
                                        else l = l * 10 + u;
                                        if (l > 255) return;
                                        n++;
                                    }
                                    t[r] = t[r] * 256 + l;
                                    a++;
                                    if (a == 2 || a == 4) r++;
                                }
                                if (a != 4) return;
                                break;
                            } else if (h() == ":") {
                                n++;
                                if (!h()) return;
                            } else if (h()) return;
                            t[r++] = s;
                        }
                        if (o !== null) {
                            c = r - o;
                            r = 7;
                            while(r != 0 && c > 0){
                                d = t[r];
                                t[r--] = t[o + c - 1];
                                t[o + --c] = d;
                            }
                        } else if (r != 8) return;
                        return t;
                    }(t.slice(1, -1))) ? void (e1.host = r) : j;
                    if (k(e1)) return t = z(t), ne.test(t) || null === (r = function(e1) {
                        var t = e1.split("."), r, o, n, s, i, a, l;
                        if (t.length && t[t.length - 1] == "") t.pop();
                        if ((r = t.length) > 4) return e1;
                        for(o = [], n = 0; n < r; n++){
                            s = t[n];
                            if (s == "") return e1;
                            i = 10;
                            if (s.length > 1 && s.charAt(0) == "0") {
                                i = ee.test(s) ? 16 : 8;
                                s = s.slice(i == 8 ? 1 : 2);
                            }
                            if (s === "") a = 0;
                            else {
                                if (!(i == 10 ? re : i == 8 ? te : oe).test(s)) return e1;
                                a = parseInt(s, i);
                            }
                            o.push(a);
                        }
                        for(n = 0; n < r; n++){
                            a = o[n];
                            if (n == r - 1) {
                                if (a >= Z(256, 5 - r)) return null;
                            } else if (a > 255) return null;
                        }
                        for(l = o.pop(), n = 0; n < o.length; n++)l += o[n] * Z(256, 3 - n);
                        return l;
                    }(t)) ? j : void (e1.host = r);
                    if (se.test(t)) return j;
                    for(r = "", o = b(t), n = 0; n < o.length; n++)r += E(o[n], S);
                    e1.host = r;
                }, le = function(e1) {
                    for(var t = null, r = 1, o = null, n = 0, s = 0; s < 8; s++)0 !== e1[s] ? (r < n && (t = o, r = n), o = null, n = 0) : (null === o && (o = s), ++n);
                    return r < n && (t = o, r = n), t;
                }, S = {}, ue = d({}, S, {
                    " ": 1,
                    '"': 1,
                    "<": 1,
                    ">": 1,
                    "`": 1
                }), ce = d({}, ue, {
                    "#": 1,
                    "?": 1,
                    "{": 1,
                    "}": 1
                }), T = d({}, ce, {
                    "/": 1,
                    ":": 1,
                    ";": 1,
                    "=": 1,
                    "@": 1,
                    "[": 1,
                    "\\": 1,
                    "]": 1,
                    "^": 1,
                    "|": 1
                }), E = function(e1, t) {
                    var r = V(e1, 0);
                    return 32 < r && r < 127 && !v(t, e1) ? e1 : encodeURIComponent(e1);
                }, M = {
                    ftp: 21,
                    file: null,
                    http: 80,
                    https: 443,
                    ws: 80,
                    wss: 443
                }, k = function(e1) {
                    return v(M, e1.scheme);
                }, O = function(e1) {
                    return "" != e1.username || "" != e1.password;
                }, C = function(e1, t) {
                    return 2 == e1.length && J.test(e1.charAt(0)) && (":" == (e1 = e1.charAt(1)) || !t && "|" == e1);
                }, de = function(e1) {
                    return 1 < e1.length && C(e1.slice(0, 2)) && (2 == e1.length || "/" === (e1 = e1.charAt(2)) || "\\" === e1 || "?" === e1 || "#" === e1);
                }, he = function(e1) {
                    var t = e1.path, r = t.length;
                    !r || "file" == e1.scheme && 1 == r && C(t[0], !0) || t.pop();
                }, fe = function(e1) {
                    return "." === e1 || "%2e" === e1.toLowerCase();
                }, pe = function(e1) {
                    return ".." === (e1 = e1.toLowerCase()) || "%2e." === e1 || ".%2e" === e1 || "%2e%2e" === e1;
                }, me = {}, ye = {}, ge = {}, ve = {}, be = {}, _e = {}, je = {}, xe = {}, P = {}, A = {}, we = {}, Se = {}, Te = {}, Ee = {}, Me = {}, ke = {}, L = {}, R = {}, Oe = {}, I = {}, D = {}, s = l.prototype, m = function() {
                    var e1 = p(this), t = e1.scheme, r = e1.username, o = e1.password, n = e1.host, s = e1.port, i = e1.path, a = e1.query, l = e1.fragment, u = t + ":";
                    return null !== n ? (u += "//", O(e1) && (u += r + (o ? ":" + o : "") + "@"), u += c(n), null !== s && (u += ":" + s)) : "file" == t && (u += "//"), u += e1.cannotBeABaseURL ? i[0] : i.length ? "/" + i.join("/") : "", null !== a && (u += "?" + a), null !== l && (u += "#" + l), u;
                }, Ce = function() {
                    var e1 = p(this), t = e1.scheme, r = e1.port;
                    if ("blob" == t) try {
                        return new URL(t.path[0]).origin;
                    } catch (e1) {
                        return "null";
                    }
                    return "file" != t && k(e1) ? t + "://" + c(e1.host) + (null !== r ? ":" + r : "") : "null";
                }, Pe = function() {
                    return p(this).scheme + ":";
                }, Ae = function() {
                    return p(this).username;
                }, Le = function() {
                    return p(this).password;
                }, Re = function() {
                    var e1 = p(this), t = e1.host, e1 = e1.port;
                    return null === t ? "" : null === e1 ? c(t) : c(t) + ":" + e1;
                }, Ie = function() {
                    var e1 = p(this).host;
                    return null === e1 ? "" : c(e1);
                }, De = function() {
                    var e1 = p(this).port;
                    return null === e1 ? "" : String(e1);
                }, Fe = function() {
                    var e1 = p(this), t = e1.path;
                    return e1.cannotBeABaseURL ? t[0] : t.length ? "/" + t.join("/") : "";
                }, Ue = function() {
                    var e1 = p(this).query;
                    return e1 ? "?" + e1 : "";
                }, Ne = function() {
                    return p(this).searchParams;
                }, Be = function() {
                    var e1 = p(this).fragment;
                    return e1 ? "#" + e1 : "";
                };
                u && B(s, {
                    href: t(m, function(e1) {
                        var t = p(this), e1 = String(e1), e1 = a(t, e1);
                        if (e1) throw TypeError(e1);
                        f(t.searchParams).updateSearchParams(t.query);
                    }),
                    origin: t(Ce),
                    protocol: t(Pe, function(e1) {
                        var t = p(this);
                        a(t, String(e1) + ":", me);
                    }),
                    username: t(Ae, function(e1) {
                        var t = p(this), r = b(String(e1));
                        if (!n(t)) {
                            t.username = "";
                            for(var o = 0; o < r.length; o++)t.username += E(r[o], T);
                        }
                    }),
                    password: t(Le, function(e1) {
                        var t = p(this), r = b(String(e1));
                        if (!n(t)) {
                            t.password = "";
                            for(var o = 0; o < r.length; o++)t.password += E(r[o], T);
                        }
                    }),
                    host: t(Re, function(e1) {
                        var t = p(this);
                        t.cannotBeABaseURL || a(t, String(e1), we);
                    }),
                    hostname: t(Ie, function(e1) {
                        var t = p(this);
                        t.cannotBeABaseURL || a(t, String(e1), Se);
                    }),
                    port: t(De, function(e1) {
                        var t = p(this);
                        n(t) || ("" == (e1 = String(e1)) ? t.port = null : a(t, e1, Te));
                    }),
                    pathname: t(Fe, function(e1) {
                        var t = p(this);
                        t.cannotBeABaseURL || (t.path = [], a(t, e1 + "", L));
                    }),
                    search: t(Ue, function(e1) {
                        var t = p(this);
                        "" == (e1 = String(e1)) ? t.query = null : ("?" == e1.charAt(0) && (e1 = e1.slice(1)), t.query = "", a(t, e1, I)), f(t.searchParams).updateSearchParams(t.query);
                    }),
                    searchParams: t(Ne),
                    hash: t(Be, function(e1) {
                        var t = p(this);
                        "" == (e1 = String(e1)) ? t.fragment = null : ("#" == e1.charAt(0) && (e1 = e1.slice(1)), t.fragment = "", a(t, e1, D));
                    })
                }), i(s, "toJSON", function() {
                    return m.call(this);
                }, {
                    enumerable: !0
                }), i(s, "toString", function() {
                    return m.call(this);
                }, {
                    enumerable: !0
                }), h && (r = h.createObjectURL, o = h.revokeObjectURL, r && i(l, "createObjectURL", function(e1) {
                    return r.apply(h, arguments);
                }), o && i(l, "revokeObjectURL", function(e1) {
                    return o.apply(h, arguments);
                })), H(l, "URL"), U({
                    global: !0,
                    forced: !N,
                    sham: !u
                }, {
                    URL: l
                });
            },
            {
                "../internals/an-instance": 9,
                "../internals/array-from": 17,
                "../internals/descriptors": 43,
                "../internals/export": 50,
                "../internals/global": 60,
                "../internals/has": 61,
                "../internals/internal-state": 71,
                "../internals/native-url": 85,
                "../internals/object-assign": 90,
                "../internals/object-define-properties": 92,
                "../internals/redefine": 110,
                "../internals/set-to-string-tag": 119,
                "../internals/string-multibyte": 125,
                "../internals/string-punycode-to-ascii": 128,
                "../modules/es.string.iterator": 200,
                "../modules/web.url-search-params": 247
            }
        ],
        249: [
            function(e1, t, r) {
                "use strict";
                t.exports = e1("./").polyfill();
            },
            {
                "./": 250
            }
        ],
        250: [
            function(V, r, o) {
                (function(B, G) {
                    var e1, t;
                    e1 = this, t = function() {
                        "use strict";
                        function l(e1) {
                            return "function" == typeof e1;
                        }
                        var r = Array.isArray || function(e1) {
                            return "[object Array]" === Object.prototype.toString.call(e1);
                        }, o = 0, t = void 0, n = void 0, i = function(e1, t) {
                            d[o] = e1, d[o + 1] = t, 2 === (o += 2) && (n ? n(h) : D());
                        };
                        var e1 = "undefined" != typeof window ? window : void 0, s = e1 || {}, s = s.MutationObserver || s.WebKitMutationObserver, a = "undefined" == typeof self && void 0 !== B && "[object process]" === ({}).toString.call(B), u = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel;
                        function c() {
                            var e1 = setTimeout;
                            return function() {
                                return e1(h, 1);
                            };
                        }
                        var d = new Array(1e3);
                        function h() {
                            for(var e1 = 0; e1 < o; e1 += 2)(0, d[e1])(d[e1 + 1]), d[e1] = void 0, d[e1 + 1] = void 0;
                            o = 0;
                        }
                        function f() {
                            try {
                                var e1 = Function("return this")().require("vertx");
                                return void 0 !== (t = e1.runOnLoop || e1.runOnContext) ? function() {
                                    t(h);
                                } : c();
                            } catch (e1) {
                                return c();
                            }
                        }
                        var p, m, y, D = void 0;
                        function g(e1, t) {
                            var r, o = this, n = new this.constructor(_), s = (void 0 === n[b] && A(n), o._state);
                            return s ? (r = arguments[s - 1], i(function() {
                                return C(s, n, r, o._result);
                            })) : k(o, n, e1, t), n;
                        }
                        function v(e1) {
                            var t;
                            return e1 && "object" == typeof e1 && e1.constructor === this ? e1 : (T(t = new this(_), e1), t);
                        }
                        var D = a ? function() {
                            return B.nextTick(h);
                        } : s ? (m = 0, a = new s(h), y = document.createTextNode(""), a.observe(y, {
                            characterData: !0
                        }), function() {
                            y.data = m = ++m % 2;
                        }) : u ? ((p = new MessageChannel).port1.onmessage = h, function() {
                            return p.port2.postMessage(0);
                        }) : (void 0 === e1 && "function" == typeof V ? f : c)(), b = Math.random().toString(36).substring(2);
                        function _() {}
                        var j = void 0, x = 1, w = 2;
                        function F(e1, o, n) {
                            i(function(t) {
                                var r = !1, e1 = function(e1, t, r, o) {
                                    try {
                                        e1.call(t, r, o);
                                    } catch (e1) {
                                        return e1;
                                    }
                                }(n, o, function(e1) {
                                    r || (r = !0, (o !== e1 ? T : E)(t, e1));
                                }, function(e1) {
                                    r || (r = !0, M(t, e1));
                                }, t._label);
                                !r && e1 && (r = !0, M(t, e1));
                            }, e1);
                        }
                        function S(e1, t, r) {
                            var o, n;
                            t.constructor === e1.constructor && r === g && t.constructor.resolve === v ? (o = e1, (n = t)._state === x ? E(o, n._result) : n._state === w ? M(o, n._result) : k(n, void 0, function(e1) {
                                return T(o, e1);
                            }, function(e1) {
                                return M(o, e1);
                            })) : void 0 !== r && l(r) ? F(e1, t, r) : E(e1, t);
                        }
                        function T(t, e1) {
                            if (t === e1) M(t, new TypeError("You cannot resolve a promise with itself"));
                            else if (r = typeof e1, null === e1 || "object" != r && "function" != r) E(t, e1);
                            else {
                                r = void 0;
                                try {
                                    r = e1.then;
                                } catch (e1) {
                                    return void M(t, e1);
                                }
                                S(t, e1, r);
                            }
                            var r;
                        }
                        function U(e1) {
                            e1._onerror && e1._onerror(e1._result), O(e1);
                        }
                        function E(e1, t) {
                            e1._state === j && (e1._result = t, e1._state = x, 0 !== e1._subscribers.length && i(O, e1));
                        }
                        function M(e1, t) {
                            e1._state === j && (e1._state = w, e1._result = t, i(U, e1));
                        }
                        function k(e1, t, r, o) {
                            var n = e1._subscribers, s = n.length;
                            e1._onerror = null, n[s] = t, n[s + x] = r, n[s + w] = o, 0 === s && e1._state && i(O, e1);
                        }
                        function O(e1) {
                            var t = e1._subscribers, r = e1._state;
                            if (0 !== t.length) {
                                for(var o, n = void 0, s = e1._result, i = 0; i < t.length; i += 3)o = t[i], n = t[i + r], o ? C(r, o, n, s) : n(s);
                                e1._subscribers.length = 0;
                            }
                        }
                        function C(e1, t, r, o) {
                            var n = l(r), s = void 0, i = void 0, a = !0;
                            if (n) {
                                try {
                                    s = r(o);
                                } catch (e1) {
                                    a = !1, i = e1;
                                }
                                if (t === s) return void M(t, new TypeError("A promises callback cannot return that same promise."));
                            } else s = o;
                            t._state === j && (n && a ? T(t, s) : !1 === a ? M(t, i) : e1 === x ? E(t, s) : e1 === w && M(t, s));
                        }
                        var P = 0;
                        function A(e1) {
                            e1[b] = P++, e1._state = void 0, e1._result = void 0, e1._subscribers = [];
                        }
                        L.prototype._enumerate = function(e1) {
                            for(var t = 0; this._state === j && t < e1.length; t++)this._eachEntry(e1[t], t);
                        }, L.prototype._eachEntry = function(t, e1) {
                            var r = this._instanceConstructor, o = r.resolve;
                            if (o === v) {
                                var n, s = void 0, i = void 0, a = !1;
                                try {
                                    s = t.then;
                                } catch (e1) {
                                    a = !0, i = e1;
                                }
                                s === g && t._state !== j ? this._settledAt(t._state, e1, t._result) : "function" != typeof s ? (this._remaining--, this._result[e1] = t) : r === R ? (n = new r(_), a ? M(n, i) : S(n, t, s), this._willSettleAt(n, e1)) : this._willSettleAt(new r(function(e1) {
                                    return e1(t);
                                }), e1);
                            } else this._willSettleAt(o(t), e1);
                        }, L.prototype._settledAt = function(e1, t, r) {
                            var o = this.promise;
                            o._state === j && (this._remaining--, e1 === w ? M(o, r) : this._result[t] = r), 0 === this._remaining && E(o, this._result);
                        }, L.prototype._willSettleAt = function(e1, t) {
                            var r = this;
                            k(e1, void 0, function(e1) {
                                return r._settledAt(x, t, e1);
                            }, function(e1) {
                                return r._settledAt(w, t, e1);
                            });
                        };
                        var N = L;
                        function L(e1, t) {
                            this._instanceConstructor = e1, this.promise = new e1(_), this.promise[b] || A(this.promise), r(t) ? (this.length = t.length, this._remaining = t.length, this._result = new Array(this.length), 0 !== this.length && (this.length = this.length || 0, this._enumerate(t), 0 !== this._remaining) || E(this.promise, this._result)) : M(this.promise, new Error("Array Methods must be provided an Array"));
                        }
                        I.prototype.catch = function(e1) {
                            return this.then(null, e1);
                        }, I.prototype.finally = function(t) {
                            var r = this.constructor;
                            return l(t) ? this.then(function(e1) {
                                return r.resolve(t()).then(function() {
                                    return e1;
                                });
                            }, function(e1) {
                                return r.resolve(t()).then(function() {
                                    throw e1;
                                });
                            }) : this.then(t, t);
                        };
                        var R = I;
                        function I(e1) {
                            if (this[b] = P++, this._result = this._state = void 0, this._subscribers = [], _ !== e1) {
                                if ("function" != typeof e1) throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
                                if (!(this instanceof I)) throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
                                var t = this;
                                try {
                                    e1(function(e1) {
                                        T(t, e1);
                                    }, function(e1) {
                                        M(t, e1);
                                    });
                                } catch (e1) {
                                    M(t, e1);
                                }
                            }
                        }
                        return R.prototype.then = g, R.all = function(e1) {
                            return new N(this, e1).promise;
                        }, R.race = function(n) {
                            var s = this;
                            return r(n) ? new s(function(e1, t) {
                                for(var r = n.length, o = 0; o < r; o++)s.resolve(n[o]).then(e1, t);
                            }) : new s(function(e1, t) {
                                return t(new TypeError("You must pass an array to race."));
                            });
                        }, R.resolve = v, R.reject = function(e1) {
                            var t = new this(_);
                            return M(t, e1), t;
                        }, R._setScheduler = function(e1) {
                            n = e1;
                        }, R._setAsap = function(e1) {
                            i = e1;
                        }, R._asap = i, R.polyfill = function() {
                            var e1 = void 0;
                            if (void 0 !== G) e1 = G;
                            else if ("undefined" != typeof self) e1 = self;
                            else try {
                                e1 = Function("return this")();
                            } catch (e1) {
                                throw new Error("polyfill failed because global object is unavailable in this environment");
                            }
                            var t = e1.Promise;
                            if (t) {
                                var r = null;
                                try {
                                    r = Object.prototype.toString.call(t.resolve());
                                } catch (e1) {}
                                if ("[object Promise]" === r && !t.cast) return;
                            }
                            e1.Promise = R;
                        }, R.Promise = R;
                    }, "object" == typeof o && void 0 !== r ? r.exports = t() : "function" == typeof s && s.amd ? s(t) : e1.ES6Promise = t();
                }).call(this, V("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                _process: 259
            }
        ],
        251: [
            function(e1, t, r) {
                var o, n;
                o = this, n = function(e1, t) {
                    "use strict";
                    var r = 5e3, o = "callback";
                    function d(t) {
                        try {
                            delete window[t];
                        } catch (e1) {
                            window[t] = void 0;
                        }
                    }
                    function h(e1) {
                        e1 = document.getElementById(e1);
                        e1 && document.getElementsByTagName("head")[0].removeChild(e1);
                    }
                    t.exports = function(s) {
                        var i = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1], a = s, l = i.timeout || r, u = i.jsonpCallback || o, c = void 0;
                        return new Promise(function(t, e1) {
                            var r = i.jsonpCallbackFunction || "jsonp_" + Date.now() + "_" + Math.ceil(1e5 * Math.random()), o = u + "_" + r, n = (window[r] = function(e1) {
                                t({
                                    ok: !0,
                                    json: function() {
                                        return Promise.resolve(e1);
                                    }
                                }), c && clearTimeout(c), h(o), d(r);
                            }, a += -1 === a.indexOf("?") ? "?" : "&", document.createElement("script"));
                            n.setAttribute("src", "" + a + u + "=" + r), i.charset && n.setAttribute("charset", i.charset), n.id = o, document.getElementsByTagName("head")[0].appendChild(n), c = setTimeout(function() {
                                e1(new Error("JSONP request to " + s + " timed out")), d(r), h(o), window[r] = function() {
                                    d(r);
                                };
                            }, l), n.onerror = function() {
                                e1(new Error("JSONP request to " + s + " failed")), d(r), h(o), c && clearTimeout(c);
                            };
                        });
                    };
                }, "function" == typeof s && s.amd ? s([
                    "exports",
                    "module"
                ], n) : void 0 !== r && void 0 !== t ? n(0, t) : (n(n = {
                    exports: {}
                }, n), o.fetchJsonp = n.exports);
            },
            {}
        ],
        252: [
            function(e1, t, r) {
                var o = function(a) {
                    "use strict";
                    var l, u, c, d, h, f, t, p, m, o, e1;
                    if (!(void 0 === a || "undefined" != typeof navigator && /MSIE [1-9]\./.test(navigator.userAgent))) return e1 = a.document, l = function() {
                        return a.URL || a.webkitURL || a;
                    }, u = e1.createElementNS("http://www.w3.org/1999/xhtml", "a"), c = "download" in u, d = /constructor/i.test(a.HTMLElement) || a.safari, h = /CriOS\/[\d]+/.test(navigator.userAgent), f = function(e1) {
                        (a.setImmediate || a.setTimeout)(function() {
                            throw e1;
                        }, 0);
                    }, t = 4e4, p = function(e1) {
                        setTimeout(function() {
                            "string" == typeof e1 ? l().revokeObjectURL(e1) : e1.remove();
                        }, t);
                    }, m = function(e1) {
                        return /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e1.type) ? new Blob([
                            String.fromCharCode(65279),
                            e1
                        ], {
                            type: e1.type
                        }) : e1;
                    }, e1 = (o = function(e1, r, t) {
                        t || (e1 = m(e1));
                        var o, n, s = this, t = "application/octet-stream" === e1.type, i = function() {
                            for(var e1 = s, t = "writestart progress write writeend".split(" "), r = void 0, o = (t = [].concat(t)).length; o--;){
                                var n = e1["on" + t[o]];
                                if ("function" == typeof n) try {
                                    n.call(e1, r || e1);
                                } catch (e1) {
                                    f(e1);
                                }
                            }
                        };
                        s.readyState = s.INIT, c ? (o = l().createObjectURL(e1), setTimeout(function() {
                            var e1, t;
                            u.href = o, u.download = r, e1 = u, t = new MouseEvent("click"), e1.dispatchEvent(t), i(), p(o), s.readyState = s.DONE;
                        })) : (h || t && d) && a.FileReader ? ((n = new FileReader).onloadend = function() {
                            var e1 = h ? n.result : n.result.replace(/^data:[^;]*;/, "data:attachment/file;");
                            a.open(e1, "_blank") || (a.location.href = e1), e1 = void 0, s.readyState = s.DONE, i();
                        }, n.readAsDataURL(e1), s.readyState = s.INIT) : (o = o || l().createObjectURL(e1), !t && a.open(o, "_blank") || (a.location.href = o), s.readyState = s.DONE, i(), p(o));
                    }).prototype, "undefined" != typeof navigator && navigator.msSaveOrOpenBlob ? function(e1, t, r) {
                        return t = t || e1.name || "download", r || (e1 = m(e1)), navigator.msSaveOrOpenBlob(e1, t);
                    } : (e1.abort = function() {}, e1.readyState = e1.INIT = 0, e1.WRITING = 1, e1.DONE = 2, e1.error = e1.onwritestart = e1.onprogress = e1.onwrite = e1.onabort = e1.onerror = e1.onwriteend = null, function(e1, t, r) {
                        return new o(e1, t || e1.name || "download", r);
                    });
                }("undefined" != typeof self && self || "undefined" != typeof window && window || this.content);
                void 0 !== t && t.exports ? t.exports.saveAs = o : null != s && null !== s.amd && s("FileSaver.js", function() {
                    return o;
                });
            },
            {}
        ],
        253: [
            function(e1, t, r) {
                var o, n = Object.defineProperty, s = (n(r, "__esModule", {
                    value: !0
                }), r), i = {
                    GIFEncoder: ()=>h,
                    applyPalette: ()=>function(e1, t, r = "rgb565") {
                            if (!e1 || !e1.buffer) throw new Error("quantize() expected RGBA Uint8Array data");
                            if (!(e1 instanceof Uint8Array || e1 instanceof Uint8ClampedArray)) throw new Error("quantize() expected RGBA Uint8Array data");
                            if (256 < t.length) throw new Error("applyPalette() only works with 256 colors or less");
                            const o = new Uint32Array(e1.buffer), n = o.length, s = "rgb444" === r ? 4096 : 65536, i = new Uint8Array(n), a = new Array(s);
                            if ("rgba4444" === r) for(let e1 = 0; e1 < n; e1++){
                                var l = o[e1], u = l >> 24 & 255, c = l >> 16 & 255, d = l >> 8 & 255, l = 255 & l, h = P(l, d, c, u), h = h in a ? a[h] : a[h] = function(t, r, o, n, s) {
                                    let i = 0, a = 1e100;
                                    for(let e1 = 0; e1 < s.length; e1++){
                                        var l, u = s[e1], c = v(u[3] - n);
                                        c > a || (l = u[0], (c += v(l - t)) > a || (l = u[1], (c += v(l - r)) > a || (l = u[2], (c += v(l - o)) > a || (a = c, i = e1))));
                                    }
                                    return i;
                                }(l, d, c, u, t);
                                i[e1] = h;
                            }
                            else {
                                const g = "rgb444" === r ? A : C;
                                for(let e1 = 0; e1 < n; e1++){
                                    var f = o[e1], p = f >> 16 & 255, m = f >> 8 & 255, f = 255 & f, y = g(f, m, p), y = y in a ? a[y] : a[y] = function(t, r, o, n) {
                                        let s = 0, i = 1e100;
                                        for(let e1 = 0; e1 < n.length; e1++){
                                            var a, l = n[e1], u = v(l[0] - t);
                                            u > i || (a = l[1], (u += v(a - r)) > i || (a = l[2], (u += v(a - o)) > i || (i = u, s = e1)));
                                        }
                                        return s;
                                    }(f, m, p, t);
                                    i[e1] = y;
                                }
                            }
                            return i;
                        },
                    default: ()=>f,
                    nearestColor: ()=>function(e1, t, r = u) {
                            return e1[l(e1, t, r)];
                        },
                    nearestColorIndex: ()=>l,
                    nearestColorIndexWithDistance: ()=>d,
                    prequantize: ()=>function(e1, { roundRGB: r = 5, roundAlpha: o = 10, oneBitAlpha: n = null } = {}) {
                            const s = new Uint32Array(e1.buffer);
                            for(let t = 0; t < s.length; t++){
                                var i = s[t];
                                let e1 = i >> 24 & 255;
                                var a, l = i >> 16 & 255, u = i >> 8 & 255, i = 255 & i;
                                e1 = c(e1, o), n && (a = "number" == typeof n ? n : 127, e1 = e1 <= a ? 0 : 255), i = c(i, r), u = c(u, r), l = c(l, r), s[t] = e1 << 24 | l << 16 | u << 8 | i << 0;
                            }
                        },
                    quantize: ()=>function(e1, t, r = {}) {
                            var { format: o = "rgb565", clearAlpha: n = !0, clearAlphaColor: s = 0, clearAlphaThreshold: i = 0, oneBitAlpha: a = !1 } = r;
                            if (!e1 || !e1.buffer) throw new Error("quantize() expected RGBA Uint8Array data");
                            if (!(e1 instanceof Uint8Array || e1 instanceof Uint8ClampedArray)) throw new Error("quantize() expected RGBA Uint8Array data");
                            e1 = new Uint32Array(e1.buffer);
                            let l = !1 !== r.useSqrt;
                            const u = "rgba4444" === o, c = function(r, e1) {
                                const t = "rgb444" === e1 ? 4096 : 65536, o = new Array(t), n = r.length;
                                if ("rgba4444" === e1) for(let t = 0; t < n; ++t){
                                    var s = r[t], i = s >> 24 & 255, a = s >> 16 & 255, l = s >> 8 & 255, s = 255 & s, u = P(s, l, a, i);
                                    let e1 = u in o ? o[u] : o[u] = D();
                                    e1.rc += s, e1.gc += l, e1.bc += a, e1.ac += i, e1.cnt++;
                                }
                                else if ("rgb444" === e1) for(let t = 0; t < n; ++t){
                                    var c = r[t], d = c >> 16 & 255, h = c >> 8 & 255, c = 255 & c, f = A(c, h, d);
                                    let e1 = f in o ? o[f] : o[f] = D();
                                    e1.rc += c, e1.gc += h, e1.bc += d, e1.cnt++;
                                }
                                else for(let t = 0; t < n; ++t){
                                    var p = r[t], m = p >> 16 & 255, y = p >> 8 & 255, p = 255 & p, g = C(p, y, m);
                                    let e1 = g in o ? o[g] : o[g] = D();
                                    e1.rc += p, e1.gc += y, e1.bc += m, e1.cnt++;
                                }
                                return o;
                            }(e1, o), d = c.length, h = d - 1, f = new Uint32Array(d + 1);
                            for(var p = 0, m = 0; m < d; ++m){
                                const O = c[m];
                                null != O && (E = 1 / O.cnt, u && (O.ac *= E), O.rc *= E, O.gc *= E, O.bc *= E, c[p++] = O);
                            }
                            R(t) / p < .022 && (l = !1);
                            for(var y, g, v, m = 0; m < p - 1; ++m)c[m].fw = m + 1, c[m + 1].bk = m, l && (c[m].cnt = Math.sqrt(c[m].cnt));
                            l && (c[m].cnt = Math.sqrt(c[m].cnt));
                            for(m = 0; m < p; ++m){
                                I(c, m, !1);
                                var b = c[m].err;
                                for(g = ++f[0]; 1 < g && (v = g >> 1, !(c[y = f[v]].err <= b)); g = v)f[g] = y;
                                f[g] = m;
                            }
                            var _, j = p - t;
                            for(m = 0; m < j;){
                                for(;;){
                                    var x = f[1];
                                    if ((_ = c[x]).tm >= _.mtm && c[_.nn].mtm <= _.tm) break;
                                    _.mtm == h ? x = f[1] = f[f[0]--] : (I(c, x, !1), _.tm = m);
                                    b = c[x].err;
                                    for(g = 1; (v = g + g) <= f[0] && (v < f[0] && c[f[v]].err > c[f[v + 1]].err && v++, !(b <= c[y = f[v]].err)); g = v)f[g] = y;
                                    f[g] = x;
                                }
                                var w = c[_.nn], S = _.cnt, T = w.cnt, E = 1 / (S + T);
                                u && (_.ac = E * (S * _.ac + T * w.ac)), _.rc = E * (S * _.rc + T * w.rc), _.gc = E * (S * _.gc + T * w.gc), _.bc = E * (S * _.bc + T * w.bc), _.cnt += w.cnt, _.mtm = ++m, c[w.bk].fw = w.fw, c[w.fw].bk = w.bk, w.mtm = h;
                            }
                            let M = [];
                            for(m = 0;;){
                                let e1 = L(Math.round(c[m].rc), 0, 255), t = L(Math.round(c[m].gc), 0, 255), r = L(Math.round(c[m].bc), 0, 255), o = 255;
                                u && (o = L(Math.round(c[m].ac), 0, 255), a && (k = "number" == typeof a ? a : 127, o = o <= k ? 0 : 255), n && o <= i && (e1 = t = r = s, o = 0));
                                var k = u ? [
                                    e1,
                                    t,
                                    r,
                                    o
                                ] : [
                                    e1,
                                    t,
                                    r
                                ];
                                if (function(t, r) {
                                    for(let e1 = 0; e1 < t.length; e1++){
                                        var o = t[e1], n = o[0] === r[0] && o[1] === r[1] && o[2] === r[2], o = !(4 <= o.length && 4 <= r.length) || o[3] === r[3];
                                        if (n && o) return !0;
                                    }
                                    return !1;
                                }(M, k) || M.push(k), 0 == (m = c[m].fw)) break;
                            }
                            return M;
                        },
                    snapColorsToPalette: ()=>function(r, o, e1 = 5) {
                            if (r.length && o.length) {
                                var n = r.map((e1)=>e1.slice(0, 3)), s = e1 * e1, i = r[0].length;
                                for(let t = 0; t < o.length; t++){
                                    let e1 = o[t];
                                    e1 = e1.length < i ? [
                                        e1[0],
                                        e1[1],
                                        e1[2],
                                        255
                                    ] : e1.length > i ? e1.slice(0, 3) : e1.slice();
                                    var a = d(n, e1.slice(0, 3), u), l = a[0], a = a[1];
                                    0 < a && a <= s && (r[l] = e1);
                                }
                            }
                        }
                };
                for(o in i)n(s, o, {
                    get: i[o],
                    enumerable: !0
                });
                var a = {
                    signature: "GIF",
                    version: "89a",
                    trailer: 59,
                    extensionIntroducer: 33,
                    applicationExtensionLabel: 255,
                    graphicControlExtensionLabel: 249,
                    imageSeparator: 44,
                    signatureSize: 3,
                    versionSize: 3,
                    globalColorTableFlagMask: 128,
                    colorResolutionMask: 112,
                    sortFlagMask: 8,
                    globalColorTableSizeMask: 7,
                    applicationIdentifierSize: 8,
                    applicationAuthCodeSize: 3,
                    disposalMethodMask: 28,
                    userInputFlagMask: 2,
                    transparentColorFlagMask: 1,
                    localColorTableFlagMask: 128,
                    interlaceFlagMask: 64,
                    idSortFlagMask: 32,
                    localColorTableSizeMask: 7
                };
                function M(e1 = 256) {
                    let n = 0, s = new Uint8Array(e1);
                    return {
                        get buffer () {
                            return s.buffer;
                        },
                        reset () {
                            n = 0;
                        },
                        bytesView () {
                            return s.subarray(0, n);
                        },
                        bytes () {
                            return s.slice(0, n);
                        },
                        writeByte (e1) {
                            i(n + 1), s[n] = e1, n++;
                        },
                        writeBytes (t, r = 0, o = t.length) {
                            i(n + o);
                            for(let e1 = 0; e1 < o; e1++)s[n++] = t[e1 + r];
                        },
                        writeBytesView (e1, t = 0, r = e1.byteLength) {
                            i(n + r), s.set(e1.subarray(t, t + r), n), n += r;
                        }
                    };
                    function i(e1) {
                        var t = s.length;
                        if (!(e1 <= t)) {
                            e1 = Math.max(e1, t * (t < 1048576 ? 2 : 1.125) >>> 0), 0 != t && (e1 = Math.max(e1, 256));
                            const r = s;
                            s = new Uint8Array(e1), 0 < n && s.set(r.subarray(0, n), 0);
                        }
                    }
                }
                var k = [
                    0,
                    1,
                    3,
                    7,
                    15,
                    31,
                    63,
                    127,
                    255,
                    511,
                    1023,
                    2047,
                    4095,
                    8191,
                    16383,
                    32767,
                    65535
                ];
                var S = function(e1, t, r, o, n = M(512), s = new Uint8Array(256), i = new Int32Array(5003), a = new Int32Array(5003)) {
                    var l = i.length, o = Math.max(2, o);
                    s.fill(0), a.fill(0), i.fill(-1);
                    let u = 0, c = 0;
                    var d = o + 1;
                    const h = d;
                    let f = !1, p = h, m = (1 << p) - 1;
                    var y = 1 << d - 1;
                    const g = 1 + y;
                    let v = 2 + y, b = 0, _ = r[0], j = 0;
                    for(let e1 = l; e1 < 65536; e1 *= 2)++j;
                    j = 8 - j, n.writeByte(o), E(y);
                    var x = r.length;
                    for(let t = 1; t < x; t++)e: {
                        var w = r[t], S = (w << 12) + _;
                        let e1 = w << j ^ _;
                        if (i[e1] === S) _ = a[e1];
                        else {
                            for(var T = 0 === e1 ? 1 : l - e1; 0 <= i[e1];)if ((e1 -= T) < 0 && (e1 += l), i[e1] === S) {
                                _ = a[e1];
                                break e;
                            }
                            E(_), _ = w, v < 4096 ? (a[e1] = v++, i[e1] = S) : (i.fill(-1), v = 2 + y, f = !0, E(y));
                        }
                    }
                    return E(_), E(g), n.writeByte(0), n.bytesView();
                    function E(e1) {
                        for(u &= k[c], 0 < c ? u |= e1 << c : u = e1, c += p; 8 <= c;)s[b++] = 255 & u, 254 <= b && (n.writeByte(b), n.writeBytesView(s, 0, b), b = 0), u >>= 8, c -= 8;
                        if ((v > m || f) && (f ? (p = h, m = (1 << p) - 1, f = !1) : (++p, m = 12 === p ? 1 << p : (1 << p) - 1)), e1 == g) {
                            for(; 0 < c;)s[b++] = 255 & u, 254 <= b && (n.writeByte(b), n.writeBytesView(s, 0, b), b = 0), u >>= 8, c -= 8;
                            0 < b && (n.writeByte(b), n.writeBytesView(s, 0, b), b = 0);
                        }
                    }
                };
                function C(e1, t, r) {
                    return e1 << 8 & 63488 | t << 2 & 992 | r >> 3;
                }
                function P(e1, t, r, o) {
                    return e1 >> 4 | 240 & t | (240 & r) << 4 | (240 & o) << 8;
                }
                function A(e1, t, r) {
                    return e1 >> 4 << 8 | 240 & t | r >> 4;
                }
                function L(e1, t, r) {
                    return e1 < t ? t : r < e1 ? r : e1;
                }
                function R(e1) {
                    return e1 * e1;
                }
                function I(e1, t, r) {
                    var o = 0, n = 1e100;
                    const s = e1[t];
                    for(var i = s.cnt, a = s.ac, l = s.rc, u = s.gc, c = s.bc, d = s.fw; 0 != d; d = e1[d].fw){
                        var h, f = e1[d], p = f.cnt, p = i * p / (i + p);
                        n <= p || (h = 0, r && n <= (h += p * R(f.ac - a)) || n <= (h += p * R(f.rc - l)) || n <= (h += p * R(f.gc - u)) || n <= (h += p * R(f.bc - c)) || (n = h, o = d));
                    }
                    s.err = n, s.nn = o;
                }
                function D() {
                    return {
                        ac: 0,
                        rc: 0,
                        gc: 0,
                        bc: 0,
                        cnt: 0,
                        nn: 0,
                        fw: 0,
                        bk: 0,
                        tm: 0,
                        mtm: 0,
                        err: 0
                    };
                }
                function u(e1, t) {
                    for(var r = 0, o = 0; o < e1.length; o++){
                        var n = e1[o] - t[o];
                        r += n * n;
                    }
                    return r;
                }
                function c(e1, t) {
                    return 1 < t ? Math.round(e1 / t) * t : e1;
                }
                function v(e1) {
                    return e1 * e1;
                }
                function l(t, r, o = u) {
                    let n = 1 / 0, s = -1;
                    for(let e1 = 0; e1 < t.length; e1++){
                        var i = o(r, t[e1]);
                        i < n && (n = i, s = e1);
                    }
                    return s;
                }
                function d(t, r, o = u) {
                    let n = 1 / 0, s = -1;
                    for(let e1 = 0; e1 < t.length; e1++){
                        var i = o(r, t[e1]);
                        i < n && (n = i, s = e1);
                    }
                    return [
                        s,
                        n
                    ];
                }
                function h(e1 = {}) {
                    const { initialCapacity: t = 4096, auto: g = !0 } = e1, v = M(t);
                    const b = new Uint8Array(256), _ = new Int32Array(5003), j = new Int32Array(5003);
                    let x = !1;
                    return {
                        reset () {
                            v.reset(), x = !1;
                        },
                        finish () {
                            v.writeByte(a.trailer);
                        },
                        bytes () {
                            return v.bytes();
                        },
                        bytesView () {
                            return v.bytesView();
                        },
                        get buffer () {
                            return v.buffer;
                        },
                        get stream () {
                            return v;
                        },
                        writeHeader: w,
                        writeFrame (e1, t, r, o = {}) {
                            var { transparent: n = !1, transparentIndex: s = 0, delay: i = 0, palette: a = null, repeat: l = 0, colorDepth: u = 8, dispose: c = -1 } = o;
                            let d = !1;
                            if (g ? x || (d = !0, w(), x = !0) : d = Boolean(o.first), t = Math.max(0, Math.floor(t)), r = Math.max(0, Math.floor(r)), d) {
                                if (!a) throw new Error("First frame must include a { palette } option");
                                var [o, h, f, p, m = 8] = [
                                    v,
                                    t,
                                    r,
                                    a,
                                    u
                                ];
                                p = F(p.length) - 1, m = 128 | m - 1 << 4 | p, E(o, h), E(o, f), o.writeBytes([
                                    m,
                                    0,
                                    0
                                ]), T(v, a), 0 <= l && (p = v, h = l, p.writeByte(33), p.writeByte(255), p.writeByte(11), O(p, "NETSCAPE2.0"), p.writeByte(3), p.writeByte(1), E(p, h), p.writeByte(0));
                            }
                            var y, f = Math.round(i / 10), o = v, m = c, l = f, h = n, p = s, i = (o.writeByte(33), o.writeByte(249), o.writeByte(4), p < 0 && (p = 0, h = !1), h = h ? (y = 1, 2) : y = 0, 0 <= m && (h = 7 & m), h <<= 2, o.writeByte(0 | h | y), E(o, l), o.writeByte(p || 0), o.writeByte(0), Boolean(a) && !d);
                            c = v, n = t, s = r, y = i ? a : null, c.writeByte(44), E(c, 0), E(c, 0), E(c, n), E(c, s), y ? (n = F(y.length) - 1, c.writeByte(128 | n)) : c.writeByte(0), i && T(v, a), [l, o, s, n, c = 8, i, a, e1] = [
                                v,
                                e1,
                                t,
                                r,
                                u,
                                b,
                                _,
                                j
                            ], S(s, n, o, c, l, i, a, e1);
                        }
                    };
                    function w() {
                        O(v, "GIF89a");
                    }
                }
                function T(r, o) {
                    var e1 = 1 << F(o.length);
                    for(let t = 0; t < e1; t++){
                        let e1 = [
                            0,
                            0,
                            0
                        ];
                        t < o.length && (e1 = o[t]), r.writeByte(e1[0]), r.writeByte(e1[1]), r.writeByte(e1[2]);
                    }
                }
                function E(e1, t) {
                    e1.writeByte(255 & t), e1.writeByte(t >> 8 & 255);
                }
                function O(e1, t) {
                    for(var r = 0; r < t.length; r++)e1.writeByte(t.charCodeAt(r));
                }
                function F(e1) {
                    return Math.max(Math.ceil(Math.log2(e1)), 1);
                }
                var f = h;
            },
            {}
        ],
        254: [
            function(e1, t, r) {
                r.read = function(e1, t, r, o, n) {
                    var s, i, a = 8 * n - o - 1, l = (1 << a) - 1, u = l >> 1, c = -7, d = r ? n - 1 : 0, h = r ? -1 : 1, n = e1[t + d];
                    for(d += h, s = n & (1 << -c) - 1, n >>= -c, c += a; 0 < c; s = 256 * s + e1[t + d], d += h, c -= 8);
                    for(i = s & (1 << -c) - 1, s >>= -c, c += o; 0 < c; i = 256 * i + e1[t + d], d += h, c -= 8);
                    if (0 === s) s = 1 - u;
                    else {
                        if (s === l) return i ? NaN : 1 / 0 * (n ? -1 : 1);
                        i += Math.pow(2, o), s -= u;
                    }
                    return (n ? -1 : 1) * i * Math.pow(2, s - o);
                }, r.write = function(e1, t, r, o, n, s) {
                    var i, a, l = 8 * s - n - 1, u = (1 << l) - 1, c = u >> 1, d = 23 === n ? Math.pow(2, -24) - Math.pow(2, -77) : 0, h = o ? 0 : s - 1, f = o ? 1 : -1, s = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
                    for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, i = u) : (i = Math.floor(Math.log(t) / Math.LN2), t * (o = Math.pow(2, -i)) < 1 && (i--, o *= 2), 2 <= (t += 1 <= i + c ? d / o : d * Math.pow(2, 1 - c)) * o && (i++, o /= 2), u <= i + c ? (a = 0, i = u) : 1 <= i + c ? (a = (t * o - 1) * Math.pow(2, n), i += c) : (a = t * Math.pow(2, c - 1) * Math.pow(2, n), i = 0)); 8 <= n; e1[r + h] = 255 & a, h += f, a /= 256, n -= 8);
                    for(i = i << n | a, l += n; 0 < l; e1[r + h] = 255 & i, h += f, i /= 256, l -= 8);
                    e1[r + h - f] |= 128 * s;
                };
            },
            {}
        ],
        255: [
            function(o, e1, c) {
                "use strict";
                var t;
                function y(e1, t) {
                    return e1.b === t.b && e1.a === t.a;
                }
                function g(e1, t) {
                    return e1.b < t.b || e1.b === t.b && e1.a <= t.a;
                }
                function v(e1, t, r) {
                    var o = t.b - e1.b, n = r.b - t.b;
                    return 0 < o + n ? o < n ? t.a - e1.a + o / (o + n) * (e1.a - r.a) : t.a - r.a + n / (o + n) * (r.a - e1.a) : 0;
                }
                function b(e1, t, r) {
                    var o = t.b - e1.b, n = r.b - t.b;
                    return 0 < o + n ? (t.a - r.a) * o + (t.a - e1.a) * n : 0;
                }
                function _(e1, t) {
                    return e1.a < t.a || e1.a === t.a && e1.b <= t.b;
                }
                function V(e1, t, r) {
                    var o = t.a - e1.a, n = r.a - t.a;
                    return 0 < o + n ? o < n ? t.b - e1.b + o / (o + n) * (e1.b - r.b) : t.b - r.b + n / (o + n) * (r.b - e1.b) : 0;
                }
                function z(e1, t, r) {
                    var o = t.a - e1.a, n = r.a - t.a;
                    return 0 < o + n ? (t.b - r.b) * o + (t.b - e1.b) * n : 0;
                }
                function j(e1, t, r, o) {
                    return (e1 = e1 < 0 ? 0 : e1) <= (r = r < 0 ? 0 : r) ? 0 === r ? (t + o) / 2 : t + e1 / (e1 + r) * (o - t) : o + r / (e1 + r) * (t - o);
                }
                function d(e1) {
                    var t = s(e1.b);
                    return n(t, e1.c), n(t.b, e1.c), i(t, e1.a), t;
                }
                function x(e1, t) {
                    var r = !1, o = !1;
                    e1 !== t && (t.a !== e1.a && (o = !0, E(t.a, e1.a)), t.d !== e1.d && (r = !0, a(t.d, e1.d)), T(t, e1), o || (n(t, e1.a), e1.a.c = e1), r || (i(t, e1.d), e1.d.a = e1));
                }
                function m(e1) {
                    var t = e1.b, r = !1;
                    e1.d !== e1.b.d && (r = !0, a(e1.d, e1.b.d)), e1.c === e1 ? E(e1.a, null) : (e1.b.d.a = e1.b.e, e1.a.c = e1.c, T(e1, e1.b.e), r || i(e1, e1.d)), t.c === t ? (E(t.a, null), a(t.d, null)) : (e1.d.a = t.b.e, t.a.c = t.c, T(t, t.b.e)), H(e1);
                }
                function w(e1) {
                    var t = s(e1), r = t.b;
                    return T(t, e1.e), t.a = e1.b.a, n(r, t.a), t.d = r.d = e1.d, t = t.b, T(e1.b, e1.b.b.e), T(e1.b, t), e1.b.a = t.a, t.b.a.c = t.b, t.b.d = e1.b.d, t.f = e1.f, t.b.f = e1.b.f, t;
                }
                function S(e1, t) {
                    var r = !1, o = s(e1), n = o.b;
                    return t.d !== e1.d && (r = !0, a(t.d, e1.d)), T(o, e1.e), T(n, t), o.a = e1.b.a, n.a = t.a, o.d = n.d = e1.d, e1.d.a = n, r || i(o, e1.d), o;
                }
                function s(e1) {
                    var t = new u, r = new u, o = e1.b.h;
                    return (((r.h = o).b.h = t).h = e1).b.h = r, t.b = r, ((t.c = t).e = r).b = t, (r.c = r).e = t;
                }
                function T(e1, t) {
                    var r = e1.c, o = t.c;
                    r.b.e = t, (o.b.e = e1).c = o, t.c = r;
                }
                function n(e1, t) {
                    var r = t.f, o = new D(t, r);
                    for(r.e = o, r = (t.f = o).c = e1; r.a = o, (r = r.c) !== e1;);
                }
                function i(e1, t) {
                    var r = t.d, o = new te(t, r);
                    for(r.b = o, (t.d = o).a = e1, o.c = t.c, r = e1; r.d = o, (r = r.e) !== e1;);
                }
                function H(e1) {
                    var t = e1.h;
                    e1 = e1.b.h, (t.b.h = e1).b.h = t;
                }
                function E(e1, t) {
                    for(var r = e1.c, o = r; o.a = t, (o = o.c) !== r;);
                    r = e1.f, ((o = e1.e).f = r).e = o;
                }
                function a(e1, t) {
                    for(var r = e1.a, o = r; o.d = t, (o = o.e) !== r;);
                    r = e1.d, ((o = e1.b).d = r).b = o;
                }
                function W(e1) {
                    var t = 0;
                    return Math.abs(e1[1]) > Math.abs(e1[0]) && (t = 1), t = Math.abs(e1[2]) > Math.abs(e1[t]) ? 2 : t;
                }
                function M(e1, t) {
                    e1.f += t.f, e1.b.f += t.b.f;
                }
                function h(e1, t, r) {
                    return e1 = e1.a, t = t.a, r = r.a, t.b.a === e1 ? r.b.a === e1 ? g(t.a, r.a) ? b(r.b.a, t.a, r.a) <= 0 : 0 <= b(t.b.a, r.a, t.a) : b(r.b.a, e1, r.a) <= 0 : r.b.a === e1 ? 0 <= b(t.b.a, e1, t.a) : (t = v(t.b.a, e1, t.a), (e1 = v(r.b.a, e1, r.a)) <= t);
                }
                function k(e1) {
                    e1.a.i = null;
                    var t = e1.e;
                    t.a.c = t.c, t.c.a = t.a, e1.e = null;
                }
                function O(e1, t) {
                    m(e1.a), e1.c = !1, (e1.a = t).i = e1;
                }
                function C(e1) {
                    for(var t = e1.a.a; (e1 = G(e1)).a.a === t;);
                    return e1.c && (O(e1, t = S(B(e1).a.b, e1.a.e)), e1 = G(e1)), e1;
                }
                function q(e1, t, r) {
                    var o = new N;
                    return o.a = r, o.e = p(e1.f, t.e, o), r.i = o;
                }
                function X(e1, t) {
                    switch(e1.s){
                        case 100130:
                            return 0 != (1 & t);
                        case 100131:
                            return 0 !== t;
                        case 100132:
                            return 0 < t;
                        case 100133:
                            return t < 0;
                        case 100134:
                            return 2 <= t || t <= -2;
                    }
                    return !1;
                }
                function f(e1) {
                    var t = e1.a, r = t.d;
                    r.c = e1.d, r.a = t, k(e1);
                }
                function P(e1, t, r) {
                    for(t = (e1 = t).a; e1 !== r;){
                        e1.c = !1;
                        var o = B(e1), n = o.a;
                        if (n.a !== t.a) {
                            if (!o.c) {
                                f(e1);
                                break;
                            }
                            O(o, n = S(t.c.b, n.b));
                        }
                        t.c !== n && (x(n.b.e, n), x(t, n)), f(e1), t = o.a, e1 = o;
                    }
                    return t;
                }
                function A(e1, t, r, o, n, s) {
                    for(var i = !0; q(e1, t, r.b), (r = r.c) !== o;);
                    for(null === n && (n = B(t).a.b.c); (r = (o = B(t)).a.b).a === n.a;)r.c !== n && (x(r.b.e, r), x(n.b.e, r)), o.f = t.f - r.f, o.d = X(e1, o.f), t.b = !0, !i && R(e1, t) && (M(r, n), k(t), m(n)), i = !1, t = o, n = r;
                    t.b = !0, s && Q(e1, t);
                }
                function Y(e1, t, r, o, n) {
                    var s = [
                        t.g[0],
                        t.g[1],
                        t.g[2]
                    ];
                    t.d = null, t.d = e1.o && e1.o(s, r, o, e1.c) || null, null === t.d && (n ? e1.n || (l(e1, 100156), e1.n = !0) : t.d = r[0]);
                }
                function L(e1, t, r) {
                    var o = [
                        null,
                        null,
                        null,
                        null
                    ];
                    o[0] = t.a.d, o[1] = r.a.d, Y(e1, t.a, o, [
                        .5,
                        .5,
                        0,
                        0
                    ], !1), x(t, r);
                }
                function Z(e1, t, r, o, n) {
                    var s = Math.abs(t.b - e1.b) + Math.abs(t.a - e1.a), i = Math.abs(r.b - e1.b) + Math.abs(r.a - e1.a), a = n + 1;
                    o[n] = .5 * i / (s + i), o[a] = .5 * s / (s + i), e1.g[0] += o[n] * t.g[0] + o[a] * r.g[0], e1.g[1] += o[n] * t.g[1] + o[a] * r.g[1], e1.g[2] += o[n] * t.g[2] + o[a] * r.g[2];
                }
                function R(e1, t) {
                    var r = B(t), o = t.a, n = r.a;
                    if (g(o.a, n.a)) {
                        if (0 < b(n.b.a, o.a, n.a)) return;
                        if (y(o.a, n.a)) {
                            if (o.a !== n.a) {
                                var r = e1.e, s = o.a.h;
                                if (0 <= s) {
                                    var i = (r = r.b).d, a = r.e, l = r.c, u = l[s];
                                    i[u] = i[r.a], (l[i[u]] = u) <= --r.a && (u <= 1 || g(a[i[u >> 1]], a[i[u]]) ? U : ue)(r, u), a[s] = null, l[s] = r.b, r.b = s;
                                } else for(r.c[-(s + 1)] = null; 0 < r.a && null === r.c[r.d[r.a - 1]];)--r.a;
                                L(e1, n.b.e, o);
                            }
                        } else w(n.b), x(o, n.b.e), t.b = r.b = !0;
                    } else {
                        if (b(o.b.a, n.a, o.a) < 0) return;
                        G(t).b = t.b = !0, w(o.b), x(n.b.e, o);
                    }
                    return 1;
                }
                function K(e1, t) {
                    var r = B(t), o = t.a, n = r.a, s = o.a, i = n.a, a = o.b.a, l = n.b.a, u = new D;
                    if (b(a, e1.a, s), b(l, e1.a, i), !(s === i || Math.min(s.a, a.a) > Math.max(i.a, l.a))) {
                        if (g(s, i)) {
                            if (0 < b(l, s, i)) return;
                        } else if (b(a, i, s) < 0) return;
                        var c, d, h = a, f = s, p = l, m = i;
                        if (g(h, f) || (c = h, h = f, f = c), g(p, m) || (c = p, p = m, m = c), g(h, p) || (c = h, h = p, p = c, c = f, f = m, m = c), g(p, f) ? g(f, m) ? ((c = v(h, p, f)) + (d = v(p, f, m)) < 0 && (c = -c, d = -d), u.b = j(c, p.b, d, f.b)) : ((c = b(h, p, f)) + (d = -b(h, m, f)) < 0 && (c = -c, d = -d), u.b = j(c, p.b, d, m.b)) : u.b = (p.b + f.b) / 2, _(h, f) || (c = h, h = f, f = c), _(p, m) || (c = p, p = m, m = c), _(h, p) || (c = h, h = p, p = c, c = f, f = m, m = c), _(p, f) ? _(f, m) ? ((c = V(h, p, f)) + (d = V(p, f, m)) < 0 && (c = -c, d = -d), u.a = j(c, p.a, d, f.a)) : ((c = z(h, p, f)) + (d = -z(h, m, f)) < 0 && (c = -c, d = -d), u.a = j(c, p.a, d, m.a)) : u.a = (p.a + f.a) / 2, g(u, e1.a) && (u.b = e1.a.b, u.a = e1.a.a), h = g(s, i) ? s : i, g(h, u) && (u.b = h.b, u.a = h.a), y(u, s) || y(u, i)) return R(e1, t), 0;
                        if (!y(a, e1.a) && 0 <= b(a, e1.a, u) || !y(l, e1.a) && b(l, e1.a, u) <= 0) {
                            if (l === e1.a) w(o.b), x(n.b, o), o = B(t = C(t)).a, P(e1, B(t), r), A(e1, t, o.b.e, o, o, !0);
                            else {
                                if (a !== e1.a) return 0 <= b(a, e1.a, u) && (G(t).b = t.b = !0, w(o.b), o.a.b = e1.a.b, o.a.a = e1.a.a), void (b(l, e1.a, u) <= 0 && (t.b = r.b = !0, w(n.b), n.a.b = e1.a.b, n.a.a = e1.a.a));
                                for(w(n.b), x(o.e, n.b.e), i = (s = r = t).a.b.a; (s = G(s)).a.b.a === i;);
                                s = B(t = s).a.b.c, r.a = n.b.e, A(e1, t, (n = P(e1, r, null)).c, o.b.c, s, !0);
                            }
                            return 1;
                        }
                        w(o.b), w(n.b), x(n.b.e, o), o.a.b = u.b, o.a.a = u.a, o.a.h = ne(e1.e, o.a), o = o.a, n = [
                            0,
                            0,
                            0,
                            0
                        ], u = [
                            s.d,
                            a.d,
                            i.d,
                            l.d
                        ], o.g[0] = o.g[1] = o.g[2] = 0, Z(o, s, a, n, 0), Z(o, i, l, n, 2), Y(e1, o, u, n, !0), G(t).b = t.b = r.b = !0;
                    }
                }
                function Q(e1, t) {
                    for(var r = B(t);;){
                        for(; r.b;)r = B(t = r);
                        if (!t.b && (null === (t = G(r = t)) || !t.b)) break;
                        t.b = !1;
                        var o = t.a, n = r.a;
                        if (s = o.b.a !== n.b.a) e: {
                            var s, i = B(s = t), a = s.a, l = i.a, u = void 0;
                            if (g(a.b.a, l.b.a)) {
                                if (b(a.b.a, l.b.a, a.a) < 0) {
                                    s = !1;
                                    break e;
                                }
                                G(s).b = s.b = !0, u = w(a), x(l.b, u), u.d.c = s.d;
                            } else {
                                if (0 < b(l.b.a, a.b.a, l.a)) {
                                    s = !1;
                                    break e;
                                }
                                s.b = i.b = !0, u = w(l), x(a.e, l.b), u.b.d.c = s.d;
                            }
                            s = !0;
                        }
                        if (s && (r.c ? (k(r), m(n), n = (r = B(t)).a) : t.c && (k(t), m(o), o = (t = G(r)).a)), o.a !== n.a) {
                            if (o.b.a === n.b.a || t.c || r.c || o.b.a !== e1.a && n.b.a !== e1.a) R(e1, t);
                            else if (K(e1, t)) break;
                        }
                        o.a === n.a && o.b.a === n.b.a && (M(n, o), k(t), m(o), t = G(r));
                    }
                }
                function J(e1, t) {
                    var r = new N, o = d(e1.b);
                    o.a.b = 4e150, o.a.a = t, o.b.a.b = -4000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000, o.b.a.a = t, e1.a = o.b.a, r.a = o, r.f = 0, r.d = !1, r.c = !1, r.h = !0, r.b = !1, o = p(o = e1.f, o.a, r), r.e = o;
                }
                function $(e1) {
                    this.a = new ee, this.b = e1, this.c = h;
                }
                function p(e1, t, r) {
                    for(; null !== (t = t.c).b && !e1.c(e1.b, t.b, r););
                    return e1 = new ee(r, t.a, t), t.a.c = e1, t.a = e1;
                }
                function ee(e1, t, r) {
                    this.b = e1 || null, this.a = t || this, this.c = r || this;
                }
                function r() {
                    this.d = 0, this.p = this.b = this.q = null, this.j = [
                        0,
                        0,
                        0
                    ], this.s = 100130, this.n = !1, this.o = this.a = this.e = this.f = null, this.m = !1, this.c = this.r = this.i = this.k = this.l = this.h = null;
                }
                function I(e1, t) {
                    if (e1.d !== t) for(; e1.d !== t;)if (e1.d < t) switch(e1.d){
                        case 0:
                            l(e1, 100151), e1.u(null);
                            break;
                        case 1:
                            l(e1, 100152), e1.t();
                    }
                    else switch(e1.d){
                        case 2:
                            l(e1, 100154), e1.v();
                            break;
                        case 1:
                            l(e1, 100153), e1.w();
                    }
                }
                function l(e1, t) {
                    e1.p && e1.p(t, e1.c);
                }
                function te(e1, t) {
                    this.b = e1 || this, this.d = t || this, this.a = null, this.c = !1;
                }
                function u() {
                    (this.h = this).i = this.d = this.a = this.e = this.c = this.b = null, this.f = 0;
                }
                function re() {
                    this.c = new D, this.a = new te, this.b = new u, this.d = new u, this.b.b = this.d, this.d.b = this.b;
                }
                function D(e1, t) {
                    this.e = e1 || this, this.f = t || this, this.d = this.c = null, this.g = [
                        0,
                        0,
                        0
                    ], this.h = this.a = this.b = 0;
                }
                function oe() {
                    this.c = [], this.d = null, this.a = 0, this.e = !1, this.b = new ie;
                }
                function ne(e1, t) {
                    var r, o, n;
                    return e1.e ? (2 * (o = ++(r = e1.b).a) > r.f && (r.f *= 2, r.c = ae(r.c, r.f + 1)), 0 === r.b ? n = o : (n = r.b, r.b = r.c[r.b]), r.e[n] = t, r.c[n] = o, r.d[o] = n, r.h && ue(r, o), n) : (r = e1.a++, e1.c[r] = t, -(r + 1));
                }
                function se(e1) {
                    if (0 === e1.a) return le(e1.b);
                    var t = e1.c[e1.d[e1.a - 1]];
                    if (0 !== e1.b.a && g(F(e1.b), t)) return le(e1.b);
                    for(; --e1.a, 0 < e1.a && null === e1.c[e1.d[e1.a - 1]];);
                    return t;
                }
                function ie() {
                    this.d = ae([
                        0
                    ], 33), this.e = [
                        null,
                        null
                    ], this.c = [
                        0,
                        0
                    ], this.a = 0, this.f = 32, this.b = 0, this.h = !1, this.d[1] = 1;
                }
                function ae(e1, t) {
                    for(var r = Array(t), o = 0; o < e1.length; o++)r[o] = e1[o];
                    for(; o < t; o++)r[o] = 0;
                    return r;
                }
                function F(e1) {
                    return e1.e[e1.d[1]];
                }
                function le(e1) {
                    var t = e1.d, r = e1.e, o = e1.c, n = t[1], s = r[n];
                    return 0 < e1.a && (t[1] = t[e1.a], o[t[1]] = 1, r[n] = null, o[n] = e1.b, e1.b = n, 0 < --e1.a && U(e1, 1)), s;
                }
                function U(e1, t) {
                    for(var r = e1.d, o = e1.e, n = e1.c, s = t, i = r[s];;){
                        var a = s << 1, l = (a < e1.a && g(o[r[a + 1]], o[r[a]]) && (a += 1), r[a]);
                        if (a > e1.a || g(o[i], o[l])) {
                            n[r[s] = i] = s;
                            break;
                        }
                        n[r[s] = l] = s, s = a;
                    }
                }
                function ue(e1, t) {
                    for(var r = e1.d, o = e1.e, n = e1.c, s = t, i = r[s];;){
                        var a = s >> 1, l = r[a];
                        if (0 == a || g(o[l], o[i])) {
                            n[r[s] = i] = s;
                            break;
                        }
                        n[r[s] = l] = s, s = a;
                    }
                }
                function N() {
                    this.e = this.a = null, this.f = 0, this.c = this.b = this.h = this.d = !1;
                }
                function B(e1) {
                    return e1.e.c.b;
                }
                function G(e1) {
                    return e1.e.a.b;
                }
                (t = r.prototype).x = function() {
                    I(this, 0);
                }, t.B = function(e1, t) {
                    switch(e1){
                        case 100142:
                            return;
                        case 100140:
                            switch(t){
                                case 100130:
                                case 100131:
                                case 100132:
                                case 100133:
                                case 100134:
                                    return void (this.s = t);
                            }
                            break;
                        case 100141:
                            return void (this.m = !!t);
                        default:
                            return void l(this, 100900);
                    }
                    l(this, 100901);
                }, t.y = function(e1) {
                    switch(e1){
                        case 100142:
                            return 0;
                        case 100140:
                            return this.s;
                        case 100141:
                            return this.m;
                        default:
                            l(this, 100900);
                    }
                    return !1;
                }, t.A = function(e1, t, r) {
                    this.j[0] = e1, this.j[1] = t, this.j[2] = r;
                }, t.z = function(e1, t) {
                    var r = t || null;
                    switch(e1){
                        case 100100:
                        case 100106:
                            this.h = r;
                            break;
                        case 100104:
                        case 100110:
                            this.l = r;
                            break;
                        case 100101:
                        case 100107:
                            this.k = r;
                            break;
                        case 100102:
                        case 100108:
                            this.i = r;
                            break;
                        case 100103:
                        case 100109:
                            this.p = r;
                            break;
                        case 100105:
                        case 100111:
                            this.o = r;
                            break;
                        case 100112:
                            this.r = r;
                            break;
                        default:
                            l(this, 100900);
                    }
                }, t.C = function(e1, t) {
                    var r = !1, o = [
                        0,
                        0,
                        0
                    ];
                    I(this, 2);
                    for(var n = 0; n < 3; ++n){
                        var s = e1[n];
                        s < -1000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000 && (s = -1000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000, r = !0), 1e150 < s && (s = 1e150, r = !0), o[n] = s;
                    }
                    r && l(this, 100155), null === (r = this.q) ? x(r = d(this.b), r.b) : (w(r), r = r.e), r.a.d = t, r.a.g[0] = o[0], r.a.g[1] = o[1], r.a.g[2] = o[2], r.f = 1, r.b.f = -1, this.q = r;
                }, t.u = function(e1) {
                    I(this, 0), this.d = 1, this.b = new re, this.c = e1;
                }, t.t = function() {
                    I(this, 1), this.d = 2, this.q = null;
                }, t.v = function() {
                    I(this, 2), this.d = 1;
                }, t.w = function() {
                    I(this, 1), this.d = 0;
                    var e1, t, r = this.j[0], o = this.j[1], n = this.j[2], s = !1, i = [
                        r,
                        o,
                        n
                    ];
                    if (0 === r && 0 === o && 0 === n) {
                        for(var o = [
                            -2000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                            -2000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                            -2000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000
                        ], a = [
                            2e150,
                            2e150,
                            2e150
                        ], n = [], l = [], r = (s = this.b.c).e; r !== s; r = r.e)for(var u = 0; u < 3; ++u){
                            var c = r.g[u];
                            c < a[u] && (a[u] = c, l[u] = r), c > o[u] && (o[u] = c, n[u] = r);
                        }
                        if (o[1] - a[1] > o[r = 0] - a[0] && (r = 1), a[r = o[2] - a[2] > o[r] - a[r] ? 2 : r] >= o[r]) i[0] = 0, i[1] = 0, i[2] = 1;
                        else {
                            for(a = l[r], n = n[r], l = [
                                o = 0,
                                0,
                                0
                            ], a = [
                                a.g[0] - n.g[0],
                                a.g[1] - n.g[1],
                                a.g[2] - n.g[2]
                            ], u = [
                                0,
                                0,
                                0
                            ], r = s.e; r !== s; r = r.e)u[0] = r.g[0] - n.g[0], u[1] = r.g[1] - n.g[1], u[2] = r.g[2] - n.g[2], l[0] = a[1] * u[2] - a[2] * u[1], l[1] = a[2] * u[0] - a[0] * u[2], l[2] = a[0] * u[1] - a[1] * u[0], o < (c = l[0] * l[0] + l[1] * l[1] + l[2] * l[2]) && (o = c, i[0] = l[0], i[1] = l[1], i[2] = l[2]);
                            o <= 0 && (i[0] = i[1] = i[2] = 0, i[W(a)] = 1);
                        }
                        s = !0;
                    }
                    for(l = W(i), r = this.b.c, o = (l + 1) % 3, n = (l + 2) % 3, l = 0 < i[l] ? 1 : -1, i = r.e; i !== r; i = i.e)i.b = i.g[o], i.a = l * i.g[n];
                    if (s) {
                        for(i = 0, r = (s = this.b.a).b; r !== s; r = r.b)if (!((o = r.a).f <= 0)) for(; i += (o.a.b - o.b.a.b) * (o.a.a + o.b.a.a), (o = o.e) !== r.a;);
                        if (i < 0) for(s = (i = this.b.c).e; s !== i; s = s.e)s.a = -s.a;
                    }
                    for(this.n = !1, i = this.b.b, r = i.h; r !== i; r = s)s = r.h, o = r.e, y(r.a, r.b.a) && r.e.e !== r && (L(this, o, r), m(r), o = (r = o).e), o.e === r && (o !== r && (o !== s && o !== s.b || (s = s.h), m(o)), r !== s && r !== s.b || (s = s.h), m(r));
                    for(this.e = i = new oe, s = this.b.c, r = s.e; r !== s; r = r.e)r.h = ne(i, r);
                    var d = i;
                    d.d = [];
                    for(var h = 0; h < d.a; h++)d.d[h] = h;
                    d.d.sort(function(r) {
                        return function(e1, t) {
                            return g(r[e1], r[t]) ? 1 : -1;
                        };
                    }(d.c)), d.e = !0;
                    for(var f = d.b, p = f.a; 1 <= p; --p)U(f, p);
                    for(f.h = !0, this.f = new $(this), J(this, -4000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000), J(this, 4e150); null !== (i = se(this.e));){
                        for(;;){
                            e: if (0 === (r = this.e).a) s = F(r.b);
                            else if (s = r.c[r.d[r.a - 1]], 0 !== r.b.a && g(r = F(r.b), s)) {
                                s = r;
                                break e;
                            }
                            if (null === s || !y(s, i)) break;
                            s = se(this.e), L(this, i.c, s.c);
                        }
                        !function e1(t, r) {
                            for(var o, n = (t.a = r).c; null === n.i;)if ((n = n.c) === r.c) {
                                var n = t, s = r;
                                (c = new N).a = s.c.b;
                                for(var i = (a = n.f).a; null !== (i = i.a).b && !a.c(a.b, c, i.b););
                                var a, l, u = B(a = i.b), c = a.a, i = u.a;
                                return void (0 === b(c.b.a, s, c.a) ? y((c = a.a).a, s) || y(c.b.a, s) || (w(c.b), a.c && (m(c.c), a.c = !1), x(s.c, c), e1(n, s)) : (l = g(i.b.a, c.b.a) ? a : u, u = void 0, a.d || l.c ? (u = l === a ? S(s.c.b, c.e) : S(i.b.c.b, s.c).b, l.c ? O(l, u) : ((a = q(c = n, a, u)).f = G(a).f + a.a.f, a.d = X(c, a.f)), e1(n, s)) : A(n, a, s.c, s.c, null, !0)));
                            }
                            a = (c = B(n = C(n.i))).a, (c = P(t, c, null)).c === a ? (c = (a = c).c, i = B(n), u = n.a, l = i.a, o = !1, u.b.a !== l.b.a && K(t, n), y(u.a, t.a) && (x(c.b.e, u), c = B(n = C(n)).a, P(t, B(n), i), o = !0), y(l.a, t.a) && (x(a, l.b.e), a = P(t, i, null), o = !0), o ? A(t, n, a.c, c, c, !0) : (s = g(l.a, u.a) ? l.b.e : u, A(t, n, s = S(a.c.b, s), s.c, s.c, !1), s.b.i.c = !0, Q(t, n))) : A(t, n, c.c, a, a, !0);
                        }(this, i);
                    }
                    for(this.a = this.f.a.a.b.a.a, i = 0; null !== (s = this.f.a.a.b);)s.h || ++i, k(s);
                    for(this.f = null, (i = this.e).b = null, i.d = null, this.e = i.c = null, i = this.b, r = i.a.b; r !== i.a; r = s)s = r.b, (r = r.a).e.e === r && (M(r.c, r), m(r));
                    if (!this.n) {
                        if (i = this.b, this.m) for(r = i.b.h; r !== i.b; r = s)s = r.h, r.b.d.c !== r.d.c ? r.f = r.d.c ? 1 : -1 : m(r);
                        else for(r = i.a.b; r !== i.a; r = s)if (s = r.b, r.c) {
                            for(r = r.a; g(r.b.a, r.a); r = r.c.b);
                            for(; g(r.a, r.b.a); r = r.e);
                            for(o = r.c.b, n = void 0; r.e !== o;)if (g(r.b.a, o.a)) {
                                for(; o.e !== r && (g((t = o.e).b.a, t.a) || b(o.a, o.b.a, o.e.b.a) <= 0);)o = (n = S(o.e, o)).b;
                                o = o.c.b;
                            } else {
                                for(; o.e !== r && (g((e1 = r.c.b).a, e1.b.a) || 0 <= b(r.b.a, r.a, r.c.b.a));)r = (n = S(r, r.c.b)).b;
                                r = r.e;
                            }
                            for(; o.e.e !== r;)n = S(o.e, o), o = n.b;
                        }
                        if (this.h || this.i || this.k || this.l) {
                            if (this.m) {
                                for(s = (i = this.b).a.b; s !== i.a; s = s.b)if (s.c) {
                                    for(this.h && this.h(2, this.c), r = s.a; this.k && this.k(r.a.d, this.c), (r = r.e) !== s.a;);
                                    this.i && this.i(this.c);
                                }
                            } else {
                                for(i = this.b, s = !!this.l, r = !1, o = -1, n = i.a.d; n !== i.a; n = n.d)if (n.c) for(r || (this.h && this.h(4, this.c), r = !0), l = n.a; s && (a = l.b.d.c ? 0 : 1, o !== a && (o = a, this.l && this.l(!!o, this.c))), this.k && this.k(l.a.d, this.c), (l = l.e) !== n.a;);
                                r && this.i && this.i(this.c);
                            }
                        }
                        if (this.r) {
                            for(i = this.b, r = i.a.b; r !== i.a; r = s)if (s = r.b, !r.c) {
                                for(n = (o = r.a).e, l = void 0; n = (l = n).e, (l.d = null) === l.b.d && (l.c === l ? E(l.a, null) : (l.a.c = l.c, T(l, l.b.e)), (a = l.b).c === a ? E(a.a, null) : (a.a.c = a.c, T(a, a.b.e)), H(l)), l !== o;);
                                o = r.d, ((r = r.b).d = o).b = r;
                            }
                            return this.r(this.b), void (this.c = this.b = null);
                        }
                    }
                    this.b = this.c = null;
                }, this.libtess = {
                    GluTesselator: r,
                    windingRule: {
                        GLU_TESS_WINDING_ODD: 100130,
                        GLU_TESS_WINDING_NONZERO: 100131,
                        GLU_TESS_WINDING_POSITIVE: 100132,
                        GLU_TESS_WINDING_NEGATIVE: 100133,
                        GLU_TESS_WINDING_ABS_GEQ_TWO: 100134
                    },
                    primitiveType: {
                        GL_LINE_LOOP: 2,
                        GL_TRIANGLES: 4,
                        GL_TRIANGLE_STRIP: 5,
                        GL_TRIANGLE_FAN: 6
                    },
                    errorType: {
                        GLU_TESS_MISSING_BEGIN_POLYGON: 100151,
                        GLU_TESS_MISSING_END_POLYGON: 100153,
                        GLU_TESS_MISSING_BEGIN_CONTOUR: 100152,
                        GLU_TESS_MISSING_END_CONTOUR: 100154,
                        GLU_TESS_COORD_TOO_LARGE: 100155,
                        GLU_TESS_NEED_COMBINE_CALLBACK: 100156
                    },
                    gluEnum: {
                        GLU_TESS_MESH: 100112,
                        GLU_TESS_TOLERANCE: 100142,
                        GLU_TESS_WINDING_RULE: 100140,
                        GLU_TESS_BOUNDARY_ONLY: 100141,
                        GLU_INVALID_ENUM: 100900,
                        GLU_INVALID_VALUE: 100901,
                        GLU_TESS_BEGIN: 100100,
                        GLU_TESS_VERTEX: 100101,
                        GLU_TESS_END: 100102,
                        GLU_TESS_ERROR: 100103,
                        GLU_TESS_EDGE_FLAG: 100104,
                        GLU_TESS_COMBINE: 100105,
                        GLU_TESS_BEGIN_DATA: 100106,
                        GLU_TESS_VERTEX_DATA: 100107,
                        GLU_TESS_END_DATA: 100108,
                        GLU_TESS_ERROR_DATA: 100109,
                        GLU_TESS_EDGE_FLAG_DATA: 100110,
                        GLU_TESS_COMBINE_DATA: 100111
                    }
                }, r.prototype.gluDeleteTess = r.prototype.x, r.prototype.gluTessProperty = r.prototype.B, r.prototype.gluGetTessProperty = r.prototype.y, r.prototype.gluTessNormal = r.prototype.A, r.prototype.gluTessCallback = r.prototype.z, r.prototype.gluTessVertex = r.prototype.C, r.prototype.gluTessBeginPolygon = r.prototype.u, r.prototype.gluTessBeginContour = r.prototype.t, r.prototype.gluTessEndContour = r.prototype.v, r.prototype.gluTessEndPolygon = r.prototype.w, void 0 !== e1 && (e1.exports = this.libtess);
            },
            {}
        ],
        256: [
            function(e1, t, r) {
                "use strict";
                function o(g, e1, t, r) {
                    var v = 0, o = void 0 === (r = void 0 === r ? {} : r).loop ? null : r.loop, b = void 0 === r.palette ? null : r.palette;
                    if (e1 <= 0 || t <= 0 || 65535 < e1 || 65535 < t) throw new Error("Width/Height invalid.");
                    function _(e1) {
                        e1 = e1.length;
                        if (e1 < 2 || 256 < e1 || e1 & e1 - 1) throw new Error("Invalid code/color length, must be power of 2 and 2 .. 256.");
                        return e1;
                    }
                    g[v++] = 71, g[v++] = 73, g[v++] = 70, g[v++] = 56, g[v++] = 57, g[v++] = 97;
                    var n = 0, s = 0;
                    if (null !== b) {
                        for(var i = _(b); i >>= 1;)++n;
                        if (i = 1 << n, --n, void 0 !== r.background) {
                            if (i <= (s = r.background)) throw new Error("Background index out of range.");
                            if (0 === s) throw new Error("Background index explicitly passed as 0.");
                        }
                    }
                    if (g[v++] = 255 & e1, g[v++] = e1 >> 8 & 255, g[v++] = 255 & t, g[v++] = t >> 8 & 255, g[v++] = (null !== b ? 128 : 0) | n, g[v++] = s, g[v++] = 0, null !== b) for(var a = 0, l = b.length; a < l; ++a){
                        var u = b[a];
                        g[v++] = u >> 16 & 255, g[v++] = u >> 8 & 255, g[v++] = 255 & u;
                    }
                    if (null !== o) {
                        if (o < 0 || 65535 < o) throw new Error("Loop count invalid.");
                        g[v++] = 33, g[v++] = 255, g[v++] = 11, g[v++] = 78, g[v++] = 69, g[v++] = 84, g[v++] = 83, g[v++] = 67, g[v++] = 65, g[v++] = 80, g[v++] = 69, g[v++] = 50, g[v++] = 46, g[v++] = 48, g[v++] = 3, g[v++] = 1, g[v++] = 255 & o, g[v++] = o >> 8 & 255, g[v++] = 0;
                    }
                    var j = !1;
                    this.addFrame = function(e1, t, r, o, n, s) {
                        if (!0 === j && (--v, j = !1), s = void 0 === s ? {} : s, e1 < 0 || t < 0 || 65535 < e1 || 65535 < t) throw new Error("x/y invalid.");
                        if (r <= 0 || o <= 0 || 65535 < r || 65535 < o) throw new Error("Width/Height invalid.");
                        if (n.length < r * o) throw new Error("Not enough pixels for the frame size.");
                        var i = !0, a = s.palette;
                        if (null == a && (i = !1, a = b), null == a) throw new Error("Must supply either a local or global palette.");
                        for(var l = _(a), u = 0; l >>= 1;)++u;
                        var l = 1 << u, c = void 0 === s.delay ? 0 : s.delay, d = void 0 === s.disposal ? 0 : s.disposal;
                        if (d < 0 || 3 < d) throw new Error("Disposal out of range.");
                        var h = !1, f = 0;
                        if (void 0 !== s.transparent && null !== s.transparent && (h = !0, (f = s.transparent) < 0 || l <= f)) throw new Error("Transparent color index.");
                        if (0 === d && !h && 0 === c || (g[v++] = 33, g[v++] = 249, g[v++] = 4, g[v++] = d << 2 | (!0 === h ? 1 : 0), g[v++] = 255 & c, g[v++] = c >> 8 & 255, g[v++] = f, g[v++] = 0), g[v++] = 44, g[v++] = 255 & e1, g[v++] = e1 >> 8 & 255, g[v++] = 255 & t, g[v++] = t >> 8 & 255, g[v++] = 255 & r, g[v++] = r >> 8 & 255, g[v++] = 255 & o, g[v++] = o >> 8 & 255, g[v++] = !0 === i ? 128 | u - 1 : 0, !0 === i) for(var p = 0, m = a.length; p < m; ++p){
                            var y = a[p];
                            g[v++] = y >> 16 & 255, g[v++] = y >> 8 & 255, g[v++] = 255 & y;
                        }
                        return v = function(t, r, e1, o) {
                            t[r++] = e1;
                            var n = r++, s = 1 << e1, i = s - 1, a = 1 + s, l = 1 + a, u = e1 + 1, c = 0, d = 0;
                            function h(e1) {
                                for(; e1 <= c;)t[r++] = 255 & d, d >>= 8, c -= 8, r === n + 256 && (t[n] = 255, n = r++);
                            }
                            function f(e1) {
                                d |= e1 << c, c += u, h(8);
                            }
                            var p = o[0] & i, m = {};
                            f(s);
                            for(var y = 1, g = o.length; y < g; ++y){
                                var v = o[y] & i, b = p << 8 | v, _ = m[b];
                                if (void 0 === _) {
                                    for(d |= p << c, c += u; 8 <= c;)t[r++] = 255 & d, d >>= 8, c -= 8, r === n + 256 && (t[n] = 255, n = r++);
                                    4096 === l ? (f(s), l = 1 + a, u = e1 + 1, m = {}) : (1 << u <= l && ++u, m[b] = l++), p = v;
                                } else p = _;
                            }
                            f(p), f(a), h(1), n + 1 === r ? t[n] = 0 : (t[n] = r - n - 1, t[r++] = 0);
                            return r;
                        }(g, v, u < 2 ? 2 : u, n);
                    }, this.end = function() {
                        return !1 === j && (g[v++] = 59, j = !0), v;
                    }, this.getOutputBuffer = function() {
                        return g;
                    }, this.setOutputBuffer = function(e1) {
                        g = e1;
                    }, this.getOutputBufferPosition = function() {
                        return v;
                    }, this.setOutputBufferPosition = function(e1) {
                        v = e1;
                    };
                }
                function E(e1, t, r, o) {
                    for(var n = e1[t++], s = 1 << n, i = 1 + s, a = 1 + i, l = n + 1, u = (1 << l) - 1, c = 0, d = 0, h = 0, f = e1[t++], p = new Int32Array(4096), m = null;;){
                        for(; c < 16 && 0 !== f;)d |= e1[t++] << c, c += 8, 1 === f ? f = e1[t++] : --f;
                        if (c < l) break;
                        var y = d & u;
                        if (d >>= l, c -= l, y == s) a = 1 + i, u = (1 << (l = n + 1)) - 1, m = null;
                        else {
                            if (y == i) break;
                            for(var g = y < a ? y : m, v = 0, b = g; s < b;)b = p[b] >> 8, ++v;
                            var _ = b;
                            if (o < h + v + (g !== y ? 1 : 0)) return void console.log("Warning, gif stream longer than expected.");
                            r[h++] = _;
                            var j = h += v;
                            for(g !== y && (r[h++] = _), b = g; v--;)b = p[b], r[--j] = 255 & b, b >>= 8;
                            null !== m && a < 4096 && (p[a++] = m << 8 | _, u + 1 <= a && l < 12 && (++l, u = u << 1 | 1)), m = y;
                        }
                    }
                    h !== o && console.log("Warning, gif stream shorter than expected.");
                }
                try {
                    r.GifWriter = o, r.GifReader = function(b) {
                        var e1 = 0;
                        if (71 !== b[e1++] || 73 !== b[e1++] || 70 !== b[e1++] || 56 !== b[e1++] || 56 != (b[e1++] + 1 & 253) || 97 !== b[e1++]) throw new Error("Invalid GIF 87a/89a header.");
                        var _ = b[e1++] | b[e1++] << 8, t = b[e1++] | b[e1++] << 8, r = b[e1++], o = 1 << 1 + (7 & r), n = (b[e1++], b[e1++], null), s = null, i = (r >> 7 && (n = e1, e1 += 3 * (s = o)), !0), a = [], l = 0, u = null, c = 0, d = null;
                        for(this.width = _, this.height = t; i && e1 < b.length;)switch(b[e1++]){
                            case 33:
                                switch(b[e1++]){
                                    case 255:
                                        if (11 !== b[e1] || 78 == b[e1 + 1] && 69 == b[e1 + 2] && 84 == b[e1 + 3] && 83 == b[e1 + 4] && 67 == b[e1 + 5] && 65 == b[e1 + 6] && 80 == b[e1 + 7] && 69 == b[e1 + 8] && 50 == b[e1 + 9] && 46 == b[e1 + 10] && 48 == b[e1 + 11] && 3 == b[e1 + 12] && 1 == b[e1 + 13] && 0 == b[e1 + 16]) e1 += 14, d = b[e1++] | b[e1++] << 8, e1++;
                                        else for(e1 += 12;;){
                                            if (!(0 <= (f = b[e1++]))) throw Error("Invalid block size");
                                            if (0 === f) break;
                                            e1 += f;
                                        }
                                        break;
                                    case 249:
                                        if (4 !== b[e1++] || 0 !== b[e1 + 4]) throw new Error("Invalid graphics extension block.");
                                        var h = b[e1++], l = b[e1++] | b[e1++] << 8, u = b[e1++];
                                        0 == (1 & h) && (u = null), c = h >> 2 & 7, e1++;
                                        break;
                                    case 254:
                                        for(;;){
                                            if (!(0 <= (f = b[e1++]))) throw Error("Invalid block size");
                                            if (0 === f) break;
                                            e1 += f;
                                        }
                                        break;
                                    default:
                                        throw new Error("Unknown graphic control label: 0x" + b[e1 - 1].toString(16));
                                }
                                break;
                            case 44:
                                var f, p = b[e1++] | b[e1++] << 8, m = b[e1++] | b[e1++] << 8, y = b[e1++] | b[e1++] << 8, g = b[e1++] | b[e1++] << 8, v = b[e1++], j = v >> 6 & 1, x = 1 << 1 + (7 & v), w = n, S = s, T = !1, v = (v >> 7 && (T = !0, w = e1, e1 += 3 * (S = x)), e1);
                                for(e1++;;){
                                    if (!(0 <= (f = b[e1++]))) throw Error("Invalid block size");
                                    if (0 === f) break;
                                    e1 += f;
                                }
                                a.push({
                                    x: p,
                                    y: m,
                                    width: y,
                                    height: g,
                                    has_local_palette: T,
                                    palette_offset: w,
                                    palette_size: S,
                                    data_offset: v,
                                    data_length: e1 - v,
                                    transparent_index: u,
                                    interlaced: !!j,
                                    delay: l,
                                    disposal: c
                                });
                                break;
                            case 59:
                                i = !1;
                                break;
                            default:
                                throw new Error("Unknown gif block: 0x" + b[e1 - 1].toString(16));
                        }
                        this.numFrames = function() {
                            return a.length;
                        }, this.loopCount = function() {
                            return d;
                        }, this.frameInfo = function(e1) {
                            if (e1 < 0 || e1 >= a.length) throw new Error("Frame index out of range.");
                            return a[e1];
                        }, this.decodeAndBlitFrameBGRA = function(e1, t) {
                            for(var e1 = this.frameInfo(e1), r = e1.width * e1.height, o = new Uint8Array(r), n = (E(b, e1.data_offset, o, r), e1.palette_offset), s = e1.transparent_index, i = (null === s && (s = 256), e1.width), a = _ - i, l = i, u = 4 * (e1.y * _ + e1.x), c = 4 * ((e1.y + e1.height) * _ + e1.x), d = u, h = 4 * a, f = (!0 === e1.interlaced && (h += 4 * _ * 7), 8), p = 0, m = o.length; p < m; ++p){
                                var y, g, v = o[p];
                                0 === l && (l = i, c <= (d += h) && (h = 4 * a + 4 * _ * (f - 1), d = u + (i + a) * (f << 1), f >>= 1)), v === s ? d += 4 : (y = b[n + 3 * v], g = b[n + 3 * v + 1], v = b[n + 3 * v + 2], t[d++] = v, t[d++] = g, t[d++] = y, t[d++] = 255), --l;
                            }
                        }, this.decodeAndBlitFrameRGBA = function(e1, t) {
                            for(var e1 = this.frameInfo(e1), r = e1.width * e1.height, o = new Uint8Array(r), n = (E(b, e1.data_offset, o, r), e1.palette_offset), s = e1.transparent_index, i = (null === s && (s = 256), e1.width), a = _ - i, l = i, u = 4 * (e1.y * _ + e1.x), c = 4 * ((e1.y + e1.height) * _ + e1.x), d = u, h = 4 * a, f = (!0 === e1.interlaced && (h += 4 * _ * 7), 8), p = 0, m = o.length; p < m; ++p){
                                var y, g, v = o[p];
                                0 === l && (l = i, c <= (d += h) && (h = 4 * a + 4 * _ * (f - 1), d = u + (i + a) * (f << 1), f >>= 1)), v === s ? d += 4 : (y = b[n + 3 * v], g = b[n + 3 * v + 1], v = b[n + 3 * v + 2], t[d++] = y, t[d++] = g, t[d++] = v, t[d++] = 255), --l;
                            }
                        };
                    };
                } catch (e1) {}
            },
            {}
        ],
        257: [
            function(Ar, r, o) {
                (function(Pr) {
                    var e1, t;
                    e1 = this, t = function(_) {
                        "use strict";
                        function D(e1) {
                            if (null == this) throw TypeError();
                            var t, r = String(this), o = r.length, e1 = e1 ? Number(e1) : 0;
                            if (!((e1 = e1 != e1 ? 0 : e1) < 0 || o <= e1)) return 55296 <= (t = r.charCodeAt(e1)) && t <= 56319 && e1 + 1 < o && 56320 <= (o = r.charCodeAt(e1 + 1)) && o <= 57343 ? 1024 * (t - 55296) + o - 56320 + 65536 : t;
                        }
                        String.prototype.codePointAt || ((F = function() {
                            try {
                                var e1 = {}, t = Object.defineProperty, r = t(e1, e1, e1) && t;
                            } catch (e1) {}
                            return r;
                        }()) ? F(String.prototype, "codePointAt", {
                            value: D,
                            configurable: !0,
                            writable: !0
                        }) : String.prototype.codePointAt = D);
                        var F, U = 0, N = -3;
                        function B() {
                            this.table = new Uint16Array(16), this.trans = new Uint16Array(288);
                        }
                        function G(e1, t) {
                            this.source = e1, this.sourceIndex = 0, this.tag = 0, this.bitcount = 0, this.dest = t, this.destLen = 0, this.ltree = new B, this.dtree = new B;
                        }
                        var V = new B, z = new B, H = new Uint8Array(30), W = new Uint16Array(30), q = new Uint8Array(30), X = new Uint16Array(30), Y = new Uint8Array([
                            16,
                            17,
                            18,
                            0,
                            8,
                            7,
                            9,
                            6,
                            10,
                            5,
                            11,
                            4,
                            12,
                            3,
                            13,
                            2,
                            14,
                            1,
                            15
                        ]), Z = new B, v = new Uint8Array(320);
                        function K(e1, t, r, o) {
                            for(var n, s = 0; s < r; ++s)e1[s] = 0;
                            for(s = 0; s < 30 - r; ++s)e1[s + r] = s / r | 0;
                            for(n = o, s = 0; s < 30; ++s)t[s] = n, n += 1 << e1[s];
                        }
                        var Q = new Uint16Array(16);
                        function J(e1, t, r, o) {
                            for(var n, s = 0; s < 16; ++s)e1.table[s] = 0;
                            for(s = 0; s < o; ++s)e1.table[t[r + s]]++;
                            for(s = n = e1.table[0] = 0; s < 16; ++s)Q[s] = n, n += e1.table[s];
                            for(s = 0; s < o; ++s)t[r + s] && (e1.trans[Q[t[r + s]]++] = s);
                        }
                        function b(e1, t, r) {
                            if (!t) return r;
                            for(; e1.bitcount < 24;)e1.tag |= e1.source[e1.sourceIndex++] << e1.bitcount, e1.bitcount += 8;
                            var o = e1.tag & 65535 >>> 16 - t;
                            return e1.tag >>>= t, e1.bitcount -= t, o + r;
                        }
                        function $(e1, t) {
                            for(; e1.bitcount < 24;)e1.tag |= e1.source[e1.sourceIndex++] << e1.bitcount, e1.bitcount += 8;
                            for(var r = 0, o = 0, n = 0, s = e1.tag; o = 2 * o + (1 & s), s >>>= 1, r += t.table[++n], 0 <= (o -= t.table[n]););
                            return e1.tag = s, e1.bitcount -= n, t.trans[r + o];
                        }
                        function ee(e1, t, r) {
                            for(;;){
                                var o = $(e1, t);
                                if (256 === o) return U;
                                if (o < 256) e1.dest[e1.destLen++] = o;
                                else for(var n, s = b(e1, H[o -= 257], W[o]), o = $(e1, r), i = n = e1.destLen - b(e1, q[o], X[o]); i < n + s; ++i)e1.dest[e1.destLen++] = e1.dest[i];
                            }
                        }
                        for(var e1 = V, te = z, t = 0; t < 7; ++t)e1.table[t] = 0;
                        for(e1.table[7] = 24, e1.table[8] = 152, e1.table[9] = 112, t = 0; t < 24; ++t)e1.trans[t] = 256 + t;
                        for(t = 0; t < 144; ++t)e1.trans[24 + t] = t;
                        for(t = 0; t < 8; ++t)e1.trans[168 + t] = 280 + t;
                        for(t = 0; t < 112; ++t)e1.trans[176 + t] = 144 + t;
                        for(t = 0; t < 5; ++t)te.table[t] = 0;
                        for(te.table[5] = 32, t = 0; t < 32; ++t)te.trans[t] = t;
                        K(H, W, 4, 3), K(q, X, 2, 1), H[28] = 0, W[28] = 258;
                        var re = function(e1, t) {
                            var r, o, n, s = new G(e1, t);
                            do {
                                switch(n = void 0, (o = s).bitcount-- || (o.tag = o.source[o.sourceIndex++], o.bitcount = 7), n = 1 & o.tag, o.tag >>>= 1, o = n, b(s, 2, 0)){
                                    case 0:
                                        r = function(e1) {
                                            for(var t, r; 8 < e1.bitcount;)e1.sourceIndex--, e1.bitcount -= 8;
                                            if ((t = 256 * e1.source[e1.sourceIndex + 1] + e1.source[e1.sourceIndex]) !== (65535 & ~(256 * e1.source[e1.sourceIndex + 3] + e1.source[e1.sourceIndex + 2]))) return N;
                                            for(e1.sourceIndex += 4, r = t; r; --r)e1.dest[e1.destLen++] = e1.source[e1.sourceIndex++];
                                            return e1.bitcount = 0, U;
                                        }(s);
                                        break;
                                    case 1:
                                        r = ee(s, V, z);
                                        break;
                                    case 2:
                                        y = m = p = g = i = f = h = d = c = u = l = a = void 0;
                                        for(var i, a = s, l = s.ltree, u = s.dtree, c = b(a, 5, 257), d = b(a, 5, 1), h = b(a, 4, 4), f = 0; f < 19; ++f)v[f] = 0;
                                        for(f = 0; f < h; ++f){
                                            var p = b(a, 3, 0);
                                            v[Y[f]] = p;
                                        }
                                        for(J(Z, v, 0, 19), i = 0; i < c + d;){
                                            var m = $(a, Z);
                                            switch(m){
                                                case 16:
                                                    for(var y = v[i - 1], g = b(a, 2, 3); g; --g)v[i++] = y;
                                                    break;
                                                case 17:
                                                    for(g = b(a, 3, 3); g; --g)v[i++] = 0;
                                                    break;
                                                case 18:
                                                    for(g = b(a, 7, 11); g; --g)v[i++] = 0;
                                                    break;
                                                default:
                                                    v[i++] = m;
                                            }
                                        }
                                        J(l, v, 0, c), J(u, v, c, d), r = ee(s, s.ltree, s.dtree);
                                        break;
                                    default:
                                        r = N;
                                }
                                if (r !== U) throw new Error("Data error");
                            }while (!o);
                            return s.destLen < s.dest.length ? "function" == typeof s.dest.slice ? s.dest.slice(0, s.destLen) : s.dest.subarray(0, s.destLen) : s.dest;
                        };
                        function g(e1, t, r, o, n) {
                            return Math.pow(1 - n, 3) * e1 + 3 * Math.pow(1 - n, 2) * n * t + 3 * (1 - n) * Math.pow(n, 2) * r + Math.pow(n, 3) * o;
                        }
                        function a() {
                            this.x1 = Number.NaN, this.y1 = Number.NaN, this.x2 = Number.NaN, this.y2 = Number.NaN;
                        }
                        function h() {
                            this.commands = [], this.fill = "black", this.stroke = null, this.strokeWidth = 1;
                        }
                        function oe(e1) {
                            throw new Error(e1);
                        }
                        function ne(e1, t) {
                            e1 || oe(t);
                        }
                        a.prototype.isEmpty = function() {
                            return isNaN(this.x1) || isNaN(this.y1) || isNaN(this.x2) || isNaN(this.y2);
                        }, a.prototype.addPoint = function(e1, t) {
                            "number" == typeof e1 && ((isNaN(this.x1) || isNaN(this.x2)) && (this.x1 = e1, this.x2 = e1), e1 < this.x1 && (this.x1 = e1), e1 > this.x2 && (this.x2 = e1)), "number" == typeof t && ((isNaN(this.y1) || isNaN(this.y2)) && (this.y1 = t, this.y2 = t), t < this.y1 && (this.y1 = t), t > this.y2 && (this.y2 = t));
                        }, a.prototype.addX = function(e1) {
                            this.addPoint(e1, null);
                        }, a.prototype.addY = function(e1) {
                            this.addPoint(null, e1);
                        }, a.prototype.addBezier = function(e1, t, r, o, n, s, i, a) {
                            var l = [
                                e1,
                                t
                            ], u = [
                                r,
                                o
                            ], c = [
                                n,
                                s
                            ], d = [
                                i,
                                a
                            ];
                            this.addPoint(e1, t), this.addPoint(i, a);
                            for(var h = 0; h <= 1; h++){
                                var f, p = 6 * l[h] - 12 * u[h] + 6 * c[h], m = -3 * l[h] + 9 * u[h] - 9 * c[h] + 3 * d[h], y = 3 * u[h] - 3 * l[h];
                                0 == m ? 0 == p || 0 < (f = -y / p) && f < 1 && (0 === h && this.addX(g(l[h], u[h], c[h], d[h], f)), 1 === h && this.addY(g(l[h], u[h], c[h], d[h], f))) : (f = Math.pow(p, 2) - 4 * y * m) < 0 || (0 < (y = (-p + Math.sqrt(f)) / (2 * m)) && y < 1 && (0 === h && this.addX(g(l[h], u[h], c[h], d[h], y)), 1 === h && this.addY(g(l[h], u[h], c[h], d[h], y))), 0 < (y = (-p - Math.sqrt(f)) / (2 * m)) && y < 1 && (0 === h && this.addX(g(l[h], u[h], c[h], d[h], y)), 1 === h && this.addY(g(l[h], u[h], c[h], d[h], y))));
                            }
                        }, a.prototype.addQuad = function(e1, t, r, o, n, s) {
                            r = e1 + 2 / 3 * (r - e1), o = t + 2 / 3 * (o - t);
                            this.addBezier(e1, t, r, o, r + 1 / 3 * (n - e1), o + 1 / 3 * (s - t), n, s);
                        }, h.prototype.moveTo = function(e1, t) {
                            this.commands.push({
                                type: "M",
                                x: e1,
                                y: t
                            });
                        }, h.prototype.lineTo = function(e1, t) {
                            this.commands.push({
                                type: "L",
                                x: e1,
                                y: t
                            });
                        }, h.prototype.curveTo = h.prototype.bezierCurveTo = function(e1, t, r, o, n, s) {
                            this.commands.push({
                                type: "C",
                                x1: e1,
                                y1: t,
                                x2: r,
                                y2: o,
                                x: n,
                                y: s
                            });
                        }, h.prototype.quadTo = h.prototype.quadraticCurveTo = function(e1, t, r, o) {
                            this.commands.push({
                                type: "Q",
                                x1: e1,
                                y1: t,
                                x: r,
                                y: o
                            });
                        }, h.prototype.close = h.prototype.closePath = function() {
                            this.commands.push({
                                type: "Z"
                            });
                        }, h.prototype.extend = function(e1) {
                            var t;
                            if (e1.commands) e1 = e1.commands;
                            else if (e1 instanceof a) return t = e1, this.moveTo(t.x1, t.y1), this.lineTo(t.x2, t.y1), this.lineTo(t.x2, t.y2), this.lineTo(t.x1, t.y2), void this.close();
                            Array.prototype.push.apply(this.commands, e1);
                        }, h.prototype.getBoundingBox = function() {
                            for(var e1 = new a, t = 0, r = 0, o = 0, n = 0, s = 0; s < this.commands.length; s++){
                                var i = this.commands[s];
                                switch(i.type){
                                    case "M":
                                        e1.addPoint(i.x, i.y), t = o = i.x, r = n = i.y;
                                        break;
                                    case "L":
                                        e1.addPoint(i.x, i.y), o = i.x, n = i.y;
                                        break;
                                    case "Q":
                                        e1.addQuad(o, n, i.x1, i.y1, i.x, i.y), o = i.x, n = i.y;
                                        break;
                                    case "C":
                                        e1.addBezier(o, n, i.x1, i.y1, i.x2, i.y2, i.x, i.y), o = i.x, n = i.y;
                                        break;
                                    case "Z":
                                        o = t, n = r;
                                        break;
                                    default:
                                        throw new Error("Unexpected path command " + i.type);
                                }
                            }
                            return e1.isEmpty() && e1.addPoint(0, 0), e1;
                        }, h.prototype.draw = function(e1) {
                            e1.beginPath();
                            for(var t = 0; t < this.commands.length; t += 1){
                                var r = this.commands[t];
                                "M" === r.type ? e1.moveTo(r.x, r.y) : "L" === r.type ? e1.lineTo(r.x, r.y) : "C" === r.type ? e1.bezierCurveTo(r.x1, r.y1, r.x2, r.y2, r.x, r.y) : "Q" === r.type ? e1.quadraticCurveTo(r.x1, r.y1, r.x, r.y) : "Z" === r.type && e1.closePath();
                            }
                            this.fill && (e1.fillStyle = this.fill, e1.fill()), this.stroke && (e1.strokeStyle = this.stroke, e1.lineWidth = this.strokeWidth, e1.stroke());
                        }, h.prototype.toPathData = function(n) {
                            function e1() {
                                for(var e1 = arguments, t = "", r = 0; r < arguments.length; r += 1){
                                    var o = e1[r];
                                    0 <= o && 0 < r && (t += " "), t += (o, Math.round(o) === o ? "" + Math.round(o) : o.toFixed(n));
                                }
                                return t;
                            }
                            n = void 0 !== n ? n : 2;
                            for(var t = "", r = 0; r < this.commands.length; r += 1){
                                var o = this.commands[r];
                                "M" === o.type ? t += "M" + e1(o.x, o.y) : "L" === o.type ? t += "L" + e1(o.x, o.y) : "C" === o.type ? t += "C" + e1(o.x1, o.y1, o.x2, o.y2, o.x, o.y) : "Q" === o.type ? t += "Q" + e1(o.x1, o.y1, o.x, o.y) : "Z" === o.type && (t += "Z");
                            }
                            return t;
                        }, h.prototype.toSVG = function(e1) {
                            var t = (t = '<path d="') + this.toPathData(e1) + '"';
                            return this.fill && "black" !== this.fill && (null === this.fill ? t += ' fill="none"' : t += ' fill="' + this.fill + '"'), this.stroke && (t += ' stroke="' + this.stroke + '" stroke-width="' + this.strokeWidth + '"'), t += "/>";
                        }, h.prototype.toDOMElement = function(e1) {
                            var e1 = this.toPathData(e1), t = document.createElementNS("http://www.w3.org/2000/svg", "path");
                            return t.setAttribute("d", e1), t;
                        };
                        var L = {
                            fail: oe,
                            argument: ne,
                            assert: ne
                        }, m = {}, w = {}, l = {};
                        function r(e1) {
                            return function() {
                                return e1;
                            };
                        }
                        w.BYTE = function(e1) {
                            return L.argument(0 <= e1 && e1 <= 255, "Byte value should be between 0 and 255."), [
                                e1
                            ];
                        }, l.BYTE = r(1), w.CHAR = function(e1) {
                            return [
                                e1.charCodeAt(0)
                            ];
                        }, l.CHAR = r(1), w.CHARARRAY = function(e1) {
                            for(var t = [], r = 0; r < e1.length; r += 1)t[r] = e1.charCodeAt(r);
                            return t;
                        }, l.CHARARRAY = function(e1) {
                            return e1.length;
                        }, w.USHORT = function(e1) {
                            return [
                                e1 >> 8 & 255,
                                255 & e1
                            ];
                        }, l.USHORT = r(2), w.SHORT = function(e1) {
                            return [
                                (e1 = 32768 <= e1 ? -(65536 - e1) : e1) >> 8 & 255,
                                255 & e1
                            ];
                        }, l.SHORT = r(2), w.UINT24 = function(e1) {
                            return [
                                e1 >> 16 & 255,
                                e1 >> 8 & 255,
                                255 & e1
                            ];
                        }, l.UINT24 = r(3), w.ULONG = function(e1) {
                            return [
                                e1 >> 24 & 255,
                                e1 >> 16 & 255,
                                e1 >> 8 & 255,
                                255 & e1
                            ];
                        }, l.ULONG = r(4), w.LONG = function(e1) {
                            return [
                                (e1 = 2147483648 <= e1 ? -(4294967296 - e1) : e1) >> 24 & 255,
                                e1 >> 16 & 255,
                                e1 >> 8 & 255,
                                255 & e1
                            ];
                        }, l.LONG = r(4), w.FIXED = w.ULONG, l.FIXED = l.ULONG, w.FWORD = w.SHORT, l.FWORD = l.SHORT, w.UFWORD = w.USHORT, l.UFWORD = l.USHORT, w.LONGDATETIME = function(e1) {
                            return [
                                0,
                                0,
                                0,
                                0,
                                e1 >> 24 & 255,
                                e1 >> 16 & 255,
                                e1 >> 8 & 255,
                                255 & e1
                            ];
                        }, l.LONGDATETIME = r(8), w.TAG = function(e1) {
                            return L.argument(4 === e1.length, "Tag should be exactly 4 ASCII characters."), [
                                e1.charCodeAt(0),
                                e1.charCodeAt(1),
                                e1.charCodeAt(2),
                                e1.charCodeAt(3)
                            ];
                        }, l.TAG = r(4), w.Card8 = w.BYTE, l.Card8 = l.BYTE, w.Card16 = w.USHORT, l.Card16 = l.USHORT, w.OffSize = w.BYTE, l.OffSize = l.BYTE, w.SID = w.USHORT, l.SID = l.USHORT, w.NUMBER = function(e1) {
                            return -107 <= e1 && e1 <= 107 ? [
                                e1 + 139
                            ] : 108 <= e1 && e1 <= 1131 ? [
                                247 + ((e1 -= 108) >> 8),
                                255 & e1
                            ] : -1131 <= e1 && e1 <= -108 ? [
                                251 + ((e1 = -e1 - 108) >> 8),
                                255 & e1
                            ] : -32768 <= e1 && e1 <= 32767 ? w.NUMBER16(e1) : w.NUMBER32(e1);
                        }, l.NUMBER = function(e1) {
                            return w.NUMBER(e1).length;
                        }, w.NUMBER16 = function(e1) {
                            return [
                                28,
                                e1 >> 8 & 255,
                                255 & e1
                            ];
                        }, l.NUMBER16 = r(3), w.NUMBER32 = function(e1) {
                            return [
                                29,
                                e1 >> 24 & 255,
                                e1 >> 16 & 255,
                                e1 >> 8 & 255,
                                255 & e1
                            ];
                        }, l.NUMBER32 = r(5), w.REAL = function(e1) {
                            for(var t = e1.toString(), r = /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/.exec(t), o = (r && (r = parseFloat("1e" + ((r[2] ? +r[2] : 0) + r[1].length)), t = (Math.round(e1 * r) / r).toString()), ""), n = 0, s = t.length; n < s; n += 1){
                                var i = t[n];
                                o += "e" === i ? "-" === t[++n] ? "c" : "b" : "." === i ? "a" : "-" === i ? "e" : i;
                            }
                            for(var a = [
                                30
                            ], l = 0, u = (o += 1 & o.length ? "f" : "ff").length; l < u; l += 2)a.push(parseInt(o.substr(l, 2), 16));
                            return a;
                        }, l.REAL = function(e1) {
                            return w.REAL(e1).length;
                        }, w.NAME = w.CHARARRAY, l.NAME = l.CHARARRAY, w.STRING = w.CHARARRAY, l.STRING = l.CHARARRAY, m.UTF8 = function(e1, t, r) {
                            for(var o = [], n = r, s = 0; s < n; s++, t += 1)o[s] = e1.getUint8(t);
                            return String.fromCharCode.apply(null, o);
                        }, m.UTF16 = function(e1, t, r) {
                            for(var o = [], n = r / 2, s = 0; s < n; s++, t += 2)o[s] = e1.getUint16(t);
                            return String.fromCharCode.apply(null, o);
                        }, w.UTF16 = function(e1) {
                            for(var t = [], r = 0; r < e1.length; r += 1){
                                var o = e1.charCodeAt(r);
                                t[t.length] = o >> 8 & 255, t[t.length] = 255 & o;
                            }
                            return t;
                        }, l.UTF16 = function(e1) {
                            return 2 * e1.length;
                        };
                        var se, ie = {
                            "x-mac-croatian": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\u0160\u2122\xb4\xa8\u2260\u017D\xd8\u221E\xb1\u2264\u2265\u2206\xb5\u2202\u2211\u220F\u0161\u222B\xaa\xba\u03A9\u017E\xf8\xbf\xa1\xac\u221A\u0192\u2248\u0106\xab\u010C\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u0110\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\uF8FF\xa9\u2044\u20AC\u2039\u203A\xc6\xbb\u2013\xb7\u201A\u201E\u2030\xc2\u0107\xc1\u010D\xc8\xcd\xce\xcf\xcc\xd3\xd4\u0111\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u03C0\xcb\u02DA\xb8\xca\xe6\u02C7",
                            "x-mac-cyrillic": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u2020\xb0\u0490\xa3\xa7\u2022\xb6\u0406\xae\xa9\u2122\u0402\u0452\u2260\u0403\u0453\u221E\xb1\u2264\u2265\u0456\xb5\u0491\u0408\u0404\u0454\u0407\u0457\u0409\u0459\u040A\u045A\u0458\u0405\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\u040B\u045B\u040C\u045C\u0455\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u201E\u040E\u045E\u040F\u045F\u2116\u0401\u0451\u044F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E",
                            "x-mac-gaelic": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u1E02\xb1\u2264\u2265\u1E03\u010A\u010B\u1E0A\u1E0B\u1E1E\u1E1F\u0120\u0121\u1E40\xe6\xf8\u1E41\u1E56\u1E57\u027C\u0192\u017F\u1E60\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\u1E61\u1E9B\xff\u0178\u1E6A\u20AC\u2039\u203A\u0176\u0177\u1E6B\xb7\u1EF2\u1EF3\u204A\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\u2663\xd2\xda\xdb\xd9\u0131\xdd\xfd\u0174\u0175\u1E84\u1E85\u1E80\u1E81\u1E82\u1E83",
                            "x-mac-greek": "\xc4\xb9\xb2\xc9\xb3\xd6\xdc\u0385\xe0\xe2\xe4\u0384\xa8\xe7\xe9\xe8\xea\xeb\xa3\u2122\xee\xef\u2022\xbd\u2030\xf4\xf6\xa6\u20AC\xf9\xfb\xfc\u2020\u0393\u0394\u0398\u039B\u039E\u03A0\xdf\xae\xa9\u03A3\u03AA\xa7\u2260\xb0\xb7\u0391\xb1\u2264\u2265\xa5\u0392\u0395\u0396\u0397\u0399\u039A\u039C\u03A6\u03AB\u03A8\u03A9\u03AC\u039D\xac\u039F\u03A1\u2248\u03A4\xab\xbb\u2026\xa0\u03A5\u03A7\u0386\u0388\u0153\u2013\u2015\u201C\u201D\u2018\u2019\xf7\u0389\u038A\u038C\u038E\u03AD\u03AE\u03AF\u03CC\u038F\u03CD\u03B1\u03B2\u03C8\u03B4\u03B5\u03C6\u03B3\u03B7\u03B9\u03BE\u03BA\u03BB\u03BC\u03BD\u03BF\u03C0\u03CE\u03C1\u03C3\u03C4\u03B8\u03C9\u03C2\u03C7\u03C5\u03B6\u03CA\u03CB\u0390\u03B0\xad",
                            "x-mac-icelandic": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\xdd\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u03A9\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\u20AC\xd0\xf0\xde\xfe\xfd\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uF8FF\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7",
                            "x-mac-inuit": "\u1403\u1404\u1405\u1406\u140A\u140B\u1431\u1432\u1433\u1434\u1438\u1439\u1449\u144E\u144F\u1450\u1451\u1455\u1456\u1466\u146D\u146E\u146F\u1470\u1472\u1473\u1483\u148B\u148C\u148D\u148E\u1490\u1491\xb0\u14A1\u14A5\u14A6\u2022\xb6\u14A7\xae\xa9\u2122\u14A8\u14AA\u14AB\u14BB\u14C2\u14C3\u14C4\u14C5\u14C7\u14C8\u14D0\u14EF\u14F0\u14F1\u14F2\u14F4\u14F5\u1505\u14D5\u14D6\u14D7\u14D8\u14DA\u14DB\u14EA\u1528\u1529\u152A\u152B\u152D\u2026\xa0\u152E\u153E\u1555\u1556\u1557\u2013\u2014\u201C\u201D\u2018\u2019\u1558\u1559\u155A\u155D\u1546\u1547\u1548\u1549\u154B\u154C\u1550\u157F\u1580\u1581\u1582\u1583\u1584\u1585\u158F\u1590\u1591\u1592\u1593\u1594\u1595\u1671\u1672\u1673\u1674\u1675\u1676\u1596\u15A0\u15A1\u15A2\u15A3\u15A4\u15A5\u15A6\u157C\u0141\u0142",
                            "x-mac-ce": "\xc4\u0100\u0101\xc9\u0104\xd6\xdc\xe1\u0105\u010C\xe4\u010D\u0106\u0107\xe9\u0179\u017A\u010E\xed\u010F\u0112\u0113\u0116\xf3\u0117\xf4\xf6\xf5\xfa\u011A\u011B\xfc\u2020\xb0\u0118\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\u0119\xa8\u2260\u0123\u012E\u012F\u012A\u2264\u2265\u012B\u0136\u2202\u2211\u0142\u013B\u013C\u013D\u013E\u0139\u013A\u0145\u0146\u0143\xac\u221A\u0144\u0147\u2206\xab\xbb\u2026\xa0\u0148\u0150\xd5\u0151\u014C\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\u014D\u0154\u0155\u0158\u2039\u203A\u0159\u0156\u0157\u0160\u201A\u201E\u0161\u015A\u015B\xc1\u0164\u0165\xcd\u017D\u017E\u016A\xd3\xd4\u016B\u016E\xda\u016F\u0170\u0171\u0172\u0173\xdd\xfd\u0137\u017B\u0141\u017C\u0122\u02C7",
                            macintosh: "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u03A9\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\u20AC\u2039\u203A\uFB01\uFB02\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uF8FF\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7",
                            "x-mac-romanian": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\u0102\u0218\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u03A9\u0103\u0219\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\u20AC\u2039\u203A\u021A\u021B\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uF8FF\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7",
                            "x-mac-turkish": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u03A9\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u011E\u011F\u0130\u0131\u015E\u015F\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uF8FF\xd2\xda\xdb\xd9\uF8A0\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
                        }, ae = (m.MACSTRING = function(e1, t, r, o) {
                            var n = ie[o];
                            if (void 0 !== n) {
                                for(var s = "", i = 0; i < r; i++){
                                    var a = e1.getUint8(t + i);
                                    s += a <= 127 ? String.fromCharCode(a) : n[127 & a];
                                }
                                return s;
                            }
                        }, "function" == typeof WeakMap && new WeakMap);
                        function le(e1) {
                            return -128 <= e1 && e1 <= 127;
                        }
                        w.MACSTRING = function(e1, t) {
                            var r = function(e1) {
                                if (!se) for(var t in se = {}, ie)se[t] = new String(t);
                                var r = se[e1];
                                if (void 0 !== r) {
                                    if (ae) {
                                        var o = ae.get(r);
                                        if (void 0 !== o) return o;
                                    }
                                    var n = ie[e1];
                                    if (void 0 !== n) {
                                        for(var s = {}, i = 0; i < n.length; i++)s[n.charCodeAt(i)] = i + 128;
                                        return ae && ae.set(r, s), s;
                                    }
                                }
                            }(t);
                            if (void 0 !== r) {
                                for(var o = [], n = 0; n < e1.length; n++){
                                    var s = e1.charCodeAt(n);
                                    if (128 <= s && void 0 === (s = r[s])) return;
                                    o[n] = s;
                                }
                                return o;
                            }
                        }, l.MACSTRING = function(e1, t) {
                            e1 = w.MACSTRING(e1, t);
                            return void 0 !== e1 ? e1.length : 0;
                        }, w.VARDELTAS = function(e1) {
                            for(var t = 0, r = []; t < e1.length;)var o = e1[t], t = (0 === o ? function(e1, t, r) {
                                for(var o = 0, n = e1.length; t < n && o < 64 && 0 === e1[t];)++t, ++o;
                                return r.push(128 | o - 1), t;
                            } : -128 <= o && o <= 127 ? function(e1, t, r) {
                                for(var o = 0, n = e1.length, s = t; s < n && o < 64;){
                                    var i = e1[s];
                                    if (!le(i)) break;
                                    if (0 === i && s + 1 < n && 0 === e1[s + 1]) break;
                                    ++s, ++o;
                                }
                                r.push(o - 1);
                                for(var a = t; a < s; ++a)r.push(e1[a] + 256 & 255);
                                return s;
                            } : function(e1, t, r) {
                                for(var o = 0, n = e1.length, s = t; s < n && o < 64;){
                                    var i = e1[s];
                                    if (0 === i) break;
                                    if (le(i) && s + 1 < n && le(e1[s + 1])) break;
                                    ++s, ++o;
                                }
                                r.push(64 | o - 1);
                                for(var a = t; a < s; ++a){
                                    var l = e1[a];
                                    r.push(l + 65536 >> 8 & 255, l + 256 & 255);
                                }
                                return s;
                            })(e1, t, r);
                            return r;
                        }, w.INDEX = function(e1) {
                            for(var t = 1, r = [
                                t
                            ], o = [], n = 0; n < e1.length; n += 1){
                                var s = w.OBJECT(e1[n]);
                                Array.prototype.push.apply(o, s), t += s.length, r.push(t);
                            }
                            if (0 === o.length) return [
                                0,
                                0
                            ];
                            for(var i = [], a = 1 + Math.floor(Math.log(t) / Math.log(2)) / 8 | 0, l = [
                                void 0,
                                w.BYTE,
                                w.USHORT,
                                w.UINT24,
                                w.ULONG
                            ][a], u = 0; u < r.length; u += 1){
                                var c = l(r[u]);
                                Array.prototype.push.apply(i, c);
                            }
                            return Array.prototype.concat(w.Card16(e1.length), w.OffSize(a), i, o);
                        }, l.INDEX = function(e1) {
                            return w.INDEX(e1).length;
                        }, w.DICT = function(e1) {
                            for(var t = [], r = Object.keys(e1), o = r.length, n = 0; n < o; n += 1){
                                var s = parseInt(r[n], 0), i = e1[s];
                                t = (t = t.concat(w.OPERAND(i.value, i.type))).concat(w.OPERATOR(s));
                            }
                            return t;
                        }, l.DICT = function(e1) {
                            return w.DICT(e1).length;
                        }, w.OPERATOR = function(e1) {
                            return e1 < 1200 ? [
                                e1
                            ] : [
                                12,
                                e1 - 1200
                            ];
                        }, w.OPERAND = function(e1, t) {
                            var r = [];
                            if (Array.isArray(t)) for(var o = 0; o < t.length; o += 1)L.argument(e1.length === t.length, "Not enough arguments given for type" + t), r = r.concat(w.OPERAND(e1[o], t[o]));
                            else if ("SID" === t) r = r.concat(w.NUMBER(e1));
                            else if ("offset" === t) r = r.concat(w.NUMBER32(e1));
                            else if ("number" === t) r = r.concat(w.NUMBER(e1));
                            else {
                                if ("real" !== t) throw new Error("Unknown operand type " + t);
                                r = r.concat(w.REAL(e1));
                            }
                            return r;
                        }, w.OP = w.BYTE, l.OP = l.BYTE;
                        var ue = "function" == typeof WeakMap && new WeakMap;
                        function n(e1, t, r) {
                            for(var o = 0; o < t.length; o += 1){
                                var n = t[o];
                                this[n.name] = n.value;
                            }
                            if (this.tableName = e1, this.fields = t, r) for(var s = Object.keys(r), i = 0; i < s.length; i += 1){
                                var a = s[i], l = r[a];
                                void 0 !== this[a] && (this[a] = l);
                            }
                        }
                        function ce(e1, t, r) {
                            void 0 === r && (r = t.length);
                            var o = new Array(t.length + 1);
                            o[0] = {
                                name: e1 + "Count",
                                type: "USHORT",
                                value: r
                            };
                            for(var n = 0; n < t.length; n++)o[n + 1] = {
                                name: e1 + n,
                                type: "USHORT",
                                value: t[n]
                            };
                            return o;
                        }
                        function de(e1, t, r) {
                            var o = t.length, n = new Array(o + 1);
                            n[0] = {
                                name: e1 + "Count",
                                type: "USHORT",
                                value: o
                            };
                            for(var s = 0; s < o; s++)n[s + 1] = {
                                name: e1 + s,
                                type: "TABLE",
                                value: r(t[s], s)
                            };
                            return n;
                        }
                        function he(e1, t, r) {
                            var o = t.length, n = [];
                            n[0] = {
                                name: e1 + "Count",
                                type: "USHORT",
                                value: o
                            };
                            for(var s = 0; s < o; s++)n = n.concat(r(t[s], s));
                            return n;
                        }
                        function fe(e1) {
                            1 === e1.format ? n.call(this, "coverageTable", [
                                {
                                    name: "coverageFormat",
                                    type: "USHORT",
                                    value: 1
                                }
                            ].concat(ce("glyph", e1.glyphs))) : L.assert(!1, "Can't create coverage table format 2 yet.");
                        }
                        function pe(e1) {
                            n.call(this, "scriptListTable", he("scriptRecord", e1, function(e1, t) {
                                var r = e1.script, o = r.defaultLangSys;
                                return L.assert(!!o, "Unable to write GSUB: script " + e1.tag + " has no default language system."), [
                                    {
                                        name: "scriptTag" + t,
                                        type: "TAG",
                                        value: e1.tag
                                    },
                                    {
                                        name: "script" + t,
                                        type: "TABLE",
                                        value: new n("scriptTable", [
                                            {
                                                name: "defaultLangSys",
                                                type: "TABLE",
                                                value: new n("defaultLangSys", [
                                                    {
                                                        name: "lookupOrder",
                                                        type: "USHORT",
                                                        value: 0
                                                    },
                                                    {
                                                        name: "reqFeatureIndex",
                                                        type: "USHORT",
                                                        value: o.reqFeatureIndex
                                                    }
                                                ].concat(ce("featureIndex", o.featureIndexes)))
                                            }
                                        ].concat(he("langSys", r.langSysRecords, function(e1, t) {
                                            var r = e1.langSys;
                                            return [
                                                {
                                                    name: "langSysTag" + t,
                                                    type: "TAG",
                                                    value: e1.tag
                                                },
                                                {
                                                    name: "langSys" + t,
                                                    type: "TABLE",
                                                    value: new n("langSys", [
                                                        {
                                                            name: "lookupOrder",
                                                            type: "USHORT",
                                                            value: 0
                                                        },
                                                        {
                                                            name: "reqFeatureIndex",
                                                            type: "USHORT",
                                                            value: r.reqFeatureIndex
                                                        }
                                                    ].concat(ce("featureIndex", r.featureIndexes)))
                                                }
                                            ];
                                        })))
                                    }
                                ];
                            }));
                        }
                        function me(e1) {
                            n.call(this, "featureListTable", he("featureRecord", e1, function(e1, t) {
                                var r = e1.feature;
                                return [
                                    {
                                        name: "featureTag" + t,
                                        type: "TAG",
                                        value: e1.tag
                                    },
                                    {
                                        name: "feature" + t,
                                        type: "TABLE",
                                        value: new n("featureTable", [
                                            {
                                                name: "featureParams",
                                                type: "USHORT",
                                                value: r.featureParams
                                            }
                                        ].concat(ce("lookupListIndex", r.lookupListIndexes)))
                                    }
                                ];
                            }));
                        }
                        function ye(e1, r) {
                            n.call(this, "lookupListTable", de("lookup", e1, function(e1) {
                                var t = r[e1.lookupType];
                                return L.assert(!!t, "Unable to write GSUB lookup type " + e1.lookupType + " tables."), new n("lookupTable", [
                                    {
                                        name: "lookupType",
                                        type: "USHORT",
                                        value: e1.lookupType
                                    },
                                    {
                                        name: "lookupFlag",
                                        type: "USHORT",
                                        value: e1.lookupFlag
                                    }
                                ].concat(de("subtable", e1.subtables, t)));
                            }));
                        }
                        w.CHARSTRING = function(e1) {
                            if (ue) {
                                var t = ue.get(e1);
                                if (void 0 !== t) return t;
                            }
                            for(var r = [], o = e1.length, n = 0; n < o; n += 1)var s = e1[n], r = r.concat(w[s.type](s.value));
                            return ue && ue.set(e1, r), r;
                        }, l.CHARSTRING = function(e1) {
                            return w.CHARSTRING(e1).length;
                        }, w.OBJECT = function(e1) {
                            var t = w[e1.type];
                            return L.argument(void 0 !== t, "No encoding function for type " + e1.type), t(e1.value);
                        }, l.OBJECT = function(e1) {
                            var t = l[e1.type];
                            return L.argument(void 0 !== t, "No sizeOf function for type " + e1.type), t(e1.value);
                        }, w.TABLE = function(e1) {
                            for(var t = [], r = e1.fields.length, o = [], n = [], s = 0; s < r; s += 1){
                                var i = e1.fields[s], a = w[i.type], l = (L.argument(void 0 !== a, "No encoding function for field type " + i.type + " (" + i.name + ")"), e1[i.name]), a = a(l = void 0 === l ? i.value : l);
                                "TABLE" === i.type ? (n.push(t.length), t = t.concat([
                                    0,
                                    0
                                ]), o.push(a)) : t = t.concat(a);
                            }
                            for(var u = 0; u < o.length; u += 1){
                                var c = n[u], d = t.length;
                                L.argument(d < 65536, "Table " + e1.tableName + " too big."), t[c] = d >> 8, t[c + 1] = 255 & d, t = t.concat(o[u]);
                            }
                            return t;
                        }, l.TABLE = function(e1) {
                            for(var t = 0, r = e1.fields.length, o = 0; o < r; o += 1){
                                var n = e1.fields[o], s = l[n.type], i = (L.argument(void 0 !== s, "No sizeOf function for field type " + n.type + " (" + n.name + ")"), e1[n.name]);
                                t += s(i = void 0 === i ? n.value : i), "TABLE" === n.type && (t += 2);
                            }
                            return t;
                        }, w.RECORD = w.TABLE, l.RECORD = l.TABLE, w.LITERAL = function(e1) {
                            return e1;
                        }, l.LITERAL = function(e1) {
                            return e1.length;
                        }, n.prototype.encode = function() {
                            return w.TABLE(this);
                        }, n.prototype.sizeOf = function() {
                            return l.TABLE(this);
                        };
                        var S = {
                            Table: n,
                            Record: n,
                            Coverage: (fe.prototype = Object.create(n.prototype)).constructor = fe,
                            ScriptList: (pe.prototype = Object.create(n.prototype)).constructor = pe,
                            FeatureList: (me.prototype = Object.create(n.prototype)).constructor = me,
                            LookupList: (ye.prototype = Object.create(n.prototype)).constructor = ye,
                            ushortList: ce,
                            tableList: de,
                            recordList: he
                        };
                        function ge(e1, t) {
                            return e1.getUint8(t);
                        }
                        function ve(e1, t) {
                            return e1.getUint16(t, !1);
                        }
                        function be(e1, t) {
                            return e1.getUint32(t, !1);
                        }
                        function _e(e1, t) {
                            return e1.getInt16(t, !1) + e1.getUint16(t + 2, !1) / 65535;
                        }
                        var je = {
                            byte: 1,
                            uShort: 2,
                            short: 2,
                            uLong: 4,
                            fixed: 4,
                            longDateTime: 8,
                            tag: 4
                        };
                        function u(e1, t) {
                            this.data = e1, this.offset = t, this.relativeOffset = 0;
                        }
                        u.prototype.parseByte = function() {
                            var e1 = this.data.getUint8(this.offset + this.relativeOffset);
                            return this.relativeOffset += 1, e1;
                        }, u.prototype.parseChar = function() {
                            var e1 = this.data.getInt8(this.offset + this.relativeOffset);
                            return this.relativeOffset += 1, e1;
                        }, u.prototype.parseCard8 = u.prototype.parseByte, u.prototype.parseCard16 = u.prototype.parseUShort = function() {
                            var e1 = this.data.getUint16(this.offset + this.relativeOffset);
                            return this.relativeOffset += 2, e1;
                        }, u.prototype.parseSID = u.prototype.parseUShort, u.prototype.parseOffset16 = u.prototype.parseUShort, u.prototype.parseShort = function() {
                            var e1 = this.data.getInt16(this.offset + this.relativeOffset);
                            return this.relativeOffset += 2, e1;
                        }, u.prototype.parseF2Dot14 = function() {
                            var e1 = this.data.getInt16(this.offset + this.relativeOffset) / 16384;
                            return this.relativeOffset += 2, e1;
                        }, u.prototype.parseOffset32 = u.prototype.parseULong = function() {
                            var e1 = be(this.data, this.offset + this.relativeOffset);
                            return this.relativeOffset += 4, e1;
                        }, u.prototype.parseFixed = function() {
                            var e1 = _e(this.data, this.offset + this.relativeOffset);
                            return this.relativeOffset += 4, e1;
                        }, u.prototype.parseString = function(e1) {
                            var t = this.data, r = this.offset + this.relativeOffset, o = "";
                            this.relativeOffset += e1;
                            for(var n = 0; n < e1; n++)o += String.fromCharCode(t.getUint8(r + n));
                            return o;
                        }, u.prototype.parseTag = function() {
                            return this.parseString(4);
                        }, u.prototype.parseLongDateTime = function() {
                            var e1 = be(this.data, this.offset + this.relativeOffset + 4);
                            return e1 -= 2082844800, this.relativeOffset += 8, e1;
                        }, u.prototype.parseVersion = function(e1) {
                            var t = ve(this.data, this.offset + this.relativeOffset), r = ve(this.data, this.offset + this.relativeOffset + 2);
                            return this.relativeOffset += 4, t + r / (e1 = void 0 === e1 ? 4096 : e1) / 10;
                        }, u.prototype.skip = function(e1, t) {
                            this.relativeOffset += je[e1] * (t = void 0 === t ? 1 : t);
                        }, u.prototype.parseULongList = function(e1) {
                            void 0 === e1 && (e1 = this.parseULong());
                            for(var t = new Array(e1), r = this.data, o = this.offset + this.relativeOffset, n = 0; n < e1; n++)t[n] = r.getUint32(o), o += 4;
                            return this.relativeOffset += 4 * e1, t;
                        }, u.prototype.parseOffset16List = u.prototype.parseUShortList = function(e1) {
                            void 0 === e1 && (e1 = this.parseUShort());
                            for(var t = new Array(e1), r = this.data, o = this.offset + this.relativeOffset, n = 0; n < e1; n++)t[n] = r.getUint16(o), o += 2;
                            return this.relativeOffset += 2 * e1, t;
                        }, u.prototype.parseShortList = function(e1) {
                            for(var t = new Array(e1), r = this.data, o = this.offset + this.relativeOffset, n = 0; n < e1; n++)t[n] = r.getInt16(o), o += 2;
                            return this.relativeOffset += 2 * e1, t;
                        }, u.prototype.parseByteList = function(e1) {
                            for(var t = new Array(e1), r = this.data, o = this.offset + this.relativeOffset, n = 0; n < e1; n++)t[n] = r.getUint8(o++);
                            return this.relativeOffset += e1, t;
                        }, u.prototype.parseList = function(e1, t) {
                            t || (t = e1, e1 = this.parseUShort());
                            for(var r = new Array(e1), o = 0; o < e1; o++)r[o] = t.call(this);
                            return r;
                        }, u.prototype.parseList32 = function(e1, t) {
                            t || (t = e1, e1 = this.parseULong());
                            for(var r = new Array(e1), o = 0; o < e1; o++)r[o] = t.call(this);
                            return r;
                        }, u.prototype.parseRecordList = function(e1, t) {
                            t || (t = e1, e1 = this.parseUShort());
                            for(var r = new Array(e1), o = Object.keys(t), n = 0; n < e1; n++){
                                for(var s = {}, i = 0; i < o.length; i++){
                                    var a = o[i], l = t[a];
                                    s[a] = l.call(this);
                                }
                                r[n] = s;
                            }
                            return r;
                        }, u.prototype.parseRecordList32 = function(e1, t) {
                            t || (t = e1, e1 = this.parseULong());
                            for(var r = new Array(e1), o = Object.keys(t), n = 0; n < e1; n++){
                                for(var s = {}, i = 0; i < o.length; i++){
                                    var a = o[i], l = t[a];
                                    s[a] = l.call(this);
                                }
                                r[n] = s;
                            }
                            return r;
                        }, u.prototype.parseStruct = function(e1) {
                            if ("function" == typeof e1) return e1.call(this);
                            for(var t = Object.keys(e1), r = {}, o = 0; o < t.length; o++){
                                var n = t[o], s = e1[n];
                                r[n] = s.call(this);
                            }
                            return r;
                        }, u.prototype.parseValueRecord = function(e1) {
                            var t;
                            if (0 !== (e1 = void 0 === e1 ? this.parseUShort() : e1)) return t = {}, 1 & e1 && (t.xPlacement = this.parseShort()), 2 & e1 && (t.yPlacement = this.parseShort()), 4 & e1 && (t.xAdvance = this.parseShort()), 8 & e1 && (t.yAdvance = this.parseShort()), 16 & e1 && (t.xPlaDevice = void 0, this.parseShort()), 32 & e1 && (t.yPlaDevice = void 0, this.parseShort()), 64 & e1 && (t.xAdvDevice = void 0, this.parseShort()), 128 & e1 && (t.yAdvDevice = void 0, this.parseShort()), t;
                        }, u.prototype.parseValueRecordList = function() {
                            for(var e1 = this.parseUShort(), t = this.parseUShort(), r = new Array(t), o = 0; o < t; o++)r[o] = this.parseValueRecord(e1);
                            return r;
                        }, u.prototype.parsePointer = function(e1) {
                            var t = this.parseOffset16();
                            if (0 < t) return new u(this.data, this.offset + t).parseStruct(e1);
                        }, u.prototype.parsePointer32 = function(e1) {
                            var t = this.parseOffset32();
                            if (0 < t) return new u(this.data, this.offset + t).parseStruct(e1);
                        }, u.prototype.parseListOfLists = function(e1) {
                            for(var t = this.parseOffset16List(), r = t.length, o = this.relativeOffset, n = new Array(r), s = 0; s < r; s++){
                                var i = t[s];
                                if (0 === i) n[s] = void 0;
                                else if (this.relativeOffset = i, e1) {
                                    for(var a = this.parseOffset16List(), l = new Array(a.length), u = 0; u < a.length; u++)this.relativeOffset = i + a[u], l[u] = e1.call(this);
                                    n[s] = l;
                                } else n[s] = this.parseUShortList();
                            }
                            return this.relativeOffset = o, n;
                        }, u.prototype.parseCoverage = function() {
                            var e1 = this.offset + this.relativeOffset, t = this.parseUShort(), r = this.parseUShort();
                            if (1 === t) return {
                                format: 1,
                                glyphs: this.parseUShortList(r)
                            };
                            if (2 !== t) throw new Error("0x" + e1.toString(16) + ": Coverage format must be 1 or 2.");
                            for(var o = new Array(r), n = 0; n < r; n++)o[n] = {
                                start: this.parseUShort(),
                                end: this.parseUShort(),
                                index: this.parseUShort()
                            };
                            return {
                                format: 2,
                                ranges: o
                            };
                        }, u.prototype.parseClassDef = function() {
                            var e1 = this.offset + this.relativeOffset, t = this.parseUShort();
                            if (1 === t) return {
                                format: 1,
                                startGlyph: this.parseUShort(),
                                classes: this.parseUShortList()
                            };
                            if (2 === t) return {
                                format: 2,
                                ranges: this.parseRecordList({
                                    start: u.uShort,
                                    end: u.uShort,
                                    classId: u.uShort
                                })
                            };
                            throw new Error("0x" + e1.toString(16) + ": ClassDef format must be 1 or 2.");
                        }, u.list = function(e1, t) {
                            return function() {
                                return this.parseList(e1, t);
                            };
                        }, u.list32 = function(e1, t) {
                            return function() {
                                return this.parseList32(e1, t);
                            };
                        }, u.recordList = function(e1, t) {
                            return function() {
                                return this.parseRecordList(e1, t);
                            };
                        }, u.recordList32 = function(e1, t) {
                            return function() {
                                return this.parseRecordList32(e1, t);
                            };
                        }, u.pointer = function(e1) {
                            return function() {
                                return this.parsePointer(e1);
                            };
                        }, u.pointer32 = function(e1) {
                            return function() {
                                return this.parsePointer32(e1);
                            };
                        }, u.tag = u.prototype.parseTag, u.byte = u.prototype.parseByte, u.uShort = u.offset16 = u.prototype.parseUShort, u.uShortList = u.prototype.parseUShortList, u.uLong = u.offset32 = u.prototype.parseULong, u.uLongList = u.prototype.parseULongList, u.struct = u.prototype.parseStruct, u.coverage = u.prototype.parseCoverage, u.classDef = u.prototype.parseClassDef;
                        var xe = {
                            reserved: u.uShort,
                            reqFeatureIndex: u.uShort,
                            featureIndexes: u.uShortList
                        }, R = (u.prototype.parseScriptList = function() {
                            return this.parsePointer(u.recordList({
                                tag: u.tag,
                                script: u.pointer({
                                    defaultLangSys: u.pointer(xe),
                                    langSysRecords: u.recordList({
                                        tag: u.tag,
                                        langSys: u.pointer(xe)
                                    })
                                })
                            })) || [];
                        }, u.prototype.parseFeatureList = function() {
                            return this.parsePointer(u.recordList({
                                tag: u.tag,
                                feature: u.pointer({
                                    featureParams: u.offset16,
                                    lookupListIndexes: u.uShortList
                                })
                            })) || [];
                        }, u.prototype.parseLookupList = function(o) {
                            return this.parsePointer(u.list(u.pointer(function() {
                                var e1 = this.parseUShort(), t = (L.argument(1 <= e1 && e1 <= 9, "GPOS/GSUB lookup type " + e1 + " unknown."), this.parseUShort()), r = 16 & t;
                                return {
                                    lookupType: e1,
                                    lookupFlag: t,
                                    subtables: this.parseList(u.pointer(o[e1])),
                                    markFilteringSet: r ? this.parseUShort() : void 0
                                };
                            }))) || [];
                        }, u.prototype.parseFeatureVariationsList = function() {
                            return this.parsePointer32(function() {
                                var e1 = this.parseUShort(), t = this.parseUShort();
                                return L.argument(1 === e1 && t < 1, "GPOS/GSUB feature variations table unknown."), this.parseRecordList32({
                                    conditionSetOffset: u.offset32,
                                    featureTableSubstitutionOffset: u.offset32
                                });
                            }) || [];
                        }, {
                            getByte: ge,
                            getCard8: ge,
                            getUShort: ve,
                            getCard16: ve,
                            getShort: function(e1, t) {
                                return e1.getInt16(t, !1);
                            },
                            getULong: be,
                            getFixed: _e,
                            getTag: function(e1, t) {
                                for(var r = "", o = t; o < t + 4; o += 1)r += String.fromCharCode(e1.getInt8(o));
                                return r;
                            },
                            getOffset: function(e1, t, r) {
                                for(var o = 0, n = 0; n < r; n += 1)o = (o <<= 8) + e1.getUint8(t + n);
                                return o;
                            },
                            getBytes: function(e1, t, r) {
                                for(var o = [], n = t; n < r; n += 1)o.push(e1.getUint8(n));
                                return o;
                            },
                            bytesToString: function(e1) {
                                for(var t = "", r = 0; r < e1.length; r += 1)t += String.fromCharCode(e1[r]);
                                return t;
                            },
                            Parser: u
                        });
                        var we = {
                            parse: function(e1, t) {
                                for(var r = {}, o = (r.version = R.getUShort(e1, t), L.argument(0 === r.version, "cmap table version should be 0."), r.numTables = R.getUShort(e1, t + 2), -1), n = r.numTables - 1; 0 <= n; --n){
                                    var s = R.getUShort(e1, t + 4 + 8 * n), i = R.getUShort(e1, t + 4 + 8 * n + 2);
                                    if (3 === s && (0 === i || 1 === i || 10 === i) || 0 === s && (0 === i || 1 === i || 2 === i || 3 === i || 4 === i)) {
                                        o = R.getULong(e1, t + 4 + 8 * n + 4);
                                        break;
                                    }
                                }
                                if (-1 === o) throw new Error("No valid cmap sub-tables found.");
                                var a = new R.Parser(e1, t + o);
                                if (r.format = a.parseUShort(), 12 === r.format) {
                                    var l, u = r, c = a;
                                    c.parseUShort(), u.length = c.parseULong(), u.language = c.parseULong(), u.groupCount = l = c.parseULong(), u.glyphIndexMap = {};
                                    for(var d = 0; d < l; d += 1)for(var h = c.parseULong(), f = c.parseULong(), p = c.parseULong(), m = h; m <= f; m += 1)u.glyphIndexMap[m] = p, p++;
                                } else {
                                    if (4 !== r.format) throw new Error("Only format 4 and 12 cmap tables are supported (found format " + r.format + ").");
                                    var y = r, g = e1, v = t, b = o;
                                    y.length = a.parseUShort(), y.language = a.parseUShort(), y.segCount = _ = a.parseUShort() >> 1, a.skip("uShort", 3), y.glyphIndexMap = {};
                                    for(var _, j = new R.Parser(g, v + b + 14), x = new R.Parser(g, v + b + 16 + 2 * _), w = new R.Parser(g, v + b + 16 + 4 * _), S = new R.Parser(g, v + b + 16 + 6 * _), T = v + b + 16 + 8 * _, E = 0; E < _ - 1; E += 1)for(var M = void 0, k = j.parseUShort(), O = x.parseUShort(), C = w.parseShort(), P = S.parseUShort(), A = O; A <= k; A += 1)0 !== P ? (T = (T = S.offset + S.relativeOffset - 2) + P + 2 * (A - O), 0 !== (M = R.getUShort(g, T)) && (M = M + C & 65535)) : M = A + C & 65535, y.glyphIndexMap[A] = M;
                                }
                                return r;
                            },
                            make: function(e1) {
                                for(var t = !0, r = e1.length - 1; 0 < r; --r)if (65535 < e1.get(r).unicode) {
                                    console.log("Adding CMAP format 12 (needed!)"), t = !1;
                                    break;
                                }
                                var o, n, s = [
                                    {
                                        name: "version",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "numTables",
                                        type: "USHORT",
                                        value: t ? 1 : 2
                                    },
                                    {
                                        name: "platformID",
                                        type: "USHORT",
                                        value: 3
                                    },
                                    {
                                        name: "encodingID",
                                        type: "USHORT",
                                        value: 1
                                    },
                                    {
                                        name: "offset",
                                        type: "ULONG",
                                        value: t ? 12 : 20
                                    }
                                ], i = (s = (s = t ? s : s.concat([
                                    {
                                        name: "cmap12PlatformID",
                                        type: "USHORT",
                                        value: 3
                                    },
                                    {
                                        name: "cmap12EncodingID",
                                        type: "USHORT",
                                        value: 10
                                    },
                                    {
                                        name: "cmap12Offset",
                                        type: "ULONG",
                                        value: 0
                                    }
                                ])).concat([
                                    {
                                        name: "format",
                                        type: "USHORT",
                                        value: 4
                                    },
                                    {
                                        name: "cmap4Length",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "language",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "segCountX2",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "searchRange",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "entrySelector",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "rangeShift",
                                        type: "USHORT",
                                        value: 0
                                    }
                                ]), new S.Table("cmap", s));
                                for(i.segments = [], r = 0; r < e1.length; r += 1){
                                    for(var a = e1.get(r), l = 0; l < a.unicodes.length; l += 1)o = a.unicodes[l], n = r, i.segments.push({
                                        end: o,
                                        start: o,
                                        delta: -(o - n),
                                        offset: 0,
                                        glyphIndex: n
                                    });
                                    i.segments = i.segments.sort(function(e1, t) {
                                        return e1.start - t.start;
                                    });
                                }
                                i.segments.push({
                                    end: 65535,
                                    start: 65535,
                                    delta: 1,
                                    offset: 0
                                });
                                var u = i.segments.length, c = 0, d = [], h = [], f = [], p = [], m = [], y = [];
                                for(r = 0; r < u; r += 1){
                                    var g = i.segments[r];
                                    g.end <= 65535 && g.start <= 65535 ? (d = d.concat({
                                        name: "end_" + r,
                                        type: "USHORT",
                                        value: g.end
                                    }), h = h.concat({
                                        name: "start_" + r,
                                        type: "USHORT",
                                        value: g.start
                                    }), f = f.concat({
                                        name: "idDelta_" + r,
                                        type: "SHORT",
                                        value: g.delta
                                    }), p = p.concat({
                                        name: "idRangeOffset_" + r,
                                        type: "USHORT",
                                        value: g.offset
                                    }), void 0 !== g.glyphId && (m = m.concat({
                                        name: "glyph_" + r,
                                        type: "USHORT",
                                        value: g.glyphId
                                    }))) : c += 1, t || void 0 === g.glyphIndex || (y = (y = (y = y.concat({
                                        name: "cmap12Start_" + r,
                                        type: "ULONG",
                                        value: g.start
                                    })).concat({
                                        name: "cmap12End_" + r,
                                        type: "ULONG",
                                        value: g.end
                                    })).concat({
                                        name: "cmap12Glyph_" + r,
                                        type: "ULONG",
                                        value: g.glyphIndex
                                    }));
                                }
                                return i.segCountX2 = 2 * (u - c), i.searchRange = 2 * Math.pow(2, Math.floor(Math.log(u - c) / Math.log(2))), i.entrySelector = Math.log(i.searchRange / 2) / Math.log(2), i.rangeShift = i.segCountX2 - i.searchRange, i.fields = i.fields.concat(d), i.fields.push({
                                    name: "reservedPad",
                                    type: "USHORT",
                                    value: 0
                                }), i.fields = i.fields.concat(h), i.fields = i.fields.concat(f), i.fields = i.fields.concat(p), i.fields = i.fields.concat(m), i.cmap4Length = 14 + 2 * d.length + 2 + 2 * h.length + 2 * f.length + 2 * p.length + 2 * m.length, t || (s = 16 + 4 * y.length, i.cmap12Offset = 20 + i.cmap4Length, i.fields = i.fields.concat([
                                    {
                                        name: "cmap12Format",
                                        type: "USHORT",
                                        value: 12
                                    },
                                    {
                                        name: "cmap12Reserved",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "cmap12Length",
                                        type: "ULONG",
                                        value: s
                                    },
                                    {
                                        name: "cmap12Language",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "cmap12nGroups",
                                        type: "ULONG",
                                        value: y.length / 3
                                    }
                                ]), i.fields = i.fields.concat(y)), i;
                            }
                        }, Se = [
                            ".notdef",
                            "space",
                            "exclam",
                            "quotedbl",
                            "numbersign",
                            "dollar",
                            "percent",
                            "ampersand",
                            "quoteright",
                            "parenleft",
                            "parenright",
                            "asterisk",
                            "plus",
                            "comma",
                            "hyphen",
                            "period",
                            "slash",
                            "zero",
                            "one",
                            "two",
                            "three",
                            "four",
                            "five",
                            "six",
                            "seven",
                            "eight",
                            "nine",
                            "colon",
                            "semicolon",
                            "less",
                            "equal",
                            "greater",
                            "question",
                            "at",
                            "A",
                            "B",
                            "C",
                            "D",
                            "E",
                            "F",
                            "G",
                            "H",
                            "I",
                            "J",
                            "K",
                            "L",
                            "M",
                            "N",
                            "O",
                            "P",
                            "Q",
                            "R",
                            "S",
                            "T",
                            "U",
                            "V",
                            "W",
                            "X",
                            "Y",
                            "Z",
                            "bracketleft",
                            "backslash",
                            "bracketright",
                            "asciicircum",
                            "underscore",
                            "quoteleft",
                            "a",
                            "b",
                            "c",
                            "d",
                            "e",
                            "f",
                            "g",
                            "h",
                            "i",
                            "j",
                            "k",
                            "l",
                            "m",
                            "n",
                            "o",
                            "p",
                            "q",
                            "r",
                            "s",
                            "t",
                            "u",
                            "v",
                            "w",
                            "x",
                            "y",
                            "z",
                            "braceleft",
                            "bar",
                            "braceright",
                            "asciitilde",
                            "exclamdown",
                            "cent",
                            "sterling",
                            "fraction",
                            "yen",
                            "florin",
                            "section",
                            "currency",
                            "quotesingle",
                            "quotedblleft",
                            "guillemotleft",
                            "guilsinglleft",
                            "guilsinglright",
                            "fi",
                            "fl",
                            "endash",
                            "dagger",
                            "daggerdbl",
                            "periodcentered",
                            "paragraph",
                            "bullet",
                            "quotesinglbase",
                            "quotedblbase",
                            "quotedblright",
                            "guillemotright",
                            "ellipsis",
                            "perthousand",
                            "questiondown",
                            "grave",
                            "acute",
                            "circumflex",
                            "tilde",
                            "macron",
                            "breve",
                            "dotaccent",
                            "dieresis",
                            "ring",
                            "cedilla",
                            "hungarumlaut",
                            "ogonek",
                            "caron",
                            "emdash",
                            "AE",
                            "ordfeminine",
                            "Lslash",
                            "Oslash",
                            "OE",
                            "ordmasculine",
                            "ae",
                            "dotlessi",
                            "lslash",
                            "oslash",
                            "oe",
                            "germandbls",
                            "onesuperior",
                            "logicalnot",
                            "mu",
                            "trademark",
                            "Eth",
                            "onehalf",
                            "plusminus",
                            "Thorn",
                            "onequarter",
                            "divide",
                            "brokenbar",
                            "degree",
                            "thorn",
                            "threequarters",
                            "twosuperior",
                            "registered",
                            "minus",
                            "eth",
                            "multiply",
                            "threesuperior",
                            "copyright",
                            "Aacute",
                            "Acircumflex",
                            "Adieresis",
                            "Agrave",
                            "Aring",
                            "Atilde",
                            "Ccedilla",
                            "Eacute",
                            "Ecircumflex",
                            "Edieresis",
                            "Egrave",
                            "Iacute",
                            "Icircumflex",
                            "Idieresis",
                            "Igrave",
                            "Ntilde",
                            "Oacute",
                            "Ocircumflex",
                            "Odieresis",
                            "Ograve",
                            "Otilde",
                            "Scaron",
                            "Uacute",
                            "Ucircumflex",
                            "Udieresis",
                            "Ugrave",
                            "Yacute",
                            "Ydieresis",
                            "Zcaron",
                            "aacute",
                            "acircumflex",
                            "adieresis",
                            "agrave",
                            "aring",
                            "atilde",
                            "ccedilla",
                            "eacute",
                            "ecircumflex",
                            "edieresis",
                            "egrave",
                            "iacute",
                            "icircumflex",
                            "idieresis",
                            "igrave",
                            "ntilde",
                            "oacute",
                            "ocircumflex",
                            "odieresis",
                            "ograve",
                            "otilde",
                            "scaron",
                            "uacute",
                            "ucircumflex",
                            "udieresis",
                            "ugrave",
                            "yacute",
                            "ydieresis",
                            "zcaron",
                            "exclamsmall",
                            "Hungarumlautsmall",
                            "dollaroldstyle",
                            "dollarsuperior",
                            "ampersandsmall",
                            "Acutesmall",
                            "parenleftsuperior",
                            "parenrightsuperior",
                            "266 ff",
                            "onedotenleader",
                            "zerooldstyle",
                            "oneoldstyle",
                            "twooldstyle",
                            "threeoldstyle",
                            "fouroldstyle",
                            "fiveoldstyle",
                            "sixoldstyle",
                            "sevenoldstyle",
                            "eightoldstyle",
                            "nineoldstyle",
                            "commasuperior",
                            "threequartersemdash",
                            "periodsuperior",
                            "questionsmall",
                            "asuperior",
                            "bsuperior",
                            "centsuperior",
                            "dsuperior",
                            "esuperior",
                            "isuperior",
                            "lsuperior",
                            "msuperior",
                            "nsuperior",
                            "osuperior",
                            "rsuperior",
                            "ssuperior",
                            "tsuperior",
                            "ff",
                            "ffi",
                            "ffl",
                            "parenleftinferior",
                            "parenrightinferior",
                            "Circumflexsmall",
                            "hyphensuperior",
                            "Gravesmall",
                            "Asmall",
                            "Bsmall",
                            "Csmall",
                            "Dsmall",
                            "Esmall",
                            "Fsmall",
                            "Gsmall",
                            "Hsmall",
                            "Ismall",
                            "Jsmall",
                            "Ksmall",
                            "Lsmall",
                            "Msmall",
                            "Nsmall",
                            "Osmall",
                            "Psmall",
                            "Qsmall",
                            "Rsmall",
                            "Ssmall",
                            "Tsmall",
                            "Usmall",
                            "Vsmall",
                            "Wsmall",
                            "Xsmall",
                            "Ysmall",
                            "Zsmall",
                            "colonmonetary",
                            "onefitted",
                            "rupiah",
                            "Tildesmall",
                            "exclamdownsmall",
                            "centoldstyle",
                            "Lslashsmall",
                            "Scaronsmall",
                            "Zcaronsmall",
                            "Dieresissmall",
                            "Brevesmall",
                            "Caronsmall",
                            "Dotaccentsmall",
                            "Macronsmall",
                            "figuredash",
                            "hypheninferior",
                            "Ogoneksmall",
                            "Ringsmall",
                            "Cedillasmall",
                            "questiondownsmall",
                            "oneeighth",
                            "threeeighths",
                            "fiveeighths",
                            "seveneighths",
                            "onethird",
                            "twothirds",
                            "zerosuperior",
                            "foursuperior",
                            "fivesuperior",
                            "sixsuperior",
                            "sevensuperior",
                            "eightsuperior",
                            "ninesuperior",
                            "zeroinferior",
                            "oneinferior",
                            "twoinferior",
                            "threeinferior",
                            "fourinferior",
                            "fiveinferior",
                            "sixinferior",
                            "seveninferior",
                            "eightinferior",
                            "nineinferior",
                            "centinferior",
                            "dollarinferior",
                            "periodinferior",
                            "commainferior",
                            "Agravesmall",
                            "Aacutesmall",
                            "Acircumflexsmall",
                            "Atildesmall",
                            "Adieresissmall",
                            "Aringsmall",
                            "AEsmall",
                            "Ccedillasmall",
                            "Egravesmall",
                            "Eacutesmall",
                            "Ecircumflexsmall",
                            "Edieresissmall",
                            "Igravesmall",
                            "Iacutesmall",
                            "Icircumflexsmall",
                            "Idieresissmall",
                            "Ethsmall",
                            "Ntildesmall",
                            "Ogravesmall",
                            "Oacutesmall",
                            "Ocircumflexsmall",
                            "Otildesmall",
                            "Odieresissmall",
                            "OEsmall",
                            "Oslashsmall",
                            "Ugravesmall",
                            "Uacutesmall",
                            "Ucircumflexsmall",
                            "Udieresissmall",
                            "Yacutesmall",
                            "Thornsmall",
                            "Ydieresissmall",
                            "001.000",
                            "001.001",
                            "001.002",
                            "001.003",
                            "Black",
                            "Bold",
                            "Book",
                            "Light",
                            "Medium",
                            "Regular",
                            "Roman",
                            "Semibold"
                        ], Te = [
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "space",
                            "exclam",
                            "quotedbl",
                            "numbersign",
                            "dollar",
                            "percent",
                            "ampersand",
                            "quoteright",
                            "parenleft",
                            "parenright",
                            "asterisk",
                            "plus",
                            "comma",
                            "hyphen",
                            "period",
                            "slash",
                            "zero",
                            "one",
                            "two",
                            "three",
                            "four",
                            "five",
                            "six",
                            "seven",
                            "eight",
                            "nine",
                            "colon",
                            "semicolon",
                            "less",
                            "equal",
                            "greater",
                            "question",
                            "at",
                            "A",
                            "B",
                            "C",
                            "D",
                            "E",
                            "F",
                            "G",
                            "H",
                            "I",
                            "J",
                            "K",
                            "L",
                            "M",
                            "N",
                            "O",
                            "P",
                            "Q",
                            "R",
                            "S",
                            "T",
                            "U",
                            "V",
                            "W",
                            "X",
                            "Y",
                            "Z",
                            "bracketleft",
                            "backslash",
                            "bracketright",
                            "asciicircum",
                            "underscore",
                            "quoteleft",
                            "a",
                            "b",
                            "c",
                            "d",
                            "e",
                            "f",
                            "g",
                            "h",
                            "i",
                            "j",
                            "k",
                            "l",
                            "m",
                            "n",
                            "o",
                            "p",
                            "q",
                            "r",
                            "s",
                            "t",
                            "u",
                            "v",
                            "w",
                            "x",
                            "y",
                            "z",
                            "braceleft",
                            "bar",
                            "braceright",
                            "asciitilde",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "exclamdown",
                            "cent",
                            "sterling",
                            "fraction",
                            "yen",
                            "florin",
                            "section",
                            "currency",
                            "quotesingle",
                            "quotedblleft",
                            "guillemotleft",
                            "guilsinglleft",
                            "guilsinglright",
                            "fi",
                            "fl",
                            "",
                            "endash",
                            "dagger",
                            "daggerdbl",
                            "periodcentered",
                            "",
                            "paragraph",
                            "bullet",
                            "quotesinglbase",
                            "quotedblbase",
                            "quotedblright",
                            "guillemotright",
                            "ellipsis",
                            "perthousand",
                            "",
                            "questiondown",
                            "",
                            "grave",
                            "acute",
                            "circumflex",
                            "tilde",
                            "macron",
                            "breve",
                            "dotaccent",
                            "dieresis",
                            "",
                            "ring",
                            "cedilla",
                            "",
                            "hungarumlaut",
                            "ogonek",
                            "caron",
                            "emdash",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "AE",
                            "",
                            "ordfeminine",
                            "",
                            "",
                            "",
                            "",
                            "Lslash",
                            "Oslash",
                            "OE",
                            "ordmasculine",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "ae",
                            "",
                            "",
                            "",
                            "dotlessi",
                            "",
                            "",
                            "lslash",
                            "oslash",
                            "oe",
                            "germandbls"
                        ], Ee = [
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "space",
                            "exclamsmall",
                            "Hungarumlautsmall",
                            "",
                            "dollaroldstyle",
                            "dollarsuperior",
                            "ampersandsmall",
                            "Acutesmall",
                            "parenleftsuperior",
                            "parenrightsuperior",
                            "twodotenleader",
                            "onedotenleader",
                            "comma",
                            "hyphen",
                            "period",
                            "fraction",
                            "zerooldstyle",
                            "oneoldstyle",
                            "twooldstyle",
                            "threeoldstyle",
                            "fouroldstyle",
                            "fiveoldstyle",
                            "sixoldstyle",
                            "sevenoldstyle",
                            "eightoldstyle",
                            "nineoldstyle",
                            "colon",
                            "semicolon",
                            "commasuperior",
                            "threequartersemdash",
                            "periodsuperior",
                            "questionsmall",
                            "",
                            "asuperior",
                            "bsuperior",
                            "centsuperior",
                            "dsuperior",
                            "esuperior",
                            "",
                            "",
                            "isuperior",
                            "",
                            "",
                            "lsuperior",
                            "msuperior",
                            "nsuperior",
                            "osuperior",
                            "",
                            "",
                            "rsuperior",
                            "ssuperior",
                            "tsuperior",
                            "",
                            "ff",
                            "fi",
                            "fl",
                            "ffi",
                            "ffl",
                            "parenleftinferior",
                            "",
                            "parenrightinferior",
                            "Circumflexsmall",
                            "hyphensuperior",
                            "Gravesmall",
                            "Asmall",
                            "Bsmall",
                            "Csmall",
                            "Dsmall",
                            "Esmall",
                            "Fsmall",
                            "Gsmall",
                            "Hsmall",
                            "Ismall",
                            "Jsmall",
                            "Ksmall",
                            "Lsmall",
                            "Msmall",
                            "Nsmall",
                            "Osmall",
                            "Psmall",
                            "Qsmall",
                            "Rsmall",
                            "Ssmall",
                            "Tsmall",
                            "Usmall",
                            "Vsmall",
                            "Wsmall",
                            "Xsmall",
                            "Ysmall",
                            "Zsmall",
                            "colonmonetary",
                            "onefitted",
                            "rupiah",
                            "Tildesmall",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "exclamdownsmall",
                            "centoldstyle",
                            "Lslashsmall",
                            "",
                            "",
                            "Scaronsmall",
                            "Zcaronsmall",
                            "Dieresissmall",
                            "Brevesmall",
                            "Caronsmall",
                            "",
                            "Dotaccentsmall",
                            "",
                            "",
                            "Macronsmall",
                            "",
                            "",
                            "figuredash",
                            "hypheninferior",
                            "",
                            "",
                            "Ogoneksmall",
                            "Ringsmall",
                            "Cedillasmall",
                            "",
                            "",
                            "",
                            "onequarter",
                            "onehalf",
                            "threequarters",
                            "questiondownsmall",
                            "oneeighth",
                            "threeeighths",
                            "fiveeighths",
                            "seveneighths",
                            "onethird",
                            "twothirds",
                            "",
                            "",
                            "zerosuperior",
                            "onesuperior",
                            "twosuperior",
                            "threesuperior",
                            "foursuperior",
                            "fivesuperior",
                            "sixsuperior",
                            "sevensuperior",
                            "eightsuperior",
                            "ninesuperior",
                            "zeroinferior",
                            "oneinferior",
                            "twoinferior",
                            "threeinferior",
                            "fourinferior",
                            "fiveinferior",
                            "sixinferior",
                            "seveninferior",
                            "eightinferior",
                            "nineinferior",
                            "centinferior",
                            "dollarinferior",
                            "periodinferior",
                            "commainferior",
                            "Agravesmall",
                            "Aacutesmall",
                            "Acircumflexsmall",
                            "Atildesmall",
                            "Adieresissmall",
                            "Aringsmall",
                            "AEsmall",
                            "Ccedillasmall",
                            "Egravesmall",
                            "Eacutesmall",
                            "Ecircumflexsmall",
                            "Edieresissmall",
                            "Igravesmall",
                            "Iacutesmall",
                            "Icircumflexsmall",
                            "Idieresissmall",
                            "Ethsmall",
                            "Ntildesmall",
                            "Ogravesmall",
                            "Oacutesmall",
                            "Ocircumflexsmall",
                            "Otildesmall",
                            "Odieresissmall",
                            "OEsmall",
                            "Oslashsmall",
                            "Ugravesmall",
                            "Uacutesmall",
                            "Ucircumflexsmall",
                            "Udieresissmall",
                            "Yacutesmall",
                            "Thornsmall",
                            "Ydieresissmall"
                        ], c = [
                            ".notdef",
                            ".null",
                            "nonmarkingreturn",
                            "space",
                            "exclam",
                            "quotedbl",
                            "numbersign",
                            "dollar",
                            "percent",
                            "ampersand",
                            "quotesingle",
                            "parenleft",
                            "parenright",
                            "asterisk",
                            "plus",
                            "comma",
                            "hyphen",
                            "period",
                            "slash",
                            "zero",
                            "one",
                            "two",
                            "three",
                            "four",
                            "five",
                            "six",
                            "seven",
                            "eight",
                            "nine",
                            "colon",
                            "semicolon",
                            "less",
                            "equal",
                            "greater",
                            "question",
                            "at",
                            "A",
                            "B",
                            "C",
                            "D",
                            "E",
                            "F",
                            "G",
                            "H",
                            "I",
                            "J",
                            "K",
                            "L",
                            "M",
                            "N",
                            "O",
                            "P",
                            "Q",
                            "R",
                            "S",
                            "T",
                            "U",
                            "V",
                            "W",
                            "X",
                            "Y",
                            "Z",
                            "bracketleft",
                            "backslash",
                            "bracketright",
                            "asciicircum",
                            "underscore",
                            "grave",
                            "a",
                            "b",
                            "c",
                            "d",
                            "e",
                            "f",
                            "g",
                            "h",
                            "i",
                            "j",
                            "k",
                            "l",
                            "m",
                            "n",
                            "o",
                            "p",
                            "q",
                            "r",
                            "s",
                            "t",
                            "u",
                            "v",
                            "w",
                            "x",
                            "y",
                            "z",
                            "braceleft",
                            "bar",
                            "braceright",
                            "asciitilde",
                            "Adieresis",
                            "Aring",
                            "Ccedilla",
                            "Eacute",
                            "Ntilde",
                            "Odieresis",
                            "Udieresis",
                            "aacute",
                            "agrave",
                            "acircumflex",
                            "adieresis",
                            "atilde",
                            "aring",
                            "ccedilla",
                            "eacute",
                            "egrave",
                            "ecircumflex",
                            "edieresis",
                            "iacute",
                            "igrave",
                            "icircumflex",
                            "idieresis",
                            "ntilde",
                            "oacute",
                            "ograve",
                            "ocircumflex",
                            "odieresis",
                            "otilde",
                            "uacute",
                            "ugrave",
                            "ucircumflex",
                            "udieresis",
                            "dagger",
                            "degree",
                            "cent",
                            "sterling",
                            "section",
                            "bullet",
                            "paragraph",
                            "germandbls",
                            "registered",
                            "copyright",
                            "trademark",
                            "acute",
                            "dieresis",
                            "notequal",
                            "AE",
                            "Oslash",
                            "infinity",
                            "plusminus",
                            "lessequal",
                            "greaterequal",
                            "yen",
                            "mu",
                            "partialdiff",
                            "summation",
                            "product",
                            "pi",
                            "integral",
                            "ordfeminine",
                            "ordmasculine",
                            "Omega",
                            "ae",
                            "oslash",
                            "questiondown",
                            "exclamdown",
                            "logicalnot",
                            "radical",
                            "florin",
                            "approxequal",
                            "Delta",
                            "guillemotleft",
                            "guillemotright",
                            "ellipsis",
                            "nonbreakingspace",
                            "Agrave",
                            "Atilde",
                            "Otilde",
                            "OE",
                            "oe",
                            "endash",
                            "emdash",
                            "quotedblleft",
                            "quotedblright",
                            "quoteleft",
                            "quoteright",
                            "divide",
                            "lozenge",
                            "ydieresis",
                            "Ydieresis",
                            "fraction",
                            "currency",
                            "guilsinglleft",
                            "guilsinglright",
                            "fi",
                            "fl",
                            "daggerdbl",
                            "periodcentered",
                            "quotesinglbase",
                            "quotedblbase",
                            "perthousand",
                            "Acircumflex",
                            "Ecircumflex",
                            "Aacute",
                            "Edieresis",
                            "Egrave",
                            "Iacute",
                            "Icircumflex",
                            "Idieresis",
                            "Igrave",
                            "Oacute",
                            "Ocircumflex",
                            "apple",
                            "Ograve",
                            "Uacute",
                            "Ucircumflex",
                            "Ugrave",
                            "dotlessi",
                            "circumflex",
                            "tilde",
                            "macron",
                            "breve",
                            "dotaccent",
                            "ring",
                            "cedilla",
                            "hungarumlaut",
                            "ogonek",
                            "caron",
                            "Lslash",
                            "lslash",
                            "Scaron",
                            "scaron",
                            "Zcaron",
                            "zcaron",
                            "brokenbar",
                            "Eth",
                            "eth",
                            "Yacute",
                            "yacute",
                            "Thorn",
                            "thorn",
                            "minus",
                            "multiply",
                            "onesuperior",
                            "twosuperior",
                            "threesuperior",
                            "onehalf",
                            "onequarter",
                            "threequarters",
                            "franc",
                            "Gbreve",
                            "gbreve",
                            "Idotaccent",
                            "Scedilla",
                            "scedilla",
                            "Cacute",
                            "cacute",
                            "Ccaron",
                            "ccaron",
                            "dcroat"
                        ];
                        function Me(e1) {
                            this.font = e1;
                        }
                        function ke(e1) {
                            this.cmap = e1;
                        }
                        function Oe(e1, t) {
                            this.encoding = e1, this.charset = t;
                        }
                        function Ce(e1) {
                            switch(e1.version){
                                case 1:
                                    this.names = c.slice();
                                    break;
                                case 2:
                                    this.names = new Array(e1.numberOfGlyphs);
                                    for(var t = 0; t < e1.numberOfGlyphs; t++)e1.glyphNameIndex[t] < c.length ? this.names[t] = c[e1.glyphNameIndex[t]] : this.names[t] = e1.names[e1.glyphNameIndex[t] - c.length];
                                    break;
                                case 2.5:
                                    this.names = new Array(e1.numberOfGlyphs);
                                    for(var r = 0; r < e1.numberOfGlyphs; r++)this.names[r] = c[r + e1.glyphNameIndex[r]];
                                    break;
                                default:
                                    this.names = [];
                            }
                        }
                        Me.prototype.charToGlyphIndex = function(e1) {
                            var t = e1.codePointAt(0), r = this.font.glyphs;
                            if (r) {
                                for(var o = 0; o < r.length; o += 1)for(var n = r.get(o), s = 0; s < n.unicodes.length; s += 1)if (n.unicodes[s] === t) return o;
                            }
                            return null;
                        }, ke.prototype.charToGlyphIndex = function(e1) {
                            return this.cmap.glyphIndexMap[e1.codePointAt(0)] || 0;
                        }, Oe.prototype.charToGlyphIndex = function(e1) {
                            e1 = e1.codePointAt(0), e1 = this.encoding[e1];
                            return this.charset.indexOf(e1);
                        }, Ce.prototype.nameToGlyphIndex = function(e1) {
                            return this.names.indexOf(e1);
                        }, Ce.prototype.glyphIndexToName = function(e1) {
                            return this.names[e1];
                        };
                        var d = {
                            line: function(e1, t, r, o, n) {
                                e1.beginPath(), e1.moveTo(t, r), e1.lineTo(o, n), e1.stroke();
                            }
                        };
                        function f(e1) {
                            this.bindConstructorValues(e1);
                        }
                        function Pe(t, e1, r) {
                            Object.defineProperty(t, e1, {
                                get: function() {
                                    return t.path, t[r];
                                },
                                set: function(e1) {
                                    t[r] = e1;
                                },
                                enumerable: !0,
                                configurable: !0
                            });
                        }
                        function Ae(e1, t) {
                            if (this.font = e1, this.glyphs = {}, Array.isArray(t)) for(var r = 0; r < t.length; r++)this.glyphs[r] = t[r];
                            this.length = t && t.length || 0;
                        }
                        f.prototype.bindConstructorValues = function(e1) {
                            var t;
                            this.index = e1.index || 0, this.name = e1.name || null, this.unicode = e1.unicode || void 0, this.unicodes = e1.unicodes || void 0 !== e1.unicode ? [
                                e1.unicode
                            ] : [], e1.xMin && (this.xMin = e1.xMin), e1.yMin && (this.yMin = e1.yMin), e1.xMax && (this.xMax = e1.xMax), e1.yMax && (this.yMax = e1.yMax), e1.advanceWidth && (this.advanceWidth = e1.advanceWidth), Object.defineProperty(this, "path", (e1 = e1.path, t = e1 || new h, {
                                configurable: !0,
                                get: function() {
                                    return t = "function" == typeof t ? t() : t;
                                },
                                set: function(e1) {
                                    t = e1;
                                }
                            }));
                        }, f.prototype.addUnicode = function(e1) {
                            0 === this.unicodes.length && (this.unicode = e1), this.unicodes.push(e1);
                        }, f.prototype.getBoundingBox = function() {
                            return this.path.getBoundingBox();
                        }, f.prototype.getPath = function(e1, t, r, o, n) {
                            e1 = void 0 !== e1 ? e1 : 0, t = void 0 !== t ? t : 0, r = void 0 !== r ? r : 72;
                            for(var s, i, a = (o = o || {}).xScale, l = o.yScale, u = ((s = o.hinting && n && n.hinting ? this.path && n.hinting.exec(this, r) : s) ? (i = n.hinting.getCommands(s), e1 = Math.round(e1), t = Math.round(t), a = l = 1) : (i = this.path.commands, o = 1 / this.path.unitsPerEm * r, void 0 === a && (a = o), void 0 === l && (l = o)), new h), c = 0; c < i.length; c += 1){
                                var d = i[c];
                                "M" === d.type ? u.moveTo(e1 + d.x * a, t + -d.y * l) : "L" === d.type ? u.lineTo(e1 + d.x * a, t + -d.y * l) : "Q" === d.type ? u.quadraticCurveTo(e1 + d.x1 * a, t + -d.y1 * l, e1 + d.x * a, t + -d.y * l) : "C" === d.type ? u.curveTo(e1 + d.x1 * a, t + -d.y1 * l, e1 + d.x2 * a, t + -d.y2 * l, e1 + d.x * a, t + -d.y * l) : "Z" === d.type && u.closePath();
                            }
                            return u;
                        }, f.prototype.getContours = function() {
                            if (void 0 === this.points) return [];
                            for(var e1 = [], t = [], r = 0; r < this.points.length; r += 1){
                                var o = this.points[r];
                                t.push(o), o.lastPointOfContour && (e1.push(t), t = []);
                            }
                            return L.argument(0 === t.length, "There are still points left in the current contour."), e1;
                        }, f.prototype.getMetrics = function() {
                            for(var e1 = this.path.commands, t = [], r = [], o = 0; o < e1.length; o += 1){
                                var n = e1[o];
                                "Z" !== n.type && (t.push(n.x), r.push(n.y)), "Q" !== n.type && "C" !== n.type || (t.push(n.x1), r.push(n.y1)), "C" === n.type && (t.push(n.x2), r.push(n.y2));
                            }
                            var s = {
                                xMin: Math.min.apply(null, t),
                                yMin: Math.min.apply(null, r),
                                xMax: Math.max.apply(null, t),
                                yMax: Math.max.apply(null, r),
                                leftSideBearing: this.leftSideBearing
                            };
                            return isFinite(s.xMin) || (s.xMin = 0), isFinite(s.xMax) || (s.xMax = this.advanceWidth), isFinite(s.yMin) || (s.yMin = 0), isFinite(s.yMax) || (s.yMax = 0), s.rightSideBearing = this.advanceWidth - s.leftSideBearing - (s.xMax - s.xMin), s;
                        }, f.prototype.draw = function(e1, t, r, o, n) {
                            this.getPath(t, r, o, n).draw(e1);
                        }, f.prototype.drawPoints = function(i, e1, t, r) {
                            function o(e1, t, r, o) {
                                var n = 2 * Math.PI;
                                i.beginPath();
                                for(var s = 0; s < e1.length; s += 1)i.moveTo(t + e1[s].x * o, r + e1[s].y * o), i.arc(t + e1[s].x * o, r + e1[s].y * o, 2, 0, n, !1);
                                i.closePath(), i.fill();
                            }
                            e1 = void 0 !== e1 ? e1 : 0, t = void 0 !== t ? t : 0;
                            for(var r = 1 / this.path.unitsPerEm * (r = void 0 !== r ? r : 24), n = [], s = [], a = this.path, l = 0; l < a.commands.length; l += 1){
                                var u = a.commands[l];
                                void 0 !== u.x && n.push({
                                    x: u.x,
                                    y: -u.y
                                }), void 0 !== u.x1 && s.push({
                                    x: u.x1,
                                    y: -u.y1
                                }), void 0 !== u.x2 && s.push({
                                    x: u.x2,
                                    y: -u.y2
                                });
                            }
                            i.fillStyle = "blue", o(n, e1, t, r), i.fillStyle = "red", o(s, e1, t, r);
                        }, f.prototype.drawMetrics = function(e1, t, r, o) {
                            t = void 0 !== t ? t : 0, r = void 0 !== r ? r : 0, o = 1 / this.path.unitsPerEm * (o = void 0 !== o ? o : 24), e1.lineWidth = 1, e1.strokeStyle = "black", d.line(e1, t, -10000, t, 1e4), d.line(e1, -10000, r, 1e4, r);
                            var n = this.xMin || 0, s = this.yMin || 0, i = this.xMax || 0, a = this.yMax || 0, l = this.advanceWidth || 0;
                            e1.strokeStyle = "blue", d.line(e1, t + n * o, -10000, t + n * o, 1e4), d.line(e1, t + i * o, -10000, t + i * o, 1e4), d.line(e1, -10000, r + -s * o, 1e4, r + -s * o), d.line(e1, -10000, r + -a * o, 1e4, r + -a * o), e1.strokeStyle = "green", d.line(e1, t + l * o, -10000, t + l * o, 1e4);
                        }, Ae.prototype.get = function(e1) {
                            return "function" == typeof this.glyphs[e1] && (this.glyphs[e1] = this.glyphs[e1]()), this.glyphs[e1];
                        }, Ae.prototype.push = function(e1, t) {
                            this.glyphs[e1] = t, this.length++;
                        };
                        var p = {
                            GlyphSet: Ae,
                            glyphLoader: function(e1, t) {
                                return new f({
                                    index: t,
                                    font: e1
                                });
                            },
                            ttfGlyphLoader: function(r, e1, o, n, s, i) {
                                return function() {
                                    var t = new f({
                                        index: e1,
                                        font: r
                                    });
                                    return t.path = function() {
                                        o(t, n, s);
                                        var e1 = i(r.glyphs, t);
                                        return e1.unitsPerEm = r.unitsPerEm, e1;
                                    }, Pe(t, "xMin", "_xMin"), Pe(t, "xMax", "_xMax"), Pe(t, "yMin", "_yMin"), Pe(t, "yMax", "_yMax"), t;
                                };
                            },
                            cffGlyphLoader: function(r, e1, o, n) {
                                return function() {
                                    var t = new f({
                                        index: e1,
                                        font: r
                                    });
                                    return t.path = function() {
                                        var e1 = o(r, t, n);
                                        return e1.unitsPerEm = r.unitsPerEm, e1;
                                    }, t;
                                };
                            }
                        };
                        function Le(e1) {
                            e1 = e1.length < 1240 ? 107 : e1.length < 33900 ? 1131 : 32768;
                            return e1;
                        }
                        function y(e1, t, r) {
                            var o, n = [], s = [], i = R.getCard16(e1, t);
                            if (0 !== i) {
                                for(var a = R.getByte(e1, t + 2), l = t + (i + 1) * a + 2, u = t + 3, c = 0; c < i + 1; c += 1)n.push(R.getOffset(e1, u, a)), u += a;
                                o = l + n[i];
                            } else o = t + 2;
                            for(var d = 0; d < n.length - 1; d += 1){
                                var h = R.getBytes(e1, l + n[d], l + n[d + 1]);
                                r && (h = r(h)), s.push(h);
                            }
                            return {
                                objects: s,
                                startOffset: t,
                                endOffset: o
                            };
                        }
                        function Re(e1, t) {
                            if (28 === t) return e1.parseByte() << 8 | e1.parseByte();
                            if (29 === t) return e1.parseByte() << 24 | e1.parseByte() << 16 | e1.parseByte() << 8 | e1.parseByte();
                            if (30 === t) {
                                for(var r = e1, o = "", n = [
                                    "0",
                                    "1",
                                    "2",
                                    "3",
                                    "4",
                                    "5",
                                    "6",
                                    "7",
                                    "8",
                                    "9",
                                    ".",
                                    "E",
                                    "E-",
                                    null,
                                    "-"
                                ];;){
                                    var s = r.parseByte(), i = s >> 4, s = 15 & s;
                                    if (15 == i) break;
                                    if (o += n[i], 15 == s) break;
                                    o += n[s];
                                }
                                return parseFloat(o);
                            }
                            if (32 <= t && t <= 246) return t - 139;
                            if (247 <= t && t <= 250) return 256 * (t - 247) + e1.parseByte() + 108;
                            if (251 <= t && t <= 254) return 256 * -(t - 251) - e1.parseByte() - 108;
                            throw new Error("Invalid b0 " + t);
                        }
                        function Ie(e1, t, r) {
                            var o = new R.Parser(e1, t = void 0 !== t ? t : 0), n = [], s = [];
                            for(r = void 0 !== r ? r : e1.length; o.relativeOffset < r;){
                                var i = o.parseByte();
                                i <= 21 ? (12 === i && (i = 1200 + o.parseByte()), n.push([
                                    i,
                                    s
                                ]), s = []) : s.push(Re(o, i));
                            }
                            for(var a = n, l = {}, u = 0; u < a.length; u += 1){
                                var c = a[u][0], d = a[u][1], h = void 0, h = 1 === d.length ? d[0] : d;
                                if (l.hasOwnProperty(c) && !isNaN(l[c])) throw new Error("Object " + l + " already has key " + c);
                                l[c] = h;
                            }
                            return l;
                        }
                        function De(e1, t) {
                            return t = t <= 390 ? Se[t] : e1[t - 391];
                        }
                        function Fe(e1, t, r) {
                            for(var o, n = {}, s = 0; s < t.length; s += 1){
                                var i = t[s];
                                if (Array.isArray(i.type)) {
                                    var a = [];
                                    a.length = i.type.length;
                                    for(var l = 0; l < i.type.length; l++)void 0 === (o = void 0 !== e1[i.op] ? e1[i.op][l] : void 0) && (o = void 0 !== i.value && void 0 !== i.value[l] ? i.value[l] : null), "SID" === i.type[l] && (o = De(r, o)), a[l] = o;
                                    n[i.name] = a;
                                } else void 0 === (o = e1[i.op]) && (o = void 0 !== i.value ? i.value : null), "SID" === i.type && (o = De(r, o)), n[i.name] = o;
                            }
                            return n;
                        }
                        var Ue = [
                            {
                                name: "version",
                                op: 0,
                                type: "SID"
                            },
                            {
                                name: "notice",
                                op: 1,
                                type: "SID"
                            },
                            {
                                name: "copyright",
                                op: 1200,
                                type: "SID"
                            },
                            {
                                name: "fullName",
                                op: 2,
                                type: "SID"
                            },
                            {
                                name: "familyName",
                                op: 3,
                                type: "SID"
                            },
                            {
                                name: "weight",
                                op: 4,
                                type: "SID"
                            },
                            {
                                name: "isFixedPitch",
                                op: 1201,
                                type: "number",
                                value: 0
                            },
                            {
                                name: "italicAngle",
                                op: 1202,
                                type: "number",
                                value: 0
                            },
                            {
                                name: "underlinePosition",
                                op: 1203,
                                type: "number",
                                value: -100
                            },
                            {
                                name: "underlineThickness",
                                op: 1204,
                                type: "number",
                                value: 50
                            },
                            {
                                name: "paintType",
                                op: 1205,
                                type: "number",
                                value: 0
                            },
                            {
                                name: "charstringType",
                                op: 1206,
                                type: "number",
                                value: 2
                            },
                            {
                                name: "fontMatrix",
                                op: 1207,
                                type: [
                                    "real",
                                    "real",
                                    "real",
                                    "real",
                                    "real",
                                    "real"
                                ],
                                value: [
                                    .001,
                                    0,
                                    0,
                                    .001,
                                    0,
                                    0
                                ]
                            },
                            {
                                name: "uniqueId",
                                op: 13,
                                type: "number"
                            },
                            {
                                name: "fontBBox",
                                op: 5,
                                type: [
                                    "number",
                                    "number",
                                    "number",
                                    "number"
                                ],
                                value: [
                                    0,
                                    0,
                                    0,
                                    0
                                ]
                            },
                            {
                                name: "strokeWidth",
                                op: 1208,
                                type: "number",
                                value: 0
                            },
                            {
                                name: "xuid",
                                op: 14,
                                type: [],
                                value: null
                            },
                            {
                                name: "charset",
                                op: 15,
                                type: "offset",
                                value: 0
                            },
                            {
                                name: "encoding",
                                op: 16,
                                type: "offset",
                                value: 0
                            },
                            {
                                name: "charStrings",
                                op: 17,
                                type: "offset",
                                value: 0
                            },
                            {
                                name: "private",
                                op: 18,
                                type: [
                                    "number",
                                    "offset"
                                ],
                                value: [
                                    0,
                                    0
                                ]
                            },
                            {
                                name: "ros",
                                op: 1230,
                                type: [
                                    "SID",
                                    "SID",
                                    "number"
                                ]
                            },
                            {
                                name: "cidFontVersion",
                                op: 1231,
                                type: "number",
                                value: 0
                            },
                            {
                                name: "cidFontRevision",
                                op: 1232,
                                type: "number",
                                value: 0
                            },
                            {
                                name: "cidFontType",
                                op: 1233,
                                type: "number",
                                value: 0
                            },
                            {
                                name: "cidCount",
                                op: 1234,
                                type: "number",
                                value: 8720
                            },
                            {
                                name: "uidBase",
                                op: 1235,
                                type: "number"
                            },
                            {
                                name: "fdArray",
                                op: 1236,
                                type: "offset"
                            },
                            {
                                name: "fdSelect",
                                op: 1237,
                                type: "offset"
                            },
                            {
                                name: "fontName",
                                op: 1238,
                                type: "SID"
                            }
                        ], Ne = [
                            {
                                name: "subrs",
                                op: 19,
                                type: "offset",
                                value: 0
                            },
                            {
                                name: "defaultWidthX",
                                op: 20,
                                type: "number",
                                value: 0
                            },
                            {
                                name: "nominalWidthX",
                                op: 21,
                                type: "number",
                                value: 0
                            }
                        ];
                        function Be(e1, t, r, o) {
                            return Fe(Ie(e1, t, r), Ne, o);
                        }
                        function Ge(e1, t, r, o) {
                            for(var n = [], s = 0; s < r.length; s += 1){
                                var i = new DataView(new Uint8Array(r[s]).buffer), i = (a = o, Fe(Ie(i, 0, i.byteLength), Ue, a)), a = (i._subrs = [], i._subrsBias = 0, i.private[0]), l = i.private[1];
                                0 !== a && 0 !== l && (a = Be(e1, l + t, a, o), i._defaultWidthX = a.defaultWidthX, i._nominalWidthX = a.nominalWidthX, 0 !== a.subrs && (l = y(e1, l + a.subrs + t), i._subrs = l.objects, i._subrsBias = Le(i._subrs)), i._privateDict = a), n.push(i);
                            }
                            return n;
                        }
                        function Ve(y, g, e1) {
                            var v, b, _, j, t, x, w, r, S, T = new h, E = [], M = 0, k = !1, O = !1, C = 0, P = 0, A = (S = (y.isCIDFont ? (t = y.tables.cff.topDict._fdSelect[g.index], t = y.tables.cff.topDict._fdArray[t], x = t._subrs, w = t._subrsBias, r = t._defaultWidthX, t) : (x = y.tables.cff.topDict._subrs, w = y.tables.cff.topDict._subrsBias, r = y.tables.cff.topDict._defaultWidthX, y.tables.cff.topDict))._nominalWidthX, r);
                            function L(e1, t) {
                                O && T.closePath(), T.moveTo(e1, t), O = !0;
                            }
                            function R() {
                                E.length % 2 == 0 || k || (A = E.shift() + S), M += E.length >> 1, E.length = 0, k = !0;
                            }
                            return function e1(t) {
                                for(var r, o, n, s, i, a, l, u, c, d, h, f, p = 0; p < t.length;){
                                    var m = t[p];
                                    switch(p += 1, m){
                                        case 1:
                                        case 3:
                                            R();
                                            break;
                                        case 4:
                                            1 < E.length && !k && (A = E.shift() + S, k = !0), P += E.pop(), L(C, P);
                                            break;
                                        case 5:
                                            for(; 0 < E.length;)C += E.shift(), P += E.shift(), T.lineTo(C, P);
                                            break;
                                        case 6:
                                            for(; 0 < E.length && (C += E.shift(), T.lineTo(C, P), 0 !== E.length);)P += E.shift(), T.lineTo(C, P);
                                            break;
                                        case 7:
                                            for(; 0 < E.length && (P += E.shift(), T.lineTo(C, P), 0 !== E.length);)C += E.shift(), T.lineTo(C, P);
                                            break;
                                        case 8:
                                            for(; 0 < E.length;)v = C + E.shift(), b = P + E.shift(), _ = v + E.shift(), j = b + E.shift(), C = _ + E.shift(), P = j + E.shift(), T.curveTo(v, b, _, j, C, P);
                                            break;
                                        case 10:
                                            i = E.pop() + w, (a = x[i]) && e1(a);
                                            break;
                                        case 11:
                                            return;
                                        case 12:
                                            switch(m = t[p], p += 1, m){
                                                case 35:
                                                    v = C + E.shift(), b = P + E.shift(), _ = v + E.shift(), j = b + E.shift(), l = _ + E.shift(), u = j + E.shift(), c = l + E.shift(), d = u + E.shift(), h = c + E.shift(), f = d + E.shift(), C = h + E.shift(), P = f + E.shift(), E.shift(), T.curveTo(v, b, _, j, l, u), T.curveTo(c, d, h, f, C, P);
                                                    break;
                                                case 34:
                                                    v = C + E.shift(), b = P, _ = v + E.shift(), j = b + E.shift(), l = _ + E.shift(), u = j, c = l + E.shift(), d = j, h = c + E.shift(), f = P, C = h + E.shift(), T.curveTo(v, b, _, j, l, u), T.curveTo(c, d, h, f, C, P);
                                                    break;
                                                case 36:
                                                    v = C + E.shift(), b = P + E.shift(), _ = v + E.shift(), j = b + E.shift(), l = _ + E.shift(), u = j, c = l + E.shift(), d = j, h = c + E.shift(), f = d + E.shift(), C = h + E.shift(), T.curveTo(v, b, _, j, l, u), T.curveTo(c, d, h, f, C, P);
                                                    break;
                                                case 37:
                                                    v = C + E.shift(), b = P + E.shift(), _ = v + E.shift(), j = b + E.shift(), l = _ + E.shift(), u = j + E.shift(), c = l + E.shift(), d = u + E.shift(), h = c + E.shift(), f = d + E.shift(), Math.abs(h - C) > Math.abs(f - P) ? C = h + E.shift() : P = f + E.shift(), T.curveTo(v, b, _, j, l, u), T.curveTo(c, d, h, f, C, P);
                                                    break;
                                                default:
                                                    console.log("Glyph " + g.index + ": unknown operator 1200" + m), E.length = 0;
                                            }
                                            break;
                                        case 14:
                                            0 < E.length && !k && (A = E.shift() + S, k = !0), O && (T.closePath(), O = !1);
                                            break;
                                        case 18:
                                            R();
                                            break;
                                        case 19:
                                        case 20:
                                            R(), p += M + 7 >> 3;
                                            break;
                                        case 21:
                                            2 < E.length && !k && (A = E.shift() + S, k = !0), P += E.pop(), L(C += E.pop(), P);
                                            break;
                                        case 22:
                                            1 < E.length && !k && (A = E.shift() + S, k = !0), L(C += E.pop(), P);
                                            break;
                                        case 23:
                                            R();
                                            break;
                                        case 24:
                                            for(; 2 < E.length;)v = C + E.shift(), b = P + E.shift(), _ = v + E.shift(), j = b + E.shift(), C = _ + E.shift(), P = j + E.shift(), T.curveTo(v, b, _, j, C, P);
                                            C += E.shift(), P += E.shift(), T.lineTo(C, P);
                                            break;
                                        case 25:
                                            for(; 6 < E.length;)C += E.shift(), P += E.shift(), T.lineTo(C, P);
                                            v = C + E.shift(), b = P + E.shift(), _ = v + E.shift(), j = b + E.shift(), C = _ + E.shift(), P = j + E.shift(), T.curveTo(v, b, _, j, C, P);
                                            break;
                                        case 26:
                                            for(E.length % 2 && (C += E.shift()); 0 < E.length;)v = C, b = P + E.shift(), _ = v + E.shift(), j = b + E.shift(), C = _, P = j + E.shift(), T.curveTo(v, b, _, j, C, P);
                                            break;
                                        case 27:
                                            for(E.length % 2 && (P += E.shift()); 0 < E.length;)v = C + E.shift(), b = P, _ = v + E.shift(), j = b + E.shift(), C = _ + E.shift(), P = j, T.curveTo(v, b, _, j, C, P);
                                            break;
                                        case 28:
                                            r = t[p], o = t[p + 1], E.push((r << 24 | o << 16) >> 16), p += 2;
                                            break;
                                        case 29:
                                            i = E.pop() + y.gsubrsBias, (a = y.gsubrs[i]) && e1(a);
                                            break;
                                        case 30:
                                            for(; 0 < E.length && (v = C, b = P + E.shift(), _ = v + E.shift(), j = b + E.shift(), C = _ + E.shift(), P = j + (1 === E.length ? E.shift() : 0), T.curveTo(v, b, _, j, C, P), 0 !== E.length);)v = C + E.shift(), b = P, _ = v + E.shift(), j = b + E.shift(), P = j + E.shift(), C = _ + (1 === E.length ? E.shift() : 0), T.curveTo(v, b, _, j, C, P);
                                            break;
                                        case 31:
                                            for(; 0 < E.length && (v = C + E.shift(), b = P, _ = v + E.shift(), j = b + E.shift(), P = j + E.shift(), C = _ + (1 === E.length ? E.shift() : 0), T.curveTo(v, b, _, j, C, P), 0 !== E.length);)v = C, b = P + E.shift(), _ = v + E.shift(), j = b + E.shift(), C = _ + E.shift(), P = j + (1 === E.length ? E.shift() : 0), T.curveTo(v, b, _, j, C, P);
                                            break;
                                        default:
                                            m < 32 ? console.log("Glyph " + g.index + ": unknown operator " + m) : m < 247 ? E.push(m - 139) : m < 251 ? (r = t[p], p += 1, E.push(256 * (m - 247) + r + 108)) : m < 255 ? (r = t[p], p += 1, E.push(256 * -(m - 251) - r - 108)) : (r = t[p], o = t[p + 1], n = t[p + 2], s = t[p + 3], p += 4, E.push((r << 24 | o << 16 | n << 8 | s) / 65536));
                                    }
                                }
                            }(e1), g.advanceWidth = A, T;
                        }
                        function ze(e1, t) {
                            var r, o = Se.indexOf(e1);
                            return 0 <= o && (r = o), 0 <= (o = t.indexOf(e1)) ? r = o + Se.length : (r = Se.length + t.length, t.push(e1)), r;
                        }
                        function He(e1, t, r) {
                            for(var o = {}, n = 0; n < e1.length; n += 1){
                                var s = e1[n], i = t[s.name];
                                void 0 === i || function e1(t, r) {
                                    if (t === r) return 1;
                                    if (Array.isArray(t) && Array.isArray(r) && t.length === r.length) {
                                        for(var o = 0; o < t.length; o += 1)if (!e1(t[o], r[o])) return;
                                        return 1;
                                    }
                                }(i, s.value) || ("SID" === s.type && (i = ze(i, r)), o[s.op] = {
                                    name: s.name,
                                    type: s.type,
                                    value: i
                                });
                            }
                            return o;
                        }
                        function We(e1, t) {
                            var r = new S.Record("Top DICT", [
                                {
                                    name: "dict",
                                    type: "DICT",
                                    value: {}
                                }
                            ]);
                            return r.dict = He(Ue, e1, t), r;
                        }
                        function qe(e1) {
                            var t = new S.Record("Top DICT INDEX", [
                                {
                                    name: "topDicts",
                                    type: "INDEX",
                                    value: []
                                }
                            ]);
                            return t.topDicts = [
                                {
                                    name: "topDict_0",
                                    type: "TABLE",
                                    value: e1
                                }
                            ], t;
                        }
                        function Xe(e1) {
                            for(var t = new S.Record("CharStrings INDEX", [
                                {
                                    name: "charStrings",
                                    type: "INDEX",
                                    value: []
                                }
                            ]), r = 0; r < e1.length; r += 1){
                                var o = e1.get(r), n = function(e1) {
                                    for(var t = [], r = e1.path, o = (t.push({
                                        name: "width",
                                        type: "NUMBER",
                                        value: e1.advanceWidth
                                    }), 0), n = 0, s = 0; s < r.commands.length; s += 1){
                                        var i, a, l, u, c = void 0, d = void 0, h = r.commands[s];
                                        "M" === (h = "Q" === h.type ? {
                                            type: "C",
                                            x: h.x,
                                            y: h.y,
                                            x1: 1 / 3 * o + 2 / 3 * h.x1,
                                            y1: 1 / 3 * n + 2 / 3 * h.y1,
                                            x2: 1 / 3 * h.x + 2 / 3 * h.x1,
                                            y2: 1 / 3 * h.y + 2 / 3 * h.y1
                                        } : h).type ? (c = Math.round(h.x - o), d = Math.round(h.y - n), t.push({
                                            name: "dx",
                                            type: "NUMBER",
                                            value: c
                                        }), t.push({
                                            name: "dy",
                                            type: "NUMBER",
                                            value: d
                                        }), t.push({
                                            name: "rmoveto",
                                            type: "OP",
                                            value: 21
                                        }), o = Math.round(h.x), n = Math.round(h.y)) : "L" === h.type ? (c = Math.round(h.x - o), d = Math.round(h.y - n), t.push({
                                            name: "dx",
                                            type: "NUMBER",
                                            value: c
                                        }), t.push({
                                            name: "dy",
                                            type: "NUMBER",
                                            value: d
                                        }), t.push({
                                            name: "rlineto",
                                            type: "OP",
                                            value: 5
                                        }), o = Math.round(h.x), n = Math.round(h.y)) : "C" === h.type && (i = Math.round(h.x1 - o), a = Math.round(h.y1 - n), l = Math.round(h.x2 - h.x1), u = Math.round(h.y2 - h.y1), c = Math.round(h.x - h.x2), d = Math.round(h.y - h.y2), t.push({
                                            name: "dx1",
                                            type: "NUMBER",
                                            value: i
                                        }), t.push({
                                            name: "dy1",
                                            type: "NUMBER",
                                            value: a
                                        }), t.push({
                                            name: "dx2",
                                            type: "NUMBER",
                                            value: l
                                        }), t.push({
                                            name: "dy2",
                                            type: "NUMBER",
                                            value: u
                                        }), t.push({
                                            name: "dx",
                                            type: "NUMBER",
                                            value: c
                                        }), t.push({
                                            name: "dy",
                                            type: "NUMBER",
                                            value: d
                                        }), t.push({
                                            name: "rrcurveto",
                                            type: "OP",
                                            value: 8
                                        }), o = Math.round(h.x), n = Math.round(h.y));
                                    }
                                    return t.push({
                                        name: "endchar",
                                        type: "OP",
                                        value: 14
                                    }), t;
                                }(o);
                                t.charStrings.push({
                                    name: o.name,
                                    type: "CHARSTRING",
                                    value: n
                                });
                            }
                            return t;
                        }
                        var Ye = {
                            parse: function(e1, t, r) {
                                r.tables.cff = {}, o = e1, n = t, (s = {}).formatMajor = R.getCard8(o, n), s.formatMinor = R.getCard8(o, n + 1), s.size = R.getCard8(o, n + 2), s.offsetSize = R.getCard8(o, n + 3), s.startOffset = n, s.endOffset = n + 4;
                                var o = y(e1, s.endOffset, R.bytesToString), n = y(e1, o.endOffset), s = y(e1, n.endOffset, R.bytesToString), o = y(e1, s.endOffset);
                                if (r.gsubrs = o.objects, r.gsubrsBias = Le(r.gsubrs), 1 !== (o = Ge(e1, t, n.objects, s.objects)).length) throw new Error("CFF table has too many fonts in 'FontSet' - count of fonts NameIndex.length = " + o.length);
                                if (n = o[0], (r.tables.cff.topDict = n)._privateDict && (r.defaultWidthX = n._privateDict.defaultWidthX, r.nominalWidthX = n._privateDict.nominalWidthX), void 0 !== n.ros[0] && void 0 !== n.ros[1] && (r.isCIDFont = !0), r.isCIDFont) {
                                    var o = n.fdArray, i = n.fdSelect;
                                    if (0 === o || 0 === i) throw new Error("Font is marked as a CID font, but FDArray and/or FDSelect information is missing");
                                    o = Ge(e1, t, y(e1, o += t).objects, s.objects);
                                    n._fdArray = o, n._fdSelect = function(e1, t, r, o) {
                                        var n, s = [], i = new R.Parser(e1, t);
                                        if (0 === (e1 = i.parseCard8())) for(var a = 0; a < r; a++){
                                            if (o <= (n = i.parseCard8())) throw new Error("CFF table CID Font FDSelect has bad FD index value " + n + " (FD count " + o + ")");
                                            s.push(n);
                                        }
                                        else {
                                            if (3 !== e1) throw new Error("CFF Table CID Font FDSelect table has unsupported format " + e1);
                                            var l, u = i.parseCard16(), c = i.parseCard16();
                                            if (0 !== c) throw new Error("CFF Table CID Font FDSelect format 3 range has bad initial GID " + c);
                                            for(var d = 0; d < u; d++){
                                                if (n = i.parseCard8(), l = i.parseCard16(), o <= n) throw new Error("CFF table CID Font FDSelect has bad FD index value " + n + " (FD count " + o + ")");
                                                if (r < l) throw new Error("CFF Table CID Font FDSelect format 3 range has bad GID " + l);
                                                for(; c < l; c++)s.push(n);
                                                c = l;
                                            }
                                            if (l !== r) throw new Error("CFF Table CID Font FDSelect format 3 range has bad final GID " + l);
                                        }
                                        return s;
                                    }(e1, i += t, r.numGlyphs, o.length);
                                }
                                var i = t + n.private[1], o = Be(e1, i, n.private[0], s.objects), a = (r.defaultWidthX = o.defaultWidthX, r.nominalWidthX = o.nominalWidthX, 0 !== o.subrs ? (i = y(e1, i + o.subrs), r.subrs = i.objects, r.subrsBias = Le(r.subrs)) : (r.subrs = [], r.subrsBias = 0), y(e1, t + n.charStrings)), o = (r.nGlyphs = a.objects.length, function(e1, t, r, o) {
                                    var n = new R.Parser(e1, t), s = (--r, [
                                        ".notdef"
                                    ]);
                                    if (0 === (e1 = n.parseCard8())) for(var i = 0; i < r; i += 1)a = n.parseSID(), s.push(De(o, a));
                                    else if (1 === e1) for(; s.length <= r;)for(var a = n.parseSID(), l = n.parseCard8(), u = 0; u <= l; u += 1)s.push(De(o, a)), a += 1;
                                    else {
                                        if (2 !== e1) throw new Error("Unknown charset format " + e1);
                                        for(; s.length <= r;){
                                            a = n.parseSID(), l = n.parseCard16();
                                            for(var c = 0; c <= l; c += 1)s.push(De(o, a)), a += 1;
                                        }
                                    }
                                    return s;
                                }(e1, t + n.charset, r.nGlyphs, s.objects));
                                0 === n.encoding ? r.cffEncoding = new Oe(Te, o) : 1 === n.encoding ? r.cffEncoding = new Oe(Ee, o) : r.cffEncoding = function(e1, t, r) {
                                    var o = {}, n = new R.Parser(e1, t);
                                    if (0 === (e1 = n.parseCard8())) for(var s = n.parseCard8(), i = 0; i < s; i += 1)o[l = n.parseCard8()] = i;
                                    else {
                                        if (1 !== e1) throw new Error("Unknown encoding format " + e1);
                                        for(var a = n.parseCard8(), l = 1, u = 0; u < a; u += 1)for(var c = n.parseCard8(), d = n.parseCard8(), h = c; h <= c + d; h += 1)o[h] = l, l += 1;
                                    }
                                    return new Oe(o, r);
                                }(e1, t + n.encoding, o), r.encoding = r.encoding || r.cffEncoding, r.glyphs = new p.GlyphSet(r);
                                for(var l = 0; l < r.nGlyphs; l += 1){
                                    var u = a.objects[l];
                                    r.glyphs.push(l, p.cffGlyphLoader(r, l, Ve, u));
                                }
                            },
                            make: function(e1, t) {
                                for(var r, o = new S.Table("CFF ", [
                                    {
                                        name: "header",
                                        type: "RECORD"
                                    },
                                    {
                                        name: "nameIndex",
                                        type: "RECORD"
                                    },
                                    {
                                        name: "topDictIndex",
                                        type: "RECORD"
                                    },
                                    {
                                        name: "stringIndex",
                                        type: "RECORD"
                                    },
                                    {
                                        name: "globalSubrIndex",
                                        type: "RECORD"
                                    },
                                    {
                                        name: "charsets",
                                        type: "RECORD"
                                    },
                                    {
                                        name: "charStringsIndex",
                                        type: "RECORD"
                                    },
                                    {
                                        name: "privateDict",
                                        type: "RECORD"
                                    }
                                ]), n = 1 / t.unitsPerEm, n = {
                                    version: t.version,
                                    fullName: t.fullName,
                                    familyName: t.familyName,
                                    weight: t.weightName,
                                    fontBBox: t.fontBBox || [
                                        0,
                                        0,
                                        0,
                                        0
                                    ],
                                    fontMatrix: [
                                        n,
                                        0,
                                        0,
                                        n,
                                        0,
                                        0
                                    ],
                                    charset: 999,
                                    encoding: 0,
                                    charStrings: 999,
                                    private: [
                                        0,
                                        999
                                    ]
                                }, s = [], i = 1; i < e1.length; i += 1)r = e1.get(i), s.push(r.name);
                                var a, l, u = [], t = (o.header = new S.Record("Header", [
                                    {
                                        name: "major",
                                        type: "Card8",
                                        value: 1
                                    },
                                    {
                                        name: "minor",
                                        type: "Card8",
                                        value: 0
                                    },
                                    {
                                        name: "hdrSize",
                                        type: "Card8",
                                        value: 4
                                    },
                                    {
                                        name: "major",
                                        type: "Card8",
                                        value: 1
                                    }
                                ]), o.nameIndex = function(e1) {
                                    var t = new S.Record("Name INDEX", [
                                        {
                                            name: "names",
                                            type: "INDEX",
                                            value: []
                                        }
                                    ]);
                                    t.names = [];
                                    for(var r = 0; r < e1.length; r += 1)t.names.push({
                                        name: "name_" + r,
                                        type: "NAME",
                                        value: e1[r]
                                    });
                                    return t;
                                }([
                                    t.postScriptName
                                ]), We(n, u)), c = (o.topDictIndex = qe(t), o.globalSubrIndex = new S.Record("Global Subr INDEX", [
                                    {
                                        name: "subrs",
                                        type: "INDEX",
                                        value: []
                                    }
                                ]), o.charsets = function(e1, t) {
                                    for(var r = new S.Record("Charsets", [
                                        {
                                            name: "format",
                                            type: "Card8",
                                            value: 0
                                        }
                                    ]), o = 0; o < e1.length; o += 1){
                                        var n = ze(e1[o], t);
                                        r.fields.push({
                                            name: "glyph_" + o,
                                            type: "SID",
                                            value: n
                                        });
                                    }
                                    return r;
                                }(s, u), o.charStringsIndex = Xe(e1), o.privateDict = (c = {}, a = u, (l = new S.Record("Private DICT", [
                                    {
                                        name: "dict",
                                        type: "DICT",
                                        value: {}
                                    }
                                ])).dict = He(Ne, c, a), l), o.stringIndex = function(e1) {
                                    var t = new S.Record("String INDEX", [
                                        {
                                            name: "strings",
                                            type: "INDEX",
                                            value: []
                                        }
                                    ]);
                                    t.strings = [];
                                    for(var r = 0; r < e1.length; r += 1)t.strings.push({
                                        name: "string_" + r,
                                        type: "STRING",
                                        value: e1[r]
                                    });
                                    return t;
                                }(u), o.header.sizeOf() + o.nameIndex.sizeOf() + o.topDictIndex.sizeOf() + o.stringIndex.sizeOf() + o.globalSubrIndex.sizeOf());
                                return n.charset = c, n.encoding = 0, n.charStrings = n.charset + o.charsets.sizeOf(), n.private[1] = n.charStrings + o.charStringsIndex.sizeOf(), t = We(n, u), o.topDictIndex = qe(t), o;
                            }
                        };
                        var Ze = {
                            parse: function(e1, t) {
                                var r = {}, e1 = new R.Parser(e1, t);
                                return r.version = e1.parseVersion(), r.fontRevision = Math.round(1e3 * e1.parseFixed()) / 1e3, r.checkSumAdjustment = e1.parseULong(), r.magicNumber = e1.parseULong(), L.argument(1594834165 === r.magicNumber, "Font header has wrong magic number."), r.flags = e1.parseUShort(), r.unitsPerEm = e1.parseUShort(), r.created = e1.parseLongDateTime(), r.modified = e1.parseLongDateTime(), r.xMin = e1.parseShort(), r.yMin = e1.parseShort(), r.xMax = e1.parseShort(), r.yMax = e1.parseShort(), r.macStyle = e1.parseUShort(), r.lowestRecPPEM = e1.parseUShort(), r.fontDirectionHint = e1.parseShort(), r.indexToLocFormat = e1.parseShort(), r.glyphDataFormat = e1.parseShort(), r;
                            },
                            make: function(e1) {
                                var t = Math.round((new Date).getTime() / 1e3) + 2082844800, r = t;
                                return e1.createdTimestamp && (r = e1.createdTimestamp + 2082844800), new S.Table("head", [
                                    {
                                        name: "version",
                                        type: "FIXED",
                                        value: 65536
                                    },
                                    {
                                        name: "fontRevision",
                                        type: "FIXED",
                                        value: 65536
                                    },
                                    {
                                        name: "checkSumAdjustment",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "magicNumber",
                                        type: "ULONG",
                                        value: 1594834165
                                    },
                                    {
                                        name: "flags",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "unitsPerEm",
                                        type: "USHORT",
                                        value: 1e3
                                    },
                                    {
                                        name: "created",
                                        type: "LONGDATETIME",
                                        value: r
                                    },
                                    {
                                        name: "modified",
                                        type: "LONGDATETIME",
                                        value: t
                                    },
                                    {
                                        name: "xMin",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "yMin",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "xMax",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "yMax",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "macStyle",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "lowestRecPPEM",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "fontDirectionHint",
                                        type: "SHORT",
                                        value: 2
                                    },
                                    {
                                        name: "indexToLocFormat",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "glyphDataFormat",
                                        type: "SHORT",
                                        value: 0
                                    }
                                ], e1);
                            }
                        };
                        var Ke = {
                            parse: function(e1, t) {
                                var r = {}, e1 = new R.Parser(e1, t);
                                return r.version = e1.parseVersion(), r.ascender = e1.parseShort(), r.descender = e1.parseShort(), r.lineGap = e1.parseShort(), r.advanceWidthMax = e1.parseUShort(), r.minLeftSideBearing = e1.parseShort(), r.minRightSideBearing = e1.parseShort(), r.xMaxExtent = e1.parseShort(), r.caretSlopeRise = e1.parseShort(), r.caretSlopeRun = e1.parseShort(), r.caretOffset = e1.parseShort(), e1.relativeOffset += 8, r.metricDataFormat = e1.parseShort(), r.numberOfHMetrics = e1.parseUShort(), r;
                            },
                            make: function(e1) {
                                return new S.Table("hhea", [
                                    {
                                        name: "version",
                                        type: "FIXED",
                                        value: 65536
                                    },
                                    {
                                        name: "ascender",
                                        type: "FWORD",
                                        value: 0
                                    },
                                    {
                                        name: "descender",
                                        type: "FWORD",
                                        value: 0
                                    },
                                    {
                                        name: "lineGap",
                                        type: "FWORD",
                                        value: 0
                                    },
                                    {
                                        name: "advanceWidthMax",
                                        type: "UFWORD",
                                        value: 0
                                    },
                                    {
                                        name: "minLeftSideBearing",
                                        type: "FWORD",
                                        value: 0
                                    },
                                    {
                                        name: "minRightSideBearing",
                                        type: "FWORD",
                                        value: 0
                                    },
                                    {
                                        name: "xMaxExtent",
                                        type: "FWORD",
                                        value: 0
                                    },
                                    {
                                        name: "caretSlopeRise",
                                        type: "SHORT",
                                        value: 1
                                    },
                                    {
                                        name: "caretSlopeRun",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "caretOffset",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "reserved1",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "reserved2",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "reserved3",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "reserved4",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "metricDataFormat",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "numberOfHMetrics",
                                        type: "USHORT",
                                        value: 0
                                    }
                                ], e1);
                            }
                        };
                        var Qe = {
                            parse: function(e1, t, r, o, n) {
                                for(var s, i, a = new R.Parser(e1, t), l = 0; l < o; l += 1){
                                    l < r && (s = a.parseUShort(), i = a.parseShort());
                                    var u = n.get(l);
                                    u.advanceWidth = s, u.leftSideBearing = i;
                                }
                            },
                            make: function(e1) {
                                for(var t = new S.Table("hmtx", []), r = 0; r < e1.length; r += 1){
                                    var o = e1.get(r), n = o.advanceWidth || 0, o = o.leftSideBearing || 0;
                                    t.fields.push({
                                        name: "advanceWidth_" + r,
                                        type: "USHORT",
                                        value: n
                                    }), t.fields.push({
                                        name: "leftSideBearing_" + r,
                                        type: "SHORT",
                                        value: o
                                    });
                                }
                                return t;
                            }
                        };
                        var Je = {
                            make: function(e1) {
                                for(var t = new S.Table("ltag", [
                                    {
                                        name: "version",
                                        type: "ULONG",
                                        value: 1
                                    },
                                    {
                                        name: "flags",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "numTags",
                                        type: "ULONG",
                                        value: e1.length
                                    }
                                ]), r = "", o = 12 + 4 * e1.length, n = 0; n < e1.length; ++n){
                                    var s = r.indexOf(e1[n]);
                                    s < 0 && (s = r.length, r += e1[n]), t.fields.push({
                                        name: "offset " + n,
                                        type: "USHORT",
                                        value: o + s
                                    }), t.fields.push({
                                        name: "length " + n,
                                        type: "USHORT",
                                        value: e1[n].length
                                    });
                                }
                                return t.fields.push({
                                    name: "stringPool",
                                    type: "CHARARRAY",
                                    value: r
                                }), t;
                            },
                            parse: function(e1, t) {
                                for(var r = new R.Parser(e1, t), o = r.parseULong(), n = (L.argument(1 === o, "Unsupported ltag table version."), r.skip("uLong", 1), r.parseULong()), s = [], i = 0; i < n; i++){
                                    for(var a = "", l = t + r.parseUShort(), u = r.parseUShort(), c = l; c < l + u; ++c)a += String.fromCharCode(e1.getInt8(c));
                                    s.push(a);
                                }
                                return s;
                            }
                        };
                        var $e = {
                            parse: function(e1, t) {
                                var r = {}, e1 = new R.Parser(e1, t);
                                return r.version = e1.parseVersion(), r.numGlyphs = e1.parseUShort(), 1 === r.version && (r.maxPoints = e1.parseUShort(), r.maxContours = e1.parseUShort(), r.maxCompositePoints = e1.parseUShort(), r.maxCompositeContours = e1.parseUShort(), r.maxZones = e1.parseUShort(), r.maxTwilightPoints = e1.parseUShort(), r.maxStorage = e1.parseUShort(), r.maxFunctionDefs = e1.parseUShort(), r.maxInstructionDefs = e1.parseUShort(), r.maxStackElements = e1.parseUShort(), r.maxSizeOfInstructions = e1.parseUShort(), r.maxComponentElements = e1.parseUShort(), r.maxComponentDepth = e1.parseUShort()), r;
                            },
                            make: function(e1) {
                                return new S.Table("maxp", [
                                    {
                                        name: "version",
                                        type: "FIXED",
                                        value: 20480
                                    },
                                    {
                                        name: "numGlyphs",
                                        type: "USHORT",
                                        value: e1
                                    }
                                ]);
                            }
                        }, et = [
                            "copyright",
                            "fontFamily",
                            "fontSubfamily",
                            "uniqueID",
                            "fullName",
                            "version",
                            "postScriptName",
                            "trademark",
                            "manufacturer",
                            "designer",
                            "description",
                            "manufacturerURL",
                            "designerURL",
                            "license",
                            "licenseURL",
                            "reserved",
                            "preferredFamily",
                            "preferredSubfamily",
                            "compatibleFullName",
                            "sampleText",
                            "postScriptFindFontName",
                            "wwsFamily",
                            "wwsSubfamily"
                        ], tt = {
                            0: "en",
                            1: "fr",
                            2: "de",
                            3: "it",
                            4: "nl",
                            5: "sv",
                            6: "es",
                            7: "da",
                            8: "pt",
                            9: "no",
                            10: "he",
                            11: "ja",
                            12: "ar",
                            13: "fi",
                            14: "el",
                            15: "is",
                            16: "mt",
                            17: "tr",
                            18: "hr",
                            19: "zh-Hant",
                            20: "ur",
                            21: "hi",
                            22: "th",
                            23: "ko",
                            24: "lt",
                            25: "pl",
                            26: "hu",
                            27: "es",
                            28: "lv",
                            29: "se",
                            30: "fo",
                            31: "fa",
                            32: "ru",
                            33: "zh",
                            34: "nl-BE",
                            35: "ga",
                            36: "sq",
                            37: "ro",
                            38: "cz",
                            39: "sk",
                            40: "si",
                            41: "yi",
                            42: "sr",
                            43: "mk",
                            44: "bg",
                            45: "uk",
                            46: "be",
                            47: "uz",
                            48: "kk",
                            49: "az-Cyrl",
                            50: "az-Arab",
                            51: "hy",
                            52: "ka",
                            53: "mo",
                            54: "ky",
                            55: "tg",
                            56: "tk",
                            57: "mn-CN",
                            58: "mn",
                            59: "ps",
                            60: "ks",
                            61: "ku",
                            62: "sd",
                            63: "bo",
                            64: "ne",
                            65: "sa",
                            66: "mr",
                            67: "bn",
                            68: "as",
                            69: "gu",
                            70: "pa",
                            71: "or",
                            72: "ml",
                            73: "kn",
                            74: "ta",
                            75: "te",
                            76: "si",
                            77: "my",
                            78: "km",
                            79: "lo",
                            80: "vi",
                            81: "id",
                            82: "tl",
                            83: "ms",
                            84: "ms-Arab",
                            85: "am",
                            86: "ti",
                            87: "om",
                            88: "so",
                            89: "sw",
                            90: "rw",
                            91: "rn",
                            92: "ny",
                            93: "mg",
                            94: "eo",
                            128: "cy",
                            129: "eu",
                            130: "ca",
                            131: "la",
                            132: "qu",
                            133: "gn",
                            134: "ay",
                            135: "tt",
                            136: "ug",
                            137: "dz",
                            138: "jv",
                            139: "su",
                            140: "gl",
                            141: "af",
                            142: "br",
                            143: "iu",
                            144: "gd",
                            145: "gv",
                            146: "ga",
                            147: "to",
                            148: "el-polyton",
                            149: "kl",
                            150: "az",
                            151: "nn"
                        }, rt = {
                            0: 0,
                            1: 0,
                            2: 0,
                            3: 0,
                            4: 0,
                            5: 0,
                            6: 0,
                            7: 0,
                            8: 0,
                            9: 0,
                            10: 5,
                            11: 1,
                            12: 4,
                            13: 0,
                            14: 6,
                            15: 0,
                            16: 0,
                            17: 0,
                            18: 0,
                            19: 2,
                            20: 4,
                            21: 9,
                            22: 21,
                            23: 3,
                            24: 29,
                            25: 29,
                            26: 29,
                            27: 29,
                            28: 29,
                            29: 0,
                            30: 0,
                            31: 4,
                            32: 7,
                            33: 25,
                            34: 0,
                            35: 0,
                            36: 0,
                            37: 0,
                            38: 29,
                            39: 29,
                            40: 0,
                            41: 5,
                            42: 7,
                            43: 7,
                            44: 7,
                            45: 7,
                            46: 7,
                            47: 7,
                            48: 7,
                            49: 7,
                            50: 4,
                            51: 24,
                            52: 23,
                            53: 7,
                            54: 7,
                            55: 7,
                            56: 7,
                            57: 27,
                            58: 7,
                            59: 4,
                            60: 4,
                            61: 4,
                            62: 4,
                            63: 26,
                            64: 9,
                            65: 9,
                            66: 9,
                            67: 13,
                            68: 13,
                            69: 11,
                            70: 10,
                            71: 12,
                            72: 17,
                            73: 16,
                            74: 14,
                            75: 15,
                            76: 18,
                            77: 19,
                            78: 20,
                            79: 22,
                            80: 30,
                            81: 0,
                            82: 0,
                            83: 0,
                            84: 4,
                            85: 28,
                            86: 28,
                            87: 28,
                            88: 0,
                            89: 0,
                            90: 0,
                            91: 0,
                            92: 0,
                            93: 0,
                            94: 0,
                            128: 0,
                            129: 0,
                            130: 0,
                            131: 0,
                            132: 0,
                            133: 0,
                            134: 0,
                            135: 7,
                            136: 4,
                            137: 26,
                            138: 0,
                            139: 0,
                            140: 0,
                            141: 0,
                            142: 0,
                            143: 28,
                            144: 0,
                            145: 0,
                            146: 0,
                            147: 0,
                            148: 6,
                            149: 0,
                            150: 0,
                            151: 0
                        }, ot = {
                            1078: "af",
                            1052: "sq",
                            1156: "gsw",
                            1118: "am",
                            5121: "ar-DZ",
                            15361: "ar-BH",
                            3073: "ar",
                            2049: "ar-IQ",
                            11265: "ar-JO",
                            13313: "ar-KW",
                            12289: "ar-LB",
                            4097: "ar-LY",
                            6145: "ary",
                            8193: "ar-OM",
                            16385: "ar-QA",
                            1025: "ar-SA",
                            10241: "ar-SY",
                            7169: "aeb",
                            14337: "ar-AE",
                            9217: "ar-YE",
                            1067: "hy",
                            1101: "as",
                            2092: "az-Cyrl",
                            1068: "az",
                            1133: "ba",
                            1069: "eu",
                            1059: "be",
                            2117: "bn",
                            1093: "bn-IN",
                            8218: "bs-Cyrl",
                            5146: "bs",
                            1150: "br",
                            1026: "bg",
                            1027: "ca",
                            3076: "zh-HK",
                            5124: "zh-MO",
                            2052: "zh",
                            4100: "zh-SG",
                            1028: "zh-TW",
                            1155: "co",
                            1050: "hr",
                            4122: "hr-BA",
                            1029: "cs",
                            1030: "da",
                            1164: "prs",
                            1125: "dv",
                            2067: "nl-BE",
                            1043: "nl",
                            3081: "en-AU",
                            10249: "en-BZ",
                            4105: "en-CA",
                            9225: "en-029",
                            16393: "en-IN",
                            6153: "en-IE",
                            8201: "en-JM",
                            17417: "en-MY",
                            5129: "en-NZ",
                            13321: "en-PH",
                            18441: "en-SG",
                            7177: "en-ZA",
                            11273: "en-TT",
                            2057: "en-GB",
                            1033: "en",
                            12297: "en-ZW",
                            1061: "et",
                            1080: "fo",
                            1124: "fil",
                            1035: "fi",
                            2060: "fr-BE",
                            3084: "fr-CA",
                            1036: "fr",
                            5132: "fr-LU",
                            6156: "fr-MC",
                            4108: "fr-CH",
                            1122: "fy",
                            1110: "gl",
                            1079: "ka",
                            3079: "de-AT",
                            1031: "de",
                            5127: "de-LI",
                            4103: "de-LU",
                            2055: "de-CH",
                            1032: "el",
                            1135: "kl",
                            1095: "gu",
                            1128: "ha",
                            1037: "he",
                            1081: "hi",
                            1038: "hu",
                            1039: "is",
                            1136: "ig",
                            1057: "id",
                            1117: "iu",
                            2141: "iu-Latn",
                            2108: "ga",
                            1076: "xh",
                            1077: "zu",
                            1040: "it",
                            2064: "it-CH",
                            1041: "ja",
                            1099: "kn",
                            1087: "kk",
                            1107: "km",
                            1158: "quc",
                            1159: "rw",
                            1089: "sw",
                            1111: "kok",
                            1042: "ko",
                            1088: "ky",
                            1108: "lo",
                            1062: "lv",
                            1063: "lt",
                            2094: "dsb",
                            1134: "lb",
                            1071: "mk",
                            2110: "ms-BN",
                            1086: "ms",
                            1100: "ml",
                            1082: "mt",
                            1153: "mi",
                            1146: "arn",
                            1102: "mr",
                            1148: "moh",
                            1104: "mn",
                            2128: "mn-CN",
                            1121: "ne",
                            1044: "nb",
                            2068: "nn",
                            1154: "oc",
                            1096: "or",
                            1123: "ps",
                            1045: "pl",
                            1046: "pt",
                            2070: "pt-PT",
                            1094: "pa",
                            1131: "qu-BO",
                            2155: "qu-EC",
                            3179: "qu",
                            1048: "ro",
                            1047: "rm",
                            1049: "ru",
                            9275: "smn",
                            4155: "smj-NO",
                            5179: "smj",
                            3131: "se-FI",
                            1083: "se",
                            2107: "se-SE",
                            8251: "sms",
                            6203: "sma-NO",
                            7227: "sms",
                            1103: "sa",
                            7194: "sr-Cyrl-BA",
                            3098: "sr",
                            6170: "sr-Latn-BA",
                            2074: "sr-Latn",
                            1132: "nso",
                            1074: "tn",
                            1115: "si",
                            1051: "sk",
                            1060: "sl",
                            11274: "es-AR",
                            16394: "es-BO",
                            13322: "es-CL",
                            9226: "es-CO",
                            5130: "es-CR",
                            7178: "es-DO",
                            12298: "es-EC",
                            17418: "es-SV",
                            4106: "es-GT",
                            18442: "es-HN",
                            2058: "es-MX",
                            19466: "es-NI",
                            6154: "es-PA",
                            15370: "es-PY",
                            10250: "es-PE",
                            20490: "es-PR",
                            3082: "es",
                            1034: "es",
                            21514: "es-US",
                            14346: "es-UY",
                            8202: "es-VE",
                            2077: "sv-FI",
                            1053: "sv",
                            1114: "syr",
                            1064: "tg",
                            2143: "tzm",
                            1097: "ta",
                            1092: "tt",
                            1098: "te",
                            1054: "th",
                            1105: "bo",
                            1055: "tr",
                            1090: "tk",
                            1152: "ug",
                            1058: "uk",
                            1070: "hsb",
                            1056: "ur",
                            2115: "uz-Cyrl",
                            1091: "uz",
                            1066: "vi",
                            1106: "cy",
                            1160: "wo",
                            1157: "sah",
                            1144: "ii",
                            1130: "yo"
                        };
                        var nt = "utf-16", st = {
                            0: "macintosh",
                            1: "x-mac-japanese",
                            2: "x-mac-chinesetrad",
                            3: "x-mac-korean",
                            6: "x-mac-greek",
                            7: "x-mac-cyrillic",
                            9: "x-mac-devanagai",
                            10: "x-mac-gurmukhi",
                            11: "x-mac-gujarati",
                            12: "x-mac-oriya",
                            13: "x-mac-bengali",
                            14: "x-mac-tamil",
                            15: "x-mac-telugu",
                            16: "x-mac-kannada",
                            17: "x-mac-malayalam",
                            18: "x-mac-sinhalese",
                            19: "x-mac-burmese",
                            20: "x-mac-khmer",
                            21: "x-mac-thai",
                            22: "x-mac-lao",
                            23: "x-mac-georgian",
                            24: "x-mac-armenian",
                            25: "x-mac-chinesesimp",
                            26: "x-mac-tibetan",
                            27: "x-mac-mongolian",
                            28: "x-mac-ethiopic",
                            29: "x-mac-ce",
                            30: "x-mac-vietnamese",
                            31: "x-mac-extarabic"
                        }, it = {
                            15: "x-mac-icelandic",
                            17: "x-mac-turkish",
                            18: "x-mac-croatian",
                            24: "x-mac-ce",
                            25: "x-mac-ce",
                            26: "x-mac-ce",
                            27: "x-mac-ce",
                            28: "x-mac-ce",
                            30: "x-mac-icelandic",
                            37: "x-mac-romanian",
                            38: "x-mac-ce",
                            39: "x-mac-ce",
                            40: "x-mac-ce",
                            143: "x-mac-inuit",
                            146: "x-mac-gaelic"
                        };
                        function at(e1, t, r) {
                            switch(e1){
                                case 0:
                                    return nt;
                                case 1:
                                    return it[r] || st[t];
                                case 3:
                                    if (1 === t || 10 === t) return nt;
                            }
                        }
                        function lt(e1) {
                            var t, r = {};
                            for(t in e1)r[e1[t]] = parseInt(t);
                            return r;
                        }
                        function ut(e1, t, r, o, n, s) {
                            return new S.Record("NameRecord", [
                                {
                                    name: "platformID",
                                    type: "USHORT",
                                    value: e1
                                },
                                {
                                    name: "encodingID",
                                    type: "USHORT",
                                    value: t
                                },
                                {
                                    name: "languageID",
                                    type: "USHORT",
                                    value: r
                                },
                                {
                                    name: "nameID",
                                    type: "USHORT",
                                    value: o
                                },
                                {
                                    name: "length",
                                    type: "USHORT",
                                    value: n
                                },
                                {
                                    name: "offset",
                                    type: "USHORT",
                                    value: s
                                }
                            ]);
                        }
                        function ct(e1, t) {
                            if ((r = function(e1, t) {
                                var r = e1.length, o = t.length - r + 1;
                                e: for(var n = 0; n < o; n++)for(; n < o; n++){
                                    for(var s = 0; s < r; s++)if (t[n + s] !== e1[s]) continue e;
                                    return n;
                                }
                                return -1;
                            }(e1, t)) < 0) for(var r = t.length, o = 0, n = e1.length; o < n; ++o)t.push(e1[o]);
                            return r;
                        }
                        var dt = {
                            parse: function(e1, t, r) {
                                for(var o = {}, n = new R.Parser(e1, t), t = n.parseUShort(), s = n.parseUShort(), i = n.offset + n.parseUShort(), a = 0; a < s; a++){
                                    var l = n.parseUShort(), u = n.parseUShort(), c = n.parseUShort(), d = n.parseUShort(), d = et[d] || d, h = n.parseUShort(), f = n.parseUShort(), p = function(e1, t, r) {
                                        switch(e1){
                                            case 0:
                                                if (65535 === t) return "und";
                                                if (r) return r[t];
                                                break;
                                            case 1:
                                                return tt[t];
                                            case 3:
                                                return ot[t];
                                        }
                                    }(l, c, r), l = at(l, u, c);
                                    void 0 !== l && void 0 !== p && (u = void 0, (u = l === nt ? m.UTF16(e1, i + f, h) : m.MACSTRING(e1, i + f, h, l)) && ((c = void 0 === (c = o[d]) ? o[d] = {} : c)[p] = u));
                                }
                                return 1 === t && n.parseUShort(), o;
                            },
                            make: function(e1, t) {
                                var r, o = [], n = {}, s = lt(et);
                                for(r in e1){
                                    var i = s[r];
                                    if (void 0 === i && (i = r), h = parseInt(i), isNaN(h)) throw new Error('Name table entry "' + r + '" does not exist, see nameTableNames for complete list.');
                                    n[h] = e1[r], o.push(h);
                                }
                                for(var a = lt(tt), l = lt(ot), u = [], c = [], d = 0; d < o.length; d++){
                                    var h, f, p = n[h = o[d]];
                                    for(f in p){
                                        var m = p[f], y = 1, g = a[f], v = rt[g], b = at(y, v, g), b = w.MACSTRING(m, b), _ = (void 0 === b && (y = 0, (g = t.indexOf(f)) < 0 && (g = t.length, t.push(f)), v = 4, b = w.UTF16(m)), ct(b, c)), y = (u.push(ut(y, v, g, h, b.length, _)), l[f]);
                                        void 0 !== y && (g = ct(v = w.UTF16(m), c), u.push(ut(3, 1, y, h, v.length, g)));
                                    }
                                }
                                u.sort(function(e1, t) {
                                    return e1.platformID - t.platformID || e1.encodingID - t.encodingID || e1.languageID - t.languageID || e1.nameID - t.nameID;
                                });
                                for(var j = new S.Table("name", [
                                    {
                                        name: "format",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "count",
                                        type: "USHORT",
                                        value: u.length
                                    },
                                    {
                                        name: "stringOffset",
                                        type: "USHORT",
                                        value: 6 + 12 * u.length
                                    }
                                ]), x = 0; x < u.length; x++)j.fields.push({
                                    name: "record_" + x,
                                    type: "RECORD",
                                    value: u[x]
                                });
                                return j.fields.push({
                                    name: "strings",
                                    type: "LITERAL",
                                    value: c
                                }), j;
                            }
                        }, ht = [
                            {
                                begin: 0,
                                end: 127
                            },
                            {
                                begin: 128,
                                end: 255
                            },
                            {
                                begin: 256,
                                end: 383
                            },
                            {
                                begin: 384,
                                end: 591
                            },
                            {
                                begin: 592,
                                end: 687
                            },
                            {
                                begin: 688,
                                end: 767
                            },
                            {
                                begin: 768,
                                end: 879
                            },
                            {
                                begin: 880,
                                end: 1023
                            },
                            {
                                begin: 11392,
                                end: 11519
                            },
                            {
                                begin: 1024,
                                end: 1279
                            },
                            {
                                begin: 1328,
                                end: 1423
                            },
                            {
                                begin: 1424,
                                end: 1535
                            },
                            {
                                begin: 42240,
                                end: 42559
                            },
                            {
                                begin: 1536,
                                end: 1791
                            },
                            {
                                begin: 1984,
                                end: 2047
                            },
                            {
                                begin: 2304,
                                end: 2431
                            },
                            {
                                begin: 2432,
                                end: 2559
                            },
                            {
                                begin: 2560,
                                end: 2687
                            },
                            {
                                begin: 2688,
                                end: 2815
                            },
                            {
                                begin: 2816,
                                end: 2943
                            },
                            {
                                begin: 2944,
                                end: 3071
                            },
                            {
                                begin: 3072,
                                end: 3199
                            },
                            {
                                begin: 3200,
                                end: 3327
                            },
                            {
                                begin: 3328,
                                end: 3455
                            },
                            {
                                begin: 3584,
                                end: 3711
                            },
                            {
                                begin: 3712,
                                end: 3839
                            },
                            {
                                begin: 4256,
                                end: 4351
                            },
                            {
                                begin: 6912,
                                end: 7039
                            },
                            {
                                begin: 4352,
                                end: 4607
                            },
                            {
                                begin: 7680,
                                end: 7935
                            },
                            {
                                begin: 7936,
                                end: 8191
                            },
                            {
                                begin: 8192,
                                end: 8303
                            },
                            {
                                begin: 8304,
                                end: 8351
                            },
                            {
                                begin: 8352,
                                end: 8399
                            },
                            {
                                begin: 8400,
                                end: 8447
                            },
                            {
                                begin: 8448,
                                end: 8527
                            },
                            {
                                begin: 8528,
                                end: 8591
                            },
                            {
                                begin: 8592,
                                end: 8703
                            },
                            {
                                begin: 8704,
                                end: 8959
                            },
                            {
                                begin: 8960,
                                end: 9215
                            },
                            {
                                begin: 9216,
                                end: 9279
                            },
                            {
                                begin: 9280,
                                end: 9311
                            },
                            {
                                begin: 9312,
                                end: 9471
                            },
                            {
                                begin: 9472,
                                end: 9599
                            },
                            {
                                begin: 9600,
                                end: 9631
                            },
                            {
                                begin: 9632,
                                end: 9727
                            },
                            {
                                begin: 9728,
                                end: 9983
                            },
                            {
                                begin: 9984,
                                end: 10175
                            },
                            {
                                begin: 12288,
                                end: 12351
                            },
                            {
                                begin: 12352,
                                end: 12447
                            },
                            {
                                begin: 12448,
                                end: 12543
                            },
                            {
                                begin: 12544,
                                end: 12591
                            },
                            {
                                begin: 12592,
                                end: 12687
                            },
                            {
                                begin: 43072,
                                end: 43135
                            },
                            {
                                begin: 12800,
                                end: 13055
                            },
                            {
                                begin: 13056,
                                end: 13311
                            },
                            {
                                begin: 44032,
                                end: 55215
                            },
                            {
                                begin: 55296,
                                end: 57343
                            },
                            {
                                begin: 67840,
                                end: 67871
                            },
                            {
                                begin: 19968,
                                end: 40959
                            },
                            {
                                begin: 57344,
                                end: 63743
                            },
                            {
                                begin: 12736,
                                end: 12783
                            },
                            {
                                begin: 64256,
                                end: 64335
                            },
                            {
                                begin: 64336,
                                end: 65023
                            },
                            {
                                begin: 65056,
                                end: 65071
                            },
                            {
                                begin: 65040,
                                end: 65055
                            },
                            {
                                begin: 65104,
                                end: 65135
                            },
                            {
                                begin: 65136,
                                end: 65279
                            },
                            {
                                begin: 65280,
                                end: 65519
                            },
                            {
                                begin: 65520,
                                end: 65535
                            },
                            {
                                begin: 3840,
                                end: 4095
                            },
                            {
                                begin: 1792,
                                end: 1871
                            },
                            {
                                begin: 1920,
                                end: 1983
                            },
                            {
                                begin: 3456,
                                end: 3583
                            },
                            {
                                begin: 4096,
                                end: 4255
                            },
                            {
                                begin: 4608,
                                end: 4991
                            },
                            {
                                begin: 5024,
                                end: 5119
                            },
                            {
                                begin: 5120,
                                end: 5759
                            },
                            {
                                begin: 5760,
                                end: 5791
                            },
                            {
                                begin: 5792,
                                end: 5887
                            },
                            {
                                begin: 6016,
                                end: 6143
                            },
                            {
                                begin: 6144,
                                end: 6319
                            },
                            {
                                begin: 10240,
                                end: 10495
                            },
                            {
                                begin: 40960,
                                end: 42127
                            },
                            {
                                begin: 5888,
                                end: 5919
                            },
                            {
                                begin: 66304,
                                end: 66351
                            },
                            {
                                begin: 66352,
                                end: 66383
                            },
                            {
                                begin: 66560,
                                end: 66639
                            },
                            {
                                begin: 118784,
                                end: 119039
                            },
                            {
                                begin: 119808,
                                end: 120831
                            },
                            {
                                begin: 1044480,
                                end: 1048573
                            },
                            {
                                begin: 65024,
                                end: 65039
                            },
                            {
                                begin: 917504,
                                end: 917631
                            },
                            {
                                begin: 6400,
                                end: 6479
                            },
                            {
                                begin: 6480,
                                end: 6527
                            },
                            {
                                begin: 6528,
                                end: 6623
                            },
                            {
                                begin: 6656,
                                end: 6687
                            },
                            {
                                begin: 11264,
                                end: 11359
                            },
                            {
                                begin: 11568,
                                end: 11647
                            },
                            {
                                begin: 19904,
                                end: 19967
                            },
                            {
                                begin: 43008,
                                end: 43055
                            },
                            {
                                begin: 65536,
                                end: 65663
                            },
                            {
                                begin: 65856,
                                end: 65935
                            },
                            {
                                begin: 66432,
                                end: 66463
                            },
                            {
                                begin: 66464,
                                end: 66527
                            },
                            {
                                begin: 66640,
                                end: 66687
                            },
                            {
                                begin: 66688,
                                end: 66735
                            },
                            {
                                begin: 67584,
                                end: 67647
                            },
                            {
                                begin: 68096,
                                end: 68191
                            },
                            {
                                begin: 119552,
                                end: 119647
                            },
                            {
                                begin: 73728,
                                end: 74751
                            },
                            {
                                begin: 119648,
                                end: 119679
                            },
                            {
                                begin: 7040,
                                end: 7103
                            },
                            {
                                begin: 7168,
                                end: 7247
                            },
                            {
                                begin: 7248,
                                end: 7295
                            },
                            {
                                begin: 43136,
                                end: 43231
                            },
                            {
                                begin: 43264,
                                end: 43311
                            },
                            {
                                begin: 43312,
                                end: 43359
                            },
                            {
                                begin: 43520,
                                end: 43615
                            },
                            {
                                begin: 65936,
                                end: 65999
                            },
                            {
                                begin: 66e3,
                                end: 66047
                            },
                            {
                                begin: 66208,
                                end: 66271
                            },
                            {
                                begin: 127024,
                                end: 127135
                            }
                        ];
                        var ft = {
                            parse: function(e1, t) {
                                var r = {}, o = new R.Parser(e1, t);
                                r.version = o.parseUShort(), r.xAvgCharWidth = o.parseShort(), r.usWeightClass = o.parseUShort(), r.usWidthClass = o.parseUShort(), r.fsType = o.parseUShort(), r.ySubscriptXSize = o.parseShort(), r.ySubscriptYSize = o.parseShort(), r.ySubscriptXOffset = o.parseShort(), r.ySubscriptYOffset = o.parseShort(), r.ySuperscriptXSize = o.parseShort(), r.ySuperscriptYSize = o.parseShort(), r.ySuperscriptXOffset = o.parseShort(), r.ySuperscriptYOffset = o.parseShort(), r.yStrikeoutSize = o.parseShort(), r.yStrikeoutPosition = o.parseShort(), r.sFamilyClass = o.parseShort(), r.panose = [];
                                for(var n = 0; n < 10; n++)r.panose[n] = o.parseByte();
                                return r.ulUnicodeRange1 = o.parseULong(), r.ulUnicodeRange2 = o.parseULong(), r.ulUnicodeRange3 = o.parseULong(), r.ulUnicodeRange4 = o.parseULong(), r.achVendID = String.fromCharCode(o.parseByte(), o.parseByte(), o.parseByte(), o.parseByte()), r.fsSelection = o.parseUShort(), r.usFirstCharIndex = o.parseUShort(), r.usLastCharIndex = o.parseUShort(), r.sTypoAscender = o.parseShort(), r.sTypoDescender = o.parseShort(), r.sTypoLineGap = o.parseShort(), r.usWinAscent = o.parseUShort(), r.usWinDescent = o.parseUShort(), 1 <= r.version && (r.ulCodePageRange1 = o.parseULong(), r.ulCodePageRange2 = o.parseULong()), 2 <= r.version && (r.sxHeight = o.parseShort(), r.sCapHeight = o.parseShort(), r.usDefaultChar = o.parseUShort(), r.usBreakChar = o.parseUShort(), r.usMaxContent = o.parseUShort()), r;
                            },
                            make: function(e1) {
                                return new S.Table("OS/2", [
                                    {
                                        name: "version",
                                        type: "USHORT",
                                        value: 3
                                    },
                                    {
                                        name: "xAvgCharWidth",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usWeightClass",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usWidthClass",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "fsType",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "ySubscriptXSize",
                                        type: "SHORT",
                                        value: 650
                                    },
                                    {
                                        name: "ySubscriptYSize",
                                        type: "SHORT",
                                        value: 699
                                    },
                                    {
                                        name: "ySubscriptXOffset",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "ySubscriptYOffset",
                                        type: "SHORT",
                                        value: 140
                                    },
                                    {
                                        name: "ySuperscriptXSize",
                                        type: "SHORT",
                                        value: 650
                                    },
                                    {
                                        name: "ySuperscriptYSize",
                                        type: "SHORT",
                                        value: 699
                                    },
                                    {
                                        name: "ySuperscriptXOffset",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "ySuperscriptYOffset",
                                        type: "SHORT",
                                        value: 479
                                    },
                                    {
                                        name: "yStrikeoutSize",
                                        type: "SHORT",
                                        value: 49
                                    },
                                    {
                                        name: "yStrikeoutPosition",
                                        type: "SHORT",
                                        value: 258
                                    },
                                    {
                                        name: "sFamilyClass",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "bFamilyType",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bSerifStyle",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bWeight",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bProportion",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bContrast",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bStrokeVariation",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bArmStyle",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bLetterform",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bMidline",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bXHeight",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "ulUnicodeRange1",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "ulUnicodeRange2",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "ulUnicodeRange3",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "ulUnicodeRange4",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "achVendID",
                                        type: "CHARARRAY",
                                        value: "XXXX"
                                    },
                                    {
                                        name: "fsSelection",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usFirstCharIndex",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usLastCharIndex",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "sTypoAscender",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "sTypoDescender",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "sTypoLineGap",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usWinAscent",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usWinDescent",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "ulCodePageRange1",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "ulCodePageRange2",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "sxHeight",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "sCapHeight",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usDefaultChar",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usBreakChar",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usMaxContext",
                                        type: "USHORT",
                                        value: 0
                                    }
                                ], e1);
                            },
                            unicodeRanges: ht,
                            getUnicodeRange: function(e1) {
                                for(var t = 0; t < ht.length; t += 1){
                                    var r = ht[t];
                                    if (e1 >= r.begin && e1 < r.end) return t;
                                }
                                return -1;
                            }
                        };
                        var pt = {
                            parse: function(e1, t) {
                                var r = {}, o = new R.Parser(e1, t);
                                switch(r.version = o.parseVersion(), r.italicAngle = o.parseFixed(), r.underlinePosition = o.parseShort(), r.underlineThickness = o.parseShort(), r.isFixedPitch = o.parseULong(), r.minMemType42 = o.parseULong(), r.maxMemType42 = o.parseULong(), r.minMemType1 = o.parseULong(), r.maxMemType1 = o.parseULong(), r.version){
                                    case 1:
                                        r.names = c.slice();
                                        break;
                                    case 2:
                                        r.numberOfGlyphs = o.parseUShort(), r.glyphNameIndex = new Array(r.numberOfGlyphs);
                                        for(var n = 0; n < r.numberOfGlyphs; n++)r.glyphNameIndex[n] = o.parseUShort();
                                        r.names = [];
                                        for(var s, i = 0; i < r.numberOfGlyphs; i++)r.glyphNameIndex[i] >= c.length && (s = o.parseChar(), r.names.push(o.parseString(s)));
                                        break;
                                    case 2.5:
                                        r.numberOfGlyphs = o.parseUShort(), r.offset = new Array(r.numberOfGlyphs);
                                        for(var a = 0; a < r.numberOfGlyphs; a++)r.offset[a] = o.parseChar();
                                }
                                return r;
                            },
                            make: function() {
                                return new S.Table("post", [
                                    {
                                        name: "version",
                                        type: "FIXED",
                                        value: 196608
                                    },
                                    {
                                        name: "italicAngle",
                                        type: "FIXED",
                                        value: 0
                                    },
                                    {
                                        name: "underlinePosition",
                                        type: "FWORD",
                                        value: 0
                                    },
                                    {
                                        name: "underlineThickness",
                                        type: "FWORD",
                                        value: 0
                                    },
                                    {
                                        name: "isFixedPitch",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "minMemType42",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "maxMemType42",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "minMemType1",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "maxMemType1",
                                        type: "ULONG",
                                        value: 0
                                    }
                                ]);
                            }
                        }, o = new Array(9), s = (o[1] = function() {
                            var e1 = this.offset + this.relativeOffset, t = this.parseUShort();
                            return 1 === t ? {
                                substFormat: 1,
                                coverage: this.parsePointer(u.coverage),
                                deltaGlyphId: this.parseUShort()
                            } : 2 === t ? {
                                substFormat: 2,
                                coverage: this.parsePointer(u.coverage),
                                substitute: this.parseOffset16List()
                            } : void L.assert(!1, "0x" + e1.toString(16) + ": lookup type 1 format must be 1 or 2.");
                        }, o[2] = function() {
                            var e1 = this.parseUShort();
                            return L.argument(1 === e1, "GSUB Multiple Substitution Subtable identifier-format must be 1"), {
                                substFormat: e1,
                                coverage: this.parsePointer(u.coverage),
                                sequences: this.parseListOfLists()
                            };
                        }, o[3] = function() {
                            var e1 = this.parseUShort();
                            return L.argument(1 === e1, "GSUB Alternate Substitution Subtable identifier-format must be 1"), {
                                substFormat: e1,
                                coverage: this.parsePointer(u.coverage),
                                alternateSets: this.parseListOfLists()
                            };
                        }, o[4] = function() {
                            var e1 = this.parseUShort();
                            return L.argument(1 === e1, "GSUB ligature table identifier-format must be 1"), {
                                substFormat: e1,
                                coverage: this.parsePointer(u.coverage),
                                ligatureSets: this.parseListOfLists(function() {
                                    return {
                                        ligGlyph: this.parseUShort(),
                                        components: this.parseUShortList(this.parseUShort() - 1)
                                    };
                                })
                            };
                        }, {
                            sequenceIndex: u.uShort,
                            lookupListIndex: u.uShort
                        });
                        o[5] = function() {
                            var e1, t, r = this.offset + this.relativeOffset, o = this.parseUShort();
                            return 1 === o ? {
                                substFormat: o,
                                coverage: this.parsePointer(u.coverage),
                                ruleSets: this.parseListOfLists(function() {
                                    var e1 = this.parseUShort(), t = this.parseUShort();
                                    return {
                                        input: this.parseUShortList(e1 - 1),
                                        lookupRecords: this.parseRecordList(t, s)
                                    };
                                })
                            } : 2 === o ? {
                                substFormat: o,
                                coverage: this.parsePointer(u.coverage),
                                classDef: this.parsePointer(u.classDef),
                                classSets: this.parseListOfLists(function() {
                                    var e1 = this.parseUShort(), t = this.parseUShort();
                                    return {
                                        classes: this.parseUShortList(e1 - 1),
                                        lookupRecords: this.parseRecordList(t, s)
                                    };
                                })
                            } : 3 === o ? (e1 = this.parseUShort(), t = this.parseUShort(), {
                                substFormat: o,
                                coverages: this.parseList(e1, u.pointer(u.coverage)),
                                lookupRecords: this.parseRecordList(t, s)
                            }) : void L.assert(!1, "0x" + r.toString(16) + ": lookup type 5 format must be 1, 2 or 3.");
                        }, o[6] = function() {
                            var e1 = this.offset + this.relativeOffset, t = this.parseUShort();
                            return 1 === t ? {
                                substFormat: 1,
                                coverage: this.parsePointer(u.coverage),
                                chainRuleSets: this.parseListOfLists(function() {
                                    return {
                                        backtrack: this.parseUShortList(),
                                        input: this.parseUShortList(this.parseShort() - 1),
                                        lookahead: this.parseUShortList(),
                                        lookupRecords: this.parseRecordList(s)
                                    };
                                })
                            } : 2 === t ? {
                                substFormat: 2,
                                coverage: this.parsePointer(u.coverage),
                                backtrackClassDef: this.parsePointer(u.classDef),
                                inputClassDef: this.parsePointer(u.classDef),
                                lookaheadClassDef: this.parsePointer(u.classDef),
                                chainClassSet: this.parseListOfLists(function() {
                                    return {
                                        backtrack: this.parseUShortList(),
                                        input: this.parseUShortList(this.parseShort() - 1),
                                        lookahead: this.parseUShortList(),
                                        lookupRecords: this.parseRecordList(s)
                                    };
                                })
                            } : 3 === t ? {
                                substFormat: 3,
                                backtrackCoverage: this.parseList(u.pointer(u.coverage)),
                                inputCoverage: this.parseList(u.pointer(u.coverage)),
                                lookaheadCoverage: this.parseList(u.pointer(u.coverage)),
                                lookupRecords: this.parseRecordList(s)
                            } : void L.assert(!1, "0x" + e1.toString(16) + ": lookup type 6 format must be 1, 2 or 3.");
                        }, o[7] = function() {
                            var e1 = this.parseUShort(), e1 = (L.argument(1 === e1, "GSUB Extension Substitution subtable identifier-format must be 1"), this.parseUShort()), t = new u(this.data, this.offset + this.parseULong());
                            return {
                                substFormat: 1,
                                lookupType: e1,
                                extension: o[e1].call(t)
                            };
                        }, o[8] = function() {
                            var e1 = this.parseUShort();
                            return L.argument(1 === e1, "GSUB Reverse Chaining Contextual Single Substitution Subtable identifier-format must be 1"), {
                                substFormat: e1,
                                coverage: this.parsePointer(u.coverage),
                                backtrackCoverage: this.parseList(u.pointer(u.coverage)),
                                lookaheadCoverage: this.parseList(u.pointer(u.coverage)),
                                substitutes: this.parseUShortList()
                            };
                        };
                        var mt = new Array(9);
                        mt[1] = function(e1) {
                            return 1 === e1.substFormat ? new S.Table("substitutionTable", [
                                {
                                    name: "substFormat",
                                    type: "USHORT",
                                    value: 1
                                },
                                {
                                    name: "coverage",
                                    type: "TABLE",
                                    value: new S.Coverage(e1.coverage)
                                },
                                {
                                    name: "deltaGlyphID",
                                    type: "USHORT",
                                    value: e1.deltaGlyphId
                                }
                            ]) : new S.Table("substitutionTable", [
                                {
                                    name: "substFormat",
                                    type: "USHORT",
                                    value: 2
                                },
                                {
                                    name: "coverage",
                                    type: "TABLE",
                                    value: new S.Coverage(e1.coverage)
                                }
                            ].concat(S.ushortList("substitute", e1.substitute)));
                        }, mt[3] = function(e1) {
                            return L.assert(1 === e1.substFormat, "Lookup type 3 substFormat must be 1."), new S.Table("substitutionTable", [
                                {
                                    name: "substFormat",
                                    type: "USHORT",
                                    value: 1
                                },
                                {
                                    name: "coverage",
                                    type: "TABLE",
                                    value: new S.Coverage(e1.coverage)
                                }
                            ].concat(S.tableList("altSet", e1.alternateSets, function(e1) {
                                return new S.Table("alternateSetTable", S.ushortList("alternate", e1));
                            })));
                        }, mt[4] = function(e1) {
                            return L.assert(1 === e1.substFormat, "Lookup type 4 substFormat must be 1."), new S.Table("substitutionTable", [
                                {
                                    name: "substFormat",
                                    type: "USHORT",
                                    value: 1
                                },
                                {
                                    name: "coverage",
                                    type: "TABLE",
                                    value: new S.Coverage(e1.coverage)
                                }
                            ].concat(S.tableList("ligSet", e1.ligatureSets, function(e1) {
                                return new S.Table("ligatureSetTable", S.tableList("ligature", e1, function(e1) {
                                    return new S.Table("ligatureTable", [
                                        {
                                            name: "ligGlyph",
                                            type: "USHORT",
                                            value: e1.ligGlyph
                                        }
                                    ].concat(S.ushortList("component", e1.components, e1.components.length + 1)));
                                }));
                            })));
                        };
                        var yt = {
                            parse: function(e1, t) {
                                return t = (e1 = new u(e1, t = t || 0)).parseVersion(1), L.argument(1 === t || 1.1 === t, "Unsupported GSUB table version."), 1 === t ? {
                                    version: t,
                                    scripts: e1.parseScriptList(),
                                    features: e1.parseFeatureList(),
                                    lookups: e1.parseLookupList(o)
                                } : {
                                    version: t,
                                    scripts: e1.parseScriptList(),
                                    features: e1.parseFeatureList(),
                                    lookups: e1.parseLookupList(o),
                                    variations: e1.parseFeatureVariationsList()
                                };
                            },
                            make: function(e1) {
                                return new S.Table("GSUB", [
                                    {
                                        name: "version",
                                        type: "ULONG",
                                        value: 65536
                                    },
                                    {
                                        name: "scripts",
                                        type: "TABLE",
                                        value: new S.ScriptList(e1.scripts)
                                    },
                                    {
                                        name: "features",
                                        type: "TABLE",
                                        value: new S.FeatureList(e1.features)
                                    },
                                    {
                                        name: "lookups",
                                        type: "TABLE",
                                        value: new S.LookupList(e1.lookups, mt)
                                    }
                                ]);
                            }
                        };
                        var gt = {
                            parse: function(e1, t) {
                                for(var r = new R.Parser(e1, t), o = r.parseULong(), n = (L.argument(1 === o, "Unsupported META table version."), r.parseULong(), r.parseULong(), r.parseULong()), s = {}, i = 0; i < n; i++){
                                    var a = r.parseTag(), l = r.parseULong(), u = r.parseULong(), l = m.UTF8(e1, t + l, u);
                                    s[a] = l;
                                }
                                return s;
                            },
                            make: function(e1) {
                                var t, r = Object.keys(e1).length, o = "", n = 16 + 12 * r, s = new S.Table("meta", [
                                    {
                                        name: "version",
                                        type: "ULONG",
                                        value: 1
                                    },
                                    {
                                        name: "flags",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "offset",
                                        type: "ULONG",
                                        value: n
                                    },
                                    {
                                        name: "numTags",
                                        type: "ULONG",
                                        value: r
                                    }
                                ]);
                                for(t in e1){
                                    var i = o.length;
                                    o += e1[t], s.fields.push({
                                        name: "tag " + t,
                                        type: "TAG",
                                        value: t
                                    }), s.fields.push({
                                        name: "offset " + t,
                                        type: "ULONG",
                                        value: n + i
                                    }), s.fields.push({
                                        name: "length " + t,
                                        type: "ULONG",
                                        value: e1[t].length
                                    });
                                }
                                return s.fields.push({
                                    name: "stringPool",
                                    type: "CHARARRAY",
                                    value: o
                                }), s;
                            }
                        };
                        function vt(e1) {
                            return Math.log(e1) / Math.log(2) | 0;
                        }
                        function bt(e1) {
                            for(; e1.length % 4 != 0;)e1.push(0);
                            for(var t = 0, r = 0; r < e1.length; r += 4)t += (e1[r] << 24) + (e1[r + 1] << 16) + (e1[r + 2] << 8) + e1[r + 3];
                            return t %= Math.pow(2, 32);
                        }
                        function _t(e1, t, r, o) {
                            return new S.Record("Table Record", [
                                {
                                    name: "tag",
                                    type: "TAG",
                                    value: void 0 !== e1 ? e1 : ""
                                },
                                {
                                    name: "checkSum",
                                    type: "ULONG",
                                    value: void 0 !== t ? t : 0
                                },
                                {
                                    name: "offset",
                                    type: "ULONG",
                                    value: void 0 !== r ? r : 0
                                },
                                {
                                    name: "length",
                                    type: "ULONG",
                                    value: void 0 !== o ? o : 0
                                }
                            ]);
                        }
                        function jt(e1) {
                            for(var t = new S.Table("sfnt", [
                                {
                                    name: "version",
                                    type: "TAG",
                                    value: "OTTO"
                                },
                                {
                                    name: "numTables",
                                    type: "USHORT",
                                    value: 0
                                },
                                {
                                    name: "searchRange",
                                    type: "USHORT",
                                    value: 0
                                },
                                {
                                    name: "entrySelector",
                                    type: "USHORT",
                                    value: 0
                                },
                                {
                                    name: "rangeShift",
                                    type: "USHORT",
                                    value: 0
                                }
                            ]), r = (t.tables = e1, t.numTables = e1.length, Math.pow(2, vt(t.numTables))), o = (t.searchRange = 16 * r, t.entrySelector = vt(r), t.rangeShift = 16 * t.numTables - t.searchRange, []), n = [], s = t.sizeOf() + _t().sizeOf() * t.numTables; s % 4 != 0;)s += 1, n.push({
                                name: "padding",
                                type: "BYTE",
                                value: 0
                            });
                            for(var i = 0; i < e1.length; i += 1){
                                var a = e1[i], l = (L.argument(4 === a.tableName.length, "Table name" + a.tableName + " is invalid."), a.sizeOf()), u = _t(a.tableName, bt(a.encode()), s, l);
                                for(o.push({
                                    name: u.tag + " Table Record",
                                    type: "RECORD",
                                    value: u
                                }), n.push({
                                    name: a.tableName + " table",
                                    type: "RECORD",
                                    value: a
                                }), s += l, L.argument(!isNaN(s), "Something went wrong calculating the offset."); s % 4 != 0;)s += 1, n.push({
                                    name: "padding",
                                    type: "BYTE",
                                    value: 0
                                });
                            }
                            return o.sort(function(e1, t) {
                                return e1.value.tag > t.value.tag ? 1 : -1;
                            }), t.fields = t.fields.concat(o), t.fields = t.fields.concat(n), t;
                        }
                        function xt(e1, t, r) {
                            for(var o = 0; o < t.length; o += 1){
                                var n = e1.charToGlyphIndex(t[o]);
                                if (0 < n) return e1.glyphs.get(n).getMetrics();
                            }
                            return r;
                        }
                        var wt = {
                            make: jt,
                            fontToTable: function(e1) {
                                for(var t, r = [], o = [], n = [], s = [], i = [], a = [], l = [], u = 0, c = 0, d = 0, h = 0, f = 0, p = 0; p < e1.glyphs.length; p += 1){
                                    var m = e1.glyphs.get(p), y = 0 | m.unicode;
                                    if (isNaN(m.advanceWidth)) throw new Error("Glyph " + m.name + " (" + p + "): advanceWidth is not a number.");
                                    (y < t || void 0 === t) && 0 < y && (t = y), u < y && (u = y);
                                    var y = ft.getUnicodeRange(y);
                                    if (y < 32) c |= 1 << y;
                                    else if (y < 64) d |= 1 << y - 32;
                                    else if (y < 96) h |= 1 << y - 64;
                                    else {
                                        if (!(y < 123)) throw new Error("Unicode ranges bits > 123 are reserved for internal usage");
                                        f |= 1 << y - 96;
                                    }
                                    ".notdef" !== m.name && (y = m.getMetrics(), r.push(y.xMin), o.push(y.yMin), n.push(y.xMax), s.push(y.yMax), a.push(y.leftSideBearing), l.push(y.rightSideBearing), i.push(m.advanceWidth));
                                }
                                var g, v = {
                                    xMin: Math.min.apply(null, r),
                                    yMin: Math.min.apply(null, o),
                                    xMax: Math.max.apply(null, n),
                                    yMax: Math.max.apply(null, s),
                                    advanceWidthMax: Math.max.apply(null, i),
                                    advanceWidthAvg: function(e1) {
                                        for(var t = 0, r = 0; r < e1.length; r += 1)t += e1[r];
                                        return t / e1.length;
                                    }(i),
                                    minLeftSideBearing: Math.min.apply(null, a),
                                    maxLeftSideBearing: Math.max.apply(null, a),
                                    minRightSideBearing: Math.min.apply(null, l)
                                }, b = (v.ascender = e1.ascender, v.descender = e1.descender, Ze.make({
                                    flags: 3,
                                    unitsPerEm: e1.unitsPerEm,
                                    xMin: v.xMin,
                                    yMin: v.yMin,
                                    xMax: v.xMax,
                                    yMax: v.yMax,
                                    lowestRecPPEM: 3,
                                    createdTimestamp: e1.createdTimestamp
                                })), _ = Ke.make({
                                    ascender: v.ascender,
                                    descender: v.descender,
                                    advanceWidthMax: v.advanceWidthMax,
                                    minLeftSideBearing: v.minLeftSideBearing,
                                    minRightSideBearing: v.minRightSideBearing,
                                    xMaxExtent: v.maxLeftSideBearing + (v.xMax - v.xMin),
                                    numberOfHMetrics: e1.glyphs.length
                                }), j = $e.make(e1.glyphs.length), x = ft.make({
                                    xAvgCharWidth: Math.round(v.advanceWidthAvg),
                                    usWeightClass: e1.tables.os2.usWeightClass,
                                    usWidthClass: e1.tables.os2.usWidthClass,
                                    usFirstCharIndex: t,
                                    usLastCharIndex: u,
                                    ulUnicodeRange1: c,
                                    ulUnicodeRange2: d,
                                    ulUnicodeRange3: h,
                                    ulUnicodeRange4: f,
                                    fsSelection: e1.tables.os2.fsSelection,
                                    sTypoAscender: v.ascender,
                                    sTypoDescender: v.descender,
                                    sTypoLineGap: 0,
                                    usWinAscent: v.yMax,
                                    usWinDescent: Math.abs(v.yMin),
                                    ulCodePageRange1: 1,
                                    sxHeight: xt(e1, "xyvw", {
                                        yMax: Math.round(v.ascender / 2)
                                    }).yMax,
                                    sCapHeight: xt(e1, "HIKLEFJMNTZBDPRAGOQSUVWXY", v).yMax,
                                    usDefaultChar: e1.hasChar(" ") ? 32 : 0,
                                    usBreakChar: e1.hasChar(" ") ? 32 : 0
                                }), w = Qe.make(e1.glyphs), S = we.make(e1.glyphs), T = e1.getEnglishName("fontFamily"), E = e1.getEnglishName("fontSubfamily"), M = T + " " + E, k = (k = e1.getEnglishName("postScriptName")) || T.replace(/\s/g, "") + "-" + E, O = {};
                                for(g in e1.names)O[g] = e1.names[g];
                                O.uniqueID || (O.uniqueID = {
                                    en: e1.getEnglishName("manufacturer") + ":" + M
                                }), O.postScriptName || (O.postScriptName = {
                                    en: k
                                }), O.preferredFamily || (O.preferredFamily = e1.names.fontFamily), O.preferredSubfamily || (O.preferredSubfamily = e1.names.fontSubfamily);
                                var C = [], P = dt.make(O, C), C = 0 < C.length ? Je.make(C) : void 0, A = pt.make(), M = Ye.make(e1.glyphs, {
                                    version: e1.getEnglishName("version"),
                                    fullName: M,
                                    familyName: T,
                                    weightName: E,
                                    postScriptName: k,
                                    unitsPerEm: e1.unitsPerEm,
                                    fontBBox: [
                                        0,
                                        v.yMin,
                                        v.ascender,
                                        v.advanceWidthMax
                                    ]
                                }), T = e1.metas && 0 < Object.keys(e1.metas).length ? gt.make(e1.metas) : void 0, E = [
                                    b,
                                    _,
                                    j,
                                    x,
                                    P,
                                    S,
                                    A,
                                    M,
                                    w
                                ];
                                C && E.push(C), e1.tables.gsub && E.push(yt.make(e1.tables.gsub)), T && E.push(T);
                                for(var D = bt((k = jt(E)).encode()), L = k.fields, R = !1, I = 0; I < L.length; I += 1)if ("head table" === L[I].name) {
                                    L[I].value.checkSumAdjustment = 2981146554 - D, R = !0;
                                    break;
                                }
                                if (R) return k;
                                throw new Error("Could not find head table with checkSum to adjust.");
                            },
                            computeCheckSum: bt
                        };
                        function St(e1, t) {
                            for(var r = 0, o = e1.length - 1; r <= o;){
                                var n = r + o >>> 1, s = e1[n].tag;
                                if (s === t) return n;
                                s < t ? r = 1 + n : o = n - 1;
                            }
                            return -r - 1;
                        }
                        function Tt(e1, t) {
                            for(var r = 0, o = e1.length - 1; r <= o;){
                                var n = r + o >>> 1, s = e1[n];
                                if (s === t) return n;
                                s < t ? r = 1 + n : o = n - 1;
                            }
                            return -r - 1;
                        }
                        function Et(e1, t) {
                            for(var r = 0, o = e1.length - 1; r <= o;){
                                var n, s = r + o >>> 1, i = (n = e1[s]).start;
                                if (i === t) return n;
                                i < t ? r = 1 + s : o = s - 1;
                            }
                            if (0 < r) return t > (n = e1[r - 1]).end ? 0 : n;
                        }
                        function Mt(e1, t) {
                            this.font = e1, this.tableName = t;
                        }
                        function kt(e1) {
                            Mt.call(this, e1, "gpos");
                        }
                        function i(e1) {
                            Mt.call(this, e1, "gsub");
                        }
                        function Ot(e1, t, r) {
                            for(var o = e1.subtables, n = 0; n < o.length; n++){
                                var s = o[n];
                                if (s.substFormat === t) return s;
                            }
                            if (r) return o.push(r), r;
                        }
                        function Ct(e1) {
                            for(var t = new ArrayBuffer(e1.length), r = new Uint8Array(t), o = 0; o < e1.length; ++o)r[o] = e1[o];
                            return t;
                        }
                        function j(e1, t) {
                            if (!e1) throw t;
                        }
                        function Pt(e1, t, r, o, n) {
                            var s = 0 < (t & o) ? (s = e1.parseByte(), r + (s = 0 == (t & n) ? -s : s)) : 0 < (t & n) ? r : r + e1.parseShort();
                            return s;
                        }
                        function At(e1, t, r) {
                            var o, n = new R.Parser(t, r);
                            if (e1.numberOfContours = n.parseShort(), e1._xMin = n.parseShort(), e1._yMin = n.parseShort(), e1._xMax = n.parseShort(), e1._yMax = n.parseShort(), 0 < e1.numberOfContours) {
                                for(var s = e1.endPointIndices = [], i = 0; i < e1.numberOfContours; i += 1)s.push(n.parseUShort());
                                e1.instructionLength = n.parseUShort(), e1.instructions = [];
                                for(var a = 0; a < e1.instructionLength; a += 1)e1.instructions.push(n.parseByte());
                                for(var l = s[s.length - 1] + 1, u = [], c = 0; c < l; c += 1)if (o = n.parseByte(), u.push(o), 0 < (8 & o)) for(var d = n.parseByte(), h = 0; h < d; h += 1)u.push(o), c += 1;
                                if (L.argument(u.length === l, "Bad flags."), 0 < s.length) {
                                    var f, p = [];
                                    if (0 < l) {
                                        for(var m = 0; m < l; m += 1)o = u[m], (f = {}).onCurve = !!(1 & o), f.lastPointOfContour = 0 <= s.indexOf(m), p.push(f);
                                        for(var y = 0, g = 0; g < l; g += 1)o = u[g], (f = p[g]).x = Pt(n, o, y, 2, 16), y = f.x;
                                        for(var v = 0, b = 0; b < l; b += 1)o = u[b], (f = p[b]).y = Pt(n, o, v, 4, 32), v = f.y;
                                    }
                                    e1.points = p;
                                } else e1.points = [];
                            } else if (0 === e1.numberOfContours) e1.points = [];
                            else {
                                e1.isComposite = !0, e1.points = [], e1.components = [];
                                for(var _ = !0; _;){
                                    u = n.parseUShort();
                                    var j = {
                                        glyphIndex: n.parseUShort(),
                                        xScale: 1,
                                        scale01: 0,
                                        scale10: 0,
                                        yScale: 1,
                                        dx: 0,
                                        dy: 0
                                    };
                                    0 < (1 & u) ? 0 < (2 & u) ? (j.dx = n.parseShort(), j.dy = n.parseShort()) : j.matchedPoints = [
                                        n.parseUShort(),
                                        n.parseUShort()
                                    ] : 0 < (2 & u) ? (j.dx = n.parseChar(), j.dy = n.parseChar()) : j.matchedPoints = [
                                        n.parseByte(),
                                        n.parseByte()
                                    ], 0 < (8 & u) ? j.xScale = j.yScale = n.parseF2Dot14() : 0 < (64 & u) ? (j.xScale = n.parseF2Dot14(), j.yScale = n.parseF2Dot14()) : 0 < (128 & u) && (j.xScale = n.parseF2Dot14(), j.scale01 = n.parseF2Dot14(), j.scale10 = n.parseF2Dot14(), j.yScale = n.parseF2Dot14()), e1.components.push(j), _ = !!(32 & u);
                                }
                                if (256 & u) {
                                    e1.instructionLength = n.parseUShort(), e1.instructions = [];
                                    for(var x = 0; x < e1.instructionLength; x += 1)e1.instructions.push(n.parseByte());
                                }
                            }
                        }
                        function Lt(e1, t) {
                            for(var r = [], o = 0; o < e1.length; o += 1){
                                var n = e1[o], n = {
                                    x: t.xScale * n.x + t.scale01 * n.y + t.dx,
                                    y: t.scale10 * n.x + t.yScale * n.y + t.dy,
                                    onCurve: n.onCurve,
                                    lastPointOfContour: n.lastPointOfContour
                                };
                                r.push(n);
                            }
                            return r;
                        }
                        function Rt(e1) {
                            var t = new h;
                            if (e1) for(var r = function(e1) {
                                for(var t = [], r = [], o = 0; o < e1.length; o += 1){
                                    var n = e1[o];
                                    r.push(n), n.lastPointOfContour && (t.push(r), r = []);
                                }
                                return L.argument(0 === r.length, "There are still points left in the current contour."), t;
                            }(e1), o = 0; o < r.length; ++o){
                                var n, s = r[o], i = s[s.length - 1], a = s[0];
                                i.onCurve ? t.moveTo(i.x, i.y) : a.onCurve ? t.moveTo(a.x, a.y) : (n = {
                                    x: .5 * (i.x + a.x),
                                    y: .5 * (i.y + a.y)
                                }, t.moveTo(n.x, n.y));
                                for(var l = 0; l < s.length; ++l){
                                    var u, c = i, i = a, a = s[(l + 1) % s.length];
                                    i.onCurve ? t.lineTo(i.x, i.y) : (u = a, c.onCurve || (i.x, c.x, i.y, c.y), a.onCurve || (u = {
                                        x: .5 * (i.x + a.x),
                                        y: .5 * (i.y + a.y)
                                    }), t.quadraticCurveTo(i.x, i.y, u.x, u.y));
                                }
                                t.closePath();
                            }
                            return t;
                        }
                        function It(e1, t) {
                            if (t.isComposite) for(var r = 0; r < t.components.length; r += 1){
                                var o = t.components[r], n = e1.get(o.glyphIndex);
                                if (n.getPath(), n.points) {
                                    var s = void 0;
                                    if (void 0 === o.matchedPoints) s = Lt(n.points, o);
                                    else {
                                        if (o.matchedPoints[0] > t.points.length - 1 || o.matchedPoints[1] > n.points.length - 1) throw Error("Matched points out of range in " + t.name);
                                        var i = t.points[o.matchedPoints[0]], a = n.points[o.matchedPoints[1]], o = {
                                            xScale: o.xScale,
                                            scale01: o.scale01,
                                            scale10: o.scale10,
                                            yScale: o.yScale,
                                            dx: 0,
                                            dy: 0
                                        }, a = Lt([
                                            a
                                        ], o)[0];
                                        o.dx = i.x - a.x, o.dy = i.y - a.y, s = Lt(n.points, o);
                                    }
                                    t.points = t.points.concat(s);
                                }
                            }
                            return Rt(t.points);
                        }
                        (kt.prototype = Mt.prototype = {
                            searchTag: St,
                            binSearch: Tt,
                            getTable: function(e1) {
                                var t = this.font.tables[this.tableName];
                                return t = !t && e1 ? this.font.tables[this.tableName] = this.createDefaultTable() : t;
                            },
                            getScriptNames: function() {
                                var e1 = this.getTable();
                                return e1 ? e1.scripts.map(function(e1) {
                                    return e1.tag;
                                }) : [];
                            },
                            getDefaultScriptName: function() {
                                var e1 = this.getTable();
                                if (e1) {
                                    for(var t = !1, r = 0; r < e1.scripts.length; r++){
                                        var o = e1.scripts[r].tag;
                                        if ("DFLT" === o) return o;
                                        "latn" === o && (t = !0);
                                    }
                                    return t ? "latn" : void 0;
                                }
                            },
                            getScriptTable: function(e1, t) {
                                var r, o = this.getTable(t);
                                if (o) return r = o.scripts, 0 <= (o = St(o.scripts, e1 = e1 || "DFLT")) ? r[o].script : t ? (r.splice(-1 - o, 0, t = {
                                    tag: e1,
                                    script: {
                                        defaultLangSys: {
                                            reserved: 0,
                                            reqFeatureIndex: 65535,
                                            featureIndexes: []
                                        },
                                        langSysRecords: []
                                    }
                                }), t.script) : void 0;
                            },
                            getLangSysTable: function(e1, t, r) {
                                var o, e1 = this.getScriptTable(e1, r);
                                if (e1) return t && "dflt" !== t && "DFLT" !== t ? 0 <= (o = St(e1.langSysRecords, t)) ? e1.langSysRecords[o].langSys : r ? (e1.langSysRecords.splice(-1 - o, 0, r = {
                                    tag: t,
                                    langSys: {
                                        reserved: 0,
                                        reqFeatureIndex: 65535,
                                        featureIndexes: []
                                    }
                                }), r.langSys) : void 0 : e1.defaultLangSys;
                            },
                            getFeatureTable: function(e1, t, r, o) {
                                e1 = this.getLangSysTable(e1, t, o);
                                if (e1) {
                                    for(var n, s = e1.featureIndexes, i = this.font.tables[this.tableName].features, a = 0; a < s.length; a++)if ((n = i[s[a]]).tag === r) return n.feature;
                                    if (o) return t = i.length, L.assert(0 === t || r >= i[t - 1].tag, "Features must be added in alphabetical order."), i.push(n = {
                                        tag: r,
                                        feature: {
                                            params: 0,
                                            lookupListIndexes: []
                                        }
                                    }), s.push(t), n.feature;
                                }
                            },
                            getLookupTables: function(e1, t, r, o, n) {
                                var e1 = this.getFeatureTable(e1, t, r, n), s = [];
                                if (e1) {
                                    for(var i, a = e1.lookupListIndexes, l = this.font.tables[this.tableName].lookups, u = 0; u < a.length; u++)(i = l[a[u]]).lookupType === o && s.push(i);
                                    if (0 === s.length && n) return t = l.length, l.push(i = {
                                        lookupType: o,
                                        lookupFlag: 0,
                                        subtables: [],
                                        markFilteringSet: void 0
                                    }), a.push(t), [
                                        i
                                    ];
                                }
                                return s;
                            },
                            getGlyphClass: function(e1, t) {
                                switch(e1.format){
                                    case 1:
                                        return e1.startGlyph <= t && t < e1.startGlyph + e1.classes.length ? e1.classes[t - e1.startGlyph] : 0;
                                    case 2:
                                        var r = Et(e1.ranges, t);
                                        return r ? r.classId : 0;
                                }
                            },
                            getCoverageIndex: function(e1, t) {
                                switch(e1.format){
                                    case 1:
                                        var r = Tt(e1.glyphs, t);
                                        return 0 <= r ? r : -1;
                                    case 2:
                                        r = Et(e1.ranges, t);
                                        return r ? r.index + t - r.start : -1;
                                }
                            },
                            expandCoverage: function(e1) {
                                if (1 === e1.format) return e1.glyphs;
                                for(var t = [], r = e1.ranges, o = 0; o < r.length; o++)for(var n = r[o], s = n.start, i = n.end, a = s; a <= i; a++)t.push(a);
                                return t;
                            }
                        }).init = function() {
                            var e1 = this.getDefaultScriptName();
                            this.defaultKerningTables = this.getKerningTables(e1);
                        }, kt.prototype.getKerningValue = function(e1, t, r) {
                            for(var o = 0; o < e1.length; o++)for(var n = e1[o].subtables, s = 0; s < n.length; s++){
                                var i = n[s], a = this.getCoverageIndex(i.coverage, t);
                                if (!(a < 0)) switch(i.posFormat){
                                    case 1:
                                        for(var l = i.pairSets[a], u = 0; u < l.length; u++){
                                            var c = l[u];
                                            if (c.secondGlyph === r) return c.value1 && c.value1.xAdvance || 0;
                                        }
                                        break;
                                    case 2:
                                        var d = this.getGlyphClass(i.classDef1, t), h = this.getGlyphClass(i.classDef2, r), d = i.classRecords[d][h];
                                        return d.value1 && d.value1.xAdvance || 0;
                                }
                            }
                            return 0;
                        }, kt.prototype.getKerningTables = function(e1, t) {
                            if (this.font.tables.gpos) return this.getLookupTables(e1, t, "kern", 2);
                        }, (i.prototype = Mt.prototype).createDefaultTable = function() {
                            return {
                                version: 1,
                                scripts: [
                                    {
                                        tag: "DFLT",
                                        script: {
                                            defaultLangSys: {
                                                reserved: 0,
                                                reqFeatureIndex: 65535,
                                                featureIndexes: []
                                            },
                                            langSysRecords: []
                                        }
                                    }
                                ],
                                features: [],
                                lookups: []
                            };
                        }, i.prototype.getSingle = function(e1, t, r) {
                            for(var o = [], n = this.getLookupTables(t, r, e1, 1), s = 0; s < n.length; s++)for(var i = n[s].subtables, a = 0; a < i.length; a++){
                                var l = i[a], u = this.expandCoverage(l.coverage), c = void 0;
                                if (1 === l.substFormat) for(var d = l.deltaGlyphId, c = 0; c < u.length; c++){
                                    var h = u[c];
                                    o.push({
                                        sub: h,
                                        by: h + d
                                    });
                                }
                                else {
                                    var f = l.substitute;
                                    for(c = 0; c < u.length; c++)o.push({
                                        sub: u[c],
                                        by: f[c]
                                    });
                                }
                            }
                            return o;
                        }, i.prototype.getAlternates = function(e1, t, r) {
                            for(var o = [], n = this.getLookupTables(t, r, e1, 3), s = 0; s < n.length; s++)for(var i = n[s].subtables, a = 0; a < i.length; a++)for(var l = i[a], u = this.expandCoverage(l.coverage), c = l.alternateSets, d = 0; d < u.length; d++)o.push({
                                sub: u[d],
                                by: c[d]
                            });
                            return o;
                        }, i.prototype.getLigatures = function(e1, t, r) {
                            for(var o = [], n = this.getLookupTables(t, r, e1, 4), s = 0; s < n.length; s++)for(var i = n[s].subtables, a = 0; a < i.length; a++)for(var l = i[a], u = this.expandCoverage(l.coverage), c = l.ligatureSets, d = 0; d < u.length; d++)for(var h = u[d], f = c[d], p = 0; p < f.length; p++){
                                var m = f[p];
                                o.push({
                                    sub: [
                                        h
                                    ].concat(m.components),
                                    by: m.ligGlyph
                                });
                            }
                            return o;
                        }, i.prototype.addSingle = function(e1, t, r, o) {
                            r = Ot(this.getLookupTables(r, o, e1, 1, !0)[0], 2, {
                                substFormat: 2,
                                coverage: {
                                    format: 1,
                                    glyphs: []
                                },
                                substitute: []
                            }), L.assert(1 === r.coverage.format, "Ligature: unable to modify coverage table format " + r.coverage.format), o = t.sub, e1 = this.binSearch(r.coverage.glyphs, o);
                            e1 < 0 && (r.coverage.glyphs.splice(e1 = -1 - e1, 0, o), r.substitute.splice(e1, 0, 0)), r.substitute[e1] = t.by;
                        }, i.prototype.addAlternate = function(e1, t, r, o) {
                            r = Ot(this.getLookupTables(r, o, e1, 3, !0)[0], 1, {
                                substFormat: 1,
                                coverage: {
                                    format: 1,
                                    glyphs: []
                                },
                                alternateSets: []
                            }), L.assert(1 === r.coverage.format, "Ligature: unable to modify coverage table format " + r.coverage.format), o = t.sub, e1 = this.binSearch(r.coverage.glyphs, o);
                            e1 < 0 && (r.coverage.glyphs.splice(e1 = -1 - e1, 0, o), r.alternateSets.splice(e1, 0, 0)), r.alternateSets[e1] = t.by;
                        }, i.prototype.addLigature = function(e1, t, r, o) {
                            var r = this.getLookupTables(r, o, e1, 4, !0)[0], o = r.subtables[0], e1 = (o || (r.subtables[0] = o = {
                                substFormat: 1,
                                coverage: {
                                    format: 1,
                                    glyphs: []
                                },
                                ligatureSets: []
                            }), L.assert(1 === o.coverage.format, "Ligature: unable to modify coverage table format " + o.coverage.format), t.sub[0]), n = t.sub.slice(1), r = {
                                ligGlyph: t.by,
                                components: n
                            }, t = this.binSearch(o.coverage.glyphs, e1);
                            if (0 <= t) {
                                for(var s = o.ligatureSets[t], i = 0; i < s.length; i++)if (function(e1, t) {
                                    var r = e1.length;
                                    if (r === t.length) {
                                        for(var o = 0; o < r; o++)if (e1[o] !== t[o]) return;
                                        return 1;
                                    }
                                }(s[i].components, n)) return;
                                s.push(r);
                            } else o.coverage.glyphs.splice(t = -1 - t, 0, e1), o.ligatureSets.splice(t, 0, [
                                r
                            ]);
                        }, i.prototype.getFeature = function(e1, t, r) {
                            if (/ss\d\d/.test(e1)) return this.getSingle(e1, t, r);
                            switch(e1){
                                case "aalt":
                                case "salt":
                                    return this.getSingle(e1, t, r).concat(this.getAlternates(e1, t, r));
                                case "dlig":
                                case "liga":
                                case "rlig":
                                    return this.getLigatures(e1, t, r);
                            }
                        }, i.prototype.add = function(e1, t, r, o) {
                            if (/ss\d\d/.test(e1)) return this.addSingle(e1, t, r, o);
                            switch(e1){
                                case "aalt":
                                case "salt":
                                    return "number" == typeof t.by ? this.addSingle(e1, t, r, o) : this.addAlternate(e1, t, r, o);
                                case "dlig":
                                case "liga":
                                case "rlig":
                                    return this.addLigature(e1, t, r, o);
                            }
                        };
                        var Dt = {
                            getPath: Rt,
                            parse: function(e1, t, r, o) {
                                for(var n = new p.GlyphSet(o), s = 0; s < r.length - 1; s += 1){
                                    var i = r[s];
                                    i !== r[s + 1] ? n.push(s, p.ttfGlyphLoader(o, s, At, e1, t + i, It)) : n.push(s, p.glyphLoader(o, s));
                                }
                                return n;
                            }
                        };
                        function Ft(e1) {
                            this.font = e1, this.getCommands = function(e1) {
                                return Dt.getPath(e1).commands;
                            }, this._fpgmState = this._prepState = void 0, this._errorState = 0;
                        }
                        function Ut(e1) {
                            return e1;
                        }
                        function Nt(e1) {
                            return Math.sign(e1) * Math.round(Math.abs(e1));
                        }
                        function Bt(e1) {
                            return Math.sign(e1) * Math.round(Math.abs(2 * e1)) / 2;
                        }
                        function Gt(e1) {
                            return Math.sign(e1) * (Math.round(Math.abs(e1) + .5) - .5);
                        }
                        function Vt(e1) {
                            return Math.sign(e1) * Math.ceil(Math.abs(e1));
                        }
                        function zt(e1) {
                            return Math.sign(e1) * Math.floor(Math.abs(e1));
                        }
                        function Ht(e1) {
                            var t = this.srPeriod, r = this.srPhase, o = 1;
                            return e1 < 0 && (e1 = -e1, o = -1), e1 += this.srThreshold - r, e1 = Math.trunc(e1 / t) * t, (e1 += r) < 0 ? r * o : e1 * o;
                        }
                        var x = {
                            x: 1,
                            y: 0,
                            axis: "x",
                            distance: function(e1, t, r, o) {
                                return (r ? e1.xo : e1.x) - (o ? t.xo : t.x);
                            },
                            interpolate: function(e1, t, r, o) {
                                var n, s, i, a, l, u, c;
                                if (!o || o === this) return n = e1.xo - t.xo, s = e1.xo - r.xo, l = t.x - t.xo, u = r.x - r.xo, 0 === (c = (i = Math.abs(n)) + (a = Math.abs(s))) ? void (e1.x = e1.xo + (l + u) / 2) : void (e1.x = e1.xo + (l * a + u * i) / c);
                                n = o.distance(e1, t, !0, !0), s = o.distance(e1, r, !0, !0), l = o.distance(t, t, !1, !0), u = o.distance(r, r, !1, !0), 0 === (c = (i = Math.abs(n)) + (a = Math.abs(s))) ? x.setRelative(e1, e1, (l + u) / 2, o, !0) : x.setRelative(e1, e1, (l * a + u * i) / c, o, !0);
                            },
                            normalSlope: Number.NEGATIVE_INFINITY,
                            setRelative: function(e1, t, r, o, n) {
                                var s, i;
                                o && o !== this ? (s = n ? t.xo : t.x, i = n ? t.yo : t.y, s += r * o.x, i += r * o.y, e1.x = s + (e1.y - i) / o.normalSlope) : e1.x = (n ? t.xo : t.x) + r;
                            },
                            slope: 0,
                            touch: function(e1) {
                                e1.xTouched = !0;
                            },
                            touched: function(e1) {
                                return e1.xTouched;
                            },
                            untouch: function(e1) {
                                e1.xTouched = !1;
                            }
                        }, T = {
                            x: 0,
                            y: 1,
                            axis: "y",
                            distance: function(e1, t, r, o) {
                                return (r ? e1.yo : e1.y) - (o ? t.yo : t.y);
                            },
                            interpolate: function(e1, t, r, o) {
                                var n, s, i, a, l, u, c;
                                if (!o || o === this) return n = e1.yo - t.yo, s = e1.yo - r.yo, l = t.y - t.yo, u = r.y - r.yo, 0 === (c = (i = Math.abs(n)) + (a = Math.abs(s))) ? void (e1.y = e1.yo + (l + u) / 2) : void (e1.y = e1.yo + (l * a + u * i) / c);
                                n = o.distance(e1, t, !0, !0), s = o.distance(e1, r, !0, !0), l = o.distance(t, t, !1, !0), u = o.distance(r, r, !1, !0), 0 === (c = (i = Math.abs(n)) + (a = Math.abs(s))) ? T.setRelative(e1, e1, (l + u) / 2, o, !0) : T.setRelative(e1, e1, (l * a + u * i) / c, o, !0);
                            },
                            normalSlope: 0,
                            setRelative: function(e1, t, r, o, n) {
                                var s, i;
                                o && o !== this ? (s = n ? t.xo : t.x, i = n ? t.yo : t.y, s += r * o.x, i += r * o.y, e1.y = i + o.normalSlope * (e1.x - s)) : e1.y = (n ? t.yo : t.y) + r;
                            },
                            slope: Number.POSITIVE_INFINITY,
                            touch: function(e1) {
                                e1.yTouched = !0;
                            },
                            touched: function(e1) {
                                return e1.yTouched;
                            },
                            untouch: function(e1) {
                                e1.yTouched = !1;
                            }
                        };
                        function Wt(e1, t) {
                            this.x = e1, this.y = t, this.axis = void 0, this.slope = t / e1, this.normalSlope = -e1 / t, Object.freeze(this);
                        }
                        function qt(e1, t) {
                            var r = Math.sqrt(e1 * e1 + t * t);
                            return t /= r, 1 === (e1 /= r) && 0 === t ? x : 0 === e1 && 1 === t ? T : new Wt(e1, t);
                        }
                        function E(e1, t, r, o) {
                            this.x = this.xo = Math.round(64 * e1) / 64, this.y = this.yo = Math.round(64 * t) / 64, this.lastPointOfContour = r, this.onCurve = o, this.prevPointOnContour = void 0, this.nextPointOnContour = void 0, this.xTouched = !1, this.yTouched = !1, Object.preventExtensions(this);
                        }
                        Object.freeze(x), Object.freeze(T), Wt.prototype.distance = function(e1, t, r, o) {
                            return this.x * x.distance(e1, t, r, o) + this.y * T.distance(e1, t, r, o);
                        }, Wt.prototype.interpolate = function(e1, t, r, o) {
                            var n = o.distance(e1, t, !0, !0), s = o.distance(e1, r, !0, !0), t = o.distance(t, t, !1, !0), r = o.distance(r, r, !1, !0), n = Math.abs(n), s = Math.abs(s), i = n + s;
                            0 === i ? this.setRelative(e1, e1, (t + r) / 2, o, !0) : this.setRelative(e1, e1, (t * s + r * n) / i, o, !0);
                        }, Wt.prototype.setRelative = function(e1, t, r, o, n) {
                            var s = n ? t.xo : t.x, n = n ? t.yo : t.y, t = s + r * (o = o || this).x, s = n + r * o.y, n = o.normalSlope, r = this.slope, o = e1.x, i = e1.y;
                            e1.x = (r * o - n * t + s - i) / (r - n), e1.y = r * (e1.x - o) + i;
                        }, Wt.prototype.touch = function(e1) {
                            e1.xTouched = !0, e1.yTouched = !0;
                        }, E.prototype.nextTouched = function(e1) {
                            for(var t = this.nextPointOnContour; !e1.touched(t) && t !== this;)t = t.nextPointOnContour;
                            return t;
                        }, E.prototype.prevTouched = function(e1) {
                            for(var t = this.prevPointOnContour; !e1.touched(t) && t !== this;)t = t.prevPointOnContour;
                            return t;
                        };
                        var Xt = Object.freeze(new E(0, 0)), Yt = {
                            cvCutIn: 17 / 16,
                            deltaBase: 9,
                            deltaShift: .125,
                            loop: 1,
                            minDis: 1,
                            autoFlip: !0
                        };
                        function M(e1, t) {
                            switch(this.env = e1, this.stack = [], this.prog = t, e1){
                                case "glyf":
                                    this.zp0 = this.zp1 = this.zp2 = 1, this.rp0 = this.rp1 = this.rp2 = 0;
                                case "prep":
                                    this.fv = this.pv = this.dpv = x, this.round = Nt;
                            }
                        }
                        function Zt(e1) {
                            for(var t = e1.tZone = new Array(e1.gZone.length), r = 0; r < t.length; r++)t[r] = new E(0, 0);
                        }
                        function Kt(e1, t) {
                            var r, o = e1.prog, n = e1.ip, s = 1;
                            do {
                                if (88 === (r = o[++n])) s++;
                                else if (89 === r) s--;
                                else if (64 === r) n += o[n + 1] + 1;
                                else if (65 === r) n += 2 * o[n + 1] + 1;
                                else if (176 <= r && r <= 183) n += r - 176 + 1;
                                else if (184 <= r && r <= 191) n += 2 * (r - 184 + 1);
                                else if (t && 1 === s && 27 === r) break;
                            }while (0 < s);
                            e1.ip = n;
                        }
                        function Qt(e1, t) {
                            _.DEBUG && console.log(t.step, "SVTCA[" + e1.axis + "]"), t.fv = t.pv = t.dpv = e1;
                        }
                        function Jt(e1, t) {
                            _.DEBUG && console.log(t.step, "SPVTCA[" + e1.axis + "]"), t.pv = t.dpv = e1;
                        }
                        function $t(e1, t) {
                            _.DEBUG && console.log(t.step, "SFVTCA[" + e1.axis + "]"), t.fv = e1;
                        }
                        function er(e1, t) {
                            var r, o = t.stack, n = o.pop(), o = o.pop(), s = t.z2[n], i = t.z1[o];
                            _.DEBUG && console.log("SPVTL[" + e1 + "]", n, o), n = e1 ? (r = s.y - i.y, i.x - s.x) : (r = i.x - s.x, i.y - s.y), t.pv = t.dpv = qt(r, n);
                        }
                        function tr(e1, t) {
                            var r, o = t.stack, n = o.pop(), o = o.pop(), s = t.z2[n], i = t.z1[o];
                            _.DEBUG && console.log("SFVTL[" + e1 + "]", n, o), n = e1 ? (r = s.y - i.y, i.x - s.x) : (r = i.x - s.x, i.y - s.y), t.fv = qt(r, n);
                        }
                        function rr(e1) {
                            _.DEBUG && console.log(e1.step, "POP[]"), e1.stack.pop();
                        }
                        function or(e1, t) {
                            var r = t.stack.pop(), o = t.z0[r], n = t.fv, s = t.pv, i = (_.DEBUG && console.log(t.step, "MDAP[" + e1 + "]", r), s.distance(o, Xt));
                            e1 && (i = t.round(i)), n.setRelative(o, Xt, i, s), n.touch(o), t.rp0 = t.rp1 = r;
                        }
                        function nr(e1, t) {
                            var r, o, n, s = t.z2, i = s.length - 2;
                            _.DEBUG && console.log(t.step, "IUP[" + e1.axis + "]");
                            for(var a = 0; a < i; a++)r = s[a], e1.touched(r) || (o = r.prevTouched(e1)) !== r && (o === (n = r.nextTouched(e1)) && e1.setRelative(r, r, e1.distance(o, o, !1, !0), e1, !0), e1.interpolate(r, o, n, e1));
                        }
                        function sr(e1, t) {
                            for(var r = t.stack, o = e1 ? t.rp1 : t.rp2, n = (e1 ? t.z0 : t.z1)[o], s = t.fv, i = t.pv, a = t.loop, l = t.z2; a--;){
                                var u = r.pop(), c = l[u], d = i.distance(n, n, !1, !0);
                                s.setRelative(c, c, d, i), s.touch(c), _.DEBUG && console.log(t.step, (1 < t.loop ? "loop " + (t.loop - a) + ": " : "") + "SHP[" + (e1 ? "rp1" : "rp2") + "]", u);
                            }
                            t.loop = 1;
                        }
                        function ir(e1, t) {
                            for(var r = t.stack, o = e1 ? t.rp1 : t.rp2, n = (e1 ? t.z0 : t.z1)[o], s = t.fv, i = t.pv, o = r.pop(), a = t.z2[t.contours[o]], l = a, u = (_.DEBUG && console.log(t.step, "SHC[" + e1 + "]", o), i.distance(n, n, !1, !0)); l !== n && s.setRelative(l, l, u, i), (l = l.nextPointOnContour) !== a;);
                        }
                        function ar(e1, t) {
                            var r, o, n = t.stack, s = e1 ? t.rp1 : t.rp2, s = (e1 ? t.z0 : t.z1)[s], i = t.fv, a = t.pv, n = n.pop();
                            switch(_.DEBUG && console.log(t.step, "SHZ[" + e1 + "]", n), n){
                                case 0:
                                    r = t.tZone;
                                    break;
                                case 1:
                                    r = t.gZone;
                                    break;
                                default:
                                    throw new Error("Invalid zone");
                            }
                            for(var l = a.distance(s, s, !1, !0), u = r.length - 2, c = 0; c < u; c++)o = r[c], i.setRelative(o, o, l, a);
                        }
                        function lr(e1, t) {
                            var r = t.stack, o = r.pop() / 64, r = r.pop(), n = t.z1[r], s = t.z0[t.rp0], i = t.fv, a = t.pv;
                            i.setRelative(n, s, o, a), i.touch(n), _.DEBUG && console.log(t.step, "MSIRP[" + e1 + "]", o, r), t.rp1 = t.rp0, t.rp2 = r, e1 && (t.rp0 = r);
                        }
                        function ur(e1, t) {
                            var r = t.stack, o = r.pop(), r = r.pop(), n = t.z0[r], s = t.fv, i = t.pv, a = t.cvt[o], o = (_.DEBUG && console.log(t.step, "MIAP[" + e1 + "]", o, "(", a, ")", r), i.distance(n, Xt));
                            e1 && (Math.abs(o - a) < t.cvCutIn && (o = a), o = t.round(o)), s.setRelative(n, Xt, o, i), 0 === t.zp0 && (n.xo = n.x, n.yo = n.y), s.touch(n), t.rp0 = t.rp1 = r;
                        }
                        function cr(e1, t) {
                            var r = t.stack, o = r.pop(), n = t.z2[o];
                            _.DEBUG && console.log(t.step, "GC[" + e1 + "]", o), r.push(64 * t.dpv.distance(n, Xt, e1, !1));
                        }
                        function dr(e1, t) {
                            var r = t.stack, o = r.pop(), r = r.pop(), n = t.z1[o], s = t.z0[r], s = t.dpv.distance(s, n, e1, e1);
                            _.DEBUG && console.log(t.step, "MD[" + e1 + "]", o, r, "->", s), t.stack.push(Math.round(64 * s));
                        }
                        function hr(e1, t) {
                            var r = t.stack, o = r.pop(), n = t.fv, s = t.pv, i = t.ppem, a = t.deltaBase + 16 * (e1 - 1), l = t.deltaShift, u = t.z0;
                            _.DEBUG && console.log(t.step, "DELTAP[" + e1 + "]", o, r);
                            for(var c = 0; c < o; c++){
                                var d = r.pop(), h = r.pop();
                                a + ((240 & h) >> 4) === i && (0 <= (h = (15 & h) - 8) && h++, _.DEBUG && console.log(t.step, "DELTAPFIX", d, "by", h * l), d = u[d], n.setRelative(d, d, h * l, s));
                            }
                        }
                        function fr(e1, t) {
                            var r = t.stack, o = r.pop();
                            _.DEBUG && console.log(t.step, "ROUND[]"), r.push(64 * t.round(o / 64));
                        }
                        function pr(e1, t) {
                            var r = t.stack, o = r.pop(), n = t.ppem, s = t.deltaBase + 16 * (e1 - 1), i = t.deltaShift;
                            _.DEBUG && console.log(t.step, "DELTAC[" + e1 + "]", o, r);
                            for(var a = 0; a < o; a++){
                                var l = r.pop(), u = r.pop();
                                s + ((240 & u) >> 4) === n && (0 <= (u = (15 & u) - 8) && u++, u = u * i, _.DEBUG && console.log(t.step, "DELTACFIX", l, "by", u), t.cvt[l] += u);
                            }
                        }
                        function mr(e1, t) {
                            var r, o = t.stack, n = o.pop(), o = o.pop(), s = t.z2[n], i = t.z1[o];
                            _.DEBUG && console.log(t.step, "SDPVTL[" + e1 + "]", n, o), n = e1 ? (r = s.y - i.y, i.x - s.x) : (r = i.x - s.x, i.y - s.y), t.dpv = qt(r, n);
                        }
                        function k(e1, t) {
                            var r = t.stack, o = t.prog, n = t.ip;
                            _.DEBUG && console.log(t.step, "PUSHB[" + e1 + "]");
                            for(var s = 0; s < e1; s++)r.push(o[++n]);
                            t.ip = n;
                        }
                        function O(e1, t) {
                            var r = t.ip, o = t.prog, n = t.stack;
                            _.DEBUG && console.log(t.ip, "PUSHW[" + e1 + "]");
                            for(var s = 0; s < e1; s++){
                                var i = o[++r] << 8 | o[++r];
                                32768 & i && (i = -(1 + (65535 ^ i))), n.push(i);
                            }
                            t.ip = r;
                        }
                        function C(e1, t, r, o, n, s) {
                            var i, a, l = s.stack, u = e1 && l.pop(), l = l.pop(), c = s.rp0, c = s.z0[c], d = s.z1[l], h = s.minDis, f = s.fv, p = s.dpv, m = i = p.distance(d, c, !0, !0), y = 0 <= m ? 1 : -1;
                            m = Math.abs(m), e1 && (a = s.cvt[u], o && Math.abs(m - a) < s.cvCutIn && (m = a)), r && m < h && (m = h), o && (m = s.round(m)), f.setRelative(d, c, y * m, p), f.touch(d), _.DEBUG && console.log(s.step, (e1 ? "MIRP[" : "MDRP[") + (t ? "M" : "m") + (r ? ">" : "_") + (o ? "R" : "_") + (0 === n ? "Gr" : 1 === n ? "Bl" : 2 === n ? "Wh" : "") + "]", e1 ? u + "(" + s.cvt[u] + "," + a + ")" : "", l, "(d =", i, "->", y * m, ")"), s.rp1 = s.rp0, s.rp2 = l, t && (s.rp0 = l);
                        }
                        Ft.prototype.exec = function(e1, t) {
                            if ("number" != typeof t) throw new Error("Point size is not a number!");
                            if (!(2 < this._errorState)) {
                                var r = this.font, o = this._prepState;
                                if (!o || o.ppem !== t) {
                                    var n = this._fpgmState;
                                    if (!n) {
                                        M.prototype = Yt, (n = this._fpgmState = new M("fpgm", r.tables.fpgm)).funcs = [], n.font = r, _.DEBUG && (console.log("---EXEC FPGM---"), n.step = -1);
                                        try {
                                            vr(n);
                                        } catch (e1) {
                                            return console.log("Hinting error in FPGM:" + e1), void (this._errorState = 3);
                                        }
                                    }
                                    M.prototype = n, (o = this._prepState = new M("prep", r.tables.prep)).ppem = t;
                                    var s = r.tables.cvt;
                                    if (s) for(var i = o.cvt = new Array(s.length), a = t / r.unitsPerEm, l = 0; l < s.length; l++)i[l] = s[l] * a;
                                    else o.cvt = [];
                                    _.DEBUG && (console.log("---EXEC PREP---"), o.step = -1);
                                    try {
                                        vr(o);
                                    } catch (e1) {
                                        this._errorState < 2 && console.log("Hinting error in PREP:" + e1), this._errorState = 2;
                                    }
                                }
                                if (!(1 < this._errorState)) try {
                                    return yr(e1, o);
                                } catch (e1) {
                                    this._errorState < 1 && (console.log("Hinting error:" + e1), console.log("Note: further hinting errors are silenced")), this._errorState = 1;
                                }
                            }
                        };
                        var yr = function(e1, t) {
                            var r = t.ppem / t.font.unitsPerEm, o = r, n = e1.components;
                            if (M.prototype = t, n) {
                                for(var s = t.font, i = [], a = [], l = 0; l < n.length; l++){
                                    var u = n[l], c = s.glyphs.get(u.glyphIndex), d = new M("glyf", c.instructions);
                                    _.DEBUG && (console.log("---EXEC COMP " + l + "---"), d.step = -1), gr(c, d, r, o);
                                    for(var h = Math.round(u.dx * r), f = Math.round(u.dy * o), p = d.gZone, m = d.contours, y = 0; y < p.length; y++){
                                        var g = p[y];
                                        g.xTouched = g.yTouched = !1, g.xo = g.x = g.x + h, g.yo = g.y = g.y + f;
                                    }
                                    var v = i.length;
                                    i.push.apply(i, p);
                                    for(var b = 0; b < m.length; b++)a.push(m[b] + v);
                                }
                                e1.instructions && !d.inhibitGridFit && ((d = new M("glyf", e1.instructions)).gZone = d.z0 = d.z1 = d.z2 = i, d.contours = a, i.push(new E(0, 0), new E(Math.round(e1.advanceWidth * r), 0)), _.DEBUG && (console.log("---EXEC COMPOSITE---"), d.step = -1), vr(d), i.length -= 2);
                            } else d = new M("glyf", e1.instructions), _.DEBUG && (console.log("---EXEC GLYPH---"), d.step = -1), gr(e1, d, r, o), i = d.gZone;
                            return i;
                        }, gr = function(e1, t, r, o) {
                            for(var n, s, i, a = e1.points || [], l = a.length, u = t.gZone = t.z0 = t.z1 = t.z2 = [], c = t.contours = [], d = 0; d < l; d++)n = a[d], u[d] = new E(n.x * r, n.y * o, n.lastPointOfContour, n.onCurve);
                            for(var h = 0; h < l; h++)n = u[h], s || (s = n, c.push(h)), n.lastPointOfContour ? ((n.nextPointOnContour = s).prevPointOnContour = n, s = void 0) : (i = u[h + 1], (n.nextPointOnContour = i).prevPointOnContour = n);
                            if (!t.inhibitGridFit) {
                                if (_.DEBUG) {
                                    console.log("PROCESSING GLYPH", t.stack);
                                    for(var f = 0; f < l; f++)console.log(f, u[f].x, u[f].y);
                                }
                                if (u.push(new E(0, 0), new E(Math.round(e1.advanceWidth * r), 0)), vr(t), u.length -= 2, _.DEBUG) {
                                    console.log("FINISHED GLYPH", t.stack);
                                    for(var p = 0; p < l; p++)console.log(p, u[p].x, u[p].y);
                                }
                            }
                        }, vr = function(e1) {
                            var t = e1.prog;
                            if (t) {
                                var r, o = t.length;
                                for(e1.ip = 0; e1.ip < o; e1.ip++){
                                    if (_.DEBUG && e1.step++, !(r = br[t[e1.ip]])) throw new Error("unknown instruction: 0x" + Number(t[e1.ip]).toString(16));
                                    r(e1);
                                }
                            }
                        }, br = [
                            Qt.bind(void 0, T),
                            Qt.bind(void 0, x),
                            Jt.bind(void 0, T),
                            Jt.bind(void 0, x),
                            $t.bind(void 0, T),
                            $t.bind(void 0, x),
                            er.bind(void 0, 0),
                            er.bind(void 0, 1),
                            tr.bind(void 0, 0),
                            tr.bind(void 0, 1),
                            function(e1) {
                                var t = (r = e1.stack).pop(), r = r.pop();
                                _.DEBUG && console.log(e1.step, "SPVFS[]", t, r), e1.pv = e1.dpv = qt(r, t);
                            },
                            function(e1) {
                                var t = (r = e1.stack).pop(), r = r.pop();
                                _.DEBUG && console.log(e1.step, "SPVFS[]", t, r), e1.fv = qt(r, t);
                            },
                            function(e1) {
                                var t = e1.stack, r = e1.pv;
                                _.DEBUG && console.log(e1.step, "GPV[]"), t.push(16384 * r.x), t.push(16384 * r.y);
                            },
                            function(e1) {
                                var t = e1.stack, r = e1.fv;
                                _.DEBUG && console.log(e1.step, "GFV[]"), t.push(16384 * r.x), t.push(16384 * r.y);
                            },
                            function(e1) {
                                e1.fv = e1.pv, _.DEBUG && console.log(e1.step, "SFVTPV[]");
                            },
                            function(e1) {
                                var t = (s = e1.stack).pop(), r = s.pop(), o = s.pop(), n = s.pop(), s = s.pop(), i = e1.z0, a = e1.z1, l = i[t], i = i[r], u = a[o], a = a[n], e1 = e1.z2[s], t = (_.DEBUG && console.log("ISECT[], ", t, r, o, n, s), l.x), r = l.y, o = i.x, n = i.y, s = u.x, l = u.y, i = a.x, u = a.y, a = (t - o) * (l - u) - (r - n) * (s - i), c = t * n - r * o, d = s * u - l * i;
                                e1.x = (c * (s - i) - d * (t - o)) / a, e1.y = (c * (l - u) - d * (r - n)) / a;
                            },
                            function(e1) {
                                e1.rp0 = e1.stack.pop(), _.DEBUG && console.log(e1.step, "SRP0[]", e1.rp0);
                            },
                            function(e1) {
                                e1.rp1 = e1.stack.pop(), _.DEBUG && console.log(e1.step, "SRP1[]", e1.rp1);
                            },
                            function(e1) {
                                e1.rp2 = e1.stack.pop(), _.DEBUG && console.log(e1.step, "SRP2[]", e1.rp2);
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                switch(_.DEBUG && console.log(e1.step, "SZP0[]", t), e1.zp0 = t){
                                    case 0:
                                        e1.tZone || Zt(e1), e1.z0 = e1.tZone;
                                        break;
                                    case 1:
                                        e1.z0 = e1.gZone;
                                        break;
                                    default:
                                        throw new Error("Invalid zone pointer");
                                }
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                switch(_.DEBUG && console.log(e1.step, "SZP1[]", t), e1.zp1 = t){
                                    case 0:
                                        e1.tZone || Zt(e1), e1.z1 = e1.tZone;
                                        break;
                                    case 1:
                                        e1.z1 = e1.gZone;
                                        break;
                                    default:
                                        throw new Error("Invalid zone pointer");
                                }
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                switch(_.DEBUG && console.log(e1.step, "SZP2[]", t), e1.zp2 = t){
                                    case 0:
                                        e1.tZone || Zt(e1), e1.z2 = e1.tZone;
                                        break;
                                    case 1:
                                        e1.z2 = e1.gZone;
                                        break;
                                    default:
                                        throw new Error("Invalid zone pointer");
                                }
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                switch(_.DEBUG && console.log(e1.step, "SZPS[]", t), e1.zp0 = e1.zp1 = e1.zp2 = t){
                                    case 0:
                                        e1.tZone || Zt(e1), e1.z0 = e1.z1 = e1.z2 = e1.tZone;
                                        break;
                                    case 1:
                                        e1.z0 = e1.z1 = e1.z2 = e1.gZone;
                                        break;
                                    default:
                                        throw new Error("Invalid zone pointer");
                                }
                            },
                            function(e1) {
                                e1.loop = e1.stack.pop(), _.DEBUG && console.log(e1.step, "SLOOP[]", e1.loop);
                            },
                            function(e1) {
                                _.DEBUG && console.log(e1.step, "RTG[]"), e1.round = Nt;
                            },
                            function(e1) {
                                _.DEBUG && console.log(e1.step, "RTHG[]"), e1.round = Gt;
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                _.DEBUG && console.log(e1.step, "SMD[]", t), e1.minDis = t / 64;
                            },
                            function(e1) {
                                _.DEBUG && console.log(e1.step, "ELSE[]"), Kt(e1, !1);
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                _.DEBUG && console.log(e1.step, "JMPR[]", t), e1.ip += t - 1;
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                _.DEBUG && console.log(e1.step, "SCVTCI[]", t), e1.cvCutIn = t / 64;
                            },
                            void 0,
                            void 0,
                            function(e1) {
                                var t = e1.stack;
                                _.DEBUG && console.log(e1.step, "DUP[]"), t.push(t[t.length - 1]);
                            },
                            rr,
                            function(e1) {
                                _.DEBUG && console.log(e1.step, "CLEAR[]"), e1.stack.length = 0;
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                _.DEBUG && console.log(e1.step, "SWAP[]"), t.push(r), t.push(o);
                            },
                            function(e1) {
                                var t = e1.stack;
                                _.DEBUG && console.log(e1.step, "DEPTH[]"), t.push(t.length);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                _.DEBUG && console.log(e1.step, "CINDEX[]", r), t.push(t[t.length - r]);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                _.DEBUG && console.log(e1.step, "MINDEX[]", r), t.push(t.splice(t.length - r, 1)[0]);
                            },
                            void 0,
                            void 0,
                            void 0,
                            function(e1) {
                                var t = (o = e1.stack).pop(), r = o.pop(), o = (_.DEBUG && console.log(e1.step, "LOOPCALL[]", t, r), e1.ip), n = e1.prog;
                                e1.prog = e1.funcs[t];
                                for(var s = 0; s < r; s++)vr(e1), _.DEBUG && console.log(++e1.step, s + 1 < r ? "next loopcall" : "done loopcall", s);
                                e1.ip = o, e1.prog = n;
                            },
                            function(e1) {
                                var t = e1.stack.pop(), r = (_.DEBUG && console.log(e1.step, "CALL[]", t), e1.ip), o = e1.prog;
                                e1.prog = e1.funcs[t], vr(e1), e1.ip = r, e1.prog = o, _.DEBUG && console.log(++e1.step, "returning from", t);
                            },
                            function(e1) {
                                if ("fpgm" !== e1.env) throw new Error("FDEF not allowed here");
                                var t = e1.stack, r = e1.prog, o = e1.ip, t = t.pop(), n = o;
                                for(_.DEBUG && console.log(e1.step, "FDEF[]", t); 45 !== r[++o];);
                                e1.ip = o, e1.funcs[t] = r.slice(n + 1, o);
                            },
                            void 0,
                            or.bind(void 0, 0),
                            or.bind(void 0, 1),
                            nr.bind(void 0, T),
                            nr.bind(void 0, x),
                            sr.bind(void 0, 0),
                            sr.bind(void 0, 1),
                            ir.bind(void 0, 0),
                            ir.bind(void 0, 1),
                            ar.bind(void 0, 0),
                            ar.bind(void 0, 1),
                            function(e1) {
                                for(var t = e1.stack, r = e1.loop, o = e1.fv, n = t.pop() / 64, s = e1.z2; r--;){
                                    var i = t.pop(), a = s[i];
                                    _.DEBUG && console.log(e1.step, (1 < e1.loop ? "loop " + (e1.loop - r) + ": " : "") + "SHPIX[]", i, n), o.setRelative(a, a, n), o.touch(a);
                                }
                                e1.loop = 1;
                            },
                            function(e1) {
                                for(var t = e1.stack, r = e1.rp1, o = e1.rp2, n = e1.loop, s = e1.z0[r], i = e1.z1[o], a = e1.fv, l = e1.dpv, u = e1.z2; n--;){
                                    var c = t.pop(), d = u[c];
                                    _.DEBUG && console.log(e1.step, (1 < e1.loop ? "loop " + (e1.loop - n) + ": " : "") + "IP[]", c, r, "<->", o), a.interpolate(d, s, i, l), a.touch(d);
                                }
                                e1.loop = 1;
                            },
                            lr.bind(void 0, 0),
                            lr.bind(void 0, 1),
                            function(e1) {
                                for(var t = e1.stack, r = e1.rp0, o = e1.z0[r], n = e1.loop, s = e1.fv, i = e1.pv, a = e1.z1; n--;){
                                    var l = t.pop(), u = a[l];
                                    _.DEBUG && console.log(e1.step, (1 < e1.loop ? "loop " + (e1.loop - n) + ": " : "") + "ALIGNRP[]", l), s.setRelative(u, o, 0, i), s.touch(u);
                                }
                                e1.loop = 1;
                            },
                            function(e1) {
                                _.DEBUG && console.log(e1.step, "RTDG[]"), e1.round = Bt;
                            },
                            ur.bind(void 0, 0),
                            ur.bind(void 0, 1),
                            function(e1) {
                                var t = e1.prog, r = e1.ip, o = e1.stack, n = t[++r];
                                _.DEBUG && console.log(e1.step, "NPUSHB[]", n);
                                for(var s = 0; s < n; s++)o.push(t[++r]);
                                e1.ip = r;
                            },
                            function(e1) {
                                var t = e1.ip, r = e1.prog, o = e1.stack, n = r[++t];
                                _.DEBUG && console.log(e1.step, "NPUSHW[]", n);
                                for(var s = 0; s < n; s++){
                                    var i = r[++t] << 8 | r[++t];
                                    32768 & i && (i = -(1 + (65535 ^ i))), o.push(i);
                                }
                                e1.ip = t;
                            },
                            function(e1) {
                                var t = e1.stack, r = (r = e1.store) || (e1.store = []), o = t.pop(), t = t.pop();
                                _.DEBUG && console.log(e1.step, "WS", o, t), r[t] = o;
                            },
                            function(e1) {
                                var t = e1.stack, r = e1.store, o = t.pop(), e1 = (_.DEBUG && console.log(e1.step, "RS", o), r && r[o] || 0);
                                t.push(e1);
                            },
                            function(e1) {
                                var t = (r = e1.stack).pop(), r = r.pop();
                                _.DEBUG && console.log(e1.step, "WCVTP", t, r), e1.cvt[r] = t / 64;
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                _.DEBUG && console.log(e1.step, "RCVT", r), t.push(64 * e1.cvt[r]);
                            },
                            cr.bind(void 0, 0),
                            cr.bind(void 0, 1),
                            void 0,
                            dr.bind(void 0, 0),
                            dr.bind(void 0, 1),
                            function(e1) {
                                _.DEBUG && console.log(e1.step, "MPPEM[]"), e1.stack.push(e1.ppem);
                            },
                            void 0,
                            function(e1) {
                                _.DEBUG && console.log(e1.step, "FLIPON[]"), e1.autoFlip = !0;
                            },
                            void 0,
                            void 0,
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                _.DEBUG && console.log(e1.step, "LT[]", r, o), t.push(o < r ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                _.DEBUG && console.log(e1.step, "LTEQ[]", r, o), t.push(o <= r ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                _.DEBUG && console.log(e1.step, "GT[]", r, o), t.push(r < o ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                _.DEBUG && console.log(e1.step, "GTEQ[]", r, o), t.push(r <= o ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                _.DEBUG && console.log(e1.step, "EQ[]", r, o), t.push(r === o ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                _.DEBUG && console.log(e1.step, "NEQ[]", r, o), t.push(r !== o ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                _.DEBUG && console.log(e1.step, "ODD[]", r), t.push(Math.trunc(r) % 2 ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                _.DEBUG && console.log(e1.step, "EVEN[]", r), t.push(Math.trunc(r) % 2 ? 0 : 1);
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                _.DEBUG && console.log(e1.step, "IF[]", t), t || (Kt(e1, !0), _.DEBUG && console.log(e1.step, "EIF[]"));
                            },
                            function(e1) {
                                _.DEBUG && console.log(e1.step, "EIF[]");
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                _.DEBUG && console.log(e1.step, "AND[]", r, o), t.push(r && o ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                _.DEBUG && console.log(e1.step, "OR[]", r, o), t.push(r || o ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                _.DEBUG && console.log(e1.step, "NOT[]", r), t.push(r ? 0 : 1);
                            },
                            hr.bind(void 0, 1),
                            function(e1) {
                                var t = e1.stack.pop();
                                _.DEBUG && console.log(e1.step, "SDB[]", t), e1.deltaBase = t;
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                _.DEBUG && console.log(e1.step, "SDS[]", t), e1.deltaShift = Math.pow(.5, t);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                _.DEBUG && console.log(e1.step, "ADD[]", r, o), t.push(o + r);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                _.DEBUG && console.log(e1.step, "SUB[]", r, o), t.push(o - r);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                _.DEBUG && console.log(e1.step, "DIV[]", r, o), t.push(64 * o / r);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                _.DEBUG && console.log(e1.step, "MUL[]", r, o), t.push(o * r / 64);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                _.DEBUG && console.log(e1.step, "ABS[]", r), t.push(Math.abs(r));
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                _.DEBUG && console.log(e1.step, "NEG[]", r), t.push(-r);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                _.DEBUG && console.log(e1.step, "FLOOR[]", r), t.push(64 * Math.floor(r / 64));
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                _.DEBUG && console.log(e1.step, "CEILING[]", r), t.push(64 * Math.ceil(r / 64));
                            },
                            fr.bind(void 0, 0),
                            fr.bind(void 0, 1),
                            fr.bind(void 0, 2),
                            fr.bind(void 0, 3),
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            function(e1) {
                                var t = (r = e1.stack).pop(), r = r.pop();
                                _.DEBUG && console.log(e1.step, "WCVTF[]", t, r), e1.cvt[r] = t * e1.ppem / e1.font.unitsPerEm;
                            },
                            hr.bind(void 0, 2),
                            hr.bind(void 0, 3),
                            pr.bind(void 0, 1),
                            pr.bind(void 0, 2),
                            pr.bind(void 0, 3),
                            function(e1) {
                                var t, r = e1.stack.pop();
                                switch(_.DEBUG && console.log(e1.step, "SROUND[]", r), e1.round = Ht, 192 & r){
                                    case 0:
                                        t = .5;
                                        break;
                                    case 64:
                                        t = 1;
                                        break;
                                    case 128:
                                        t = 2;
                                        break;
                                    default:
                                        throw new Error("invalid SROUND value");
                                }
                                switch(e1.srPeriod = t, 48 & r){
                                    case 0:
                                        e1.srPhase = 0;
                                        break;
                                    case 16:
                                        e1.srPhase = .25 * t;
                                        break;
                                    case 32:
                                        e1.srPhase = .5 * t;
                                        break;
                                    case 48:
                                        e1.srPhase = .75 * t;
                                        break;
                                    default:
                                        throw new Error("invalid SROUND value");
                                }
                                e1.srThreshold = 0 === (r &= 15) ? 0 : (r / 8 - .5) * t;
                            },
                            function(e1) {
                                var t, r = e1.stack.pop();
                                switch(_.DEBUG && console.log(e1.step, "S45ROUND[]", r), e1.round = Ht, 192 & r){
                                    case 0:
                                        t = Math.sqrt(2) / 2;
                                        break;
                                    case 64:
                                        t = Math.sqrt(2);
                                        break;
                                    case 128:
                                        t = 2 * Math.sqrt(2);
                                        break;
                                    default:
                                        throw new Error("invalid S45ROUND value");
                                }
                                switch(e1.srPeriod = t, 48 & r){
                                    case 0:
                                        e1.srPhase = 0;
                                        break;
                                    case 16:
                                        e1.srPhase = .25 * t;
                                        break;
                                    case 32:
                                        e1.srPhase = .5 * t;
                                        break;
                                    case 48:
                                        e1.srPhase = .75 * t;
                                        break;
                                    default:
                                        throw new Error("invalid S45ROUND value");
                                }
                                e1.srThreshold = 0 === (r &= 15) ? 0 : (r / 8 - .5) * t;
                            },
                            void 0,
                            void 0,
                            function(e1) {
                                _.DEBUG && console.log(e1.step, "ROFF[]"), e1.round = Ut;
                            },
                            void 0,
                            function(e1) {
                                _.DEBUG && console.log(e1.step, "RUTG[]"), e1.round = Vt;
                            },
                            function(e1) {
                                _.DEBUG && console.log(e1.step, "RDTG[]"), e1.round = zt;
                            },
                            rr,
                            rr,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            function(e1) {
                                var t = e1.stack.pop();
                                _.DEBUG && console.log(e1.step, "SCANCTRL[]", t);
                            },
                            mr.bind(void 0, 0),
                            mr.bind(void 0, 1),
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = 0;
                                _.DEBUG && console.log(e1.step, "GETINFO[]", r), 1 & r && (o = 35), 32 & r && (o |= 4096), t.push(o);
                            },
                            void 0,
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop(), n = t.pop();
                                _.DEBUG && console.log(e1.step, "ROLL[]"), t.push(o), t.push(r), t.push(n);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                _.DEBUG && console.log(e1.step, "MAX[]", r, o), t.push(Math.max(o, r));
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                _.DEBUG && console.log(e1.step, "MIN[]", r, o), t.push(Math.min(o, r));
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                _.DEBUG && console.log(e1.step, "SCANTYPE[]", t);
                            },
                            function(e1) {
                                var t = e1.stack.pop(), r = e1.stack.pop();
                                switch(_.DEBUG && console.log(e1.step, "INSTCTRL[]", t, r), t){
                                    case 1:
                                        return void (e1.inhibitGridFit = !!r);
                                    case 2:
                                        return void (e1.ignoreCvt = !!r);
                                    default:
                                        throw new Error("invalid INSTCTRL[] selector");
                                }
                            },
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            k.bind(void 0, 1),
                            k.bind(void 0, 2),
                            k.bind(void 0, 3),
                            k.bind(void 0, 4),
                            k.bind(void 0, 5),
                            k.bind(void 0, 6),
                            k.bind(void 0, 7),
                            k.bind(void 0, 8),
                            O.bind(void 0, 1),
                            O.bind(void 0, 2),
                            O.bind(void 0, 3),
                            O.bind(void 0, 4),
                            O.bind(void 0, 5),
                            O.bind(void 0, 6),
                            O.bind(void 0, 7),
                            O.bind(void 0, 8),
                            C.bind(void 0, 0, 0, 0, 0, 0),
                            C.bind(void 0, 0, 0, 0, 0, 1),
                            C.bind(void 0, 0, 0, 0, 0, 2),
                            C.bind(void 0, 0, 0, 0, 0, 3),
                            C.bind(void 0, 0, 0, 0, 1, 0),
                            C.bind(void 0, 0, 0, 0, 1, 1),
                            C.bind(void 0, 0, 0, 0, 1, 2),
                            C.bind(void 0, 0, 0, 0, 1, 3),
                            C.bind(void 0, 0, 0, 1, 0, 0),
                            C.bind(void 0, 0, 0, 1, 0, 1),
                            C.bind(void 0, 0, 0, 1, 0, 2),
                            C.bind(void 0, 0, 0, 1, 0, 3),
                            C.bind(void 0, 0, 0, 1, 1, 0),
                            C.bind(void 0, 0, 0, 1, 1, 1),
                            C.bind(void 0, 0, 0, 1, 1, 2),
                            C.bind(void 0, 0, 0, 1, 1, 3),
                            C.bind(void 0, 0, 1, 0, 0, 0),
                            C.bind(void 0, 0, 1, 0, 0, 1),
                            C.bind(void 0, 0, 1, 0, 0, 2),
                            C.bind(void 0, 0, 1, 0, 0, 3),
                            C.bind(void 0, 0, 1, 0, 1, 0),
                            C.bind(void 0, 0, 1, 0, 1, 1),
                            C.bind(void 0, 0, 1, 0, 1, 2),
                            C.bind(void 0, 0, 1, 0, 1, 3),
                            C.bind(void 0, 0, 1, 1, 0, 0),
                            C.bind(void 0, 0, 1, 1, 0, 1),
                            C.bind(void 0, 0, 1, 1, 0, 2),
                            C.bind(void 0, 0, 1, 1, 0, 3),
                            C.bind(void 0, 0, 1, 1, 1, 0),
                            C.bind(void 0, 0, 1, 1, 1, 1),
                            C.bind(void 0, 0, 1, 1, 1, 2),
                            C.bind(void 0, 0, 1, 1, 1, 3),
                            C.bind(void 0, 1, 0, 0, 0, 0),
                            C.bind(void 0, 1, 0, 0, 0, 1),
                            C.bind(void 0, 1, 0, 0, 0, 2),
                            C.bind(void 0, 1, 0, 0, 0, 3),
                            C.bind(void 0, 1, 0, 0, 1, 0),
                            C.bind(void 0, 1, 0, 0, 1, 1),
                            C.bind(void 0, 1, 0, 0, 1, 2),
                            C.bind(void 0, 1, 0, 0, 1, 3),
                            C.bind(void 0, 1, 0, 1, 0, 0),
                            C.bind(void 0, 1, 0, 1, 0, 1),
                            C.bind(void 0, 1, 0, 1, 0, 2),
                            C.bind(void 0, 1, 0, 1, 0, 3),
                            C.bind(void 0, 1, 0, 1, 1, 0),
                            C.bind(void 0, 1, 0, 1, 1, 1),
                            C.bind(void 0, 1, 0, 1, 1, 2),
                            C.bind(void 0, 1, 0, 1, 1, 3),
                            C.bind(void 0, 1, 1, 0, 0, 0),
                            C.bind(void 0, 1, 1, 0, 0, 1),
                            C.bind(void 0, 1, 1, 0, 0, 2),
                            C.bind(void 0, 1, 1, 0, 0, 3),
                            C.bind(void 0, 1, 1, 0, 1, 0),
                            C.bind(void 0, 1, 1, 0, 1, 1),
                            C.bind(void 0, 1, 1, 0, 1, 2),
                            C.bind(void 0, 1, 1, 0, 1, 3),
                            C.bind(void 0, 1, 1, 1, 0, 0),
                            C.bind(void 0, 1, 1, 1, 0, 1),
                            C.bind(void 0, 1, 1, 1, 0, 2),
                            C.bind(void 0, 1, 1, 1, 0, 3),
                            C.bind(void 0, 1, 1, 1, 1, 0),
                            C.bind(void 0, 1, 1, 1, 1, 1),
                            C.bind(void 0, 1, 1, 1, 1, 2),
                            C.bind(void 0, 1, 1, 1, 1, 3)
                        ], _r = Array.from || function(e1) {
                            return e1.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]?|[^\uD800-\uDFFF]|./g) || [];
                        };
                        function P(e1) {
                            (e1 = e1 || {}).empty || (j(e1.familyName, "When creating a new Font object, familyName is required."), j(e1.styleName, "When creating a new Font object, styleName is required."), j(e1.unitsPerEm, "When creating a new Font object, unitsPerEm is required."), j(e1.ascender, "When creating a new Font object, ascender is required."), j(e1.descender, "When creating a new Font object, descender is required."), j(e1.descender < 0, "Descender should be negative (e.g. -512)."), this.names = {
                                fontFamily: {
                                    en: e1.familyName || " "
                                },
                                fontSubfamily: {
                                    en: e1.styleName || " "
                                },
                                fullName: {
                                    en: e1.fullName || e1.familyName + " " + e1.styleName
                                },
                                postScriptName: {
                                    en: e1.postScriptName || (e1.familyName + e1.styleName).replace(/\s/g, "")
                                },
                                designer: {
                                    en: e1.designer || " "
                                },
                                designerURL: {
                                    en: e1.designerURL || " "
                                },
                                manufacturer: {
                                    en: e1.manufacturer || " "
                                },
                                manufacturerURL: {
                                    en: e1.manufacturerURL || " "
                                },
                                license: {
                                    en: e1.license || " "
                                },
                                licenseURL: {
                                    en: e1.licenseURL || " "
                                },
                                version: {
                                    en: e1.version || "Version 0.1"
                                },
                                description: {
                                    en: e1.description || " "
                                },
                                copyright: {
                                    en: e1.copyright || " "
                                },
                                trademark: {
                                    en: e1.trademark || " "
                                }
                            }, this.unitsPerEm = e1.unitsPerEm || 1e3, this.ascender = e1.ascender, this.descender = e1.descender, this.createdTimestamp = e1.createdTimestamp, this.tables = {
                                os2: {
                                    usWeightClass: e1.weightClass || this.usWeightClasses.MEDIUM,
                                    usWidthClass: e1.widthClass || this.usWidthClasses.MEDIUM,
                                    fsSelection: e1.fsSelection || this.fsSelectionValues.REGULAR
                                }
                            }), this.supported = !0, this.glyphs = new p.GlyphSet(this, e1.glyphs || []), this.encoding = new Me(this), this.position = new kt(this), this.substitution = new i(this), this.tables = this.tables || {}, Object.defineProperty(this, "hinting", {
                                get: function() {
                                    return this._hinting || ("truetype" === this.outlinesFormat ? this._hinting = new Ft(this) : void 0);
                                }
                            });
                        }
                        function jr(e1, t) {
                            var r, o = JSON.stringify(e1), n = 256;
                            for(r in t){
                                var s = parseInt(r);
                                if (s && !(s < 256)) {
                                    if (JSON.stringify(t[r]) === o) return s;
                                    n <= s && (n = s + 1);
                                }
                            }
                            return t[n] = e1, n;
                        }
                        P.prototype.hasChar = function(e1) {
                            return null !== this.encoding.charToGlyphIndex(e1);
                        }, P.prototype.charToGlyphIndex = function(e1) {
                            return this.encoding.charToGlyphIndex(e1);
                        }, P.prototype.charToGlyph = function(e1) {
                            e1 = this.charToGlyphIndex(e1);
                            return this.glyphs.get(e1) || this.glyphs.get(0);
                        }, P.prototype.stringToGlyphs = function(e1, t) {
                            t = t || this.defaultRenderOptions;
                            for(var r = _r(e1), o = [], n = 0; n < r.length; n += 1){
                                var s = r[n];
                                o.push(this.charToGlyphIndex(s));
                            }
                            var i = o.length;
                            if (t.features) {
                                var e1 = t.script || this.substitution.getDefaultScriptName(), a = [];
                                t.features.liga && (a = a.concat(this.substitution.getFeature("liga", e1, t.language))), t.features.rlig && (a = a.concat(this.substitution.getFeature("rlig", e1, t.language)));
                                for(var l = 0; l < i; l += 1)for(var u = 0; u < a.length; u++){
                                    for(var c = a[u], d = c.sub, h = d.length, f = 0; f < h && d[f] === o[l + f];)f++;
                                    f === h && (o.splice(l, h, c.by), i = i - h + 1);
                                }
                            }
                            for(var p = new Array(i), m = this.glyphs.get(0), y = 0; y < i; y += 1)p[y] = this.glyphs.get(o[y]) || m;
                            return p;
                        }, P.prototype.nameToGlyphIndex = function(e1) {
                            return this.glyphNames.nameToGlyphIndex(e1);
                        }, P.prototype.nameToGlyph = function(e1) {
                            e1 = this.nameToGlyphIndex(e1);
                            return this.glyphs.get(e1) || this.glyphs.get(0);
                        }, P.prototype.glyphIndexToName = function(e1) {
                            return this.glyphNames.glyphIndexToName ? this.glyphNames.glyphIndexToName(e1) : "";
                        }, P.prototype.getKerningValue = function(e1, t) {
                            e1 = e1.index || e1, t = t.index || t;
                            var r = this.position.defaultKerningTables;
                            return r ? this.position.getKerningValue(r, e1, t) : this.kerningPairs[e1 + "," + t] || 0;
                        }, P.prototype.defaultRenderOptions = {
                            kerning: !0,
                            features: {
                                liga: !0,
                                rlig: !0
                            }
                        }, P.prototype.forEachGlyph = function(e1, t, r, o, n, s) {
                            t = void 0 !== t ? t : 0, r = void 0 !== r ? r : 0, n = n || this.defaultRenderOptions;
                            var i, a = 1 / this.unitsPerEm * (o = void 0 !== o ? o : 72), l = this.stringToGlyphs(e1, n);
                            n.kerning && (e1 = n.script || this.position.getDefaultScriptName(), i = this.position.getKerningTables(e1, n.language));
                            for(var u = 0; u < l.length; u += 1){
                                var c = l[u];
                                s.call(this, c, t, r, o, n), c.advanceWidth && (t += c.advanceWidth * a), n.kerning && u < l.length - 1 && (t += (i ? this.position.getKerningValue(i, c.index, l[u + 1].index) : this.getKerningValue(c, l[u + 1])) * a), n.letterSpacing ? t += n.letterSpacing * o : n.tracking && (t += n.tracking / 1e3 * o);
                            }
                            return t;
                        }, P.prototype.getPath = function(e1, t, r, o, n) {
                            var s = new h;
                            return this.forEachGlyph(e1, t, r, o, n, function(e1, t, r, o) {
                                e1 = e1.getPath(t, r, o, n, this);
                                s.extend(e1);
                            }), s;
                        }, P.prototype.getPaths = function(e1, t, r, o, n) {
                            var s = [];
                            return this.forEachGlyph(e1, t, r, o, n, function(e1, t, r, o) {
                                e1 = e1.getPath(t, r, o, n, this);
                                s.push(e1);
                            }), s;
                        }, P.prototype.getAdvanceWidth = function(e1, t, r) {
                            return this.forEachGlyph(e1, 0, 0, t, r, function() {});
                        }, P.prototype.draw = function(e1, t, r, o, n, s) {
                            this.getPath(t, r, o, n, s).draw(e1);
                        }, P.prototype.drawPoints = function(n, e1, t, r, o, s) {
                            this.forEachGlyph(e1, t, r, o, s, function(e1, t, r, o) {
                                e1.drawPoints(n, t, r, o);
                            });
                        }, P.prototype.drawMetrics = function(n, e1, t, r, o, s) {
                            this.forEachGlyph(e1, t, r, o, s, function(e1, t, r, o) {
                                e1.drawMetrics(n, t, r, o);
                            });
                        }, P.prototype.getEnglishName = function(e1) {
                            e1 = this.names[e1];
                            if (e1) return e1.en;
                        }, P.prototype.validate = function() {
                            var t = this;
                            function e1(e1) {
                                e1 = t.getEnglishName(e1);
                                e1 && e1.trim().length;
                            }
                            e1("fontFamily"), e1("weightName"), e1("manufacturer"), e1("copyright"), e1("version"), this.unitsPerEm;
                        }, P.prototype.toTables = function() {
                            return wt.fontToTable(this);
                        }, P.prototype.toBuffer = function() {
                            return console.warn("Font.toBuffer is deprecated. Use Font.toArrayBuffer instead."), this.toArrayBuffer();
                        }, P.prototype.toArrayBuffer = function() {
                            for(var e1 = this.toTables().encode(), t = new ArrayBuffer(e1.length), r = new Uint8Array(t), o = 0; o < e1.length; o++)r[o] = e1[o];
                            return t;
                        }, P.prototype.download = function(t) {
                            var e1 = this.getEnglishName("fontFamily"), r = this.getEnglishName("fontSubfamily"), o = (t = t || e1.replace(/\s/g, "") + "-" + r + ".otf", this.toArrayBuffer());
                            "undefined" != typeof window ? (window.requestFileSystem = window.requestFileSystem || window.webkitRequestFileSystem, window.requestFileSystem(window.TEMPORARY, o.byteLength, function(e1) {
                                e1.root.getFile(t, {
                                    create: !0
                                }, function(r) {
                                    r.createWriter(function(e1) {
                                        var t = new DataView(o), t = new Blob([
                                            t
                                        ], {
                                            type: "font/opentype"
                                        });
                                        e1.write(t), e1.addEventListener("writeend", function() {
                                            location.href = r.toURL();
                                        }, !1);
                                    });
                                });
                            }, function(e1) {
                                throw new Error(e1.name + ": " + e1.message);
                            })) : (e1 = Ar("fs"), r = function(e1) {
                                for(var t = new Pr(e1.byteLength), r = new Uint8Array(e1), o = 0; o < t.length; ++o)t[o] = r[o];
                                return t;
                            }(o), e1.writeFileSync(t, r));
                        }, P.prototype.fsSelectionValues = {
                            ITALIC: 1,
                            UNDERSCORE: 2,
                            NEGATIVE: 4,
                            OUTLINED: 8,
                            STRIKEOUT: 16,
                            BOLD: 32,
                            REGULAR: 64,
                            USER_TYPO_METRICS: 128,
                            WWS: 256,
                            OBLIQUE: 512
                        }, P.prototype.usWidthClasses = {
                            ULTRA_CONDENSED: 1,
                            EXTRA_CONDENSED: 2,
                            CONDENSED: 3,
                            SEMI_CONDENSED: 4,
                            MEDIUM: 5,
                            SEMI_EXPANDED: 6,
                            EXPANDED: 7,
                            EXTRA_EXPANDED: 8,
                            ULTRA_EXPANDED: 9
                        }, P.prototype.usWeightClasses = {
                            THIN: 100,
                            EXTRA_LIGHT: 200,
                            LIGHT: 300,
                            NORMAL: 400,
                            MEDIUM: 500,
                            SEMI_BOLD: 600,
                            BOLD: 700,
                            EXTRA_BOLD: 800,
                            BLACK: 900
                        };
                        var xr = {
                            make: function(e1, t) {
                                var r = new S.Table("fvar", [
                                    {
                                        name: "version",
                                        type: "ULONG",
                                        value: 65536
                                    },
                                    {
                                        name: "offsetToData",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "countSizePairs",
                                        type: "USHORT",
                                        value: 2
                                    },
                                    {
                                        name: "axisCount",
                                        type: "USHORT",
                                        value: e1.axes.length
                                    },
                                    {
                                        name: "axisSize",
                                        type: "USHORT",
                                        value: 20
                                    },
                                    {
                                        name: "instanceCount",
                                        type: "USHORT",
                                        value: e1.instances.length
                                    },
                                    {
                                        name: "instanceSize",
                                        type: "USHORT",
                                        value: 4 + 4 * e1.axes.length
                                    }
                                ]);
                                r.offsetToData = r.sizeOf();
                                for(var o, n, s, i = 0; i < e1.axes.length; i++)r.fields = r.fields.concat((o = i, n = e1.axes[i], s = t, s = jr(n.name, t), [
                                    {
                                        name: "tag_" + o,
                                        type: "TAG",
                                        value: n.tag
                                    },
                                    {
                                        name: "minValue_" + o,
                                        type: "FIXED",
                                        value: n.minValue << 16
                                    },
                                    {
                                        name: "defaultValue_" + o,
                                        type: "FIXED",
                                        value: n.defaultValue << 16
                                    },
                                    {
                                        name: "maxValue_" + o,
                                        type: "FIXED",
                                        value: n.maxValue << 16
                                    },
                                    {
                                        name: "flags_" + o,
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "nameID_" + o,
                                        type: "USHORT",
                                        value: s
                                    }
                                ]));
                                for(var a = 0; a < e1.instances.length; a++)r.fields = r.fields.concat(function(e1, t, r, o) {
                                    for(var n = [
                                        {
                                            name: "nameID_" + e1,
                                            type: "USHORT",
                                            value: jr(t.name, o)
                                        },
                                        {
                                            name: "flags_" + e1,
                                            type: "USHORT",
                                            value: 0
                                        }
                                    ], s = 0; s < r.length; ++s){
                                        var i = r[s].tag;
                                        n.push({
                                            name: "axis_" + e1 + " " + i,
                                            type: "FIXED",
                                            value: t.coordinates[i] << 16
                                        });
                                    }
                                    return n;
                                }(a, e1.instances[a], e1.axes, t));
                                return r;
                            },
                            parse: function(e1, t, r) {
                                for(var o, n, s, i, a = new R.Parser(e1, t), l = a.parseULong(), u = (L.argument(65536 === l, "Unsupported fvar table version."), a.parseOffset16()), c = (a.skip("uShort", 1), a.parseUShort()), d = a.parseUShort(), h = a.parseUShort(), f = a.parseUShort(), p = [], m = 0; m < c; m++)p.push((o = e1, n = t + u + m * d, s = r, i = {}, o = new R.Parser(o, n), i.tag = o.parseTag(), i.minValue = o.parseFixed(), i.defaultValue = o.parseFixed(), i.maxValue = o.parseFixed(), o.skip("uShort", 1), i.name = s[o.parseUShort()] || {}, i));
                                for(var y = [], g = t + u + c * d, v = 0; v < h; v++)y.push(function(e1, t, r, o) {
                                    var n = {}, s = new R.Parser(e1, t);
                                    n.name = o[s.parseUShort()] || {}, s.skip("uShort", 1), n.coordinates = {};
                                    for(var i = 0; i < r.length; ++i)n.coordinates[r[i].tag] = s.parseFixed();
                                    return n;
                                }(e1, g + v * f, p, r));
                                return {
                                    axes: p,
                                    instances: y
                                };
                            }
                        }, A = new Array(10);
                        A[1] = function() {
                            var e1 = this.offset + this.relativeOffset, t = this.parseUShort();
                            return 1 === t ? {
                                posFormat: 1,
                                coverage: this.parsePointer(u.coverage),
                                value: this.parseValueRecord()
                            } : 2 === t ? {
                                posFormat: 2,
                                coverage: this.parsePointer(u.coverage),
                                values: this.parseValueRecordList()
                            } : void L.assert(!1, "0x" + e1.toString(16) + ": GPOS lookup type 1 format must be 1 or 2.");
                        }, A[2] = function() {
                            var e1, t, r, o, n = this.offset + this.relativeOffset, s = this.parseUShort(), n = (L.assert(1 === s || 2 === s, "0x" + n.toString(16) + ": GPOS lookup type 2 format must be 1 or 2."), this.parsePointer(u.coverage)), i = this.parseUShort(), a = this.parseUShort();
                            return 1 === s ? {
                                posFormat: s,
                                coverage: n,
                                valueFormat1: i,
                                valueFormat2: a,
                                pairSets: this.parseList(u.pointer(u.list(function() {
                                    return {
                                        secondGlyph: this.parseUShort(),
                                        value1: this.parseValueRecord(i),
                                        value2: this.parseValueRecord(a)
                                    };
                                })))
                            } : 2 === s ? (e1 = this.parsePointer(u.classDef), t = this.parsePointer(u.classDef), r = this.parseUShort(), o = this.parseUShort(), {
                                posFormat: s,
                                coverage: n,
                                valueFormat1: i,
                                valueFormat2: a,
                                classDef1: e1,
                                classDef2: t,
                                class1Count: r,
                                class2Count: o,
                                classRecords: this.parseList(r, u.list(o, function() {
                                    return {
                                        value1: this.parseValueRecord(i),
                                        value2: this.parseValueRecord(a)
                                    };
                                }))
                            }) : void 0;
                        }, A[3] = function() {
                            return {
                                error: "GPOS Lookup 3 not supported"
                            };
                        }, A[4] = function() {
                            return {
                                error: "GPOS Lookup 4 not supported"
                            };
                        }, A[5] = function() {
                            return {
                                error: "GPOS Lookup 5 not supported"
                            };
                        }, A[6] = function() {
                            return {
                                error: "GPOS Lookup 6 not supported"
                            };
                        }, A[7] = function() {
                            return {
                                error: "GPOS Lookup 7 not supported"
                            };
                        }, A[8] = function() {
                            return {
                                error: "GPOS Lookup 8 not supported"
                            };
                        }, A[9] = function() {
                            return {
                                error: "GPOS Lookup 9 not supported"
                            };
                        };
                        var wr = new Array(10);
                        var Sr = {
                            parse: function(e1, t) {
                                return t = (e1 = new u(e1, t = t || 0)).parseVersion(1), L.argument(1 === t || 1.1 === t, "Unsupported GPOS table version " + t), 1 === t ? {
                                    version: t,
                                    scripts: e1.parseScriptList(),
                                    features: e1.parseFeatureList(),
                                    lookups: e1.parseLookupList(A)
                                } : {
                                    version: t,
                                    scripts: e1.parseScriptList(),
                                    features: e1.parseFeatureList(),
                                    lookups: e1.parseLookupList(A),
                                    variations: e1.parseFeatureVariationsList()
                                };
                            },
                            make: function(e1) {
                                return new S.Table("GPOS", [
                                    {
                                        name: "version",
                                        type: "ULONG",
                                        value: 65536
                                    },
                                    {
                                        name: "scripts",
                                        type: "TABLE",
                                        value: new S.ScriptList(e1.scripts)
                                    },
                                    {
                                        name: "features",
                                        type: "TABLE",
                                        value: new S.FeatureList(e1.features)
                                    },
                                    {
                                        name: "lookups",
                                        type: "TABLE",
                                        value: new S.LookupList(e1.lookups, wr)
                                    }
                                ]);
                            }
                        };
                        var Tr = {
                            parse: function(e1, t) {
                                if (e1 = new R.Parser(e1, t), 0 === (t = e1.parseUShort())) {
                                    var r = e1, o = {}, n = (r.skip("uShort"), r.parseUShort()), s = (L.argument(0 === n, "Unsupported kern sub-table version."), r.skip("uShort", 2), r.parseUShort());
                                    r.skip("uShort", 3);
                                    for(var i = 0; i < s; i += 1){
                                        var a = r.parseUShort(), l = r.parseUShort(), u = r.parseShort();
                                        o[a + "," + l] = u;
                                    }
                                    return o;
                                }
                                if (1 !== t) throw new Error("Unsupported kern table version (" + t + ").");
                                var c = e1, d = {}, n = (c.skip("uShort"), 1 < c.parseULong() && console.warn("Only the first kern subtable is supported."), c.skip("uLong"), 255 & c.parseUShort());
                                if (c.skip("uShort"), 0 == n) {
                                    var h = c.parseUShort();
                                    c.skip("uShort", 3);
                                    for(var f = 0; f < h; f += 1){
                                        var p = c.parseUShort(), m = c.parseUShort(), y = c.parseShort();
                                        d[p + "," + m] = y;
                                    }
                                }
                                return d;
                            }
                        };
                        var Er = {
                            parse: function(e1, t, r, o) {
                                for(var n = new R.Parser(e1, t), s = o ? n.parseUShort : n.parseULong, i = [], a = 0; a < r + 1; a += 1){
                                    var l = s.call(n);
                                    o && (l *= 2), i.push(l);
                                }
                                return i;
                            }
                        };
                        function Mr(e1, r) {
                            Ar("fs").readFile(e1, function(e1, t) {
                                if (e1) return r(e1.message);
                                r(null, Ct(t));
                            });
                        }
                        function kr(e1, t) {
                            var r = new XMLHttpRequest;
                            r.open("get", e1, !0), r.responseType = "arraybuffer", r.onload = function() {
                                return r.response ? t(null, r.response) : t("Font could not be loaded: " + r.statusText);
                            }, r.onerror = function() {
                                t("Font could not be loaded");
                            }, r.send();
                        }
                        function Or(e1, t) {
                            for(var r = [], o = 12, n = 0; n < t; n += 1){
                                var s = R.getTag(e1, o), i = R.getULong(e1, o + 4), a = R.getULong(e1, o + 8), l = R.getULong(e1, o + 12);
                                r.push({
                                    tag: s,
                                    checksum: i,
                                    offset: a,
                                    length: l,
                                    compression: !1
                                }), o += 16;
                            }
                            return r;
                        }
                        function I(e1, t) {
                            if ("WOFF" !== t.compression) return {
                                data: e1,
                                offset: t.offset
                            };
                            var e1 = new Uint8Array(e1.buffer, t.offset + 2, t.compressedLength - 2), r = new Uint8Array(t.length);
                            if (re(e1, r), r.byteLength !== t.length) throw new Error("Decompression error: " + t.tag + " decompressed length doesn't match recorded length");
                            return {
                                data: new DataView(r.buffer, 0),
                                offset: 0
                            };
                        }
                        function Cr(e1) {
                            var t, r, o, n, s, i, a, l, u, c, d, h, f, p, m = new P({
                                empty: !0
                            }), y = new DataView(e1, 0), g = [], e1 = R.getTag(y, 0);
                            if (e1 === String.fromCharCode(0, 1, 0, 0) || "true" === e1 || "typ1" === e1) m.outlinesFormat = "truetype", g = Or(y, o = R.getUShort(y, 4));
                            else if ("OTTO" === e1) m.outlinesFormat = "cff", g = Or(y, o = R.getUShort(y, 4));
                            else {
                                if ("wOFF" !== e1) throw new Error("Unsupported OpenType signature " + e1);
                                var v = R.getTag(y, 4);
                                if (v === String.fromCharCode(0, 1, 0, 0)) m.outlinesFormat = "truetype";
                                else {
                                    if ("OTTO" !== v) throw new Error("Unsupported OpenType flavor " + e1);
                                    m.outlinesFormat = "cff";
                                }
                                g = function(e1, t) {
                                    for(var r = [], o = 44, n = 0; n < t; n += 1){
                                        var s = R.getTag(e1, o), i = R.getULong(e1, o + 4), a = R.getULong(e1, o + 8), l = R.getULong(e1, o + 12), u = void 0, u = a < l && "WOFF";
                                        r.push({
                                            tag: s,
                                            offset: i,
                                            compression: u,
                                            compressedLength: a,
                                            length: l
                                        }), o += 20;
                                    }
                                    return r;
                                }(y, o = R.getUShort(y, 12));
                            }
                            for(var b = 0; b < o; b += 1){
                                var _ = g[b], j = void 0;
                                switch(_.tag){
                                    case "cmap":
                                        j = I(y, _), m.tables.cmap = we.parse(j.data, j.offset), m.encoding = new ke(m.tables.cmap);
                                        break;
                                    case "cvt ":
                                        j = I(y, _), p = new R.Parser(j.data, j.offset), m.tables.cvt = p.parseShortList(_.length / 2);
                                        break;
                                    case "fvar":
                                        s = _;
                                        break;
                                    case "fpgm":
                                        j = I(y, _), p = new R.Parser(j.data, j.offset), m.tables.fpgm = p.parseByteList(_.length);
                                        break;
                                    case "head":
                                        j = I(y, _), m.tables.head = Ze.parse(j.data, j.offset), m.unitsPerEm = m.tables.head.unitsPerEm, t = m.tables.head.indexToLocFormat;
                                        break;
                                    case "hhea":
                                        j = I(y, _), m.tables.hhea = Ke.parse(j.data, j.offset), m.ascender = m.tables.hhea.ascender, m.descender = m.tables.hhea.descender, m.numberOfHMetrics = m.tables.hhea.numberOfHMetrics;
                                        break;
                                    case "hmtx":
                                        u = _;
                                        break;
                                    case "ltag":
                                        j = I(y, _), r = Je.parse(j.data, j.offset);
                                        break;
                                    case "maxp":
                                        j = I(y, _), m.tables.maxp = $e.parse(j.data, j.offset), m.numGlyphs = m.tables.maxp.numGlyphs;
                                        break;
                                    case "name":
                                        h = _;
                                        break;
                                    case "OS/2":
                                        j = I(y, _), m.tables.os2 = ft.parse(j.data, j.offset);
                                        break;
                                    case "post":
                                        j = I(y, _), m.tables.post = pt.parse(j.data, j.offset), m.glyphNames = new Ce(m.tables.post);
                                        break;
                                    case "prep":
                                        j = I(y, _), p = new R.Parser(j.data, j.offset), m.tables.prep = p.parseByteList(_.length);
                                        break;
                                    case "glyf":
                                        i = _;
                                        break;
                                    case "loca":
                                        d = _;
                                        break;
                                    case "CFF ":
                                        n = _;
                                        break;
                                    case "kern":
                                        c = _;
                                        break;
                                    case "GPOS":
                                        a = _;
                                        break;
                                    case "GSUB":
                                        l = _;
                                        break;
                                    case "meta":
                                        f = _;
                                }
                            }
                            v = I(y, h);
                            if (m.tables.name = dt.parse(v.data, v.offset, r), m.names = m.tables.name, i && d) {
                                e1 = 0 === t, v = I(y, d), v = Er.parse(v.data, v.offset, m.numGlyphs, e1), e1 = I(y, i);
                                m.glyphs = Dt.parse(e1.data, e1.offset, v, m);
                            } else {
                                if (!n) throw new Error("Font doesn't contain TrueType or CFF outlines.");
                                e1 = I(y, n);
                                Ye.parse(e1.data, e1.offset, m);
                            }
                            for(var v = I(y, u), x = (Qe.parse(v.data, v.offset, m.numberOfHMetrics, m.numGlyphs, m.glyphs), m), w = x.tables.cmap.glyphIndexMap, S = Object.keys(w), T = 0; T < S.length; T += 1){
                                var E, M = S[T], k = w[M];
                                (E = x.glyphs.get(k)).addUnicode(parseInt(M));
                            }
                            for(var O = 0; O < x.glyphs.length; O += 1)E = x.glyphs.get(O), x.cffEncoding ? x.isCIDFont ? E.name = "gid" + O : E.name = x.cffEncoding.charset[O] : x.glyphNames.names && (E.name = x.glyphNames.glyphIndexToName(O));
                            return c ? (e1 = I(y, c), m.kerningPairs = Tr.parse(e1.data, e1.offset)) : m.kerningPairs = {}, a && (v = I(y, a), m.tables.gpos = Sr.parse(v.data, v.offset), m.position.init()), l && (e1 = I(y, l), m.tables.gsub = yt.parse(e1.data, e1.offset)), s && (v = I(y, s), m.tables.fvar = xr.parse(v.data, v.offset, m.names)), f && (e1 = I(y, f), m.tables.meta = gt.parse(e1.data, e1.offset), m.metas = m.tables.meta), m;
                        }
                        _.Font = P, _.Glyph = f, _.Path = h, _.BoundingBox = a, _._parse = R, _.parse = Cr, _.load = function(e1, o) {
                            ("undefined" == typeof window ? Mr : kr)(e1, function(e1, t) {
                                if (e1) return o(e1);
                                var r;
                                try {
                                    r = Cr(t);
                                } catch (e1) {
                                    return o(e1, null);
                                }
                                return o(null, r);
                            });
                        }, _.loadSync = function(e1) {
                            return Cr(Ct(Ar("fs").readFileSync(e1)));
                        }, Object.defineProperty(_, "__esModule", {
                            value: !0
                        });
                    }, "object" == typeof o && void 0 !== r ? t(o) : "function" == typeof s && s.amd ? s([
                        "exports"
                    ], t) : t(e1.opentype = {});
                }).call(this, Ar("buffer").Buffer);
            },
            {
                buffer: 4,
                fs: 2
            }
        ],
        258: [
            function(e1, t, u) {
                (function(n) {
                    function s(e1, t) {
                        for(var r = 0, o = e1.length - 1; 0 <= o; o--){
                            var n = e1[o];
                            "." === n ? e1.splice(o, 1) : ".." === n ? (e1.splice(o, 1), r++) : r && (e1.splice(o, 1), r--);
                        }
                        if (t) for(; r--;)e1.unshift("..");
                        return e1;
                    }
                    function i(e1, t) {
                        if (e1.filter) return e1.filter(t);
                        for(var r = [], o = 0; o < e1.length; o++)t(e1[o], o, e1) && r.push(e1[o]);
                        return r;
                    }
                    u.resolve = function() {
                        for(var e1 = "", t = !1, r = arguments.length - 1; -1 <= r && !t; r--){
                            var o = 0 <= r ? arguments[r] : n.cwd();
                            if ("string" != typeof o) throw new TypeError("Arguments to path.resolve must be strings");
                            o && (e1 = o + "/" + e1, t = "/" === o.charAt(0));
                        }
                        return (t ? "/" : "") + (e1 = s(i(e1.split("/"), function(e1) {
                            return !!e1;
                        }), !t).join("/")) || ".";
                    }, u.normalize = function(e1) {
                        var t = u.isAbsolute(e1), r = "/" === o(e1, -1);
                        return (e1 = (e1 = s(i(e1.split("/"), function(e1) {
                            return !!e1;
                        }), !t).join("/")) || t ? e1 : ".") && r && (e1 += "/"), (t ? "/" : "") + e1;
                    }, u.isAbsolute = function(e1) {
                        return "/" === e1.charAt(0);
                    }, u.join = function() {
                        var e1 = Array.prototype.slice.call(arguments, 0);
                        return u.normalize(i(e1, function(e1, t) {
                            if ("string" != typeof e1) throw new TypeError("Arguments to path.join must be strings");
                            return e1;
                        }).join("/"));
                    }, u.relative = function(e1, t) {
                        function r(e1) {
                            for(var t = 0; t < e1.length && "" === e1[t]; t++);
                            for(var r = e1.length - 1; 0 <= r && "" === e1[r]; r--);
                            return r < t ? [] : e1.slice(t, r - t + 1);
                        }
                        e1 = u.resolve(e1).substr(1), t = u.resolve(t).substr(1);
                        for(var o = r(e1.split("/")), n = r(t.split("/")), s = Math.min(o.length, n.length), i = s, a = 0; a < s; a++)if (o[a] !== n[a]) {
                            i = a;
                            break;
                        }
                        for(var l = [], a = i; a < o.length; a++)l.push("..");
                        return (l = l.concat(n.slice(i))).join("/");
                    }, u.sep = "/", u.delimiter = ":", u.dirname = function(e1) {
                        if ("string" != typeof e1 && (e1 += ""), 0 === e1.length) return ".";
                        for(var t = 47 === e1.charCodeAt(0), r = -1, o = !0, n = e1.length - 1; 1 <= n; --n)if (47 === e1.charCodeAt(n)) {
                            if (!o) {
                                r = n;
                                break;
                            }
                        } else o = !1;
                        return -1 === r ? t ? "/" : "." : t && 1 === r ? "/" : e1.slice(0, r);
                    }, u.basename = function(e1, t) {
                        e1 = function(e1) {
                            "string" != typeof e1 && (e1 += "");
                            for(var t = 0, r = -1, o = !0, n = e1.length - 1; 0 <= n; --n)if (47 === e1.charCodeAt(n)) {
                                if (!o) {
                                    t = n + 1;
                                    break;
                                }
                            } else -1 === r && (o = !1, r = n + 1);
                            return -1 === r ? "" : e1.slice(t, r);
                        }(e1);
                        return e1 = t && e1.substr(-1 * t.length) === t ? e1.substr(0, e1.length - t.length) : e1;
                    }, u.extname = function(e1) {
                        "string" != typeof e1 && (e1 += "");
                        for(var t = -1, r = 0, o = -1, n = !0, s = 0, i = e1.length - 1; 0 <= i; --i){
                            var a = e1.charCodeAt(i);
                            if (47 === a) {
                                if (n) continue;
                                r = i + 1;
                                break;
                            }
                            -1 === o && (n = !1, o = i + 1), 46 === a ? -1 === t ? t = i : 1 !== s && (s = 1) : -1 !== t && (s = -1);
                        }
                        return -1 === t || -1 === o || 0 === s || 1 === s && t === o - 1 && t === r + 1 ? "" : e1.slice(t, o);
                    };
                    var o = "b" === "ab".substr(-1) ? function(e1, t, r) {
                        return e1.substr(t, r);
                    } : function(e1, t, r) {
                        return t < 0 && (t = e1.length + t), e1.substr(t, r);
                    };
                }).call(this, e1("_process"));
            },
            {
                _process: 259
            }
        ],
        259: [
            function(e1, t, r) {
                var o, n, t = t.exports = {};
                function s() {
                    throw new Error("setTimeout has not been defined");
                }
                function i() {
                    throw new Error("clearTimeout has not been defined");
                }
                try {
                    o = "function" == typeof setTimeout ? setTimeout : s;
                } catch (e1) {
                    o = s;
                }
                try {
                    n = "function" == typeof clearTimeout ? clearTimeout : i;
                } catch (e1) {
                    n = i;
                }
                function a(t) {
                    if (o === setTimeout) return setTimeout(t, 0);
                    if ((o === s || !o) && setTimeout) return (o = setTimeout)(t, 0);
                    try {
                        return o(t, 0);
                    } catch (e1) {
                        try {
                            return o.call(null, t, 0);
                        } catch (e1) {
                            return o.call(this, t, 0);
                        }
                    }
                }
                var l, u = [], c = !1, d = -1;
                function h() {
                    c && l && (c = !1, l.length ? u = l.concat(u) : d = -1, u.length && f());
                }
                function f() {
                    if (!c) {
                        for(var e1 = a(h), t = (c = !0, u.length); t;){
                            for(l = u, u = []; ++d < t;)l && l[d].run();
                            d = -1, t = u.length;
                        }
                        l = null, c = !1, !function(t) {
                            if (n === clearTimeout) return clearTimeout(t);
                            if ((n === i || !n) && clearTimeout) return (n = clearTimeout)(t);
                            try {
                                n(t);
                            } catch (e1) {
                                try {
                                    return n.call(null, t);
                                } catch (e1) {
                                    return n.call(this, t);
                                }
                            }
                        }(e1);
                    }
                }
                function p(e1, t) {
                    this.fun = e1, this.array = t;
                }
                function m() {}
                t.nextTick = function(e1) {
                    var t = new Array(arguments.length - 1);
                    if (1 < arguments.length) for(var r = 1; r < arguments.length; r++)t[r - 1] = arguments[r];
                    u.push(new p(e1, t)), 1 !== u.length || c || a(f);
                }, p.prototype.run = function() {
                    this.fun.apply(null, this.array);
                }, t.title = "browser", t.browser = !0, t.env = {}, t.argv = [], t.version = "", t.versions = {}, t.on = m, t.addListener = m, t.once = m, t.off = m, t.removeListener = m, t.removeAllListeners = m, t.emit = m, t.prependListener = m, t.prependOnceListener = m, t.listeners = function(e1) {
                    return [];
                }, t.binding = function(e1) {
                    throw new Error("process.binding is not supported");
                }, t.cwd = function() {
                    return "/";
                }, t.chdir = function(e1) {
                    throw new Error("process.chdir is not supported");
                }, t.umask = function() {
                    return 0;
                };
            },
            {}
        ],
        260: [
            function(e1, t, r) {
                t = function(s) {
                    "use strict";
                    var l, e1 = Object.prototype, u = e1.hasOwnProperty, t = "function" == typeof Symbol ? Symbol : {}, o = t.iterator || "@@iterator", r = t.asyncIterator || "@@asyncIterator", n = t.toStringTag || "@@toStringTag";
                    function i(e1, t, r, o) {
                        var n, s, i, a, t = t && t.prototype instanceof y ? t : y, t = Object.create(t.prototype), o = new S(o || []);
                        return t._invoke = (n = e1, s = r, i = o, a = d, function(e1, t) {
                            if (a === f) throw new Error("Generator is already running");
                            if (a === p) {
                                if ("throw" === e1) throw t;
                                return E();
                            }
                            for(i.method = e1, i.arg = t;;){
                                var r = i.delegate;
                                if (r) {
                                    r = function e1(t, r) {
                                        var o = t.iterator[r.method];
                                        if (o === l) {
                                            if (r.delegate = null, "throw" === r.method) {
                                                if (t.iterator.return && (r.method = "return", r.arg = l, e1(t, r), "throw" === r.method)) return m;
                                                r.method = "throw", r.arg = new TypeError("The iterator does not provide a 'throw' method");
                                            }
                                            return m;
                                        }
                                        o = c(o, t.iterator, r.arg);
                                        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, m;
                                        o = o.arg;
                                        if (!o) return r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, m;
                                        if (!o.done) return o;
                                        r[t.resultName] = o.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = l);
                                        r.delegate = null;
                                        return m;
                                    }(r, i);
                                    if (r) {
                                        if (r === m) continue;
                                        return r;
                                    }
                                }
                                if ("next" === i.method) i.sent = i._sent = i.arg;
                                else if ("throw" === i.method) {
                                    if (a === d) throw a = p, i.arg;
                                    i.dispatchException(i.arg);
                                } else "return" === i.method && i.abrupt("return", i.arg);
                                a = f;
                                r = c(n, s, i);
                                if ("normal" === r.type) {
                                    if (a = i.done ? p : h, r.arg !== m) return {
                                        value: r.arg,
                                        done: i.done
                                    };
                                } else "throw" === r.type && (a = p, i.method = "throw", i.arg = r.arg);
                            }
                        }), t;
                    }
                    function c(e1, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, r)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    s.wrap = i;
                    var d = "suspendedStart", h = "suspendedYield", f = "executing", p = "completed", m = {};
                    function y() {}
                    function a() {}
                    function g() {}
                    var t = {}, v = (t[o] = function() {
                        return this;
                    }, Object.getPrototypeOf), v = v && v(v(T([]))), b = (v && v !== e1 && u.call(v, o) && (t = v), g.prototype = y.prototype = Object.create(t));
                    function _(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            e1[t] = function(e1) {
                                return this._invoke(t, e1);
                            };
                        });
                    }
                    function j(i) {
                        var t;
                        this._invoke = function(r, o) {
                            function e1() {
                                return new Promise(function(e1, t) {
                                    !function t(e1, r, o, n) {
                                        var s, e1 = c(i[e1], i, r);
                                        if ("throw" !== e1.type) return (r = (s = e1.arg).value) && "object" == typeof r && u.call(r, "__await") ? Promise.resolve(r.__await).then(function(e1) {
                                            t("next", e1, o, n);
                                        }, function(e1) {
                                            t("throw", e1, o, n);
                                        }) : Promise.resolve(r).then(function(e1) {
                                            s.value = e1, o(s);
                                        }, function(e1) {
                                            return t("throw", e1, o, n);
                                        });
                                        n(e1.arg);
                                    }(r, o, e1, t);
                                });
                            }
                            return t = t ? t.then(e1, e1) : e1();
                        };
                    }
                    function x(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function w(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function S(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(x, this), this.reset(!0);
                    }
                    function T(t) {
                        if (t) {
                            var r, e1 = t[o];
                            if (e1) return e1.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) return r = -1, (e1 = function e1() {
                                for(; ++r < t.length;)if (u.call(t, r)) return e1.value = t[r], e1.done = !1, e1;
                                return e1.value = l, e1.done = !0, e1;
                            }).next = e1;
                        }
                        return {
                            next: E
                        };
                    }
                    function E() {
                        return {
                            value: l,
                            done: !0
                        };
                    }
                    return (a.prototype = b.constructor = g).constructor = a, g[n] = a.displayName = "GeneratorFunction", s.isGeneratorFunction = function(e1) {
                        e1 = "function" == typeof e1 && e1.constructor;
                        return !!e1 && (e1 === a || "GeneratorFunction" === (e1.displayName || e1.name));
                    }, s.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, g) : (e1.__proto__ = g, n in e1 || (e1[n] = "GeneratorFunction")), e1.prototype = Object.create(b), e1;
                    }, s.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, _(j.prototype), j.prototype[r] = function() {
                        return this;
                    }, s.AsyncIterator = j, s.async = function(e1, t, r, o) {
                        var n = new j(i(e1, t, r, o));
                        return s.isGeneratorFunction(t) ? n : n.next().then(function(e1) {
                            return e1.done ? e1.value : n.next();
                        });
                    }, _(b), b[n] = "Generator", b[o] = function() {
                        return this;
                    }, b.toString = function() {
                        return "[object Generator]";
                    }, s.keys = function(r) {
                        var e1, o = [];
                        for(e1 in r)o.push(e1);
                        return o.reverse(), function e1() {
                            for(; o.length;){
                                var t = o.pop();
                                if (t in r) return e1.value = t, e1.done = !1, e1;
                            }
                            return e1.done = !0, e1;
                        };
                    }, s.values = T, S.prototype = {
                        constructor: S,
                        reset: function(e1) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = l, this.done = !1, this.delegate = null, this.method = "next", this.arg = l, this.tryEntries.forEach(w), !e1) for(var t in this)"t" === t.charAt(0) && u.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = l);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(r) {
                            if (this.done) throw r;
                            var o = this;
                            function e1(e1, t) {
                                return s.type = "throw", s.arg = r, o.next = e1, t && (o.method = "next", o.arg = l), !!t;
                            }
                            for(var t = this.tryEntries.length - 1; 0 <= t; --t){
                                var n = this.tryEntries[t], s = n.completion;
                                if ("root" === n.tryLoc) return e1("end");
                                if (n.tryLoc <= this.prev) {
                                    var i = u.call(n, "catchLoc"), a = u.call(n, "finallyLoc");
                                    if (i && a) {
                                        if (this.prev < n.catchLoc) return e1(n.catchLoc, !0);
                                        if (this.prev < n.finallyLoc) return e1(n.finallyLoc);
                                    } else if (i) {
                                        if (this.prev < n.catchLoc) return e1(n.catchLoc, !0);
                                    } else {
                                        if (!a) throw new Error("try statement without catch or finally");
                                        if (this.prev < n.finallyLoc) return e1(n.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var r = this.tryEntries.length - 1; 0 <= r; --r){
                                var o = this.tryEntries[r];
                                if (o.tryLoc <= this.prev && u.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                                    var n = o;
                                    break;
                                }
                            }
                            var s = (n = n && ("break" === e1 || "continue" === e1) && n.tryLoc <= t && t <= n.finallyLoc ? null : n) ? n.completion : {};
                            return s.type = e1, s.arg = t, n ? (this.method = "next", this.next = n.finallyLoc, m) : this.complete(s);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), m;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; 0 <= t; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), w(r), m;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; 0 <= t; --t){
                                var r, o, n = this.tryEntries[t];
                                if (n.tryLoc === e1) return "throw" === (r = n.completion).type && (o = r.arg, w(n)), o;
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(e1, t, r) {
                            return this.delegate = {
                                iterator: T(e1),
                                resultName: t,
                                nextLoc: r
                            }, "next" === this.method && (this.arg = l), m;
                        }
                    }, s;
                }("object" == typeof t ? t.exports : {});
                try {
                    regeneratorRuntime = t;
                } catch (e1) {
                    Function("r", "regeneratorRuntime = r")(t);
                }
            },
            {}
        ],
        261: [
            function(e1, t, r) {
                !function(e1) {
                    "use strict";
                    var t, r, i, o, n, s, a, l, u, c;
                    function d(e1) {
                        if ("string" != typeof e1 && (e1 = String(e1)), /[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(e1)) throw new TypeError("Invalid character in header field name");
                        return e1.toLowerCase();
                    }
                    function h(e1) {
                        return e1 = "string" != typeof e1 ? String(e1) : e1;
                    }
                    function f(t) {
                        var e1 = {
                            next: function() {
                                var e1 = t.shift();
                                return {
                                    done: void 0 === e1,
                                    value: e1
                                };
                            }
                        };
                        return r && (e1[Symbol.iterator] = function() {
                            return e1;
                        }), e1;
                    }
                    function p(t) {
                        this.map = {}, t instanceof p ? t.forEach(function(e1, t) {
                            this.append(t, e1);
                        }, this) : Array.isArray(t) ? t.forEach(function(e1) {
                            this.append(e1[0], e1[1]);
                        }, this) : t && Object.getOwnPropertyNames(t).forEach(function(e1) {
                            this.append(e1, t[e1]);
                        }, this);
                    }
                    function m(e1) {
                        if (e1.bodyUsed) return Promise.reject(new TypeError("Already read"));
                        e1.bodyUsed = !0;
                    }
                    function y(r) {
                        return new Promise(function(e1, t) {
                            r.onload = function() {
                                e1(r.result);
                            }, r.onerror = function() {
                                t(r.error);
                            };
                        });
                    }
                    function g(e1) {
                        var t = new FileReader, r = y(t);
                        return t.readAsArrayBuffer(e1), r;
                    }
                    function v(e1) {
                        var t;
                        return e1.slice ? e1.slice(0) : ((t = new Uint8Array(e1.byteLength)).set(new Uint8Array(e1)), t.buffer);
                    }
                    function b() {
                        return this.bodyUsed = !1, this._initBody = function(e1) {
                            if (this._bodyInit = e1) {
                                if ("string" == typeof e1) this._bodyText = e1;
                                else if (i && Blob.prototype.isPrototypeOf(e1)) this._bodyBlob = e1;
                                else if (o && FormData.prototype.isPrototypeOf(e1)) this._bodyFormData = e1;
                                else if (t && URLSearchParams.prototype.isPrototypeOf(e1)) this._bodyText = e1.toString();
                                else if (n && i && a(e1)) this._bodyArrayBuffer = v(e1.buffer), this._bodyInit = new Blob([
                                    this._bodyArrayBuffer
                                ]);
                                else {
                                    if (!n || !ArrayBuffer.prototype.isPrototypeOf(e1) && !l(e1)) throw new Error("unsupported BodyInit type");
                                    this._bodyArrayBuffer = v(e1);
                                }
                            } else this._bodyText = "";
                            this.headers.get("content-type") || ("string" == typeof e1 ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : t && URLSearchParams.prototype.isPrototypeOf(e1) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
                        }, i && (this.blob = function() {
                            var e1 = m(this);
                            if (e1) return e1;
                            if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                            if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                                this._bodyArrayBuffer
                            ]));
                            if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                            return Promise.resolve(new Blob([
                                this._bodyText
                            ]));
                        }, this.arrayBuffer = function() {
                            return this._bodyArrayBuffer ? m(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(g);
                        }), this.text = function() {
                            var e1, t, r = m(this);
                            if (r) return r;
                            if (this._bodyBlob) return r = this._bodyBlob, e1 = new FileReader, t = y(e1), e1.readAsText(r), t;
                            if (this._bodyArrayBuffer) return Promise.resolve(function(e1) {
                                for(var t = new Uint8Array(e1), r = new Array(t.length), o = 0; o < t.length; o++)r[o] = String.fromCharCode(t[o]);
                                return r.join("");
                            }(this._bodyArrayBuffer));
                            if (this._bodyFormData) throw new Error("could not read FormData body as text");
                            return Promise.resolve(this._bodyText);
                        }, o && (this.formData = function() {
                            return this.text().then(j);
                        }), this.json = function() {
                            return this.text().then(JSON.parse);
                        }, this;
                    }
                    function _(e1, t) {
                        var r, o = (t = t || {}).body;
                        if (e1 instanceof _) {
                            if (e1.bodyUsed) throw new TypeError("Already read");
                            this.url = e1.url, this.credentials = e1.credentials, t.headers || (this.headers = new p(e1.headers)), this.method = e1.method, this.mode = e1.mode, o || null == e1._bodyInit || (o = e1._bodyInit, e1.bodyUsed = !0);
                        } else this.url = String(e1);
                        if (this.credentials = t.credentials || this.credentials || "omit", !t.headers && this.headers || (this.headers = new p(t.headers)), this.method = (e1 = t.method || this.method || "GET", r = e1.toUpperCase(), -1 < u.indexOf(r) ? r : e1), this.mode = t.mode || this.mode || null, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && o) throw new TypeError("Body not allowed for GET or HEAD requests");
                        this._initBody(o);
                    }
                    function j(e1) {
                        var r = new FormData;
                        return e1.trim().split("&").forEach(function(e1) {
                            var t;
                            e1 && (t = (e1 = e1.split("=")).shift().replace(/\+/g, " "), e1 = e1.join("=").replace(/\+/g, " "), r.append(decodeURIComponent(t), decodeURIComponent(e1)));
                        }), r;
                    }
                    function x(e1, t) {
                        t = t || {}, this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = 200 <= this.status && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new p(t.headers), this.url = t.url || "", this._initBody(e1);
                    }
                    e1.fetch || (t = "URLSearchParams" in e1, r = "Symbol" in e1 && "iterator" in Symbol, i = "FileReader" in e1 && "Blob" in e1 && function() {
                        try {
                            return new Blob, !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), o = "FormData" in e1, (n = "ArrayBuffer" in e1) && (s = [
                        "[object Int8Array]",
                        "[object Uint8Array]",
                        "[object Uint8ClampedArray]",
                        "[object Int16Array]",
                        "[object Uint16Array]",
                        "[object Int32Array]",
                        "[object Uint32Array]",
                        "[object Float32Array]",
                        "[object Float64Array]"
                    ], a = function(e1) {
                        return e1 && DataView.prototype.isPrototypeOf(e1);
                    }, l = ArrayBuffer.isView || function(e1) {
                        return e1 && -1 < s.indexOf(Object.prototype.toString.call(e1));
                    }), p.prototype.append = function(e1, t) {
                        e1 = d(e1), t = h(t);
                        var r = this.map[e1];
                        this.map[e1] = r ? r + "," + t : t;
                    }, p.prototype.delete = function(e1) {
                        delete this.map[d(e1)];
                    }, p.prototype.get = function(e1) {
                        return e1 = d(e1), this.has(e1) ? this.map[e1] : null;
                    }, p.prototype.has = function(e1) {
                        return this.map.hasOwnProperty(d(e1));
                    }, p.prototype.set = function(e1, t) {
                        this.map[d(e1)] = h(t);
                    }, p.prototype.forEach = function(e1, t) {
                        for(var r in this.map)this.map.hasOwnProperty(r) && e1.call(t, this.map[r], r, this);
                    }, p.prototype.keys = function() {
                        var r = [];
                        return this.forEach(function(e1, t) {
                            r.push(t);
                        }), f(r);
                    }, p.prototype.values = function() {
                        var t = [];
                        return this.forEach(function(e1) {
                            t.push(e1);
                        }), f(t);
                    }, p.prototype.entries = function() {
                        var r = [];
                        return this.forEach(function(e1, t) {
                            r.push([
                                t,
                                e1
                            ]);
                        }), f(r);
                    }, r && (p.prototype[Symbol.iterator] = p.prototype.entries), u = [
                        "DELETE",
                        "GET",
                        "HEAD",
                        "OPTIONS",
                        "POST",
                        "PUT"
                    ], _.prototype.clone = function() {
                        return new _(this, {
                            body: this._bodyInit
                        });
                    }, b.call(_.prototype), b.call(x.prototype), x.prototype.clone = function() {
                        return new x(this._bodyInit, {
                            status: this.status,
                            statusText: this.statusText,
                            headers: new p(this.headers),
                            url: this.url
                        });
                    }, x.error = function() {
                        var e1 = new x(null, {
                            status: 0,
                            statusText: ""
                        });
                        return e1.type = "error", e1;
                    }, c = [
                        301,
                        302,
                        303,
                        307,
                        308
                    ], x.redirect = function(e1, t) {
                        if (-1 === c.indexOf(t)) throw new RangeError("Invalid status code");
                        return new x(null, {
                            status: t,
                            headers: {
                                location: e1
                            }
                        });
                    }, e1.Headers = p, e1.Request = _, e1.Response = x, e1.fetch = function(r, s) {
                        return new Promise(function(o, e1) {
                            var t = new _(r, s), n = new XMLHttpRequest;
                            n.onload = function() {
                                var r, e1 = {
                                    status: n.status,
                                    statusText: n.statusText,
                                    headers: (e1 = n.getAllResponseHeaders() || "", r = new p, e1.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function(e1) {
                                        var e1 = e1.split(":"), t = e1.shift().trim();
                                        t && (e1 = e1.join(":").trim(), r.append(t, e1));
                                    }), r)
                                }, t = (e1.url = "responseURL" in n ? n.responseURL : e1.headers.get("X-Request-URL"), "response" in n ? n.response : n.responseText);
                                o(new x(t, e1));
                            }, n.onerror = function() {
                                e1(new TypeError("Network request failed"));
                            }, n.ontimeout = function() {
                                e1(new TypeError("Network request failed"));
                            }, n.open(t.method, t.url, !0), "include" === t.credentials ? n.withCredentials = !0 : "omit" === t.credentials && (n.withCredentials = !1), "responseType" in n && i && (n.responseType = "blob"), t.headers.forEach(function(e1, t) {
                                n.setRequestHeader(t, e1);
                            }), n.send(void 0 === t._bodyInit ? null : t._bodyInit);
                        });
                    }, e1.fetch.polyfill = !0);
                }("undefined" != typeof self ? self : this);
            },
            {}
        ],
        262: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.function.name"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.split"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var l, o = n(e1("../core/main")), u = n(e1("../color/color_conversion"));
                function n(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                var c = [
                    {
                        h: 0,
                        s: 0,
                        b: .8275,
                        name: "gray"
                    },
                    {
                        h: 0,
                        s: 0,
                        b: .8627,
                        name: "gray"
                    },
                    {
                        h: 0,
                        s: 0,
                        b: .7529,
                        name: "gray"
                    },
                    {
                        h: .0167,
                        s: .1176,
                        b: 1,
                        name: "light pink"
                    }
                ], d = [
                    {
                        h: 0,
                        s: 0,
                        b: 0,
                        name: "black"
                    },
                    {
                        h: 0,
                        s: 0,
                        b: .5,
                        name: "gray"
                    },
                    {
                        h: 0,
                        s: 0,
                        b: 1,
                        name: "white"
                    },
                    {
                        h: 0,
                        s: .5,
                        b: .5,
                        name: "dark maroon"
                    },
                    {
                        h: 0,
                        s: .5,
                        b: 1,
                        name: "salmon pink"
                    },
                    {
                        h: 0,
                        s: 1,
                        b: 0,
                        name: "black"
                    },
                    {
                        h: 0,
                        s: 1,
                        b: .5,
                        name: "dark red"
                    },
                    {
                        h: 0,
                        s: 1,
                        b: 1,
                        name: "red"
                    },
                    {
                        h: 5,
                        s: 0,
                        b: 1,
                        name: "very light peach"
                    },
                    {
                        h: 5,
                        s: .5,
                        b: .5,
                        name: "brown"
                    },
                    {
                        h: 5,
                        s: .5,
                        b: 1,
                        name: "peach"
                    },
                    {
                        h: 5,
                        s: 1,
                        b: .5,
                        name: "brick red"
                    },
                    {
                        h: 5,
                        s: 1,
                        b: 1,
                        name: "crimson"
                    },
                    {
                        h: 10,
                        s: 0,
                        b: 1,
                        name: "light peach"
                    },
                    {
                        h: 10,
                        s: .5,
                        b: .5,
                        name: "brown"
                    },
                    {
                        h: 10,
                        s: .5,
                        b: 1,
                        name: "light orange"
                    },
                    {
                        h: 10,
                        s: 1,
                        b: .5,
                        name: "brown"
                    },
                    {
                        h: 10,
                        s: 1,
                        b: 1,
                        name: "orange"
                    },
                    {
                        h: 15,
                        s: 0,
                        b: 1,
                        name: "very light yellow"
                    },
                    {
                        h: 15,
                        s: .5,
                        b: .5,
                        name: "olive green"
                    },
                    {
                        h: 15,
                        s: .5,
                        b: 1,
                        name: "light yellow"
                    },
                    {
                        h: 15,
                        s: 1,
                        b: 0,
                        name: "dark olive green"
                    },
                    {
                        h: 15,
                        s: 1,
                        b: .5,
                        name: "olive green"
                    },
                    {
                        h: 15,
                        s: 1,
                        b: 1,
                        name: "yellow"
                    },
                    {
                        h: 20,
                        s: 0,
                        b: 1,
                        name: "very light yellow"
                    },
                    {
                        h: 20,
                        s: .5,
                        b: .5,
                        name: "olive green"
                    },
                    {
                        h: 20,
                        s: .5,
                        b: 1,
                        name: "light yellow green"
                    },
                    {
                        h: 20,
                        s: 1,
                        b: 0,
                        name: "dark olive green"
                    },
                    {
                        h: 20,
                        s: 1,
                        b: .5,
                        name: "dark yellow green"
                    },
                    {
                        h: 20,
                        s: 1,
                        b: 1,
                        name: "yellow green"
                    },
                    {
                        h: 25,
                        s: .5,
                        b: .5,
                        name: "dark yellow green"
                    },
                    {
                        h: 25,
                        s: .5,
                        b: 1,
                        name: "light green"
                    },
                    {
                        h: 25,
                        s: 1,
                        b: .5,
                        name: "dark green"
                    },
                    {
                        h: 25,
                        s: 1,
                        b: 1,
                        name: "green"
                    },
                    {
                        h: 30,
                        s: .5,
                        b: 1,
                        name: "light green"
                    },
                    {
                        h: 30,
                        s: 1,
                        b: .5,
                        name: "dark green"
                    },
                    {
                        h: 30,
                        s: 1,
                        b: 1,
                        name: "green"
                    },
                    {
                        h: 35,
                        s: 0,
                        b: .5,
                        name: "light green"
                    },
                    {
                        h: 35,
                        s: 0,
                        b: 1,
                        name: "very light green"
                    },
                    {
                        h: 35,
                        s: .5,
                        b: .5,
                        name: "dark green"
                    },
                    {
                        h: 35,
                        s: .5,
                        b: 1,
                        name: "light green"
                    },
                    {
                        h: 35,
                        s: 1,
                        b: 0,
                        name: "very dark green"
                    },
                    {
                        h: 35,
                        s: 1,
                        b: .5,
                        name: "dark green"
                    },
                    {
                        h: 35,
                        s: 1,
                        b: 1,
                        name: "green"
                    },
                    {
                        h: 40,
                        s: 0,
                        b: 1,
                        name: "very light green"
                    },
                    {
                        h: 40,
                        s: .5,
                        b: .5,
                        name: "dark green"
                    },
                    {
                        h: 40,
                        s: .5,
                        b: 1,
                        name: "light green"
                    },
                    {
                        h: 40,
                        s: 1,
                        b: .5,
                        name: "dark green"
                    },
                    {
                        h: 40,
                        s: 1,
                        b: 1,
                        name: "green"
                    },
                    {
                        h: 45,
                        s: .5,
                        b: 1,
                        name: "light turquoise"
                    },
                    {
                        h: 45,
                        s: 1,
                        b: .5,
                        name: "dark turquoise"
                    },
                    {
                        h: 45,
                        s: 1,
                        b: 1,
                        name: "turquoise"
                    },
                    {
                        h: 50,
                        s: 0,
                        b: 1,
                        name: "light sky blue"
                    },
                    {
                        h: 50,
                        s: .5,
                        b: .5,
                        name: "dark cyan"
                    },
                    {
                        h: 50,
                        s: .5,
                        b: 1,
                        name: "light cyan"
                    },
                    {
                        h: 50,
                        s: 1,
                        b: .5,
                        name: "dark cyan"
                    },
                    {
                        h: 50,
                        s: 1,
                        b: 1,
                        name: "cyan"
                    },
                    {
                        h: 55,
                        s: 0,
                        b: 1,
                        name: "light sky blue"
                    },
                    {
                        h: 55,
                        s: .5,
                        b: 1,
                        name: "light sky blue"
                    },
                    {
                        h: 55,
                        s: 1,
                        b: .5,
                        name: "dark blue"
                    },
                    {
                        h: 55,
                        s: 1,
                        b: 1,
                        name: "sky blue"
                    },
                    {
                        h: 60,
                        s: 0,
                        b: .5,
                        name: "gray"
                    },
                    {
                        h: 60,
                        s: 0,
                        b: 1,
                        name: "very light blue"
                    },
                    {
                        h: 60,
                        s: .5,
                        b: .5,
                        name: "blue"
                    },
                    {
                        h: 60,
                        s: .5,
                        b: 1,
                        name: "light blue"
                    },
                    {
                        h: 60,
                        s: 1,
                        b: .5,
                        name: "navy blue"
                    },
                    {
                        h: 60,
                        s: 1,
                        b: 1,
                        name: "blue"
                    },
                    {
                        h: 65,
                        s: 0,
                        b: 1,
                        name: "lavender"
                    },
                    {
                        h: 65,
                        s: .5,
                        b: .5,
                        name: "navy blue"
                    },
                    {
                        h: 65,
                        s: .5,
                        b: 1,
                        name: "light purple"
                    },
                    {
                        h: 65,
                        s: 1,
                        b: .5,
                        name: "dark navy blue"
                    },
                    {
                        h: 65,
                        s: 1,
                        b: 1,
                        name: "blue"
                    },
                    {
                        h: 70,
                        s: 0,
                        b: 1,
                        name: "lavender"
                    },
                    {
                        h: 70,
                        s: .5,
                        b: .5,
                        name: "navy blue"
                    },
                    {
                        h: 70,
                        s: .5,
                        b: 1,
                        name: "lavender blue"
                    },
                    {
                        h: 70,
                        s: 1,
                        b: .5,
                        name: "dark navy blue"
                    },
                    {
                        h: 70,
                        s: 1,
                        b: 1,
                        name: "blue"
                    },
                    {
                        h: 75,
                        s: .5,
                        b: 1,
                        name: "lavender"
                    },
                    {
                        h: 75,
                        s: 1,
                        b: .5,
                        name: "dark purple"
                    },
                    {
                        h: 75,
                        s: 1,
                        b: 1,
                        name: "purple"
                    },
                    {
                        h: 80,
                        s: .5,
                        b: 1,
                        name: "pinkish purple"
                    },
                    {
                        h: 80,
                        s: 1,
                        b: .5,
                        name: "dark purple"
                    },
                    {
                        h: 80,
                        s: 1,
                        b: 1,
                        name: "purple"
                    },
                    {
                        h: 85,
                        s: 0,
                        b: 1,
                        name: "light pink"
                    },
                    {
                        h: 85,
                        s: .5,
                        b: .5,
                        name: "purple"
                    },
                    {
                        h: 85,
                        s: .5,
                        b: 1,
                        name: "light fuchsia"
                    },
                    {
                        h: 85,
                        s: 1,
                        b: .5,
                        name: "dark fuchsia"
                    },
                    {
                        h: 85,
                        s: 1,
                        b: 1,
                        name: "fuchsia"
                    },
                    {
                        h: 90,
                        s: .5,
                        b: .5,
                        name: "dark fuchsia"
                    },
                    {
                        h: 90,
                        s: .5,
                        b: 1,
                        name: "hot pink"
                    },
                    {
                        h: 90,
                        s: 1,
                        b: .5,
                        name: "dark fuchsia"
                    },
                    {
                        h: 90,
                        s: 1,
                        b: 1,
                        name: "fuchsia"
                    },
                    {
                        h: 95,
                        s: 0,
                        b: 1,
                        name: "pink"
                    },
                    {
                        h: 95,
                        s: .5,
                        b: 1,
                        name: "light pink"
                    },
                    {
                        h: 95,
                        s: 1,
                        b: .5,
                        name: "dark magenta"
                    },
                    {
                        h: 95,
                        s: 1,
                        b: 1,
                        name: "magenta"
                    }
                ];
                o.default.prototype._rgbColorName = function(e1) {
                    var t, r, e1 = u.default._rgbaToHSBA(e1), o = [
                        (l = e1)[0],
                        e1[1],
                        e1[2]
                    ];
                    0 !== o[0] && (o[0] = Math.round(100 * o[0]), (e1 = o[0].toString().split(""))[r = e1.length - 1] = parseInt(e1[r]), e1[r] < 2.5 ? e1[r] = 0 : 2.5 <= e1[r] && e1[r] < 7.5 && (e1[r] = 5), 2 === e1.length ? (e1[0] = parseInt(e1[0]), 7.5 <= e1[r] && (e1[r] = 0, e1[0] = e1[0] + 1), o[0] = 10 * e1[0] + e1[1]) : 7.5 <= e1[r] ? o[0] = 10 : o[0] = e1[r]), o[2] = o[2] / 255;
                    for(var n = o.length - 1; 1 <= n; n--)o[n] <= .25 ? o[n] = 0 : .25 < o[n] && o[n] < .75 ? o[n] = .5 : o[n] = 1;
                    if (0 === o[0] && 0 === o[1] && 1 === o[2]) {
                        for(var s = 2; 0 <= s; s--)l[s] = Math.round(1e4 * l[s]) / 1e4;
                        for(var i = 0; i < c.length; i++){
                            if (c[i].h === l[0] && c[i].s === l[1] && c[i].b === l[2]) {
                                t = c[i].name;
                                break;
                            }
                            t = "white";
                        }
                    } else for(var a = 0; a < d.length; a++)if (d[a].h === o[0] && d[a].s === o[1] && d[a].b === o[2]) {
                        t = d[a].name;
                        break;
                    }
                    return t;
                };
                e1 = o.default;
                r.default = e1;
            },
            {
                "../color/color_conversion": 268,
                "../core/main": 283,
                "core-js/modules/es.function.name": 174,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.regexp.exec": 195,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.split": 206
            }
        ],
        263: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.ends-with"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.ends-with"), e1("core-js/modules/es.string.replace"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                var i = "_Description", a = "_fallbackDesc", l = "_fallbackTable", u = "_Label", c = "_labelDesc", d = "_labelTable";
                function h(e1) {
                    if ("label" === e1 || "fallback" === e1) throw new Error("description should not be LABEL or FALLBACK");
                    return e1.endsWith(".") || e1.endsWith(";") || e1.endsWith(",") || e1.endsWith("?") || e1.endsWith("!") || (e1 += "."), e1;
                }
                s.default.prototype.describe = function(e1, t) {
                    var r;
                    s.default._validateParameters("describe", arguments), "string" == typeof e1 && (r = this.canvas.id, e1 = h(e1), this.dummyDOM || (this.dummyDOM = document.getElementById(r).parentNode), this.descriptions || (this.descriptions = {}), this.descriptions.fallback ? this.descriptions.fallback.innerHTML !== e1 && (this.descriptions.fallback.innerHTML = e1) : this._describeHTML("fallback", e1), t === this.LABEL && (this.descriptions.label ? this.descriptions.label.innerHTML !== e1 && (this.descriptions.label.innerHTML = e1) : this._describeHTML("label", e1)));
                }, s.default.prototype.describeElement = function(e1, t, r) {
                    var o, n;
                    s.default._validateParameters("describeElement", arguments), "string" == typeof t && "string" == typeof e1 && (o = this.canvas.id, t = h(t), n = function(e1) {
                        if ("label" === e1 || "fallback" === e1) throw new Error("element name should not be LABEL or FALLBACK");
                        e1.endsWith(".") || e1.endsWith(";") || e1.endsWith(",") ? e1 = e1.replace(/.$/, ":") : e1.endsWith(":") || (e1 += ":");
                        return e1;
                    }(e1), e1 = e1.replace(/[^a-zA-Z0-9]/g, ""), n = '<th scope="row">'.concat(n, "</th><td>").concat(t, "</td>"), this.dummyDOM || (this.dummyDOM = document.getElementById(o).parentNode), this.descriptions ? this.descriptions.fallbackElements || (this.descriptions.fallbackElements = {}) : this.descriptions = {
                        fallbackElements: {}
                    }, this.descriptions.fallbackElements[e1] ? this.descriptions.fallbackElements[e1].innerHTML !== n && (this.descriptions.fallbackElements[e1].innerHTML = n) : this._describeElementHTML("fallback", e1, n), r === this.LABEL && (this.descriptions.labelElements || (this.descriptions.labelElements = {}), this.descriptions.labelElements[e1] ? this.descriptions.labelElements[e1].innerHTML !== n && (this.descriptions.labelElements[e1].innerHTML = n) : this._describeElementHTML("label", e1, n)));
                }, s.default.prototype._describeHTML = function(e1, t) {
                    var r, o = this.canvas.id;
                    "fallback" === e1 ? (this.dummyDOM.querySelector("#".concat(o + i)) ? this.dummyDOM.querySelector("#" + o + l).insertAdjacentHTML("beforebegin", '<p id="'.concat(o + a, '"></p>')) : (r = '<div id="'.concat(o).concat(i, '" role="region" aria-label="Canvas Description"><p id="').concat(o).concat(a, '"></p></div>'), this.dummyDOM.querySelector("#".concat(o, "accessibleOutput")) ? this.dummyDOM.querySelector("#".concat(o, "accessibleOutput")).insertAdjacentHTML("beforebegin", r) : this.dummyDOM.querySelector("#".concat(o)).innerHTML = r), this.descriptions.fallback = this.dummyDOM.querySelector("#".concat(o).concat(a)), this.descriptions.fallback.innerHTML = t) : "label" === e1 && (this.dummyDOM.querySelector("#".concat(o + u)) ? this.dummyDOM.querySelector("#".concat(o + d)) && this.dummyDOM.querySelector("#".concat(o + d)).insertAdjacentHTML("beforebegin", '<p id="'.concat(o).concat(c, '"></p>')) : (r = '<div id="'.concat(o).concat(u, '" class="p5Label"><p id="').concat(o).concat(c, '"></p></div>'), this.dummyDOM.querySelector("#".concat(o, "accessibleOutputLabel")) ? this.dummyDOM.querySelector("#".concat(o, "accessibleOutputLabel")).insertAdjacentHTML("beforebegin", r) : this.dummyDOM.querySelector("#" + o).insertAdjacentHTML("afterend", r)), this.descriptions.label = this.dummyDOM.querySelector("#" + o + c), this.descriptions.label.innerHTML = t);
                }, s.default.prototype._describeElementHTML = function(e1, t, r) {
                    var o, n = this.canvas.id;
                    "fallback" === e1 ? (this.dummyDOM.querySelector("#".concat(n + i)) ? this.dummyDOM.querySelector("#" + n + l) || this.dummyDOM.querySelector("#" + n + a).insertAdjacentHTML("afterend", '<table id="'.concat(n).concat(l, '"><caption>Canvas elements and their descriptions</caption></table>')) : (o = '<div id="'.concat(n).concat(i, '" role="region" aria-label="Canvas Description"><table id="').concat(n).concat(l, '"><caption>Canvas elements and their descriptions</caption></table></div>'), this.dummyDOM.querySelector("#".concat(n, "accessibleOutput")) ? this.dummyDOM.querySelector("#".concat(n, "accessibleOutput")).insertAdjacentHTML("beforebegin", o) : this.dummyDOM.querySelector("#" + n).innerHTML = o), (o = document.createElement("tr")).id = n + "_fte_" + t, this.dummyDOM.querySelector("#" + n + l).appendChild(o), this.descriptions.fallbackElements[t] = this.dummyDOM.querySelector("#".concat(n).concat("_fte_").concat(t)), this.descriptions.fallbackElements[t].innerHTML = r) : "label" === e1 && (this.dummyDOM.querySelector("#".concat(n + u)) ? this.dummyDOM.querySelector("#".concat(n + d)) || this.dummyDOM.querySelector("#" + n + c).insertAdjacentHTML("afterend", '<table id="'.concat(n + d, '"></table>')) : (o = '<div id="'.concat(n).concat(u, '" class="p5Label"><table id="').concat(n).concat(d, '"></table></div>'), this.dummyDOM.querySelector("#".concat(n, "accessibleOutputLabel")) ? this.dummyDOM.querySelector("#".concat(n, "accessibleOutputLabel")).insertAdjacentHTML("beforebegin", o) : this.dummyDOM.querySelector("#" + n).insertAdjacentHTML("afterend", o)), (e1 = document.createElement("tr")).id = n + "_lte_" + t, this.dummyDOM.querySelector("#" + n + d).appendChild(e1), this.descriptions.labelElements[t] = this.dummyDOM.querySelector("#".concat(n).concat("_lte_").concat(t)), this.descriptions.labelElements[t].innerHTML = r);
                };
                e1 = s.default;
                r.default = e1;
            },
            {
                "../core/main": 283,
                "core-js/modules/es.array.concat": 153,
                "core-js/modules/es.regexp.exec": 195,
                "core-js/modules/es.string.ends-with": 198,
                "core-js/modules/es.string.replace": 204
            }
        ],
        264: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.string.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                s.default.prototype._updateGridOutput = function(e1) {
                    var t, r, o, n;
                    this._renderer && this._renderer instanceof s.default.RendererGL ? this._didOutputGridWebGLMessage || (this._didOutputGridWebGLMessage = !0, console.error("gridOutput() does not yet work in WebGL mode.")) : this.dummyDOM.querySelector("#".concat(e1, "_summary")) && (t = this._accessibleOutputs[e1], o = function(e1, t, r, o) {
                        t = "".concat(t, " canvas, ").concat(r, " by ").concat(o, " pixels, contains ").concat(e1[0]);
                        t = (1 === e1[0] ? "".concat(t, " shape: ") : "".concat(t, " shapes: ")).concat(e1[1]);
                        return t;
                    }((r = function(e1, t) {
                        var r, o = "", n = "", s = 0;
                        for(r in t){
                            var i, a = 0;
                            for(i in t[r]){
                                var l = '<li id="'.concat(e1, "shape").concat(s, '">').concat(t[r][i].color, " ").concat(r, ",");
                                "line" === r ? l += " location = ".concat(t[r][i].pos, ", length = ").concat(t[r][i].length, " pixels") : (l += " location = ".concat(t[r][i].pos), "point" !== r && (l += ", area = ".concat(t[r][i].area, " %")), l += "</li>"), o += l, a++, s++;
                            }
                            n = 1 < a ? "".concat(n, " ").concat(a, " ").concat(r, "s") : "".concat(n, " ").concat(a, " ").concat(r);
                        }
                        return {
                            numShapes: [
                                s,
                                n
                            ],
                            details: o
                        };
                    }(e1, this.ingredients.shapes)).numShapes, this.ingredients.colors.background, this.width, this.height), n = function(e1, t) {
                        var r, o, n = 0, s = "", i = Array.from(Array(10), function() {
                            return Array(10);
                        });
                        for(r in t)for(var a in t[r]){
                            var l = void 0;
                            l = "line" !== r ? '<a href="#'.concat(e1, "shape").concat(n, '">').concat(t[r][a].color, " ").concat(r, "</a>") : '<a href="#'.concat(e1, "shape").concat(n, '">').concat(t[r][a].color, " ").concat(r, " midpoint</a>"), t[r][a].loc.locY < i.length && t[r][a].loc.locX < i[t[r][a].loc.locY].length && (i[t[r][a].loc.locY][t[r][a].loc.locX] ? i[t[r][a].loc.locY][t[r][a].loc.locX] = i[t[r][a].loc.locY][t[r][a].loc.locX] + "  " + l : i[t[r][a].loc.locY][t[r][a].loc.locX] = l, n++);
                        }
                        for(o in i){
                            var u, c = "<tr>";
                            for(u in i[o])c += "<td>", void 0 !== i[o][u] && (c += i[o][u]), c += "</td>";
                            s = s + c + "</tr>";
                        }
                        return s;
                    }(e1, this.ingredients.shapes), o !== t.summary.innerHTML && (t.summary.innerHTML = o), n !== t.map.innerHTML && (t.map.innerHTML = n), r.details !== t.shapeDetails.innerHTML && (t.shapeDetails.innerHTML = r.details), this._accessibleOutputs[e1] = t);
                };
                e1 = s.default;
                r.default = e1;
            },
            {
                "../core/main": 283,
                "core-js/modules/es.array.concat": 153,
                "core-js/modules/es.array.from": 162,
                "core-js/modules/es.array.map": 168,
                "core-js/modules/es.string.iterator": 200
            }
        ],
        265: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.number.to-fixed"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var o = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function l(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                function u(e1, t, r) {
                    var o = e1[0], e1 = e1[1], o = Math.floor(o / t * 10), t = Math.floor(e1 / r * 10);
                    return {
                        locX: Math.min(Math.max(o, 0), 9),
                        locY: Math.min(Math.max(t, 0), 9)
                    };
                }
                o.default.prototype.textOutput = function(e1) {
                    o.default._validateParameters("textOutput", arguments), this._accessibleOutputs.text || (this._accessibleOutputs.text = !0, this._createOutput("textOutput", "Fallback"), e1 === this.LABEL && (this._accessibleOutputs.textLabel = !0, this._createOutput("textOutput", "Label")));
                }, o.default.prototype.gridOutput = function(e1) {
                    o.default._validateParameters("gridOutput", arguments), this._accessibleOutputs.grid || (this._accessibleOutputs.grid = !0, this._createOutput("gridOutput", "Fallback"), e1 === this.LABEL && (this._accessibleOutputs.gridLabel = !0, this._createOutput("gridOutput", "Label")));
                }, o.default.prototype._addAccsOutput = function() {
                    return this._accessibleOutputs || (this._accessibleOutputs = {
                        text: !1,
                        grid: !1,
                        textLabel: !1,
                        gridLabel: !1
                    }), this._accessibleOutputs.grid || this._accessibleOutputs.text;
                }, o.default.prototype._createOutput = function(e1, t) {
                    var r, o, n, s = this.canvas.id, i = (this.ingredients || (this.ingredients = {
                        shapes: {},
                        colors: {
                            background: "white",
                            fill: "white",
                            stroke: "black"
                        },
                        pShapes: "",
                        pBackground: ""
                    }), this.dummyDOM || (this.dummyDOM = document.getElementById(s).parentNode), "");
                    "Fallback" === t ? (r = s + e1, this.dummyDOM.querySelector("#".concat(o = s + "accessibleOutput")) || (this.dummyDOM.querySelector("#".concat(s, "_Description")) ? this.dummyDOM.querySelector("#".concat(s, "_Description")).insertAdjacentHTML("afterend", '<div id="'.concat(o, '" role="region" aria-label="Canvas Outputs"></div>')) : this.dummyDOM.querySelector("#".concat(s)).innerHTML = '<div id="'.concat(o, '" role="region" aria-label="Canvas Outputs"></div>'))) : "Label" === t && (r = s + e1 + (i = t), this.dummyDOM.querySelector("#".concat(o = s + "accessibleOutput" + t)) || (this.dummyDOM.querySelector("#".concat(s, "_Label")) ? this.dummyDOM.querySelector("#".concat(s, "_Label")) : this.dummyDOM.querySelector("#".concat(s))).insertAdjacentHTML("afterend", '<div id="'.concat(o, '"></div>'))), this._accessibleOutputs[r] = {}, "textOutput" === e1 ? (i = "#".concat(s, "gridOutput").concat(i), n = '<div id="'.concat(r, '">Text Output<div id="').concat(r, 'Summary" aria-label="text output summary"><p id="').concat(r, '_summary"></p><ul id="').concat(r, '_list"></ul></div><table id="').concat(r, '_shapeDetails" summary="text output shape details"></table></div>'), this.dummyDOM.querySelector(i) ? this.dummyDOM.querySelector(i).insertAdjacentHTML("beforebegin", n) : this.dummyDOM.querySelector("#".concat(o)).innerHTML = n, this._accessibleOutputs[r].list = this.dummyDOM.querySelector("#".concat(r, "_list"))) : "gridOutput" === e1 && (i = "#".concat(s, "textOutput").concat(i), n = '<div id="'.concat(r, '">Grid Output<p id="').concat(r, '_summary" aria-label="grid output summary"><table id="').concat(r, '_map" summary="grid output content"></table><ul id="').concat(r, '_shapeDetails" aria-label="grid output shape details"></ul></div>'), this.dummyDOM.querySelector(i) ? this.dummyDOM.querySelector(i).insertAdjacentHTML("afterend", n) : this.dummyDOM.querySelector("#".concat(o)).innerHTML = n, this._accessibleOutputs[r].map = this.dummyDOM.querySelector("#".concat(r, "_map"))), this._accessibleOutputs[r].shapeDetails = this.dummyDOM.querySelector("#".concat(r, "_shapeDetails")), this._accessibleOutputs[r].summary = this.dummyDOM.querySelector("#".concat(r, "_summary"));
                }, o.default.prototype._updateAccsOutput = function() {
                    var e1 = this.canvas.id;
                    JSON.stringify(this.ingredients.shapes) === this.ingredients.pShapes && this.ingredients.colors.background === this.ingredients.pBackground || (this.ingredients.pShapes = JSON.stringify(this.ingredients.shapes), this._accessibleOutputs.text && this._updateTextOutput(e1 + "textOutput"), this._accessibleOutputs.grid && this._updateGridOutput(e1 + "gridOutput"), this._accessibleOutputs.textLabel && this._updateTextOutput(e1 + "textOutputLabel"), this._accessibleOutputs.gridLabel && this._updateGridOutput(e1 + "gridOutputLabel"));
                }, o.default.prototype._accsBackground = function(e1) {
                    this.ingredients.pShapes = JSON.stringify(this.ingredients.shapes), this.ingredients.pBackground = this.ingredients.colors.background, this.ingredients.shapes = {}, this.ingredients.colors.backgroundRGBA !== e1 && (this.ingredients.colors.backgroundRGBA = e1, this.ingredients.colors.background = this._rgbColorName(e1));
                }, o.default.prototype._accsCanvasColors = function(e1, t) {
                    "fill" === e1 ? this.ingredients.colors.fillRGBA !== t && (this.ingredients.colors.fillRGBA = t, this.ingredients.colors.fill = this._rgbColorName(t)) : "stroke" === e1 && this.ingredients.colors.strokeRGBA !== t && (this.ingredients.colors.strokeRGBA = t, this.ingredients.colors.stroke = this._rgbColorName(t));
                }, o.default.prototype._accsOutput = function(e1, t) {
                    "ellipse" === e1 && t[2] === t[3] ? e1 = "circle" : "rectangle" === e1 && t[2] === t[3] && (e1 = "square");
                    var r, o, n = {}, s = !0, i = function(e1, t) {
                        var r;
                        e1 = "rectangle" === e1 || "ellipse" === e1 || "arc" === e1 || "circle" === e1 || "square" === e1 ? (r = Math.round(t[0] + t[2] / 2), Math.round(t[1] + t[3] / 2)) : "triangle" === e1 ? (r = (t[0] + t[2] + t[4]) / 3, (t[1] + t[3] + t[5]) / 3) : "quadrilateral" === e1 ? (r = (t[0] + t[2] + t[4] + t[6]) / 4, (t[1] + t[3] + t[5] + t[7]) / 4) : "line" === e1 ? (r = (t[0] + t[2]) / 2, (t[1] + t[3]) / 2) : (r = t[0], t[1]);
                        return [
                            r,
                            e1
                        ];
                    }(e1, t);
                    if ("line" === e1 ? (n.color = this.ingredients.colors.stroke, n.length = Math.round(this.dist(t[0], t[1], t[2], t[3])), r = this._getPos(t[0], [
                        1
                    ]), o = this._getPos(t[2], [
                        3
                    ]), n.loc = u(i, this.width, this.height), n.pos = r === o ? "at ".concat(r) : "from ".concat(r, " to ").concat(o)) : ("point" === e1 ? n.color = this.ingredients.colors.stroke : (n.color = this.ingredients.colors.fill, n.area = this._getArea(e1, t)), n.pos = this._getPos.apply(this, l(i)), n.loc = u(i, this.width, this.height)), this.ingredients.shapes[e1]) {
                        for(var a in this.ingredients.shapes[e1])JSON.stringify(this.ingredients.shapes[e1][a]) === JSON.stringify(n) && (s = !1);
                        !0 === s && this.ingredients.shapes[e1].push(n);
                    } else this.ingredients.shapes[e1] = [
                        n
                    ];
                }, o.default.prototype._getPos = function(e1, t) {
                    var e1 = new DOMPointReadOnly(e1, t), t = this._renderer.isP3D ? new DOMMatrix(this._renderer.uMVMatrix.mat4) : this.drawingContext.getTransform(), e1 = e1.matrixTransform(t), t = e1.x, e1 = e1.y, r = this.width * this._pixelDensity, o = this.height * this._pixelDensity;
                    return t < .4 * r ? e1 < .4 * o ? "top left" : .6 * o < e1 ? "bottom left" : "mid left" : .6 * r < t ? e1 < .4 * o ? "top right" : .6 * o < e1 ? "bottom right" : "mid right" : e1 < .4 * o ? "top middle" : .6 * o < e1 ? "bottom middle" : "middle";
                }, o.default.prototype._getArea = function(e1, t) {
                    var r, o, n = 0, s = ("arc" === e1 ? (n = (r = ((t[5] - t[4]) % (2 * Math.PI) + 2 * Math.PI) % (2 * Math.PI)) * t[2] * t[3] / 8, "open" !== t[6] && "chord" !== t[6] || (o = t[0], u = t[1], s = t[0] + t[2] / 2 * Math.cos(t[4]).toFixed(2), c = t[1] + t[3] / 2 * Math.sin(t[4]).toFixed(2), a = t[0] + t[2] / 2 * Math.cos(t[5]).toFixed(2), i = t[1] + t[3] / 2 * Math.sin(t[5]).toFixed(2), o = Math.abs(o * (c - i) + s * (i - u) + a * (u - c)) / 2, r > Math.PI ? n += o : n -= o)) : "ellipse" === e1 || "circle" === e1 ? n = 3.14 * t[2] / 2 * t[3] / 2 : "line" === e1 || "point" === e1 ? n = 0 : "quadrilateral" === e1 ? n = Math.abs((t[6] + t[0]) * (t[7] - t[1]) + (t[0] + t[2]) * (t[1] - t[3]) + (t[2] + t[4]) * (t[3] - t[5]) + (t[4] + t[6]) * (t[5] - t[7])) / 2 : "rectangle" === e1 || "square" === e1 ? n = t[2] * t[3] : "triangle" === e1 && (n = Math.abs(t[0] * (t[3] - t[5]) + t[2] * (t[5] - t[1]) + t[4] * (t[1] - t[3])) / 2), this.width * this._pixelDensity), i = this.height * this._pixelDensity, a = [
                        new DOMPoint(0, 0),
                        new DOMPoint(s, 0),
                        new DOMPoint(s, i),
                        new DOMPoint(0, i)
                    ], l = (this._renderer.isP3D ? new DOMMatrix(this._renderer.uMVMatrix.mat4) : this.drawingContext.getTransform()).inverse(), u = a.map(function(e1) {
                        return e1.matrixTransform(l);
                    }), c = Math.abs((u[3].x + u[0].x) * (u[3].y - u[0].y) + (u[0].x + u[1].x) * (u[0].y - u[1].y) + (u[1].x + u[2].x) * (u[1].y - u[2].y) + (u[2].x + u[3].x) * (u[2].y - u[3].y)) / 2;
                    return Math.round(100 * n / c);
                };
                e1 = o.default;
                r.default = e1;
            },
            {
                "../core/main": 283,
                "core-js/modules/es.array.concat": 153,
                "core-js/modules/es.array.fill": 156,
                "core-js/modules/es.array.from": 162,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.map": 168,
                "core-js/modules/es.number.to-fixed": 182,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        266: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.concat"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                s.default.prototype._updateTextOutput = function(e1) {
                    var t, r, o, n;
                    this._renderer && this._renderer instanceof s.default.RendererGL ? this._didOutputTextWebGLMessage || (this._didOutputTextWebGLMessage = !0, console.error("textOutput() does not yet work in WebGL mode.")) : this.dummyDOM.querySelector("#".concat(e1, "_summary")) && (t = this._accessibleOutputs[e1], o = function(e1, t, r, o) {
                        r = "Your output is a, ".concat(r, " by ").concat(o, " pixels, ").concat(t, " canvas containing the following");
                        r = 1 === e1 ? "".concat(r, " shape:") : "".concat(r, " ").concat(e1, " shapes:");
                        return r;
                    }((r = function(e1, t) {
                        var r, o = "", n = 0;
                        for(r in t)for(var s in t[r]){
                            var i = '<li><a href="#'.concat(e1, "shape").concat(n, '">').concat(t[r][s].color, " ").concat(r, "</a>");
                            "line" === r ? i += ", ".concat(t[r][s].pos, ", ").concat(t[r][s].length, " pixels long.</li>") : (i += ", at ".concat(t[r][s].pos), "point" !== r && (i += ", covering ".concat(t[r][s].area, "% of the canvas")), i += ".</li>"), o += i, n++;
                        }
                        return {
                            numShapes: n,
                            listShapes: o
                        };
                    }(e1, this.ingredients.shapes)).numShapes, this.ingredients.colors.background, this.width, this.height), n = function(e1, t) {
                        var r, o = "", n = 0;
                        for(r in t)for(var s in t[r]){
                            var i = '<tr id="'.concat(e1, "shape").concat(n, '"><th>').concat(t[r][s].color, " ").concat(r, "</th>");
                            "line" === r ? i += "<td>location = ".concat(t[r][s].pos, "</td><td>length = ").concat(t[r][s].length, " pixels</td></tr>") : (i += "<td>location = ".concat(t[r][s].pos, "</td>"), "point" !== r && (i += "<td> area = ".concat(t[r][s].area, "%</td>")), i += "</tr>"), o += i, n++;
                        }
                        return o;
                    }(e1, this.ingredients.shapes), o !== t.summary.innerHTML && (t.summary.innerHTML = o), r.listShapes !== t.list.innerHTML && (t.list.innerHTML = r.listShapes), n !== t.shapeDetails.innerHTML && (t.shapeDetails.innerHTML = n), this._accessibleOutputs[e1] = t);
                };
                e1 = s.default;
                r.default = e1;
            },
            {
                "../core/main": 283,
                "core-js/modules/es.array.concat": 153
            }
        ],
        267: [
            function(e1, t, r) {
                "use strict";
                var o = (o = e1("./core/main")) && o.__esModule ? o : {
                    default: o
                };
                e1("./core/constants"), e1("./core/environment"), e1("./core/friendly_errors/stacktrace"), e1("./core/friendly_errors/validate_params"), e1("./core/friendly_errors/file_errors"), e1("./core/friendly_errors/fes_core"), e1("./core/friendly_errors/sketch_reader"), e1("./core/helpers"), e1("./core/legacy"), e1("./core/preload"), e1("./core/p5.Element"), e1("./core/p5.Graphics"), e1("./core/p5.Renderer"), e1("./core/p5.Renderer2D"), e1("./core/rendering"), e1("./core/shim"), e1("./core/structure"), e1("./core/transform"), e1("./core/shape/2d_primitives"), e1("./core/shape/attributes"), e1("./core/shape/curves"), e1("./core/shape/vertex"), e1("./accessibility/outputs"), e1("./accessibility/textOutput"), e1("./accessibility/gridOutput"), e1("./accessibility/color_namer"), e1("./color/color_conversion"), e1("./color/creating_reading"), e1("./color/p5.Color"), e1("./color/setting"), e1("./data/p5.TypedDict"), e1("./data/local_storage.js"), e1("./dom/dom"), e1("./accessibility/describe"), e1("./events/acceleration"), e1("./events/keyboard"), e1("./events/mouse"), e1("./events/touch"), e1("./image/filters"), e1("./image/image"), e1("./image/loading_displaying"), e1("./image/p5.Image"), e1("./image/pixels"), e1("./io/files"), e1("./io/p5.Table"), e1("./io/p5.TableRow"), e1("./io/p5.XML"), e1("./math/calculation"), e1("./math/math"), e1("./math/noise"), e1("./math/p5.Vector"), e1("./math/random"), e1("./math/trigonometry"), e1("./typography/attributes"), e1("./typography/loading_displaying"), e1("./typography/p5.Font"), e1("./utilities/array_functions"), e1("./utilities/conversion"), e1("./utilities/string_functions"), e1("./utilities/time_date"), e1("./webgl/3d_primitives"), e1("./webgl/interaction"), e1("./webgl/light"), e1("./webgl/loading"), e1("./webgl/material"), e1("./webgl/p5.Camera"), e1("./webgl/p5.DataArray"), e1("./webgl/p5.Geometry"), e1("./webgl/p5.Matrix"), e1("./webgl/p5.Quat"), e1("./webgl/p5.RendererGL.Immediate"), e1("./webgl/p5.RendererGL"), e1("./webgl/p5.RendererGL.Retained"), e1("./webgl/p5.Framebuffer"), e1("./webgl/p5.Shader"), e1("./webgl/p5.RenderBuffer"), e1("./webgl/p5.Texture"), e1("./webgl/text"), e1("./core/init"), t.exports = o.default;
            },
            {
                "./accessibility/color_namer": 262,
                "./accessibility/describe": 263,
                "./accessibility/gridOutput": 264,
                "./accessibility/outputs": 265,
                "./accessibility/textOutput": 266,
                "./color/color_conversion": 268,
                "./color/creating_reading": 269,
                "./color/p5.Color": 270,
                "./color/setting": 271,
                "./core/constants": 272,
                "./core/environment": 273,
                "./core/friendly_errors/fes_core": 274,
                "./core/friendly_errors/file_errors": 275,
                "./core/friendly_errors/sketch_reader": 276,
                "./core/friendly_errors/stacktrace": 277,
                "./core/friendly_errors/validate_params": 278,
                "./core/helpers": 279,
                "./core/init": 280,
                "./core/legacy": 282,
                "./core/main": 283,
                "./core/p5.Element": 284,
                "./core/p5.Graphics": 285,
                "./core/p5.Renderer": 286,
                "./core/p5.Renderer2D": 287,
                "./core/preload": 288,
                "./core/rendering": 289,
                "./core/shape/2d_primitives": 290,
                "./core/shape/attributes": 291,
                "./core/shape/curves": 292,
                "./core/shape/vertex": 293,
                "./core/shim": 294,
                "./core/structure": 295,
                "./core/transform": 296,
                "./data/local_storage.js": 297,
                "./data/p5.TypedDict": 298,
                "./dom/dom": 299,
                "./events/acceleration": 300,
                "./events/keyboard": 301,
                "./events/mouse": 302,
                "./events/touch": 303,
                "./image/filters": 304,
                "./image/image": 305,
                "./image/loading_displaying": 306,
                "./image/p5.Image": 307,
                "./image/pixels": 308,
                "./io/files": 309,
                "./io/p5.Table": 310,
                "./io/p5.TableRow": 311,
                "./io/p5.XML": 312,
                "./math/calculation": 313,
                "./math/math": 314,
                "./math/noise": 315,
                "./math/p5.Vector": 316,
                "./math/random": 317,
                "./math/trigonometry": 318,
                "./typography/attributes": 319,
                "./typography/loading_displaying": 320,
                "./typography/p5.Font": 321,
                "./utilities/array_functions": 322,
                "./utilities/conversion": 323,
                "./utilities/string_functions": 324,
                "./utilities/time_date": 325,
                "./webgl/3d_primitives": 326,
                "./webgl/interaction": 328,
                "./webgl/light": 329,
                "./webgl/loading": 330,
                "./webgl/material": 331,
                "./webgl/p5.Camera": 332,
                "./webgl/p5.DataArray": 333,
                "./webgl/p5.Framebuffer": 334,
                "./webgl/p5.Geometry": 335,
                "./webgl/p5.Matrix": 336,
                "./webgl/p5.Quat": 337,
                "./webgl/p5.RenderBuffer": 338,
                "./webgl/p5.RendererGL": 341,
                "./webgl/p5.RendererGL.Immediate": 339,
                "./webgl/p5.RendererGL.Retained": 340,
                "./webgl/p5.Shader": 342,
                "./webgl/p5.Texture": 343,
                "./webgl/text": 344
            }
        ],
        268: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                e1.default.ColorConversion = {
                    _hsbaToHSLA: function(e1) {
                        var t = e1[0], r = e1[1], o = e1[2], n = (2 - r) * o / 2;
                        return 0 != n && (1 == n ? r = 0 : n < .5 ? r /= 2 - r : r = r * o / (2 - 2 * n)), [
                            t,
                            r,
                            n,
                            e1[3]
                        ];
                    },
                    _hsbaToRGBA: function(e1) {
                        var t, r, o, n, s, i = 6 * e1[0], a = e1[1], l = e1[2];
                        return 0 === a ? [
                            l,
                            l,
                            l,
                            e1[3]
                        ] : (r = l * (1 - a), o = l * (1 - a * (i - (t = Math.floor(i)))), a = l * (1 - a * (1 + t - i)), i = 1 === t ? (n = o, s = l, r) : 2 === t ? (n = r, s = l, a) : 3 === t ? (n = r, s = o, l) : 4 === t ? (n = a, s = r, l) : 5 === t ? (n = l, s = r, o) : (n = l, s = a, r), [
                            n,
                            s,
                            i,
                            e1[3]
                        ]);
                    },
                    _hslaToHSBA: function(e1) {
                        var t = e1[0], r = e1[1], o = e1[2], n = o < .5 ? (1 + r) * o : o + r - o * r;
                        return [
                            t,
                            r = 2 * (n - o) / n,
                            n,
                            e1[3]
                        ];
                    },
                    _hslaToRGBA: function(e1) {
                        var t, r = 6 * e1[0], o = e1[1], n = e1[2];
                        return 0 === o ? [
                            n,
                            n,
                            n,
                            e1[3]
                        ] : [
                            (t = function(e1, t, r) {
                                return e1 < 0 ? e1 += 6 : 6 <= e1 && (e1 -= 6), e1 < 1 ? t + (r - t) * e1 : e1 < 3 ? r : e1 < 4 ? t + (r - t) * (4 - e1) : t;
                            })(2 + r, o = 2 * n - (n = n < .5 ? (1 + o) * n : n + o - n * o), n),
                            t(r, o, n),
                            t(r - 2, o, n),
                            e1[3]
                        ];
                    },
                    _rgbaToHSBA: function(e1) {
                        var t, r, o = e1[0], n = e1[1], s = e1[2], i = Math.max(o, n, s), a = i - Math.min(o, n, s);
                        return 0 == a ? r = t = 0 : (r = a / i, o === i ? t = (n - s) / a : n === i ? t = 2 + (s - o) / a : s === i && (t = 4 + (o - n) / a), t < 0 ? t += 6 : 6 <= t && (t -= 6)), [
                            t / 6,
                            r,
                            i,
                            e1[3]
                        ];
                    },
                    _rgbaToHSLA: function(e1) {
                        var t, r, o = e1[0], n = e1[1], s = e1[2], i = Math.max(o, n, s), a = Math.min(o, n, s), l = i + a, a = i - a;
                        return 0 == a ? r = t = 0 : (r = l < 1 ? a / l : a / (2 - l), o === i ? t = (n - s) / a : n === i ? t = 2 + (s - o) / a : s === i && (t = 4 + (o - n) / a), t < 0 ? t += 6 : 6 <= t && (t -= 6)), [
                            t / 6,
                            r,
                            l / 2,
                            e1[3]
                        ];
                    }
                };
                e1 = e1.default.ColorConversion;
                r.default = e1;
            },
            {
                "../core/main": 283
            }
        ],
        269: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.map"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var l = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                }, u = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                e1("./p5.Color"), e1("../core/friendly_errors/validate_params"), e1("../core/friendly_errors/file_errors"), e1("../core/friendly_errors/fes_core"), l.default.prototype.alpha = function(e1) {
                    return l.default._validateParameters("alpha", arguments), this.color(e1)._getAlpha();
                }, l.default.prototype.blue = function(e1) {
                    return l.default._validateParameters("blue", arguments), this.color(e1)._getBlue();
                }, l.default.prototype.brightness = function(e1) {
                    return l.default._validateParameters("brightness", arguments), this.color(e1)._getBrightness();
                }, l.default.prototype.color = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return l.default._validateParameters("color", r), r[0] instanceof l.default.Color ? r[0] : (e1 = Array.isArray(r[0]) ? r[0] : r, new l.default.Color(this, e1));
                }, l.default.prototype.green = function(e1) {
                    return l.default._validateParameters("green", arguments), this.color(e1)._getGreen();
                }, l.default.prototype.hue = function(e1) {
                    return l.default._validateParameters("hue", arguments), this.color(e1)._getHue();
                }, l.default.prototype.lerpColor = function(e1, t, r) {
                    l.default._validateParameters("lerpColor", arguments), e1 instanceof l.default.Color || (e1 = color(e1)), t instanceof l.default.Color || (t = color(t));
                    var o, n, s, i = this._colorMode, a = this._colorMaxes;
                    if (i === u.RGB) n = e1.levels.map(function(e1) {
                        return e1 / 255;
                    }), s = t.levels.map(function(e1) {
                        return e1 / 255;
                    });
                    else if (i === u.HSB) e1._getBrightness(), t._getBrightness(), n = e1.hsba, s = t.hsba;
                    else {
                        if (i !== u.HSL) throw new Error("".concat(i, " cannot be used for interpolation."));
                        e1._getLightness(), t._getLightness(), n = e1.hsla, s = t.hsla;
                    }
                    return r = Math.max(Math.min(r, 1), 0), void 0 === this.lerp && (this.lerp = function(e1, t, r) {
                        return r * (t - e1) + e1;
                    }), i === u.RGB ? o = this.lerp(n[0], s[0], r) : (.5 < Math.abs(n[0] - s[0]) && (n[0] > s[0] ? s[0] += 1 : n[0] += 1), 1 <= (o = this.lerp(n[0], s[0], r)) && --o), e1 = this.lerp(n[1], s[1], r), t = this.lerp(n[2], s[2], r), n = this.lerp(n[3], s[3], r), o *= a[i][0], e1 *= a[i][1], t *= a[i][2], n *= a[i][3], this.color(o, e1, t, n);
                }, l.default.prototype.paletteLerp = function(e1, t) {
                    var r = e1[0];
                    if (t < r[1]) return this.color(r[0]);
                    for(var o = 1; o < e1.length; o++){
                        var n, s = e1[o];
                        if (t < s[1]) return n = e1[o - 1], this.lerpColor(this.color(n[0]), this.color(s[0]), (t - n[1]) / (s[1] - n[1]));
                    }
                    return this.color(e1[e1.length - 1][0]);
                }, l.default.prototype.lightness = function(e1) {
                    return l.default._validateParameters("lightness", arguments), this.color(e1)._getLightness();
                }, l.default.prototype.red = function(e1) {
                    return l.default._validateParameters("red", arguments), this.color(e1)._getRed();
                }, l.default.prototype.saturation = function(e1) {
                    return l.default._validateParameters("saturation", arguments), this.color(e1)._getSaturation();
                };
                var n = l.default;
                r.default = n;
            },
            {
                "../core/constants": 272,
                "../core/friendly_errors/fes_core": 274,
                "../core/friendly_errors/file_errors": 275,
                "../core/friendly_errors/validate_params": 278,
                "../core/main": 283,
                "./p5.Color": 270,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.map": 168,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        270: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.constructor"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.trim"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.constructor"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.trim"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e1("../core/main")), d = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants")), h = s(e1("./color_conversion"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function s(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function l(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                var f = {
                    aliceblue: "#f0f8ff",
                    antiquewhite: "#faebd7",
                    aqua: "#00ffff",
                    aquamarine: "#7fffd4",
                    azure: "#f0ffff",
                    beige: "#f5f5dc",
                    bisque: "#ffe4c4",
                    black: "#000000",
                    blanchedalmond: "#ffebcd",
                    blue: "#0000ff",
                    blueviolet: "#8a2be2",
                    brown: "#a52a2a",
                    burlywood: "#deb887",
                    cadetblue: "#5f9ea0",
                    chartreuse: "#7fff00",
                    chocolate: "#d2691e",
                    coral: "#ff7f50",
                    cornflowerblue: "#6495ed",
                    cornsilk: "#fff8dc",
                    crimson: "#dc143c",
                    cyan: "#00ffff",
                    darkblue: "#00008b",
                    darkcyan: "#008b8b",
                    darkgoldenrod: "#b8860b",
                    darkgray: "#a9a9a9",
                    darkgreen: "#006400",
                    darkgrey: "#a9a9a9",
                    darkkhaki: "#bdb76b",
                    darkmagenta: "#8b008b",
                    darkolivegreen: "#556b2f",
                    darkorange: "#ff8c00",
                    darkorchid: "#9932cc",
                    darkred: "#8b0000",
                    darksalmon: "#e9967a",
                    darkseagreen: "#8fbc8f",
                    darkslateblue: "#483d8b",
                    darkslategray: "#2f4f4f",
                    darkslategrey: "#2f4f4f",
                    darkturquoise: "#00ced1",
                    darkviolet: "#9400d3",
                    deeppink: "#ff1493",
                    deepskyblue: "#00bfff",
                    dimgray: "#696969",
                    dimgrey: "#696969",
                    dodgerblue: "#1e90ff",
                    firebrick: "#b22222",
                    floralwhite: "#fffaf0",
                    forestgreen: "#228b22",
                    fuchsia: "#ff00ff",
                    gainsboro: "#dcdcdc",
                    ghostwhite: "#f8f8ff",
                    gold: "#ffd700",
                    goldenrod: "#daa520",
                    gray: "#808080",
                    green: "#008000",
                    greenyellow: "#adff2f",
                    grey: "#808080",
                    honeydew: "#f0fff0",
                    hotpink: "#ff69b4",
                    indianred: "#cd5c5c",
                    indigo: "#4b0082",
                    ivory: "#fffff0",
                    khaki: "#f0e68c",
                    lavender: "#e6e6fa",
                    lavenderblush: "#fff0f5",
                    lawngreen: "#7cfc00",
                    lemonchiffon: "#fffacd",
                    lightblue: "#add8e6",
                    lightcoral: "#f08080",
                    lightcyan: "#e0ffff",
                    lightgoldenrodyellow: "#fafad2",
                    lightgray: "#d3d3d3",
                    lightgreen: "#90ee90",
                    lightgrey: "#d3d3d3",
                    lightpink: "#ffb6c1",
                    lightsalmon: "#ffa07a",
                    lightseagreen: "#20b2aa",
                    lightskyblue: "#87cefa",
                    lightslategray: "#778899",
                    lightslategrey: "#778899",
                    lightsteelblue: "#b0c4de",
                    lightyellow: "#ffffe0",
                    lime: "#00ff00",
                    limegreen: "#32cd32",
                    linen: "#faf0e6",
                    magenta: "#ff00ff",
                    maroon: "#800000",
                    mediumaquamarine: "#66cdaa",
                    mediumblue: "#0000cd",
                    mediumorchid: "#ba55d3",
                    mediumpurple: "#9370db",
                    mediumseagreen: "#3cb371",
                    mediumslateblue: "#7b68ee",
                    mediumspringgreen: "#00fa9a",
                    mediumturquoise: "#48d1cc",
                    mediumvioletred: "#c71585",
                    midnightblue: "#191970",
                    mintcream: "#f5fffa",
                    mistyrose: "#ffe4e1",
                    moccasin: "#ffe4b5",
                    navajowhite: "#ffdead",
                    navy: "#000080",
                    oldlace: "#fdf5e6",
                    olive: "#808000",
                    olivedrab: "#6b8e23",
                    orange: "#ffa500",
                    orangered: "#ff4500",
                    orchid: "#da70d6",
                    palegoldenrod: "#eee8aa",
                    palegreen: "#98fb98",
                    paleturquoise: "#afeeee",
                    palevioletred: "#db7093",
                    papayawhip: "#ffefd5",
                    peachpuff: "#ffdab9",
                    peru: "#cd853f",
                    pink: "#ffc0cb",
                    plum: "#dda0dd",
                    powderblue: "#b0e0e6",
                    purple: "#800080",
                    rebeccapurple: "#663399",
                    red: "#ff0000",
                    rosybrown: "#bc8f8f",
                    royalblue: "#4169e1",
                    saddlebrown: "#8b4513",
                    salmon: "#fa8072",
                    sandybrown: "#f4a460",
                    seagreen: "#2e8b57",
                    seashell: "#fff5ee",
                    sienna: "#a0522d",
                    silver: "#c0c0c0",
                    skyblue: "#87ceeb",
                    slateblue: "#6a5acd",
                    slategray: "#708090",
                    slategrey: "#708090",
                    snow: "#fffafa",
                    springgreen: "#00ff7f",
                    steelblue: "#4682b4",
                    tan: "#d2b48c",
                    teal: "#008080",
                    thistle: "#d8bfd8",
                    tomato: "#ff6347",
                    turquoise: "#40e0d0",
                    violet: "#ee82ee",
                    wheat: "#f5deb3",
                    white: "#ffffff",
                    whitesmoke: "#f5f5f5",
                    yellow: "#ffff00",
                    yellowgreen: "#9acd32"
                }, e1 = /\s*/, u = /(\d{1,3})/, c = /((?:\d+(?:\.\d+)?)|(?:\.\d+))/, p = new RegExp("".concat(c.source, "%")), m = {
                    HEX3: /^#([a-f0-9])([a-f0-9])([a-f0-9])$/i,
                    HEX4: /^#([a-f0-9])([a-f0-9])([a-f0-9])([a-f0-9])$/i,
                    HEX6: /^#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})$/i,
                    HEX8: /^#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})$/i,
                    RGB: new RegExp([
                        "^rgb\\(",
                        u.source,
                        ",",
                        u.source,
                        ",",
                        u.source,
                        "\\)$"
                    ].join(e1.source), "i"),
                    RGB_PERCENT: new RegExp([
                        "^rgb\\(",
                        p.source,
                        ",",
                        p.source,
                        ",",
                        p.source,
                        "\\)$"
                    ].join(e1.source), "i"),
                    RGBA: new RegExp([
                        "^rgba\\(",
                        u.source,
                        ",",
                        u.source,
                        ",",
                        u.source,
                        ",",
                        c.source,
                        "\\)$"
                    ].join(e1.source), "i"),
                    RGBA_PERCENT: new RegExp([
                        "^rgba\\(",
                        p.source,
                        ",",
                        p.source,
                        ",",
                        p.source,
                        ",",
                        c.source,
                        "\\)$"
                    ].join(e1.source), "i"),
                    HSL: new RegExp([
                        "^hsl\\(",
                        u.source,
                        ",",
                        p.source,
                        ",",
                        p.source,
                        "\\)$"
                    ].join(e1.source), "i"),
                    HSLA: new RegExp([
                        "^hsla\\(",
                        u.source,
                        ",",
                        p.source,
                        ",",
                        p.source,
                        ",",
                        c.source,
                        "\\)$"
                    ].join(e1.source), "i"),
                    HSB: new RegExp([
                        "^hsb\\(",
                        u.source,
                        ",",
                        p.source,
                        ",",
                        p.source,
                        "\\)$"
                    ].join(e1.source), "i"),
                    HSBA: new RegExp([
                        "^hsba\\(",
                        u.source,
                        ",",
                        p.source,
                        ",",
                        p.source,
                        ",",
                        c.source,
                        "\\)$"
                    ].join(e1.source), "i")
                }, u = (n.default.Color = function() {
                    function c(e1, t) {
                        if (!(this instanceof c)) throw new TypeError("Cannot call a class as a function");
                        if (this._storeModeAndMaxes(e1._colorMode, e1._colorMaxes), ![
                            d.RGB,
                            d.HSL,
                            d.HSB
                        ].includes(this.mode)) throw new Error("".concat(this.mode, " is an invalid colorMode."));
                        this._array = c._parseInputs.apply(this, t), this._calculateLevels();
                    }
                    var e1, t, r;
                    return e1 = c, r = [
                        {
                            key: "_parseInputs",
                            value: function(e1, t, r, o) {
                                var n, s = arguments.length, i = this.mode, a = this.maxes[i], l = [];
                                if (3 <= s) {
                                    for(l[0] = e1 / a[0], l[1] = t / a[1], l[2] = r / a[2], l[3] = "number" == typeof o ? o / a[3] : 1, n = l.length - 1; 0 <= n; --n){
                                        var u = l[n];
                                        u < 0 ? l[n] = 0 : 1 < u && (l[n] = 1);
                                    }
                                    return i === d.HSL ? h.default._hslaToRGBA(l) : i === d.HSB ? h.default._hsbaToRGBA(l) : l;
                                }
                                if (1 === s && "string" == typeof e1) {
                                    r = e1.trim().toLowerCase();
                                    if (f[r]) return c._parseInputs.call(this, f[r]);
                                    if (m.HEX3.test(r)) return (l = m.HEX3.exec(r).slice(1).map(function(e1) {
                                        return parseInt(e1 + e1, 16) / 255;
                                    }))[3] = 1, l;
                                    if (m.HEX6.test(r)) return (l = m.HEX6.exec(r).slice(1).map(function(e1) {
                                        return parseInt(e1, 16) / 255;
                                    }))[3] = 1, l;
                                    if (m.HEX4.test(r)) return l = m.HEX4.exec(r).slice(1).map(function(e1) {
                                        return parseInt(e1 + e1, 16) / 255;
                                    });
                                    if (m.HEX8.test(r)) return l = m.HEX8.exec(r).slice(1).map(function(e1) {
                                        return parseInt(e1, 16) / 255;
                                    });
                                    if (m.RGB.test(r)) return (l = m.RGB.exec(r).slice(1).map(function(e1) {
                                        return e1 / 255;
                                    }))[3] = 1, l;
                                    if (m.RGB_PERCENT.test(r)) return (l = m.RGB_PERCENT.exec(r).slice(1).map(function(e1) {
                                        return parseFloat(e1) / 100;
                                    }))[3] = 1, l;
                                    if (m.RGBA.test(r)) return l = m.RGBA.exec(r).slice(1).map(function(e1, t) {
                                        return 3 === t ? parseFloat(e1) : e1 / 255;
                                    });
                                    if (m.RGBA_PERCENT.test(r)) return l = m.RGBA_PERCENT.exec(r).slice(1).map(function(e1, t) {
                                        return 3 === t ? parseFloat(e1) : parseFloat(e1) / 100;
                                    });
                                    if (m.HSL.test(r) ? (l = m.HSL.exec(r).slice(1).map(function(e1, t) {
                                        return 0 === t ? parseInt(e1, 10) / 360 : parseInt(e1, 10) / 100;
                                    }))[3] = 1 : m.HSLA.test(r) && (l = m.HSLA.exec(r).slice(1).map(function(e1, t) {
                                        return 0 === t ? parseInt(e1, 10) / 360 : 3 === t ? parseFloat(e1) : parseInt(e1, 10) / 100;
                                    })), (l = l.map(function(e1) {
                                        return Math.max(Math.min(e1, 1), 0);
                                    })).length) return h.default._hslaToRGBA(l);
                                    if (m.HSB.test(r) ? (l = m.HSB.exec(r).slice(1).map(function(e1, t) {
                                        return 0 === t ? parseInt(e1, 10) / 360 : parseInt(e1, 10) / 100;
                                    }))[3] = 1 : m.HSBA.test(r) && (l = m.HSBA.exec(r).slice(1).map(function(e1, t) {
                                        return 0 === t ? parseInt(e1, 10) / 360 : 3 === t ? parseFloat(e1) : parseInt(e1, 10) / 100;
                                    })), l.length) {
                                        for(n = l.length - 1; 0 <= n; --n)l[n] = Math.max(Math.min(l[n], 1), 0);
                                        return h.default._hsbaToRGBA(l);
                                    }
                                    l = [
                                        1,
                                        1,
                                        1,
                                        1
                                    ];
                                } else {
                                    if (1 !== s && 2 !== s || "number" != typeof e1) throw new Error("".concat(arguments, "is not a valid color representation."));
                                    l[0] = e1 / a[2], l[1] = e1 / a[2], l[2] = e1 / a[2], l[3] = "number" == typeof t ? t / a[3] : 1, l = l.map(function(e1) {
                                        return Math.max(Math.min(e1, 1), 0);
                                    });
                                }
                                return l;
                            }
                        }
                    ], t = [
                        {
                            key: "toString",
                            value: function(e1) {
                                var t = this.levels, r = this._array, o = r[3];
                                switch(e1){
                                    case "#rrggbb":
                                        return "#".concat(t[0] < 16 ? "0".concat(t[0].toString(16)) : t[0].toString(16), t[1] < 16 ? "0".concat(t[1].toString(16)) : t[1].toString(16), t[2] < 16 ? "0".concat(t[2].toString(16)) : t[2].toString(16));
                                    case "#rrggbbaa":
                                        return "#".concat(t[0] < 16 ? "0".concat(t[0].toString(16)) : t[0].toString(16), t[1] < 16 ? "0".concat(t[1].toString(16)) : t[1].toString(16), t[2] < 16 ? "0".concat(t[2].toString(16)) : t[2].toString(16), t[3] < 16 ? "0".concat(t[3].toString(16)) : t[3].toString(16));
                                    case "#rgb":
                                        return "#".concat(Math.round(15 * r[0]).toString(16), Math.round(15 * r[1]).toString(16), Math.round(15 * r[2]).toString(16));
                                    case "#rgba":
                                        return "#".concat(Math.round(15 * r[0]).toString(16), Math.round(15 * r[1]).toString(16), Math.round(15 * r[2]).toString(16), Math.round(15 * r[3]).toString(16));
                                    case "rgb":
                                        return "rgb(".concat(t[0], ", ", t[1], ", ", t[2], ")");
                                    case "rgb%":
                                        return "rgb(".concat((100 * r[0]).toPrecision(3), "%, ", (100 * r[1]).toPrecision(3), "%, ", (100 * r[2]).toPrecision(3), "%)");
                                    case "rgba%":
                                        return "rgba(".concat((100 * r[0]).toPrecision(3), "%, ", (100 * r[1]).toPrecision(3), "%, ", (100 * r[2]).toPrecision(3), "%, ", (100 * r[3]).toPrecision(3), "%)");
                                    case "hsb":
                                    case "hsv":
                                        return this.hsba || (this.hsba = h.default._rgbaToHSBA(this._array)), "hsb(".concat(this.hsba[0] * this.maxes[d.HSB][0], ", ", this.hsba[1] * this.maxes[d.HSB][1], ", ", this.hsba[2] * this.maxes[d.HSB][2], ")");
                                    case "hsb%":
                                    case "hsv%":
                                        return this.hsba || (this.hsba = h.default._rgbaToHSBA(this._array)), "hsb(".concat((100 * this.hsba[0]).toPrecision(3), "%, ", (100 * this.hsba[1]).toPrecision(3), "%, ", (100 * this.hsba[2]).toPrecision(3), "%)");
                                    case "hsba":
                                    case "hsva":
                                        return this.hsba || (this.hsba = h.default._rgbaToHSBA(this._array)), "hsba(".concat(this.hsba[0] * this.maxes[d.HSB][0], ", ", this.hsba[1] * this.maxes[d.HSB][1], ", ", this.hsba[2] * this.maxes[d.HSB][2], ", ", o, ")");
                                    case "hsba%":
                                    case "hsva%":
                                        return this.hsba || (this.hsba = h.default._rgbaToHSBA(this._array)), "hsba(".concat((100 * this.hsba[0]).toPrecision(3), "%, ", (100 * this.hsba[1]).toPrecision(3), "%, ", (100 * this.hsba[2]).toPrecision(3), "%, ", (100 * o).toPrecision(3), "%)");
                                    case "hsl":
                                        return this.hsla || (this.hsla = h.default._rgbaToHSLA(this._array)), "hsl(".concat(this.hsla[0] * this.maxes[d.HSL][0], ", ", this.hsla[1] * this.maxes[d.HSL][1], ", ", this.hsla[2] * this.maxes[d.HSL][2], ")");
                                    case "hsl%":
                                        return this.hsla || (this.hsla = h.default._rgbaToHSLA(this._array)), "hsl(".concat((100 * this.hsla[0]).toPrecision(3), "%, ", (100 * this.hsla[1]).toPrecision(3), "%, ", (100 * this.hsla[2]).toPrecision(3), "%)");
                                    case "hsla":
                                        return this.hsla || (this.hsla = h.default._rgbaToHSLA(this._array)), "hsla(".concat(this.hsla[0] * this.maxes[d.HSL][0], ", ", this.hsla[1] * this.maxes[d.HSL][1], ", ", this.hsla[2] * this.maxes[d.HSL][2], ", ", o, ")");
                                    case "hsla%":
                                        return this.hsla || (this.hsla = h.default._rgbaToHSLA(this._array)), "hsl(".concat((100 * this.hsla[0]).toPrecision(3), "%, ", (100 * this.hsla[1]).toPrecision(3), "%, ", (100 * this.hsla[2]).toPrecision(3), "%, ", (100 * o).toPrecision(3), "%)");
                                    default:
                                        return "rgba(".concat(t[0], ",", t[1], ",", t[2], ",", o, ")");
                                }
                            }
                        },
                        {
                            key: "setRed",
                            value: function(e1) {
                                this._array[0] = e1 / this.maxes[d.RGB][0], this._calculateLevels();
                            }
                        },
                        {
                            key: "setGreen",
                            value: function(e1) {
                                this._array[1] = e1 / this.maxes[d.RGB][1], this._calculateLevels();
                            }
                        },
                        {
                            key: "setBlue",
                            value: function(e1) {
                                this._array[2] = e1 / this.maxes[d.RGB][2], this._calculateLevels();
                            }
                        },
                        {
                            key: "setAlpha",
                            value: function(e1) {
                                this._array[3] = e1 / this.maxes[this.mode][3], this._calculateLevels();
                            }
                        },
                        {
                            key: "_calculateLevels",
                            value: function() {
                                for(var e1 = this._array, t = this.levels = new Array(e1.length), r = e1.length - 1; 0 <= r; --r)t[r] = Math.round(255 * e1[r]);
                                this.hsla = null, this.hsba = null;
                            }
                        },
                        {
                            key: "_getAlpha",
                            value: function() {
                                return this._array[3] * this.maxes[this.mode][3];
                            }
                        },
                        {
                            key: "_storeModeAndMaxes",
                            value: function(e1, t) {
                                this.mode = e1, this.maxes = t;
                            }
                        },
                        {
                            key: "_getMode",
                            value: function() {
                                return this.mode;
                            }
                        },
                        {
                            key: "_getMaxes",
                            value: function() {
                                return this.maxes;
                            }
                        },
                        {
                            key: "_getBlue",
                            value: function() {
                                return this._array[2] * this.maxes[d.RGB][2];
                            }
                        },
                        {
                            key: "_getBrightness",
                            value: function() {
                                return this.hsba || (this.hsba = h.default._rgbaToHSBA(this._array)), this.hsba[2] * this.maxes[d.HSB][2];
                            }
                        },
                        {
                            key: "_getGreen",
                            value: function() {
                                return this._array[1] * this.maxes[d.RGB][1];
                            }
                        },
                        {
                            key: "_getHue",
                            value: function() {
                                return this.mode === d.HSB ? (this.hsba || (this.hsba = h.default._rgbaToHSBA(this._array)), this.hsba[0] * this.maxes[d.HSB][0]) : (this.hsla || (this.hsla = h.default._rgbaToHSLA(this._array)), this.hsla[0] * this.maxes[d.HSL][0]);
                            }
                        },
                        {
                            key: "_getLightness",
                            value: function() {
                                return this.hsla || (this.hsla = h.default._rgbaToHSLA(this._array)), this.hsla[2] * this.maxes[d.HSL][2];
                            }
                        },
                        {
                            key: "_getRed",
                            value: function() {
                                return this._array[0] * this.maxes[d.RGB][0];
                            }
                        },
                        {
                            key: "_getSaturation",
                            value: function() {
                                return this.mode === d.HSB ? (this.hsba || (this.hsba = h.default._rgbaToHSBA(this._array)), this.hsba[1] * this.maxes[d.HSB][1]) : (this.hsla || (this.hsla = h.default._rgbaToHSLA(this._array)), this.hsla[1] * this.maxes[d.HSL][1]);
                            }
                        }
                    ], l(e1.prototype, t), r && l(e1, r), c;
                }(), n.default.Color);
                r.default = u;
            },
            {
                "../core/constants": 272,
                "../core/main": 283,
                "./color_conversion": 268,
                "core-js/modules/es.array.includes": 163,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.join": 166,
                "core-js/modules/es.array.map": 168,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.regexp.constructor": 194,
                "core-js/modules/es.regexp.exec": 195,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.includes": 199,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.string.trim": 209,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        271: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.fill"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                }, a = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = l();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function l() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, l = function() {
                        return e1;
                    }, e1);
                }
                e1("./p5.Color"), s.default.prototype.beginClip = function() {
                    this._renderer.beginClip(0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {});
                }, s.default.prototype.endClip = function() {
                    this._renderer.endClip();
                }, s.default.prototype.clip = function(e1, t) {
                    this._renderer.beginClip(t), e1(), this._renderer.endClip(t);
                }, s.default.prototype.background = function() {
                    var e1;
                    return (e1 = this._renderer).background.apply(e1, arguments), this;
                }, s.default.prototype.clear = function() {
                    return this._renderer.clear((arguments.length <= 0 ? void 0 : arguments[0]) || 0, (arguments.length <= 1 ? void 0 : arguments[1]) || 0, (arguments.length <= 2 ? void 0 : arguments[2]) || 0, (arguments.length <= 3 ? void 0 : arguments[3]) || 0), this;
                }, s.default.prototype.colorMode = function(e1, t, r, o, n) {
                    return s.default._validateParameters("colorMode", arguments), e1 !== a.RGB && e1 !== a.HSB && e1 !== a.HSL || (this._colorMode = e1, e1 = this._colorMaxes[e1], 2 === arguments.length ? (e1[0] = t, e1[1] = t, e1[2] = t, e1[3] = t) : 4 === arguments.length ? (e1[0] = t, e1[1] = r, e1[2] = o) : 5 === arguments.length && (e1[0] = t, e1[1] = r, e1[2] = o, e1[3] = n)), this;
                }, s.default.prototype.fill = function() {
                    var e1;
                    return this._renderer._setProperty("_fillSet", !0), this._renderer._setProperty("_doFill", !0), (e1 = this._renderer).fill.apply(e1, arguments), this;
                }, s.default.prototype.noFill = function() {
                    return this._renderer._setProperty("_doFill", !1), this;
                }, s.default.prototype.noStroke = function() {
                    return this._renderer._setProperty("_doStroke", !1), this;
                }, s.default.prototype.stroke = function() {
                    var e1;
                    return this._renderer._setProperty("_strokeSet", !0), this._renderer._setProperty("_doStroke", !0), (e1 = this._renderer).stroke.apply(e1, arguments), this;
                }, s.default.prototype.erase = function() {
                    return this._renderer.erase(0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 255, 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 255), this;
                }, s.default.prototype.noErase = function() {
                    return this._renderer.noErase(), this;
                };
                var n = s.default;
                r.default = n;
            },
            {
                "../core/constants": 272,
                "../core/main": 283,
                "./p5.Color": 270,
                "core-js/modules/es.array.fill": 156,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        272: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.QUADRATIC = r.LINEAR = r._CTX_MIDDLE = r._DEFAULT_LEADMULT = r._DEFAULT_TEXT_FILL = r.WORD = r.CHAR = r.BOLDITALIC = r.BOLD = r.ITALIC = r.NORMAL = r.BLUR = r.ERODE = r.DILATE = r.POSTERIZE = r.INVERT = r.OPAQUE = r.GRAY = r.THRESHOLD = r.BURN = r.DODGE = r.SOFT_LIGHT = r.HARD_LIGHT = r.OVERLAY = r.REPLACE = r.SCREEN = r.MULTIPLY = r.EXCLUSION = r.SUBTRACT = r.DIFFERENCE = r.LIGHTEST = r.DARKEST = r.ADD = r.REMOVE = r.BLEND = r.UP_ARROW = r.TAB = r.SHIFT = r.RIGHT_ARROW = r.RETURN = r.OPTION = r.LEFT_ARROW = r.ESCAPE = r.ENTER = r.DOWN_ARROW = r.DELETE = r.CONTROL = r.BACKSPACE = r.ALT = r.AUTO = r.HSL = r.HSB = r.RGB = r.MITER = r.BEVEL = r.ROUND = r.SQUARE = r.PROJECT = r.PIE = r.CHORD = r.OPEN = r.CLOSE = r.TESS = r.QUAD_STRIP = r.QUADS = r.TRIANGLE_STRIP = r.TRIANGLE_FAN = r.TRIANGLES = r.LINE_LOOP = r.LINE_STRIP = r.LINES = r.POINTS = r.BASELINE = r.BOTTOM = r.TOP = r.CENTER = r.LEFT = r.RIGHT = r.RADIUS = r.CORNERS = r.CORNER = r.RAD_TO_DEG = r.DEG_TO_RAD = r.RADIANS = r.DEGREES = r.TWO_PI = r.TAU = r.QUARTER_PI = r.PI = r.HALF_PI = r.WAIT = r.TEXT = r.MOVE = r.HAND = r.CROSS = r.ARROW = r.WEBGL2 = r.WEBGL = r.P2D = r.VERSION = void 0, r.RGBA = r.HALF_FLOAT = r.FLOAT = r.UNSIGNED_INT = r.UNSIGNED_BYTE = r.COVER = r.CONTAIN = r.FALLBACK = r.LABEL = r.AXES = r.GRID = r._DEFAULT_FILL = r._DEFAULT_STROKE = r.PORTRAIT = r.LANDSCAPE = r.SMOOTH = r.FLAT = r.MIRROR = r.CLAMP = r.REPEAT = r.NEAREST = r.IMAGE = r.IMMEDIATE = r.TEXTURE = r.FILL = r.STROKE = r.CURVE = r.BEZIER = void 0;
                var o = Math.PI, n = (r.VERSION = "1.11.13", r.P2D = "p2d", r.WEBGL = "webgl", r.WEBGL2 = "webgl2", r.ARROW = "default", r.CROSS = "crosshair", r.HAND = "pointer", r.MOVE = "move", r.TEXT = "text", r.WAIT = "wait", o / 2), n = (r.HALF_PI = n, o), n = (r.PI = n, o / 4), n = (r.QUARTER_PI = n, 2 * o), n = (r.TAU = n, 2 * o), n = (r.TWO_PI = n, r.DEGREES = "degrees", r.RADIANS = "radians", o / 180), n = (r.DEG_TO_RAD = n, 180 / o);
                r.RAD_TO_DEG = n, r.CORNER = "corner", r.CORNERS = "corners", r.RADIUS = "radius", r.RIGHT = "right", r.LEFT = "left", r.CENTER = "center", r.TOP = "top", r.BOTTOM = "bottom", r.BASELINE = "alphabetic", r.POINTS = 0, r.LINES = 1, r.LINE_STRIP = 3, r.LINE_LOOP = 2, r.TRIANGLES = 4, r.TRIANGLE_FAN = 6, r.TRIANGLE_STRIP = 5, r.QUADS = "quads", r.QUAD_STRIP = "quad_strip", r.TESS = "tess", r.CLOSE = "close", r.OPEN = "open", r.CHORD = "chord", r.PIE = "pie", r.PROJECT = "square", r.SQUARE = "butt", r.ROUND = "round", r.BEVEL = "bevel", r.MITER = "miter", r.RGB = "rgb", r.HSB = "hsb", r.HSL = "hsl", r.AUTO = "auto", r.ALT = 18, r.BACKSPACE = 8, r.CONTROL = 17, r.DELETE = 46, r.DOWN_ARROW = 40, r.ENTER = 13, r.ESCAPE = 27, r.LEFT_ARROW = 37, r.OPTION = 18, r.RETURN = 13, r.RIGHT_ARROW = 39, r.SHIFT = 16, r.TAB = 9, r.UP_ARROW = 38, r.BLEND = "source-over", r.REMOVE = "destination-out", r.ADD = "lighter", r.DARKEST = "darken", r.LIGHTEST = "lighten", r.DIFFERENCE = "difference", r.SUBTRACT = "subtract", r.EXCLUSION = "exclusion", r.MULTIPLY = "multiply", r.SCREEN = "screen", r.REPLACE = "copy", r.OVERLAY = "overlay", r.HARD_LIGHT = "hard-light", r.SOFT_LIGHT = "soft-light", r.DODGE = "color-dodge", r.BURN = "color-burn", r.THRESHOLD = "threshold", r.GRAY = "gray", r.OPAQUE = "opaque", r.INVERT = "invert", r.POSTERIZE = "posterize", r.DILATE = "dilate", r.ERODE = "erode", r.BLUR = "blur", r.NORMAL = "normal", r.ITALIC = "italic", r.BOLD = "bold", r.BOLDITALIC = "bold italic", r.CHAR = "CHAR", r.WORD = "WORD", r._DEFAULT_TEXT_FILL = "#000000", r._DEFAULT_LEADMULT = 1.25, r._CTX_MIDDLE = "middle", r.LINEAR = "linear", r.QUADRATIC = "quadratic", r.BEZIER = "bezier", r.CURVE = "curve", r.STROKE = "stroke", r.FILL = "fill", r.TEXTURE = "texture", r.IMMEDIATE = "immediate", r.IMAGE = "image", r.NEAREST = "nearest", r.REPEAT = "repeat", r.CLAMP = "clamp", r.MIRROR = "mirror", r.FLAT = "flat", r.SMOOTH = "smooth", r.LANDSCAPE = "landscape", r.PORTRAIT = "portrait", r._DEFAULT_STROKE = "#000000", r._DEFAULT_FILL = "#FFFFFF", r.GRID = "grid", r.AXES = "axes", r.LABEL = "label", r.FALLBACK = "fallback", r.CONTAIN = "contain", r.COVER = "cover", r.UNSIGNED_BYTE = "unsigned-byte", r.UNSIGNED_INT = "unsigned-int", r.FLOAT = "float", r.HALF_FLOAT = "half-float";
                r.RGBA = "rgba";
            },
            {}
        ],
        273: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.search"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.search"), e1("core-js/modules/es.string.split"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (s = e1("./main")) && s.__esModule ? s : {
                    default: s
                }, s = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("./constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                var l = [
                    s.ARROW,
                    s.CROSS,
                    s.HAND,
                    s.MOVE,
                    s.TEXT,
                    s.WAIT
                ], u = (n.default.prototype._frameRate = 0, n.default.prototype._lastFrameTime = window.performance.now(), n.default.prototype._targetFrameRate = 60, window.print), c = !1;
                function d() {
                    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth || 0;
                }
                function h() {
                    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight || 0;
                }
                n.default.prototype.print = function() {
                    var e1;
                    arguments.length ? (e1 = console).log.apply(e1, arguments) : c || (u(), window.confirm("You just tried to print the webpage. Do you want to prevent this from running again?") && (c = !0));
                }, n.default.prototype.frameCount = 0, n.default.prototype.deltaTime = 0, n.default.prototype.focused = document.hasFocus(), n.default.prototype.cursor = function(e1, t, r) {
                    var o, n = "auto", s = this._curElement.elt;
                    l.includes(e1) ? n = e1 : "string" == typeof e1 && (o = "", t && r && "number" == typeof t && "number" == typeof r && (o = "".concat(t, " ").concat(r)), n = "http://" === e1.substring(0, 7) || "https://" === e1.substring(0, 8) || /\.(cur|jpg|jpeg|gif|png|CUR|JPG|JPEG|GIF|PNG)$/.test(e1) ? "url(".concat(e1, ") ").concat(o, ", auto") : e1), s.style.cursor = n;
                }, n.default.prototype.frameRate = function(e1) {
                    return n.default._validateParameters("frameRate", arguments), "number" != typeof e1 || e1 < 0 ? this._frameRate : (this._setProperty("_targetFrameRate", e1), 0 === e1 && this._setProperty("_frameRate", e1), this);
                }, n.default.prototype.getFrameRate = function() {
                    return this.frameRate();
                }, n.default.prototype.setFrameRate = function(e1) {
                    return this.frameRate(e1);
                }, n.default.prototype.getTargetFrameRate = function() {
                    return this._targetFrameRate;
                }, n.default.prototype.noCursor = function() {
                    this._curElement.elt.style.cursor = "none";
                }, n.default.prototype.webglVersion = s.P2D, n.default.prototype.displayWidth = screen.width, n.default.prototype.displayHeight = screen.height, n.default.prototype.windowWidth = 0, n.default.prototype.windowHeight = 0, n.default.prototype._onresize = function(e1) {
                    this._setProperty("windowWidth", d()), this._setProperty("windowHeight", h());
                    var t = this._isGlobal ? window : this;
                    "function" != typeof t.windowResized || void 0 === (t = t.windowResized(e1)) || t || e1.preventDefault();
                }, n.default.prototype._updateWindowSize = function() {
                    this._setProperty("windowWidth", d()), this._setProperty("windowHeight", h());
                }, n.default.prototype.width = 0, n.default.prototype.height = 0, n.default.prototype.fullscreen = function(e1) {
                    if (n.default._validateParameters("fullscreen", arguments), void 0 === e1) return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
                    if (e1) {
                        e1 = document.documentElement;
                        if (!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled)) throw new Error("Fullscreen not enabled in this browser.");
                        e1.requestFullscreen ? e1.requestFullscreen() : e1.mozRequestFullScreen ? e1.mozRequestFullScreen() : e1.webkitRequestFullscreen ? e1.webkitRequestFullscreen() : e1.msRequestFullscreen && e1.msRequestFullscreen();
                    } else document.exitFullscreen ? document.exitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : document.msExitFullscreen && document.msExitFullscreen();
                }, n.default.prototype.pixelDensity = function(e1) {
                    var t;
                    return n.default._validateParameters("pixelDensity", arguments), "number" == typeof e1 ? (e1 !== this._pixelDensity && (this._pixelDensity = this._maxAllowedPixelDimensions = e1), (t = this).resizeCanvas(this.width, this.height, !0)) : t = this._pixelDensity, t;
                }, n.default.prototype.displayDensity = function() {
                    return window.devicePixelRatio;
                }, n.default.prototype.getURL = function() {
                    return location.href;
                }, n.default.prototype.getURLPath = function() {
                    return location.pathname.split("/").filter(function(e1) {
                        return "" !== e1;
                    });
                }, n.default.prototype.getURLParams = function() {
                    for(var e1, t = /[?&]([^&=]+)(?:[&=])([^&=]+)/gim, r = {}; null != (e1 = t.exec(location.search));)e1.index === t.lastIndex && t.lastIndex++, r[e1[1]] = e1[2];
                    return r;
                };
                e1 = n.default;
                r.default = e1;
            },
            {
                "./constants": 272,
                "./main": 283,
                "core-js/modules/es.array.concat": 153,
                "core-js/modules/es.array.filter": 157,
                "core-js/modules/es.array.includes": 163,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.regexp.exec": 195,
                "core-js/modules/es.string.includes": 199,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.string.search": 205,
                "core-js/modules/es.string.split": 206,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        274: [
            function(r, e1, t) {
                "use strict";
                r("core-js/modules/es.symbol"), r("core-js/modules/es.symbol.description"), r("core-js/modules/es.symbol.iterator"), r("core-js/modules/es.array.concat"), r("core-js/modules/es.array.filter"), r("core-js/modules/es.array.for-each"), r("core-js/modules/es.array.includes"), r("core-js/modules/es.array.iterator"), r("core-js/modules/es.array.join"), r("core-js/modules/es.array.map"), r("core-js/modules/es.array.slice"), r("core-js/modules/es.array.some"), r("core-js/modules/es.function.name"), r("core-js/modules/es.object.assign"), r("core-js/modules/es.object.get-own-property-names"), r("core-js/modules/es.object.keys"), r("core-js/modules/es.object.to-string"), r("core-js/modules/es.regexp.constructor"), r("core-js/modules/es.regexp.exec"), r("core-js/modules/es.regexp.to-string"), r("core-js/modules/es.string.iterator"), r("core-js/modules/es.string.match"), r("core-js/modules/es.string.replace"), r("core-js/modules/es.string.split"), r("core-js/modules/es.string.starts-with"), r("core-js/modules/web.dom-collections.for-each"), r("core-js/modules/web.dom-collections.iterator"), r("core-js/modules/es.symbol"), r("core-js/modules/es.symbol.description"), r("core-js/modules/es.symbol.iterator"), r("core-js/modules/es.array.concat"), r("core-js/modules/es.array.filter"), r("core-js/modules/es.array.for-each"), r("core-js/modules/es.array.includes"), r("core-js/modules/es.array.iterator"), r("core-js/modules/es.array.join"), r("core-js/modules/es.array.map"), r("core-js/modules/es.array.slice"), r("core-js/modules/es.array.some"), r("core-js/modules/es.function.name"), r("core-js/modules/es.object.assign"), r("core-js/modules/es.object.get-own-property-names"), r("core-js/modules/es.object.keys"), r("core-js/modules/es.object.to-string"), r("core-js/modules/es.regexp.constructor"), r("core-js/modules/es.regexp.exec"), r("core-js/modules/es.regexp.to-string"), r("core-js/modules/es.string.iterator"), r("core-js/modules/es.string.match"), r("core-js/modules/es.string.replace"), r("core-js/modules/es.string.split"), r("core-js/modules/es.string.starts-with"), r("core-js/modules/web.dom-collections.for-each"), r("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var o = (l = r("../main")) && l.__esModule ? l : {
                    default: l
                };
                r("../internationalization");
                function n(r, o) {
                    o = o || console.log.bind(console), s || i(), s.some(function(e1) {
                        var t;
                        if (r.message && null !== r.message.match("\\W?".concat(e1.name, "\\W"))) return t = "function" === e1.type ? "".concat(e1.name, "()") : e1.name, o("Did you just try to use p5.js's ".concat(t, " ").concat(e1.type, "? If so, you may want to move it into your sketch's setup() function.\n\nFor more details, see: ").concat(a)), !0;
                    });
                }
                var s = null, i = null, a = (o.default._friendlyError = o.default._checkForUserDefinedFunctions = o.default._fesErrorMonitor = function() {}, s = null, "https://github.com/processing/p5.js/wiki/p5.js-overview#why-cant-i-assign-variables-using-p5-functions-and-variables-before-setup"), i = function() {
                    function e1(r) {
                        return Object.getOwnPropertyNames(r).filter(function(e1) {
                            return "_" !== e1[0] && !(e1 in t) && (t[e1] = !0);
                        }).map(function(e1) {
                            var t = "function" == typeof r[e1] ? "function" : e1 === e1.toUpperCase() ? "constant" : "variable";
                            return {
                                name: e1,
                                type: t
                            };
                        });
                    }
                    var t = {};
                    (s = [].concat(e1(o.default.prototype), e1(r("../constants")))).sort(function(e1, t) {
                        return t.name.length - e1.name.length;
                    });
                }, l = (o.default.prototype._helpForMisusedAtTopLevelCode = n, "complete" !== document.readyState && (window.addEventListener("error", n, !1), window.addEventListener("load", function() {
                    window.removeEventListener("error", n, !1);
                })), o.default);
                t.default = l;
            },
            {
                "../constants": 272,
                "../internationalization": 281,
                "../main": 283,
                "./browser_errors": void 0,
                "core-js/modules/es.array.concat": 153,
                "core-js/modules/es.array.filter": 157,
                "core-js/modules/es.array.for-each": 161,
                "core-js/modules/es.array.includes": 163,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.join": 166,
                "core-js/modules/es.array.map": 168,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.array.some": 170,
                "core-js/modules/es.function.name": 174,
                "core-js/modules/es.object.assign": 183,
                "core-js/modules/es.object.get-own-property-names": 187,
                "core-js/modules/es.object.keys": 189,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.regexp.constructor": 194,
                "core-js/modules/es.regexp.exec": 195,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.string.match": 201,
                "core-js/modules/es.string.replace": 204,
                "core-js/modules/es.string.split": 206,
                "core-js/modules/es.string.starts-with": 207,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/web.dom-collections.for-each": 245,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        275: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var o = (o = e1("../main")) && o.__esModule ? o : {
                    default: o
                };
                e1("../internationalization");
                o.default._friendlyFileLoadError = function() {};
                e1 = o.default;
                r.default = e1;
            },
            {
                "../internationalization": 281,
                "../main": 283
            }
        ],
        276: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.constructor"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.trim"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.regexp.constructor"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.trim"), e1("core-js/modules/web.dom-collections.for-each"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = C(e1("../main")), s = e1("../internationalization"), a = O(e1("../constants")), l, u, c, d, h, f, p, m, y, g, v, b, _, j, x, w, S, T, E, M, I;
                function k() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, k = function() {
                        return e1;
                    }, e1);
                }
                function O(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = k();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o, n = {}, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1)Object.prototype.hasOwnProperty.call(e1, r) && ((o = s ? Object.getOwnPropertyDescriptor(e1, r) : null) && (o.get || o.set) ? Object.defineProperty(n, r, o) : n[r] = e1[r]);
                    return n.default = e1, t && t.set(e1, n), n;
                }
                function C(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function D(e1) {
                    return L(e1) || A(e1) || P();
                }
                function P() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance");
                }
                function A(e1) {
                    if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                }
                function L(e1) {
                    if (Array.isArray(e1)) {
                        for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                        return r;
                    }
                }
                n.default._fesCodeReader = function() {};
                var R = n.default;
                r.default = R;
            },
            {
                "../constants": 272,
                "../internationalization": 281,
                "../main": 283,
                "core-js/modules/es.array.filter": 157,
                "core-js/modules/es.array.for-each": 161,
                "core-js/modules/es.array.from": 162,
                "core-js/modules/es.array.includes": 163,
                "core-js/modules/es.array.index-of": 164,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.join": 166,
                "core-js/modules/es.array.map": 168,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.keys": 189,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.regexp.constructor": 194,
                "core-js/modules/es.regexp.exec": 195,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.includes": 199,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.string.match": 201,
                "core-js/modules/es.string.split": 206,
                "core-js/modules/es.string.trim": 209,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.for-each": 245,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        277: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function o() {
                    var t = /(^|@)\S+:\d+/, r = /^\s*at .*(\S+:\d+|\(native\))/m, o = /^(eval@)?(\[native code])?$/;
                    return {
                        parse: function(e1) {
                            return void 0 !== e1.stacktrace || void 0 !== e1["opera#sourceloc"] ? this.parseOpera(e1) : e1.stack && e1.stack.match(r) ? this.parseV8OrIE(e1) : e1.stack ? this.parseFFOrSafari(e1) : void 0;
                        },
                        extractLocation: function(e1) {
                            return -1 === e1.indexOf(":") ? [
                                e1
                            ] : [
                                (e1 = /(.+?)(?::(\d+))?(?::(\d+))?$/.exec(e1.replace(/[()]/g, "")))[1],
                                e1[2] || void 0,
                                e1[3] || void 0
                            ];
                        },
                        parseV8OrIE: function(e1) {
                            return e1.stack.split("\n").filter(function(e1) {
                                return !!e1.match(r);
                            }, this).map(function(e1) {
                                var t = (e1 = -1 < e1.indexOf("(eval ") ? e1.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, "") : e1).replace(/^\s+/, "").replace(/\(eval code/g, "("), r = t.match(/ (\((.+):(\d+):(\d+)\)$)/), t = (t = r ? t.replace(r[0], "") : t).split(/\s+/).slice(1), r = this.extractLocation(r ? r[1] : t.pop());
                                return {
                                    functionName: t.join(" ") || void 0,
                                    fileName: -1 < [
                                        "eval",
                                        "<anonymous>"
                                    ].indexOf(r[0]) ? void 0 : r[0],
                                    lineNumber: r[1],
                                    columnNumber: r[2],
                                    source: e1
                                };
                            }, this);
                        },
                        parseFFOrSafari: function(e1) {
                            return e1.stack.split("\n").filter(function(e1) {
                                return !e1.match(o);
                            }, this).map(function(e1) {
                                var t, r;
                                return -1 === (e1 = -1 < e1.indexOf(" > eval") ? e1.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1") : e1).indexOf("@") && -1 === e1.indexOf(":") ? {
                                    functionName: e1
                                } : {
                                    functionName: (r = e1.match(t = /((.*".+"[^@]*)?[^@]*)(?:@)/)) && r[1] ? r[1] : void 0,
                                    fileName: (r = this.extractLocation(e1.replace(t, "")))[0],
                                    lineNumber: r[1],
                                    columnNumber: r[2],
                                    source: e1
                                };
                            }, this);
                        },
                        parseOpera: function(e1) {
                            return !e1.stacktrace || -1 < e1.message.indexOf("\n") && e1.message.split("\n").length > e1.stacktrace.split("\n").length ? this.parseOpera9(e1) : e1.stack ? this.parseOpera11(e1) : this.parseOpera10(e1);
                        },
                        parseOpera9: function(e1) {
                            for(var t = /Line (\d+).*script (?:in )?(\S+)/i, r = e1.message.split("\n"), o = [], n = 2, s = r.length; n < s; n += 2){
                                var i = t.exec(r[n]);
                                i && o.push({
                                    fileName: i[2],
                                    lineNumber: i[1],
                                    source: r[n]
                                });
                            }
                            return o;
                        },
                        parseOpera10: function(e1) {
                            for(var t = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, r = e1.stacktrace.split("\n"), o = [], n = 0, s = r.length; n < s; n += 2){
                                var i = t.exec(r[n]);
                                i && o.push({
                                    functionName: i[3] || void 0,
                                    fileName: i[2],
                                    lineNumber: i[1],
                                    source: r[n]
                                });
                            }
                            return o;
                        },
                        parseOpera11: function(e1) {
                            return e1.stack.split("\n").filter(function(e1) {
                                return !!e1.match(t) && !e1.match(/^Error created at/);
                            }, this).map(function(e1) {
                                var t, r = e1.split("@"), o = this.extractLocation(r.pop()), r = r.shift() || "";
                                return {
                                    functionName: r.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0,
                                    args: void 0 === (t = r.match(/\(([^)]*)\)/) ? r.replace(/^[^(]+\(([^)]*)\)$/, "$1") : t) || "[arguments not available]" === t ? void 0 : t.split(","),
                                    fileName: o[0],
                                    lineNumber: o[1],
                                    columnNumber: o[2],
                                    source: e1
                                };
                            }, this);
                        }
                    };
                }
                e1.default._getErrorStackParser = function() {
                    return new o;
                };
                e1 = e1.default;
                r.default = e1;
            },
            {
                "../main": 283,
                "core-js/modules/es.array.filter": 157,
                "core-js/modules/es.array.index-of": 164,
                "core-js/modules/es.array.join": 166,
                "core-js/modules/es.array.map": 168,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.regexp.exec": 195,
                "core-js/modules/es.string.match": 201,
                "core-js/modules/es.string.replace": 204,
                "core-js/modules/es.string.split": 206
            }
        ],
        278: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.last-index-of"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.map"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.set"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.last-index-of"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.set"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.split"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (n = e1("../main")) && n.__esModule ? n : {
                    default: n
                };
                (function(e1) {
                    if (e1 && e1.__esModule) return;
                    if (null === e1 || "object" !== a(e1) && "function" != typeof e1) return;
                    var t = i();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                })(e1("../constants")), e1("../internationalization");
                function i() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, i = function() {
                        return e1;
                    }, e1);
                }
                function a(e1) {
                    return (a = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                n.default._validateParameters = n.default._clearValidateParamsCache = function() {};
                e1 = n.default;
                r.default = e1;
            },
            {
                "../../../docs/parameterData.json": void 0,
                "../constants": 272,
                "../internationalization": 281,
                "../main": 283,
                "core-js/modules/es.array.concat": 153,
                "core-js/modules/es.array.for-each": 161,
                "core-js/modules/es.array.includes": 163,
                "core-js/modules/es.array.index-of": 164,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.join": 166,
                "core-js/modules/es.array.last-index-of": 167,
                "core-js/modules/es.array.map": 168,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.function.name": 174,
                "core-js/modules/es.map": 175,
                "core-js/modules/es.number.constructor": 179,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.get-prototype-of": 188,
                "core-js/modules/es.object.keys": 189,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.reflect.construct": 192,
                "core-js/modules/es.regexp.exec": 195,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.set": 197,
                "core-js/modules/es.string.includes": 199,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.string.split": 206,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.for-each": 245,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        279: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var a = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = l();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("./constants"));
                function l() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, l = function() {
                        return e1;
                    }, e1);
                }
                r.default = {
                    modeAdjust: function(e1, t, r, o, n) {
                        var s;
                        return n === a.CORNER ? s = {
                            x: e1,
                            y: t,
                            w: Math.abs(r),
                            h: Math.abs(o)
                        } : n === a.CORNERS ? s = {
                            x: Math.min(e1, r),
                            y: Math.min(t, o),
                            w: Math.abs(r - e1),
                            h: Math.abs(o - t)
                        } : n === a.RADIUS ? s = {
                            x: e1 - (r = Math.abs(r)),
                            y: t - (o = Math.abs(o)),
                            w: 2 * r,
                            h: 2 * o
                        } : n === a.CENTER && (s = {
                            x: e1 - .5 * (r = Math.abs(r)),
                            y: t - .5 * (o = Math.abs(o)),
                            w: r,
                            h: o
                        }), s;
                    }
                };
            },
            {
                "./constants": 272,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        280: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator");
                var o = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                };
                e1("./internationalization");
                var n = Promise.resolve();
                Promise.all([
                    new Promise(function(e1, t) {
                        "complete" === document.readyState ? e1() : window.addEventListener("load", e1, !1);
                    }),
                    n
                ]).then(function() {
                    var e1;
                    void 0 !== window._setupDone ? console.warn("p5.js seems to have been imported multiple times. Please remove the duplicate import") : window.mocha || (e1 = new Event("p5Ready"), window.dispatchEvent(e1), (window.setup && "function" == typeof window.setup || window.draw && "function" == typeof window.draw) && !o.default.instance && new o.default);
                });
            },
            {
                "../core/main": 283,
                "./internationalization": 281,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.promise": 191,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        281: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.setTranslatorLanguage = r.currentTranslatorLanguage = r.availableTranslatorLanguages = r.initialize = r.translator = void 0;
                var n, s, o = l(e1("i18next")), i = l(e1("i18next-browser-languagedetector")), a = e1("./constants");
                function l(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function u(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                var c = function() {
                    function r(e1, t) {
                        if (!(this instanceof r)) throw new TypeError("Cannot call a class as a function");
                        this.init(e1, t);
                    }
                    var e1, t, o;
                    return e1 = r, t = [
                        {
                            key: "fetchWithTimeout",
                            value: function(e1, t) {
                                var r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 2e3;
                                return Promise.race([
                                    fetch(e1, t),
                                    new Promise(function(e1, t) {
                                        return setTimeout(function() {
                                            return t(new Error("timeout"));
                                        }, r);
                                    })
                                ]);
                            }
                        },
                        {
                            key: "init",
                            value: function(e1) {
                                var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
                                this.services = e1, this.options = t;
                            }
                        },
                        {
                            key: "read",
                            value: function(e1, t, r) {
                                var o = this.options.loadPath;
                                e1 === this.options.fallback ? r(null, n[e1][t]) : s.includes(e1) ? (o = this.services.interpolator.interpolate(o, {
                                    lng: e1,
                                    ns: t
                                }), this.loadUrl(o, r)) : r("Not found", !1);
                            }
                        },
                        {
                            key: "loadUrl",
                            value: function(t, r) {
                                this.fetchWithTimeout(t).then(function(e1) {
                                    if (e1.ok) return e1.json();
                                    throw new Error("failed loading ".concat(t));
                                }, function() {
                                    throw new Error("failed loading ".concat(t));
                                }).then(function(e1) {
                                    return r(null, e1);
                                }).catch(r);
                            }
                        }
                    ], u(e1.prototype, t), o && u(e1, o), r;
                }();
                c.type = "backend", r.translator = function(e1, t) {
                    console.debug("p5.js translator called before translations were loaded"), o.default.t(e1, t);
                }, r.initialize = function() {
                    return o.default.use(i.default).use(c).init({
                        fallbackLng: "en",
                        nestingPrefix: "$tr(",
                        nestingSuffix: ")",
                        defaultNS: "translation",
                        returnEmptyString: !1,
                        interpolation: {
                            escapeValue: !1
                        },
                        detection: {
                            checkWhitelist: !1,
                            order: [
                                "querystring",
                                "navigator",
                                "htmlTag",
                                "path",
                                "subdomain"
                            ],
                            caches: []
                        },
                        backend: {
                            fallback: "en",
                            loadPath: "https://cdn.jsdelivr.net/npm/p5@".concat(a.VERSION.replace(/^(\d+\.\d+)\.\d+.*$/, "$1"), "/translations/{{lng}}/{{ns}}.json")
                        },
                        partialBundledLanguages: !0,
                        resources: n
                    }).then(function(e1) {
                        r.translator = e1;
                    }, function(e1) {
                        return console.debug("Translations failed to load (".concat(e1, ")"));
                    });
                }, r.availableTranslatorLanguages = function() {
                    return o.default.languages;
                }, r.currentTranslatorLanguage = function(e1) {
                    return o.default.language;
                };
                r.setTranslatorLanguage = function(e1) {
                    return o.default.changeLanguage(e1 || void 0, function(e1) {
                        return console.debug("Translations failed to load (".concat(e1, ")"));
                    });
                };
            },
            {
                "../../translations": void 0,
                "../../translations/dev": void 0,
                "./constants": 272,
                "core-js/modules/es.array.includes": 163,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.join": 166,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.object.keys": 189,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.promise": 191,
                "core-js/modules/es.regexp.exec": 195,
                "core-js/modules/es.string.includes": 199,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.string.replace": 204,
                "core-js/modules/es.string.split": 206,
                "core-js/modules/web.dom-collections.iterator": 246,
                i18next: 3,
                "i18next-browser-languagedetector": 3
            }
        ],
        282: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("./main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                e1.default.prototype.pushStyle = function() {
                    throw new Error("pushStyle() not used, see push()");
                }, e1.default.prototype.popStyle = function() {
                    throw new Error("popStyle() not used, see pop()");
                }, e1.default.prototype.popMatrix = function() {
                    throw new Error("popMatrix() not used, see pop()");
                }, e1.default.prototype.pushMatrix = function() {
                    throw new Error("pushMatrix() not used, see push()");
                };
                e1 = e1.default;
                r.default = e1;
            },
            {
                "./main": 283
            }
        ],
        283: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.get-own-property-names"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.object.get-own-property-names"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0, e1("./shim");
                var n = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("./constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                var l, u = function() {
                    function g(e1, t) {
                        var d = this;
                        if (!(this instanceof g)) throw new TypeError("Cannot call a class as a function");
                        this._isGlobal = !e1, this._setupDone = !1, this._preloadDone = !1, this._pixelDensity = Math.ceil(window.devicePixelRatio) || 1, this._maxAllowedPixelDimensions = 0, this._userNode = t, this._curElement = null, this._elements = [], this._glAttributes = null, this._requestAnimId = 0, this._preloadCount = 0, this._loop = !0, this._startListener = null, this._initializeInstanceVariables(), this._defaultCanvasSize = {
                            width: 100,
                            height: 100
                        }, this._events = {
                            mousemove: null,
                            mousedown: null,
                            mouseup: null,
                            dragend: null,
                            dragover: null,
                            click: null,
                            dblclick: null,
                            mouseover: null,
                            mouseout: null,
                            keydown: null,
                            keyup: null,
                            keypress: null,
                            touchstart: null,
                            touchmove: null,
                            touchend: null,
                            resize: null,
                            blur: null
                        }, this._millisStart = -1, this._recording = !1, this.touchstart = !1, this.touchend = !1, this._lcg_random_state = null, this._gaussian_previous = !1, this._events.wheel = null, this._loadingScreenId = "p5_loading", this._registeredMethods = {};
                        var t = Object.getOwnPropertyNames(g.prototype._registeredMethods), r = !0, o = !1, n = void 0;
                        try {
                            for(var s, i = t[Symbol.iterator](); !(r = (s = i.next()).done); r = !0){
                                var a = s.value;
                                this._registeredMethods[a] = g.prototype._registeredMethods[a].slice();
                            }
                        } catch (e1) {
                            o = !0, n = e1;
                        } finally{
                            try {
                                r || null == i.return || i.return();
                            } finally{
                                if (o) throw n;
                            }
                        }
                        window.DeviceOrientationEvent && (this._events.deviceorientation = null), window.DeviceMotionEvent && !window._isNodeWebkit && (this._events.devicemotion = null), g.prototype.callRegisteredHooksFor = function(t) {
                            var e1 = this || g.prototype, r = this._isGlobal ? window : this;
                            if (e1._registeredMethods.hasOwnProperty(t)) {
                                var e1 = e1._registeredMethods[t], o = !0, t = !1, n = void 0;
                                try {
                                    for(var s, i = e1[Symbol.iterator](); !(o = (s = i.next()).done); o = !0){
                                        var a = s.value;
                                        "function" == typeof a && a.call(r);
                                    }
                                } catch (e1) {
                                    t = !0, n = e1;
                                } finally{
                                    try {
                                        o || null == i.return || i.return();
                                    } finally{
                                        if (t) throw n;
                                    }
                                }
                            }
                        }, this._start = function() {
                            d._userNode && "string" == typeof d._userNode && (d._userNode = document.getElementById(d._userNode));
                            var e1 = d._isGlobal ? window : d;
                            if (e1.preload) {
                                d.callRegisteredHooksFor("beforePreload");
                                var t, r = document.getElementById(d._loadingScreenId), o = (r || ((r = document.createElement("div")).innerHTML = "Loading...", r.style.position = "absolute", r.id = d._loadingScreenId, (d._userNode || document.body).appendChild(r)), d._preloadMethods);
                                for(t in o){
                                    o[t] = o[t] || g;
                                    var n = o[t];
                                    n !== g.prototype && n !== g || (d._isGlobal && (window[t] = d._wrapPreload(d, t)), n = d), d._registeredPreloadMethods[t] = n[t], n[t] = d._wrapPreload(n, t);
                                }
                                e1.preload(), d._runIfPreloadsAreDone();
                            } else d._setup(), d._recording || d._draw();
                        }, this._runIfPreloadsAreDone = function() {
                            var e1, t = this._isGlobal ? window : this;
                            0 === t._preloadCount && ((e1 = document.getElementById(t._loadingScreenId)) && e1.parentNode.removeChild(e1), this.callRegisteredHooksFor("afterPreload"), this._setupDone || (this._lastTargetFrameTime = window.performance.now(), this._lastRealFrameTime = window.performance.now(), t._setup(), this._recording || t._draw()));
                        }, this._decrementPreload = function() {
                            var e1 = this._isGlobal ? window : this;
                            e1._preloadDone || "function" != typeof e1.preload || (e1._setProperty("_preloadCount", e1._preloadCount - 1), e1._runIfPreloadsAreDone());
                        }, this._wrapPreload = function(o, n) {
                            var s = this;
                            return function() {
                                s._incrementPreload();
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                return s._registeredPreloadMethods[n].apply(o, t);
                            };
                        }, this._incrementPreload = function() {
                            var e1 = this._isGlobal ? window : this;
                            e1._preloadDone || e1._setProperty("_preloadCount", e1._preloadCount + 1);
                        }, this._setup = function() {
                            d.callRegisteredHooksFor("beforeSetup"), d.createCanvas(d._defaultCanvasSize.width, d._defaultCanvasSize.height, "p2d");
                            var e1 = d._isGlobal ? window : d;
                            if ("function" == typeof e1.preload) for(var t in d._preloadMethods)e1[t] = d._preloadMethods[t][t], e1[t] && d && (e1[t] = e1[t].bind(d));
                            d._millisStart = window.performance.now(), e1._preloadDone = !0, "function" == typeof e1.setup && e1.setup();
                            var r = document.getElementsByTagName("canvas"), o = !0, n = !1, s = void 0;
                            try {
                                for(var i, a = r[Symbol.iterator](); !(o = (i = a.next()).done); o = !0){
                                    var l = i.value;
                                    "true" === l.dataset.hidden && (l.style.visibility = "", delete l.dataset.hidden);
                                }
                            } catch (e1) {
                                n = !0, s = e1;
                            } finally{
                                try {
                                    o || null == a.return || a.return();
                                } finally{
                                    if (n) throw s;
                                }
                            }
                            d._lastTargetFrameTime = window.performance.now(), d._lastRealFrameTime = window.performance.now(), d._setupDone = !0, (d._accessibleOutputs.grid || d._accessibleOutputs.text) && d._updateAccsOutput(), d.callRegisteredHooksFor("afterSetup");
                        }, this._draw = function(e1) {
                            var e1 = e1 || window.performance.now(), t = e1 - d._lastTargetFrameTime, r = 1e3 / d._targetFrameRate;
                            (!d._loop || r - 5 <= t) && (d.deltaTime = e1 - d._lastRealFrameTime, d._setProperty("deltaTime", d.deltaTime), d._frameRate = 1e3 / d.deltaTime, d.redraw(), d._lastTargetFrameTime = Math.max(d._lastTargetFrameTime + r, e1), d._lastRealFrameTime = e1, void 0 !== d._updateMouseCoords && (d._updateMouseCoords(), d._setProperty("movedX", 0), d._setProperty("movedY", 0))), d._loop && (d._requestAnimId = window.requestAnimationFrame(d._draw));
                        }, this._setProperty = function(e1, t) {
                            d[e1] = t, d._isGlobal && (window[e1] = t);
                        }, this.remove = function() {
                            d._startListener && window.removeEventListener("load", d._startListener, !1);
                            var t = document.getElementById(d._loadingScreenId);
                            if (t && (t.parentNode.removeChild(t), d._incrementPreload()), d._curElement) {
                                for(var e1 in d._loop = !1, d._requestAnimId && window.cancelAnimationFrame(d._requestAnimId), d._events)window.removeEventListener(e1, d._events[e1]);
                                var r = !0, t = !1, o = void 0;
                                try {
                                    for(var n, s = d._elements[Symbol.iterator](); !(r = (n = s.next()).done); r = !0){
                                        var i, a = n.value;
                                        for(i in a.elt && a.elt.parentNode && a.elt.parentNode.removeChild(a.elt), a._events)a.elt.removeEventListener(i, a._events[i]);
                                    }
                                } catch (e1) {
                                    t = !0, o = e1;
                                } finally{
                                    try {
                                        r || null == s.return || s.return();
                                    } finally{
                                        if (t) throw o;
                                    }
                                }
                                var l = d;
                                d._registeredMethods.remove.forEach(function(e1) {
                                    void 0 !== e1 && e1.call(l);
                                });
                            }
                            if (d._isGlobal) {
                                for(var u in g.prototype)try {
                                    delete window[u];
                                } catch (e1) {
                                    window[u] = void 0;
                                }
                                for(var c in d)if (d.hasOwnProperty(c)) try {
                                    delete window[c];
                                } catch (e1) {
                                    window[c] = void 0;
                                }
                                g.instance = null;
                            }
                        };
                        var l, u, c = this._createFriendlyGlobalFunctionBinder();
                        if (this._isGlobal) {
                            for(var h in g.instance = this, g.prototype)"function" == typeof g.prototype[h] ? (l = h.substring(2), this._events.hasOwnProperty(l) || (Math.hasOwnProperty(h) && Math[h] === g.prototype[h] ? c(h, g.prototype[h]) : c(h, g.prototype[h].bind(this)))) : c(h, g.prototype[h]);
                            for(var f in this)this.hasOwnProperty(f) && c(f, this[f]);
                        } else e1(this), g._checkForUserDefinedFunctions(this);
                        for(u in this._updateWindowSize(), this.callRegisteredHooksFor("init"), this._setupPromisePreloads(), this._events){
                            var p = this["_on".concat(u)];
                            p && (p = p.bind(this), window.addEventListener(u, p, {
                                passive: !1
                            }), this._events[u] = p);
                        }
                        function m() {
                            d._setProperty("focused", !0);
                        }
                        function y() {
                            d._setProperty("focused", !1);
                        }
                        window.addEventListener("focus", m), window.addEventListener("blur", y), this.registerMethod("remove", function() {
                            window.removeEventListener("focus", m), window.removeEventListener("blur", y);
                        }), "complete" === document.readyState ? this._start() : (this._startListener = this._start.bind(this), window.addEventListener("load", this._startListener, !1));
                    }
                    var e1, t, r;
                    return e1 = g, t = [
                        {
                            key: "_initializeInstanceVariables",
                            value: function() {
                                this._accessibleOutputs = {
                                    text: !1,
                                    grid: !1,
                                    textLabel: !1,
                                    gridLabel: !1
                                }, this._styles = [], this._bezierDetail = 20, this._curveDetail = 20, this._colorMode = n.RGB, this._colorMaxes = {
                                    rgb: [
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    hsb: [
                                        360,
                                        100,
                                        100,
                                        1
                                    ],
                                    hsl: [
                                        360,
                                        100,
                                        100,
                                        1
                                    ]
                                }, this._downKeys = {};
                            }
                        },
                        {
                            key: "registerPreloadMethod",
                            value: function(e1, t) {
                                g.prototype._preloadMethods.hasOwnProperty(e1) || (g.prototype._preloadMethods[e1] = t);
                            }
                        },
                        {
                            key: "registerMethod",
                            value: function(e1, t) {
                                var r = this || g.prototype;
                                r._registeredMethods.hasOwnProperty(e1) || (r._registeredMethods[e1] = []), r._registeredMethods[e1].push(t);
                            }
                        },
                        {
                            key: "unregisterMethod",
                            value: function(e1, t) {
                                var r = this || g.prototype;
                                if (r._registeredMethods.hasOwnProperty(e1)) {
                                    for(var o = r._registeredMethods[e1], n = [], s = 0; s < o.length; s++)o[s] === t && n.push(s);
                                    for(var i = n.length - 1; 0 <= i; i--)o.splice(n[i], 1);
                                }
                            }
                        },
                        {
                            key: "_createFriendlyGlobalFunctionBinder",
                            value: function() {
                                var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {}, r = e1.globalObject || window;
                                e1.log || console.log.bind(console);
                                return function(e1, t) {
                                    g.disableFriendlyErrors, r[e1] = t;
                                };
                            }
                        }
                    ], s(e1.prototype, t), r && s(e1, r), g;
                }();
                for(l in u.instance = null, u.disableFriendlyErrors = !1, n)u.prototype[l] = n[l];
                u.VERSION = n.VERSION, u.prototype._preloadMethods = {
                    loadJSON: u.prototype,
                    loadImage: u.prototype,
                    loadStrings: u.prototype,
                    loadXML: u.prototype,
                    loadBytes: u.prototype,
                    loadTable: u.prototype,
                    loadFont: u.prototype,
                    loadModel: u.prototype,
                    loadShader: u.prototype
                }, u.prototype._registeredMethods = {
                    init: [],
                    pre: [],
                    post: [],
                    remove: []
                }, u.prototype._registeredPreloadMethods = {}, r.default = u;
            },
            {
                "./constants": 272,
                "./shim": 294,
                "core-js/modules/es.array.for-each": 161,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.array.splice": 171,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.get-own-property-names": 187,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.for-each": 245,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        284: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (e1 = e1("./main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                n.default.Element = function() {
                    function r(e1, t) {
                        if (!(this instanceof r)) throw new TypeError("Cannot call a class as a function");
                        this.elt = e1, this._pInst = this._pixelsState = t, this._events = {}, this.width = this.elt.offsetWidth, this.height = this.elt.offsetHeight;
                    }
                    var e1, t, o;
                    return e1 = r, o = [
                        {
                            key: "_adjustListener",
                            value: function(e1, t, r) {
                                return !1 === t ? n.default.Element._detachListener(e1, r) : n.default.Element._attachListener(e1, t, r), this;
                            }
                        },
                        {
                            key: "_attachListener",
                            value: function(e1, t, r) {
                                r._events[e1] && n.default.Element._detachListener(e1, r);
                                t = t.bind(r);
                                r.elt.addEventListener(e1, t, !1), r._events[e1] = t;
                            }
                        },
                        {
                            key: "_detachListener",
                            value: function(e1, t) {
                                var r = t._events[e1];
                                t.elt.removeEventListener(e1, r, !1), t._events[e1] = null;
                            }
                        }
                    ], t = [
                        {
                            key: "parent",
                            value: function(e1) {
                                return void 0 === e1 ? this.elt.parentNode : ("string" == typeof e1 ? ("#" === e1[0] && (e1 = e1.substring(1)), e1 = document.getElementById(e1)) : e1 instanceof n.default.Element && (e1 = e1.elt), e1.appendChild(this.elt), this);
                            }
                        },
                        {
                            key: "id",
                            value: function(e1) {
                                return void 0 === e1 ? this.elt.id : (this.elt.id = e1, this.width = this.elt.offsetWidth, this.height = this.elt.offsetHeight, this);
                            }
                        },
                        {
                            key: "class",
                            value: function(e1) {
                                return void 0 === e1 ? this.elt.className : (this.elt.className = e1, this);
                            }
                        },
                        {
                            key: "mousePressed",
                            value: function(t) {
                                return n.default.Element._adjustListener("mousedown", function(e1) {
                                    return this._pInst._setProperty("mouseIsPressed", !0), this._pInst._setMouseButton(e1), t.call(this, e1);
                                }, this), this;
                            }
                        },
                        {
                            key: "doubleClicked",
                            value: function(e1) {
                                return n.default.Element._adjustListener("dblclick", e1, this), this;
                            }
                        },
                        {
                            key: "mouseWheel",
                            value: function(e1) {
                                return n.default.Element._adjustListener("wheel", e1, this), this;
                            }
                        },
                        {
                            key: "mouseReleased",
                            value: function(e1) {
                                return n.default.Element._adjustListener("mouseup", e1, this), this;
                            }
                        },
                        {
                            key: "mouseClicked",
                            value: function(e1) {
                                return n.default.Element._adjustListener("click", e1, this), this;
                            }
                        },
                        {
                            key: "mouseMoved",
                            value: function(e1) {
                                return n.default.Element._adjustListener("mousemove", e1, this), this;
                            }
                        },
                        {
                            key: "mouseOver",
                            value: function(e1) {
                                return n.default.Element._adjustListener("mouseover", e1, this), this;
                            }
                        },
                        {
                            key: "mouseOut",
                            value: function(e1) {
                                return n.default.Element._adjustListener("mouseout", e1, this), this;
                            }
                        },
                        {
                            key: "touchStarted",
                            value: function(e1) {
                                return n.default.Element._adjustListener("touchstart", e1, this), this;
                            }
                        },
                        {
                            key: "touchMoved",
                            value: function(e1) {
                                return n.default.Element._adjustListener("touchmove", e1, this), this;
                            }
                        },
                        {
                            key: "touchEnded",
                            value: function(e1) {
                                return n.default.Element._adjustListener("touchend", e1, this), this;
                            }
                        },
                        {
                            key: "dragOver",
                            value: function(e1) {
                                return n.default.Element._adjustListener("dragover", e1, this), this;
                            }
                        },
                        {
                            key: "dragLeave",
                            value: function(e1) {
                                return n.default.Element._adjustListener("dragleave", e1, this), this;
                            }
                        },
                        {
                            key: "_setProperty",
                            value: function(e1, t) {
                                this[e1] = t;
                            }
                        }
                    ], s(e1.prototype, t), o && s(e1, o), r;
                }();
                e1 = n.default.Element;
                r.default = e1;
            },
            {
                "./main": 283
            }
        ],
        285: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.object.get-prototype-of"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var c = (u = e1("./main")) && u.__esModule ? u : {
                    default: u
                }, d = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("./constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function s(e1, t) {
                    return (s = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                function h(r) {
                    return function() {
                        var e1, t = l(r);
                        return f(this, function() {
                            if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                                if ("function" == typeof Proxy) return 1;
                                try {
                                    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                                } catch (e1) {}
                            }
                        }() ? (e1 = l(this).constructor, Reflect.construct(t, arguments, e1)) : t.apply(this, arguments));
                    };
                }
                function f(e1, t) {
                    return !t || "object" !== i(t) && "function" != typeof t ? p(e1) : t;
                }
                function p(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }
                function l(e1) {
                    return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    })(e1);
                }
                c.default.Graphics = function(e1) {
                    var t = u;
                    if ("function" != typeof e1 && null !== e1) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e1 && e1.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e1 && s(t, e1);
                    var r, l = h(u);
                    function u(e1, t, r, o, n) {
                        var s;
                        if (!(this instanceof u)) throw new TypeError("Cannot call a class as a function");
                        a = n || document.createElement("canvas"), (s = l.call(this, a, o)).canvas = a;
                        var i, a = r || d.P2D, r = o._userNode || document.body;
                        for(i in n || r.appendChild(s.canvas), c.default.prototype)s[i] || ("function" == typeof c.default.prototype[i] ? s[i] = c.default.prototype[i].bind(p(s)) : s[i] = c.default.prototype[i]);
                        return c.default.prototype._initializeInstanceVariables.apply(p(s)), s.width = e1, s.height = t, s._pixelDensity = o._pixelDensity, a === d.WEBGL ? (s._renderer = new c.default.RendererGL(s.canvas, p(s), !1), e1 = (n = s._renderer._adjustDimensions(e1, t)).adjustedWidth, t = n.adjustedHeight) : s._renderer = new c.default.Renderer2D(s.canvas, p(s), !1), o._elements.push(p(s)), Object.defineProperty(p(s), "deltaTime", {
                            get: function() {
                                return this._pInst.deltaTime;
                            }
                        }), s._renderer.resize(e1, t), s._renderer._applyDefaults(), f(s, p(s));
                    }
                    return t = u, e1 = [
                        {
                            key: "reset",
                            value: function() {
                                this._renderer.resetMatrix(), this._renderer.isP3D && this._renderer._update();
                            }
                        },
                        {
                            key: "remove",
                            value: function() {
                                this._renderer && "function" == typeof this._renderer.remove && this._renderer.remove(), this.elt.parentNode && this.elt.parentNode.removeChild(this.elt);
                                var e1, t = this._pInst._elements.indexOf(this);
                                for(e1 in -1 !== t && this._pInst._elements.splice(t, 1), this._events)this.elt.removeEventListener(e1, this._events[e1]);
                                this._renderer = void 0, this.canvas = void 0, this.elt = void 0;
                            }
                        },
                        {
                            key: "createFramebuffer",
                            value: function(e1) {
                                return new c.default.Framebuffer(this, e1);
                            }
                        }
                    ], n(t.prototype, e1), r && n(t, r), u;
                }(c.default.Element);
                var u = c.default.Graphics;
                r.default = u;
            },
            {
                "./constants": 272,
                "./main": 283,
                "core-js/modules/es.array.index-of": 164,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.splice": 171,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.get-prototype-of": 188,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.reflect.construct": 192,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        286: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.trim"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.trim"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var a = (s = e1("./main")) && s.__esModule ? s : {
                    default: s
                }, P = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== l(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = i();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function i() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, i = function() {
                        return e1;
                    }, e1);
                }
                function l(e1) {
                    return (l = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                function u(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function c(e1, t) {
                    return (c = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                function d(o) {
                    return function() {
                        var e1, t, r = n(o);
                        return e1 = function() {
                            if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                                if ("function" == typeof Proxy) return 1;
                                try {
                                    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                                } catch (e1) {}
                            }
                        }() ? (e1 = n(this).constructor, Reflect.construct(r, arguments, e1)) : r.apply(this, arguments), r = this, !(t = e1) || "object" !== l(t) && "function" != typeof t ? h(r) : t;
                    };
                }
                function h(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }
                function n(e1) {
                    return (n = Object.setPrototypeOf ? Object.getPrototypeOf : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    })(e1);
                }
                var s = function(e1) {
                    var t = s;
                    if ("function" != typeof e1 && null !== e1) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e1 && e1.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e1 && c(t, e1);
                    var r, n = d(s);
                    function s(e1, t, r) {
                        var o;
                        if (this instanceof s) return (o = n.call(this, e1, t)).canvas = e1, o._pixelsState = t, r ? (o._isMainCanvas = !0, o._pInst._setProperty("_curElement", h(o)), o._pInst._setProperty("canvas", o.canvas), o._pInst._setProperty("width", o.width), o._pInst._setProperty("height", o.height)) : (o.canvas.style.display = "none", o._styles = []), o._clipping = !1, o._clipInvert = !1, o._textSize = 12, o._textLeading = 15, o._textFont = "sans-serif", o._textStyle = P.NORMAL, o._textAscent = null, o._textDescent = null, o._textAlign = P.LEFT, o._textBaseline = P.BASELINE, o._textWrap = P.WORD, o._rectMode = P.CORNER, o._ellipseMode = P.CENTER, o._curveTightness = 0, o._imageMode = P.CORNER, o._tint = null, o._doStroke = !0, o._doFill = !0, o._strokeSet = !1, o._fillSet = !1, o._leadingSet = !1, o._pushPopDepth = 0, o;
                        throw new TypeError("Cannot call a class as a function");
                    }
                    return t = s, e1 = [
                        {
                            key: "push",
                            value: function() {
                                return this._pushPopDepth++, {
                                    properties: {
                                        _doStroke: this._doStroke,
                                        _strokeSet: this._strokeSet,
                                        _doFill: this._doFill,
                                        _fillSet: this._fillSet,
                                        _tint: this._tint,
                                        _imageMode: this._imageMode,
                                        _rectMode: this._rectMode,
                                        _ellipseMode: this._ellipseMode,
                                        _textFont: this._textFont,
                                        _textLeading: this._textLeading,
                                        _leadingSet: this._leadingSet,
                                        _textSize: this._textSize,
                                        _textAlign: this._textAlign,
                                        _textBaseline: this._textBaseline,
                                        _textStyle: this._textStyle,
                                        _textWrap: this._textWrap
                                    }
                                };
                            }
                        },
                        {
                            key: "pop",
                            value: function(e1) {
                                this._pushPopDepth--, e1.properties && Object.assign(this, e1.properties);
                            }
                        },
                        {
                            key: "beginClip",
                            value: function() {
                                var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
                                if (this._clipping) throw new Error("It looks like you're trying to clip while already in the middle of clipping. Did you forget to endClip()?");
                                this._clipping = !0, this._clipInvert = e1.invert;
                            }
                        },
                        {
                            key: "endClip",
                            value: function() {
                                if (!this._clipping) throw new Error("It looks like you've called endClip() without beginClip(). Did you forget to call beginClip() first?");
                                this._clipping = !1;
                            }
                        },
                        {
                            key: "resize",
                            value: function(e1, t) {
                                this.width = e1, this.height = t, this.elt.width = e1 * this._pInst._pixelDensity, this.elt.height = t * this._pInst._pixelDensity, this.elt.style.width = "".concat(e1, "px"), this.elt.style.height = "".concat(t, "px"), this._isMainCanvas && (this._pInst._setProperty("width", this.width), this._pInst._setProperty("height", this.height));
                            }
                        },
                        {
                            key: "get",
                            value: function(e1, t, r, o) {
                                var n = this._pixelsState, s = n._pixelDensity, i = this.canvas;
                                if (void 0 === e1 && void 0 === t) e1 = t = 0, r = n.width, o = n.height;
                                else if (e1 *= s, t *= s, void 0 === r && void 0 === o) return e1 < 0 || t < 0 || e1 >= i.width || t >= i.height ? [
                                    0,
                                    0,
                                    0,
                                    0
                                ] : this._getPixel(e1, t);
                                n = new a.default.Image(r * s, o * s);
                                return n.pixelDensity(s), n.canvas.getContext("2d").drawImage(i, e1, t, r * s, o * s, 0, 0, r * s, o * s), n;
                            }
                        },
                        {
                            key: "textLeading",
                            value: function(e1) {
                                return "number" == typeof e1 ? (this._setProperty("_leadingSet", !0), this._setProperty("_textLeading", e1), this._pInst) : this._textLeading;
                            }
                        },
                        {
                            key: "textStyle",
                            value: function(e1) {
                                return e1 ? (e1 !== P.NORMAL && e1 !== P.ITALIC && e1 !== P.BOLD && e1 !== P.BOLDITALIC || this._setProperty("_textStyle", e1), this._applyTextProperties()) : this._textStyle;
                            }
                        },
                        {
                            key: "textAscent",
                            value: function() {
                                return null === this._textAscent && this._updateTextMetrics(), this._textAscent;
                            }
                        },
                        {
                            key: "textDescent",
                            value: function() {
                                return null === this._textDescent && this._updateTextMetrics(), this._textDescent;
                            }
                        },
                        {
                            key: "textAlign",
                            value: function(e1, t) {
                                return void 0 !== e1 ? (this._setProperty("_textAlign", e1), void 0 !== t && this._setProperty("_textBaseline", t), this._applyTextProperties()) : {
                                    horizontal: this._textAlign,
                                    vertical: this._textBaseline
                                };
                            }
                        },
                        {
                            key: "textWrap",
                            value: function(e1) {
                                return this._setProperty("_textWrap", e1), this._textWrap;
                            }
                        },
                        {
                            key: "text",
                            value: function(e1, t, r, o, n) {
                                var s, i, a, l, u = this._pInst, c = this._textWrap, d = Number.MAX_VALUE, h = r;
                                if ((this._doFill || this._doStroke) && void 0 !== e1) {
                                    if (s = (e1 = (e1 = "string" != typeof e1 ? e1.toString() : e1).replace(/(\t)/g, "  ")).split("\n"), void 0 !== o) {
                                        switch(this._rectMode === P.CENTER && (t -= o / 2), this._textAlign){
                                            case P.CENTER:
                                                t += o / 2;
                                                break;
                                            case P.RIGHT:
                                                t += o;
                                        }
                                        if (void 0 !== n) {
                                            this._rectMode === P.CENTER && (r -= n / 2, h -= n / 2);
                                            var e1 = r, f = u.textAscent();
                                            switch(this._textBaseline){
                                                case P.BOTTOM:
                                                    l = r + n, r = Math.max(l, r), h += f;
                                                    break;
                                                case P.CENTER:
                                                    l = r + n / 2, r = Math.max(l, r), h += f / 2;
                                            }
                                            d = r + n - f, this._textBaseline === P.CENTER && (d = e1 + n - f / 2);
                                        } else this._textBaseline !== P.BOTTOM && this._textBaseline !== P.CENTER || (h = r - (e1 = u.textSize() * this._textLeading) / 2, d = r + e1 / 2);
                                        if (c === P.WORD) {
                                            for(var p = [], m = 0; m < s.length; m++){
                                                for(var y = "", g = s[m].split(" "), v = 0; v < g.length; v++)i = "".concat(y + g[v]) + " ", y = o < (a = this.textWidth(i)) && 0 < y.length ? (p.push(y), "".concat(g[v]) + " ") : i;
                                                p.push(y);
                                            }
                                            var b = 0;
                                            this._textBaseline === P.CENTER ? b = (p.length - 1) * u.textLeading() / 2 : this._textBaseline === P.BOTTOM && (b = (p.length - 1) * u.textLeading());
                                            for(var _ = 0; _ < s.length; _++){
                                                y = "", g = s[_].split(" ");
                                                for(var j = 0; j < g.length; j++)i = "".concat(y + g[j]) + " ", o < (a = this.textWidth(i)) && 0 < y.length ? (this._renderText(u, y.trim(), t, r - b, d, h), y = "".concat(g[j]) + " ", r += u.textLeading()) : y = i;
                                                this._renderText(u, y.trim(), t, r - b, d, h), r += u.textLeading();
                                            }
                                        } else {
                                            for(var x = [], w = 0; w < s.length; w++)for(var S = s[w].split(y = ""), T = 0; T < S.length; T++)i = "".concat(y + S[T]), (a = this.textWidth(i)) <= o ? y += S[T] : o < a && 0 < y.length && (x.push(y), y = "".concat(S[T]));
                                            x.push(y);
                                            var E = 0;
                                            this._textBaseline === P.CENTER ? E = (x.length - 1) * u.textLeading() / 2 : this._textBaseline === P.BOTTOM && (E = (x.length - 1) * u.textLeading());
                                            for(var M = 0; M < s.length; M++){
                                                S = s[M].split(y = "");
                                                for(var k = 0; k < S.length; k++)i = "".concat(y + S[k]), (a = this.textWidth(i)) <= o ? y += S[k] : o < a && 0 < y.length && (this._renderText(u, y.trim(), t, r - E, d, h), r += u.textLeading(), y = "".concat(S[k]));
                                            }
                                            this._renderText(u, y.trim(), t, r - E, d, h), r += u.textLeading();
                                        }
                                    } else {
                                        var O = 0;
                                        this._textBaseline === P.CENTER ? O = (s.length - 1) * u.textLeading() / 2 : this._textBaseline === P.BOTTOM && (O = (s.length - 1) * u.textLeading());
                                        for(var C = 0; C < s.length; C++)this._renderText(u, s[C], t, r - O, d, h - O), r += u.textLeading();
                                    }
                                    return u;
                                }
                            }
                        },
                        {
                            key: "_applyDefaults",
                            value: function() {
                                return this;
                            }
                        },
                        {
                            key: "_isOpenType",
                            value: function() {
                                var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : this._textFont;
                                return "object" === l(e1) && e1.font && e1.font.supported;
                            }
                        },
                        {
                            key: "_updateTextMetrics",
                            value: function() {
                                var e1, t, r, o, n, s;
                                return this._isOpenType() ? (this._setProperty("_textAscent", this._textFont._textAscent()), this._setProperty("_textDescent", this._textFont._textDescent())) : ((e1 = document.createElement("span")).style.fontFamily = this._textFont, e1.style.fontSize = "".concat(this._textSize, "px"), e1.innerHTML = "ABCjgq|", (s = document.createElement("div")).style.display = "inline-block", s.style.width = "1px", s.style.height = "0px", o = ((t = document.createElement("div")).appendChild(e1), t.appendChild(s), t.style.height = "0px", t.style.overflow = "hidden", document.body.appendChild(t), s.style.verticalAlign = "baseline", f(s)), n = f(e1), r = o[1] - n[1], o = (s.style.verticalAlign = "bottom", f(s)), n = f(e1), s = o[1] - n[1] - r, document.body.removeChild(t), this._setProperty("_textAscent", r), this._setProperty("_textDescent", s)), this;
                            }
                        }
                    ], u(t.prototype, e1), r && u(t, r), s;
                }(a.default.Element);
                function f(e1) {
                    var t = 0, r = 0;
                    if (e1.offsetParent) for(; t += e1.offsetLeft, r += e1.offsetTop, e1 = e1.offsetParent;);
                    else t += e1.offsetLeft, r += e1.offsetTop;
                    return [
                        t,
                        r
                    ];
                }
                s.prototype.textSize = function(e1) {
                    return "number" == typeof e1 ? (this._setProperty("_textSize", e1), this._leadingSet || this._setProperty("_textLeading", e1 * P._DEFAULT_LEADMULT), this._applyTextProperties()) : this._textSize;
                }, a.default.Renderer = s;
                e1 = a.default.Renderer;
                r.default = e1;
            },
            {
                "../core/constants": 272,
                "./main": 283,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.number.constructor": 179,
                "core-js/modules/es.object.assign": 183,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.get-prototype-of": 188,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.reflect.construct": 192,
                "core-js/modules/es.regexp.exec": 195,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.string.replace": 204,
                "core-js/modules/es.string.split": 206,
                "core-js/modules/es.string.trim": 209,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        287: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.reflect.get"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var d = (n = e1("./main")) && n.__esModule ? n : {
                    default: n
                }, p = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("./constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function l(e1, t, r) {
                    return (l = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e1, t, r) {
                        var e1 = function(e1, t) {
                            for(; !Object.prototype.hasOwnProperty.call(e1, t) && null !== (e1 = h(e1)););
                            return e1;
                        }(e1, t);
                        if (e1) return (e1 = Object.getOwnPropertyDescriptor(e1, t)).get ? e1.get.call(r) : e1.value;
                    })(e1, t, r || e1);
                }
                function u(e1, t) {
                    return (u = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                function c(r) {
                    return function() {
                        var e1, t = h(r), t = (e1 = function() {
                            if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                                if ("function" == typeof Proxy) return 1;
                                try {
                                    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                                } catch (e1) {}
                            }
                        }() ? (e1 = h(this).constructor, Reflect.construct(t, arguments, e1)) : t.apply(this, arguments), this);
                        if (!e1 || "object" !== i(e1) && "function" != typeof e1) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }
                        return e1;
                    };
                }
                function h(e1) {
                    return (h = Object.setPrototypeOf ? Object.getPrototypeOf : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    })(e1);
                }
                e1("./p5.Renderer");
                var f = "rgba(0,0,0,0)", n = function(e1) {
                    var t = n;
                    if ("function" != typeof e1 && null !== e1) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e1 && e1.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e1 && u(t, e1);
                    var r, o = c(n);
                    function n(e1, t, r) {
                        if (this instanceof n) return (e1 = o.call(this, e1, t, r)).drawingContext = e1.canvas.getContext("2d"), e1._pInst._setProperty("drawingContext", e1.drawingContext), e1;
                        throw new TypeError("Cannot call a class as a function");
                    }
                    return t = n, e1 = [
                        {
                            key: "getFilterGraphicsLayer",
                            value: function() {
                                var e1;
                                return this.filterGraphicsLayer || (e1 = (this._pInst instanceof d.default.Graphics ? this._pInst : this)._pInst, this.filterGraphicsLayer = new d.default.Graphics(this.width, this.height, p.WEBGL, e1)), this.filterGraphicsLayer.width === this.width && this.filterGraphicsLayer.height === this.height || this.filterGraphicsLayer.resizeCanvas(this.width, this.height), this.filterGraphicsLayer.pixelDensity() !== this._pInst.pixelDensity() && this.filterGraphicsLayer.pixelDensity(this._pInst.pixelDensity()), this.filterGraphicsLayer;
                            }
                        },
                        {
                            key: "_applyDefaults",
                            value: function() {
                                this._cachedFillStyle = this._cachedStrokeStyle = void 0, this._cachedBlendMode = p.BLEND, this._setFill(p._DEFAULT_FILL), this._setStroke(p._DEFAULT_STROKE), this.drawingContext.lineCap = p.ROUND, this.drawingContext.font = "normal 12px sans-serif";
                            }
                        },
                        {
                            key: "resize",
                            value: function(e1, t) {
                                l(h(n.prototype), "resize", this).call(this, e1, t), this.drawingContext.scale(this._pInst._pixelDensity, this._pInst._pixelDensity);
                            }
                        },
                        {
                            key: "background",
                            value: function() {
                                var e1, t;
                                this.drawingContext.save(), this.resetMatrix(), (arguments.length <= 0 ? void 0 : arguments[0]) instanceof d.default.Image ? 0 <= (arguments.length <= 1 ? void 0 : arguments[1]) ? (e1 = arguments.length <= 0 ? void 0 : arguments[0], this.drawingContext.globalAlpha = (arguments.length <= 1 ? void 0 : arguments[1]) / 255, this._pInst.image(e1, 0, 0, this.width, this.height)) : this._pInst.image(arguments.length <= 0 ? void 0 : arguments[0], 0, 0, this.width, this.height) : (e1 = this._getFill(), t = (t = this._pInst).color.apply(t, arguments), this._pInst._addAccsOutput() && this._pInst._accsBackground(t.levels), t = t.toString(), this._setFill(t), this._isErasing && this.blendMode(this._cachedBlendMode), this.drawingContext.fillRect(0, 0, this.width, this.height), this._setFill(e1), this._isErasing && this._pInst.erase()), this.drawingContext.restore();
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                this.drawingContext.save(), this.resetMatrix(), this.drawingContext.clearRect(0, 0, this.width, this.height), this.drawingContext.restore();
                            }
                        },
                        {
                            key: "fill",
                            value: function() {
                                var e1 = (e1 = this._pInst).color.apply(e1, arguments);
                                this._setFill(e1.toString()), this._pInst._addAccsOutput() && this._pInst._accsCanvasColors("fill", e1.levels);
                            }
                        },
                        {
                            key: "stroke",
                            value: function() {
                                var e1 = (e1 = this._pInst).color.apply(e1, arguments);
                                this._setStroke(e1.toString()), this._pInst._addAccsOutput() && this._pInst._accsCanvasColors("stroke", e1.levels);
                            }
                        },
                        {
                            key: "erase",
                            value: function(e1, t) {
                                this._isErasing || (this._cachedFillStyle = this.drawingContext.fillStyle, e1 = this._pInst.color(255, e1).toString(), this.drawingContext.fillStyle = e1, this._cachedStrokeStyle = this.drawingContext.strokeStyle, e1 = this._pInst.color(255, t).toString(), this.drawingContext.strokeStyle = e1, t = this._cachedBlendMode, this.blendMode(p.REMOVE), this._cachedBlendMode = t, this._isErasing = !0);
                            }
                        },
                        {
                            key: "noErase",
                            value: function() {
                                this._isErasing && (this.drawingContext.fillStyle = this._cachedFillStyle, this.drawingContext.strokeStyle = this._cachedStrokeStyle, this.blendMode(this._cachedBlendMode), this._isErasing = !1);
                            }
                        },
                        {
                            key: "beginClip",
                            value: function() {
                                var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {}, e1 = (l(h(n.prototype), "beginClip", this).call(this, e1), this._cachedFillStyle = this.drawingContext.fillStyle, this._pInst.color(255, 0).toString()), e1 = (this.drawingContext.fillStyle = e1, this._cachedStrokeStyle = this.drawingContext.strokeStyle, this._pInst.color(255, 0).toString()), e1 = (this.drawingContext.strokeStyle = e1, this._cachedBlendMode);
                                this.blendMode(p.BLEND), this._cachedBlendMode = e1, this.drawingContext.beginPath(), this._clipInvert && (this.drawingContext.moveTo(-2 * this.width, -2 * this.height), this.drawingContext.lineTo(-2 * this.width, 2 * this.height), this.drawingContext.lineTo(2 * this.width, 2 * this.height), this.drawingContext.lineTo(2 * this.width, -2 * this.height), this.drawingContext.closePath());
                            }
                        },
                        {
                            key: "endClip",
                            value: function() {
                                this._doFillStrokeClose(), this.drawingContext.clip(), l(h(n.prototype), "endClip", this).call(this), this.drawingContext.fillStyle = this._cachedFillStyle, this.drawingContext.strokeStyle = this._cachedStrokeStyle, this.blendMode(this._cachedBlendMode);
                            }
                        },
                        {
                            key: "image",
                            value: function(e1, t, r, o, n, s, i, a, l) {
                                e1.gifProperties && e1._animateGif(this._pInst);
                                try {
                                    d.default.MediaElement && e1 instanceof d.default.MediaElement && e1._ensureCanvas();
                                    var u = (u = this._tint && e1.canvas ? this._getTintedImageCanvas(e1) : u) || e1.canvas || e1.elt, c = 1;
                                    e1.width && 0 < e1.width && (c = u.width / e1.width), this._isErasing && this.blendMode(this._cachedBlendMode), this.drawingContext.drawImage(u, c * t, c * r, c * o, c * n, s, i, a, l), this._isErasing && this._pInst.erase();
                                } catch (e1) {
                                    if ("NS_ERROR_NOT_AVAILABLE" !== e1.name) throw e1;
                                }
                            }
                        },
                        {
                            key: "_getTintedImageCanvas",
                            value: function(e1) {
                                if (!e1.canvas) return e1;
                                e1.tintCanvas || (e1.tintCanvas = document.createElement("canvas")), e1.tintCanvas.width !== e1.canvas.width && (e1.tintCanvas.width = e1.canvas.width), e1.tintCanvas.height !== e1.canvas.height && (e1.tintCanvas.height = e1.canvas.height);
                                var t = e1.tintCanvas.getContext("2d");
                                return t.save(), t.clearRect(0, 0, e1.canvas.width, e1.canvas.height), (this._tint[0] < 255 || this._tint[1] < 255 || this._tint[2] < 255) && (t.drawImage(e1.canvas, 0, 0), t.globalCompositeOperation = "luminosity", t.drawImage(e1.canvas, 0, 0), t.globalCompositeOperation = "color", t.drawImage(e1.canvas, 0, 0), t.globalCompositeOperation = "multiply", t.fillStyle = "rgb(".concat(this._tint.slice(0, 3).join(", "), ")"), t.fillRect(0, 0, e1.canvas.width, e1.canvas.height), t.globalCompositeOperation = "destination-in"), t.globalAlpha = this._tint[3] / 255, t.drawImage(e1.canvas, 0, 0), t.restore(), e1.tintCanvas;
                            }
                        },
                        {
                            key: "blendMode",
                            value: function(e1) {
                                if (e1 === p.SUBTRACT) console.warn("blendMode(SUBTRACT) only works in WEBGL mode.");
                                else {
                                    if (e1 !== p.BLEND && e1 !== p.REMOVE && e1 !== p.DARKEST && e1 !== p.LIGHTEST && e1 !== p.DIFFERENCE && e1 !== p.MULTIPLY && e1 !== p.EXCLUSION && e1 !== p.SCREEN && e1 !== p.REPLACE && e1 !== p.OVERLAY && e1 !== p.HARD_LIGHT && e1 !== p.SOFT_LIGHT && e1 !== p.DODGE && e1 !== p.BURN && e1 !== p.ADD) throw new Error("Mode ".concat(e1, " not recognized."));
                                    this._cachedBlendMode = e1, this.drawingContext.globalCompositeOperation = e1;
                                }
                            }
                        },
                        {
                            key: "blend",
                            value: function() {
                                for(var e1 = this.drawingContext.globalCompositeOperation, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                                var n = r[r.length - 1], s = Array.prototype.slice.call(r, 0, r.length - 1);
                                this.drawingContext.globalCompositeOperation = n, d.default.prototype.copy.apply(this, s), this.drawingContext.globalCompositeOperation = e1;
                            }
                        },
                        {
                            key: "_getPixel",
                            value: function(e1, t) {
                                e1 = this.drawingContext.getImageData(e1, t, 1, 1).data;
                                return [
                                    e1[0],
                                    e1[1],
                                    e1[2],
                                    e1[3]
                                ];
                            }
                        },
                        {
                            key: "loadPixels",
                            value: function() {
                                var e1 = this._pixelsState, t = e1._pixelDensity, r = this.width * t, t = this.height * t, r = this.drawingContext.getImageData(0, 0, r, t);
                                e1._setProperty("imageData", r), e1._setProperty("pixels", r.data);
                            }
                        },
                        {
                            key: "set",
                            value: function(e1, t, r) {
                                e1 = Math.floor(e1), t = Math.floor(t);
                                var o = this._pixelsState;
                                if (r instanceof d.default.Image) this.drawingContext.save(), this.drawingContext.setTransform(1, 0, 0, 1, 0, 0), this.drawingContext.scale(o._pixelDensity, o._pixelDensity), this.drawingContext.clearRect(e1, t, r.width, r.height), this.drawingContext.drawImage(r.canvas, e1, t), this.drawingContext.restore();
                                else {
                                    var n = 0, s = 0, i = 0, a = 0, l = 4 * (t * o._pixelDensity * (this.width * o._pixelDensity) + e1 * o._pixelDensity);
                                    if (o.imageData || o.loadPixels(), "number" == typeof r) l < o.pixels.length && (i = s = n = r, a = 255);
                                    else if (Array.isArray(r)) {
                                        if (r.length < 4) throw new Error("pixel array must be of the form [R, G, B, A]");
                                        l < o.pixels.length && (n = r[0], s = r[1], i = r[2], a = r[3]);
                                    } else r instanceof d.default.Color && l < o.pixels.length && (n = r.levels[0], s = r.levels[1], i = r.levels[2], a = r.levels[3]);
                                    for(var u = 0; u < o._pixelDensity; u++)for(var c = 0; c < o._pixelDensity; c++)l = 4 * ((t * o._pixelDensity + c) * this.width * o._pixelDensity + (e1 * o._pixelDensity + u)), o.pixels[l] = n, o.pixels[l + 1] = s, o.pixels[l + 2] = i, o.pixels[l + 3] = a;
                                }
                            }
                        },
                        {
                            key: "updatePixels",
                            value: function(e1, t, r, o) {
                                var n = this._pixelsState, s = n._pixelDensity;
                                void 0 === e1 && void 0 === t && void 0 === r && void 0 === o && (t = e1 = 0, r = this.width, o = this.height), e1 *= s, t *= s, r *= s, o *= s, this.gifProperties && (this.gifProperties.frames[this.gifProperties.displayIndex].image = n.imageData), this.drawingContext.putImageData(n.imageData, 0, 0, e1, t, r, o);
                            }
                        },
                        {
                            key: "arc",
                            value: function(e1, t, r, o, n, s, i) {
                                var a = this.drawingContext, e1 = e1 + r / 2, t = t + o / 2, r = r / 2, o = o / 2, l = !(i === p.CHORD || i === p.OPEN || (s - n) % p.TWO_PI == 0);
                                return this._doFill && (this._clipping || a.beginPath(), a.ellipse(e1, t, r, o, 0, n, s), l && a.lineTo(e1, t), a.closePath(), this._clipping || a.fill()), this._doStroke && (this._clipping || a.beginPath(), a.ellipse(e1, t, r, o, 0, n, s), i === p.PIE && l && a.lineTo(e1, t), i !== p.PIE && i !== p.CHORD || a.closePath(), this._clipping || a.stroke()), this;
                            }
                        },
                        {
                            key: "ellipse",
                            value: function(e1) {
                                var t = this.drawingContext, r = this._doFill, o = this._doStroke, n = parseFloat(e1[0]), s = parseFloat(e1[1]), i = parseFloat(e1[2]), e1 = parseFloat(e1[3]);
                                if (r && !o) {
                                    if (this._getFill() === f) return this;
                                } else if (!r && o && this._getStroke() === f) return this;
                                n += i / 2, s += e1 / 2, i /= 2, e1 /= 2;
                                this._clipping || t.beginPath(), t.ellipse(n, s, i, e1, 0, 0, 2 * Math.PI), t.closePath(), !this._clipping && r && t.fill(), !this._clipping && o && t.stroke();
                            }
                        },
                        {
                            key: "line",
                            value: function(e1, t, r, o) {
                                var n = this.drawingContext;
                                return this._doStroke && this._getStroke() !== f && (this._clipping || n.beginPath(), n.moveTo(e1, t), n.lineTo(r, o), n.stroke()), this;
                            }
                        },
                        {
                            key: "point",
                            value: function(e1, t) {
                                var r, o, n = this.drawingContext;
                                return !this._doStroke || this._getStroke() === f ? this : (r = this._getStroke(), o = this._getFill(), this._clipping || this._setFill(r), this._clipping || n.beginPath(), n.arc(e1, t, n.lineWidth / 2, 0, p.TWO_PI, !1), void (this._clipping || (n.fill(), this._setFill(o))));
                            }
                        },
                        {
                            key: "quad",
                            value: function(e1, t, r, o, n, s, i, a) {
                                var l = this.drawingContext, u = this._doFill, c = this._doStroke;
                                if (u && !c) {
                                    if (this._getFill() === f) return this;
                                } else if (!u && c && this._getStroke() === f) return this;
                                return this._clipping || l.beginPath(), l.moveTo(e1, t), l.lineTo(r, o), l.lineTo(n, s), l.lineTo(i, a), l.closePath(), !this._clipping && u && l.fill(), !this._clipping && c && l.stroke(), this;
                            }
                        },
                        {
                            key: "rect",
                            value: function(e1) {
                                var t, r, o = e1[0], n = e1[1], s = e1[2], i = e1[3], a = e1[4], l = e1[5], u = e1[6], e1 = e1[7], c = this.drawingContext, d = this._doFill, h = this._doStroke;
                                if (d && !h) {
                                    if (this._getFill() === f) return this;
                                } else if (!d && h && this._getStroke() === f) return this;
                                return this._clipping || c.beginPath(), void 0 === a ? c.rect(o, n, s, i) : (void 0 === l && (l = a), void 0 === u && (u = l), void 0 === e1 && (e1 = u), h = (d = Math.abs(s)) / 2, r = (t = Math.abs(i)) / 2, c.roundRect(o, n, s, i, [
                                    a = t < 2 * (a = d < 2 * a ? h : a) ? r : a,
                                    l = t < 2 * (l = d < 2 * l ? h : l) ? r : l,
                                    u = t < 2 * (u = d < 2 * u ? h : u) ? r : u,
                                    e1 = t < 2 * (e1 = d < 2 * e1 ? h : e1) ? r : e1
                                ])), !this._clipping && this._doFill && c.fill(), !this._clipping && this._doStroke && c.stroke(), this;
                            }
                        },
                        {
                            key: "triangle",
                            value: function(e1) {
                                var t = this.drawingContext, r = this._doFill, o = this._doStroke, n = e1[0], s = e1[1], i = e1[2], a = e1[3], l = e1[4], e1 = e1[5];
                                if (r && !o) {
                                    if (this._getFill() === f) return this;
                                } else if (!r && o && this._getStroke() === f) return this;
                                this._clipping || t.beginPath(), t.moveTo(n, s), t.lineTo(i, a), t.lineTo(l, e1), t.closePath(), !this._clipping && r && t.fill(), !this._clipping && o && t.stroke();
                            }
                        },
                        {
                            key: "endShape",
                            value: function(e1, t, r, o, n, s, i) {
                                if (0 !== t.length && (this._doStroke || this._doFill)) {
                                    var a, l, u, c = e1 === p.CLOSE, d = (c && !s && t.push(t[0]), t.length);
                                    if (r && null === i) {
                                        if (3 < d) {
                                            var h = [], f = 1 - this._curveTightness;
                                            for(this._clipping || this.drawingContext.beginPath(), this.drawingContext.moveTo(t[1][0], t[1][1]), l = 1; l + 2 < d; l++)a = t[l], h[0] = [
                                                a[0],
                                                a[1]
                                            ], h[1] = [
                                                a[0] + (f * t[l + 1][0] - f * t[l - 1][0]) / 6,
                                                a[1] + (f * t[l + 1][1] - f * t[l - 1][1]) / 6
                                            ], h[2] = [
                                                t[l + 1][0] + (f * t[l][0] - f * t[l + 2][0]) / 6,
                                                t[l + 1][1] + (f * t[l][1] - f * t[l + 2][1]) / 6
                                            ], h[3] = [
                                                t[l + 1][0],
                                                t[l + 1][1]
                                            ], this.drawingContext.bezierCurveTo(h[1][0], h[1][1], h[2][0], h[2][1], h[3][0], h[3][1]);
                                            c && this.drawingContext.lineTo(t[l + 1][0], t[l + 1][1]), this._doFillStrokeClose(c);
                                        }
                                    } else if (o && null === i) {
                                        for(this._clipping || this.drawingContext.beginPath(), l = 0; l < d; l++)t[l].isVert ? t[l].moveTo ? this.drawingContext.moveTo(t[l][0], t[l][1]) : this.drawingContext.lineTo(t[l][0], t[l][1]) : this.drawingContext.bezierCurveTo(t[l][0], t[l][1], t[l][2], t[l][3], t[l][4], t[l][5]);
                                        this._doFillStrokeClose(c);
                                    } else if (n && null === i) {
                                        for(this._clipping || this.drawingContext.beginPath(), l = 0; l < d; l++)t[l].isVert ? t[l].moveTo ? this.drawingContext.moveTo(t[l][0], t[l][1]) : this.drawingContext.lineTo(t[l][0], t[l][1]) : this.drawingContext.quadraticCurveTo(t[l][0], t[l][1], t[l][2], t[l][3]);
                                        this._doFillStrokeClose(c);
                                    } else if (i === p.POINTS) for(l = 0; l < d; l++)a = t[l], this._doStroke && this._pInst.stroke(a[6]), this._pInst.point(a[0], a[1]);
                                    else if (i === p.LINES) for(l = 0; l + 1 < d; l += 2)a = t[l], this._doStroke && this._pInst.stroke(t[l + 1][6]), this._pInst.line(a[0], a[1], t[l + 1][0], t[l + 1][1]);
                                    else if (i === p.TRIANGLES) for(l = 0; l + 2 < d; l += 3)a = t[l], this._clipping || this.drawingContext.beginPath(), this.drawingContext.moveTo(a[0], a[1]), this.drawingContext.lineTo(t[l + 1][0], t[l + 1][1]), this.drawingContext.lineTo(t[l + 2][0], t[l + 2][1]), this.drawingContext.closePath(), !this._clipping && this._doFill && (this._pInst.fill(t[l + 2][5]), this.drawingContext.fill()), !this._clipping && this._doStroke && (this._pInst.stroke(t[l + 2][6]), this.drawingContext.stroke());
                                    else if (i === p.TRIANGLE_STRIP) for(l = 0; l + 1 < d; l++)a = t[l], this._clipping || this.drawingContext.beginPath(), this.drawingContext.moveTo(t[l + 1][0], t[l + 1][1]), this.drawingContext.lineTo(a[0], a[1]), !this._clipping && this._doStroke && this._pInst.stroke(t[l + 1][6]), !this._clipping && this._doFill && this._pInst.fill(t[l + 1][5]), l + 2 < d && (this.drawingContext.lineTo(t[l + 2][0], t[l + 2][1]), !this._clipping && this._doStroke && this._pInst.stroke(t[l + 2][6]), !this._clipping && this._doFill && this._pInst.fill(t[l + 2][5])), this._doFillStrokeClose(c);
                                    else if (i === p.TRIANGLE_FAN) {
                                        if (2 < d) {
                                            for(this._clipping || this.drawingContext.beginPath(), l = 2; l < d; l++)a = t[l], this.drawingContext.moveTo(t[0][0], t[0][1]), this.drawingContext.lineTo(t[l - 1][0], t[l - 1][1]), this.drawingContext.lineTo(a[0], a[1]), this.drawingContext.lineTo(t[0][0], t[0][1]), l < d - 1 && (this._doFill && a[5] !== t[l + 1][5] || this._doStroke && a[6] !== t[l + 1][6]) && (!this._clipping && this._doFill && (this._pInst.fill(a[5]), this.drawingContext.fill(), this._pInst.fill(t[l + 1][5])), !this._clipping && this._doStroke && (this._pInst.stroke(a[6]), this.drawingContext.stroke(), this._pInst.stroke(t[l + 1][6])), this.drawingContext.closePath(), this._clipping || this.drawingContext.beginPath());
                                            this._doFillStrokeClose(c);
                                        }
                                    } else if (i === p.QUADS) for(l = 0; l + 3 < d; l += 4){
                                        for(a = t[l], this._clipping || this.drawingContext.beginPath(), this.drawingContext.moveTo(a[0], a[1]), u = 1; u < 4; u++)this.drawingContext.lineTo(t[l + u][0], t[l + u][1]);
                                        this.drawingContext.lineTo(a[0], a[1]), !this._clipping && this._doFill && this._pInst.fill(t[l + 3][5]), !this._clipping && this._doStroke && this._pInst.stroke(t[l + 3][6]), this._doFillStrokeClose(c);
                                    }
                                    else if (i === p.QUAD_STRIP) {
                                        if (3 < d) for(l = 0; l + 1 < d; l += 2)a = t[l], this._clipping || this.drawingContext.beginPath(), l + 3 < d ? (this.drawingContext.moveTo(t[l + 2][0], t[l + 2][1]), this.drawingContext.lineTo(a[0], a[1]), this.drawingContext.lineTo(t[l + 1][0], t[l + 1][1]), this.drawingContext.lineTo(t[l + 3][0], t[l + 3][1]), !this._clipping && this._doFill && this._pInst.fill(t[l + 3][5]), !this._clipping && this._doStroke && this._pInst.stroke(t[l + 3][6])) : (this.drawingContext.moveTo(a[0], a[1]), this.drawingContext.lineTo(t[l + 1][0], t[l + 1][1])), this._doFillStrokeClose(c);
                                    } else {
                                        for(this._clipping || this.drawingContext.beginPath(), this.drawingContext.moveTo(t[0][0], t[0][1]), l = 1; l < d; l++)(a = t[l]).isVert && (a.moveTo ? (c && this.drawingContext.closePath(), this.drawingContext.moveTo(a[0], a[1])) : this.drawingContext.lineTo(a[0], a[1]));
                                        this._doFillStrokeClose(c), this.drawingContext.closePath();
                                    }
                                    s = n = o = r = !1, c && t.pop();
                                }
                                return this;
                            }
                        },
                        {
                            key: "strokeCap",
                            value: function(e1) {
                                return e1 !== p.ROUND && e1 !== p.SQUARE && e1 !== p.PROJECT || (this.drawingContext.lineCap = e1), this;
                            }
                        },
                        {
                            key: "strokeJoin",
                            value: function(e1) {
                                return e1 !== p.ROUND && e1 !== p.BEVEL && e1 !== p.MITER || (this.drawingContext.lineJoin = e1), this;
                            }
                        },
                        {
                            key: "strokeWeight",
                            value: function(e1) {
                                return this.drawingContext.lineWidth = void 0 === e1 || 0 === e1 ? 1e-4 : e1, this;
                            }
                        },
                        {
                            key: "_getFill",
                            value: function() {
                                return this._cachedFillStyle || (this._cachedFillStyle = this.drawingContext.fillStyle), this._cachedFillStyle;
                            }
                        },
                        {
                            key: "_setFill",
                            value: function(e1) {
                                e1 !== this._cachedFillStyle && (this.drawingContext.fillStyle = e1, this._cachedFillStyle = e1);
                            }
                        },
                        {
                            key: "_getStroke",
                            value: function() {
                                return this._cachedStrokeStyle || (this._cachedStrokeStyle = this.drawingContext.strokeStyle), this._cachedStrokeStyle;
                            }
                        },
                        {
                            key: "_setStroke",
                            value: function(e1) {
                                e1 !== this._cachedStrokeStyle && (this.drawingContext.strokeStyle = e1, this._cachedStrokeStyle = e1);
                            }
                        },
                        {
                            key: "bezier",
                            value: function(e1, t, r, o, n, s, i, a) {
                                return this._pInst.beginShape(), this._pInst.vertex(e1, t), this._pInst.bezierVertex(r, o, n, s, i, a), this._pInst.endShape(), this;
                            }
                        },
                        {
                            key: "curve",
                            value: function(e1, t, r, o, n, s, i, a) {
                                return this._pInst.beginShape(), this._pInst.curveVertex(e1, t), this._pInst.curveVertex(r, o), this._pInst.curveVertex(n, s), this._pInst.curveVertex(i, a), this._pInst.endShape(), this;
                            }
                        },
                        {
                            key: "_doFillStrokeClose",
                            value: function(e1) {
                                e1 && this.drawingContext.closePath(), !this._clipping && this._doFill && this.drawingContext.fill(), !this._clipping && this._doStroke && this.drawingContext.stroke();
                            }
                        },
                        {
                            key: "applyMatrix",
                            value: function(e1, t, r, o, n, s) {
                                this.drawingContext.transform(e1, t, r, o, n, s);
                            }
                        },
                        {
                            key: "resetMatrix",
                            value: function() {
                                return this.drawingContext.setTransform(1, 0, 0, 1, 0, 0), this.drawingContext.scale(this._pInst._pixelDensity, this._pInst._pixelDensity), this;
                            }
                        },
                        {
                            key: "rotate",
                            value: function(e1) {
                                this.drawingContext.rotate(e1);
                            }
                        },
                        {
                            key: "scale",
                            value: function(e1, t) {
                                return this.drawingContext.scale(e1, t), this;
                            }
                        },
                        {
                            key: "translate",
                            value: function(e1, t) {
                                return e1 instanceof d.default.Vector && (t = e1.y, e1 = e1.x), this.drawingContext.translate(e1, t), this;
                            }
                        },
                        {
                            key: "_renderText",
                            value: function(e1, t, r, o, n, s) {
                                if (!(o < s || n <= o)) return e1.push(), this._isOpenType() ? this._textFont._renderPath(t, r, o, {
                                    renderer: this
                                }) : (this._doStroke && this._strokeSet && this.drawingContext.strokeText(t, r, o), !this._clipping && this._doFill && (this._fillSet || this._setFill(p._DEFAULT_TEXT_FILL), this.drawingContext.fillText(t, r, o))), e1.pop(), e1;
                            }
                        },
                        {
                            key: "textWidth",
                            value: function(e1) {
                                return this._isOpenType() ? this._textFont._textWidth(e1, this._textSize) : this.drawingContext.measureText(e1).width;
                            }
                        },
                        {
                            key: "_applyTextProperties",
                            value: function() {
                                var e1 = this._pInst, t = (this._setProperty("_textAscent", null), this._setProperty("_textDescent", null), t = this._textFont, this._isOpenType() && (t = this._textFont.font.familyName, this._setProperty("_textStyle", this._textFont.font.styleName)), t || "sans-serif");
                                return /\s/.exec(t) && (t = '"'.concat(t, '"')), this.drawingContext.font = "".concat(this._textStyle || "normal", " ").concat(this._textSize || 12, "px ").concat(t), this.drawingContext.textAlign = this._textAlign, this._textBaseline === p.CENTER ? this.drawingContext.textBaseline = p._CTX_MIDDLE : this.drawingContext.textBaseline = this._textBaseline, e1;
                            }
                        },
                        {
                            key: "push",
                            value: function() {
                                return this.drawingContext.save(), l(h(n.prototype), "push", this).call(this);
                            }
                        },
                        {
                            key: "pop",
                            value: function(e1) {
                                this.drawingContext.restore(), this._cachedFillStyle = this.drawingContext.fillStyle, this._cachedStrokeStyle = this.drawingContext.strokeStyle, l(h(n.prototype), "pop", this).call(this, e1);
                            }
                        }
                    ], s(t.prototype, e1), r && s(t, r), n;
                }(d.default.Renderer), e1 = (n.prototype.text = function(e1, t, r, o, n) {
                    void 0 !== o && this.drawingContext.textBaseline === p.BASELINE && (s = !0, this.drawingContext.textBaseline = p.TOP);
                    var s, o = d.default.Renderer.prototype.text.apply(this, arguments);
                    return s && (this.drawingContext.textBaseline = p.BASELINE), o;
                }, d.default.Renderer2D = n, d.default.Renderer2D);
                r.default = e1;
            },
            {
                "./constants": 272,
                "./main": 283,
                "./p5.Renderer": 286,
                "core-js/modules/es.array.concat": 153,
                "core-js/modules/es.array.fill": 156,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.join": 166,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.function.name": 174,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.get-prototype-of": 188,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.reflect.construct": 192,
                "core-js/modules/es.reflect.get": 193,
                "core-js/modules/es.regexp.exec": 195,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        288: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator");
                var h = (e1 = e1("./main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                h.default.prototype._promisePreloads = [];
                function o() {
                    return {};
                }
                var f = (h.default.prototype.registerPromisePreload = function(e1) {
                    h.default.prototype._promisePreloads.push(e1);
                }, false);
                h.default.prototype._setupPromisePreloads = function() {
                    var e1 = !0, t = !1, r = void 0;
                    try {
                        for(var o, n = this._promisePreloads[Symbol.iterator](); !(e1 = (o = n.next()).done); e1 = !0){
                            var s = o.value, i = this, a = s.method, l = s.addCallbacks, u = s.legacyPreloadSetup, c = s.target || this, d = c[a].bind(c);
                            if (c === h.default.prototype) {
                                if (f) continue;
                                i = null, d = c[a];
                            }
                            c[a] = this._wrapPromisePreload(i, d, l), u && (c[u.method] = this._legacyPreloadGenerator(i, u, c[a]));
                        }
                    } catch (e1) {
                        t = !0, r = e1;
                    } finally{
                        try {
                            e1 || null == n.return || n.return();
                        } finally{
                            if (t) throw r;
                        }
                    }
                    f = !0;
                }, h.default.prototype._wrapPromisePreload = function(e1, l, u) {
                    var t = function() {
                        for(var e1 = this, t = (this._incrementPreload(), null), r = null, o = arguments.length, n = new Array(o), s = 0; s < o; s++)n[s] = arguments[s];
                        if (u) for(var i = n.length - 1; 0 <= i && !r && "function" == typeof n[i]; i--)r = t, t = n.pop();
                        var a = Promise.resolve(l.apply(this, n));
                        return t && a.then(t), r && a.catch(r), a.then(function() {
                            return e1._decrementPreload();
                        }), a;
                    };
                    return t = e1 ? t.bind(e1) : t;
                };
                h.default.prototype._legacyPreloadGenerator = function(e1, t, s) {
                    var i = t.createBaseObject || o, t = function() {
                        var t = this;
                        this._incrementPreload();
                        for(var e1 = arguments.length, r = new Array(e1), o = 0; o < e1; o++)r[o] = arguments[o];
                        var n = i.apply(this, r);
                        return s.apply(this, r).then(function(e1) {
                            Object.assign(n, e1), t._decrementPreload();
                        }), n;
                    };
                    return t = e1 ? t.bind(e1) : t;
                };
            },
            {
                "./main": 283,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.object.assign": 183,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.promise": 191,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        289: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var l = (n = e1("./main")) && n.__esModule ? n : {
                    default: n
                }, u = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== c(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = i();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("./constants"));
                function i() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, i = function() {
                        return e1;
                    }, e1);
                }
                function c(e1) {
                    return (c = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("./p5.Graphics"), e1("./p5.Renderer2D"), e1("../webgl/p5.RendererGL");
                var d = "defaultCanvas0", n = (l.default.prototype.createCanvas = function(e1, t, r, o) {
                    var n, s, i;
                    if (l.default._validateParameters("createCanvas", arguments), arguments[2] instanceof HTMLCanvasElement ? (r = u.P2D, o = arguments[2]) : n = r || u.P2D, o) (i = document.getElementById(d)) && i.parentNode.removeChild(i), i = o, this._defaultGraphicsCreated = !1;
                    else {
                        if (n === u.WEBGL) (i = document.getElementById(d)) && (i.parentNode.removeChild(i), s = this._renderer, this._elements = this._elements.filter(function(e1) {
                            return e1 !== s;
                        })), (i = document.createElement("canvas")).id = d, i.classList.add("p5Canvas");
                        else if (this._defaultGraphicsCreated) i = this.canvas;
                        else {
                            i = o || document.createElement("canvas");
                            for(var a = 0; document.getElementById("defaultCanvas".concat(a));)a++;
                            d = "defaultCanvas".concat(a), i.id = d, i.classList.add("p5Canvas");
                        }
                        this._setupDone || (i.dataset.hidden = !0, i.style.visibility = "hidden"), (this._userNode || (0 === document.getElementsByTagName("main").length && (r = document.createElement("main"), document.body.appendChild(r)), document.getElementsByTagName("main")[0])).appendChild(i);
                    }
                    return n === u.WEBGL ? (this._setProperty("_renderer", new l.default.RendererGL(i, this, !0)), this._elements.push(this._renderer), e1 = (o = this._renderer._adjustDimensions(e1, t)).adjustedWidth, t = o.adjustedHeight) : this._defaultGraphicsCreated || (this._setProperty("_renderer", new l.default.Renderer2D(i, this, !0)), this._defaultGraphicsCreated = !0, this._elements.push(this._renderer)), this._renderer.resize(e1, t), this._renderer._applyDefaults(), this._renderer;
                }, l.default.prototype.resizeCanvas = function(e1, t, r) {
                    if (l.default._validateParameters("resizeCanvas", arguments), this._renderer) {
                        var o, n, s, i = {};
                        for(o in this.drawingContext){
                            var a = this.drawingContext[o];
                            "object" !== c(a) && "function" != typeof a && (i[o] = a);
                        }
                        for(s in this._renderer instanceof l.default.RendererGL && (e1 = (n = this._renderer._adjustDimensions(e1, t)).adjustedWidth, t = n.adjustedHeight), this.width = e1, this.height = t, this._renderer.resize(e1, t), i)try {
                            this.drawingContext[s] = i[s];
                        } catch (e1) {}
                        r || this.redraw();
                    }
                    this._addAccsOutput() && this._updateAccsOutput();
                }, l.default.prototype.noCanvas = function() {
                    this.canvas && this.canvas.parentNode.removeChild(this.canvas);
                }, l.default.prototype.createGraphics = function(e1, t) {
                    for(var r = arguments.length, o = new Array(2 < r ? r - 2 : 0), n = 2; n < r; n++)o[n - 2] = arguments[n];
                    return o[0] instanceof HTMLCanvasElement && (o[1] = o[0], o[0] = u.P2D), l.default._validateParameters("createGraphics", arguments), new l.default.Graphics(e1, t, o[0], this, o[1]);
                }, l.default.prototype.createFramebuffer = function(e1) {
                    return new l.default.Framebuffer(this, e1);
                }, l.default.prototype.clearDepth = function(e1) {
                    this._assert3d("clearDepth"), this._renderer.clearDepth(e1);
                }, l.default.prototype.blendMode = function(e1) {
                    l.default._validateParameters("blendMode", arguments), e1 === u.NORMAL && (console.warn("NORMAL has been deprecated for use in blendMode. defaulting to BLEND instead."), e1 = u.BLEND), this._renderer.blendMode(e1);
                }, l.default);
                r.default = n;
            },
            {
                "../webgl/p5.RendererGL": 341,
                "./constants": 272,
                "./main": 283,
                "./p5.Graphics": 285,
                "./p5.Renderer2D": 287,
                "core-js/modules/es.array.filter": 157,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        290: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.slice"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var l = n(e1("../main")), a = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = c();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../constants")), u = n(e1("../helpers"));
                function c() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, c = function() {
                        return e1;
                    }, e1);
                }
                function n(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function s(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                e1("../friendly_errors/fes_core"), e1("../friendly_errors/file_errors"), e1("../friendly_errors/validate_params"), l.default.prototype._normalizeArcAngles = function(e1, t, r, o, n) {
                    var s;
                    return e1 -= a.TWO_PI * Math.floor(e1 / a.TWO_PI), t -= a.TWO_PI * Math.floor(t / a.TWO_PI), s = Math.min(Math.abs(e1 - t), a.TWO_PI - Math.abs(e1 - t)), n && (e1 = e1 <= a.HALF_PI ? Math.atan(r / o * Math.tan(e1)) : e1 > a.HALF_PI && e1 <= 3 * a.HALF_PI ? Math.atan(r / o * Math.tan(e1)) + a.PI : Math.atan(r / o * Math.tan(e1)) + a.TWO_PI, t = t <= a.HALF_PI ? Math.atan(r / o * Math.tan(t)) : t > a.HALF_PI && t <= 3 * a.HALF_PI ? Math.atan(r / o * Math.tan(t)) + a.PI : Math.atan(r / o * Math.tan(t)) + a.TWO_PI), t < e1 && (t += a.TWO_PI), {
                        start: e1,
                        stop: t,
                        correspondToSamePoint: s < 1e-5
                    };
                }, l.default.prototype.arc = function(e1, t, r, o, n, s, i, a) {
                    return l.default._validateParameters("arc", arguments), (this._renderer._doStroke || this._renderer._doFill) && n !== s && (n = this._toRadians(n), s = this._toRadians(s), e1 = u.default.modeAdjust(e1, t, r, o, this._renderer._ellipseMode), (t = this._normalizeArcAngles(n, s, e1.w, e1.h, !0)).correspondToSamePoint ? this._renderer.ellipse([
                        e1.x,
                        e1.y,
                        e1.w,
                        e1.h,
                        a
                    ]) : (this._renderer.arc(e1.x, e1.y, e1.w, e1.h, t.start, t.stop, i, a), (this._accessibleOutputs.grid || this._accessibleOutputs.text) && this._accsOutput("arc", [
                        e1.x,
                        e1.y,
                        e1.w,
                        e1.h,
                        t.start,
                        t.stop,
                        i
                    ]))), this;
                }, l.default.prototype.ellipse = function(e1, t, r, o, n) {
                    return l.default._validateParameters("ellipse", arguments), this._renderEllipse.apply(this, arguments);
                }, l.default.prototype.circle = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    l.default._validateParameters("circle", t);
                    var o = t.slice(0, 2);
                    return o.push(t[2], t[2]), this._renderEllipse.apply(this, s(o));
                }, l.default.prototype._renderEllipse = function(e1, t, r, o, n) {
                    return (this._renderer._doStroke || this._renderer._doFill) && (e1 = u.default.modeAdjust(e1, t, r, o = void 0 === o ? r : o, this._renderer._ellipseMode), this._renderer.ellipse([
                        e1.x,
                        e1.y,
                        e1.w,
                        e1.h,
                        n
                    ]), (this._accessibleOutputs.grid || this._accessibleOutputs.text) && this._accsOutput("ellipse", [
                        e1.x,
                        e1.y,
                        e1.w,
                        e1.h
                    ])), this;
                }, l.default.prototype.line = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return l.default._validateParameters("line", r), this._renderer._doStroke && (e1 = this._renderer).line.apply(e1, r), (this._accessibleOutputs.grid || this._accessibleOutputs.text) && this._accsOutput("line", r), this;
                }, l.default.prototype.point = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return l.default._validateParameters("point", r), this._renderer._doStroke && (1 === r.length && r[0] instanceof l.default.Vector ? this._renderer.point.call(this._renderer, r[0].x, r[0].y, r[0].z) : ((e1 = this._renderer).point.apply(e1, r), (this._accessibleOutputs.grid || this._accessibleOutputs.text) && this._accsOutput("point", r))), this;
                }, l.default.prototype.quad = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return l.default._validateParameters("quad", r), (this._renderer._doStroke || this._renderer._doFill) && (this._renderer.isP3D && r.length < 12 ? this._renderer.quad.call(this._renderer, r[0], r[1], 0, r[2], r[3], 0, r[4], r[5], 0, r[6], r[7], 0, r[8], r[9]) : ((e1 = this._renderer).quad.apply(e1, r), (this._accessibleOutputs.grid || this._accessibleOutputs.text) && this._accsOutput("quadrilateral", r))), this;
                }, l.default.prototype.rect = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    return l.default._validateParameters("rect", t), this._renderRect.apply(this, t);
                }, l.default.prototype.square = function(e1, t, r, o, n, s, i) {
                    return l.default._validateParameters("square", arguments), this._renderRect.call(this, e1, t, r, r, o, n, s, i);
                }, l.default.prototype._renderRect = function() {
                    if (this._renderer._doStroke || this._renderer._doFill) {
                        3 === arguments.length && (arguments[3] = arguments[2]);
                        for(var e1 = u.default.modeAdjust(arguments[0], arguments[1], arguments[2], arguments[3], this._renderer._rectMode), t = (this._renderer._rectMode === a.CORNER && (e1.w = arguments[2], e1.h = arguments[3]), [
                            e1.x,
                            e1.y,
                            e1.w,
                            e1.h
                        ]), r = 4; r < arguments.length; r++)t[r] = arguments[r];
                        this._renderer.rect(t), (this._accessibleOutputs.grid || this._accessibleOutputs.text) && this._accsOutput("rectangle", [
                            e1.x,
                            e1.y,
                            e1.w,
                            e1.h
                        ]);
                    }
                    return this;
                }, l.default.prototype.triangle = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    return l.default._validateParameters("triangle", t), (this._renderer._doStroke || this._renderer._doFill) && this._renderer.triangle(t), (this._accessibleOutputs.grid || this._accessibleOutputs.text) && this._accsOutput("triangle", t), this;
                };
                e1 = l.default;
                r.default = e1;
            },
            {
                "../constants": 272,
                "../friendly_errors/fes_core": 274,
                "../friendly_errors/file_errors": 275,
                "../friendly_errors/validate_params": 278,
                "../helpers": 279,
                "../main": 283,
                "core-js/modules/es.array.from": 162,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        291: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (l = e1("../main")) && l.__esModule ? l : {
                    default: l
                }, s = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                n.default.prototype.ellipseMode = function(e1) {
                    return n.default._validateParameters("ellipseMode", arguments), e1 !== s.CORNER && e1 !== s.CORNERS && e1 !== s.RADIUS && e1 !== s.CENTER || (this._renderer._ellipseMode = e1), this;
                }, n.default.prototype.noSmooth = function() {
                    return this._renderer.isP3D ? this.setAttributes("antialias", !1) : "imageSmoothingEnabled" in this.drawingContext && (this.drawingContext.imageSmoothingEnabled = !1), this;
                }, n.default.prototype.rectMode = function(e1) {
                    return n.default._validateParameters("rectMode", arguments), e1 !== s.CORNER && e1 !== s.CORNERS && e1 !== s.RADIUS && e1 !== s.CENTER || (this._renderer._rectMode = e1), this;
                }, n.default.prototype.smooth = function() {
                    return this._renderer.isP3D ? this.setAttributes("antialias", !0) : "imageSmoothingEnabled" in this.drawingContext && (this.drawingContext.imageSmoothingEnabled = !0), this;
                }, n.default.prototype.strokeCap = function(e1) {
                    return n.default._validateParameters("strokeCap", arguments), e1 !== s.ROUND && e1 !== s.SQUARE && e1 !== s.PROJECT || this._renderer.strokeCap(e1), this;
                }, n.default.prototype.strokeJoin = function(e1) {
                    return n.default._validateParameters("strokeJoin", arguments), e1 !== s.ROUND && e1 !== s.BEVEL && e1 !== s.MITER || this._renderer.strokeJoin(e1), this;
                }, n.default.prototype.strokeWeight = function(e1) {
                    return n.default._validateParameters("strokeWeight", arguments), this._renderer.strokeWeight(e1), this;
                };
                var l = n.default;
                r.default = l;
            },
            {
                "../constants": 272,
                "../main": 283,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        292: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var l = (o = e1("../main")) && o.__esModule ? o : {
                    default: o
                };
                e1("../friendly_errors/fes_core"), e1("../friendly_errors/file_errors"), e1("../friendly_errors/validate_params"), l.default.prototype.bezier = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return l.default._validateParameters("bezier", r), (this._renderer._doStroke || this._renderer._doFill) && (e1 = this._renderer).bezier.apply(e1, r), this;
                }, l.default.prototype.bezierDetail = function(e1) {
                    return l.default._validateParameters("bezierDetail", arguments), this._bezierDetail = e1, this;
                }, l.default.prototype.bezierPoint = function(e1, t, r, o, n) {
                    l.default._validateParameters("bezierPoint", arguments);
                    var s = 1 - n;
                    return Math.pow(s, 3) * e1 + 3 * Math.pow(s, 2) * n * t + 3 * s * Math.pow(n, 2) * r + Math.pow(n, 3) * o;
                }, l.default.prototype.bezierTangent = function(e1, t, r, o, n) {
                    l.default._validateParameters("bezierTangent", arguments);
                    var s = 1 - n;
                    return 3 * o * Math.pow(n, 2) - 3 * r * Math.pow(n, 2) + 6 * r * s * n - 6 * t * s * n + 3 * t * Math.pow(s, 2) - 3 * e1 * Math.pow(s, 2);
                }, l.default.prototype.curve = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return l.default._validateParameters("curve", r), this._renderer._doStroke && (e1 = this._renderer).curve.apply(e1, r), this;
                }, l.default.prototype.curveDetail = function(e1) {
                    return l.default._validateParameters("curveDetail", arguments), this._curveDetail = e1 < 3 ? 3 : e1, this;
                }, l.default.prototype.curveTightness = function(e1) {
                    return l.default._validateParameters("curveTightness", arguments), this._renderer._curveTightness = e1, this;
                }, l.default.prototype.curvePoint = function(e1, t, r, o, n) {
                    l.default._validateParameters("curvePoint", arguments);
                    var s = this._renderer._curveTightness, i = n * n * n, a = n * n;
                    return e1 * ((s - 1) / 2 * i + (1 - s) * a + (s - 1) / 2 * n) + t * ((s + 3) / 2 * i + (-5 - s) / 2 * a + 1) + r * ((-3 - s) / 2 * i + (s + 2) * a + (1 - s) / 2 * n) + o * ((1 - s) / 2 * i + (s - 1) / 2 * a);
                }, l.default.prototype.curveTangent = function(e1, t, r, o, n) {
                    l.default._validateParameters("curveTangent", arguments);
                    var s = this._renderer._curveTightness, i = n * n * 3, n = 2 * n;
                    return e1 * ((s - 1) / 2 * i + (1 - s) * n + (s - 1) / 2) + t * ((s + 3) / 2 * i + (-5 - s) / 2 * n) + r * ((-3 - s) / 2 * i + (s + 2) * n + (1 - s) / 2) + o * ((1 - s) / 2 * i + (s - 1) / 2 * n);
                };
                var o = l.default;
                r.default = o;
            },
            {
                "../friendly_errors/fes_core": 274,
                "../friendly_errors/file_errors": 275,
                "../friendly_errors/validate_params": 278,
                "../main": 283
            }
        ],
        293: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.slice"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var a = (y = e1("../main")) && y.__esModule ? y : {
                    default: y
                }, l = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = u();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../constants"));
                function u() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, u = function() {
                        return e1;
                    }, e1);
                }
                var n = null, c = [], d = [], h = !1, s = !1, f = !1, p = !1, m = !0, y = (a.default.prototype.beginContour = function() {
                    return this._renderer.isP3D ? this._renderer.beginContour() : (d = [], p = !0), this;
                }, a.default.prototype.beginShape = function(e1) {
                    var t;
                    return a.default._validateParameters("beginShape", arguments), this._renderer.isP3D ? (t = this._renderer).beginShape.apply(t, arguments) : (n = e1 === l.POINTS || e1 === l.LINES || e1 === l.TRIANGLES || e1 === l.TRIANGLE_FAN || e1 === l.TRIANGLE_STRIP || e1 === l.QUADS || e1 === l.QUAD_STRIP ? e1 : null, c = [], d = []), this;
                }, a.default.prototype.bezierVertex = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    if (a.default._validateParameters("bezierVertex", r), this._renderer.isP3D) (e1 = this._renderer).bezierVertex.apply(e1, r);
                    else if (0 === c.length) a.default._friendlyError("vertex() must be used once before calling bezierVertex()", "bezierVertex");
                    else {
                        h = !0;
                        for(var n = [], s = 0; s < r.length; s++)n[s] = r[s];
                        n.isVert = !1, (p ? d : c).push(n);
                    }
                    return this;
                }, a.default.prototype.curveVertex = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return a.default._validateParameters("curveVertex", r), this._renderer.isP3D ? (e1 = this._renderer).curveVertex.apply(e1, r) : (s = !0, this.vertex(r[0], r[1])), this;
                }, a.default.prototype.endContour = function() {
                    if (!this._renderer.isP3D) {
                        var e1 = d[0].slice();
                        e1.isVert = d[0].isVert, e1.moveTo = !1, d.push(e1), m && (c.push(c[0]), m = !1);
                        for(var t = 0; t < d.length; t++)c.push(d[t]);
                    }
                    return this;
                }, a.default.prototype.endShape = function(e1) {
                    var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 1;
                    if (a.default._validateParameters("endShape", arguments), t < 1 && (console.log("\uD83C\uDF38 p5.js says: You can not have less than one instance"), t = 1), this._renderer.isP3D) this._renderer.endShape(e1, s, h, f, p, n, t);
                    else {
                        if (1 !== t && console.log("\uD83C\uDF38 p5.js says: Instancing is only supported in WebGL2 mode"), 0 === c.length) return this;
                        if (!this._renderer._doStroke && !this._renderer._doFill) return this;
                        t = e1 === l.CLOSE;
                        t && !p && c.push(c[0]), this._renderer.endShape(e1, c, s, h, f, p, n), m = !(p = f = h = s = !1), t && c.pop();
                    }
                    return this;
                }, a.default.prototype.quadraticVertex = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    if (a.default._validateParameters("quadraticVertex", r), this._renderer.isP3D) (e1 = this._renderer).quadraticVertex.apply(e1, r);
                    else {
                        if (this._contourInited) return (e1 = {}).x = r[0], e1.y = r[1], e1.x3 = r[2], e1.y3 = r[3], e1.type = l.QUADRATIC, this._contourVertices.push(e1), this;
                        if (0 < c.length) {
                            f = !0;
                            for(var n = [], s = 0; s < r.length; s++)n[s] = r[s];
                            n.isVert = !1, (p ? d : c).push(n);
                        } else a.default._friendlyError("vertex() must be used once before calling quadraticVertex()", "quadraticVertex");
                    }
                    return this;
                }, a.default.prototype.vertex = function(e1, t, r, o, n) {
                    var s;
                    return this._renderer.isP3D ? (s = this._renderer).vertex.apply(s, arguments) : ((s = []).isVert = !0, s[0] = e1, s[1] = t, s[2] = 0, s[3] = 0, s[4] = 0, s[5] = this._renderer._getFill(), s[6] = this._renderer._getStroke(), r && (s.moveTo = r), (p ? (0 === d.length && (s.moveTo = !0), d) : c).push(s)), this;
                }, a.default.prototype.normal = function(e1, t, r) {
                    var o;
                    return this._assert3d("normal"), a.default._validateParameters("normal", arguments), (o = this._renderer).normal.apply(o, arguments), this;
                }, a.default);
                r.default = y;
            },
            {
                "../constants": 272,
                "../main": 283,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        294: [
            function(e1, t, r) {},
            {}
        ],
        295: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.assign"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("./main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                e1.default.prototype.noLoop = function() {
                    this._loop = !1;
                }, e1.default.prototype.loop = function() {
                    this._loop || (this._loop = !0, this._setupDone && this._draw());
                }, e1.default.prototype.isLooping = function() {
                    return this._loop;
                }, e1.default.prototype.push = function() {
                    this._styles.push({
                        props: {
                            _colorMode: this._colorMode
                        },
                        renderer: this._renderer.push()
                    });
                }, e1.default.prototype.pop = function() {
                    var e1 = this._styles.pop();
                    e1 ? (this._renderer.pop(e1.renderer), Object.assign(this, e1.props)) : console.warn("pop() was called without matching push()");
                }, e1.default.prototype.redraw = function(e1) {
                    if (!this._inUserDraw && this._setupDone) {
                        var t = parseInt(e1), r = ((isNaN(t) || t < 1) && (t = 1), this._isGlobal ? window : this);
                        if ("function" == typeof r.draw) {
                            void 0 === r.setup && r.scale(r._pixelDensity, r._pixelDensity);
                            for(var o = 0; o < t; o++){
                                r.resetMatrix(), (this._accessibleOutputs.grid || this._accessibleOutputs.text) && this._updateAccsOutput(), r._renderer.isP3D && r._renderer._update(), r._setProperty("frameCount", r.frameCount + 1), this.callRegisteredHooksFor("pre"), this._inUserDraw = !0;
                                try {
                                    r.draw();
                                } finally{
                                    this._inUserDraw = !1;
                                }
                                this.callRegisteredHooksFor("post");
                            }
                        }
                    }
                };
                e1 = e1.default;
                r.default = e1;
            },
            {
                "./main": 283,
                "core-js/modules/es.object.assign": 183
            }
        ],
        296: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (e1 = e1("./main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function o(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                n.default.prototype.applyMatrix = function() {
                    var e1 = (arguments.length <= 0 ? void 0 : arguments[0]) instanceof Object.getPrototypeOf(Uint8Array);
                    return Array.isArray(arguments.length <= 0 ? void 0 : arguments[0]) || e1 ? (e1 = this._renderer).applyMatrix.apply(e1, o(arguments.length <= 0 ? void 0 : arguments[0])) : (e1 = this._renderer).applyMatrix.apply(e1, arguments), this;
                }, n.default.prototype.resetMatrix = function() {
                    return this._renderer.resetMatrix(), this;
                }, n.default.prototype.rotate = function(e1, t) {
                    return n.default._validateParameters("rotate", arguments), this._renderer.rotate(this._toRadians(e1), t), this;
                }, n.default.prototype.rotateX = function(e1) {
                    return this._assert3d("rotateX"), n.default._validateParameters("rotateX", arguments), this._renderer.rotateX(this._toRadians(e1)), this;
                }, n.default.prototype.rotateY = function(e1) {
                    return this._assert3d("rotateY"), n.default._validateParameters("rotateY", arguments), this._renderer.rotateY(this._toRadians(e1)), this;
                }, n.default.prototype.rotateZ = function(e1) {
                    return this._assert3d("rotateZ"), n.default._validateParameters("rotateZ", arguments), this._renderer.rotateZ(this._toRadians(e1)), this;
                }, n.default.prototype.scale = function(e1, t, r) {
                    var o;
                    return n.default._validateParameters("scale", arguments), e1 instanceof n.default.Vector ? (e1 = (o = e1).x, t = o.y, r = o.z) : Array.isArray(e1) && (e1 = (o = e1)[0], t = o[1], r = o[2] || 1), isNaN(t) ? t = r = e1 : isNaN(r) && (r = 1), this._renderer.scale(e1, t, r), this;
                }, n.default.prototype.shearX = function(e1) {
                    n.default._validateParameters("shearX", arguments);
                    e1 = this._toRadians(e1);
                    return this._renderer.applyMatrix(1, 0, Math.tan(e1), 1, 0, 0), this;
                }, n.default.prototype.shearY = function(e1) {
                    n.default._validateParameters("shearY", arguments);
                    e1 = this._toRadians(e1);
                    return this._renderer.applyMatrix(1, Math.tan(e1), 0, 1, 0, 0), this;
                }, n.default.prototype.translate = function(e1, t, r) {
                    return n.default._validateParameters("translate", arguments), this._renderer.isP3D ? this._renderer.translate(e1, t, r) : this._renderer.translate(e1, t), this;
                };
                e1 = n.default;
                r.default = e1;
            },
            {
                "./main": 283,
                "core-js/modules/es.array.from": 162,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.object.get-prototype-of": 188,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.typed-array.copy-within": 213,
                "core-js/modules/es.typed-array.every": 214,
                "core-js/modules/es.typed-array.fill": 215,
                "core-js/modules/es.typed-array.filter": 216,
                "core-js/modules/es.typed-array.find": 218,
                "core-js/modules/es.typed-array.find-index": 217,
                "core-js/modules/es.typed-array.for-each": 221,
                "core-js/modules/es.typed-array.includes": 222,
                "core-js/modules/es.typed-array.index-of": 223,
                "core-js/modules/es.typed-array.iterator": 226,
                "core-js/modules/es.typed-array.join": 227,
                "core-js/modules/es.typed-array.last-index-of": 228,
                "core-js/modules/es.typed-array.map": 229,
                "core-js/modules/es.typed-array.reduce": 231,
                "core-js/modules/es.typed-array.reduce-right": 230,
                "core-js/modules/es.typed-array.reverse": 232,
                "core-js/modules/es.typed-array.set": 233,
                "core-js/modules/es.typed-array.slice": 234,
                "core-js/modules/es.typed-array.some": 235,
                "core-js/modules/es.typed-array.sort": 236,
                "core-js/modules/es.typed-array.subarray": 237,
                "core-js/modules/es.typed-array.to-locale-string": 238,
                "core-js/modules/es.typed-array.to-string": 239,
                "core-js/modules/es.typed-array.uint8-array": 242,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        297: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.ends-with"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.ends-with"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator");
                var n = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function s(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                n.default.prototype.storeItem = function(e1, t) {
                    "string" != typeof e1 && console.log("The argument that you passed to storeItem() - ".concat(e1, " is not a string.")), e1.endsWith("p5TypeID") && console.log("The argument that you passed to storeItem() - ".concat(e1, " must not end with 'p5TypeID'.")), void 0 === t && console.log("You cannot store undefined variables using storeItem().");
                    var r = i(t);
                    switch(r){
                        case "number":
                        case "boolean":
                            t = t.toString();
                            break;
                        case "object":
                            t instanceof n.default.Color ? r = "p5.Color" : t instanceof n.default.Vector && (r = "p5.Vector", t = [
                                t.x,
                                t.y,
                                t.z
                            ]), t = JSON.stringify(t);
                    }
                    localStorage.setItem(e1, t);
                    e1 = "".concat(e1, "p5TypeID");
                    localStorage.setItem(e1, r);
                }, n.default.prototype.getItem = function(e1) {
                    var t = localStorage.getItem(e1), r = localStorage.getItem("".concat(e1, "p5TypeID"));
                    if (void 0 === r) console.log("Unable to determine type of item stored under ".concat(e1, "in local storage. Did you save the item with something other than setItem()?"));
                    else if (null !== t) switch(r){
                        case "number":
                            t = parseFloat(t);
                            break;
                        case "boolean":
                            t = "true" === t;
                            break;
                        case "object":
                            t = JSON.parse(t);
                            break;
                        case "p5.Color":
                            t = JSON.parse(t), t = this.color.apply(this, s(t.levels));
                            break;
                        case "p5.Vector":
                            t = JSON.parse(t), t = this.createVector.apply(this, s(t));
                    }
                    return t;
                }, n.default.prototype.clearStorage = function() {
                    var t = this;
                    Object.keys(localStorage).forEach(function(e1) {
                        e1.endsWith("p5TypeID") && t.removeItem(e1.replace("p5TypeID", ""));
                    });
                }, n.default.prototype.removeItem = function(e1) {
                    "string" != typeof e1 && console.log("The argument that you passed to removeItem() - ".concat(e1, " is not a string.")), localStorage.removeItem(e1), localStorage.removeItem("".concat(e1, "p5TypeID"));
                };
            },
            {
                "../core/main": 283,
                "core-js/modules/es.array.for-each": 161,
                "core-js/modules/es.array.from": 162,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.object.keys": 189,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.regexp.exec": 195,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.ends-with": 198,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.string.replace": 204,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/web.dom-collections.for-each": 245,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        298: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function n(e1) {
                    return (n = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.object.keys"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function i(e1, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e1.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e1,
                            writable: !0,
                            configurable: !0
                        }
                    }), t && a(e1, t);
                }
                function a(e1, t) {
                    return (a = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                function l(r) {
                    return function() {
                        var e1, t = u(r), t = (e1 = function() {
                            if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                                if ("function" == typeof Proxy) return 1;
                                try {
                                    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                                } catch (e1) {}
                            }
                        }() ? (e1 = u(this).constructor, Reflect.construct(t, arguments, e1)) : t.apply(this, arguments), this);
                        if (!e1 || "object" !== n(e1) && "function" != typeof e1) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }
                        return e1;
                    };
                }
                function u(e1) {
                    return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    })(e1);
                }
                function c(e1, t) {
                    if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function d(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function h(e1, t, r) {
                    t && d(e1.prototype, t), r && d(e1, r);
                }
                s.default.prototype.createStringDict = function(e1, t) {
                    return s.default._validateParameters("createStringDict", arguments), new s.default.StringDict(e1, t);
                }, s.default.prototype.createNumberDict = function(e1, t) {
                    return s.default._validateParameters("createNumberDict", arguments), new s.default.NumberDict(e1, t);
                }, s.default.TypedDict = function() {
                    function r(e1, t) {
                        return c(this, r), e1 instanceof Object ? this.data = e1 : (this.data = {}, this.data[e1] = t), this;
                    }
                    return h(r, [
                        {
                            key: "size",
                            value: function() {
                                return Object.keys(this.data).length;
                            }
                        },
                        {
                            key: "hasKey",
                            value: function(e1) {
                                return this.data.hasOwnProperty(e1);
                            }
                        },
                        {
                            key: "get",
                            value: function(e1) {
                                if (this.data.hasOwnProperty(e1)) return this.data[e1];
                                console.log("".concat(e1, " does not exist in this Dictionary"));
                            }
                        },
                        {
                            key: "set",
                            value: function(e1, t) {
                                this._validate(t) ? this.data[e1] = t : console.log("Those values dont work for this dictionary type.");
                            }
                        },
                        {
                            key: "_addObj",
                            value: function(e1) {
                                for(var t in e1)this.set(t, e1[t]);
                            }
                        },
                        {
                            key: "create",
                            value: function(e1, t) {
                                e1 instanceof Object && void 0 === t ? this._addObj(e1) : void 0 !== e1 ? this.set(e1, t) : console.log("In order to create a new Dictionary entry you must pass an object or a key, value pair");
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                this.data = {};
                            }
                        },
                        {
                            key: "remove",
                            value: function(e1) {
                                if (!this.data.hasOwnProperty(e1)) throw new Error("".concat(e1, " does not exist in this Dictionary"));
                                delete this.data[e1];
                            }
                        },
                        {
                            key: "print",
                            value: function() {
                                for(var e1 in this.data)console.log("key:".concat(e1, " value:").concat(this.data[e1]));
                            }
                        },
                        {
                            key: "saveTable",
                            value: function(e1) {
                                var t, r = "";
                                for(t in this.data)r += "".concat(t, ",").concat(this.data[t], "\n");
                                var o = new Blob([
                                    r
                                ], {
                                    type: "text/csv"
                                });
                                s.default.prototype.downloadFile(o, e1 || "mycsv", "csv");
                            }
                        },
                        {
                            key: "saveJSON",
                            value: function(e1, t) {
                                s.default.prototype.saveJSON(this.data, e1, t);
                            }
                        },
                        {
                            key: "_validate",
                            value: function(e1) {
                                return !0;
                            }
                        }
                    ]), r;
                }(), s.default.StringDict = function() {
                    i(n, s.default.TypedDict);
                    var o = l(n);
                    function n() {
                        c(this, n);
                        for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                        return o.call.apply(o, [
                            this
                        ].concat(t));
                    }
                    return h(n, [
                        {
                            key: "_validate",
                            value: function(e1) {
                                return "string" == typeof e1;
                            }
                        }
                    ]), n;
                }(), s.default.NumberDict = function() {
                    i(n, s.default.TypedDict);
                    var o = l(n);
                    function n() {
                        c(this, n);
                        for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                        return o.call.apply(o, [
                            this
                        ].concat(t));
                    }
                    return h(n, [
                        {
                            key: "_validate",
                            value: function(e1) {
                                return "number" == typeof e1;
                            }
                        },
                        {
                            key: "add",
                            value: function(e1, t) {
                                this.data.hasOwnProperty(e1) ? this.data[e1] += t : console.log("The key - ".concat(e1, " does not exist in this dictionary."));
                            }
                        },
                        {
                            key: "sub",
                            value: function(e1, t) {
                                this.add(e1, -t);
                            }
                        },
                        {
                            key: "mult",
                            value: function(e1, t) {
                                this.data.hasOwnProperty(e1) ? this.data[e1] *= t : console.log("The key - ".concat(e1, " does not exist in this dictionary."));
                            }
                        },
                        {
                            key: "div",
                            value: function(e1, t) {
                                this.data.hasOwnProperty(e1) ? this.data[e1] /= t : console.log("The key - ".concat(e1, " does not exist in this dictionary."));
                            }
                        },
                        {
                            key: "_valueTest",
                            value: function(e1) {
                                if (0 === Object.keys(this.data).length) throw new Error("Unable to search for a minimum or maximum value on an empty NumberDict");
                                if (1 === Object.keys(this.data).length) return this.data[Object.keys(this.data)[0]];
                                var t, r = this.data[Object.keys(this.data)[0]];
                                for(t in this.data)this.data[t] * e1 < r * e1 && (r = this.data[t]);
                                return r;
                            }
                        },
                        {
                            key: "minValue",
                            value: function() {
                                return this._valueTest(1);
                            }
                        },
                        {
                            key: "maxValue",
                            value: function() {
                                return this._valueTest(-1);
                            }
                        },
                        {
                            key: "_keyTest",
                            value: function(e1) {
                                if (0 === Object.keys(this.data).length) throw new Error("Unable to use minValue on an empty NumberDict");
                                if (1 === Object.keys(this.data).length) return Object.keys(this.data)[0];
                                for(var t = Object.keys(this.data)[0], r = 1; r < Object.keys(this.data).length; r++)Object.keys(this.data)[r] * e1 < t * e1 && (t = Object.keys(this.data)[r]);
                                return t;
                            }
                        },
                        {
                            key: "minKey",
                            value: function() {
                                return this._keyTest(1);
                            }
                        },
                        {
                            key: "maxKey",
                            value: function() {
                                return this._keyTest(-1);
                            }
                        }
                    ]), n;
                }();
                e1 = s.default.TypedDict;
                r.default = e1;
            },
            {
                "../core/main": 283,
                "core-js/modules/es.array.concat": 153,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.object.get-prototype-of": 188,
                "core-js/modules/es.object.keys": 189,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.reflect.construct": 192,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        299: [
            function(t, r, o) {
                "use strict";
                function n(e1) {
                    return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                t("core-js/modules/es.symbol"), t("core-js/modules/es.symbol.description"), t("core-js/modules/es.symbol.iterator"), t("core-js/modules/es.array.every"), t("core-js/modules/es.array.filter"), t("core-js/modules/es.array.for-each"), t("core-js/modules/es.array.from"), t("core-js/modules/es.array.index-of"), t("core-js/modules/es.array.iterator"), t("core-js/modules/es.array.map"), t("core-js/modules/es.array.slice"), t("core-js/modules/es.array.splice"), t("core-js/modules/es.function.name"), t("core-js/modules/es.object.assign"), t("core-js/modules/es.object.get-prototype-of"), t("core-js/modules/es.object.to-string"), t("core-js/modules/es.promise"), t("core-js/modules/es.reflect.construct"), t("core-js/modules/es.regexp.exec"), t("core-js/modules/es.regexp.to-string"), t("core-js/modules/es.string.iterator"), t("core-js/modules/es.string.replace"), t("core-js/modules/es.string.split"), t("core-js/modules/es.string.trim"), t("core-js/modules/web.dom-collections.for-each"), t("core-js/modules/web.dom-collections.iterator"), t("core-js/modules/web.url"), t("core-js/modules/es.symbol"), t("core-js/modules/es.symbol.description"), t("core-js/modules/es.symbol.iterator"), t("core-js/modules/es.array.every"), t("core-js/modules/es.array.filter"), t("core-js/modules/es.array.for-each"), t("core-js/modules/es.array.from"), t("core-js/modules/es.array.index-of"), t("core-js/modules/es.array.iterator"), t("core-js/modules/es.array.map"), t("core-js/modules/es.array.slice"), t("core-js/modules/es.array.splice"), t("core-js/modules/es.function.name"), t("core-js/modules/es.object.assign"), t("core-js/modules/es.object.to-string"), t("core-js/modules/es.promise"), t("core-js/modules/es.regexp.exec"), t("core-js/modules/es.regexp.to-string"), t("core-js/modules/es.string.iterator"), t("core-js/modules/es.string.replace"), t("core-js/modules/es.string.split"), t("core-js/modules/es.string.trim"), t("core-js/modules/web.dom-collections.for-each"), t("core-js/modules/web.dom-collections.iterator"), t("core-js/modules/web.url"), Object.defineProperty(o, "__esModule", {
                    value: !0
                }), o.default = void 0;
                var f = (t = t("../core/main")) && t.__esModule ? t : {
                    default: t
                };
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function a(e1, t, r) {
                    t && s(e1.prototype, t), r && s(e1, r);
                }
                function l(e1, t) {
                    return (l = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                function u(o) {
                    return function() {
                        var e1, t, r = i(o);
                        return e1 = function() {
                            if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                                if ("function" == typeof Proxy) return 1;
                                try {
                                    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                                } catch (e1) {}
                            }
                        }() ? (e1 = i(this).constructor, Reflect.construct(r, arguments, e1)) : r.apply(this, arguments), r = this, !(t = e1) || "object" !== p(t) && "function" != typeof t ? c(r) : t;
                    };
                }
                function c(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }
                function i(e1) {
                    return (i = Object.setPrototypeOf ? Object.getPrototypeOf : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    })(e1);
                }
                function d(e1, t) {
                    if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function p(e1) {
                    return (p = "function" == typeof Symbol && "symbol" === n(Symbol.iterator) ? function(e1) {
                        return n(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : n(e1);
                    })(e1);
                }
                function m(e1, t, r) {
                    (t._userNode || document.body).appendChild(e1);
                    r = new (r ? f.default.MediaElement : f.default.Element)(e1, t);
                    return t._elements.push(r), r;
                }
                f.default.prototype.select = function(e1, t) {
                    f.default._validateParameters("select", arguments);
                    t = this._getContainer(t).querySelector(e1);
                    return t ? this._wrapElement(t) : null;
                }, f.default.prototype.selectAll = function(e1, t) {
                    f.default._validateParameters("selectAll", arguments);
                    var r = [], o = this._getContainer(t).querySelectorAll(e1);
                    if (o) for(var n = 0; n < o.length; n++){
                        var s = this._wrapElement(o[n]);
                        r.push(s);
                    }
                    return r;
                }, f.default.prototype._getContainer = function(e1) {
                    var t = document;
                    return "string" == typeof e1 ? t = document.querySelector(e1) || document : e1 instanceof f.default.Element ? t = e1.elt : e1 instanceof HTMLElement && (t = e1), t;
                }, f.default.prototype._wrapElement = function(e1) {
                    var t, r = Array.prototype.slice.call(e1.children);
                    return "INPUT" === e1.tagName && "checkbox" === e1.type ? ((t = new f.default.Element(e1, this)).checked = function() {
                        return 0 === arguments.length ? this.elt.checked : (this.elt.checked = !(arguments.length <= 0 || !arguments[0]), this);
                    }, t) : "VIDEO" === e1.tagName || "AUDIO" === e1.tagName ? new f.default.MediaElement(e1, this) : "SELECT" === e1.tagName ? this.createSelect(new f.default.Element(e1, this)) : 0 < r.length && r.every(function(e1) {
                        return "INPUT" === e1.tagName || "LABEL" === e1.tagName;
                    }) && ("DIV" === e1.tagName || "SPAN" === e1.tagName) ? this.createRadio(new f.default.Element(e1, this)) : new f.default.Element(e1, this);
                }, f.default.prototype.removeElements = function(e1) {
                    f.default._validateParameters("removeElements", arguments);
                    this._elements.filter(function(e1) {
                        return !(e1.elt instanceof HTMLCanvasElement);
                    }).map(function(e1) {
                        return e1.remove();
                    });
                }, f.default.Element.prototype.changed = function(e1) {
                    return f.default.Element._adjustListener("change", e1, this), this;
                }, f.default.Element.prototype.input = function(e1) {
                    return f.default.Element._adjustListener("input", e1, this), this;
                }, f.default.prototype.createDiv = function() {
                    var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "", t = document.createElement("div");
                    return t.innerHTML = e1, m(t, this);
                }, f.default.prototype.createP = function() {
                    var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "", t = document.createElement("p");
                    return t.innerHTML = e1, m(t, this);
                }, f.default.prototype.createSpan = function() {
                    var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "", t = document.createElement("span");
                    return t.innerHTML = e1, m(t, this);
                }, f.default.prototype.createImg = function() {
                    f.default._validateParameters("createImg", arguments);
                    var t, r = document.createElement("img"), o = arguments;
                    return 1 < o.length && "string" == typeof o[1] && (r.alt = o[1]), 2 < o.length && "string" == typeof o[2] && (r.crossOrigin = o[2]), r.src = o[0], t = m(r, this), r.addEventListener("load", function() {
                        t.width = r.offsetWidth || r.width, t.height = r.offsetHeight || r.height;
                        var e1 = o[o.length - 1];
                        "function" == typeof e1 && e1(t);
                    }), t;
                }, f.default.prototype.createA = function(e1, t, r) {
                    f.default._validateParameters("createA", arguments);
                    var o = document.createElement("a");
                    return o.href = e1, o.innerHTML = t, r && (o.target = r), m(o, this);
                }, f.default.prototype.createSlider = function(e1, t, r, o) {
                    f.default._validateParameters("createSlider", arguments);
                    var n = document.createElement("input");
                    return n.type = "range", n.min = e1, n.max = t, 0 === o ? n.step = 1e-18 : o && (n.step = o), "number" == typeof r && (n.value = r), m(n, this);
                }, f.default.prototype.createButton = function(e1, t) {
                    f.default._validateParameters("createButton", arguments);
                    var r = document.createElement("button");
                    return r.innerHTML = e1, t && (r.value = t), m(r, this);
                }, f.default.prototype.createCheckbox = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    f.default._validateParameters("createCheckbox", t);
                    var o = document.createElement("div"), n = document.createElement("input"), s = (n.type = "checkbox", document.createElement("label")), i = (s.appendChild(n), o.appendChild(s), m(o, this));
                    return i.checked = function() {
                        var e1 = i.elt.firstElementChild.getElementsByTagName("input")[0];
                        if (e1) {
                            if (0 === arguments.length) return e1.checked;
                            e1.checked = !(arguments.length <= 0 || !arguments[0]);
                        }
                        return i;
                    }, this.value = function(e1) {
                        return i.value = e1, this;
                    }, t[0] && (i.value(t[0]), (o = document.createElement("span")).innerHTML = t[0], s.appendChild(o)), t[1] && (n.checked = !0), i;
                }, f.default.prototype.createSelect = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    f.default._validateParameters("createSelect", r);
                    var n, s = r[0];
                    return s instanceof f.default.Element && s.elt instanceof HTMLSelectElement ? this.elt = (e1 = s).elt : s instanceof HTMLSelectElement ? (e1 = m(s, this), this.elt = s) : (n = document.createElement("select"), s && "boolean" == typeof s && n.setAttribute("multiple", "true"), e1 = m(n, this), this.elt = n), e1.option = function(e1, t) {
                        var r;
                        if (void 0 !== e1) {
                            for(var o, n = 0; n < this.elt.length; n += 1)if (this.elt[n].textContent === e1) {
                                r = n;
                                break;
                            }
                            void 0 !== r ? !1 === t ? this.elt.remove(r) : this.elt[r].value = t : ((o = document.createElement("option")).textContent = e1, o.value = void 0 === t ? e1 : t, this.elt.appendChild(o), this._pInst._elements.push(o));
                        }
                    }, e1.selected = function(e1) {
                        if (void 0 !== e1) {
                            for(var t = 0; t < this.elt.length; t += 1)this.elt[t].value.toString() === e1.toString() && (this.elt.selectedIndex = t);
                            return this;
                        }
                        if (this.elt.getAttribute("multiple")) {
                            var r = [], o = !0, n = !1, s = void 0;
                            try {
                                for(var i, a = this.elt.selectedOptions[Symbol.iterator](); !(o = (i = a.next()).done); o = !0){
                                    var l = i.value;
                                    r.push(l.value);
                                }
                            } catch (e1) {
                                n = !0, s = e1;
                            } finally{
                                try {
                                    o || null == a.return || a.return();
                                } finally{
                                    if (n) throw s;
                                }
                            }
                            return r;
                        }
                        return this.elt.value;
                    }, e1.disable = function(e1) {
                        if ("string" == typeof e1) for(var t = 0; t < this.elt.length; t++)this.elt[t].value.toString() === e1 && (this.elt[t].disabled = !0, this.elt[t].selected = !1);
                        else this.elt.disabled = !0;
                        return this;
                    }, e1.enable = function(e1) {
                        if ("string" == typeof e1) for(var t = 0; t < this.elt.length; t++)this.elt[t].value.toString() === e1 && (this.elt[t].disabled = !1, this.elt[t].selected = !1);
                        else {
                            this.elt.disabled = !1;
                            for(var r = 0; r < this.elt.length; r++)this.elt[r].disabled = !1, this.elt[r].selected = !1;
                        }
                        return this;
                    }, e1;
                };
                var y = 0;
                function h(e1, t, r, o) {
                    var n = document.createElement(t), s = ("string" == typeof (r = r || "") && (r = [
                        r
                    ]), !0), t = !1, i = void 0;
                    try {
                        for(var a, l = r[Symbol.iterator](); !(s = (a = l.next()).done); s = !0){
                            var u = a.value, c = document.createElement("source");
                            c.setAttribute("src", u), n.appendChild(c);
                        }
                    } catch (e1) {
                        t = !0, i = e1;
                    } finally{
                        try {
                            s || null == l.return || l.return();
                        } finally{
                            if (t) throw i;
                        }
                    }
                    var d = m(n, e1, !0);
                    return d.loadedmetadata = !1, n.addEventListener("loadedmetadata", function() {
                        d.width = n.videoWidth, d.height = n.videoHeight, 0 === d.elt.width && (d.elt.width = n.videoWidth), 0 === d.elt.height && (d.elt.height = n.videoHeight), d.presetPlaybackRate && (d.elt.playbackRate = d.presetPlaybackRate, delete d.presetPlaybackRate), d.loadedmetadata = !0;
                    }), "function" == typeof o && n.addEventListener("canplaythrough", function e1() {
                        o(d), n.removeEventListener("canplaythrough", e1);
                    }), d;
                }
                f.default.prototype.createRadio = function() {
                    function t(e1) {
                        return e1 instanceof HTMLInputElement && "radio" === e1.type;
                    }
                    function d(e1) {
                        return e1 instanceof HTMLLabelElement;
                    }
                    var h, e1, r, o = arguments.length <= 0 ? void 0 : arguments[0];
                    o instanceof f.default.Element && (o.elt instanceof HTMLDivElement || o.elt instanceof HTMLSpanElement) ? (h = o, this.elt = o.elt) : o instanceof HTMLDivElement || o instanceof HTMLSpanElement ? (h = m(o, this), e1 = this.elt = o, "string" == typeof (arguments.length <= 1 ? void 0 : arguments[1]) && (r = arguments.length <= 1 ? void 0 : arguments[1])) : ("string" == typeof o && (r = o), e1 = document.createElement("div"), h = m(e1, this), this.elt = e1), h._name = r || "radioOption_".concat(y++);
                    return h._getOptionsArray = function() {
                        return Array.from(this.elt.children).filter(function(e1) {
                            return t(e1) || d(e1) && t(e1.firstElementChild);
                        }).map(function(e1) {
                            return t(e1) ? e1 : e1.firstElementChild;
                        });
                    }, h.option = function(e1, t) {
                        var r, o, n, s = !0, i = !1, a = void 0;
                        try {
                            for(var l, u = h._getOptionsArray()[Symbol.iterator](); !(s = (l = u.next()).done); s = !0){
                                var c = l.value;
                                if (c.value === e1) {
                                    r = c;
                                    break;
                                }
                            }
                        } catch (e1) {
                            i = !0, a = e1;
                        } finally{
                            try {
                                s || null == u.return || u.return();
                            } finally{
                                if (i) throw a;
                            }
                        }
                        return void 0 === r && ((r = document.createElement("input")).setAttribute("type", "radio"), r.setAttribute("value", e1)), r.setAttribute("name", h._name), d(r.parentElement) ? o = r.parentElement : (o = document.createElement("label")).insertAdjacentElement("afterbegin", r), o.lastElementChild instanceof HTMLSpanElement ? n = o.lastElementChild : (n = document.createElement("span"), r.insertAdjacentElement("afterend", n)), n.innerHTML = void 0 === t ? e1 : t, this.elt.appendChild(o), r;
                    }, h.remove = function(e1) {
                        var t = !0, r = !1, o = void 0;
                        try {
                            for(var n, s = h._getOptionsArray()[Symbol.iterator](); !(t = (n = s.next()).done); t = !0){
                                var i = n.value;
                                if (i.value === e1) return void (d(i.parentElement) ? i.parentElement : i).remove();
                            }
                        } catch (e1) {
                            r = !0, o = e1;
                        } finally{
                            try {
                                t || null == s.return || s.return();
                            } finally{
                                if (r) throw o;
                            }
                        }
                    }, h.value = function() {
                        var e1 = "", t = !0, r = !1, o = void 0;
                        try {
                            for(var n, s = h._getOptionsArray()[Symbol.iterator](); !(t = (n = s.next()).done); t = !0){
                                var i = n.value;
                                if (i.checked) {
                                    e1 = i.value;
                                    break;
                                }
                            }
                        } catch (e1) {
                            r = !0, o = e1;
                        } finally{
                            try {
                                t || null == s.return || s.return();
                            } finally{
                                if (r) throw o;
                            }
                        }
                        return e1;
                    }, h.selected = function(e1) {
                        var t = null;
                        if (void 0 === e1) {
                            var r = !0, o = !1, n = void 0;
                            try {
                                for(var s, i = h._getOptionsArray()[Symbol.iterator](); !(r = (s = i.next()).done); r = !0){
                                    var a = s.value;
                                    if (a.checked) {
                                        t = a;
                                        break;
                                    }
                                }
                            } catch (e1) {
                                o = !0, n = e1;
                            } finally{
                                try {
                                    r || null == i.return || i.return();
                                } finally{
                                    if (o) throw n;
                                }
                            }
                        } else {
                            h._getOptionsArray().forEach(function(e1) {
                                e1.checked = !1, e1.removeAttribute("checked");
                            });
                            var l = !0, o = !1, n = void 0;
                            try {
                                for(var u, c = h._getOptionsArray()[Symbol.iterator](); !(l = (u = c.next()).done); l = !0){
                                    var d = u.value;
                                    d.value === e1 && (d.setAttribute("checked", !0), d.checked = !0, t = d);
                                }
                            } catch (e1) {
                                o = !0, n = e1;
                            } finally{
                                try {
                                    l || null == c.return || c.return();
                                } finally{
                                    if (o) throw n;
                                }
                            }
                        }
                        return t;
                    }, h.disable = function() {
                        var e1 = !(0 < arguments.length && void 0 !== arguments[0]) || arguments[0], t = !0, r = !1, o = void 0;
                        try {
                            for(var n, s = h._getOptionsArray()[Symbol.iterator](); !(t = (n = s.next()).done); t = !0)n.value.setAttribute("disabled", e1);
                        } catch (e1) {
                            r = !0, o = e1;
                        } finally{
                            try {
                                t || null == s.return || s.return();
                            } finally{
                                if (r) throw o;
                            }
                        }
                    }, h;
                }, f.default.prototype.createColorPicker = function(e1) {
                    f.default._validateParameters("createColorPicker", arguments);
                    var t = document.createElement("input");
                    return t.type = "color", e1 ? e1 instanceof f.default.Color ? t.value = e1.toString("#rrggbb") : (f.default.prototype._colorMode = "rgb", f.default.prototype._colorMaxes = {
                        rgb: [
                            255,
                            255,
                            255,
                            255
                        ],
                        hsb: [
                            360,
                            100,
                            100,
                            1
                        ],
                        hsl: [
                            360,
                            100,
                            100,
                            1
                        ]
                    }, t.value = f.default.prototype.color(e1).toString("#rrggbb")) : t.value = "#000000", (t = m(t, this)).color = function() {
                        return e1 && (e1.mode && (f.default.prototype._colorMode = e1.mode), e1.maxes && (f.default.prototype._colorMaxes = e1.maxes)), f.default.prototype.color(this.elt.value);
                    }, t;
                }, f.default.prototype.createInput = function() {
                    var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "", t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "text", r = (f.default._validateParameters("createInput", arguments), document.createElement("input"));
                    return r.setAttribute("value", e1), r.setAttribute("type", t), m(r, this);
                }, f.default.prototype.createFileInput = function(a) {
                    var e1, t = 1 < arguments.length && void 0 !== arguments[1] && arguments[1];
                    f.default._validateParameters("createFileInput", arguments);
                    if (window.File && window.FileReader && window.FileList && window.Blob) return (e1 = document.createElement("input")).setAttribute("type", "file"), t && e1.setAttribute("multiple", !0), e1.addEventListener("change", function(e1) {
                        var t = !0, r = !1, o = void 0;
                        try {
                            for(var n, s = e1.target.files[Symbol.iterator](); !(t = (n = s.next()).done); t = !0){
                                var i = n.value;
                                f.default.File._load(i, a);
                            }
                        } catch (e1) {
                            r = !0, o = e1;
                        } finally{
                            try {
                                t || null == s.return || s.return();
                            } finally{
                                if (r) throw o;
                            }
                        }
                    }, !1), m(e1, this);
                    console.log("The File APIs are not fully supported in this browser. Cannot create element.");
                }, f.default.prototype.createVideo = function(e1, t) {
                    return f.default._validateParameters("createVideo", arguments), h(this, "video", e1, t);
                }, f.default.prototype.createAudio = function(e1, t) {
                    return f.default._validateParameters("createAudio", arguments), h(this, "audio", e1, t);
                }, f.default.prototype.VIDEO = "video", f.default.prototype.AUDIO = "audio", void 0 === navigator.mediaDevices && (navigator.mediaDevices = {}), void 0 === navigator.mediaDevices.getUserMedia && (navigator.mediaDevices.getUserMedia = function(r) {
                    var o = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
                    return o ? new Promise(function(e1, t) {
                        o.call(navigator, r, e1, t);
                    }) : Promise.reject(new Error("getUserMedia is not implemented in this browser"));
                }), f.default.prototype.createCapture = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    if (f.default._validateParameters("createCapture", t), !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) throw new DOMException("getUserMedia not supported in this browser");
                    for(var o, n = !0, s = !0, i = !1, a = 0, l = t; a < l.length; a++){
                        var u = l[a];
                        u === f.default.prototype.VIDEO ? s = !1 : u === f.default.prototype.AUDIO ? n = !1 : "object" === p(u) ? (void 0 !== u.flipped && (i = u.flipped, delete u.flipped), c = Object.assign({}, c, u)) : "function" == typeof u && (o = u);
                    }
                    var c = Object.assign({}, {
                        video: n,
                        audio: s
                    }, c), d = document.createElement("video"), h = (d.setAttribute("playsinline", ""), navigator.mediaDevices.getUserMedia(c).then(function(t) {
                        try {
                            "srcObject" in d ? d.srcObject = t : d.src = window.URL.createObjectURL(t);
                        } catch (e1) {
                            d.src = t;
                        }
                    }).catch(function(e1) {
                        "NotFoundError" === e1.name && f.default._friendlyError("No webcam found on this device", "createCapture"), "NotAllowedError" === e1.name && f.default._friendlyError("Access to the camera was denied", "createCapture"), console.error(e1);
                    }), m(d, this, !0));
                    return h.loadedmetadata = !1, d.addEventListener("loadedmetadata", function() {
                        d.play(), d.width ? (h.width = d.width, h.height = d.height, i && (h.elt.style.transform = "scaleX(-1)")) : (h.width = h.elt.width = d.videoWidth, h.height = h.elt.height = d.videoHeight), h.loadedmetadata = !0, o && o(d.srcObject);
                    }), h.flipped = i, h;
                }, f.default.prototype.createElement = function(e1, t) {
                    f.default._validateParameters("createElement", arguments);
                    e1 = document.createElement(e1);
                    return void 0 !== t && (e1.innerHTML = t), m(e1, this);
                }, f.default.Element.prototype.addClass = function(e1) {
                    return this.elt.className ? this.hasClass(e1) || (this.elt.className = this.elt.className + " " + e1) : this.elt.className = e1, this;
                }, f.default.Element.prototype.removeClass = function(e1) {
                    return this.elt.classList.remove(e1), this;
                }, f.default.Element.prototype.hasClass = function(e1) {
                    return this.elt.classList.contains(e1);
                }, f.default.Element.prototype.toggleClass = function(e1) {
                    return this.elt.classList.contains(e1) ? this.elt.classList.remove(e1) : this.elt.classList.add(e1), this;
                }, f.default.Element.prototype.child = function(e1) {
                    return void 0 === e1 ? this.elt.childNodes : ("string" == typeof e1 ? ("#" === e1[0] && (e1 = e1.substring(1)), e1 = document.getElementById(e1)) : e1 instanceof f.default.Element && (e1 = e1.elt), e1 instanceof HTMLElement && this.elt.appendChild(e1), this);
                }, f.default.Element.prototype.center = function(e1) {
                    var t = this.elt.style.display, r = "none" === this.elt.style.display, o = "none" === this.parent().style.display, n = {
                        x: this.elt.offsetLeft,
                        y: this.elt.offsetTop
                    }, s = (r && this.show(), o && this.parent().show(), this.elt.style.display = "block", this.position(0, 0), Math.abs(this.parent().offsetWidth - this.elt.offsetWidth)), i = Math.abs(this.parent().offsetHeight - this.elt.offsetHeight);
                    return "both" === e1 || void 0 === e1 ? this.position(s / 2 + this.parent().offsetLeft, i / 2 + this.parent().offsetTop) : "horizontal" === e1 ? this.position(s / 2 + this.parent().offsetLeft, n.y) : "vertical" === e1 && this.position(n.x, i / 2 + this.parent().offsetTop), this.style("display", t), r && this.hide(), o && this.parent().hide(), this;
                }, f.default.Element.prototype.html = function() {
                    return 0 === arguments.length ? this.elt.innerHTML : (arguments.length <= 1 || !arguments[1] ? this.elt.innerHTML = arguments.length <= 0 ? void 0 : arguments[0] : this.elt.insertAdjacentHTML("beforeend", arguments.length <= 0 ? void 0 : arguments[0]), this);
                }, f.default.Element.prototype.position = function() {
                    return 0 === arguments.length ? {
                        x: this.elt.offsetLeft,
                        y: this.elt.offsetTop
                    } : (this.elt.style.position = "static" !== (arguments.length <= 2 ? void 0 : arguments[2]) && "fixed" !== (arguments.length <= 2 ? void 0 : arguments[2]) && "relative" !== (arguments.length <= 2 ? void 0 : arguments[2]) && "sticky" !== (arguments.length <= 2 ? void 0 : arguments[2]) && "initial" !== (arguments.length <= 2 ? void 0 : arguments[2]) && "inherit" !== (arguments.length <= 2 ? void 0 : arguments[2]) ? "absolute" : arguments.length <= 2 ? void 0 : arguments[2], this.elt.style.left = (arguments.length <= 0 ? void 0 : arguments[0]) + "px", this.elt.style.top = (arguments.length <= 1 ? void 0 : arguments[1]) + "px", this.x = arguments.length <= 0 ? void 0 : arguments[0], this.y = arguments.length <= 1 ? void 0 : arguments[1], this);
                }, f.default.Element.prototype._translate = function() {
                    this.elt.style.position = "absolute";
                    var e1 = "";
                    return this.elt.style.transform && (e1 = (e1 = this.elt.style.transform.replace(/translate3d\(.*\)/g, "")).replace(/translate[X-Z]?\(.*\)/g, "")), 2 === arguments.length ? this.elt.style.transform = "translate(" + (arguments.length <= 0 ? void 0 : arguments[0]) + "px, " + (arguments.length <= 1 ? void 0 : arguments[1]) + "px)" : 2 < arguments.length && (this.elt.style.transform = "translate3d(" + (arguments.length <= 0 ? void 0 : arguments[0]) + "px," + (arguments.length <= 1 ? void 0 : arguments[1]) + "px," + (arguments.length <= 2 ? void 0 : arguments[2]) + "px)", this.elt.parentElement.style.perspective = 3 === arguments.length ? "1000px" : (arguments.length <= 3 ? void 0 : arguments[3]) + "px"), this.elt.style.transform += e1, this;
                }, f.default.Element.prototype._rotate = function() {
                    var e1 = "";
                    return this.elt.style.transform && (e1 = (e1 = this.elt.style.transform.replace(/rotate3d\(.*\)/g, "")).replace(/rotate[X-Z]?\(.*\)/g, "")), 1 === arguments.length ? this.elt.style.transform = "rotate(" + (arguments.length <= 0 ? void 0 : arguments[0]) + "deg)" : 2 === arguments.length ? this.elt.style.transform = "rotate(" + (arguments.length <= 0 ? void 0 : arguments[0]) + "deg, " + (arguments.length <= 1 ? void 0 : arguments[1]) + "deg)" : 3 === arguments.length && (this.elt.style.transform = "rotateX(" + (arguments.length <= 0 ? void 0 : arguments[0]) + "deg)", this.elt.style.transform += "rotateY(" + (arguments.length <= 1 ? void 0 : arguments[1]) + "deg)", this.elt.style.transform += "rotateZ(" + (arguments.length <= 2 ? void 0 : arguments[2]) + "deg)"), this.elt.style.transform += e1, this;
                }, f.default.Element.prototype.style = function(e1, t) {
                    if (void 0 === (t = t instanceof f.default.Color ? "rgba(" + t.levels[0] + "," + t.levels[1] + "," + t.levels[2] + "," + t.levels[3] / 255 + ")" : t)) {
                        if (-1 === e1.indexOf(":")) return window.getComputedStyle(this.elt).getPropertyValue(e1);
                        for(var r = e1.split(";"), o = 0; o < r.length; o++){
                            var n = r[o].split(":");
                            n[0] && n[1] && (this.elt.style[n[0].trim()] = n[1].trim());
                        }
                    } else this.elt.style[e1] = t, "width" !== e1 && "height" !== e1 && "left" !== e1 && "top" !== e1 || (t = window.getComputedStyle(this.elt).getPropertyValue(e1).replace(/[^\d.]/g, ""), this[e1] = Math.round(parseFloat(t, 10)));
                    return this;
                }, f.default.Element.prototype.attribute = function(e1, t) {
                    if (null == this.elt.firstChild || "checkbox" !== this.elt.firstChild.type && "radio" !== this.elt.firstChild.type) return void 0 === t ? this.elt.getAttribute(e1) : (this.elt.setAttribute(e1, t), this);
                    if (void 0 === t) return this.elt.firstChild.getAttribute(e1);
                    for(var r = 0; r < this.elt.childNodes.length; r++)this.elt.childNodes[r].setAttribute(e1, t);
                }, f.default.Element.prototype.removeAttribute = function(e1) {
                    if (null != this.elt.firstChild && ("checkbox" === this.elt.firstChild.type || "radio" === this.elt.firstChild.type)) for(var t = 0; t < this.elt.childNodes.length; t++)this.elt.childNodes[t].removeAttribute(e1);
                    return this.elt.removeAttribute(e1), this;
                }, f.default.Element.prototype.value = function() {
                    return 0 < arguments.length ? (this.elt.value = arguments.length <= 0 ? void 0 : arguments[0], this) : "range" === this.elt.type ? parseFloat(this.elt.value) : this.elt.value;
                }, f.default.Element.prototype.show = function() {
                    return this.elt.style.display = "block", this;
                }, f.default.Element.prototype.hide = function() {
                    return this.elt.style.display = "none", this;
                }, f.default.Element.prototype.size = function(e1, t) {
                    if (0 === arguments.length) return {
                        width: this.elt.offsetWidth,
                        height: this.elt.offsetHeight
                    };
                    var r = e1, o = t, n = f.default.prototype.AUTO;
                    if (r !== n || o !== n) {
                        if (r === n ? r = t * this.width / this.height : o === n && (o = e1 * this.height / this.width), this.elt instanceof HTMLCanvasElement) {
                            var s, i = {}, a = this.elt.getContext("2d");
                            for(s in a)i[s] = a[s];
                            for(s in this.elt.setAttribute("width", r * this._pInst._pixelDensity), this.elt.setAttribute("height", o * this._pInst._pixelDensity), this.elt.style.width = r + "px", this.elt.style.height = o + "px", this._pInst.scale(this._pInst._pixelDensity, this._pInst._pixelDensity), i)this.elt.getContext("2d")[s] = i[s];
                        } else this.elt.style.width = r + "px", this.elt.style.height = o + "px", this.elt.width = r, this.elt.height = o;
                        this.width = r, this.height = o, this._pInst && this._pInst._curElement && this._pInst._curElement.elt === this.elt && (this._pInst._setProperty("width", r), this._pInst._setProperty("height", o));
                    }
                    return this;
                }, f.default.Element.prototype.remove = function() {
                    this instanceof f.default.MediaElement && (this.stop(), null !== (t = this.elt.srcObject) && t.getTracks().forEach(function(e1) {
                        e1.stop();
                    }));
                    var e1, t = this._pInst._elements.indexOf(this);
                    for(e1 in -1 !== t && this._pInst._elements.splice(t, 1), this._events)this.elt.removeEventListener(e1, this._events[e1]);
                    this.elt && this.elt.parentNode && this.elt.parentNode.removeChild(this.elt);
                }, f.default.Element.prototype.drop = function(a, l) {
                    var e1;
                    return window.File && window.FileReader && window.FileList && window.Blob ? (this._dragDisabled || (this._dragDisabled = !0, this.elt.addEventListener("dragover", e1 = function(e1) {
                        e1.preventDefault();
                    }), this.elt.addEventListener("dragleave", e1)), f.default.Element._attachListener("drop", function(e1) {
                        e1.preventDefault(), "function" == typeof l && l.call(this, e1);
                        var e1 = e1.dataTransfer.files, t = !0, r = !1, o = void 0;
                        try {
                            for(var n, s = e1[Symbol.iterator](); !(t = (n = s.next()).done); t = !0){
                                var i = n.value;
                                f.default.File._load(i, a);
                            }
                        } catch (e1) {
                            r = !0, o = e1;
                        } finally{
                            try {
                                t || null == s.return || s.return();
                            } finally{
                                if (r) throw o;
                            }
                        }
                    }, this)) : console.log("The File APIs are not fully supported in this browser."), this;
                }, f.default.Element.prototype.draggable = function(r) {
                    var e1, o = "ontouchstart" in window, n = 0, s = 0, i = 0, a = 0, l = o ? "touchend" : "mouseup", u = o ? "touchmove" : "mousemove";
                    function c(e1) {
                        var t;
                        e1 = e1 || window.event, a = o ? (t = e1.changedTouches, n = i - parseInt(t[0].clientX), s = a - parseInt(t[0].clientY), i = parseInt(t[0].clientX), parseInt(t[0].clientY)) : (n = i - parseInt(e1.clientX), s = a - parseInt(e1.clientY), i = parseInt(e1.clientX), parseInt(e1.clientY)), r.style.left = r.offsetLeft - n + "px", r.style.top = r.offsetTop - s + "px";
                    }
                    function d() {
                        document.removeEventListener(l, d, !1), document.removeEventListener(u, c, !1);
                    }
                    return void 0 === r ? e1 = r = this.elt : r !== this.elt && r.elt !== this.elt && (r = r.elt, e1 = this.elt), e1.addEventListener(o ? "touchstart" : "mousedown", function(e1) {
                        var t;
                        e1 = e1 || window.event, a = o ? (t = e1.changedTouches, i = parseInt(t[0].clientX), parseInt(t[0].clientY)) : (i = parseInt(e1.clientX), parseInt(e1.clientY));
                        return document.addEventListener(l, d, !1), document.addEventListener(u, c, !1), !1;
                    }, !1), e1.style.cursor = "move", this;
                };
                function g(e1, t, r, o) {
                    d(this, g), this.callback = e1, this.time = t, this.id = r, this.val = o;
                }
                t = function(t) {
                    var r = i;
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    r.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: r,
                            writable: !0,
                            configurable: !0
                        }
                    }), t && l(r, t);
                    var s = u(i);
                    function i(o, e1) {
                        d(this, i);
                        var n = c(e1 = s.call(this, o, e1));
                        return e1.elt.crossOrigin = "anonymous", e1._prevTime = 0, e1._cueIDCounter = 0, e1._cues = [], e1.pixels = [], e1._pixelsState = c(e1), e1._pixelDensity = 1, e1._modified = !1, e1._frameOnCanvas = -1, Object.defineProperty(n, "src", {
                            get: function() {
                                var e1 = n.elt.children[0].src, t = n.elt.src === window.location.href ? "" : n.elt.src;
                                return e1 === window.location.href ? t : e1;
                            },
                            set: function(e1) {
                                for(var t = 0; t < n.elt.children.length; t++)n.elt.removeChild(n.elt.children[t]);
                                var r = document.createElement("source");
                                r.src = e1, o.appendChild(r), n.elt.src = e1, n.modified = !0;
                            }
                        }), n._onended = function() {}, n.elt.onended = function() {
                            n._onended(n);
                        }, e1;
                    }
                    return a(i, [
                        {
                            key: "play",
                            value: function() {
                                var e1;
                                return this.elt.currentTime === this.elt.duration && (this.elt.currentTime = 0), 1 < this.elt.readyState || this.elt.load(), (e1 = this.elt.play()) && e1.catch && e1.catch(function(e1) {
                                    "NotAllowedError" === e1.name ? console.error(e1) : console.error("Media play method encountered an unexpected error", e1);
                                }), this;
                            }
                        },
                        {
                            key: "stop",
                            value: function() {
                                return this.elt.pause(), this.elt.currentTime = 0, this;
                            }
                        },
                        {
                            key: "pause",
                            value: function() {
                                return this.elt.pause(), this;
                            }
                        },
                        {
                            key: "loop",
                            value: function() {
                                return this.elt.setAttribute("loop", !0), this.play(), this;
                            }
                        },
                        {
                            key: "noLoop",
                            value: function() {
                                return this.elt.removeAttribute("loop"), this;
                            }
                        },
                        {
                            key: "_setupAutoplayFailDetection",
                            value: function() {
                                var t = setTimeout(function() {
                                    console.error(e);
                                }, 500);
                                this.elt.addEventListener("play", function() {
                                    return clearTimeout(t);
                                }, {
                                    passive: !0,
                                    once: !0
                                });
                            }
                        },
                        {
                            key: "autoplay",
                            value: function(e1) {
                                var t = this, r = this.elt.getAttribute("autoplay");
                                return this.elt.setAttribute("autoplay", e1), e1 && !r && (e1 = function() {
                                    return t._setupAutoplayFailDetection();
                                }, 4 === this.elt.readyState ? e1() : this.elt.addEventListener("canplay", e1, {
                                    passive: !0,
                                    once: !0
                                })), this;
                            }
                        },
                        {
                            key: "volume",
                            value: function(e1) {
                                if (void 0 === e1) return this.elt.volume;
                                this.elt.volume = e1;
                            }
                        },
                        {
                            key: "speed",
                            value: function(e1) {
                                if (void 0 === e1) return this.presetPlaybackRate || this.elt.playbackRate;
                                this.loadedmetadata ? this.elt.playbackRate = e1 : this.presetPlaybackRate = e1;
                            }
                        },
                        {
                            key: "time",
                            value: function(e1) {
                                return void 0 === e1 ? this.elt.currentTime : (this.elt.currentTime = e1, this);
                            }
                        },
                        {
                            key: "duration",
                            value: function() {
                                return this.elt.duration;
                            }
                        },
                        {
                            key: "_ensureCanvas",
                            value: function() {
                                this.canvas || (this.canvas = document.createElement("canvas"), this.drawingContext = this.canvas.getContext("2d"), this.setModified(!0));
                                var e1 = this._frameOnCanvas !== this._pInst.frameCount;
                                this.loadedmetadata && e1 && (this.canvas.width !== this.elt.width && (this.canvas.width = this.elt.width, this.canvas.height = this.elt.height, this.width = this.canvas.width, this.height = this.canvas.height), this.drawingContext.clearRect(0, 0, this.canvas.width, this.canvas.height), !0 === this.flipped && (this.drawingContext.save(), this.drawingContext.scale(-1, 1), this.drawingContext.translate(-this.canvas.width, 0)), this.drawingContext.drawImage(this.elt, 0, 0, this.canvas.width, this.canvas.height), !0 === this.flipped && this.drawingContext.restore(), this.setModified(!0), this._frameOnCanvas = this._pInst.frameCount);
                            }
                        },
                        {
                            key: "loadPixels",
                            value: function() {
                                this._ensureCanvas();
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                return f.default.Renderer2D.prototype.loadPixels.apply(this, t);
                            }
                        },
                        {
                            key: "updatePixels",
                            value: function(e1, t, r, o) {
                                return this.loadedmetadata && (this._ensureCanvas(), f.default.Renderer2D.prototype.updatePixels.call(this, e1, t, r, o)), this.setModified(!0), this;
                            }
                        },
                        {
                            key: "get",
                            value: function() {
                                this._ensureCanvas();
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                return f.default.Renderer2D.prototype.get.apply(this, t);
                            }
                        },
                        {
                            key: "_getPixel",
                            value: function() {
                                this.loadPixels();
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                return f.default.Renderer2D.prototype._getPixel.apply(this, t);
                            }
                        },
                        {
                            key: "set",
                            value: function(e1, t, r) {
                                this.loadedmetadata && (this._ensureCanvas(), f.default.Renderer2D.prototype.set.call(this, e1, t, r), this.setModified(!0));
                            }
                        },
                        {
                            key: "copy",
                            value: function() {
                                this._ensureCanvas();
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                f.default.prototype.copy.apply(this, t);
                            }
                        },
                        {
                            key: "mask",
                            value: function() {
                                this.loadPixels(), this.setModified(!0);
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                f.default.Image.prototype.mask.apply(this, t);
                            }
                        },
                        {
                            key: "isModified",
                            value: function() {
                                return this._modified;
                            }
                        },
                        {
                            key: "setModified",
                            value: function(e1) {
                                this._modified = e1;
                            }
                        },
                        {
                            key: "onended",
                            value: function(e1) {
                                return this._onended = e1, this;
                            }
                        },
                        {
                            key: "connect",
                            value: function(e1) {
                                var t, r;
                                if ("function" == typeof f.default.prototype.getAudioContext) t = f.default.prototype.getAudioContext(), r = f.default.soundOut.input;
                                else try {
                                    r = (t = e1.context).destination;
                                } catch (e1) {
                                    throw "connect() is meant to be used with Web Audio API or p5.sound.js";
                                }
                                this.audioSourceNode || (this.audioSourceNode = t.createMediaElementSource(this.elt), this.audioSourceNode.connect(r)), e1 ? e1.input ? this.audioSourceNode.connect(e1.input) : this.audioSourceNode.connect(e1) : this.audioSourceNode.connect(r);
                            }
                        },
                        {
                            key: "disconnect",
                            value: function() {
                                if (!this.audioSourceNode) throw "nothing to disconnect";
                                this.audioSourceNode.disconnect();
                            }
                        },
                        {
                            key: "showControls",
                            value: function() {
                                this.elt.style["text-align"] = "inherit", this.elt.controls = !0;
                            }
                        },
                        {
                            key: "hideControls",
                            value: function() {
                                this.elt.controls = !1;
                            }
                        },
                        {
                            key: "addCue",
                            value: function(e1, t, r) {
                                var o = this._cueIDCounter++, t = new g(t, e1, o, r);
                                return this._cues.push(t), this.elt.ontimeupdate || (this.elt.ontimeupdate = this._onTimeUpdate.bind(this)), o;
                            }
                        },
                        {
                            key: "removeCue",
                            value: function(e1) {
                                for(var t = 0; t < this._cues.length; t++)this._cues[t].id === e1 && (console.log(e1), this._cues.splice(t, 1));
                                0 === this._cues.length && (this.elt.ontimeupdate = null);
                            }
                        },
                        {
                            key: "clearCues",
                            value: function() {
                                this._cues = [], this.elt.ontimeupdate = null;
                            }
                        },
                        {
                            key: "_onTimeUpdate",
                            value: function() {
                                for(var e1 = this.time(), t = 0; t < this._cues.length; t++){
                                    var r = this._cues[t].time, o = this._cues[t].val;
                                    this._prevTime < r && r <= e1 && this._cues[t].callback(o);
                                }
                                this._prevTime = e1;
                            }
                        }
                    ]), i;
                }(f.default.Element), f.default.MediaElement = t, t = function() {
                    function r(e1, t) {
                        d(this, r), this.file = e1, this._pInst = t;
                        t = e1.type.split("/");
                        this.type = t[0], this.subtype = t[1], this.name = e1.name, this.size = e1.size, this.data = void 0;
                    }
                    return a(r, null, [
                        {
                            key: "_createLoader",
                            value: function(o, n) {
                                var e1 = new FileReader;
                                return e1.onload = function(e1) {
                                    var t, r = new f.default.File(o);
                                    "application/json" === r.file.type ? r.data = JSON.parse(e1.target.result) : "text/xml" === r.file.type ? (t = (new DOMParser).parseFromString(e1.target.result, "text/xml"), r.data = new f.default.XML(t.documentElement)) : r.data = e1.target.result, n(r);
                                }, e1;
                            }
                        },
                        {
                            key: "_load",
                            value: function(e1, t) {
                                var r;
                                /^text\//.test(e1.type) || "application/json" === e1.type ? f.default.File._createLoader(e1, t).readAsText(e1) : /^(video|audio)\//.test(e1.type) ? ((r = new f.default.File(e1)).data = URL.createObjectURL(e1), t(r)) : f.default.File._createLoader(e1, t).readAsDataURL(e1);
                            }
                        }
                    ]), r;
                }(), f.default.File = t, t = f.default;
                o.default = t;
            },
            {
                "../core/main": 283,
                "core-js/modules/es.array.every": 155,
                "core-js/modules/es.array.filter": 157,
                "core-js/modules/es.array.for-each": 161,
                "core-js/modules/es.array.from": 162,
                "core-js/modules/es.array.index-of": 164,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.map": 168,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.array.splice": 171,
                "core-js/modules/es.function.name": 174,
                "core-js/modules/es.object.assign": 183,
                "core-js/modules/es.object.get-prototype-of": 188,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.promise": 191,
                "core-js/modules/es.reflect.construct": 192,
                "core-js/modules/es.regexp.exec": 195,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.string.replace": 204,
                "core-js/modules/es.string.split": 206,
                "core-js/modules/es.string.trim": 209,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/web.dom-collections.for-each": 245,
                "core-js/modules/web.dom-collections.iterator": 246,
                "core-js/modules/web.url": 248
            }
        ],
        300: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var o = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                o.default.prototype.deviceOrientation = 1 < window.innerWidth / window.innerHeight ? "landscape" : "portrait", o.default.prototype.accelerationX = 0, o.default.prototype.accelerationY = 0, o.default.prototype.accelerationZ = 0, o.default.prototype.pAccelerationX = 0, o.default.prototype.pAccelerationY = 0, o.default.prototype.pAccelerationZ = 0, o.default.prototype._updatePAccelerations = function() {
                    this._setProperty("pAccelerationX", this.accelerationX), this._setProperty("pAccelerationY", this.accelerationY), this._setProperty("pAccelerationZ", this.accelerationZ);
                }, o.default.prototype.rotationX = 0, o.default.prototype.rotationY = 0, o.default.prototype.rotationZ = 0, o.default.prototype.pRotationX = 0, o.default.prototype.pRotationY = 0;
                var i = o.default.prototype.pRotationZ = 0, a = 0, l = 0, u = "clockwise", c = "clockwise", d = "clockwise", h = (o.default.prototype.pRotateDirectionX = void 0, o.default.prototype.pRotateDirectionY = void 0, o.default.prototype.pRotateDirectionZ = void 0, o.default.prototype._updatePRotations = function() {
                    this._setProperty("pRotationX", this.rotationX), this._setProperty("pRotationY", this.rotationY), this._setProperty("pRotationZ", this.rotationZ);
                }, o.default.prototype.turnAxis = void 0, .5), f = 30, e1 = (o.default.prototype.setMoveThreshold = function(e1) {
                    o.default._validateParameters("setMoveThreshold", arguments), h = e1;
                }, o.default.prototype.setShakeThreshold = function(e1) {
                    o.default._validateParameters("setShakeThreshold", arguments), f = e1;
                }, o.default.prototype._ondeviceorientation = function(e1) {
                    this._updatePRotations(), this._setProperty("rotationX", this._fromDegrees(e1.beta)), this._setProperty("rotationY", this._fromDegrees(e1.gamma)), this._setProperty("rotationZ", this._fromDegrees(e1.alpha)), this._handleMotion();
                }, o.default.prototype._ondevicemotion = function(e1) {
                    this._updatePAccelerations(), this._setProperty("accelerationX", 2 * e1.acceleration.x), this._setProperty("accelerationY", 2 * e1.acceleration.y), this._setProperty("accelerationZ", 2 * e1.acceleration.z), this._handleMotion();
                }, o.default.prototype._handleMotion = function() {
                    90 === window.orientation || -90 === window.orientation ? this._setProperty("deviceOrientation", "landscape") : 0 === window.orientation ? this._setProperty("deviceOrientation", "portrait") : void 0 === window.orientation && this._setProperty("deviceOrientation", "undefined");
                    var e1, t, r, o, n, s = this._isGlobal ? window : this;
                    "function" == typeof s.deviceMoved && (Math.abs(this.accelerationX - this.pAccelerationX) > h || Math.abs(this.accelerationY - this.pAccelerationY) > h || Math.abs(this.accelerationZ - this.pAccelerationZ) > h) && s.deviceMoved(), "function" == typeof s.deviceTurned && (t = this._toDegrees(this.rotationX) + 180, r = this._toDegrees(this.pRotationX) + 180, e1 = i + 180, 0 < t - r && t - r < 270 || t - r < -270 ? u = "clockwise" : (t - r < 0 || 270 < t - r) && (u = "counter-clockwise"), u !== this.pRotateDirectionX && (e1 = t), 90 < Math.abs(t - e1) && Math.abs(t - e1) < 270 && (e1 = t, this._setProperty("turnAxis", "X"), s.deviceTurned()), this.pRotateDirectionX = u, i = e1 - 180, r = this._toDegrees(this.rotationY) + 180, t = this._toDegrees(this.pRotationY) + 180, e1 = a + 180, 0 < r - t && r - t < 270 || r - t < -270 ? c = "clockwise" : (r - t < 0 || 270 < r - this.pRotationY) && (c = "counter-clockwise"), c !== this.pRotateDirectionY && (e1 = r), 90 < Math.abs(r - e1) && Math.abs(r - e1) < 270 && (e1 = r, this._setProperty("turnAxis", "Y"), s.deviceTurned()), this.pRotateDirectionY = c, a = e1 - 180, 0 < (t = this._toDegrees(this.rotationZ)) - (r = this._toDegrees(this.pRotationZ)) && t - r < 270 || t - r < -270 ? d = "clockwise" : (t - r < 0 || 270 < t - r) && (d = "counter-clockwise"), d !== this.pRotateDirectionZ && (l = t), 90 < Math.abs(t - l) && Math.abs(t - l) < 270 && (l = t, this._setProperty("turnAxis", "Z"), s.deviceTurned()), this.pRotateDirectionZ = d, this._setProperty("turnAxis", void 0)), "function" == typeof s.deviceShaken && (null !== this.pAccelerationX && (o = Math.abs(this.accelerationX - this.pAccelerationX), n = Math.abs(this.accelerationY - this.pAccelerationY)), f < o + n && s.deviceShaken());
                }, o.default);
                r.default = e1;
            },
            {
                "../core/main": 283
            }
        ],
        301: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.string.repeat"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.string.repeat"), e1("core-js/modules/web.dom-collections.for-each"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var o = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                o.default.prototype.isKeyPressed = !1, o.default.prototype.keyIsPressed = !1, o.default.prototype.key = "", o.default.prototype.keyCode = 0, o.default.prototype._onkeydown = function(e1) {
                    var t;
                    e1.repeat ? this._setProperty("isKeyRepeated", !0) : (this._setProperty("isKeyRepeated", !1), this._setProperty("isKeyPressed", !0), this._setProperty("keyIsPressed", !0), this._setProperty("keyCode", e1.which), this._downKeys[e1.which] = !0, this._setProperty("key", e1.key || String.fromCharCode(e1.which) || e1.which), e1.metaKey && (this._metaKeys || (this._metaKeys = []), this._metaKeys.push(e1.which)), "function" != typeof (t = this._isGlobal ? window : this).keyPressed || e1.charCode || !1 === t.keyPressed(e1) && e1.preventDefault());
                }, o.default.prototype._onkeyup = function(e1) {
                    var t = this, r = (this._setProperty("isKeyPressed", !1), this._setProperty("keyIsPressed", !1), this._setProperty("_lastKeyCodePressed", this._keyCode), this._downKeys[e1.which] = !1, "Meta" === e1.key && this._metaKeys && (this._metaKeys.forEach(function(e1) {
                        t._downKeys[e1] = !1;
                    }), this._metaKeys = []), this._isGlobal ? window : this);
                    "function" == typeof r.keyReleased && !1 === r.keyReleased(e1) && e1.preventDefault();
                }, o.default.prototype._onkeypress = function(e1) {
                    var t;
                    e1.which === this._lastKeyCodeTyped && this.isKeyRepeated || (this._setProperty("_lastKeyCodeTyped", e1.which), this._setProperty("key", e1.key || String.fromCharCode(e1.which) || e1.which), "function" == typeof (t = this._isGlobal ? window : this).keyTyped && !1 === t.keyTyped(e1) && e1.preventDefault());
                }, o.default.prototype._onblur = function(e1) {
                    this._downKeys = {};
                }, o.default.prototype.keyIsDown = function(e1) {
                    return o.default._validateParameters("keyIsDown", arguments), this._downKeys[e1] || !1;
                }, o.default.prototype._areDownKeys = function() {
                    for(var e1 in this._downKeys)if (this._downKeys.hasOwnProperty(e1) && !0 === this._downKeys[e1]) return !0;
                    return !1;
                };
                e1 = o.default;
                r.default = e1;
            },
            {
                "../core/main": 283,
                "core-js/modules/es.array.for-each": 161,
                "core-js/modules/es.string.repeat": 203,
                "core-js/modules/web.dom-collections.for-each": 245
            }
        ],
        302: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                }, s = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                n.default.prototype.movedX = 0, n.default.prototype.movedY = 0, n.default.prototype._hasMouseInteracted = !1, n.default.prototype.mouseX = 0, n.default.prototype.mouseY = 0, n.default.prototype.pmouseX = 0, n.default.prototype.pmouseY = 0, n.default.prototype.winMouseX = 0, n.default.prototype.winMouseY = 0, n.default.prototype.pwinMouseX = 0, n.default.prototype.pwinMouseY = 0, n.default.prototype.mouseButton = 0, n.default.prototype.mouseIsPressed = !1, n.default.prototype._updateNextMouseCoords = function(e1) {
                    var t, r, o, n, s;
                    null !== this._curElement && (!e1.touches || 0 < e1.touches.length) && (t = this._curElement.elt, r = this.width, o = this.height, (n = e1) && !n.clientX && (n.touches ? n = n.touches[0] : n.changedTouches && (n = n.changedTouches[0])), s = t.getBoundingClientRect(), r = t.scrollWidth / r || 1, t = t.scrollHeight / o || 1, o = {
                        x: (n.clientX - s.left) / r,
                        y: (n.clientY - s.top) / t,
                        winX: n.clientX,
                        winY: n.clientY,
                        id: n.identifier
                    }, this._setProperty("mouseX", o.x), this._setProperty("mouseY", o.y), this._setProperty("winMouseX", o.winX), this._setProperty("winMouseY", o.winY), null === document.pointerLockElement ? (r = this.mouseX - this.pmouseX, s = this.mouseY - this.pmouseY, this._setProperty("movedX", r), this._setProperty("movedY", s)) : (this._setProperty("movedX", e1.movementX), this._setProperty("movedY", e1.movementY))), this._hasMouseInteracted || (this._updateMouseCoords(), this._setProperty("_hasMouseInteracted", !0));
                }, n.default.prototype._updateMouseCoords = function() {
                    this._setProperty("pmouseX", this.mouseX), this._setProperty("pmouseY", this.mouseY), this._setProperty("pwinMouseX", this.winMouseX), this._setProperty("pwinMouseY", this.winMouseY), this._setProperty("_pmouseWheelDeltaY", this._mouseWheelDeltaY);
                }, n.default.prototype._setMouseButton = function(e1) {
                    1 === e1.button ? this._setProperty("mouseButton", s.CENTER) : 2 === e1.button ? this._setProperty("mouseButton", s.RIGHT) : this._setProperty("mouseButton", s.LEFT);
                }, n.default.prototype._onmousemove = function(e1) {
                    var t = this._isGlobal ? window : this;
                    this._updateNextMouseCoords(e1), this.mouseIsPressed ? "function" == typeof t.mouseDragged ? !1 === t.mouseDragged(e1) && e1.preventDefault() : "function" == typeof t.touchMoved && !1 === t.touchMoved(e1) && e1.preventDefault() : "function" == typeof t.mouseMoved && !1 === t.mouseMoved(e1) && e1.preventDefault();
                }, n.default.prototype._onmousedown = function(e1) {
                    var t = this._isGlobal ? window : this;
                    this._setProperty("mouseIsPressed", !0), this._setMouseButton(e1), this._updateNextMouseCoords(e1), this.touchstart || ("function" == typeof t.mousePressed ? !1 === t.mousePressed(e1) && e1.preventDefault() : "function" == typeof t.touchStarted && !1 === t.touchStarted(e1) && e1.preventDefault(), this.touchstart = !1);
                }, n.default.prototype._onmouseup = function(e1) {
                    var t = this._isGlobal ? window : this;
                    this._setProperty("mouseIsPressed", !1), this.touchend || ("function" == typeof t.mouseReleased ? !1 === t.mouseReleased(e1) && e1.preventDefault() : "function" == typeof t.touchEnded && !1 === t.touchEnded(e1) && e1.preventDefault(), this.touchend = !1);
                }, n.default.prototype._ondragend = n.default.prototype._onmouseup, n.default.prototype._ondragover = n.default.prototype._onmousemove, n.default.prototype._onclick = function(e1) {
                    var t = this._isGlobal ? window : this;
                    "function" == typeof t.mouseClicked && !1 === t.mouseClicked(e1) && e1.preventDefault();
                }, n.default.prototype._ondblclick = function(e1) {
                    var t = this._isGlobal ? window : this;
                    "function" == typeof t.doubleClicked && !1 === t.doubleClicked(e1) && e1.preventDefault();
                }, n.default.prototype._mouseWheelDeltaY = 0, n.default.prototype._pmouseWheelDeltaY = 0, n.default.prototype._onwheel = function(e1) {
                    var t = this._isGlobal ? window : this;
                    this._setProperty("_mouseWheelDeltaY", e1.deltaY), "function" == typeof t.mouseWheel && (e1.delta = e1.deltaY, !1 === t.mouseWheel(e1) && e1.preventDefault());
                }, n.default.prototype.requestPointerLock = function() {
                    var e1 = this._curElement.elt;
                    return e1.requestPointerLock = e1.requestPointerLock || e1.mozRequestPointerLock, e1.requestPointerLock ? (e1.requestPointerLock(), !0) : (console.log("requestPointerLock is not implemented in this browser"), !1);
                }, n.default.prototype.exitPointerLock = function() {
                    document.exitPointerLock();
                };
                e1 = n.default;
                r.default = e1;
            },
            {
                "../core/constants": 272,
                "../core/main": 283,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        303: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                e1.default.prototype.touches = [], e1.default.prototype._updateTouchCoords = function(e1) {
                    if (null !== this._curElement) {
                        for(var t = [], r = 0; r < e1.touches.length; r++)t[r] = function(e1, t, r, o) {
                            var n = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, s = e1.getBoundingClientRect(), t = e1.scrollWidth / t || 1, e1 = e1.scrollHeight / r || 1, r = o.touches[n] || o.changedTouches[n];
                            return {
                                x: (r.clientX - s.left) / t,
                                y: (r.clientY - s.top) / e1,
                                winX: r.clientX,
                                winY: r.clientY,
                                id: r.identifier
                            };
                        }(this._curElement.elt, this.width, this.height, e1, r);
                        this._setProperty("touches", t);
                    }
                }, e1.default.prototype._ontouchstart = function(e1) {
                    var t = this._isGlobal ? window : this;
                    this._setProperty("mouseIsPressed", !0), this._updateTouchCoords(e1), this._updateNextMouseCoords(e1), this._updateMouseCoords(), "function" == typeof t.touchStarted && (!1 === t.touchStarted(e1) && e1.preventDefault(), this.touchstart = !0);
                }, e1.default.prototype._ontouchmove = function(e1) {
                    var t = this._isGlobal ? window : this;
                    this._updateTouchCoords(e1), this._updateNextMouseCoords(e1), "function" == typeof t.touchMoved ? !1 === t.touchMoved(e1) && e1.preventDefault() : "function" == typeof t.mouseDragged && !1 === t.mouseDragged(e1) && e1.preventDefault();
                }, e1.default.prototype._ontouchend = function(e1) {
                    this._setProperty("mouseIsPressed", !1), this._updateTouchCoords(e1), this._updateNextMouseCoords(e1);
                    var t = this._isGlobal ? window : this;
                    "function" == typeof t.touchEnded && (!1 === t.touchEnded(e1) && e1.preventDefault(), this.touchend = !0);
                };
                e1 = e1.default;
                r.default = e1;
            },
            {
                "../core/main": 283
            }
        ],
        304: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.typed-array.int32-array"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.typed-array.int32-array"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var U, N, B, G, V = {
                    _toPixels: function(e1) {
                        var t, r;
                        return e1 instanceof ImageData ? e1.data : e1.getContext("2d") ? e1.getContext("2d").getImageData(0, 0, e1.width, e1.height).data : e1.getContext("webgl") ? (r = (t = e1.getContext("webgl")).drawingBufferWidth * t.drawingBufferHeight * 4, r = new Uint8Array(r), t.readPixels(0, 0, e1.width, e1.height, t.RGBA, t.UNSIGNED_BYTE, r), r) : void 0;
                    },
                    _getARGB: function(e1, t) {
                        t *= 4;
                        return e1[3 + t] << 24 & 4278190080 | e1[t] << 16 & 16711680 | e1[1 + t] << 8 & 65280 | 255 & e1[2 + t];
                    },
                    _setPixels: function(e1, t) {
                        for(var r, o = 0, n = e1.length; o < n; o++)e1[0 + (r = 4 * o)] = (16711680 & t[o]) >>> 16, e1[1 + r] = (65280 & t[o]) >>> 8, e1[2 + r] = 255 & t[o], e1[3 + r] = (4278190080 & t[o]) >>> 24;
                    },
                    _toImageData: function(e1) {
                        return e1 instanceof ImageData ? e1 : e1.getContext("2d").getImageData(0, 0, e1.width, e1.height);
                    },
                    _createImageData: function(e1, t) {
                        return V._tmpCanvas = document.createElement("canvas"), V._tmpCtx = V._tmpCanvas.getContext("2d"), this._tmpCtx.createImageData(e1, t);
                    },
                    apply: function(e1, t, r) {
                        var o = e1.getContext("2d"), n = o.getImageData(0, 0, e1.width, e1.height), t = t(n, r);
                        t instanceof ImageData ? o.putImageData(t, 0, 0, 0, 0, e1.width, e1.height) : o.putImageData(n, 0, 0, 0, 0, e1.width, e1.height);
                    },
                    threshold: function(e1) {
                        for(var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : .5, r = V._toPixels(e1), o = Math.floor(255 * t), n = 0; n < r.length; n += 4){
                            var s = void 0, s = o <= .2126 * r[n] + .7152 * r[n + 1] + .0722 * r[n + 2] ? 255 : 0;
                            r[n] = r[n + 1] = r[n + 2] = s;
                        }
                    },
                    gray: function(e1) {
                        for(var t = V._toPixels(e1), r = 0; r < t.length; r += 4){
                            var o = t[r], n = t[r + 1], s = t[r + 2];
                            t[r] = t[r + 1] = t[r + 2] = .2126 * o + .7152 * n + .0722 * s;
                        }
                    },
                    opaque: function(e1) {
                        for(var t = V._toPixels(e1), r = 0; r < t.length; r += 4)t[r + 3] = 255;
                        return t;
                    },
                    invert: function(e1) {
                        for(var t = V._toPixels(e1), r = 0; r < t.length; r += 4)t[r] = 255 - t[r], t[r + 1] = 255 - t[r + 1], t[r + 2] = 255 - t[r + 2];
                    },
                    posterize: function(e1) {
                        var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 4, r = V._toPixels(e1);
                        if (t < 2 || 255 < t) throw new Error("Level must be greater than 2 and less than 255 for posterize");
                        for(var o = t - 1, n = 0; n < r.length; n += 4){
                            var s = r[n], i = r[n + 1], a = r[n + 2];
                            r[n] = 255 * (s * t >> 8) / o, r[n + 1] = 255 * (i * t >> 8) / o, r[n + 2] = 255 * (a * t >> 8) / o;
                        }
                    },
                    dilate: function(e1) {
                        for(var t, r, o, n, s, i, a, l, u, c = V._toPixels(e1), d = 0, h = c.length ? c.length / 4 : 0, f = new Int32Array(h); d < h;)for(r = (t = d) + e1.width; d < r;)n = o = V._getARGB(c, d), (u = d - 1) < t && (u = d), r <= (l = d + 1) && (l = d), (s = d - e1.width) < 0 && (s = 0), h <= (i = d + e1.width) && (i = d), s = V._getARGB(c, s), u = V._getARGB(c, u), i = V._getARGB(c, i), (n = 77 * (n >> 16 & 255) + 151 * (n >> 8 & 255) + 28 * (255 & n)) < (a = 77 * (u >> 16 & 255) + 151 * (u >> 8 & 255) + 28 * (255 & u)) && (o = u, n = a), n < (a = 77 * ((u = V._getARGB(c, l)) >> 16 & 255) + 151 * (u >> 8 & 255) + 28 * (255 & u)) && (o = u, n = a), n < (l = 77 * (s >> 16 & 255) + 151 * (s >> 8 & 255) + 28 * (255 & s)) && (o = s, n = l), n < (u = 77 * (i >> 16 & 255) + 151 * (i >> 8 & 255) + 28 * (255 & i)) && (o = i, n = u), f[d++] = o;
                        V._setPixels(c, f);
                    },
                    erode: function(e1) {
                        for(var t, r, o, n, s, i, a, l, u, c = V._toPixels(e1), d = 0, h = c.length ? c.length / 4 : 0, f = new Int32Array(h); d < h;)for(r = (t = d) + e1.width; d < r;)n = o = V._getARGB(c, d), (u = d - 1) < t && (u = d), r <= (l = d + 1) && (l = d), (s = d - e1.width) < 0 && (s = 0), h <= (i = d + e1.width) && (i = d), s = V._getARGB(c, s), u = V._getARGB(c, u), i = V._getARGB(c, i), (a = 77 * (u >> 16 & 255) + 151 * (u >> 8 & 255) + 28 * (255 & u)) < (n = 77 * (n >> 16 & 255) + 151 * (n >> 8 & 255) + 28 * (255 & n)) && (o = u, n = a), (a = 77 * ((u = V._getARGB(c, l)) >> 16 & 255) + 151 * (u >> 8 & 255) + 28 * (255 & u)) < n && (o = u, n = a), (l = 77 * (s >> 16 & 255) + 151 * (s >> 8 & 255) + 28 * (255 & s)) < n && (o = s, n = l), (u = 77 * (i >> 16 & 255) + 151 * (i >> 8 & 255) + 28 * (255 & i)) < n && (o = i, n = u), f[d++] = o;
                        V._setPixels(c, f);
                    },
                    blur: function(e1, D) {
                        for(var t, r, o, n, s, i, a, l, u, c, d = V._toPixels(e1), h = e1.width, f = e1.height, p = h * f, m = new Int32Array(p), y = 0; y < p; y++)m[y] = V._getARGB(d, y);
                        var g, v, b, _, j, x, w, S, T = new Int32Array(p), E = new Int32Array(p), M = new Int32Array(p), F = new Int32Array(p), k = 0, O = 3.5 * D | 0;
                        if (U !== (O = O < 1 ? 1 : O < 248 ? O : 248)) {
                            N = 1 + (U = O) << 1, B = new Int32Array(N), G = new Array(N);
                            for(var C = 0; C < N; C++)G[C] = new Int32Array(256);
                            for(var P = 1, A = O - 1; P < O; P++){
                                B[O + P] = B[A] = x = A * A, w = G[O + P], S = G[A--];
                                for(var L = 0; L < 256; L++)w[L] = S[L] = x * L;
                            }
                            j = B[O] = O * O, w = G[O];
                            for(var R = 0; R < 256; R++)w[R] = j * R;
                        }
                        for(v = 0; v < f; v++){
                            for(g = 0; g < h; g++){
                                if (n = o = r = s = t = 0, (i = g - U) < 0) c = -i, i = 0;
                                else {
                                    if (h <= i) break;
                                    c = 0;
                                }
                                for(b = c; b < N && !(h <= i); b++){
                                    var I = m[i + k];
                                    _ = G[b], s += _[(-16777216 & I) >>> 24], r += _[(16711680 & I) >> 16], o += _[(65280 & I) >> 8], n += _[255 & I], t += B[b], i++;
                                }
                                T[a = k + g] = s / t, E[a] = r / t, M[a] = o / t, F[a] = n / t;
                            }
                            k += h;
                        }
                        for(u = (l = -U) * h, v = k = 0; v < f; v++){
                            for(g = 0; g < h; g++){
                                if (n = o = r = s = t = 0, l < 0) c = a = -l, i = g;
                                else {
                                    if (f <= l) break;
                                    c = 0, a = l, i = g + u;
                                }
                                for(b = c; b < N && !(f <= a); b++)_ = G[b], s += _[T[i]], r += _[E[i]], o += _[M[i]], n += _[F[i]], t += B[b], a++, i += h;
                                m[g + k] = s / t << 24 | r / t << 16 | o / t << 8 | n / t;
                            }
                            k += h, u += h, l++;
                        }
                        V._setPixels(d, m);
                    }
                };
                r.default = V;
            },
            {
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.typed-array.copy-within": 213,
                "core-js/modules/es.typed-array.every": 214,
                "core-js/modules/es.typed-array.fill": 215,
                "core-js/modules/es.typed-array.filter": 216,
                "core-js/modules/es.typed-array.find": 218,
                "core-js/modules/es.typed-array.find-index": 217,
                "core-js/modules/es.typed-array.for-each": 221,
                "core-js/modules/es.typed-array.includes": 222,
                "core-js/modules/es.typed-array.index-of": 223,
                "core-js/modules/es.typed-array.int32-array": 225,
                "core-js/modules/es.typed-array.iterator": 226,
                "core-js/modules/es.typed-array.join": 227,
                "core-js/modules/es.typed-array.last-index-of": 228,
                "core-js/modules/es.typed-array.map": 229,
                "core-js/modules/es.typed-array.reduce": 231,
                "core-js/modules/es.typed-array.reduce-right": 230,
                "core-js/modules/es.typed-array.reverse": 232,
                "core-js/modules/es.typed-array.set": 233,
                "core-js/modules/es.typed-array.slice": 234,
                "core-js/modules/es.typed-array.some": 235,
                "core-js/modules/es.typed-array.sort": 236,
                "core-js/modules/es.typed-array.subarray": 237,
                "core-js/modules/es.typed-array.to-locale-string": 238,
                "core-js/modules/es.typed-array.to-string": 239,
                "core-js/modules/es.typed-array.uint8-array": 242
            }
        ],
        305: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.set"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.uint32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.set"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.uint32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var O = o(e1("../core/main")), C = o(e1("omggif"));
                function o(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function P(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                O.default.prototype.createImage = function(e1, t) {
                    return O.default._validateParameters("createImage", arguments), new O.default.Image(e1, t);
                }, O.default.prototype.saveCanvas = function() {
                    for(var e1, t, r, o, n, s, i = arguments.length, a = new Array(i), l = 0; l < i; l++)a[l] = arguments[l];
                    switch(O.default._validateParameters("saveCanvas", a), a[0] instanceof HTMLCanvasElement ? (e1 = a[0], a.shift()) : a[0] instanceof O.default.Element ? (e1 = a[0].elt, a.shift()) : a[0] instanceof O.default.Framebuffer ? (o = a[0], (n = this.createGraphics(o.width, o.height)).pixelDensity(pixelDensity()), o.loadPixels(), n.loadPixels(), n.pixels.set(o.pixels), n.updatePixels(), e1 = n.elt, a.shift()) : e1 = this._curElement && this._curElement.elt, 1 <= a.length && (t = a[0]), r = (r = 2 <= a.length ? a[1] : r) || O.default.prototype._checkFileExtension(t, r)[1] || "png"){
                        default:
                            s = "image/png";
                            break;
                        case "webp":
                            s = "image/webp";
                            break;
                        case "jpeg":
                        case "jpg":
                            s = "image/jpeg";
                    }
                    e1.toBlob(function(e1) {
                        O.default.prototype.downloadFile(e1, t, r), n && n.remove();
                    }, s);
                }, O.default.prototype.encodeAndDownloadGif = function(d, e1) {
                    for(var h = d.gifProperties, t = h.loopLimit, r = (1 === t ? t = null : null === t && (t = 0), new Uint8Array(d.width * d.height * h.numFrames)), f = [], o = {}, n = 0; n < h.numFrames; n++){
                        for(var s = new Set, i = h.frames[n].image.data, a = i.length, l = new Uint32Array(d.width * d.height), u = 0, c = 0; u < a; u += 4, c++){
                            var p = i[u + 0] << 16 | i[u + 1] << 8 | i[u + 2] << 0;
                            s.add(p), l[c] = p;
                        }
                        var m = P(s).sort().toString();
                        void 0 === o[m] ? o[m] = {
                            freq: 1,
                            frames: [
                                n
                            ]
                        } : (o[m].freq += 1, o[m].frames.push(n)), f.push(l);
                    }
                    for(var y = [], g = Object.keys(o).sort(function(e1, t) {
                        return o[t].freq - o[e1].freq;
                    }), v = g[0].split(",").map(function(e1) {
                        return parseInt(e1);
                    }), y = y.concat(o[v].frames), b = new Set(v), _ = 1; _ < g.length; _++){
                        var j = g[_].split(",").map(function(e1) {
                            return parseInt(e1);
                        }).filter(function(e1) {
                            return !b.has(e1);
                        });
                        if (v.length + j.length <= 256) {
                            for(var x = 0; x < j.length; x++)v.push(j[x]), b.add(j[x]);
                            y = y.concat(o[g[_]].frames);
                        }
                    }
                    y = new Set(y);
                    for(var w = {}, S = 0; S < v.length; S++)w[v[S]] || (w[v[S]] = S);
                    for(var T = 1; T < v.length;)T <<= 1;
                    v.length = T;
                    for(var t = {
                        loop: t,
                        palette: new Uint32Array(v)
                    }, E = new C.default.GifWriter(r, d.width, d.height, t), M = {}, k = 0; k < h.numFrames; k++)!function(r) {
                        var o = !y.has(r), n = o ? [] : v, s = new Uint8Array(d.width * d.height), i = {}, a = new Set, e1 = (f[r].forEach(function(e1, t) {
                            o ? (void 0 === i[e1] && (i[e1] = n.length, n.push(e1)), s[t] = i[e1]) : s[t] = w[e1], 0 < r && f[r - 1][t] !== e1 && a.add(e1);
                        }), {}), t = n.filter(function(e1) {
                            return !a.has(e1);
                        });
                        if (0 < t.length) {
                            var t = t[0], l = (o ? i : w)[t];
                            if (0 < r) {
                                for(var u = 0; u < f[r].length; u++)f[r - 1][u] === f[r][u] && (s[u] = l);
                                e1.transparent = l, M.frameOpts.disposal = 1;
                            }
                        }
                        if (e1.delay = h.frames[r].delay / 10, o) {
                            for(var c = 1; c < n.length;)c <<= 1;
                            n.length = c, e1.palette = new Uint32Array(n);
                        }
                        0 < r && E.addFrame(0, 0, d.width, d.height, M.pixelPaletteIndex, M.frameOpts), M = {
                            pixelPaletteIndex: s,
                            frameOpts: e1
                        };
                    }(k);
                    M.frameOpts.disposal = 1, E.addFrame(0, 0, d.width, d.height, M.pixelPaletteIndex, M.frameOpts);
                    t = new Blob([
                        r.slice(0, E.end())
                    ], {
                        type: "image/gif"
                    });
                    O.default.prototype.downloadFile(t, e1, "gif");
                }, O.default.prototype.saveFrames = function(e1, t, r, o, n) {
                    O.default._validateParameters("saveFrames", arguments);
                    r = O.default.prototype.constrain(r = r || 3, 0, 15);
                    r *= 1e3;
                    var o = O.default.prototype.constrain(o || 15, 0, 22), s = 0, i = O.default.prototype._makeFrame, a = this._curElement.elt, l = [], u = setInterval(function() {
                        l.push(i(e1 + s, t, a)), s++;
                    }, 1e3 / o);
                    setTimeout(function() {
                        if (clearInterval(u), n) n(l);
                        else for(var e1 = 0, t = l; e1 < t.length; e1++){
                            var r = t[e1];
                            O.default.prototype.downloadFile(r.imageData, r.filename, r.ext);
                        }
                        l = [];
                    }, .01 + r);
                }, O.default.prototype._makeFrame = function(e1, t, r) {
                    var o, r = this ? this._curElement.elt : r;
                    if (t) switch(t.toLowerCase()){
                        case "png":
                            o = "image/png";
                            break;
                        case "jpeg":
                        case "jpg":
                            o = "image/jpeg";
                            break;
                        default:
                            o = "image/png";
                    }
                    else t = "png", o = "image/png";
                    var r = (r = r.toDataURL(o)).replace(o, "image/octet-stream"), n = {};
                    return n.imageData = r, n.filename = e1, n.ext = t, n;
                };
                e1 = O.default;
                r.default = e1;
            },
            {
                "../core/main": 283,
                "core-js/modules/es.array.concat": 153,
                "core-js/modules/es.array.filter": 157,
                "core-js/modules/es.array.for-each": 161,
                "core-js/modules/es.array.from": 162,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.map": 168,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.object.keys": 189,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.regexp.exec": 195,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.set": 197,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.string.replace": 204,
                "core-js/modules/es.string.split": 206,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.typed-array.copy-within": 213,
                "core-js/modules/es.typed-array.every": 214,
                "core-js/modules/es.typed-array.fill": 215,
                "core-js/modules/es.typed-array.filter": 216,
                "core-js/modules/es.typed-array.find": 218,
                "core-js/modules/es.typed-array.find-index": 217,
                "core-js/modules/es.typed-array.for-each": 221,
                "core-js/modules/es.typed-array.includes": 222,
                "core-js/modules/es.typed-array.index-of": 223,
                "core-js/modules/es.typed-array.iterator": 226,
                "core-js/modules/es.typed-array.join": 227,
                "core-js/modules/es.typed-array.last-index-of": 228,
                "core-js/modules/es.typed-array.map": 229,
                "core-js/modules/es.typed-array.reduce": 231,
                "core-js/modules/es.typed-array.reduce-right": 230,
                "core-js/modules/es.typed-array.reverse": 232,
                "core-js/modules/es.typed-array.set": 233,
                "core-js/modules/es.typed-array.slice": 234,
                "core-js/modules/es.typed-array.some": 235,
                "core-js/modules/es.typed-array.sort": 236,
                "core-js/modules/es.typed-array.subarray": 237,
                "core-js/modules/es.typed-array.to-locale-string": 238,
                "core-js/modules/es.typed-array.to-string": 239,
                "core-js/modules/es.typed-array.uint32-array": 241,
                "core-js/modules/es.typed-array.uint8-array": 242,
                "core-js/modules/web.dom-collections.for-each": 245,
                "core-js/modules/web.dom-collections.iterator": 246,
                omggif: 256
            }
        ],
        306: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.copy-within"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.uint8-clamped-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.copy-within"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.uint8-clamped-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0, e1("regenerator-runtime/runtime");
                var C = n(e1("../core/main")), m = n(e1("../core/helpers")), _ = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants")), g = n(e1("omggif")), P = e1("gifenc");
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function n(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function l(e1, t, r, o, n, s, i) {
                    try {
                        var a = e1[s](i), l = a.value;
                    } catch (e1) {
                        return void r(e1);
                    }
                    a.done ? t(l) : Promise.resolve(l).then(o, n);
                }
                function y(e1, t, r, o, n, s, i, a, l, u, c) {
                    var d, h, f, p, m, y, g, v, b;
                    return e1 === _.COVER && (d = t, f = r, g = s, v = i, y = a, b = l, h = u, p = c, m = Math.max(g / h, v / p), g /= m, v /= m, m = y, y = b, d === _.CENTER ? m += (h - g) / 2 : d === _.RIGHT && (m += h - g), f === _.CENTER ? y += (p - v) / 2 : f === _.BOTTOM && (y += p - v), a = (b = {
                        x: m,
                        y: y,
                        w: g,
                        h: v
                    }).x, l = b.y, u = b.w, c = b.h), e1 === _.CONTAIN && (d = t, h = r, f = o, p = n, m = s, y = i, g = u, v = c, b = Math.max(g / m, v / y), g /= b, v /= b, b = f, f = p, d === _.CENTER ? b += (m - g) / 2 : d === _.RIGHT && (b += m - g), h === _.CENTER ? f += (y - v) / 2 : h === _.BOTTOM && (f += y - v), o = (e1 = {
                        x: b,
                        y: f,
                        w: g,
                        h: v
                    }).x, n = e1.y, s = e1.w, i = e1.h), {
                        sx: a,
                        sy: l,
                        sw: u,
                        sh: c,
                        dx: o,
                        dy: n,
                        dw: s,
                        dh: i
                    };
                }
                function v(e1, t) {
                    return 0 < e1 && e1 < t ? e1 : t;
                }
                e1("../core/friendly_errors/validate_params"), e1("../core/friendly_errors/file_errors"), e1("../core/friendly_errors/fes_core"), C.default.prototype.loadImage = function(o, f, p) {
                    C.default._validateParameters("loadImage", arguments);
                    var m = new C.default.Image(1, 1, this), y = this, e1 = new Request(o, {
                        method: "GET",
                        mode: "cors"
                    });
                    return fetch(o, e1).then(function(e1) {
                        var t, r = e1.headers.get("content-type");
                        null === r && console.warn("The image you loaded does not have a Content-Type header. If you are using the online editor consider reuploading the asset."), r && r.includes("image/gif") ? e1.arrayBuffer().then(function(e1) {
                            if (e1) {
                                for(var e1 = new Uint8Array(e1), r = m, t = f, o = p, n = (function(e1) {
                                    y._decrementPreload();
                                }).bind(y), s = new g.default.GifReader(e1), i = (r.width = r.canvas.width = s.width, r.height = r.canvas.height = s.height, []), a = s.numFrames(), l = new Uint8ClampedArray(r.width * r.height * 4), u = 0; u < a; u++){
                                    var c = s.frameInfo(u), d = r.drawingContext.getImageData(0, 0, r.width, r.height), h = (l = d.data.slice(), !function(e1, t) {
                                        try {
                                            t.decodeAndBlitFrameRGBA(e1, l);
                                        } catch (e1) {
                                            C.default._friendlyFileLoadError(8, r.src), "function" == typeof o ? o(e1) : console.error(e1);
                                        }
                                    }(u, s), new ImageData(l, r.width, r.height)), h = (r.drawingContext.putImageData(h, 0, 0), c.delay);
                                    0 === h && (h = 10), i.push({
                                        image: r.drawingContext.getImageData(0, 0, r.width, r.height),
                                        delay: 10 * h
                                    }), 2 === c.disposal ? r.drawingContext.clearRect(c.x, c.y, c.width, c.height) : 3 === c.disposal && r.drawingContext.putImageData(d, 0, 0, c.x, c.y, c.width, c.height);
                                }
                                null === (e1 = s.loopCount()) ? e1 = 1 : 0 === e1 && (e1 = null), r.drawingContext.putImageData(i[0].image, 0, 0), 1 < i.length && (r.gifProperties = {
                                    displayIndex: 0,
                                    loopLimit: e1,
                                    loopCount: 0,
                                    frames: i,
                                    numFrames: a,
                                    playing: !0,
                                    timeDisplayed: 0,
                                    lastChangeTime: 0
                                }), "function" == typeof t && t(r), n();
                            }
                        }, function(e1) {
                            "function" == typeof p ? (p(e1), y._decrementPreload()) : console.error(e1);
                        }) : ((t = new Image).onload = function() {
                            m.width = m.canvas.width = t.width, m.height = m.canvas.height = t.height, m.drawingContext.drawImage(t, 0, 0), m.modified = !0, "function" == typeof f && f(m), y._decrementPreload();
                        }, t.onerror = function(e1) {
                            C.default._friendlyFileLoadError(0, t.src), "function" == typeof p ? (p(e1), y._decrementPreload()) : console.error(e1);
                        }, 0 !== o.indexOf("data:image/") && (t.crossOrigin = "Anonymous"), t.src = o), m.modified = !0;
                    }).catch(function(e1) {
                        C.default._friendlyFileLoadError(0, o), "function" == typeof p ? (p(e1), y._decrementPreload()) : console.error(e1);
                    }), m;
                }, C.default.prototype.saveGif = function() {
                    a = regeneratorRuntime.mark(function e1(t, r) {
                        var o, n, s, i, a, l, u, c, d, h, f, p, m, y, g, v, b, _, j, x, w, S, T, E, M, k, O = arguments;
                        return regeneratorRuntime.wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (o = 2 < O.length && void 0 !== O[2] ? O[2] : {
                                        delay: 0,
                                        units: "seconds",
                                        silent: !1,
                                        notificationDuration: 0,
                                        notificationID: "progressBar"
                                    }, "string" != typeof t) throw TypeError("fileName parameter must be a string");
                                    e1.next = 3;
                                    break;
                                case 3:
                                    if ("number" != typeof r) throw TypeError("Duration parameter must be a number");
                                    e1.next = 5;
                                    break;
                                case 5:
                                    if (n = o && o.delay || 0, s = o && o.units || "seconds", i = o && o.silent || !1, a = o && o.notificationDuration || 0, l = o && o.notificationID || "progressBar", "number" != typeof n) throw TypeError("Delay parameter must be a number");
                                    e1.next = 12;
                                    break;
                                case 12:
                                    if ("seconds" !== s && "frames" !== s) throw TypeError('Units parameter must be either "frames" or "seconds"');
                                    e1.next = 14;
                                    break;
                                case 14:
                                    if ("boolean" != typeof i) throw TypeError("Silent parameter must be a boolean");
                                    e1.next = 16;
                                    break;
                                case 16:
                                    if ("number" != typeof a) throw TypeError("Notification duration parameter must be a number");
                                    e1.next = 18;
                                    break;
                                case 18:
                                    if ("string" != typeof l) throw TypeError("Notification ID parameter must be a string");
                                    e1.next = 20;
                                    break;
                                case 20:
                                    return this._recording = !0, h = this._targetFrameRate, u = (u = 1 / (h = h !== 1 / 0 && void 0 !== h && 0 !== h ? h : 60) * 1e3) < 20 ? 20 : u, d = (c = "seconds" === s ? r * h : r) + (h = "seconds" === s ? n * h : n), h, this.frameCount = h, f = this._pixelDensity, this.pixelDensity(1), p = [], null !== document.getElementById(l) && document.getElementById(l).remove(), i || ((m = this.createP("")).id(l), m.style("font-size", "16px"), m.style("font-family", "Montserrat"), m.style("background-color", "#ffffffa0"), m.style("padding", "8px"), m.style("border-radius", "10px"), m.position(0, 0)), this._renderer instanceof C.default.RendererGL && (g = this.drawingContext, y = new Uint8Array(g.drawingBufferWidth * g.drawingBufferHeight * 4)), this.noLoop(), e1.next = 39, Promise.resolve();
                                case 39:
                                    if (h < d) return this.redraw(), E = void 0, E = this._renderer instanceof C.default.RendererGL ? (y = new Uint8Array(g.drawingBufferWidth * g.drawingBufferHeight * 4), g.readPixels(0, 0, g.drawingBufferWidth, g.drawingBufferHeight, g.RGBA, g.UNSIGNED_BYTE, y), function(e1, t, r) {
                                        for(var o = parseInt(r / 2), n = 4 * t, s = new Uint8Array(4 * t), i = 0; i < o; ++i){
                                            var a = i * n, l = (r - i - 1) * n;
                                            s.set(e1.subarray(a, a + n)), e1.copyWithin(a, l, l + n), e1.set(s, l);
                                        }
                                        return e1;
                                    }(y, this.width, this.height)) : this.drawingContext.getImageData(0, 0, this.width, this.height).data, p.push(E), h++, i || m.html("Saved frame <b>" + p.length.toString() + "</b> out of " + c.toString()), e1.next = 48, new Promise(function(e1) {
                                        return setTimeout(e1, 0);
                                    });
                                    e1.next = 50;
                                    break;
                                case 48:
                                    e1.next = 39;
                                    break;
                                case 50:
                                    i || m.html("Frames processed, generating color palette..."), this.loop(), this.pixelDensity(f), v = (0, P.GIFEncoder)(), b = function(e1) {
                                        for(var t = new Uint8Array(e1.length * e1[0].length), r = 0; r < e1.length; r++)t.set(e1[r], r * e1[0].length);
                                        var o = (0, P.quantize)(t, 256, {
                                            format: "rgba4444",
                                            oneBitAlpha: !0
                                        });
                                        256 === o.length ? o[o.length - 1] = [
                                            255 * Math.random(),
                                            255 * Math.random(),
                                            255 * Math.random(),
                                            0
                                        ] : o.push([
                                            255 * Math.random(),
                                            255 * Math.random(),
                                            255 * Math.random(),
                                            0
                                        ]);
                                        return o;
                                    }(p), _ = {}, j = function(e1) {
                                        for(var t = e1.length / 4, r = new Uint8Array(t), o = 0; o < t; o++){
                                            var n = e1[4 * o] << 24 | e1[4 * o + 1] << 16 | e1[4 * o + 2] << 8 | e1[4 * o + 3];
                                            void 0 === _[n] && (_[n] = (0, P.nearestColorIndex)(b, e1.slice(4 * o, 4 * (o + 1)))), r[o] = _[n];
                                        }
                                        return r;
                                    }, x = b.length - 1, w = [], S = 0;
                                case 60:
                                    if (!(S < p.length)) {
                                        e1.next = 71;
                                        break;
                                    }
                                    if (T = j(p[S]), E = T.slice(), 0 === S) v.writeFrame(T, this.width, this.height, {
                                        palette: b,
                                        delay: u,
                                        dispose: 1
                                    });
                                    else {
                                        for(M = 0; M < T.length; M++)T[M] === w[M] && (T[M] = x);
                                        v.writeFrame(T, this.width, this.height, {
                                            delay: u,
                                            transparent: !0,
                                            transparentIndex: x,
                                            dispose: 1
                                        });
                                    }
                                    return w = E, i || m.html("Rendered frame <b>" + S.toString() + "</b> out of " + c.toString()), e1.next = 68, new Promise(function(e1) {
                                        return setTimeout(e1, 0);
                                    });
                                case 68:
                                    S++, e1.next = 60;
                                    break;
                                case 71:
                                    v.finish(), k = v.bytesView(), k = new Blob([
                                        k
                                    ], {
                                        type: "image/gif"
                                    }), p = [], this._recording = !1, this.loop(), i || (m.html("Done. Downloading your gif!\uD83C\uDF38"), 0 < a && setTimeout(function() {
                                        return m.remove();
                                    }, 1e3 * a)), C.default.prototype.downloadFile(k, t, "gif");
                                case 80:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, this);
                    });
                    var a, r = function() {
                        var e1 = this, i = arguments;
                        return new Promise(function(t, r) {
                            var o = a.apply(e1, i);
                            function n(e1) {
                                l(o, t, r, n, s, "next", e1);
                            }
                            function s(e1) {
                                l(o, t, r, n, s, "throw", e1);
                            }
                            n(void 0);
                        });
                    };
                    return function(e1, t) {
                        return r.apply(this, arguments);
                    };
                }(), C.default.prototype.image = function(e1, t, r, o, n, s, i, a, l, u, c, d) {
                    C.default._validateParameters("image", arguments);
                    var h = e1.width, f = e1.height, p = (d = d || _.CENTER, c = c || _.CENTER, e1.elt && (h = void 0 !== h ? h : e1.elt.width, f = void 0 !== f ? f : e1.elt.height), e1.elt && e1.elt.videoWidth && !e1.canvas && (h = void 0 !== h ? h : e1.elt.videoWidth, f = void 0 !== f ? f : e1.elt.videoHeight), o || h), n = n || f, s = s || 0, i = i || 0, a = v(void 0 !== a ? a : h, h), h = v(void 0 !== l ? l : f, f), l = 1;
                    e1.elt && !e1.canvas && e1.elt.style.width && (l = e1.elt.videoWidth && !o ? e1.elt.videoWidth : e1.elt.width, l /= parseInt(e1.elt.style.width, 10)), s *= l, i *= l, h *= l, a *= l;
                    f = y(u, c, d, (f = m.default.modeAdjust(t, r, p, n, this._renderer._imageMode)).x, f.y, f.w, f.h, s, i, a, h);
                    this._renderer.image(e1, f.sx, f.sy, f.sw, f.sh, f.dx, f.dy, f.dw, f.dh);
                }, C.default.prototype.tint = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    C.default._validateParameters("tint", t);
                    var o = this.color.apply(this, t);
                    this._renderer._tint = o.levels;
                }, C.default.prototype.noTint = function() {
                    this._renderer._tint = null;
                }, C.default.prototype._getTintedImageCanvas = C.default.Renderer2D.prototype._getTintedImageCanvas, C.default.prototype.imageMode = function(e1) {
                    C.default._validateParameters("imageMode", arguments), e1 !== _.CORNER && e1 !== _.CORNERS && e1 !== _.CENTER || (this._renderer._imageMode = e1);
                };
                e1 = C.default;
                r.default = e1;
            },
            {
                "../core/constants": 272,
                "../core/friendly_errors/fes_core": 274,
                "../core/friendly_errors/file_errors": 275,
                "../core/friendly_errors/validate_params": 278,
                "../core/helpers": 279,
                "../core/main": 283,
                "core-js/modules/es.array.copy-within": 154,
                "core-js/modules/es.array.includes": 163,
                "core-js/modules/es.array.index-of": 164,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.promise": 191,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.includes": 199,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.typed-array.copy-within": 213,
                "core-js/modules/es.typed-array.every": 214,
                "core-js/modules/es.typed-array.fill": 215,
                "core-js/modules/es.typed-array.filter": 216,
                "core-js/modules/es.typed-array.find": 218,
                "core-js/modules/es.typed-array.find-index": 217,
                "core-js/modules/es.typed-array.for-each": 221,
                "core-js/modules/es.typed-array.includes": 222,
                "core-js/modules/es.typed-array.index-of": 223,
                "core-js/modules/es.typed-array.iterator": 226,
                "core-js/modules/es.typed-array.join": 227,
                "core-js/modules/es.typed-array.last-index-of": 228,
                "core-js/modules/es.typed-array.map": 229,
                "core-js/modules/es.typed-array.reduce": 231,
                "core-js/modules/es.typed-array.reduce-right": 230,
                "core-js/modules/es.typed-array.reverse": 232,
                "core-js/modules/es.typed-array.set": 233,
                "core-js/modules/es.typed-array.slice": 234,
                "core-js/modules/es.typed-array.some": 235,
                "core-js/modules/es.typed-array.sort": 236,
                "core-js/modules/es.typed-array.subarray": 237,
                "core-js/modules/es.typed-array.to-locale-string": 238,
                "core-js/modules/es.typed-array.to-string": 239,
                "core-js/modules/es.typed-array.uint8-array": 242,
                "core-js/modules/es.typed-array.uint8-clamped-array": 243,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246,
                gifenc: 253,
                omggif: 256,
                "regenerator-runtime/runtime": 260
            }
        ],
        307: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var i = o(e1("../core/main")), n = o(e1("./filters"));
                function o(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                i.default.Image = function() {
                    function r(e1, t) {
                        if (!(this instanceof r)) throw new TypeError("Cannot call a class as a function");
                        this.width = e1, this.height = t, this.canvas = document.createElement("canvas"), this.canvas.width = this.width, this.canvas.height = this.height, this.drawingContext = this.canvas.getContext("2d"), (this._pixelsState = this)._pixelDensity = 1, this.gifProperties = null, this._modified = !1, this.pixels = [];
                    }
                    var e1, t, o;
                    return e1 = r, t = [
                        {
                            key: "pixelDensity",
                            value: function(e1) {
                                return void 0 !== e1 ? (e1 <= 0 && (i.default._friendlyParamError({
                                    type: "INVALID_VALUE",
                                    format: {
                                        types: [
                                            "Number"
                                        ]
                                    },
                                    position: 1
                                }, "pixelDensity"), e1 = 1), this._pixelDensity = e1, this.width /= e1, this.height /= e1, this) : this._pixelDensity;
                            }
                        },
                        {
                            key: "_animateGif",
                            value: function(e1) {
                                var t, r = this.gifProperties, e1 = e1._lastRealFrameTime || window.performance.now();
                                0 === r.lastChangeTime && (r.lastChangeTime = e1), r.playing && (r.timeDisplayed = e1 - r.lastChangeTime, t = r.frames[r.displayIndex].delay, r.timeDisplayed >= t && (t = Math.floor(r.timeDisplayed / t), r.timeDisplayed = 0, r.lastChangeTime = e1, r.displayIndex += t, r.loopCount = Math.floor(r.displayIndex / r.numFrames), null !== r.loopLimit && r.loopCount >= r.loopLimit ? r.playing = !1 : (e1 = r.displayIndex % r.numFrames, this.drawingContext.putImageData(r.frames[e1].image, 0, 0), r.displayIndex = e1, this.setModified(!0))));
                            }
                        },
                        {
                            key: "_setProperty",
                            value: function(e1, t) {
                                this[e1] = t, this.setModified(!0);
                            }
                        },
                        {
                            key: "loadPixels",
                            value: function() {
                                i.default.Renderer2D.prototype.loadPixels.call(this), this.setModified(!0);
                            }
                        },
                        {
                            key: "updatePixels",
                            value: function(e1, t, r, o) {
                                i.default.Renderer2D.prototype.updatePixels.call(this, e1, t, r, o), this.setModified(!0);
                            }
                        },
                        {
                            key: "get",
                            value: function(e1, t, r, o) {
                                return i.default._validateParameters("p5.Image.get", arguments), i.default.Renderer2D.prototype.get.apply(this, arguments);
                            }
                        },
                        {
                            key: "_getPixel",
                            value: function() {
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                return i.default.Renderer2D.prototype._getPixel.apply(this, t);
                            }
                        },
                        {
                            key: "set",
                            value: function(e1, t, r) {
                                i.default.Renderer2D.prototype.set.call(this, e1, t, r), this.setModified(!0);
                            }
                        },
                        {
                            key: "resize",
                            value: function(e1, t) {
                                0 === e1 && 0 === t ? (e1 = this.canvas.width, t = this.canvas.height) : 0 === e1 ? e1 = this.canvas.width * t / this.canvas.height : 0 === t && (t = this.canvas.height * e1 / this.canvas.width), e1 = Math.floor(e1), t = Math.floor(t);
                                var r = document.createElement("canvas");
                                if (r.width = e1, r.height = t, this.gifProperties) for(var o = this.gifProperties, n = 0; n < o.numFrames; n++){
                                    for(var s = this.drawingContext.createImageData(e1, t), i = (d = d = c = u = l = void 0, o.frames[n].image), a = s, l = 0, u = 0; u < a.height; u++)for(var c = 0; c < a.width; c++){
                                        var d = Math.floor(c * i.width / a.width), d = 4 * (Math.floor(u * i.height / a.height) * i.width + d);
                                        a.data[l++] = i.data[d++], a.data[l++] = i.data[d++], a.data[l++] = i.data[d++], a.data[l++] = i.data[+d];
                                    }
                                    o.frames[n].image = s;
                                }
                                r.getContext("2d").drawImage(this.canvas, 0, 0, this.canvas.width, this.canvas.height, 0, 0, r.width, r.height), this.canvas.width = this.width = e1, this.canvas.height = this.height = t, this.drawingContext.drawImage(r, 0, 0, e1, t, 0, 0, e1, t), 0 < this.pixels.length && this.loadPixels(), this.setModified(!0);
                            }
                        },
                        {
                            key: "copy",
                            value: function() {
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                i.default.prototype.copy.apply(this, t);
                            }
                        },
                        {
                            key: "mask",
                            value: function(e1) {
                                var t = this.drawingContext.globalCompositeOperation, r = this._pixelDensity, o = 1, n = [
                                    e1 = void 0 === e1 ? this : e1,
                                    0,
                                    0,
                                    (o = e1 instanceof i.default.Renderer ? e1._pInst._pixelDensity : o) * e1.width,
                                    o * e1.height,
                                    0,
                                    0,
                                    r * this.width,
                                    r * this.height
                                ];
                                if (this.drawingContext.globalCompositeOperation = "destination-in", this.gifProperties) {
                                    for(var s = 0; s < this.gifProperties.frames.length; s++)this.drawingContext.putImageData(this.gifProperties.frames[s].image, 0, 0), this.copy.apply(this, n), this.gifProperties.frames[s].image = this.drawingContext.getImageData(0, 0, r * this.width, r * this.height);
                                    this.drawingContext.putImageData(this.gifProperties.frames[this.gifProperties.displayIndex].image, 0, 0);
                                } else this.copy.apply(this, n);
                                this.drawingContext.globalCompositeOperation = t, this.setModified(!0);
                            }
                        },
                        {
                            key: "filter",
                            value: function(e1, t) {
                                n.default.apply(this.canvas, n.default[e1], t), this.setModified(!0);
                            }
                        },
                        {
                            key: "blend",
                            value: function() {
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                i.default._validateParameters("p5.Image.blend", arguments), i.default.prototype.blend.apply(this, t), this.setModified(!0);
                            }
                        },
                        {
                            key: "setModified",
                            value: function(e1) {
                                this._modified = e1;
                            }
                        },
                        {
                            key: "isModified",
                            value: function() {
                                return this._modified;
                            }
                        },
                        {
                            key: "save",
                            value: function(e1, t) {
                                this.gifProperties ? i.default.prototype.encodeAndDownloadGif(this, e1) : i.default.prototype.saveCanvas(this.canvas, e1, t);
                            }
                        },
                        {
                            key: "reset",
                            value: function() {
                                var e1;
                                this.gifProperties && ((e1 = this.gifProperties).playing = !0, e1.timeSinceStart = 0, e1.timeDisplayed = 0, e1.lastChangeTime = 0, e1.loopCount = 0, e1.displayIndex = 0, this.drawingContext.putImageData(e1.frames[0].image, 0, 0));
                            }
                        },
                        {
                            key: "getCurrentFrame",
                            value: function() {
                                var e1;
                                if (this.gifProperties) return (e1 = this.gifProperties).displayIndex % e1.numFrames;
                            }
                        },
                        {
                            key: "setFrame",
                            value: function(e1) {
                                var t;
                                this.gifProperties && (e1 < (t = this.gifProperties).numFrames && 0 <= e1 ? (t.timeDisplayed = 0, t.lastChangeTime = 0, t.displayIndex = e1, this.drawingContext.putImageData(t.frames[e1].image, 0, 0)) : console.log("Cannot set GIF to a frame number that is higher than total number of frames or below zero."));
                            }
                        },
                        {
                            key: "numFrames",
                            value: function() {
                                if (this.gifProperties) return this.gifProperties.numFrames;
                            }
                        },
                        {
                            key: "play",
                            value: function() {
                                this.gifProperties && (this.gifProperties.playing = !0);
                            }
                        },
                        {
                            key: "pause",
                            value: function() {
                                this.gifProperties && (this.gifProperties.playing = !1);
                            }
                        },
                        {
                            key: "delay",
                            value: function(e1, t) {
                                if (this.gifProperties) {
                                    var r = this.gifProperties;
                                    if (t < r.numFrames && 0 <= t) r.frames[t].delay = e1;
                                    else {
                                        var o = !0, t = !1, n = void 0;
                                        try {
                                            for(var s, i = r.frames[Symbol.iterator](); !(o = (s = i.next()).done); o = !0)s.value.delay = e1;
                                        } catch (e1) {
                                            t = !0, n = e1;
                                        } finally{
                                            try {
                                                o || null == i.return || i.return();
                                            } finally{
                                                if (t) throw n;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    ], s(e1.prototype, t), o && s(e1, o), r;
                }();
                e1 = i.default.Image;
                r.default = e1;
            },
            {
                "../core/main": 283,
                "./filters": 304,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        308: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.filter"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var f = o(e1("../core/main")), a = o(e1("./filters"));
                function o(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                e1("../color/p5.Color"), f.default.prototype.pixels = [], f.default.prototype.blend = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    f.default._validateParameters("blend", r), this._renderer ? (e1 = this._renderer).blend.apply(e1, r) : f.default.Renderer2D.prototype.blend.apply(this, r);
                }, f.default.prototype.copy = function() {
                    for(var e1, t, r, o, n, s, i, a, l, u = arguments.length, c = new Array(u), d = 0; d < u; d++)c[d] = arguments[d];
                    if (f.default._validateParameters("copy", c), 9 === c.length) e1 = c[0], t = c[1], r = c[2], o = c[3], n = c[4], s = c[5], i = c[6], a = c[7], l = c[8];
                    else {
                        if (8 !== c.length) throw new Error("Signature not supported");
                        e1 = this, t = c[0], r = c[1], o = c[2], n = c[3], s = c[4], i = c[5], a = c[6], l = c[7];
                    }
                    f.default.prototype._copyHelper(this, e1, t, r, o, n, s, i, a, l);
                }, f.default.prototype._copyHelper = function(e1, t, r, o, n, s, i, a, l, u) {
                    var c = t.canvas.width / t.width, d = 0, h = 0;
                    t._renderer && t._renderer.isP3D && (d = t.width / 2, h = t.height / 2), e1._renderer && e1._renderer.isP3D ? (e1.push(), e1.resetMatrix(), e1.noLights(), e1.blendMode(e1.BLEND), e1.imageMode(e1.CORNER), f.default.RendererGL.prototype.image.call(e1._renderer, t, r + d, o + h, n, s, i, a, l, u), e1.pop()) : e1.drawingContext.drawImage(t.canvas, c * (r + d), c * (o + h), c * n, c * s, i, a, l, u);
                }, f.default.prototype.getFilterGraphicsLayer = function() {
                    return this._renderer.getFilterGraphicsLayer();
                }, f.default.prototype.filter = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    f.default._validateParameters("filter", t);
                    var o = (function() {
                        var e1, t = {
                            shader: void 0,
                            operation: void 0,
                            value: void 0,
                            useWebGL: !0
                        };
                        return (arguments.length <= 0 ? void 0 : arguments[0]) instanceof f.default.Shader ? t.shader = arguments.length <= 0 ? void 0 : arguments[0] : (t.operation = arguments.length <= 0 ? void 0 : arguments[0], 1 < arguments.length && "number" == typeof (arguments.length <= 1 ? void 0 : arguments[1]) && (t.value = arguments.length <= 1 ? void 0 : arguments[1]), !1 === ((e1 = arguments.length - 1) < 0 || arguments.length <= e1 ? void 0 : arguments[e1]) && (t.useWebGL = !1)), t;
                    }).apply(void 0, t), n = o.shader, s = o.operation, i = o.value, o = o.useWebGL;
                    this._renderer.isP3D && n ? f.default.RendererGL.prototype.filter.call(this._renderer, n) : o || this._renderer.isP3D ? (!o && this._renderer.isP3D && console.warn("filter() with useWebGL=false is not supported in WEBGL"), this._renderer.isP3D ? f.default.RendererGL.prototype.filter.call(this._renderer, s, i) : ((n = this.getFilterGraphicsLayer()).copy(this._renderer, 0, 0, this.width, this.height, -this.width / 2, -this.height / 2, this.width, this.height), this._renderer.clear(), this._renderer.resetMatrix(), n.filter.apply(n, t), this.copy(n._renderer, 0, 0, this.width, this.height, 0, 0, this.width, this.height), n.clear())) : void 0 !== this.canvas ? a.default.apply(this.canvas, a.default[s], i) : a.default.apply(this.elt, a.default[s], i);
                }, f.default.prototype.get = function(e1, t, r, o) {
                    var n;
                    return f.default._validateParameters("get", arguments), (n = this._renderer).get.apply(n, arguments);
                }, f.default.prototype.loadPixels = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    f.default._validateParameters("loadPixels", t), this._renderer.loadPixels();
                }, f.default.prototype.set = function(e1, t, r) {
                    this._renderer.set(e1, t, r);
                }, f.default.prototype.updatePixels = function(e1, t, r, o) {
                    f.default._validateParameters("updatePixels", arguments), 0 !== this.pixels.length && this._renderer.updatePixels(e1, t, r, o);
                };
                e1 = f.default;
                r.default = e1;
            },
            {
                "../color/p5.Color": 270,
                "../core/main": 283,
                "./filters": 304,
                "core-js/modules/es.array.filter": 157
            }
        ],
        309: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.last-index-of"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.object.from-entries"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/web.url"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.last-index-of"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.object.from-entries"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/web.url"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var v = s(e1("../core/main")), m = (e1("whatwg-fetch"), e1("es6-promise/auto"), s(e1("fetch-jsonp"))), n = s(e1("file-saver"));
                function s(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function y(e1) {
                    return (y = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                function g(e1) {
                    return e1.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
                }
                function i(e1, t) {
                    t && !0 !== t && "true" !== t || (t = "");
                    var r = "";
                    return (e1 = e1 || "untitled", e1.includes(".")) && (r = e1.split(".").pop()), t && r !== t && (r = t, e1 = "".concat(e1, ".").concat(r)), [
                        e1,
                        r
                    ];
                }
                e1("../core/friendly_errors/validate_params"), e1("../core/friendly_errors/file_errors"), e1("../core/friendly_errors/fes_core"), v.default.prototype.loadJSON = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    v.default._validateParameters("loadJSON", t);
                    for(var o, n, s, i = t[0], a = {}, l = "json", u = 1; u < t.length; u++){
                        var c = t[u];
                        "string" == typeof c ? "jsonp" !== c && "json" !== c || (l = c) : "function" == typeof c ? o ? n = c : o = c : "object" === y(c) && (c.hasOwnProperty("jsonpCallback") || c.hasOwnProperty("jsonpCallbackFunction")) && (l = "jsonp", s = c);
                    }
                    var d = this;
                    return this.httpDo(i, "GET", s, l, function(e1) {
                        for(var t in e1)a[t] = e1[t];
                        void 0 !== o && o(e1), d._decrementPreload();
                    }, function(e1) {
                        if (v.default._friendlyFileLoadError(5, i), !n) throw e1;
                        n(e1);
                    }), a;
                }, v.default.prototype.loadStrings = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    v.default._validateParameters("loadStrings", t);
                    for(var n, o, s = [], i = 1; i < t.length; i++){
                        var a = t[i];
                        "function" == typeof a && (void 0 === n ? n = a : void 0 === o && (o = a));
                    }
                    var l = this;
                    return v.default.prototype.httpDo.call(this, t[0], "GET", "text", function(e1) {
                        for(var t = e1.replace(/\r\n/g, "\r").replace(/\n/g, "\r").split(/\r/), r = 0, o = t.length; r < o; r += 32768)Array.prototype.push.apply(s, t.slice(r, Math.min(r + 32768, o)));
                        void 0 !== n && n(s), l._decrementPreload();
                    }, function(e1) {
                        if (v.default._friendlyFileLoadError(3, e1), !o) throw e1;
                        o(e1);
                    }), s;
                }, v.default.prototype.loadTable = function(t) {
                    var f, r, p, e1 = [], m = !1, o = t.substring(t.lastIndexOf(".") + 1, t.length);
                    "csv" === o ? p = "," : "ssv" === o ? p = ";" : "tsv" === o && (p = "\t");
                    for(var n = 1; n < arguments.length; n++)"function" == typeof arguments[n] ? void 0 === f ? f = arguments[n] : void 0 === r && (r = arguments[n]) : "string" == typeof arguments[n] && (e1.push(arguments[n]), "header" === arguments[n] && (m = !0), "csv" === arguments[n] ? p = "," : "ssv" === arguments[n] ? p = ";" : "tsv" === arguments[n] && (p = "\t"));
                    var y = new v.default.Table, g = this;
                    return this.httpDo(t, "GET", "table", function(e1) {
                        for(var t, r, o = {}, n = 0, s = [], i = 0, a = null, l = function() {
                            o.currentState = n, o.token = "";
                        }, u = function() {
                            a.push(o.token), l();
                        }, c = function() {
                            o.currentState = 4, s.push(a), a = null;
                        };;){
                            if (null == (t = e1[i++])) {
                                if (o.escaped) throw new Error("Unclosed quote in file.");
                                if (a) {
                                    u(), c();
                                    break;
                                }
                            }
                            if (null === a && (o.escaped = !1, a = [], l()), o.currentState === n) {
                                if ('"' === t) {
                                    o.escaped = !0, o.currentState = 1;
                                    continue;
                                }
                                o.currentState = 1;
                            }
                            if (1 === o.currentState && o.escaped) {
                                if ('"' === t) '"' === e1[i] ? (o.token += '"', i++) : (o.escaped = !1, o.currentState = 2);
                                else {
                                    if ("\r" === t) continue;
                                    o.token += t;
                                }
                            } else "\r" === t ? ("\n" === e1[i] && i++, u(), c()) : "\n" === t ? (u(), c()) : t === p ? u() : 1 === o.currentState && (o.token += t);
                        }
                        if (m) y.columns = s.shift();
                        else for(var d = 0; d < s[0].length; d++)y.columns[d] = "null";
                        for(var h = 0; h < s.length; h++)(1 !== s[h].length || "undefined" !== s[h][0] && "" !== s[h][0]) && ((r = new v.default.TableRow).arr = s[h], r.obj = function(r, e1) {
                            if (void 0 === (e1 = e1 || [])) for(var t = 0; t < r.length; t++)e1[t.toString()] = t;
                            return Object.fromEntries(e1.map(function(e1, t) {
                                return [
                                    e1,
                                    r[t]
                                ];
                            }));
                        }(s[h], y.columns), y.addRow(r));
                        "function" == typeof f && f(y), g._decrementPreload();
                    }, function(e1) {
                        v.default._friendlyFileLoadError(2, t), r ? r(e1) : console.error(e1);
                    }), y;
                }, v.default.prototype.loadXML = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    for(var o, n, s = new v.default.XML, i = 1; i < t.length; i++){
                        var a = t[i];
                        "function" == typeof a && (void 0 === o ? o = a : void 0 === n && (n = a));
                    }
                    var l = this;
                    return this.httpDo(t[0], "GET", "xml", function(e1) {
                        for(var t in e1)s[t] = e1[t];
                        void 0 !== o && o(s), l._decrementPreload();
                    }, function(e1) {
                        if (v.default._friendlyFileLoadError(1, e1), !n) throw e1;
                        n(e1);
                    }), s;
                }, v.default.prototype.loadBytes = function(t, r, o) {
                    var n = {}, s = this;
                    return this.httpDo(t, "GET", "arrayBuffer", function(e1) {
                        n.bytes = new Uint8Array(e1), "function" == typeof r && r(n), s._decrementPreload();
                    }, function(e1) {
                        if (v.default._friendlyFileLoadError(6, t), !o) throw e1;
                        o(e1);
                    }), n;
                }, v.default.prototype.httpGet = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    return v.default._validateParameters("httpGet", t), t.splice(1, 0, "GET"), v.default.prototype.httpDo.apply(this, t);
                }, v.default.prototype.httpPost = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    return v.default._validateParameters("httpPost", t), t.splice(1, 0, "POST"), v.default.prototype.httpDo.apply(this, t);
                }, v.default.prototype.httpDo = function() {
                    for(var r, e1, t, o = {}, n = 0, s = "text/plain", i = arguments.length - 1; 0 < i && "function" == typeof (i < 0 || arguments.length <= i ? void 0 : arguments[i]); i--)n++;
                    var a = arguments.length - n, l = arguments.length <= 0 ? void 0 : arguments[0];
                    if (2 == a && "string" == typeof l && "object" === y(arguments.length <= 1 ? void 0 : arguments[1])) p = new Request(l, arguments.length <= 1 ? void 0 : arguments[1]), e1 = arguments.length <= 2 ? void 0 : arguments[2], t = arguments.length <= 3 ? void 0 : arguments[3];
                    else {
                        for(var u, c = "GET", d = 1; d < arguments.length; d++){
                            var h = d < 0 || arguments.length <= d ? void 0 : arguments[d];
                            if ("string" == typeof h) "GET" === h || "POST" === h || "PUT" === h || "DELETE" === h ? c = h : "json" === h || "jsonp" === h || "binary" === h || "arrayBuffer" === h || "xml" === h || "text" === h || "table" === h ? r = h : u = h;
                            else if ("number" == typeof h) u = h.toString();
                            else if ("object" === y(h)) {
                                if (h.hasOwnProperty("jsonpCallback") || h.hasOwnProperty("jsonpCallbackFunction")) for(var f in h)o[f] = h[f];
                                else s = h instanceof v.default.XML ? (u = h.serialize(), "application/xml") : (u = JSON.stringify(h), "application/json");
                            } else "function" == typeof h && (e1 ? t = h : e1 = h);
                        }
                        var a = "GET" === c ? new Headers : new Headers({
                            "Content-Type": s
                        }), p = new Request(l, {
                            method: c,
                            mode: "cors",
                            body: u,
                            headers: a
                        });
                    }
                    return (a = (a = "jsonp" === (r = r || (l.includes("json") ? "json" : l.includes("xml") ? "xml" : "text")) ? (0, m.default)(l, o) : fetch(p)).then(function(e1) {
                        if (!e1.ok) throw (t = new Error(e1.body)).status = e1.status, t.ok = !1, t;
                        var t = 0;
                        switch((t = "jsonp" !== r ? e1.headers.get("content-length") : t) && 64e6 < t && v.default._friendlyFileLoadError(7, l), r){
                            case "json":
                            case "jsonp":
                                return e1.json();
                            case "binary":
                                return e1.blob();
                            case "arrayBuffer":
                                return e1.arrayBuffer();
                            case "xml":
                                return e1.text().then(function(e1) {
                                    e1 = (new DOMParser).parseFromString(e1, "text/xml");
                                    return new v.default.XML(e1.documentElement);
                                });
                            default:
                                return e1.text();
                        }
                    })).then(e1 || function() {}), a.catch(t || console.error), a;
                }, window.URL = window.URL || window.webkitURL, v.default.prototype._pWriters = [], v.default.prototype.createWriter = function(e1, t) {
                    var r, o;
                    for(o in v.default.prototype._pWriters)if (v.default.prototype._pWriters[o].name === e1) return r = new v.default.PrintWriter(e1 + this.millis(), t), v.default.prototype._pWriters.push(r), r;
                    return r = new v.default.PrintWriter(e1, t), v.default.prototype._pWriters.push(r), r;
                }, v.default.PrintWriter = function(r, o) {
                    var n = this;
                    this.name = r, this.content = "", this.write = function(e1) {
                        this.content += e1;
                    }, this.print = function(e1) {
                        this.content += "".concat(e1, "\n");
                    }, this.clear = function() {
                        this.content = "";
                    }, this.close = function() {
                        var e1, t = [];
                        for(e1 in t.push(this.content), v.default.prototype.writeFile(t, r, o), v.default.prototype._pWriters)v.default.prototype._pWriters[e1].name === this.name && v.default.prototype._pWriters.splice(e1, 1);
                        n.clear(), n = {};
                    };
                }, v.default.prototype.save = function(e1, t, r) {
                    var o = arguments, n = (this._curElement || this).elt;
                    if (0 === o.length) v.default.prototype.saveCanvas(n);
                    else if (o[0] instanceof v.default.Renderer || o[0] instanceof v.default.Graphics) v.default.prototype.saveCanvas(o[0].elt, o[1], o[2]);
                    else if (1 === o.length && "string" == typeof o[0]) v.default.prototype.saveCanvas(n, o[0]);
                    else switch(i(o[1], o[2])[1]){
                        case "json":
                            return void v.default.prototype.saveJSON(o[0], o[1], o[2]);
                        case "txt":
                            return void v.default.prototype.saveStrings(o[0], o[1], o[2]);
                        default:
                            o[0] instanceof Array ? v.default.prototype.saveStrings(o[0], o[1], o[2]) : o[0] instanceof v.default.Table ? v.default.prototype.saveTable(o[0], o[1], o[2]) : o[0] instanceof v.default.Image ? v.default.prototype.saveCanvas(o[0].canvas, o[1]) : o[0] instanceof v.default.SoundFile && v.default.prototype.saveSound(o[0], o[1], o[2], o[3]);
                    }
                }, v.default.prototype.saveJSON = function(e1, t, r) {
                    v.default._validateParameters("saveJSON", arguments), r = r ? JSON.stringify(e1) : JSON.stringify(e1, void 0, 2), this.saveStrings(r.split("\n"), t, "json");
                }, v.default.prototype.saveJSONObject = v.default.prototype.saveJSON, v.default.prototype.saveJSONArray = v.default.prototype.saveJSON, v.default.prototype.saveStrings = function(e1, t, r, o) {
                    v.default._validateParameters("saveStrings", arguments);
                    for(var n = this.createWriter(t, r || "txt"), s = 0; s < e1.length; s++)o ? n.write(e1[s] + "\r\n") : n.write(e1[s] + "\n");
                    n.close(), n.clear();
                }, v.default.prototype.saveTable = function(e1, t, r) {
                    v.default._validateParameters("saveTable", arguments), o = void 0 === r ? t.substring(t.lastIndexOf(".") + 1, t.length) : r;
                    var o, n = this.createWriter(t, o), s = e1.columns, i = "tsv" === o ? "\t" : ",";
                    if ("html" !== o) {
                        if ("0" !== s[0]) {
                            for(var a = 0; a < s.length; a++)a < s.length - 1 ? n.write(s[a] + i) : n.write(s[a]);
                            n.write("\n");
                        }
                        for(var l = 0; l < e1.rows.length; l++){
                            for(var u = void 0, u = 0; u < e1.rows[l].arr.length; u++)u < e1.rows[l].arr.length - 1 ? "csv" === o && String(e1.rows[l].arr[u]).includes(",") ? n.write('"' + e1.rows[l].arr[u] + '"' + i) : n.write(e1.rows[l].arr[u] + i) : "csv" === o && String(e1.rows[l].arr[u]).includes(",") ? n.write('"' + e1.rows[l].arr[u] + '"') : n.write(e1.rows[l].arr[u]);
                            n.write("\n");
                        }
                    } else {
                        n.print("<html>"), n.print("<head>");
                        if (n.print('  <meta http-equiv="content-type" content="text/html;charset=utf-8" />'), n.print("</head>"), n.print("<body>"), n.print("  <table>"), "0" !== s[0]) {
                            n.print("    <tr>");
                            for(var c = 0; c < s.length; c++){
                                var d = g(s[c]);
                                n.print("      <td>".concat(d)), n.print("      </td>");
                            }
                            n.print("    </tr>");
                        }
                        for(var h = 0; h < e1.rows.length; h++){
                            n.print("    <tr>");
                            for(var f = 0; f < e1.columns.length; f++){
                                var p = g(e1.rows[h].getString(f));
                                n.print("      <td>".concat(p)), n.print("      </td>");
                            }
                            n.print("    </tr>");
                        }
                        n.print("  </table>"), n.print("</body>"), n.print("</html>");
                    }
                    n.close(), n.clear();
                }, v.default.prototype.writeFile = function(e1, t, r) {
                    var o = "application/octet-stream", e1 = (v.default.prototype._isSafari() && (o = "text/plain"), new Blob(e1, {
                        type: o
                    }));
                    v.default.prototype.downloadFile(e1, t, r);
                }, v.default.prototype.downloadFile = function(e1, t, r) {
                    var o, t = i(t, r), r = t[0];
                    e1 instanceof Blob ? n.default.saveAs(e1, r) : ((o = document.createElement("a")).href = e1, o.download = r, o.onclick = function(e1) {
                        document.body.removeChild(e1.target), e1.stopPropagation();
                    }, o.style.display = "none", document.body.appendChild(o), v.default.prototype._isSafari() && (e1 = (e1 = 'Hello, Safari user! To download this file...\n1. Go to File --\x3e Save As.\n2. Choose "Page Source" as the Format.\n') + '3. Name it with this extension: ."'.concat(t[1], '"'), alert(e1)), o.click());
                }, v.default.prototype._checkFileExtension = i, v.default.prototype._isSafari = function() {
                    return window.HTMLElement.toString().includes("Constructor");
                };
                e1 = v.default;
                r.default = e1;
            },
            {
                "../core/friendly_errors/fes_core": 274,
                "../core/friendly_errors/file_errors": 275,
                "../core/friendly_errors/validate_params": 278,
                "../core/main": 283,
                "core-js/modules/es.array.concat": 153,
                "core-js/modules/es.array.includes": 163,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.last-index-of": 167,
                "core-js/modules/es.array.map": 168,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.array.splice": 171,
                "core-js/modules/es.function.name": 174,
                "core-js/modules/es.object.from-entries": 185,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.promise": 191,
                "core-js/modules/es.regexp.exec": 195,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.includes": 199,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.string.replace": 204,
                "core-js/modules/es.string.split": 206,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.typed-array.copy-within": 213,
                "core-js/modules/es.typed-array.every": 214,
                "core-js/modules/es.typed-array.fill": 215,
                "core-js/modules/es.typed-array.filter": 216,
                "core-js/modules/es.typed-array.find": 218,
                "core-js/modules/es.typed-array.find-index": 217,
                "core-js/modules/es.typed-array.for-each": 221,
                "core-js/modules/es.typed-array.includes": 222,
                "core-js/modules/es.typed-array.index-of": 223,
                "core-js/modules/es.typed-array.iterator": 226,
                "core-js/modules/es.typed-array.join": 227,
                "core-js/modules/es.typed-array.last-index-of": 228,
                "core-js/modules/es.typed-array.map": 229,
                "core-js/modules/es.typed-array.reduce": 231,
                "core-js/modules/es.typed-array.reduce-right": 230,
                "core-js/modules/es.typed-array.reverse": 232,
                "core-js/modules/es.typed-array.set": 233,
                "core-js/modules/es.typed-array.slice": 234,
                "core-js/modules/es.typed-array.some": 235,
                "core-js/modules/es.typed-array.sort": 236,
                "core-js/modules/es.typed-array.subarray": 237,
                "core-js/modules/es.typed-array.to-locale-string": 238,
                "core-js/modules/es.typed-array.to-string": 239,
                "core-js/modules/es.typed-array.uint8-array": 242,
                "core-js/modules/web.dom-collections.iterator": 246,
                "core-js/modules/web.url": 248,
                "es6-promise/auto": 249,
                "fetch-jsonp": 251,
                "file-saver": 252,
                "whatwg-fetch": 261
            }
        ],
        310: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.regexp.constructor"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.regexp.constructor"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.replace"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                n.default.Table = function() {
                    function o() {
                        var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : [], t = this, r = o;
                        if (!(t instanceof r)) throw new TypeError("Cannot call a class as a function");
                        this.columns = [], this.rows = e1;
                    }
                    var e1, t, r;
                    return e1 = o, t = [
                        {
                            key: "addRow",
                            value: function(e1) {
                                e1 = e1 || new n.default.TableRow;
                                if (void 0 === e1.arr || void 0 === e1.obj) throw new Error("invalid TableRow: ".concat(e1));
                                return (e1.table = this).rows.push(e1), e1;
                            }
                        },
                        {
                            key: "removeRow",
                            value: function(e1) {
                                this.rows[e1].table = null;
                                e1 = this.rows.splice(e1 + 1, this.rows.length);
                                this.rows.pop(), this.rows = this.rows.concat(e1);
                            }
                        },
                        {
                            key: "getRow",
                            value: function(e1) {
                                return this.rows[e1];
                            }
                        },
                        {
                            key: "getRows",
                            value: function() {
                                return this.rows;
                            }
                        },
                        {
                            key: "findRow",
                            value: function(e1, t) {
                                if ("string" == typeof t) {
                                    for(var r = 0; r < this.rows.length; r++)if (this.rows[r].obj[t] === e1) return this.rows[r];
                                } else for(var o = 0; o < this.rows.length; o++)if (this.rows[o].arr[t] === e1) return this.rows[o];
                                return null;
                            }
                        },
                        {
                            key: "findRows",
                            value: function(e1, t) {
                                var r = [];
                                if ("string" == typeof t) for(var o = 0; o < this.rows.length; o++)this.rows[o].obj[t] === e1 && r.push(this.rows[o]);
                                else for(var n = 0; n < this.rows.length; n++)this.rows[n].arr[t] === e1 && r.push(this.rows[n]);
                                return r;
                            }
                        },
                        {
                            key: "matchRow",
                            value: function(e1, t) {
                                if ("number" == typeof t) {
                                    for(var r = 0; r < this.rows.length; r++)if (this.rows[r].arr[t].match(e1)) return this.rows[r];
                                } else for(var o = 0; o < this.rows.length; o++)if (this.rows[o].obj[t].match(e1)) return this.rows[o];
                                return null;
                            }
                        },
                        {
                            key: "matchRows",
                            value: function(e1, t) {
                                var r = [];
                                if ("number" == typeof t) for(var o = 0; o < this.rows.length; o++)this.rows[o].arr[t].match(e1) && r.push(this.rows[o]);
                                else for(var n = 0; n < this.rows.length; n++)this.rows[n].obj[t].match(e1) && r.push(this.rows[n]);
                                return r;
                            }
                        },
                        {
                            key: "getColumn",
                            value: function(e1) {
                                var t = [];
                                if ("string" == typeof e1) for(var r = 0; r < this.rows.length; r++)t.push(this.rows[r].obj[e1]);
                                else for(var o = 0; o < this.rows.length; o++)t.push(this.rows[o].arr[e1]);
                                return t;
                            }
                        },
                        {
                            key: "clearRows",
                            value: function() {
                                delete this.rows, this.rows = [];
                            }
                        },
                        {
                            key: "addColumn",
                            value: function(e1) {
                                this.columns.push(e1 || null);
                            }
                        },
                        {
                            key: "getColumnCount",
                            value: function() {
                                return this.columns.length;
                            }
                        },
                        {
                            key: "getRowCount",
                            value: function() {
                                return this.rows.length;
                            }
                        },
                        {
                            key: "removeTokens",
                            value: function(e1, t) {
                                for(var r = [], o = 0; o < e1.length; o++)r.push(e1.charAt(o).replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"));
                                var n = new RegExp(r.join("|"), "g");
                                if (void 0 === t) for(var s = 0; s < this.columns.length; s++)for(var i = 0; i < this.rows.length; i++){
                                    var a = (a = this.rows[i].arr[s]).replace(n, "");
                                    this.rows[i].arr[s] = a, this.rows[i].obj[this.columns[s]] = a;
                                }
                                else if ("string" == typeof t) for(var l = 0; l < this.rows.length; l++){
                                    var u = (u = this.rows[l].obj[t]).replace(n, ""), c = (this.rows[l].obj[t] = u, this.columns.indexOf(t));
                                    this.rows[l].arr[c] = u;
                                }
                                else for(var d = 0; d < this.rows.length; d++){
                                    var h = (h = this.rows[d].arr[t]).replace(n, "");
                                    this.rows[d].arr[t] = h, this.rows[d].obj[this.columns[t]] = h;
                                }
                            }
                        },
                        {
                            key: "trim",
                            value: function(e1) {
                                var t = new RegExp(" ", "g");
                                if (void 0 === e1) for(var r = 0; r < this.columns.length; r++)for(var o = 0; o < this.rows.length; o++){
                                    var n = (n = this.rows[o].arr[r]).replace(t, "");
                                    this.rows[o].arr[r] = n, this.rows[o].obj[this.columns[r]] = n;
                                }
                                else if ("string" == typeof e1) for(var s = 0; s < this.rows.length; s++){
                                    var i = (i = this.rows[s].obj[e1]).replace(t, ""), a = (this.rows[s].obj[e1] = i, this.columns.indexOf(e1));
                                    this.rows[s].arr[a] = i;
                                }
                                else for(var l = 0; l < this.rows.length; l++){
                                    var u = (u = this.rows[l].arr[e1]).replace(t, "");
                                    this.rows[l].arr[e1] = u, this.rows[l].obj[this.columns[e1]] = u;
                                }
                            }
                        },
                        {
                            key: "removeColumn",
                            value: function(e1) {
                                "string" == typeof e1 ? r = this.columns.indexOf(t = e1) : t = this.columns[r = e1];
                                var t, r, e1 = this.columns.splice(r + 1, this.columns.length);
                                this.columns.pop(), this.columns = this.columns.concat(e1);
                                for(var o = 0; o < this.rows.length; o++){
                                    var n = this.rows[o].arr, s = n.splice(r + 1, n.length);
                                    n.pop(), this.rows[o].arr = n.concat(s), delete this.rows[o].obj[t];
                                }
                            }
                        },
                        {
                            key: "set",
                            value: function(e1, t, r) {
                                this.rows[e1].set(t, r);
                            }
                        },
                        {
                            key: "setNum",
                            value: function(e1, t, r) {
                                this.rows[e1].setNum(t, r);
                            }
                        },
                        {
                            key: "setString",
                            value: function(e1, t, r) {
                                this.rows[e1].setString(t, r);
                            }
                        },
                        {
                            key: "get",
                            value: function(e1, t) {
                                return this.rows[e1].get(t);
                            }
                        },
                        {
                            key: "getNum",
                            value: function(e1, t) {
                                return this.rows[e1].getNum(t);
                            }
                        },
                        {
                            key: "getString",
                            value: function(e1, t) {
                                return this.rows[e1].getString(t);
                            }
                        },
                        {
                            key: "getObject",
                            value: function(e1) {
                                for(var t, r = {}, o = 0; o < this.rows.length; o++)if (t = this.rows[o].obj, "string" == typeof e1) {
                                    if (!(0 <= this.columns.indexOf(e1))) throw new Error('This table has no column named "'.concat(e1, '"'));
                                    r[t[e1]] = t;
                                } else r[o] = this.rows[o].obj;
                                return r;
                            }
                        },
                        {
                            key: "getArray",
                            value: function() {
                                for(var e1 = [], t = 0; t < this.rows.length; t++)e1.push(this.rows[t].arr);
                                return e1;
                            }
                        }
                    ], s(e1.prototype, t), r && s(e1, r), o;
                }();
                e1 = n.default;
                r.default = e1;
            },
            {
                "../core/main": 283,
                "core-js/modules/es.array.concat": 153,
                "core-js/modules/es.array.index-of": 164,
                "core-js/modules/es.array.join": 166,
                "core-js/modules/es.array.splice": 171,
                "core-js/modules/es.regexp.constructor": 194,
                "core-js/modules/es.regexp.exec": 195,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.match": 201,
                "core-js/modules/es.string.replace": 204
            }
        ],
        311: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.from-entries"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.split"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.from-entries"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.split"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                e1.default.TableRow = function() {
                    function o(e1, t) {
                        if (!(this instanceof o)) throw new TypeError("Cannot call a class as a function");
                        var r = [];
                        e1 && (r = e1.split(t = t || ",")), this.arr = r, this.obj = Object.fromEntries(r.entries()), this.table = null;
                    }
                    var e1, t, r;
                    return e1 = o, t = [
                        {
                            key: "set",
                            value: function(e1, t) {
                                if ("string" == typeof e1) {
                                    var r = this.table.columns.indexOf(e1);
                                    if (!(0 <= r)) throw new Error('This table has no column named "'.concat(e1, '"'));
                                    this.obj[e1] = t, this.arr[r] = t;
                                } else {
                                    if (!(e1 < this.table.columns.length)) throw new Error("Column #".concat(e1, " is out of the range of this table"));
                                    this.arr[e1] = t;
                                    r = this.table.columns[e1];
                                    this.obj[r] = t;
                                }
                            }
                        },
                        {
                            key: "setNum",
                            value: function(e1, t) {
                                t = parseFloat(t);
                                this.set(e1, t);
                            }
                        },
                        {
                            key: "setString",
                            value: function(e1, t) {
                                t = t.toString();
                                this.set(e1, t);
                            }
                        },
                        {
                            key: "get",
                            value: function(e1) {
                                return ("string" == typeof e1 ? this.obj : this.arr)[e1];
                            }
                        },
                        {
                            key: "getNum",
                            value: function(e1) {
                                var t = "string" == typeof e1 ? parseFloat(this.obj[e1]) : parseFloat(this.arr[e1]);
                                if ("NaN" === t.toString()) throw "Error: ".concat(this.obj[e1], " is NaN (Not a Number)");
                                return t;
                            }
                        },
                        {
                            key: "getString",
                            value: function(e1) {
                                return ("string" == typeof e1 ? this.obj : this.arr)[e1].toString();
                            }
                        }
                    ], n(e1.prototype, t), r && n(e1, r), o;
                }();
                e1 = e1.default;
                r.default = e1;
            },
            {
                "../core/main": 283,
                "core-js/modules/es.array.index-of": 164,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.object.from-entries": 185,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.regexp.exec": 195,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.split": 206,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        312: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var a = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function s(e1) {
                    for(var t = [], r = 0; r < e1.length; r++)t.push(new a.default.XML(e1[r]));
                    return t;
                }
                a.default.XML = function() {
                    function t(e1) {
                        if (!(this instanceof t)) throw new TypeError("Cannot call a class as a function");
                        e1 ? this.DOM = e1 : (e1 = document.implementation.createDocument(null, "doc"), this.DOM = e1.createElement("root"));
                    }
                    var e1, r, o;
                    return e1 = t, r = [
                        {
                            key: "getParent",
                            value: function() {
                                return new a.default.XML(this.DOM.parentElement);
                            }
                        },
                        {
                            key: "getName",
                            value: function() {
                                return this.DOM.tagName;
                            }
                        },
                        {
                            key: "setName",
                            value: function(e1) {
                                var t = this.DOM.innerHTML, r = this.DOM.attributes, o = document.implementation.createDocument(null, "default").createElement(e1);
                                o.innerHTML = t;
                                for(var n = 0; n < r.length; n++)o.setAttribute(r[n].nodeName, r[n].nodeValue);
                                this.DOM = o;
                            }
                        },
                        {
                            key: "hasChildren",
                            value: function() {
                                return 0 < this.DOM.children.length;
                            }
                        },
                        {
                            key: "listChildren",
                            value: function() {
                                for(var e1 = [], t = 0; t < this.DOM.childNodes.length; t++)e1.push(this.DOM.childNodes[t].nodeName);
                                return e1;
                            }
                        },
                        {
                            key: "getChildren",
                            value: function(e1) {
                                return s(e1 ? this.DOM.getElementsByTagName(e1) : this.DOM.children);
                            }
                        },
                        {
                            key: "getChild",
                            value: function(e1) {
                                if ("string" != typeof e1) return new a.default.XML(this.DOM.children[e1]);
                                var t = !0, r = !1, o = void 0;
                                try {
                                    for(var n, s = this.DOM.children[Symbol.iterator](); !(t = (n = s.next()).done); t = !0){
                                        var i = n.value;
                                        if (i.tagName === e1) return new a.default.XML(i);
                                    }
                                } catch (e1) {
                                    r = !0, o = e1;
                                } finally{
                                    try {
                                        t || null == s.return || s.return();
                                    } finally{
                                        if (r) throw o;
                                    }
                                }
                            }
                        },
                        {
                            key: "addChild",
                            value: function(e1) {
                                e1 instanceof a.default.XML && this.DOM.appendChild(e1.DOM);
                            }
                        },
                        {
                            key: "removeChild",
                            value: function(e1) {
                                var t = -1;
                                if ("string" == typeof e1) {
                                    for(var r = 0; r < this.DOM.children.length; r++)if (this.DOM.children[r].tagName === e1) {
                                        t = r;
                                        break;
                                    }
                                } else t = e1;
                                -1 !== t && this.DOM.removeChild(this.DOM.children[t]);
                            }
                        },
                        {
                            key: "getAttributeCount",
                            value: function() {
                                return this.DOM.attributes.length;
                            }
                        },
                        {
                            key: "listAttributes",
                            value: function() {
                                var e1 = [], t = !0, r = !1, o = void 0;
                                try {
                                    for(var n, s = this.DOM.attributes[Symbol.iterator](); !(t = (n = s.next()).done); t = !0){
                                        var i = n.value;
                                        e1.push(i.nodeName);
                                    }
                                } catch (e1) {
                                    r = !0, o = e1;
                                } finally{
                                    try {
                                        t || null == s.return || s.return();
                                    } finally{
                                        if (r) throw o;
                                    }
                                }
                                return e1;
                            }
                        },
                        {
                            key: "hasAttribute",
                            value: function(e1) {
                                var t = {}, r = !0, o = !1, n = void 0;
                                try {
                                    for(var s, i = this.DOM.attributes[Symbol.iterator](); !(r = (s = i.next()).done); r = !0){
                                        var a = s.value;
                                        t[a.nodeName] = a.nodeValue;
                                    }
                                } catch (e1) {
                                    o = !0, n = e1;
                                } finally{
                                    try {
                                        r || null == i.return || i.return();
                                    } finally{
                                        if (o) throw n;
                                    }
                                }
                                return !!t[e1];
                            }
                        },
                        {
                            key: "getNum",
                            value: function(e1, t) {
                                var r = {}, o = !0, n = !1, s = void 0;
                                try {
                                    for(var i, a = this.DOM.attributes[Symbol.iterator](); !(o = (i = a.next()).done); o = !0){
                                        var l = i.value;
                                        r[l.nodeName] = l.nodeValue;
                                    }
                                } catch (e1) {
                                    n = !0, s = e1;
                                } finally{
                                    try {
                                        o || null == a.return || a.return();
                                    } finally{
                                        if (n) throw s;
                                    }
                                }
                                return Number(r[e1]) || t || 0;
                            }
                        },
                        {
                            key: "getString",
                            value: function(e1, t) {
                                var r = {}, o = !0, n = !1, s = void 0;
                                try {
                                    for(var i, a = this.DOM.attributes[Symbol.iterator](); !(o = (i = a.next()).done); o = !0){
                                        var l = i.value;
                                        r[l.nodeName] = l.nodeValue;
                                    }
                                } catch (e1) {
                                    n = !0, s = e1;
                                } finally{
                                    try {
                                        o || null == a.return || a.return();
                                    } finally{
                                        if (n) throw s;
                                    }
                                }
                                return r[e1] ? String(r[e1]) : t || null;
                            }
                        },
                        {
                            key: "setAttribute",
                            value: function(e1, t) {
                                this.DOM.setAttribute(e1, t);
                            }
                        },
                        {
                            key: "getContent",
                            value: function(e1) {
                                var t = this.DOM.textContent;
                                return (t = t.replace(/\s\s+/g, ",")) || e1 || null;
                            }
                        },
                        {
                            key: "setContent",
                            value: function(e1) {
                                this.DOM.children.length || (this.DOM.textContent = e1);
                            }
                        },
                        {
                            key: "serialize",
                            value: function() {
                                return (new XMLSerializer).serializeToString(this.DOM);
                            }
                        }
                    ], n(e1.prototype, r), o && n(e1, o), t;
                }();
                e1 = a.default;
                r.default = e1;
            },
            {
                "../core/main": 283,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.number.constructor": 179,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.regexp.exec": 195,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.string.replace": 204,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        313: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.math.hypot"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.math.hypot"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.string.includes"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var i = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function n(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                i.default.prototype.abs = Math.abs, i.default.prototype.ceil = Math.ceil, i.default.prototype.constrain = function(e1, t, r) {
                    return i.default._validateParameters("constrain", arguments), Math.max(Math.min(e1, r), t);
                }, i.default.prototype.dist = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    return i.default._validateParameters("dist", t), 4 === t.length ? Math.hypot(t[2] - t[0], t[3] - t[1]) : 6 === t.length ? Math.hypot(t[3] - t[0], t[4] - t[1], t[5] - t[2]) : void 0;
                }, i.default.prototype.exp = Math.exp, i.default.prototype.floor = Math.floor, i.default.prototype.lerp = function(e1, t, r) {
                    return i.default._validateParameters("lerp", arguments), r * (t - e1) + e1;
                }, i.default.prototype.log = Math.log, i.default.prototype.mag = function(e1, t) {
                    return i.default._validateParameters("mag", arguments), Math.hypot(e1, t);
                }, i.default.prototype.map = function(e1, t, r, o, n, s) {
                    i.default._validateParameters("map", arguments);
                    e1 = (e1 - t) / (r - t) * (n - o) + o;
                    return s ? o < n ? this.constrain(e1, o, n) : this.constrain(e1, n, o) : e1;
                }, i.default.prototype.max = function() {
                    for(var e1 = function(e1) {
                        return Math.max.apply(Math, n(e1));
                    }, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return Array.isArray(r[0]) ? e1(r[0]) : e1(r);
                }, i.default.prototype.min = function() {
                    for(var e1 = function(e1) {
                        return Math.min.apply(Math, n(e1));
                    }, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return Array.isArray(r[0]) ? e1(r[0]) : e1(r);
                }, i.default.prototype.norm = function(e1, t, r) {
                    return i.default._validateParameters("norm", arguments), this.map(e1, t, r, 0, 1);
                }, i.default.prototype.pow = Math.pow, i.default.prototype.round = function(e1, t) {
                    return t ? (t = Math.pow(10, t), Math.round(e1 * t) / t) : Math.round(e1);
                }, i.default.prototype.sq = function(e1) {
                    return e1 * e1;
                }, i.default.prototype.sqrt = Math.sqrt, i.default.prototype.fract = function(e1) {
                    i.default._validateParameters("fract", arguments);
                    var t, r = 0, e1 = Number(e1);
                    return isNaN(e1) || Math.abs(e1) === 1 / 0 ? e1 : (e1 < 0 && (e1 = -e1, r = 1), String(e1).includes(".") && !String(e1).includes("e") ? (t = String(e1), t = Number("0" + t.slice(t.indexOf("."))), Math.abs(r - t)) : e1 < 1 ? Math.abs(r - e1) : 0);
                };
                e1 = i.default;
                r.default = e1;
            },
            {
                "../core/main": 283,
                "core-js/modules/es.array.from": 162,
                "core-js/modules/es.array.includes": 163,
                "core-js/modules/es.array.index-of": 164,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.map": 168,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.math.hypot": 176,
                "core-js/modules/es.number.constructor": 179,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.includes": 199,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        314: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.slice"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var o = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function n(e1, t, r) {
                    return (n = function() {
                        if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                            if ("function" == typeof Proxy) return 1;
                            try {
                                return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                            } catch (e1) {}
                        }
                    }() ? Reflect.construct : function(e1, t, r) {
                        var o = [
                            null
                        ];
                        o.push.apply(o, t);
                        t = new (Function.bind.apply(e1, o));
                        return r && s(t, r.prototype), t;
                    }).apply(null, arguments);
                }
                function s(e1, t) {
                    return (s = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                o.default.prototype.createVector = function(e1, t, r) {
                    return this instanceof o.default ? n(o.default.Vector, [
                        this._fromRadians.bind(this),
                        this._toRadians.bind(this)
                    ].concat(Array.prototype.slice.call(arguments))) : new o.default.Vector(e1, t, r);
                };
                e1 = o.default;
                r.default = e1;
            },
            {
                "../core/main": 283,
                "core-js/modules/es.array.concat": 153,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.reflect.construct": 192,
                "core-js/modules/es.regexp.to-string": 196
            }
        ],
        315: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function b(e1) {
                    return .5 * (1 - Math.cos(e1 * Math.PI));
                }
                var _, j = 4095, x = 4, w = .5, e1 = (e1.default.prototype.noise = function(e1) {
                    var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 0, r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 0;
                    if (null == _) {
                        _ = new Array(4096);
                        for(var o = 0; o < 4096; o++)_[o] = Math.random();
                    }
                    e1 < 0 && (e1 = -e1), t < 0 && (t = -t), r < 0 && (r = -r);
                    for(var n, s, i = Math.floor(e1), a = Math.floor(t), l = Math.floor(r), u = e1 - i, c = t - a, d = r - l, h = 0, f = .5, p = 0; p < x; p++){
                        var m = i + (a << 4) + (l << 8), y = b(u), g = b(c), v = _[m & j];
                        v += y * (_[m + 1 & j] - v), n = _[m + 16 & j], v += g * ((n += y * (_[m + 16 + 1 & j] - n)) - v), n = _[(m += 256) & j], n += y * (_[m + 1 & j] - n), s = _[m + 16 & j], n += g * ((s += y * (_[m + 16 + 1 & j] - s)) - n), h += (v += b(d) * (n - v)) * f, f *= w, i <<= 1, a <<= 1, l <<= 1, 1 <= (u *= 2) && (i++, u--), 1 <= (c *= 2) && (a++, c--), 1 <= (d *= 2) && (l++, d--);
                    }
                    return h;
                }, e1.default.prototype.noiseDetail = function(e1, t) {
                    0 < e1 && (x = e1), 0 < t && (w = t);
                }, e1.default.prototype.noiseSeed = function(e1) {
                    o = 4294967296;
                    var t, r, o, n = {
                        setSeed: function(e1) {
                            r = t = (null == e1 ? Math.random() * o : e1) >>> 0;
                        },
                        getSeed: function() {
                            return t;
                        },
                        rand: function() {
                            return (r = (1664525 * r + 1013904223) % o) / o;
                        }
                    };
                    n.setSeed(e1), _ = new Array(4096);
                    for(var s = 0; s < 4096; s++)_[s] = n.rand();
                }, e1.default);
                r.default = e1;
            },
            {
                "../core/main": 283
            }
        ],
        316: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.every"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.some"), e1("core-js/modules/es.math.sign"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.number.epsilon"), e1("core-js/modules/es.number.is-finite"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.sub"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.every"), e1("core-js/modules/es.array.some"), e1("core-js/modules/es.math.sign"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.number.epsilon"), e1("core-js/modules/es.number.is-finite"), e1("core-js/modules/es.string.sub"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var u = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                }, s = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function l(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                u.default.Vector = function() {
                    function n() {
                        var e1 = this, t = n;
                        if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                        var r, o, e1 = "function" == typeof (arguments.length <= 0 ? void 0 : arguments[0]) ? (this.isPInst = !0, this._fromRadians = arguments.length <= 0 ? void 0 : arguments[0], this._toRadians = arguments.length <= 1 ? void 0 : arguments[1], r = (arguments.length <= 2 ? void 0 : arguments[2]) || 0, o = (arguments.length <= 3 ? void 0 : arguments[3]) || 0, (arguments.length <= 4 ? void 0 : arguments[4]) || 0) : (r = (arguments.length <= 0 ? void 0 : arguments[0]) || 0, o = (arguments.length <= 1 ? void 0 : arguments[1]) || 0, (arguments.length <= 2 ? void 0 : arguments[2]) || 0);
                        this.x = r, this.y = o, this.z = e1;
                    }
                    var e1, t, r;
                    return e1 = n, r = [
                        {
                            key: "fromAngle",
                            value: function(e1) {
                                var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 1;
                                return new u.default.Vector(t * Math.cos(e1), t * Math.sin(e1), 0);
                            }
                        },
                        {
                            key: "fromAngles",
                            value: function(e1, t) {
                                var r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 1, o = Math.cos(t), t = Math.sin(t), n = Math.cos(e1), e1 = Math.sin(e1);
                                return new u.default.Vector(r * e1 * t, -r * n, r * e1 * o);
                            }
                        },
                        {
                            key: "random2D",
                            value: function() {
                                return this.fromAngle(Math.random() * s.TWO_PI);
                            }
                        },
                        {
                            key: "random3D",
                            value: function() {
                                var e1 = Math.random() * s.TWO_PI, t = 2 * Math.random() - 1, r = Math.sqrt(1 - t * t), o = r * Math.cos(e1), r = r * Math.sin(e1);
                                return new u.default.Vector(o, r, t);
                            }
                        },
                        {
                            key: "copy",
                            value: function(e1) {
                                return e1.copy(e1);
                            }
                        },
                        {
                            key: "add",
                            value: function() {
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                var o = t[0], n = t[1], s = t[2];
                                return s ? s.set(o) : (s = o.copy(), 3 === t.length && u.default._friendlyError("The target parameter is undefined, it should be of type p5.Vector", "p5.Vector.add")), s.add(n), s;
                            }
                        },
                        {
                            key: "rem",
                            value: function(e1, t) {
                                if (e1 instanceof u.default.Vector && t instanceof u.default.Vector) return (e1 = e1.copy()).rem(t), e1;
                            }
                        },
                        {
                            key: "sub",
                            value: function() {
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                var o = t[0], n = t[1], s = t[2];
                                return s ? s.set(o) : (s = o.copy(), 3 === t.length && u.default._friendlyError("The target parameter is undefined, it should be of type p5.Vector", "p5.Vector.sub")), s.sub(n), s;
                            }
                        },
                        {
                            key: "mult",
                            value: function() {
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                var o = t[0], n = t[1], s = t[2];
                                return s ? s.set(o) : (s = o.copy(), 3 === t.length && u.default._friendlyError("The target parameter is undefined, it should be of type p5.Vector", "p5.Vector.mult")), s.mult(n), s;
                            }
                        },
                        {
                            key: "rotate",
                            value: function() {
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                var o = t[0], n = t[1], s = t[2];
                                return 2 === t.length ? s = o.copy() : (s instanceof u.default.Vector || u.default._friendlyError("The target parameter should be of type p5.Vector", "p5.Vector.rotate"), s.set(o)), s.rotate(n), s;
                            }
                        },
                        {
                            key: "div",
                            value: function() {
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                var o = t[0], n = t[1], s = t[2];
                                return s ? s.set(o) : (s = o.copy(), 3 === t.length && u.default._friendlyError("The target parameter is undefined, it should be of type p5.Vector", "p5.Vector.div")), s.div(n), s;
                            }
                        },
                        {
                            key: "dot",
                            value: function(e1, t) {
                                return e1.dot(t);
                            }
                        },
                        {
                            key: "cross",
                            value: function(e1, t) {
                                return e1.cross(t);
                            }
                        },
                        {
                            key: "dist",
                            value: function(e1, t) {
                                return e1.dist(t);
                            }
                        },
                        {
                            key: "lerp",
                            value: function() {
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                var o = t[0], n = t[1], s = t[2], i = t[3];
                                return i ? i.set(o) : (i = o.copy(), 4 === t.length && u.default._friendlyError("The target parameter is undefined, it should be of type p5.Vector", "p5.Vector.lerp")), i.lerp(n, s), i;
                            }
                        },
                        {
                            key: "slerp",
                            value: function() {
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                var o = t[0], n = t[1], s = t[2], i = t[3];
                                return i ? i.set(o) : (i = o.copy(), 4 === t.length && u.default._friendlyError("The target parameter is undefined, it should be of type p5.Vector", "p5.Vector.slerp")), i.slerp(n, s), i;
                            }
                        },
                        {
                            key: "mag",
                            value: function(e1) {
                                return e1.mag();
                            }
                        },
                        {
                            key: "magSq",
                            value: function(e1) {
                                return e1.magSq();
                            }
                        },
                        {
                            key: "normalize",
                            value: function() {
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                var o = t[0], n = t[1];
                                return t.length < 2 ? n = o.copy() : (n instanceof u.default.Vector || u.default._friendlyError("The target parameter should be of type p5.Vector", "p5.Vector.normalize"), n.set(o)), n.normalize();
                            }
                        },
                        {
                            key: "limit",
                            value: function() {
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                var o = t[0], n = t[1], s = t[2];
                                return t.length < 3 ? s = o.copy() : (s instanceof u.default.Vector || u.default._friendlyError("The target parameter should be of type p5.Vector", "p5.Vector.limit"), s.set(o)), s.limit(n);
                            }
                        },
                        {
                            key: "setMag",
                            value: function() {
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                var o = t[0], n = t[1], s = t[2];
                                return t.length < 3 ? s = o.copy() : (s instanceof u.default.Vector || u.default._friendlyError("The target parameter should be of type p5.Vector", "p5.Vector.setMag"), s.set(o)), s.setMag(n);
                            }
                        },
                        {
                            key: "heading",
                            value: function(e1) {
                                return e1.heading();
                            }
                        },
                        {
                            key: "angleBetween",
                            value: function(e1, t) {
                                return e1.angleBetween(t);
                            }
                        },
                        {
                            key: "reflect",
                            value: function() {
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                var o = t[0], n = t[1], s = t[2];
                                return t.length < 3 ? s = o.copy() : (s instanceof u.default.Vector || u.default._friendlyError("The target parameter should be of type p5.Vector", "p5.Vector.reflect"), s.set(o)), s.reflect(n);
                            }
                        },
                        {
                            key: "array",
                            value: function(e1) {
                                return e1.array();
                            }
                        },
                        {
                            key: "equals",
                            value: function(e1, t) {
                                var r;
                                return e1 instanceof u.default.Vector ? r = e1 : Array.isArray(e1) ? r = (new u.default.Vector).set(e1) : u.default._friendlyError("The v1 parameter should be of type Array or p5.Vector", "p5.Vector.equals"), r.equals(t);
                            }
                        }
                    ], t = [
                        {
                            key: "toString",
                            value: function() {
                                return "p5.Vector Object : [".concat(this.x, ", ").concat(this.y, ", ").concat(this.z, "]");
                            }
                        },
                        {
                            key: "set",
                            value: function(e1, t, r) {
                                return e1 instanceof u.default.Vector ? (this.x = e1.x || 0, this.y = e1.y || 0, this.z = e1.z || 0) : Array.isArray(e1) ? (this.x = e1[0] || 0, this.y = e1[1] || 0, this.z = e1[2] || 0) : (this.x = e1 || 0, this.y = t || 0, this.z = r || 0), this;
                            }
                        },
                        {
                            key: "copy",
                            value: function() {
                                return this.isPInst ? new u.default.Vector(this._fromRadians, this._toRadians, this.x, this.y, this.z) : new u.default.Vector(this.x, this.y, this.z);
                            }
                        },
                        {
                            key: "add",
                            value: function(e1, t, r) {
                                return e1 instanceof u.default.Vector ? (this.x += e1.x || 0, this.y += e1.y || 0, this.z += e1.z || 0) : Array.isArray(e1) ? (this.x += e1[0] || 0, this.y += e1[1] || 0, this.z += e1[2] || 0) : (this.x += e1 || 0, this.y += t || 0, this.z += r || 0), this;
                            }
                        },
                        {
                            key: "calculateRemainder2D",
                            value: function(e1, t) {
                                return 0 !== e1 && (this.x = this.x % e1), 0 !== t && (this.y = this.y % t), this;
                            }
                        },
                        {
                            key: "calculateRemainder3D",
                            value: function(e1, t, r) {
                                return 0 !== e1 && (this.x = this.x % e1), 0 !== t && (this.y = this.y % t), 0 !== r && (this.z = this.z % r), this;
                            }
                        },
                        {
                            key: "rem",
                            value: function() {
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                var o, n, s, i = t[0], a = t[1], l = t[2];
                                if (i instanceof u.default.Vector) {
                                    if ([
                                        i.x,
                                        i.y,
                                        i.z
                                    ].every(Number.isFinite)) return o = parseFloat(i.x), n = parseFloat(i.y), s = parseFloat(i.z), this.calculateRemainder3D(o, n, s);
                                } else if (Array.isArray(i)) {
                                    if (i.every(Number.isFinite)) return 2 === i.length ? this.calculateRemainder2D(i[0], i[1]) : 3 === i.length ? this.calculateRemainder3D(i[0], i[1], i[2]) : void 0;
                                } else if (1 === t.length) {
                                    if (Number.isFinite(i) && 0 !== i) return this.x = this.x % i, this.y = this.y % i, this.z = this.z % i, this;
                                } else if (2 === t.length) {
                                    if (t.every(Number.isFinite)) return this.calculateRemainder2D(i, a);
                                } else if (3 === t.length && t.every(Number.isFinite)) return this.calculateRemainder3D(i, a, l);
                            }
                        },
                        {
                            key: "sub",
                            value: function(e1, t, r) {
                                return e1 instanceof u.default.Vector ? (this.x -= e1.x || 0, this.y -= e1.y || 0, this.z -= e1.z || 0) : Array.isArray(e1) ? (this.x -= e1[0] || 0, this.y -= e1[1] || 0, this.z -= e1[2] || 0) : (this.x -= e1 || 0, this.y -= t || 0, this.z -= r || 0), this;
                            }
                        },
                        {
                            key: "mult",
                            value: function() {
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                var o, n = t[0], s = t[1], i = t[2];
                                return n instanceof u.default.Vector ? Number.isFinite(n.x) && Number.isFinite(n.y) && Number.isFinite(n.z) && "number" == typeof n.x && "number" == typeof n.y && "number" == typeof n.z ? (this.x *= n.x, this.y *= n.y, this.z *= n.z) : console.warn("p5.Vector.prototype.mult:", "x contains components that are either undefined or not finite numbers") : Array.isArray(n) ? n.every(function(e1) {
                                    return Number.isFinite(e1);
                                }) && n.every(function(e1) {
                                    return "number" == typeof e1;
                                }) ? 1 === n.length ? (this.x *= n[0], this.y *= n[0], this.z *= n[0]) : 2 === n.length ? (this.x *= n[0], this.y *= n[1]) : 3 === n.length && (this.x *= n[0], this.y *= n[1], this.z *= n[2]) : console.warn("p5.Vector.prototype.mult:", "x contains elements that are either undefined or not finite numbers") : (o = t).every(function(e1) {
                                    return Number.isFinite(e1);
                                }) && o.every(function(e1) {
                                    return "number" == typeof e1;
                                }) ? (1 === t.length && (this.x *= n, this.y *= n, this.z *= n), 2 === t.length && (this.x *= n, this.y *= s), 3 === t.length && (this.x *= n, this.y *= s, this.z *= i)) : console.warn("p5.Vector.prototype.mult:", "x, y, or z arguments are either undefined or not a finite number"), this;
                            }
                        },
                        {
                            key: "div",
                            value: function() {
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                var o = t[0], n = t[1], s = t[2];
                                if (o instanceof u.default.Vector) {
                                    if (Number.isFinite(o.x) && Number.isFinite(o.y) && Number.isFinite(o.z) && "number" == typeof o.x && "number" == typeof o.y && "number" == typeof o.z) {
                                        var i = 0 === o.z && 0 === this.z;
                                        if (0 === o.x || 0 === o.y || !i && 0 === o.z) return console.warn("p5.Vector.prototype.div:", "divide by 0"), this;
                                        this.x /= o.x, this.y /= o.y, i || (this.z /= o.z);
                                    } else console.warn("p5.Vector.prototype.div:", "x contains components that are either undefined or not finite numbers");
                                } else if (Array.isArray(o)) {
                                    if (o.every(Number.isFinite) && o.every(function(e1) {
                                        return "number" == typeof e1;
                                    })) {
                                        if (o.some(function(e1) {
                                            return 0 === e1;
                                        })) return console.warn("p5.Vector.prototype.div:", "divide by 0"), this;
                                        1 === o.length ? (this.x /= o[0], this.y /= o[0], this.z /= o[0]) : 2 === o.length ? (this.x /= o[0], this.y /= o[1]) : 3 === o.length && (this.x /= o[0], this.y /= o[1], this.z /= o[2]);
                                    } else console.warn("p5.Vector.prototype.div:", "x contains components that are either undefined or not finite numbers");
                                } else if (t.every(Number.isFinite) && t.every(function(e1) {
                                    return "number" == typeof e1;
                                })) {
                                    if (t.some(function(e1) {
                                        return 0 === e1;
                                    })) return console.warn("p5.Vector.prototype.div:", "divide by 0"), this;
                                    1 === t.length && (this.x /= o, this.y /= o, this.z /= o), 2 === t.length && (this.x /= o, this.y /= n), 3 === t.length && (this.x /= o, this.y /= n, this.z /= s);
                                } else console.warn("p5.Vector.prototype.div:", "x, y, or z arguments are either undefined or not a finite number");
                                return this;
                            }
                        },
                        {
                            key: "mag",
                            value: function() {
                                return Math.sqrt(this.magSq());
                            }
                        },
                        {
                            key: "magSq",
                            value: function() {
                                var e1 = this.x, t = this.y, r = this.z;
                                return e1 * e1 + t * t + r * r;
                            }
                        },
                        {
                            key: "dot",
                            value: function(e1, t, r) {
                                return e1 instanceof u.default.Vector ? this.dot(e1.x, e1.y, e1.z) : this.x * (e1 || 0) + this.y * (t || 0) + this.z * (r || 0);
                            }
                        },
                        {
                            key: "cross",
                            value: function(e1) {
                                var t = this.y * e1.z - this.z * e1.y, r = this.z * e1.x - this.x * e1.z, e1 = this.x * e1.y - this.y * e1.x;
                                return this.isPInst ? new u.default.Vector(this._fromRadians, this._toRadians, t, r, e1) : new u.default.Vector(t, r, e1);
                            }
                        },
                        {
                            key: "dist",
                            value: function(e1) {
                                return e1.copy().sub(this).mag();
                            }
                        },
                        {
                            key: "normalize",
                            value: function() {
                                var e1 = this.mag();
                                return 0 !== e1 && this.mult(1 / e1), this;
                            }
                        },
                        {
                            key: "limit",
                            value: function(e1) {
                                var t = this.magSq();
                                return e1 * e1 < t && this.div(Math.sqrt(t)).mult(e1), this;
                            }
                        },
                        {
                            key: "setMag",
                            value: function(e1) {
                                return this.normalize().mult(e1);
                            }
                        },
                        {
                            key: "heading",
                            value: function() {
                                var e1 = Math.atan2(this.y, this.x);
                                return this.isPInst ? this._fromRadians(e1) : e1;
                            }
                        },
                        {
                            key: "setHeading",
                            value: function(e1) {
                                this.isPInst && (e1 = this._toRadians(e1));
                                var t = this.mag();
                                return this.x = t * Math.cos(e1), this.y = t * Math.sin(e1), this;
                            }
                        },
                        {
                            key: "rotate",
                            value: function(e1) {
                                var e1 = this.heading() + e1, t = (this.isPInst && (e1 = this._toRadians(e1)), this.mag());
                                return this.x = Math.cos(e1) * t, this.y = Math.sin(e1) * t, this;
                            }
                        },
                        {
                            key: "angleBetween",
                            value: function(e1) {
                                var t;
                                return 0 == this.magSq() * e1.magSq() ? NaN : (t = this.cross(e1), e1 = Math.atan2(t.mag(), this.dot(e1)) * Math.sign(t.z || 1), this.isPInst ? this._fromRadians(e1) : e1);
                            }
                        },
                        {
                            key: "lerp",
                            value: function(e1, t, r, o) {
                                return e1 instanceof u.default.Vector ? this.lerp(e1.x, e1.y, e1.z, t) : (this.x += (e1 - this.x) * o || 0, this.y += (t - this.y) * o || 0, this.z += (r - this.z) * o || 0, this);
                            }
                        },
                        {
                            key: "slerp",
                            value: function(e1, t) {
                                if (0 !== t) {
                                    if (1 === t) return this.set(e1);
                                    var r = this.mag(), o = e1.mag();
                                    if (0 == r * o) this.mult(1 - t).add(e1.x * t, e1.y * t, e1.z * t);
                                    else {
                                        var n = this.cross(e1), s = n.mag(), i = Math.atan2(s, this.dot(e1));
                                        if (0 < s) n.x /= s, n.y /= s, n.z /= s;
                                        else {
                                            if (i < .5 * Math.PI) return this.mult(1 - t).add(e1.x * t, e1.y * t, e1.z * t), this;
                                            0 === this.z && 0 === e1.z ? n.set(0, 0, 1) : 0 !== this.x ? n.set(this.y, -this.x, 0).normalize() : n.set(1, 0, 0);
                                        }
                                        s = n.cross(this), e1 = 1 - t + t * o / r, n = e1 * Math.cos(t * i), o = e1 * Math.sin(t * i);
                                        this.x = this.x * n + s.x * o, this.y = this.y * n + s.y * o, this.z = this.z * n + s.z * o;
                                    }
                                }
                                return this;
                            }
                        },
                        {
                            key: "reflect",
                            value: function(e1) {
                                e1 = u.default.Vector.normalize(e1);
                                return this.sub(e1.mult(2 * this.dot(e1)));
                            }
                        },
                        {
                            key: "array",
                            value: function() {
                                return [
                                    this.x || 0,
                                    this.y || 0,
                                    this.z || 0
                                ];
                            }
                        },
                        {
                            key: "equals",
                            value: function(e1, t, r) {
                                var o, n, e1 = e1 instanceof u.default.Vector ? (o = e1.x || 0, n = e1.y || 0, e1.z || 0) : Array.isArray(e1) ? (o = e1[0] || 0, n = e1[1] || 0, e1[2] || 0) : (o = e1 || 0, n = t || 0, r || 0);
                                return this.x === o && this.y === n && this.z === e1;
                            }
                        },
                        {
                            key: "clampToZero",
                            value: function() {
                                return this.x = this._clampToZero(this.x), this.y = this._clampToZero(this.y), this.z = this._clampToZero(this.z), this;
                            }
                        },
                        {
                            key: "_clampToZero",
                            value: function(e1) {
                                return Math.abs(+(e1 || 0)) <= Number.EPSILON ? 0 : e1;
                            }
                        }
                    ], l(e1.prototype, t), r && l(e1, r), n;
                }();
                var n = u.default.Vector;
                r.default = n;
            },
            {
                "../core/constants": 272,
                "../core/main": 283,
                "core-js/modules/es.array.concat": 153,
                "core-js/modules/es.array.every": 155,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.some": 170,
                "core-js/modules/es.math.sign": 178,
                "core-js/modules/es.number.constructor": 179,
                "core-js/modules/es.number.epsilon": 180,
                "core-js/modules/es.number.is-finite": 181,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.string.sub": 208,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        317: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                var s = "_lcg_random_state", o = 4294967296, i = 0, e1 = (n.default.prototype._lcg = function(e1) {
                    return this[e1] = (1664525 * this[e1] + 1013904223) % o, this[e1] / o;
                }, n.default.prototype._lcgSetSeed = function(e1, t) {
                    this[e1] = (null == t ? Math.random() * o : t) >>> 0;
                }, n.default.prototype.randomSeed = function(e1) {
                    this._lcgSetSeed(s, e1), this._gaussian_previous = !1;
                }, n.default.prototype.random = function(e1, t) {
                    var r, o;
                    return n.default._validateParameters("random", arguments), r = null != this[s] ? this._lcg(s) : Math.random(), void 0 === e1 ? r : void 0 === t ? Array.isArray(e1) ? e1[Math.floor(r * e1.length)] : r * e1 : (t < e1 && (o = e1, e1 = t, t = o), r * (t - e1) + e1);
                }, n.default.prototype.randomGaussian = function(e1) {
                    var t, r, o, n, s = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 1;
                    if (this._gaussian_previous) t = i, this._gaussian_previous = !1;
                    else {
                        for(; 1 <= (n = (r = this.random(2) - 1) * r + (o = this.random(2) - 1) * o););
                        t = r * (n = Math.sqrt(-2 * Math.log(n) / n)), i = o * n, this._gaussian_previous = !0;
                    }
                    return t * s + (e1 || 0);
                }, n.default);
                r.default = e1;
            },
            {
                "../core/main": 283
            }
        ],
        318: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (l = e1("../core/main")) && l.__esModule ? l : {
                    default: l
                }, s = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                n.default.prototype._angleMode = s.RADIANS, n.default.prototype.acos = function(e1) {
                    return this._fromRadians(Math.acos(e1));
                }, n.default.prototype.asin = function(e1) {
                    return this._fromRadians(Math.asin(e1));
                }, n.default.prototype.atan = function(e1) {
                    return this._fromRadians(Math.atan(e1));
                }, n.default.prototype.atan2 = function(e1, t) {
                    return this._fromRadians(Math.atan2(e1, t));
                }, n.default.prototype.cos = function(e1) {
                    return Math.cos(this._toRadians(e1));
                }, n.default.prototype.sin = function(e1) {
                    return Math.sin(this._toRadians(e1));
                }, n.default.prototype.tan = function(e1) {
                    return Math.tan(this._toRadians(e1));
                }, n.default.prototype.degrees = function(e1) {
                    return e1 * s.RAD_TO_DEG;
                }, n.default.prototype.radians = function(e1) {
                    return e1 * s.DEG_TO_RAD;
                }, n.default.prototype.angleMode = function(e1) {
                    if (n.default._validateParameters("angleMode", arguments), void 0 === e1) return this._angleMode;
                    e1 !== s.DEGREES && e1 !== s.RADIANS || e1 !== this._angleMode && (e1 === s.RADIANS ? (this._setProperty("pRotationX", this.pRotationX * s.DEG_TO_RAD), this._setProperty("pRotationY", this.pRotationY * s.DEG_TO_RAD), this._setProperty("pRotationZ", this.pRotationZ * s.DEG_TO_RAD)) : (this._setProperty("pRotationX", this.pRotationX * s.RAD_TO_DEG), this._setProperty("pRotationY", this.pRotationY * s.RAD_TO_DEG), this._setProperty("pRotationZ", this.pRotationZ * s.RAD_TO_DEG)), this._angleMode = e1);
                }, n.default.prototype._toRadians = function(e1) {
                    return this._angleMode === s.DEGREES ? e1 * s.DEG_TO_RAD : e1;
                }, n.default.prototype._toDegrees = function(e1) {
                    return this._angleMode === s.RADIANS ? e1 * s.RAD_TO_DEG : e1;
                }, n.default.prototype._fromRadians = function(e1) {
                    return this._angleMode === s.DEGREES ? e1 * s.RAD_TO_DEG : e1;
                }, n.default.prototype._fromDegrees = function(e1) {
                    return this._angleMode === s.RADIANS ? e1 * s.DEG_TO_RAD : e1;
                };
                var l = n.default;
                r.default = l;
            },
            {
                "../core/constants": 272,
                "../core/main": 283,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        319: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var i = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                i.default.prototype.textAlign = function(e1, t) {
                    var r;
                    return i.default._validateParameters("textAlign", arguments), (r = this._renderer).textAlign.apply(r, arguments);
                }, i.default.prototype.textLeading = function(e1) {
                    var t;
                    return i.default._validateParameters("textLeading", arguments), (t = this._renderer).textLeading.apply(t, arguments);
                }, i.default.prototype.textSize = function(e1) {
                    var t;
                    return i.default._validateParameters("textSize", arguments), (t = this._renderer).textSize.apply(t, arguments);
                }, i.default.prototype.textStyle = function(e1) {
                    var t;
                    return i.default._validateParameters("textStyle", arguments), (t = this._renderer).textStyle.apply(t, arguments);
                }, i.default.prototype.textWidth = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    if (t[0] += "", i.default._validateParameters("textWidth", t), 0 === t[0].length) return 0;
                    for(var o = t[0].replace(/\t/g, "  ").split(/\r?\n|\r|\n/g), n = [], s = 0; s < o.length; s++)n.push(this._renderer.textWidth(o[s]));
                    return Math.max.apply(Math, n);
                }, i.default.prototype.textAscent = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    return i.default._validateParameters("textAscent", t), this._renderer.textAscent();
                }, i.default.prototype.textDescent = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    return i.default._validateParameters("textDescent", t), this._renderer.textDescent();
                }, i.default.prototype._updateTextMetrics = function() {
                    return this._renderer._updateTextMetrics();
                }, i.default.prototype.textWrap = function(e1) {
                    return i.default._validateParameters("textWrap", [
                        e1
                    ]), this._renderer.textWrap(e1);
                };
                e1 = i.default;
                r.default = e1;
            },
            {
                "../core/main": 283,
                "core-js/modules/es.regexp.exec": 195,
                "core-js/modules/es.string.replace": 204,
                "core-js/modules/es.string.split": 206
            }
        ],
        320: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.last-index-of"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.last-index-of"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.split"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var l = (c = e1("../core/main")) && c.__esModule ? c : {
                    default: c
                }, n = s(e1("../core/constants")), u = s(e1("opentype.js"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function s(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o, n = {}, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1)Object.prototype.hasOwnProperty.call(e1, r) && ((o = s ? Object.getOwnPropertyDescriptor(e1, r) : null) && (o.get || o.set) ? Object.defineProperty(n, r, o) : n[r] = e1[r]);
                    return n.default = e1, t && t.set(e1, n), n;
                }
                e1("../core/friendly_errors/validate_params"), e1("../core/friendly_errors/file_errors"), e1("../core/friendly_errors/fes_core"), l.default.prototype.loadFont = function(o, n, s) {
                    l.default._validateParameters("loadFont", arguments);
                    var i = new l.default.Font(this), a = this;
                    return u.load(o, function(e1, t) {
                        if (e1) return l.default._friendlyFileLoadError(4, o), void 0 !== s ? s(e1) : void console.error(e1, o);
                        i.font = t, void 0 !== n && n(i), a._decrementPreload();
                        var e1 = o.split("\\").pop().split("/").pop(), t = e1.lastIndexOf("."), r = t < 1 ? null : e1.slice(t + 1);
                        [
                            "ttf",
                            "otf",
                            "woff",
                            "woff2"
                        ].includes(r) && (r = e1.slice(0, -1 !== t ? t : 0), (e1 = document.createElement("style")).appendChild(document.createTextNode("\n@font-face {\nfont-family: ".concat(r, ";\nsrc: url(").concat(o, ");\n}\n"))), document.head.appendChild(e1));
                    }), i;
                }, l.default.prototype.text = function(e1, t, r, o, n) {
                    var s;
                    return l.default._validateParameters("text", arguments), this._renderer._doFill || this._renderer._doStroke ? (s = this._renderer).text.apply(s, arguments) : this;
                }, l.default.prototype.textFont = function(e1, t) {
                    if (l.default._validateParameters("textFont", arguments), arguments.length) {
                        if (e1) return this._renderer._setProperty("_textFont", e1), t && (this._renderer._setProperty("_textSize", t), this._renderer._leadingSet || this._renderer._setProperty("_textLeading", t * n._DEFAULT_LEADMULT)), this._renderer._applyTextProperties();
                        throw new Error("null font passed to textFont");
                    }
                    return this._renderer._textFont;
                };
                var c = l.default;
                r.default = c;
            },
            {
                "../core/constants": 272,
                "../core/friendly_errors/fes_core": 274,
                "../core/friendly_errors/file_errors": 275,
                "../core/friendly_errors/validate_params": 278,
                "../core/main": 283,
                "core-js/modules/es.array.concat": 153,
                "core-js/modules/es.array.includes": 163,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.last-index-of": 167,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.regexp.exec": 195,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.string.split": 206,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246,
                "opentype.js": 257
            }
        ],
        321: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                }, v = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== x(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = i();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function i() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, i = function() {
                        return e1;
                    }, e1);
                }
                function x(e1) {
                    return (x = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function w(e1, t) {
                    var r = e1.length;
                    return e1[t < 0 ? t % r + r : t % r];
                }
                function S(e1, t, r, o) {
                    var n, s, i;
                    return o ? (void 0 === S.tmpPoint1 && (S.tmpPoint1 = [], S.tmpPoint2 = []), s = S.tmpPoint1, i = S.tmpPoint2, s.x = t.x - e1.x, s.y = t.y - e1.y, i.x = r.x - t.x, i.y = r.y - t.y, n = s.x * i.x + s.y * i.y, s = Math.sqrt(s.x * s.x + s.y * s.y), i = Math.sqrt(i.x * i.x + i.y * i.y), Math.acos(n / (s * i)) < o) : 0 == (t[0] - e1[0]) * (r[1] - e1[1]) - (r[0] - e1[0]) * (t[1] - e1[1]);
                }
                function d(e1, t, r, o, n, s, i, a, l) {
                    var u = 1 - l, c = Math.pow(u, 3), d = Math.pow(u, 2), h = l * l, f = h * l, p = c * e1 + 3 * d * l * r + 3 * u * l * l * n + f * i, c = c * t + 3 * d * l * o + 3 * u * l * l * s + f * a, d = e1 + 2 * l * (r - e1) + h * (n - 2 * r + e1), f = t + 2 * l * (o - t) + h * (s - 2 * o + t), m = r + 2 * l * (n - r) + h * (i - 2 * n + r), h = o + 2 * l * (s - o) + h * (a - 2 * s + o), e1 = u * e1 + l * r, r = u * t + l * o, t = u * n + l * i, o = u * s + l * a, n = 90 - 180 * Math.atan2(d - m, f - h) / Math.PI;
                    return (m < d || f < h) && (n += 180), {
                        x: p,
                        y: c,
                        m: {
                            x: d,
                            y: f
                        },
                        n: {
                            x: m,
                            y: h
                        },
                        start: {
                            x: e1,
                            y: r
                        },
                        end: {
                            x: t,
                            y: o
                        },
                        alpha: n
                    };
                }
                function h(e1, t, r, o, n, s, i, a, l) {
                    return null == l ? f(e1, t, r, o, n, s, i, a) : d(e1, t, r, o, n, s, i, a, function(e1, t, r, o, n, s, i, a, l) {
                        if (!(l < 0 || f(e1, t, r, o, n, s, i, a) < l)) {
                            var u, c = .5, d = 1 - c;
                            for(u = f(e1, t, r, o, n, s, i, a, d); .01 < Math.abs(u - l);)u = f(e1, t, r, o, n, s, i, a, d += (u < l ? 1 : -1) * (c /= 2));
                            return d;
                        }
                    }(e1, t, r, o, n, s, i, a, l));
                }
                function T(e1, t, r) {
                    for(var o, n, s, i, a, l = 0, u = 0, c = (e1 = function(e1, t) {
                        function r(e1, t, r) {
                            var o, n;
                            if (!e1) return [
                                "C",
                                t.x,
                                t.y,
                                t.x,
                                t.y,
                                t.x,
                                t.y
                            ];
                            switch(e1[0] in {
                                T: 1,
                                Q: 1
                            } || (t.qx = t.qy = null), e1[0]){
                                case "M":
                                    t.X = e1[1], t.Y = e1[2];
                                    break;
                                case "A":
                                    e1 = [
                                        "C"
                                    ].concat(E.apply(0, [
                                        t.x,
                                        t.y
                                    ].concat(e1.slice(1))));
                                    break;
                                case "S":
                                    n = "C" === r || "S" === r ? (o = 2 * t.x - t.bx, 2 * t.y - t.by) : (o = t.x, t.y), e1 = [
                                        "C",
                                        o,
                                        n
                                    ].concat(e1.slice(1));
                                    break;
                                case "T":
                                    "Q" === r || "T" === r ? (t.qx = 2 * t.x - t.qx, t.qy = 2 * t.y - t.qy) : (t.qx = t.x, t.qy = t.y), e1 = [
                                        "C"
                                    ].concat(M(t.x, t.y, t.qx, t.qy, e1[1], e1[2]));
                                    break;
                                case "Q":
                                    t.qx = e1[1], t.qy = e1[2], e1 = [
                                        "C"
                                    ].concat(M(t.x, t.y, e1[1], e1[2], e1[3], e1[4]));
                                    break;
                                case "L":
                                    e1 = [
                                        "C"
                                    ].concat(j(t.x, t.y, e1[1], e1[2]));
                                    break;
                                case "H":
                                    e1 = [
                                        "C"
                                    ].concat(j(t.x, t.y, e1[1], t.y));
                                    break;
                                case "V":
                                    e1 = [
                                        "C"
                                    ].concat(j(t.x, t.y, t.x, e1[1]));
                                    break;
                                case "Z":
                                    e1 = [
                                        "C"
                                    ].concat(j(t.x, t.y, t.X, t.Y));
                            }
                            return e1;
                        }
                        function o(e1, t) {
                            if (7 < e1[t].length) {
                                e1[t].shift();
                                for(var r = e1[t]; r.length;)c[t] = "A", a && (d[t] = "A"), e1.splice(t++, 0, [
                                    "C"
                                ].concat(r.splice(0, 6)));
                                e1.splice(t, 1), s = Math.max(i.length, a && a.length || 0);
                            }
                        }
                        function n(e1, t, r, o, n) {
                            e1 && t && "M" === e1[n][0] && "M" !== t[n][0] && (t.splice(n, 0, [
                                "M",
                                o.x,
                                o.y
                            ]), r.bx = 0, r.by = 0, r.x = e1[n][1], r.y = e1[n][2], s = Math.max(i.length, a && a.length || 0));
                        }
                        var s, i = b(e1), a = t && b(t), l = {
                            x: 0,
                            y: 0,
                            bx: 0,
                            by: 0,
                            X: 0,
                            Y: 0,
                            qx: null,
                            qy: null
                        }, u = {
                            x: 0,
                            y: 0,
                            bx: 0,
                            by: 0,
                            X: 0,
                            Y: 0,
                            qx: null,
                            qy: null
                        }, c = [], d = [], h = "", f = "";
                        s = Math.max(i.length, a && a.length || 0);
                        for(var p = 0; p < s; p++){
                            "C" !== (h = i[p] ? i[p][0] : h) && (c[p] = h, p && (f = c[p - 1])), i[p] = r(i[p], l, f), "A" !== c[p] && "C" === h && (c[p] = "C"), o(i, p), a && ("C" !== (h = a[p] ? a[p][0] : h) && (d[p] = h, p && (f = d[p - 1])), a[p] = r(a[p], u, f), "A" !== d[p] && "C" === h && (d[p] = "C"), o(a, p)), n(i, a, l, u, p), n(a, i, u, l, p);
                            var m = i[p], y = a && a[p], g = m.length, v = a && y.length;
                            l.x = m[g - 2], l.y = m[g - 1], l.bx = parseFloat(m[g - 4]) || l.x, l.by = parseFloat(m[g - 3]) || l.y, u.bx = a && (parseFloat(y[v - 4]) || u.x), u.by = a && (parseFloat(y[v - 3]) || u.y), u.x = a && y[v - 2], u.y = a && y[v - 1];
                        }
                        return a ? [
                            i,
                            a
                        ] : i;
                    }(e1)).length; u < c; u++){
                        if ("M" === (s = e1[u])[0]) o = +s[1], n = +s[2];
                        else {
                            if (t < l + (i = h(o, n, s[1], s[2], s[3], s[4], s[5], s[6])) && !r) return {
                                x: (a = h(o, n, s[1], s[2], s[3], s[4], s[5], s[6], t - l)).x,
                                y: a.y,
                                alpha: a.alpha
                            };
                            l += i, o = +s[5], n = +s[6];
                        }
                        s.shift();
                    }
                    return a = (a = r ? l : d(o, n, s[0], s[1], s[2], s[3], s[4], s[5], 1)).alpha ? {
                        x: a.x,
                        y: a.y,
                        alpha: a.alpha
                    } : a;
                }
                function b(e1) {
                    var t = [], r = 0, o = 0, n = 0, s = 0, i = 0;
                    if (e1) {
                        "M" === e1[0][0] && (n = r = +e1[0][1], s = o = +e1[0][2], i++, t[0] = [
                            "M",
                            r,
                            o
                        ]);
                        for(var a, l, u = 3 === e1.length && "M" === e1[0][0] && "R" === e1[1][0].toUpperCase() && "Z" === e1[2][0].toUpperCase(), c = i, d = e1.length; c < d; c++){
                            if (t.push(a = []), (l = e1[c])[0] !== l[0].toUpperCase()) switch(a[0] = l[0].toUpperCase(), a[0]){
                                case "A":
                                    a[1] = l[1], a[2] = l[2], a[3] = l[3], a[4] = l[4], a[5] = l[5], a[6] = +(l[6] + r), a[7] = +(l[7] + o);
                                    break;
                                case "V":
                                    a[1] = +l[1] + o;
                                    break;
                                case "H":
                                    a[1] = +l[1] + r;
                                    break;
                                case "R":
                                    for(var h, f = 2, p = (h = [
                                        r,
                                        o
                                    ].concat(l.slice(1))).length; f < p; f++)h[f] = +h[f] + r, h[++f] = +h[f] + o;
                                    t.pop(), t = t.concat(_(h, u));
                                    break;
                                case "M":
                                    n = +l[1] + r, s = +l[2] + o;
                                    break;
                                default:
                                    for(var m = 1, y = l.length; m < y; m++)a[m] = +l[m] + (m % 2 ? r : o);
                            }
                            else if ("R" === l[0]) h = [
                                r,
                                o
                            ].concat(l.slice(1)), t.pop(), t = t.concat(_(h, u)), a = [
                                "R"
                            ].concat(l.slice(-2));
                            else for(var g = 0, v = l.length; g < v; g++)a[g] = l[g];
                            switch(a[0]){
                                case "Z":
                                    r = n, o = s;
                                    break;
                                case "H":
                                    r = a[1];
                                    break;
                                case "V":
                                    o = a[1];
                                    break;
                                case "M":
                                    n = a[a.length - 2], s = a[a.length - 1];
                                    break;
                                default:
                                    r = a[a.length - 2], o = a[a.length - 1];
                            }
                        }
                    }
                    return t;
                }
                function E(e1, t, r, o, n, s, i, a, l, u) {
                    function c(e1, t, r) {
                        return {
                            x: e1 * Math.cos(r) - t * Math.sin(r),
                            y: e1 * Math.sin(r) + t * Math.cos(r)
                        };
                    }
                    var d, h = Math.PI, f = 120 * h / 180, p = h / 180 * (+n || 0), m = [], y = (u ? (x = u[0], d = u[1], _ = u[2], j = u[3]) : (e1 = (v = c(e1, t, -p)).x, t = v.y, 1 < (y = (g = (e1 - (a = (v = c(a, l, -p)).x)) / 2) * g / (r * r) + (v = (t - (l = v.y)) / 2) * v / (o * o)) && (r *= y = Math.sqrt(y), o *= y), y = r * r, b = o * o, _ = (s = (s === i ? -1 : 1) * Math.sqrt(Math.abs((y * b - y * v * v - b * g * g) / (y * v * v + b * g * g)))) * r * v / o + (e1 + a) / 2, j = s * -o * g / r + (t + l) / 2, x = Math.asin(((t - j) / o).toFixed(9)), d = Math.asin(((l - j) / o).toFixed(9)), (x = e1 < _ ? h - x : x) < 0 && (x = 2 * h + x), (d = a < _ ? h - d : d) < 0 && (d = 2 * h + d), i && d < x && (x -= 2 * h), !i && x < d && (d -= 2 * h)), d - x), g = (Math.abs(y) > f && (b = d, v = a, s = l, d = x + f * (i && x < d ? 1 : -1), m = E(a = _ + r * Math.cos(d), l = j + o * Math.sin(d), r, o, n, 0, i, v, s, [
                        d,
                        b,
                        _,
                        j
                    ])), y = d - x, Math.cos(x)), h = Math.sin(x), f = Math.cos(d), n = Math.sin(d), i = Math.tan(y / 4), v = 4 / 3 * r * i, s = 4 / 3 * o * i, b = [
                        e1,
                        t
                    ], _ = [
                        e1 + v * h,
                        t - s * g
                    ], j = [
                        a + v * n,
                        l - s * f
                    ], x = [
                        a,
                        l
                    ];
                    if (_[0] = 2 * b[0] - _[0], _[1] = 2 * b[1] - _[1], u) return [
                        _,
                        j,
                        x
                    ].concat(m);
                    for(var w = [], S = 0, T = (m = [
                        _,
                        j,
                        x
                    ].concat(m).join().split(",")).length; S < T; S++)w[S] = S % 2 ? c(m[S - 1], m[S], p).y : c(m[S], m[S + 1], p).x;
                    return w;
                }
                function _(e1, t) {
                    for(var r = [], o = 0, n = e1.length; o < n - 2 * !t; o += 2){
                        var s = [
                            {
                                x: +e1[o - 2],
                                y: +e1[o - 1]
                            },
                            {
                                x: +e1[o],
                                y: +e1[o + 1]
                            },
                            {
                                x: +e1[o + 2],
                                y: +e1[o + 3]
                            },
                            {
                                x: +e1[o + 4],
                                y: +e1[o + 5]
                            }
                        ];
                        t ? o ? n - 4 === o ? s[3] = {
                            x: +e1[0],
                            y: +e1[1]
                        } : n - 2 === o && (s[2] = {
                            x: +e1[0],
                            y: +e1[1]
                        }, s[3] = {
                            x: +e1[2],
                            y: +e1[3]
                        }) : s[0] = {
                            x: +e1[n - 2],
                            y: +e1[n - 1]
                        } : n - 4 === o ? s[3] = s[2] : o || (s[0] = {
                            x: +e1[o],
                            y: +e1[o + 1]
                        }), r.push([
                            "C",
                            (-s[0].x + 6 * s[1].x + s[2].x) / 6,
                            (-s[0].y + 6 * s[1].y + s[2].y) / 6,
                            (s[1].x + 6 * s[2].x - s[3].x) / 6,
                            (s[1].y + 6 * s[2].y - s[3].y) / 6,
                            s[2].x,
                            s[2].y
                        ]);
                    }
                    return r;
                }
                function j(e1, t, r, o) {
                    return [
                        e1,
                        t,
                        r,
                        o,
                        r,
                        o
                    ];
                }
                function M(e1, t, r, o, n, s) {
                    return [
                        1 / 3 * e1 + 2 / 3 * r,
                        1 / 3 * t + 2 / 3 * o,
                        1 / 3 * n + 2 / 3 * r,
                        1 / 3 * s + 2 / 3 * o,
                        n,
                        s
                    ];
                }
                function f(e1, t, r, o, n, s, i, a, l) {
                    for(var u = (l = 1 < (l = null == l ? 1 : l) ? 1 : l < 0 ? 0 : l) / 2, c = [
                        -0.1252,
                        .1252,
                        -0.3678,
                        .3678,
                        -0.5873,
                        .5873,
                        -0.7699,
                        .7699,
                        -0.9041,
                        .9041,
                        -0.9816,
                        .9816
                    ], d = 0, h = [
                        .2491,
                        .2491,
                        .2335,
                        .2335,
                        .2032,
                        .2032,
                        .1601,
                        .1601,
                        .1069,
                        .1069,
                        .0472,
                        .0472
                    ], f = 0; f < 12; f++){
                        var p = u * c[f] + u, m = y(p, e1, r, n, i), p = y(p, t, o, s, a);
                        d += h[f] * Math.sqrt(m * m + p * p);
                    }
                    return u * d;
                }
                function y(e1, t, r, o, n) {
                    return e1 * (e1 * (-3 * t + 9 * r - 9 * o + 3 * n) + 6 * t - 12 * r + 6 * o) - 3 * t + 3 * r;
                }
                n.default.Font = function() {
                    function t(e1) {
                        if (!(this instanceof t)) throw new TypeError("Cannot call a class as a function");
                        this.parent = e1, this.cache = {}, this.font = void 0;
                    }
                    var e1, r, o;
                    return e1 = t, r = [
                        {
                            key: "textBounds",
                            value: function(e1) {
                                var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 0, r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 0, o = 3 < arguments.length ? arguments[3] : void 0, n = 4 < arguments.length ? arguments[4] : void 0, s = n && n.renderer && n.renderer._pInst || this.parent, i = s._renderer.drawingContext, o = (i.textAlign || v.LEFT, i.textBaseline || v.BASELINE, o || s._renderer._textSize);
                                if (!g) {
                                    for(var a = [], l = [], u = [], c = (u[0] = [], []), d = this._scale(o), h = s._renderer.textLeading(), f = 0, p = (this.font.forEachGlyph(e1, t, r, o, n, function(e1, t, r, o) {
                                        var n = e1.getMetrics();
                                        0 === e1.index ? u[f += 1] = [] : (u[f].push(t + n.xMin * d), u[f].push(t + n.xMax * d), c.push(r + f * h + -n.yMin * d), c.push(r + f * h + -n.yMax * d));
                                    }), 0 < u[f].length && (a[f] = Math.min.apply(null, u[f]), l[f] = Math.max.apply(null, u[f])), 0), m = 0; m <= f; m++){
                                        a[m] = Math.min.apply(null, u[m]), l[m] = Math.max.apply(null, u[m]);
                                        var y = l[m] - a[m];
                                        p < y && (p = y);
                                    }
                                    var i = Math.min.apply(null, a), g = {
                                        x: i,
                                        y: r = Math.min.apply(null, c),
                                        h: Math.max.apply(null, c) - r,
                                        w: p,
                                        advance: i - t
                                    }, o = this._handleAlignment(s._renderer, e1, g.x, g.y, g.w + g.advance);
                                    g.x = o.x, g.y = o.y;
                                }
                                return g;
                            }
                        },
                        {
                            key: "textToPoints",
                            value: function(e1, t, r, o, n) {
                                var s, i = t, a = [], l = this.parent, u = e1.split(/\r?\n|\r|\n/g);
                                o = o || this.parent._renderer._textSize;
                                for(var c, d, h, f = 0; f < u.length; f++){
                                    var p = 0;
                                    t = i;
                                    for(var m = (m = u[f]).replace(/\t/g, "  "), y = this._getGlyphs(m), g = 0; g < y.length; g++){
                                        if (d = m, !((h = y)[c = g].name && "space" === h[c].name || d.length === h.length && " " === d[c])) for(var v = function(e1) {
                                            for(var t, r = [], o = 0; o < e1.length; o++)"M" === e1[o].type && (t && r.push(t), t = []), t.push(function(e1) {
                                                var t = [
                                                    e1.type
                                                ];
                                                "M" === e1.type || "L" === e1.type ? t.push(e1.x, e1.y) : "C" === e1.type ? t.push(e1.x1, e1.y1, e1.x2, e1.y2, e1.x, e1.y) : "Q" === e1.type && t.push(e1.x1, e1.y1, e1.x, e1.y);
                                                return t;
                                            }(e1[o]));
                                            return r.push(t), r;
                                        }(y[g].getPath(t, r, o).commands), b = 0; b < v.length; b++)for(var _ = function(e1, t) {
                                            for(var t = function(e1, t) {
                                                if ("object" !== x(e1)) e1 = t;
                                                else for(var r in t)void 0 === e1[r] && (e1[r] = t[r]);
                                                return e1;
                                            }(t, {
                                                sampleFactor: .1,
                                                simplifyThreshold: 0
                                            }), r = T(e1, 0, 1), o = r / (r * t.sampleFactor), n = [], s = 0; s < r; s += o)n.push(T(e1, s));
                                            t.simplifyThreshold && !function(e1) {
                                                for(var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 0, r = 0, o = e1.length - 1; 3 < e1.length && 0 <= o; --o)S(w(e1, o - 1), w(e1, o), w(e1, o + 1), t) && (e1.splice(o % e1.length, 1), r++);
                                            }(n, t.simplifyThreshold);
                                            return n;
                                        }(v[b], n), j = 0; j < _.length; j++)_[j].x += p, s = this._handleAlignment(l._renderer, m, _[j].x, _[j].y), _[j].x = s.x, _[j].y = s.y, a.push(_[j]);
                                        p += y[g].advanceWidth * this._scale(o);
                                    }
                                    r += this.parent._renderer._textLeading;
                                }
                                return a;
                            }
                        },
                        {
                            key: "_getGlyphs",
                            value: function(e1) {
                                return this.font.stringToGlyphs(e1);
                            }
                        },
                        {
                            key: "_getPath",
                            value: function(e1, t, r, o) {
                                var n = (o && o.renderer && o.renderer._pInst || this.parent)._renderer, t = this._handleAlignment(n, e1, t, r);
                                return this.font.getPath(e1, t.x, t.y, n._textSize, o);
                            }
                        },
                        {
                            key: "_getPathData",
                            value: function(e1, t, r, o) {
                                var n = 3;
                                return "string" == typeof e1 && 2 < arguments.length ? e1 = this._getPath(e1, t, r, o) : "object" === x(t) && (o = t), o && "number" == typeof o.decimals && (n = o.decimals), e1.toPathData(n);
                            }
                        },
                        {
                            key: "_getSVG",
                            value: function(e1, t, r, o) {
                                var n = 3;
                                return "string" == typeof e1 && 2 < arguments.length ? e1 = this._getPath(e1, t, r, o) : "object" === x(t) && (o = t), o && ("number" == typeof o.decimals && (n = o.decimals), "number" == typeof o.strokeWidth && (e1.strokeWidth = o.strokeWidth), void 0 !== o.fill && (e1.fill = o.fill), void 0 !== o.stroke && (e1.stroke = o.stroke)), e1.toSVG(n);
                            }
                        },
                        {
                            key: "_renderPath",
                            value: function(e1, t, r, o) {
                                var n = o && o.renderer || this.parent._renderer, s = n.drawingContext, e1 = ("object" === x(e1) && e1.commands ? e1 : this._getPath(e1, t, r, o)).commands, i = (n._clipping || s.beginPath(), !0), t = !1, r = void 0;
                                try {
                                    for(var a, l = e1[Symbol.iterator](); !(i = (a = l.next()).done); i = !0){
                                        var u = a.value;
                                        "M" === u.type ? s.moveTo(u.x, u.y) : "L" === u.type ? s.lineTo(u.x, u.y) : "C" === u.type ? s.bezierCurveTo(u.x1, u.y1, u.x2, u.y2, u.x, u.y) : "Q" === u.type ? s.quadraticCurveTo(u.x1, u.y1, u.x, u.y) : "Z" === u.type && s.closePath();
                                    }
                                } catch (e1) {
                                    t = !0, r = e1;
                                } finally{
                                    try {
                                        i || null == l.return || l.return();
                                    } finally{
                                        if (t) throw r;
                                    }
                                }
                                return n._doStroke && n._strokeSet && !n._clipping && s.stroke(), n._doFill && !n._clipping && (n._fillSet || n._setFill(v._DEFAULT_TEXT_FILL), s.fill()), this;
                            }
                        },
                        {
                            key: "_textWidth",
                            value: function(e1, t) {
                                return this.font.getAdvanceWidth(e1, t);
                            }
                        },
                        {
                            key: "_textAscent",
                            value: function(e1) {
                                return this.font.ascender * this._scale(e1);
                            }
                        },
                        {
                            key: "_textDescent",
                            value: function(e1) {
                                return -this.font.descender * this._scale(e1);
                            }
                        },
                        {
                            key: "_scale",
                            value: function(e1) {
                                return 1 / this.font.unitsPerEm * (e1 || this.parent._renderer._textSize);
                            }
                        },
                        {
                            key: "_handleAlignment",
                            value: function(e1, t, r, o, n) {
                                var s = e1._textSize;
                                switch(void 0 === n && (n = this._textWidth(t, s)), e1._textAlign){
                                    case v.CENTER:
                                        r -= n / 2;
                                        break;
                                    case v.RIGHT:
                                        r -= n;
                                }
                                switch(e1._textBaseline){
                                    case v.TOP:
                                        o += this._textAscent(s);
                                        break;
                                    case v.CENTER:
                                        o += this._textAscent(s) / 2;
                                        break;
                                    case v.BOTTOM:
                                        o -= this._textDescent(s);
                                }
                                return {
                                    x: r,
                                    y: o
                                };
                            }
                        }
                    ], s(e1.prototype, r), o && s(e1, o), t;
                }();
                e1 = n.default;
                r.default = e1;
            },
            {
                "../core/constants": 272,
                "../core/main": 283,
                "core-js/modules/es.array.concat": 153,
                "core-js/modules/es.array.fill": 156,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.join": 166,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.array.splice": 171,
                "core-js/modules/es.function.name": 174,
                "core-js/modules/es.number.to-fixed": 182,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.regexp.exec": 195,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.string.replace": 204,
                "core-js/modules/es.string.split": 206,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        322: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.array-buffer.constructor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.array-buffer.constructor"), e1("core-js/modules/es.object.to-string"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                e1.default.prototype.append = function(e1, t) {
                    return e1.push(t), e1;
                }, e1.default.prototype.arrayCopy = function(e1, t, r, o, n) {
                    var s, i;
                    e1 = void 0 !== n ? (i = Math.min(n, e1.length), s = o, e1.slice(t, i + t)) : (i = void 0 !== r ? (i = r, Math.min(i, e1.length)) : e1.length, r = t, e1.slice(s = 0, i)), Array.prototype.splice.apply(r, [
                        s,
                        i
                    ].concat(e1));
                }, e1.default.prototype.concat = function(e1, t) {
                    return e1.concat(t);
                }, e1.default.prototype.reverse = function(e1) {
                    return e1.reverse();
                }, e1.default.prototype.shorten = function(e1) {
                    return e1.pop(), e1;
                }, e1.default.prototype.shuffle = function(e1, t) {
                    for(var r, o, n = ArrayBuffer && ArrayBuffer.isView && ArrayBuffer.isView(e1), s = (e1 = t || n ? e1 : e1.slice()).length; 1 < s;)r = this.random(0, 1) * s | 0, o = e1[--s], e1[s] = e1[r], e1[r] = o;
                    return e1;
                }, e1.default.prototype.sort = function(e1, t) {
                    var r = t ? e1.slice(0, Math.min(t, e1.length)) : e1, t = t ? e1.slice(Math.min(t, e1.length)) : [];
                    return (r = "string" == typeof r[0] ? r.sort() : r.sort(function(e1, t) {
                        return e1 - t;
                    })).concat(t);
                }, e1.default.prototype.splice = function(e1, t, r) {
                    return Array.prototype.splice.apply(e1, [
                        r,
                        0
                    ].concat(t)), e1;
                }, e1.default.prototype.subset = function(e1, t, r) {
                    return void 0 !== r ? e1.slice(t, t + r) : e1.slice(t, e1.length);
                };
                e1 = e1.default;
                r.default = e1;
            },
            {
                "../core/main": 283,
                "core-js/modules/es.array-buffer.constructor": 152,
                "core-js/modules/es.array.concat": 153,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.array.splice": 171,
                "core-js/modules/es.object.to-string": 190
            }
        ],
        323: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.map"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.repeat"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.repeat"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var o = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                o.default.prototype.float = function(e1) {
                    return e1 instanceof Array ? e1.map(parseFloat) : parseFloat(e1);
                }, o.default.prototype.int = function(e1) {
                    var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 10;
                    return e1 === 1 / 0 || "Infinity" === e1 ? 1 / 0 : e1 === -1 / 0 || "-Infinity" === e1 ? -1 / 0 : "string" == typeof e1 ? parseInt(e1, t) : "number" == typeof e1 ? 0 | e1 : "boolean" == typeof e1 ? e1 ? 1 : 0 : e1 instanceof Array ? e1.map(function(e1) {
                        return o.default.prototype.int(e1, t);
                    }) : void 0;
                }, o.default.prototype.str = function(e1) {
                    return e1 instanceof Array ? e1.map(o.default.prototype.str) : String(e1);
                }, o.default.prototype.boolean = function(e1) {
                    return "number" == typeof e1 ? 0 !== e1 : "string" == typeof e1 ? "true" === e1.toLowerCase() : "boolean" == typeof e1 ? e1 : e1 instanceof Array ? e1.map(o.default.prototype.boolean) : void 0;
                }, o.default.prototype.byte = function(e1) {
                    e1 = o.default.prototype.int(e1, 10);
                    return "number" == typeof e1 ? (e1 + 128) % 256 - 128 : e1 instanceof Array ? e1.map(o.default.prototype.byte) : void 0;
                }, o.default.prototype.char = function(e1) {
                    return "number" != typeof e1 || isNaN(e1) ? e1 instanceof Array ? e1.map(o.default.prototype.char) : "string" == typeof e1 ? o.default.prototype.char(parseInt(e1, 10)) : void 0 : String.fromCharCode(e1);
                }, o.default.prototype.unchar = function(e1) {
                    return "string" == typeof e1 && 1 === e1.length ? e1.charCodeAt(0) : e1 instanceof Array ? e1.map(o.default.prototype.unchar) : void 0;
                }, o.default.prototype.hex = function(e1, t) {
                    if (t = null == t ? 8 : t, e1 instanceof Array) return e1.map(function(e1) {
                        return o.default.prototype.hex(e1, t);
                    });
                    if (e1 === 1 / 0 || e1 === -1 / 0) return (e1 === 1 / 0 ? "F" : "0").repeat(t);
                    if ("number" == typeof e1) {
                        e1 < 0 && (e1 = 4294967295 + e1 + 1);
                        for(var r = Number(e1).toString(16).toUpperCase(); r.length < t;)r = "0".concat(r);
                        return r = r.length >= t ? r.substring(r.length - t, r.length) : r;
                    }
                }, o.default.prototype.unhex = function(e1) {
                    return e1 instanceof Array ? e1.map(o.default.prototype.unhex) : parseInt("0x".concat(e1), 16);
                };
                e1 = o.default;
                r.default = e1;
            },
            {
                "../core/main": 283,
                "core-js/modules/es.array.map": 168,
                "core-js/modules/es.number.constructor": 179,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.repeat": 203
            }
        ],
        324: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.constructor"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.pad-start"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.trim"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.constructor"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.pad-start"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.trim"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = (u = e1("../core/main")) && u.__esModule ? u : {
                    default: u
                };
                function a(e1, t) {
                    return function(e1) {
                        if (Array.isArray(e1)) return e1;
                    }(e1) || function(e1, t) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) {
                            var r = [], o = !0, n = !1, s = void 0;
                            try {
                                for(var i, a = e1[Symbol.iterator](); !(o = (i = a.next()).done) && (r.push(i.value), !t || r.length !== t); o = !0);
                            } catch (e1) {
                                n = !0, s = e1;
                            } finally{
                                try {
                                    o || null == a.return || a.return();
                                } finally{
                                    if (n) throw s;
                                }
                            }
                            return r;
                        }
                    }(e1, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance");
                    }();
                }
                function o(e1, t, r) {
                    var o, n = e1 < 0, s = a((e1 = Math.abs(e1)).toString().split("."), 2), i = s[0], s = s[1];
                    return void 0 === r ? (i = i.padStart(t, "0"), o = s ? i + "." + s : i, n ? "-" + o : o) : (i = (o = a(e1.toFixed(r).toString().split("."), 2))[0], s = o[1], i = i.padStart(t, "0"), e1 = void 0 === s ? i : i + "." + s, n ? "-" + e1 : e1);
                }
                function n(e1, t) {
                    var r = (e1 = e1.toString()).indexOf("."), o = -1 !== r ? e1.substring(r) : "", e1 = (e1 = -1 !== r ? e1.substring(0, r) : e1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    if (0 === t) o = "";
                    else if (void 0 !== t) {
                        if (t > o.length) for(var n = t - (o += -1 === r ? "." : "").length + 1, s = 0; s < n; s++)o += "0";
                        else o = o.substring(0, t + 1);
                    }
                    return e1 + o;
                }
                function i(e1) {
                    return 0 < parseFloat(e1) ? "+".concat(e1.toString()) : e1.toString();
                }
                function l(e1) {
                    return 0 <= parseFloat(e1) ? " ".concat(e1.toString()) : e1.toString();
                }
                e1("../core/friendly_errors/validate_params"), e1("../core/friendly_errors/file_errors"), e1("../core/friendly_errors/fes_core"), s.default.prototype.join = function(e1, t) {
                    return s.default._validateParameters("join", arguments), e1.join(t);
                }, s.default.prototype.match = function(e1, t) {
                    return s.default._validateParameters("match", arguments), e1.match(t);
                }, s.default.prototype.matchAll = function(e1, t) {
                    s.default._validateParameters("matchAll", arguments);
                    for(var r = new RegExp(t, "g"), o = r.exec(e1), n = []; null !== o;)n.push(o), o = r.exec(e1);
                    return n;
                }, s.default.prototype.nf = function(e1, t, r) {
                    return s.default._validateParameters("nf", arguments), e1 instanceof Array ? e1.map(function(e1) {
                        return o(e1, t, r);
                    }) : "[object Arguments]" === Object.prototype.toString.call(e1) ? 3 === e1.length ? this.nf(e1[0], e1[1], e1[2]) : 2 === e1.length ? this.nf(e1[0], e1[1]) : this.nf(e1[0]) : o(e1, t, r);
                }, s.default.prototype.nfc = function(e1, t) {
                    return s.default._validateParameters("nfc", arguments), e1 instanceof Array ? e1.map(function(e1) {
                        return n(e1, t);
                    }) : n(e1, t);
                }, s.default.prototype.nfp = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    s.default._validateParameters("nfp", t);
                    var o = s.default.prototype.nf.apply(this, t);
                    return o instanceof Array ? o.map(i) : i(o);
                }, s.default.prototype.nfs = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    s.default._validateParameters("nfs", t);
                    var o = s.default.prototype.nf.apply(this, t);
                    return o instanceof Array ? o.map(l) : l(o);
                }, s.default.prototype.split = function(e1, t) {
                    return s.default._validateParameters("split", arguments), e1.split(t);
                }, s.default.prototype.splitTokens = function(e1, t) {
                    var r, o;
                    return s.default._validateParameters("splitTokens", arguments), o = void 0 !== t ? (o = /\]/g.exec(t), (r = /\[/g.exec(t)) && o ? (t = t.slice(0, o.index) + t.slice(o.index + 1), r = /\[/g.exec(t), t = t.slice(0, r.index) + t.slice(r.index + 1), new RegExp("[\\[".concat(t, "\\]]"), "g")) : o ? (t = t.slice(0, o.index) + t.slice(o.index + 1), new RegExp("[".concat(t, "\\]]"), "g")) : r ? (t = t.slice(0, r.index) + t.slice(r.index + 1), new RegExp("[".concat(t, "\\[]"), "g")) : new RegExp("[".concat(t, "]"), "g")) : /\s/g, e1.split(o).filter(function(e1) {
                        return e1;
                    });
                }, s.default.prototype.trim = function(e1) {
                    return s.default._validateParameters("trim", arguments), e1 instanceof Array ? e1.map(this.trim) : e1.trim();
                };
                var u = s.default;
                r.default = u;
            },
            {
                "../core/friendly_errors/fes_core": 274,
                "../core/friendly_errors/file_errors": 275,
                "../core/friendly_errors/validate_params": 278,
                "../core/main": 283,
                "core-js/modules/es.array.filter": 157,
                "core-js/modules/es.array.index-of": 164,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.join": 166,
                "core-js/modules/es.array.map": 168,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.number.to-fixed": 182,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.regexp.constructor": 194,
                "core-js/modules/es.regexp.exec": 195,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.string.match": 201,
                "core-js/modules/es.string.pad-start": 202,
                "core-js/modules/es.string.replace": 204,
                "core-js/modules/es.string.split": 206,
                "core-js/modules/es.string.trim": 209,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        325: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                e1.default.prototype.day = function() {
                    return (new Date).getDate();
                }, e1.default.prototype.hour = function() {
                    return (new Date).getHours();
                }, e1.default.prototype.minute = function() {
                    return (new Date).getMinutes();
                }, e1.default.prototype.millis = function() {
                    return -1 === this._millisStart ? 0 : window.performance.now() - this._millisStart;
                }, e1.default.prototype.month = function() {
                    return (new Date).getMonth() + 1;
                }, e1.default.prototype.second = function() {
                    return (new Date).getSeconds();
                }, e1.default.prototype.year = function() {
                    return (new Date).getFullYear();
                };
                e1 = e1.default;
                r.default = e1;
            },
            {
                "../core/main": 283
            }
        ],
        326: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.math.hypot"), e1("core-js/modules/es.math.sign"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.math.hypot"), e1("core-js/modules/es.math.sign"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var S = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                }, j = (e1("./p5.Geometry"), function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants")));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                S.default.prototype.beginGeometry = function() {
                    return this._renderer.beginGeometry();
                }, S.default.prototype.endGeometry = function() {
                    return this._renderer.endGeometry();
                }, S.default.prototype.buildGeometry = function(e1) {
                    return this._renderer.buildGeometry(e1);
                }, S.default.prototype.freeGeometry = function(e1) {
                    this._renderer._freeBuffers(e1.gid);
                }, S.default.prototype.plane = function() {
                    var e1, t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 50, r = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : t, o = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 1, n = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : 1, s = (this._assert3d("plane"), S.default._validateParameters("plane", arguments), "plane|".concat(o, "|").concat(n));
                    return this._renderer.geometryInHash(s) || ((e1 = new S.default.Geometry(o, n, function() {
                        for(var e1, t, r = 0; r <= this.detailY; r++)for(var o = r / this.detailY, n = 0; n <= this.detailX; n++)e1 = n / this.detailX, t = new S.default.Vector(e1 - .5, o - .5, 0), this.vertices.push(t), this.uvs.push(e1, o);
                    })).computeFaces().computeNormals(), o <= 1 && n <= 1 ? e1._makeTriangleEdges()._edgesToVertices() : this._renderer._doStroke && !this._renderer.geometryBuilder && console.log("Cannot draw stroke on plane objects with more than 1 detailX or 1 detailY"), this._renderer.createBuffers(s, e1)), this._renderer.drawBuffersScaled(s, t, r, 1), this;
                }, S.default.prototype.box = function(e1, t, r, o, n) {
                    this._assert3d("box"), S.default._validateParameters("box", arguments), void 0 === e1 && (e1 = 50), void 0 === t && (t = e1), void 0 === r && (r = t);
                    var s, i = this._renderer.attributes && this._renderer.attributes.perPixelLighting, i = (void 0 === n && (n = i ? 1 : 4), "box|".concat(o = void 0 === o ? i ? 1 : 4 : o, "|").concat(n));
                    return this._renderer.geometryInHash(i) || ((s = new S.default.Geometry(o, n, function() {
                        var n = this;
                        this.edges = [
                            [
                                0,
                                1
                            ],
                            [
                                1,
                                3
                            ],
                            [
                                3,
                                2
                            ],
                            [
                                6,
                                7
                            ],
                            [
                                8,
                                9
                            ],
                            [
                                9,
                                11
                            ],
                            [
                                14,
                                15
                            ],
                            [
                                16,
                                17
                            ],
                            [
                                17,
                                19
                            ],
                            [
                                18,
                                19
                            ],
                            [
                                20,
                                21
                            ],
                            [
                                22,
                                23
                            ]
                        ], [
                            [
                                0,
                                4,
                                2,
                                6
                            ],
                            [
                                1,
                                3,
                                5,
                                7
                            ],
                            [
                                0,
                                1,
                                4,
                                5
                            ],
                            [
                                2,
                                6,
                                3,
                                7
                            ],
                            [
                                0,
                                2,
                                1,
                                3
                            ],
                            [
                                4,
                                5,
                                6,
                                7
                            ]
                        ].forEach(function(e1, t) {
                            for(var t = 4 * t, r = 0; r < 4; r++){
                                var o = e1[r], o = new S.default.Vector((2 * (1 & o) - 1) / 2, ((2 & o) - 1) / 2, ((4 & o) / 2 - 1) / 2);
                                n.vertices.push(o), n.uvs.push(1 & r, (2 & r) / 2);
                            }
                            n.faces.push([
                                t,
                                1 + t,
                                2 + t
                            ]), n.faces.push([
                                2 + t,
                                1 + t,
                                3 + t
                            ]);
                        });
                    })).computeNormals(), o <= 4 && n <= 4 ? s._edgesToVertices() : this._renderer._doStroke && !this._renderer.geometryBuilder && console.log("Cannot draw stroke on box objects with more than 4 detailX or 4 detailY"), this._renderer.createBuffers(i, s)), this._renderer.drawBuffersScaled(i, e1, t, r), this;
                }, S.default.prototype.sphere = function() {
                    var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 50, t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 24, r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 16;
                    return this._assert3d("sphere"), S.default._validateParameters("sphere", arguments), this.ellipsoid(e1, e1, e1, t, r), this;
                };
                function l(e1, t, r, o, n, s, i) {
                    e1 = e1 <= 0 ? 1 : e1, t = t < 0 ? 0 : t, r = r <= 0 ? e1 : r, o = o < 3 ? 3 : o;
                    for(var a, l, u = (s = void 0 === s || s) ? -2 : 0, c = (n = n < 1 ? 1 : n) + ((i = void 0 === i ? 0 !== t : i) ? 2 : 0), d = Math.atan2(e1 - t, r), h = Math.sin(d), f = Math.cos(d), p = u; p <= c; ++p){
                        var m = p / n, y = r * m, g = void 0, g = p < 0 ? (m = y = 0, e1) : n < p ? (y = r, m = 1, t) : e1 + (t - e1) * m;
                        for(-2 !== p && p !== n + 2 || (g = 0), y -= r / 2, a = 0; a < o; ++a){
                            var v = a / (o - 1), b = 2 * Math.PI * v, _ = Math.sin(b), b = Math.cos(b), j = (this.vertices.push(new S.default.Vector(_ * g, y, b * g)), void 0), j = p < 0 ? new S.default.Vector(0, -1, 0) : n < p && t ? new S.default.Vector(0, 1, 0) : new S.default.Vector(_ * f, h, b * f);
                            this.vertexNormals.push(j), this.uvs.push(v, m);
                        }
                    }
                    var x = 0;
                    if (s) {
                        for(l = 0; l < o; ++l)this.faces.push([
                            x + l,
                            x + o + (l + 1) % o,
                            x + o + l
                        ]);
                        x += 2 * o;
                    }
                    for(p = 0; p < n; ++p){
                        for(a = 0; a < o; ++a){
                            var w = (a + 1) % o;
                            this.faces.push([
                                x + a,
                                x + w,
                                x + o + w
                            ]), this.faces.push([
                                x + a,
                                x + o + w,
                                x + o + a
                            ]);
                        }
                        x += o;
                    }
                    if (i) for(x += o, a = 0; a < o; ++a)this.faces.push([
                        x + a,
                        x + (a + 1) % o,
                        x + o
                    ]);
                }
                S.default.prototype.cylinder = function() {
                    var e1, t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 50, r = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : t, o = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 24, n = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : 1, s = !(4 < arguments.length && void 0 !== arguments[4]) || arguments[4], i = !(5 < arguments.length && void 0 !== arguments[5]) || arguments[5], a = (this._assert3d("cylinder"), S.default._validateParameters("cylinder", arguments), "cylinder|".concat(o, "|").concat(n, "|").concat(s, "|").concat(i));
                    return this._renderer.geometryInHash(a) || (e1 = new S.default.Geometry(o, n), l.call(e1, 1, 1, 1, o, n, s, i), o <= 24 && n <= 16 ? e1._makeTriangleEdges()._edgesToVertices() : this._renderer._doStroke && !this._renderer.geometryBuilder && console.log("Cannot draw stroke on cylinder objects with more than 24 detailX or 16 detailY"), this._renderer.createBuffers(a, e1)), this._renderer.drawBuffersScaled(a, t, r, t), this;
                }, S.default.prototype.cone = function() {
                    var e1, t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 50, r = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : t, o = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 24, n = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : 1, s = !(4 < arguments.length && void 0 !== arguments[4]) || arguments[4], i = (this._assert3d("cone"), S.default._validateParameters("cone", arguments), "cone|".concat(o, "|").concat(n, "|").concat(s));
                    return this._renderer.geometryInHash(i) || (e1 = new S.default.Geometry(o, n), l.call(e1, 1, 0, 1, o, n, s, !1), o <= 24 && n <= 16 ? e1._makeTriangleEdges()._edgesToVertices() : this._renderer._doStroke && !this._renderer.geometryBuilder && console.log("Cannot draw stroke on cone objects with more than 24 detailX or 16 detailY"), this._renderer.createBuffers(i, e1)), this._renderer.drawBuffersScaled(i, t, r, t), this;
                }, S.default.prototype.ellipsoid = function() {
                    var e1, t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 50, r = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : t, o = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : t, n = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : 24, s = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 16, i = (this._assert3d("ellipsoid"), S.default._validateParameters("ellipsoid", arguments), "ellipsoid|".concat(n, "|").concat(s));
                    return this._renderer.geometryInHash(i) || ((e1 = new S.default.Geometry(n, s, function() {
                        for(var e1 = 0; e1 <= this.detailY; e1++)for(var t = e1 / this.detailY, r = Math.PI * t - Math.PI / 2, o = Math.cos(r), n = Math.sin(r), s = 0; s <= this.detailX; s++){
                            var i = s / this.detailX, a = 2 * Math.PI * i, l = Math.cos(a), a = Math.sin(a), a = new S.default.Vector(o * a, n, o * l);
                            this.vertices.push(a), this.vertexNormals.push(a), this.uvs.push(i, t);
                        }
                    })).computeFaces(), n <= 24 && s <= 24 ? e1._makeTriangleEdges()._edgesToVertices() : this._renderer._doStroke && !this._renderer.geometryBuilder && console.log("Cannot draw stroke on ellipsoids with more than 24 detailX or 24 detailY"), this._renderer.createBuffers(i, e1)), this._renderer.drawBuffersScaled(i, t, r, o), this;
                }, S.default.prototype.torus = function(e1, t, r, o) {
                    if (this._assert3d("torus"), S.default._validateParameters("torus", arguments), void 0 === e1) e1 = 50;
                    else if (!e1) return;
                    if (void 0 === t) t = 10;
                    else if (!t) return;
                    void 0 === r && (r = 24), void 0 === o && (o = 16);
                    var n, d = (t / e1).toPrecision(4), t = "torus|".concat(d, "|").concat(r, "|").concat(o);
                    return this._renderer.geometryInHash(t) || ((n = new S.default.Geometry(r, o, function() {
                        for(var e1 = 0; e1 <= this.detailY; e1++)for(var t = e1 / this.detailY, r = 2 * Math.PI * t, o = Math.cos(r), n = Math.sin(r), s = 1 + d * o, i = 0; i <= this.detailX; i++){
                            var a = i / this.detailX, l = 2 * Math.PI * a, u = Math.cos(l), l = Math.sin(l), c = new S.default.Vector(s * u, s * l, d * n), u = new S.default.Vector(o * u, o * l, n);
                            this.vertices.push(c), this.vertexNormals.push(u), this.uvs.push(a, t);
                        }
                    })).computeFaces(), r <= 24 && o <= 16 ? n._makeTriangleEdges()._edgesToVertices() : this._renderer._doStroke && !this._renderer.geometryBuilder && console.log("Cannot draw strokes on torus object with more than 24 detailX or 16 detailY"), this._renderer.createBuffers(t, n)), this._renderer.drawBuffersScaled(t, e1, e1, e1), this;
                }, S.default.RendererGL.prototype.point = function(e1, t) {
                    var r = [];
                    return r.push(new S.default.Vector(e1, t, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 0)), this._drawPoints(r, this.immediateMode.buffers.point), this;
                }, S.default.RendererGL.prototype.triangle = function(e1) {
                    var t = e1[0], r = e1[1], o = e1[2], n = e1[3], s = e1[4], e1 = e1[5], i = (this.geometryInHash("tri") || ((i = new S.default.Geometry(1, 1, function() {
                        var e1 = [];
                        e1.push(new S.default.Vector(0, 0, 0)), e1.push(new S.default.Vector(1, 0, 0)), e1.push(new S.default.Vector(0, 1, 0)), this.edges = [
                            [
                                0,
                                1
                            ],
                            [
                                1,
                                2
                            ],
                            [
                                2,
                                0
                            ]
                        ], this.vertices = e1, this.faces = [
                            [
                                0,
                                1,
                                2
                            ]
                        ], this.uvs = [
                            0,
                            0,
                            1,
                            0,
                            1,
                            1
                        ];
                    }))._edgesToVertices(), i.computeNormals(), this.createBuffers("tri", i)), this.uModelMatrix.copy());
                    try {
                        var a = Math.sign(t * n - o * r + o * e1 - s * n + s * r - t * e1), l = new S.default.Matrix([
                            o - t,
                            n - r,
                            0,
                            0,
                            s - t,
                            e1 - r,
                            0,
                            0,
                            0,
                            0,
                            a,
                            0,
                            t,
                            r,
                            0,
                            1
                        ]).mult(this.uModelMatrix);
                        this.uModelMatrix = l, this.drawBuffers("tri");
                    } finally{
                        this.uModelMatrix = i;
                    }
                    return this;
                }, S.default.RendererGL.prototype.ellipse = function(e1) {
                    this.arc(e1[0], e1[1], e1[2], e1[3], 0, j.TWO_PI, j.OPEN, e1[4]);
                }, S.default.RendererGL.prototype.arc = function() {
                    var e1, t = arguments.length <= 0 ? void 0 : arguments[0], r = arguments.length <= 1 ? void 0 : arguments[1], o = arguments.length <= 2 ? void 0 : arguments[2], n = arguments.length <= 3 ? void 0 : arguments[3], s = arguments.length <= 4 ? void 0 : arguments[4], i = arguments.length <= 5 ? void 0 : arguments[5], a = arguments.length <= 6 ? void 0 : arguments[6], l = (arguments.length <= 7 ? void 0 : arguments[7]) || 25, u = (Math.abs(i - s) >= j.TWO_PI ? "".concat(c = "ellipse", "|") : "".concat(c = "arc", "|").concat(s, "|").concat(i, "|").concat(a, "|")).concat(l, "|"), c = (this.geometryInHash(u) || ((e1 = new S.default.Geometry(l, 1, function() {
                        if (s.toFixed(10) !== i.toFixed(10)) {
                            a !== j.PIE && void 0 !== a || (this.vertices.push(new S.default.Vector(.5, .5, 0)), this.uvs.push([
                                .5,
                                .5
                            ]));
                            for(var e1 = 0; e1 <= l; e1++){
                                var t = (i - s) * (e1 / l) + s, r = .5 + Math.cos(t) / 2, t = .5 + Math.sin(t) / 2;
                                this.vertices.push(new S.default.Vector(r, t, 0)), this.uvs.push([
                                    r,
                                    t
                                ]), e1 < l - 1 && (this.faces.push([
                                    0,
                                    e1 + 1,
                                    e1 + 2
                                ]), this.edges.push([
                                    e1 + 1,
                                    e1 + 2
                                ]));
                            }
                            switch(a){
                                case j.PIE:
                                    this.faces.push([
                                        0,
                                        this.vertices.length - 2,
                                        this.vertices.length - 1
                                    ]), this.edges.push([
                                        0,
                                        1
                                    ]), this.edges.push([
                                        this.vertices.length - 2,
                                        this.vertices.length - 1
                                    ]), this.edges.push([
                                        0,
                                        this.vertices.length - 1
                                    ]);
                                    break;
                                case j.CHORD:
                                    this.edges.push([
                                        0,
                                        1
                                    ]), this.edges.push([
                                        0,
                                        this.vertices.length - 1
                                    ]);
                                    break;
                                case j.OPEN:
                                    this.edges.push([
                                        0,
                                        1
                                    ]);
                                    break;
                                default:
                                    this.faces.push([
                                        0,
                                        this.vertices.length - 2,
                                        this.vertices.length - 1
                                    ]), this.edges.push([
                                        this.vertices.length - 2,
                                        this.vertices.length - 1
                                    ]);
                            }
                        }
                    })).computeNormals(), l <= 50 ? e1._edgesToVertices(e1) : this._doStroke && console.log("Cannot apply a stroke to an ".concat(c, " with more than 50 detail")), this.createBuffers(u, e1)), this.uModelMatrix.copy());
                    try {
                        this.uModelMatrix.translate([
                            t,
                            r,
                            0
                        ]), this.uModelMatrix.scale(o, n, 1), this.drawBuffers(u);
                    } finally{
                        this.uModelMatrix = c;
                    }
                    return this;
                }, S.default.RendererGL.prototype.rect = function(e1) {
                    var t = e1[0], r = e1[1], o = e1[2], n = e1[3];
                    if (void 0 === e1[4]) {
                        var s = this._pInst._glAttributes.perPixelLighting, i = e1[4] || (s ? 1 : 24), a = e1[5] || (s ? 1 : 16), s = "rect|".concat(i, "|").concat(a), l = (this.geometryInHash(s) || ((l = new S.default.Geometry(i, a, function() {
                            for(var e1 = 0; e1 <= this.detailY; e1++)for(var t = e1 / this.detailY, r = 0; r <= this.detailX; r++){
                                var o = r / this.detailX, n = new S.default.Vector(o, t, 0);
                                this.vertices.push(n), this.uvs.push(o, t);
                            }
                            0 < i && 0 < a && (this.edges = [
                                [
                                    0,
                                    i
                                ],
                                [
                                    i,
                                    (i + 1) * (a + 1) - 1
                                ],
                                [
                                    (i + 1) * (a + 1) - 1,
                                    (i + 1) * a
                                ],
                                [
                                    (i + 1) * a,
                                    0
                                ]
                            ]);
                        })).computeFaces().computeNormals()._edgesToVertices(), this.createBuffers(s, l)), this.uModelMatrix.copy());
                        try {
                            this.uModelMatrix.translate([
                                t,
                                r,
                                0
                            ]), this.uModelMatrix.scale(o, n, 1), this.drawBuffers(s);
                        } finally{
                            this.uModelMatrix = l;
                        }
                    } else {
                        var s = e1[4], l = void 0 === e1[5] ? s : e1[5], u = void 0 === e1[6] ? l : e1[6], e1 = void 0 === e1[7] ? u : e1[7], c = o, d = n, h = ((c += t) < t && (h = t, t = c, c = h), (d += r) < r && (h = r, r = d, d = h), Math.min((c - t) / 2, (d - r) / 2)), f = (h < s && (s = h), h < l && (l = h), h < u && (u = h), h < e1 && (e1 = h), t), p = r, h = c, t = d, m = (this.beginShape(), 0 !== l ? (this.vertex(h - l, p), this.quadraticVertex(h, p, h, p + l)) : this.vertex(h, p), 0 !== u ? (this.vertex(h, t - u), this.quadraticVertex(h, t, h - u, t)) : this.vertex(h, t), 0 !== e1 ? (this.vertex(f + e1, t), this.quadraticVertex(f, t, f, t - e1)) : this.vertex(f, t), 0 !== s ? (this.vertex(f, p + s), this.quadraticVertex(f, p, f + s, p)) : this.vertex(f, p), this.immediateMode.geometry.uvs.length = 0, true), r = !1, c = void 0;
                        try {
                            for(var y, g = this.immediateMode.geometry.vertices[Symbol.iterator](); !(m = (y = g.next()).done); m = !0){
                                var v = y.value, b = (v.x - f) / o, _ = (v.y - p) / n;
                                this.immediateMode.geometry.uvs.push(b, _);
                            }
                        } catch (e1) {
                            r = !0, c = e1;
                        } finally{
                            try {
                                m || null == g.return || g.return();
                            } finally{
                                if (r) throw c;
                            }
                        }
                        this.endShape(j.CLOSE);
                    }
                    return this;
                }, S.default.RendererGL.prototype.quad = function(i, a, l, u, c, d, h, f, p, m, y, g) {
                    var e1 = 12 < arguments.length && void 0 !== arguments[12] ? arguments[12] : 2, t = 13 < arguments.length && void 0 !== arguments[13] ? arguments[13] : 2, r = "quad|".concat(i, "|").concat(a, "|").concat(l, "|").concat(u, "|").concat(c, "|").concat(d, "|").concat(h, "|").concat(f, "|").concat(p, "|").concat(m, "|").concat(y, "|").concat(g, "|").concat(e1, "|").concat(t);
                    if (!this.geometryInHash(r)) {
                        var o = new S.default.Geometry(e1, t, function() {
                            for(var e1 = 1 / (this.detailX - 1), t = 1 / (this.detailY - 1), r = 0; r < this.detailY; r++)for(var o = 0; o < this.detailX; o++){
                                var n = o * e1, s = r * t;
                                this.vertices.push(new S.default.Vector((1 - n) * ((1 - s) * i + s * m) + n * ((1 - s) * u + s * h), (1 - n) * ((1 - s) * a + s * y) + n * ((1 - s) * c + s * f), (1 - n) * ((1 - s) * l + s * g) + n * ((1 - s) * d + s * p))), this.uvs.push([
                                    n,
                                    s
                                ]);
                            }
                        });
                        o.faces = [];
                        for(var n = 0; n < t - 1; n++)for(var s = 0; s < e1 - 1; s++){
                            var v = s + n * e1, b = s + 1 + (n + 1) * e1, _ = s + (n + 1) * e1;
                            o.faces.push([
                                v,
                                s + 1 + n * e1,
                                b
                            ]), o.faces.push([
                                v,
                                b,
                                _
                            ]);
                        }
                        o.computeNormals();
                        for(var j = [
                            o.edges.length = 0,
                            2,
                            3,
                            1
                        ], x = 0; x < j.length; x++)o.edges.push([
                            j[x],
                            j[(x + 1) % j.length]
                        ]);
                        o._edgesToVertices(), this.createBuffers(r, o);
                    }
                    return this.drawBuffers(r), this;
                }, S.default.RendererGL.prototype.bezier = function(e1, t, r, o, n, s, i, a, l, u, c, d) {
                    8 === arguments.length && (c = a, u = i, a = s, i = n, n = o, o = r, r = s = l = d = 0);
                    var h = this._pInst._bezierDetail || 20;
                    this.beginShape();
                    for(var f = 0; f <= h; f++){
                        var p = Math.pow(1 - f / h, 3), m = f / h * 3 * Math.pow(1 - f / h, 2), y = 3 * Math.pow(f / h, 2) * (1 - f / h), g = Math.pow(f / h, 3);
                        this.vertex(e1 * p + o * m + i * y + u * g, t * p + n * m + a * y + c * g, r * p + s * m + l * y + d * g);
                    }
                    return this.endShape(), this;
                }, S.default.RendererGL.prototype.curve = function(e1, t, r, o, n, s, i, a, l, u, c, d) {
                    8 === arguments.length && (u = i, c = a, i = n, a = o, n = o = r, r = s = l = d = 0);
                    var h = this._pInst._curveDetail;
                    this.beginShape();
                    for(var f = 0; f <= h; f++){
                        var p = .5 * Math.pow(f / h, 3), m = .5 * Math.pow(f / h, 2), y = f / h * .5;
                        this.vertex(p * (3 * o - e1 - 3 * i + u) + m * (2 * e1 - 5 * o + 4 * i - u) + y * (-e1 + i) + 2 * o * .5, p * (3 * n - t - 3 * a + c) + m * (2 * t - 5 * n + 4 * a - c) + y * (-t + a) + 2 * n * .5, p * (3 * s - r - 3 * l + d) + m * (2 * r - 5 * s + 4 * l - d) + y * (-r + l) + 2 * s * .5);
                    }
                    return this.endShape(), this;
                }, S.default.RendererGL.prototype.line = function() {
                    return 6 === arguments.length ? (this.beginShape(j.LINES), this.vertex(arguments.length <= 0 ? void 0 : arguments[0], arguments.length <= 1 ? void 0 : arguments[1], arguments.length <= 2 ? void 0 : arguments[2]), this.vertex(arguments.length <= 3 ? void 0 : arguments[3], arguments.length <= 4 ? void 0 : arguments[4], arguments.length <= 5 ? void 0 : arguments[5]), this.endShape()) : 4 === arguments.length && (this.beginShape(j.LINES), this.vertex(arguments.length <= 0 ? void 0 : arguments[0], arguments.length <= 1 ? void 0 : arguments[1], 0), this.vertex(arguments.length <= 2 ? void 0 : arguments[2], arguments.length <= 3 ? void 0 : arguments[3], 0), this.endShape()), this;
                }, S.default.RendererGL.prototype.bezierVertex = function() {
                    if (0 === this.immediateMode._bezierVertex.length) throw Error("vertex() must be used once before calling bezierVertex()");
                    var e1, t, r, o, n, s, i = [], a = [], l = arguments.length;
                    if (0 === this._lookUpTableBezier.length || this._lutBezierDetail !== this._pInst._curveDetail) {
                        this._lookUpTableBezier = [], this._lutBezierDetail = this._pInst._curveDetail;
                        for(var u = 1 / this._lutBezierDetail, c = u, d = 1, h = 0; c < 1;){
                            if (s = parseFloat(c.toFixed(6)), this._lookUpTableBezier[h] = this._bezierCoefficients(s), d.toFixed(6) === u.toFixed(6)) {
                                s = parseFloat(d.toFixed(6)) + parseFloat(c.toFixed(6)), ++h, this._lookUpTableBezier[h] = this._bezierCoefficients(s);
                                break;
                            }
                            c += u, d -= u, ++h;
                        }
                    }
                    for(var f = this._lookUpTableBezier.length, p = [], m = 0; m < 4; m++)p.push([]);
                    p[0] = this.immediateMode.geometry.vertexColors.slice(-4), p[3] = this.curFillColor.slice();
                    var y = [];
                    for(m = 0; m < 4; m++)y.push([]);
                    if (y[0] = this.immediateMode.geometry.vertexStrokeColors.slice(-4), y[3] = this.curStrokeColor.slice(), 6 === l) {
                        this.isBezier = !0;
                        var i = [
                            this.immediateMode._bezierVertex[0],
                            arguments.length <= 0 ? void 0 : arguments[0],
                            arguments.length <= 2 ? void 0 : arguments[2],
                            arguments.length <= 4 ? void 0 : arguments[4]
                        ], a = [
                            this.immediateMode._bezierVertex[1],
                            arguments.length <= 1 ? void 0 : arguments[1],
                            arguments.length <= 3 ? void 0 : arguments[3],
                            arguments.length <= 5 ? void 0 : arguments[5]
                        ], g = Math.hypot(i[0] - i[1], a[0] - a[1]), v = Math.hypot(i[1] - i[2], a[1] - a[2]), b = Math.hypot(i[2] - i[3], a[2] - a[3]), v = g + v + b;
                        for(g /= v, b /= v, n = 0; n < 4; n++)p[1].push(p[0][n] * (1 - g) + p[3][n] * g), p[2].push(p[0][n] * b + p[3][n] * (1 - b)), y[1].push(y[0][n] * (1 - g) + y[3][n] * g), y[2].push(y[0][n] * b + y[3][n] * (1 - b));
                        for(o = 0; o < f; o++){
                            for(this.curFillColor = [
                                0,
                                0,
                                0,
                                0
                            ], this.curStrokeColor = [
                                0,
                                0,
                                0,
                                0
                            ], m = e1 = t = 0; m < 4; m++){
                                for(n = 0; n < 4; n++)this.curFillColor[n] += this._lookUpTableBezier[o][m] * p[m][n], this.curStrokeColor[n] += this._lookUpTableBezier[o][m] * y[m][n];
                                e1 += i[m] * this._lookUpTableBezier[o][m], t += a[m] * this._lookUpTableBezier[o][m];
                            }
                            this.vertex(e1, t);
                        }
                        this.curFillColor = p[3], this.curStrokeColor = y[3], this.immediateMode._bezierVertex[0] = arguments.length <= 4 ? void 0 : arguments[4], this.immediateMode._bezierVertex[1] = arguments.length <= 5 ? void 0 : arguments[5];
                    } else if (9 === l) {
                        this.isBezier = !0, i = [
                            this.immediateMode._bezierVertex[0],
                            arguments.length <= 0 ? void 0 : arguments[0],
                            arguments.length <= 3 ? void 0 : arguments[3],
                            arguments.length <= 6 ? void 0 : arguments[6]
                        ], a = [
                            this.immediateMode._bezierVertex[1],
                            arguments.length <= 1 ? void 0 : arguments[1],
                            arguments.length <= 4 ? void 0 : arguments[4],
                            arguments.length <= 7 ? void 0 : arguments[7]
                        ];
                        var _ = [
                            this.immediateMode._bezierVertex[2],
                            arguments.length <= 2 ? void 0 : arguments[2],
                            arguments.length <= 5 ? void 0 : arguments[5],
                            arguments.length <= 8 ? void 0 : arguments[8]
                        ], j = Math.hypot(i[0] - i[1], a[0] - a[1], _[0] - _[1]), v = Math.hypot(i[1] - i[2], a[1] - a[2], _[1] - _[2]), x = Math.hypot(i[2] - i[3], a[2] - a[3], _[2] - _[3]), l = j + v + x;
                        for(j /= l, x /= l, n = 0; n < 4; n++)p[1].push(p[0][n] * (1 - j) + p[3][n] * j), p[2].push(p[0][n] * x + p[3][n] * (1 - x)), y[1].push(y[0][n] * (1 - j) + y[3][n] * j), y[2].push(y[0][n] * x + y[3][n] * (1 - x));
                        for(o = 0; o < f; o++){
                            for(this.curFillColor = [
                                0,
                                0,
                                0,
                                0
                            ], this.curStrokeColor = [
                                0,
                                0,
                                0,
                                0
                            ], m = e1 = t = r = 0; m < 4; m++){
                                for(n = 0; n < 4; n++)this.curFillColor[n] += this._lookUpTableBezier[o][m] * p[m][n], this.curStrokeColor[n] += this._lookUpTableBezier[o][m] * y[m][n];
                                e1 += i[m] * this._lookUpTableBezier[o][m], t += a[m] * this._lookUpTableBezier[o][m], r += _[m] * this._lookUpTableBezier[o][m];
                            }
                            this.vertex(e1, t, r);
                        }
                        this.curFillColor = p[3], this.curStrokeColor = y[3], this.immediateMode._bezierVertex[0] = arguments.length <= 6 ? void 0 : arguments[6], this.immediateMode._bezierVertex[1] = arguments.length <= 7 ? void 0 : arguments[7], this.immediateMode._bezierVertex[2] = arguments.length <= 8 ? void 0 : arguments[8];
                    }
                }, S.default.RendererGL.prototype.quadraticVertex = function() {
                    if (0 === this.immediateMode._quadraticVertex.length) throw Error("vertex() must be used once before calling quadraticVertex()");
                    var e1, t, r, o, n, s, i = [], a = [], l = arguments.length;
                    if (0 === this._lookUpTableQuadratic.length || this._lutQuadraticDetail !== this._pInst._curveDetail) {
                        this._lookUpTableQuadratic = [], this._lutQuadraticDetail = this._pInst._curveDetail;
                        for(var u = 1 / this._lutQuadraticDetail, c = u, d = 1, h = 0; c < 1;){
                            if (s = parseFloat(c.toFixed(6)), this._lookUpTableQuadratic[h] = this._quadraticCoefficients(s), d.toFixed(6) === u.toFixed(6)) {
                                s = parseFloat(d.toFixed(6)) + parseFloat(c.toFixed(6)), ++h, this._lookUpTableQuadratic[h] = this._quadraticCoefficients(s);
                                break;
                            }
                            c += u, d -= u, ++h;
                        }
                    }
                    for(var f = this._lookUpTableQuadratic.length, p = [], m = 0; m < 3; m++)p.push([]);
                    p[0] = this.immediateMode.geometry.vertexColors.slice(-4), p[2] = this.curFillColor.slice();
                    var y = [];
                    for(m = 0; m < 3; m++)y.push([]);
                    if (y[0] = this.immediateMode.geometry.vertexStrokeColors.slice(-4), y[2] = this.curStrokeColor.slice(), 4 === l) {
                        this.isQuadratic = !0;
                        var i = [
                            this.immediateMode._quadraticVertex[0],
                            arguments.length <= 0 ? void 0 : arguments[0],
                            arguments.length <= 2 ? void 0 : arguments[2]
                        ], a = [
                            this.immediateMode._quadraticVertex[1],
                            arguments.length <= 1 ? void 0 : arguments[1],
                            arguments.length <= 3 ? void 0 : arguments[3]
                        ], g = Math.hypot(i[0] - i[1], a[0] - a[1]);
                        for(g /= g + Math.hypot(i[1] - i[2], a[1] - a[2]), n = 0; n < 4; n++)p[1].push(p[0][n] * (1 - g) + p[2][n] * g), y[1].push(y[0][n] * (1 - g) + y[2][n] * g);
                        for(o = 0; o < f; o++){
                            for(this.curFillColor = [
                                0,
                                0,
                                0,
                                0
                            ], this.curStrokeColor = [
                                0,
                                0,
                                0,
                                0
                            ], m = e1 = t = 0; m < 3; m++){
                                for(n = 0; n < 4; n++)this.curFillColor[n] += this._lookUpTableQuadratic[o][m] * p[m][n], this.curStrokeColor[n] += this._lookUpTableQuadratic[o][m] * y[m][n];
                                e1 += i[m] * this._lookUpTableQuadratic[o][m], t += a[m] * this._lookUpTableQuadratic[o][m];
                            }
                            this.vertex(e1, t);
                        }
                        this.curFillColor = p[2], this.curStrokeColor = y[2], this.immediateMode._quadraticVertex[0] = arguments.length <= 2 ? void 0 : arguments[2], this.immediateMode._quadraticVertex[1] = arguments.length <= 3 ? void 0 : arguments[3];
                    } else if (6 === l) {
                        this.isQuadratic = !0, i = [
                            this.immediateMode._quadraticVertex[0],
                            arguments.length <= 0 ? void 0 : arguments[0],
                            arguments.length <= 3 ? void 0 : arguments[3]
                        ], a = [
                            this.immediateMode._quadraticVertex[1],
                            arguments.length <= 1 ? void 0 : arguments[1],
                            arguments.length <= 4 ? void 0 : arguments[4]
                        ];
                        var v = [
                            this.immediateMode._quadraticVertex[2],
                            arguments.length <= 2 ? void 0 : arguments[2],
                            arguments.length <= 5 ? void 0 : arguments[5]
                        ], b = Math.hypot(i[0] - i[1], a[0] - a[1], v[0] - v[1]);
                        for(b /= b + Math.hypot(i[1] - i[2], a[1] - a[2], v[1] - v[2]), n = 0; n < 4; n++)p[1].push(p[0][n] * (1 - b) + p[2][n] * b), y[1].push(y[0][n] * (1 - b) + y[2][n] * b);
                        for(o = 0; o < f; o++){
                            for(this.curFillColor = [
                                0,
                                0,
                                0,
                                0
                            ], this.curStrokeColor = [
                                0,
                                0,
                                0,
                                0
                            ], m = e1 = t = r = 0; m < 3; m++){
                                for(n = 0; n < 4; n++)this.curFillColor[n] += this._lookUpTableQuadratic[o][m] * p[m][n], this.curStrokeColor[n] += this._lookUpTableQuadratic[o][m] * y[m][n];
                                e1 += i[m] * this._lookUpTableQuadratic[o][m], t += a[m] * this._lookUpTableQuadratic[o][m], r += v[m] * this._lookUpTableQuadratic[o][m];
                            }
                            this.vertex(e1, t, r);
                        }
                        this.curFillColor = p[2], this.curStrokeColor = y[2], this.immediateMode._quadraticVertex[0] = arguments.length <= 3 ? void 0 : arguments[3], this.immediateMode._quadraticVertex[1] = arguments.length <= 4 ? void 0 : arguments[4], this.immediateMode._quadraticVertex[2] = arguments.length <= 5 ? void 0 : arguments[5];
                    }
                }, S.default.RendererGL.prototype.curveVertex = function() {
                    var e1, t, r, o, n, s, i = [], a = [], l = arguments.length;
                    if (0 === this._lookUpTableBezier.length || this._lutBezierDetail !== this._pInst._curveDetail) {
                        this._lookUpTableBezier = [], this._lutBezierDetail = this._pInst._curveDetail;
                        for(var u = 1 / this._lutBezierDetail, c = u, d = 1, h = 0; c < 1;){
                            if (s = parseFloat(c.toFixed(6)), this._lookUpTableBezier[h] = this._bezierCoefficients(s), d.toFixed(6) === u.toFixed(6)) {
                                s = parseFloat(d.toFixed(6)) + parseFloat(c.toFixed(6)), ++h, this._lookUpTableBezier[h] = this._bezierCoefficients(s);
                                break;
                            }
                            c += u, d -= u, ++h;
                        }
                    }
                    var f = this._lookUpTableBezier.length;
                    if (2 === l) {
                        if (this.immediateMode._curveVertex.push(arguments.length <= 0 ? void 0 : arguments[0]), this.immediateMode._curveVertex.push(arguments.length <= 1 ? void 0 : arguments[1]), 8 === this.immediateMode._curveVertex.length) {
                            for(this.isCurve = !0, i = this._bezierToCatmull([
                                this.immediateMode._curveVertex[0],
                                this.immediateMode._curveVertex[2],
                                this.immediateMode._curveVertex[4],
                                this.immediateMode._curveVertex[6]
                            ]), a = this._bezierToCatmull([
                                this.immediateMode._curveVertex[1],
                                this.immediateMode._curveVertex[3],
                                this.immediateMode._curveVertex[5],
                                this.immediateMode._curveVertex[7]
                            ]), n = 0; n < f; n++)t = i[0] * this._lookUpTableBezier[n][0] + i[1] * this._lookUpTableBezier[n][1] + i[2] * this._lookUpTableBezier[n][2] + i[3] * this._lookUpTableBezier[n][3], r = a[0] * this._lookUpTableBezier[n][0] + a[1] * this._lookUpTableBezier[n][1] + a[2] * this._lookUpTableBezier[n][2] + a[3] * this._lookUpTableBezier[n][3], this.vertex(t, r);
                            for(n = 0; n < l; n++)this.immediateMode._curveVertex.shift();
                        }
                    } else if (3 === l && (this.immediateMode._curveVertex.push(arguments.length <= 0 ? void 0 : arguments[0]), this.immediateMode._curveVertex.push(arguments.length <= 1 ? void 0 : arguments[1]), this.immediateMode._curveVertex.push(arguments.length <= 2 ? void 0 : arguments[2]), 12 === this.immediateMode._curveVertex.length)) {
                        for(this.isCurve = !0, i = this._bezierToCatmull([
                            this.immediateMode._curveVertex[0],
                            this.immediateMode._curveVertex[3],
                            this.immediateMode._curveVertex[6],
                            this.immediateMode._curveVertex[9]
                        ]), a = this._bezierToCatmull([
                            this.immediateMode._curveVertex[1],
                            this.immediateMode._curveVertex[4],
                            this.immediateMode._curveVertex[7],
                            this.immediateMode._curveVertex[10]
                        ]), e1 = this._bezierToCatmull([
                            this.immediateMode._curveVertex[2],
                            this.immediateMode._curveVertex[5],
                            this.immediateMode._curveVertex[8],
                            this.immediateMode._curveVertex[11]
                        ]), n = 0; n < f; n++)t = i[0] * this._lookUpTableBezier[n][0] + i[1] * this._lookUpTableBezier[n][1] + i[2] * this._lookUpTableBezier[n][2] + i[3] * this._lookUpTableBezier[n][3], r = a[0] * this._lookUpTableBezier[n][0] + a[1] * this._lookUpTableBezier[n][1] + a[2] * this._lookUpTableBezier[n][2] + a[3] * this._lookUpTableBezier[n][3], o = e1[0] * this._lookUpTableBezier[n][0] + e1[1] * this._lookUpTableBezier[n][1] + e1[2] * this._lookUpTableBezier[n][2] + e1[3] * this._lookUpTableBezier[n][3], this.vertex(t, r, o);
                        for(n = 0; n < l; n++)this.immediateMode._curveVertex.shift();
                    }
                }, S.default.RendererGL.prototype.image = function(e1, t, r, o, n, s, i, a, l) {
                    this._isErasing && this.blendMode(this._cachedBlendMode), this._pInst.push(), this._pInst.noLights(), this._pInst.noStroke(), this._pInst.texture(e1), this._pInst.textureMode(j.NORMAL);
                    var u = 0, c = (t <= e1.width && (u = t / e1.width), 1), t = (t + o <= e1.width && (c = (t + o) / e1.width), 0), o = (r <= e1.height && (t = r / e1.height), 1);
                    r + n <= e1.height && (o = (r + n) / e1.height), this.beginShape(), this.vertex(s, i, 0, u, t), this.vertex(s + a, i, 0, c, t), this.vertex(s + a, i + l, 0, c, o), this.vertex(s, i + l, 0, u, o), this.endShape(j.CLOSE), this._pInst.pop(), this._isErasing && this.blendMode(j.REMOVE);
                };
                var n = S.default;
                r.default = n;
            },
            {
                "../core/constants": 272,
                "../core/main": 283,
                "./p5.Geometry": 335,
                "core-js/modules/es.array.concat": 153,
                "core-js/modules/es.array.for-each": 161,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.math.hypot": 176,
                "core-js/modules/es.math.sign": 178,
                "core-js/modules/es.number.to-fixed": 182,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        327: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.every"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.every"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.object.assign"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (c = e1("../core/main")) && c.__esModule ? c : {
                    default: c
                }, a = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = l();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function l() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, l = function() {
                        return e1;
                    }, e1);
                }
                function s(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                function u(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                var c = function() {
                    function t(e1) {
                        if (!(this instanceof t)) throw new TypeError("Cannot call a class as a function");
                        (this.renderer = e1)._pInst.push(), this.identityMatrix = new n.default.Matrix, e1.uModelMatrix = new n.default.Matrix, this.geometry = new n.default.Geometry, this.geometry.gid = "_p5_GeometryBuilder_".concat(t.nextGeometryId), t.nextGeometryId++, this.hasTransform = !1;
                    }
                    var e1, r, o;
                    return e1 = t, r = [
                        {
                            key: "transformVertices",
                            value: function(e1) {
                                var t = this;
                                return this.hasTransform ? e1.map(function(e1) {
                                    return t.renderer.uModelMatrix.multiplyPoint(e1);
                                }) : e1;
                            }
                        },
                        {
                            key: "transformNormals",
                            value: function(e1) {
                                var t = this;
                                return this.hasTransform ? e1.map(function(e1) {
                                    return t.renderer.uNMatrix.multiplyVec3(e1);
                                }) : e1;
                            }
                        },
                        {
                            key: "addGeometry",
                            value: function(e1) {
                                for(var t, r = this, o = (this.hasTransform = !this.renderer.uModelMatrix.mat4.every(function(e1, t) {
                                    return e1 === r.identityMatrix.mat4[t];
                                }), this.hasTransform && this.renderer.uNMatrix.inverseTranspose(this.renderer.uModelMatrix), this.geometry.vertices.length), n = ((t = this.geometry.vertices).push.apply(t, s(this.transformVertices(e1.vertices))), (t = this.geometry.vertexNormals).push.apply(t, s(this.transformNormals(e1.vertexNormals))), (t = this.geometry.uvs).push.apply(t, s(e1.uvs)), this.renderer._doFill && (t = this.geometry.faces).push.apply(t, s(e1.faces.map(function(e1) {
                                    return e1.map(function(e1) {
                                        return e1 + o;
                                    });
                                }))), this.renderer._doStroke && (t = this.geometry.edges).push.apply(t, s(e1.edges.map(function(e1) {
                                    return e1.map(function(e1) {
                                        return e1 + o;
                                    });
                                }))), s(e1.vertexColors)); n.length < 4 * e1.vertices.length;)n.push.apply(n, s(this.renderer.curFillColor));
                                (t = this.geometry.vertexColors).push.apply(t, s(n));
                            }
                        },
                        {
                            key: "addImmediate",
                            value: function() {
                                var e1 = this.renderer.immediateMode.geometry, t = this.renderer.immediateMode.shapeMode, r = [];
                                if (this.renderer._doFill) {
                                    if (t === a.TRIANGLE_STRIP || t === a.QUAD_STRIP) for(var o = 2; o < e1.vertices.length; o++)o % 2 == 0 ? r.push([
                                        o,
                                        o - 1,
                                        o - 2
                                    ]) : r.push([
                                        o,
                                        o - 2,
                                        o - 1
                                    ]);
                                    else if (t === a.TRIANGLE_FAN) for(var n = 2; n < e1.vertices.length; n++)r.push([
                                        0,
                                        n - 1,
                                        n
                                    ]);
                                    else for(var s = 0; s < e1.vertices.length; s += 3)r.push([
                                        s,
                                        s + 1,
                                        s + 2
                                    ]);
                                }
                                this.addGeometry(Object.assign({}, e1, {
                                    faces: r
                                }));
                            }
                        },
                        {
                            key: "addRetained",
                            value: function(e1) {
                                this.addGeometry(e1.model);
                            }
                        },
                        {
                            key: "finish",
                            value: function() {
                                return this.renderer._pInst.pop(), this.geometry;
                            }
                        }
                    ], u(e1.prototype, r), o && u(e1, o), t;
                }();
                c.nextGeometryId = 0, r.default = c;
            },
            {
                "../core/constants": 272,
                "../core/main": 283,
                "core-js/modules/es.array.every": 155,
                "core-js/modules/es.array.from": 162,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.map": 168,
                "core-js/modules/es.object.assign": 183,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        328: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.math.hypot"), e1("core-js/modules/es.math.sign"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.math.hypot"), e1("core-js/modules/es.math.sign"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var g = (s = e1("../core/main")) && s.__esModule ? s : {
                    default: s
                }, n = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== v(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = i();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function i() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, i = function() {
                        return e1;
                    }, e1);
                }
                function v(e1) {
                    return (v = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                g.default.prototype.orbitControl = function(e1, t, r, o) {
                    var n = this, s = (this._assert3d("orbitControl"), g.default._validateParameters("orbitControl", arguments), this._renderer._curCamera);
                    void 0 === e1 && (e1 = 1), void 0 === t && (t = e1), void 0 === r && (r = 1), "object" !== v(o) && (o = {}), !0 !== this.contextMenuDisabled && (this.canvas.oncontextmenu = function() {
                        return !1;
                    }, this._setProperty("contextMenuDisabled", !0)), !0 !== this.wheelDefaultDisabled && (this.canvas.onwheel = function() {
                        return !1;
                    }, this._setProperty("wheelDefaultDisabled", !0));
                    var i = o.disableTouchActions;
                    !0 === this.touchActionsDisabled || void 0 !== i && !i || (this.canvas.style["touch-action"] = "none", this._setProperty("touchActionsDisabled", !0));
                    var a, l, u, i = o.freeRotation, o = void 0 !== i && i, c = [], i = (this.touches.forEach(function(t) {
                        n._renderer.prevTouches.forEach(function(e1) {
                            t.id === e1.id && (e1 = {
                                x: t.x,
                                y: t.y,
                                px: e1.x,
                                py: e1.y
                            }, c.push(e1));
                        });
                    }), this._renderer.prevTouches = this.touches, 0), d = 0, h = 0, f = 0, p = 0, m = this.height < this.width ? this.height : this.width, y = !1;
                    return 0 < c.length ? (y = 0 < c[0].x && c[0].x < this.width && 0 < c[0].y && c[0].y < this.height, 1 === c.length ? (d = -e1 * ((a = c[0]).x - a.px) / m, h = t * (a.y - a.py) / m) : (a = c[0], l = c[1], i = -(Math.hypot(a.x - l.x, a.y - l.y) - Math.hypot(a.px - l.px, a.py - l.py)) * r * 4e-4, f = .5 * (a.x + l.x) - .5 * (a.px + l.px), p = .5 * (a.y + l.y) - .5 * (a.py + l.py)), 0 < this.touches.length ? y && (this._renderer.executeRotateAndMove = !0, this._renderer.executeZoom = !0) : (this._renderer.executeRotateAndMove = !1, this._renderer.executeZoom = !1)) : (y = 0 < this.mouseX && this.mouseX < this.width && 0 < this.mouseY && this.mouseY < this.height, 0 !== this._mouseWheelDeltaY ? (i = Math.sign(this._mouseWheelDeltaY) * r, i *= .01, this._mouseWheelDeltaY = 0, y && (this._renderer.executeZoom = !0)) : this._renderer.executeZoom = !1, this.mouseIsPressed ? (this.mouseButton === this.LEFT ? (d = -e1 * this.movedX / m, h = t * this.movedY / m) : this.mouseButton === this.RIGHT && (f = this.movedX, p = this.movedY * s.yScale), y && (this._renderer.executeRotateAndMove = !0)) : this._renderer.executeRotateAndMove = !1), 0 !== i && this._renderer.executeZoom && (this._renderer.zoomVelocity += i), .001 < Math.abs(this._renderer.zoomVelocity) ? (o ? s._orbitFree(0, 0, this._renderer.zoomVelocity) : s._orbit(0, 0, this._renderer.zoomVelocity), 0 !== s.projMatrix.mat4[15] && (s.projMatrix.mat4[0] *= Math.pow(10, -this._renderer.zoomVelocity), s.projMatrix.mat4[5] *= Math.pow(10, -this._renderer.zoomVelocity), this._renderer.uPMatrix.mat4[0] = s.projMatrix.mat4[0], this._renderer.uPMatrix.mat4[5] = s.projMatrix.mat4[5]), this._renderer.zoomVelocity *= .85) : this._renderer.zoomVelocity = 0, 0 === d && 0 === h || !this._renderer.executeRotateAndMove || this._renderer.rotateVelocity.add(.6 * d, .6 * h), 1e-6 < this._renderer.rotateVelocity.magSq() ? (o ? s._orbitFree(-this._renderer.rotateVelocity.x, this._renderer.rotateVelocity.y, 0) : s._orbit(this._renderer.rotateVelocity.x, this._renderer.rotateVelocity.y, 0), this._renderer.rotateVelocity.mult(.85)) : this._renderer.rotateVelocity.set(0, 0), 0 === f && 0 === p || !this._renderer.executeRotateAndMove || (a = 2 * f / this.width, l = 2 * -p / this.height, this._renderer.moveVelocity.add(.15 * a, .15 * l)), 1e-6 < this._renderer.moveVelocity.magSq() ? (r = s._getLocalAxes(), e1 = s.eyeX - s.centerX, t = s.eyeY - s.centerY, m = s.eyeZ - s.centerZ, y = Math.sqrt(e1 * e1 + t * t + m * m), i = new g.default.Vector(s.centerX, s.centerY, s.centerZ), i = s.cameraMatrix.multiplyPoint(i), (i = this._renderer.uPMatrix.multiplyAndNormalizePoint(i)).x -= this._renderer.moveVelocity.x, i.y -= this._renderer.moveVelocity.y, h = 0 === (d = this._renderer.uPMatrix.mat4)[15] ? (u = (d[8] + i.x) / d[0] * y, (d[9] + i.y) / d[5] * y) : (u = (i.x - d[12]) / d[0], (i.y - d[13]) / d[5]), s.setPosition(s.eyeX + u * r.x[0] + h * r.y[0], s.eyeY + u * r.x[1] + h * r.y[1], s.eyeZ + u * r.x[2] + h * r.y[2]), this._renderer.moveVelocity.mult(.85)) : this._renderer.moveVelocity.set(0, 0), this;
                }, g.default.prototype.debugMode = function() {
                    this._assert3d("debugMode");
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    g.default._validateParameters("debugMode", t);
                    for(var o = this._registeredMethods.post.length - 1; 0 <= o; o--)this._registeredMethods.post[o].toString() !== this._grid().toString() && this._registeredMethods.post[o].toString() !== this._axesIcon().toString() || this._registeredMethods.post.splice(o, 1);
                    t[0] === n.GRID ? this.registerMethod("post", this._grid(t[1], t[2], t[3], t[4], t[5])) : t[0] === n.AXES ? this.registerMethod("post", this._axesIcon(t[1], t[2], t[3], t[4])) : (this.registerMethod("post", this._grid(t[0], t[1], t[2], t[3], t[4])), this.registerMethod("post", this._axesIcon(t[5], t[6], t[7], t[8])));
                }, g.default.prototype.noDebugMode = function() {
                    this._assert3d("noDebugMode");
                    for(var e1 = this._registeredMethods.post.length - 1; 0 <= e1; e1--)this._registeredMethods.post[e1].toString() !== this._grid().toString() && this._registeredMethods.post[e1].toString() !== this._axesIcon().toString() || this._registeredMethods.post.splice(e1, 1);
                }, g.default.prototype._grid = function(e1, r, o, n, s) {
                    void 0 === e1 && (e1 = this.width / 2), void 0 === r && (r = Math.round(e1 / 30) < 4 ? 4 : Math.round(e1 / 30)), void 0 === o && (o = 0), void 0 === n && (n = 0), void 0 === s && (s = 0);
                    var i = e1 / r, a = e1 / 2;
                    return function() {
                        this.push(), this.stroke(255 * this._renderer.curStrokeColor[0], 255 * this._renderer.curStrokeColor[1], 255 * this._renderer.curStrokeColor[2]), this._renderer.uModelMatrix.reset();
                        for(var e1 = 0; e1 <= r; e1++)this.beginShape(this.LINES), this.vertex(-a + o, n, e1 * i - a + s), this.vertex(a + o, n, e1 * i - a + s), this.endShape();
                        for(var t = 0; t <= r; t++)this.beginShape(this.LINES), this.vertex(t * i - a + o, n, -a + s), this.vertex(t * i - a + o, n, a + s), this.endShape();
                        this.pop();
                    };
                }, g.default.prototype._axesIcon = function(e1, t, r, o) {
                    return void 0 === e1 && (e1 = 40 < this.width / 20 ? this.width / 20 : 40), void 0 === t && (t = -this.width / 4), void 0 === r && (r = t), void 0 === o && (o = t), function() {
                        this.push(), this._renderer.uModelMatrix.reset(), this.strokeWeight(2), this.stroke(255, 0, 0), this.beginShape(this.LINES), this.vertex(t, r, o), this.vertex(t + e1, r, o), this.endShape(), this.stroke(0, 255, 0), this.beginShape(this.LINES), this.vertex(t, r, o), this.vertex(t, r + e1, o), this.endShape(), this.stroke(0, 0, 255), this.beginShape(this.LINES), this.vertex(t, r, o), this.vertex(t, r, o + e1), this.endShape(), this.pop();
                    };
                };
                var s = g.default;
                r.default = s;
            },
            {
                "../core/constants": 272,
                "../core/main": 283,
                "core-js/modules/es.array.for-each": 161,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.splice": 171,
                "core-js/modules/es.math.hypot": 176,
                "core-js/modules/es.math.sign": 178,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.for-each": 245,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        329: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.filter"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var m = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                m.default.prototype.ambientLight = function(e1, t, r, o) {
                    this._assert3d("ambientLight"), m.default._validateParameters("ambientLight", arguments);
                    var n = this.color.apply(this, arguments);
                    return this._renderer.ambientLightColors.push(n._array[0], n._array[1], n._array[2]), this._renderer._enableLighting = !0, this;
                }, m.default.prototype.specularColor = function(e1, t, r) {
                    this._assert3d("specularColor"), m.default._validateParameters("specularColor", arguments);
                    var o = this.color.apply(this, arguments);
                    return this._renderer.specularColors = [
                        o._array[0],
                        o._array[1],
                        o._array[2]
                    ], this;
                }, m.default.prototype.directionalLight = function(e1, t, r, o, n, s) {
                    this._assert3d("directionalLight"), m.default._validateParameters("directionalLight", arguments), e1 = e1 instanceof m.default.Color ? e1 : this.color(e1, t, r);
                    var i, a, t = arguments[arguments.length - 1], r = "number" == typeof t ? (i = arguments[arguments.length - 3], a = arguments[arguments.length - 2], arguments[arguments.length - 1]) : (i = t.x, a = t.y, t.z), t = Math.sqrt(i * i + a * a + r * r);
                    return this._renderer.directionalLightDirections.push(i / t, a / t, r / t), this._renderer.directionalLightDiffuseColors.push(e1._array[0], e1._array[1], e1._array[2]), Array.prototype.push.apply(this._renderer.directionalLightSpecularColors, this._renderer.specularColors), this._renderer._enableLighting = !0, this;
                }, m.default.prototype.pointLight = function(e1, t, r, o, n, s) {
                    this._assert3d("pointLight"), m.default._validateParameters("pointLight", arguments), e1 = e1 instanceof m.default.Color ? e1 : this.color(e1, t, r);
                    var i, a, t = arguments[arguments.length - 1], r = "number" == typeof t ? (i = arguments[arguments.length - 3], a = arguments[arguments.length - 2], arguments[arguments.length - 1]) : (i = t.x, a = t.y, t.z);
                    return this._renderer.pointLightPositions.push(i, a, r), this._renderer.pointLightDiffuseColors.push(e1._array[0], e1._array[1], e1._array[2]), Array.prototype.push.apply(this._renderer.pointLightSpecularColors, this._renderer.specularColors), this._renderer._enableLighting = !0, this;
                }, m.default.prototype.imageLight = function(e1) {
                    this._renderer.activeImageLight = e1, this._renderer._enableLighting = !0;
                }, m.default.prototype.panorama = function(e1) {
                    this.filter(this._renderer._getSphereMapping(e1));
                }, m.default.prototype.lights = function() {
                    this._assert3d("lights");
                    var e1 = this.color("rgb(128,128,128)");
                    return this.ambientLight(e1), this.directionalLight(e1, 0, 0, -1), this;
                }, m.default.prototype.lightFalloff = function(e1, t, r) {
                    return this._assert3d("lightFalloff"), m.default._validateParameters("lightFalloff", arguments), e1 < 0 && (e1 = 0, console.warn("Value of constant argument in lightFalloff() should be never be negative. Set to 0.")), t < 0 && (t = 0, console.warn("Value of linear argument in lightFalloff() should be never be negative. Set to 0.")), r < 0 && (r = 0, console.warn("Value of quadratic argument in lightFalloff() should be never be negative. Set to 0.")), 0 === e1 && 0 === t && 0 === r && (e1 = 1, console.warn("Either one of the three arguments in lightFalloff() should be greater than zero. Set constant argument to 1.")), this._renderer.constantAttenuation = e1, this._renderer.linearAttenuation = t, this._renderer.quadraticAttenuation = r, this;
                }, m.default.prototype.spotLight = function(e1, t, r, o, n, s, i, a, l, u, c) {
                    this._assert3d("spotLight"), m.default._validateParameters("spotLight", arguments);
                    var d, h, f, p = arguments.length;
                    switch(p){
                        case 11:
                        case 10:
                            d = this.color(e1, t, r), h = new m.default.Vector(o, n, s), f = new m.default.Vector(i, a, l);
                            break;
                        case 9:
                            e1 instanceof m.default.Color ? (d = e1, h = new m.default.Vector(t, r, o), f = new m.default.Vector(n, s, i), u = a, c = l) : o instanceof m.default.Vector ? (d = this.color(e1, t, r), h = o, f = new m.default.Vector(n, s, i), u = a, c = l) : i instanceof m.default.Vector ? (d = this.color(e1, t, r), h = new m.default.Vector(o, n, s), f = i, u = a, c = l) : (d = this.color(e1, t, r), h = new m.default.Vector(o, n, s), f = new m.default.Vector(i, a, l));
                            break;
                        case 8:
                            u = (f = e1 instanceof m.default.Color ? (d = e1, h = new m.default.Vector(t, r, o), new m.default.Vector(n, s, i)) : o instanceof m.default.Vector ? (d = this.color(e1, t, r), h = o, new m.default.Vector(n, s, i)) : (d = this.color(e1, t, r), h = new m.default.Vector(o, n, s), i), a);
                            break;
                        case 7:
                            e1 instanceof m.default.Color && t instanceof m.default.Vector ? (d = e1, h = t, f = new m.default.Vector(r, o, n), u = s, c = i) : e1 instanceof m.default.Color && n instanceof m.default.Vector ? (d = e1, h = new m.default.Vector(t, r, o), f = n, u = s, c = i) : o instanceof m.default.Vector && n instanceof m.default.Vector ? (d = this.color(e1, t, r), h = o, f = n, u = s, c = i) : f = e1 instanceof m.default.Color ? (d = e1, h = new m.default.Vector(t, r, o), new m.default.Vector(n, s, i)) : o instanceof m.default.Vector ? (d = this.color(e1, t, r), h = o, new m.default.Vector(n, s, i)) : (d = this.color(e1, t, r), h = new m.default.Vector(o, n, s), i);
                            break;
                        case 6:
                            o instanceof m.default.Vector && n instanceof m.default.Vector ? (d = this.color(e1, t, r), h = o, f = n, u = s) : e1 instanceof m.default.Color && n instanceof m.default.Vector ? (d = e1, h = new m.default.Vector(t, r, o), f = n, u = s) : e1 instanceof m.default.Color && t instanceof m.default.Vector && (d = e1, h = t, f = new m.default.Vector(r, o, n), u = s);
                            break;
                        case 5:
                            e1 instanceof m.default.Color && t instanceof m.default.Vector && r instanceof m.default.Vector ? (d = e1, h = t, f = r, u = o, c = n) : o instanceof m.default.Vector && n instanceof m.default.Vector ? (d = this.color(e1, t, r), h = o, f = n) : e1 instanceof m.default.Color && n instanceof m.default.Vector ? (d = e1, h = new m.default.Vector(t, r, o), f = n) : e1 instanceof m.default.Color && t instanceof m.default.Vector && (d = e1, h = t, f = new m.default.Vector(r, o, n));
                            break;
                        case 4:
                            d = e1, h = t, f = r, u = o;
                            break;
                        case 3:
                            d = e1, h = t, f = r;
                            break;
                        default:
                            return console.warn("Sorry, input for spotlight() is not in prescribed format. Too ".concat(p < 3 ? "few" : "many", " arguments were provided")), this;
                    }
                    return this._renderer.spotLightDiffuseColors.push(d._array[0], d._array[1], d._array[2]), Array.prototype.push.apply(this._renderer.spotLightSpecularColors, this._renderer.specularColors), this._renderer.spotLightPositions.push(h.x, h.y, h.z), f.normalize(), this._renderer.spotLightDirections.push(f.x, f.y, f.z), void 0 === u && (u = Math.PI / 3), void 0 !== c && c < 1 ? (c = 1, console.warn("Value of concentration needs to be greater than 1. Setting it to 1")) : void 0 === c && (c = 100), u = this._renderer._pInst._toRadians(u), this._renderer.spotLightAngle.push(Math.cos(u)), this._renderer.spotLightConc.push(c), this._renderer._enableLighting = !0, this;
                }, m.default.prototype.noLights = function() {
                    this._assert3d("noLights");
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    return m.default._validateParameters("noLights", t), this._renderer.activeImageLight = null, this._renderer._enableLighting = !1, this._renderer.ambientLightColors.length = 0, this._renderer.specularColors = [
                        1,
                        1,
                        1
                    ], this._renderer.directionalLightDirections.length = 0, this._renderer.directionalLightDiffuseColors.length = 0, this._renderer.directionalLightSpecularColors.length = 0, this._renderer.pointLightPositions.length = 0, this._renderer.pointLightDiffuseColors.length = 0, this._renderer.pointLightSpecularColors.length = 0, this._renderer.spotLightPositions.length = 0, this._renderer.spotLightDirections.length = 0, this._renderer.spotLightDiffuseColors.length = 0, this._renderer.spotLightSpecularColors.length = 0, this._renderer.spotLightAngle.length = 0, this._renderer.spotLightConc.length = 0, this._renderer.constantAttenuation = 1, this._renderer.linearAttenuation = 0, this._renderer.quadraticAttenuation = 0, this._renderer._useShininess = 1, this._renderer._useMetalness = 0, this;
                };
                e1 = m.default;
                r.default = e1;
            },
            {
                "../core/main": 283,
                "core-js/modules/es.array.filter": 157
            }
        ],
        330: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.set"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.trim"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.set"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.trim"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0, e1("regenerator-runtime/runtime");
                var L = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                };
                function f(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                function l(e1, t, r, o, n, s, i) {
                    try {
                        var a = e1[s](i), l = a.value;
                    } catch (e1) {
                        return void r(e1);
                    }
                    a.done ? t(l) : Promise.resolve(l).then(o, n);
                }
                function p(a) {
                    return function() {
                        var e1 = this, i = arguments;
                        return new Promise(function(t, r) {
                            var o = a.apply(e1, i);
                            function n(e1) {
                                l(o, t, r, n, s, "next", e1);
                            }
                            function s(e1) {
                                l(o, t, r, n, s, "throw", e1);
                            }
                            n(void 0);
                        });
                    };
                }
                function m(e1) {
                    return (m = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                function y(e1, t, r) {
                    for(var o = 2 < arguments.length && void 0 !== r ? r : {}, n = {
                        v: [],
                        vt: [],
                        vn: []
                    }, s = {}, i = null, a = new Set, l = !1, u = !1, c = 0; c < t.length; ++c){
                        var d = t[c].trim().split(/\b\s+/);
                        if (0 < d.length) {
                            if ("usemtl" === d[0]) i = d[1];
                            else if ("v" === d[0] || "vn" === d[0]) {
                                var h = new L.default.Vector(parseFloat(d[1]), parseFloat(d[2]), parseFloat(d[3]));
                                n[d[0]].push(h);
                            } else if ("vt" === d[0]) {
                                h = [
                                    parseFloat(d[1]),
                                    1 - parseFloat(d[2])
                                ];
                                n[d[0]].push(h);
                            } else if ("f" === d[0]) for(var f = 3; f < d.length; ++f){
                                for(var p = [], m = [
                                    1,
                                    f - 1,
                                    f
                                ], y = 0; y < m.length; ++y){
                                    for(var g, v = d[m[y]], b = v.split("/"), _ = 0; _ < b.length; _++){
                                        var j = parseInt(b[_]);
                                        0 < j && --j, b[_] = j;
                                    }
                                    s[v] || (s[v] = {}), void 0 === s[v][i] ? (g = e1.vertices.length, e1.vertices.push(n.v.at(b[0]).copy()), e1.uvs.push(n.vt.at(b[1]) ? n.vt.at(b[1]).slice() : [
                                        0,
                                        0
                                    ]), e1.vertexNormals.push(n.vn.at(b[2]) ? n.vn.at(b[2]).copy() : new L.default.Vector), s[v][i] = g, p.push(g), i && o[i] && o[i].diffuseColor && a.add(n.v.at(b[0]))) : p.push(s[v][i]);
                                }
                                if (p[0] !== p[1] && p[0] !== p[2] && p[1] !== p[2]) {
                                    if (e1.faces.push(p), i && o[i] && o[i].diffuseColor) for(var l = l = !0, x = o[i].diffuseColor, w = 0; w < p.length; w++)e1.vertexColors.push(x[0]), e1.vertexColors.push(x[1]), e1.vertexColors.push(x[2]);
                                    else u = !0;
                                }
                            }
                        }
                    }
                    if (0 === e1.vertexNormals.length && e1.computeNormals(), l === u) throw new Error("Model coloring is inconsistent. Either all vertices should have colors or none should.");
                }
                function g(e1, t) {
                    if (function(e1) {
                        for(var t = new DataView(e1), r = [
                            115,
                            111,
                            108,
                            105,
                            100
                        ], o = 0; o < 5; o++)if (function(e1, t, r) {
                            for(var o = 0, n = e1.length; o < n; o++)if (e1[o] !== t.getUint8(r + o, !1)) return;
                            return 1;
                        }(r, t, o)) return;
                        return 1;
                    }(t)) {
                        for(var r, o, n, s, i, a, l, u = e1, c = new DataView(t), d = c.getUint32(80, !0), h = !1, f = 0; f < 70; f++)1129270351 === c.getUint32(f, !1) && 82 === c.getUint8(f + 4) && 61 === c.getUint8(f + 5) && (h = !0, s = [], i = c.getUint8(f + 6) / 255, a = c.getUint8(f + 7) / 255, l = c.getUint8(f + 8) / 255);
                        for(var p = 0; p < d; p++){
                            for(var m, y = 84 + 50 * p, g = c.getFloat32(y, !0), v = c.getFloat32(4 + y, !0), b = c.getFloat32(8 + y, !0), _ = (h && (m = c.getUint16(48 + y, !0), n = 0 == (32768 & m) ? (r = (31 & m) / 31, o = (m >> 5 & 31) / 31, (m >> 10 & 31) / 31) : (r = i, o = a, l)), new L.default.Vector(g, v, b)), j = 1; j <= 3; j++){
                                var x = y + 12 * j, x = new L.default.Vector(c.getFloat32(x, !0), c.getFloat32(4 + x, !0), c.getFloat32(8 + x, !0));
                                u.vertices.push(x), u.vertexNormals.push(_), h && s.push(r, o, n);
                            }
                            u.faces.push([
                                3 * p,
                                3 * p + 1,
                                3 * p + 2
                            ]), u.uvs.push([
                                0,
                                0
                            ], [
                                0,
                                0
                            ], [
                                0,
                                0
                            ]);
                        }
                    } else {
                        t = new DataView(t);
                        if ("TextDecoder" in window) for(var w, S, T = e1, E = new TextDecoder("utf-8").decode(t).split("\n"), M = "", k = [], O = 0; O < E.length; ++O){
                            for(var C = E[O].trim(), P = C.split(" "), A = 0; A < P.length; ++A)"" === P[A] && P.splice(A, 1);
                            if (0 !== P.length) switch(M){
                                case "":
                                    if ("solid" !== P[0]) return void (console.error(C), console.error('Invalid state "'.concat(P[0], '", should be "solid"')));
                                    M = "solid";
                                    break;
                                case "solid":
                                    if ("facet" !== P[0] || "normal" !== P[1]) return void (console.error(C), console.error('Invalid state "'.concat(P[0], '", should be "facet normal"')));
                                    w = new L.default.Vector(parseFloat(P[2]), parseFloat(P[3]), parseFloat(P[4])), T.vertexNormals.push(w, w, w), M = "facet normal";
                                    break;
                                case "facet normal":
                                    if ("outer" !== P[0] || "loop" !== P[1]) return void (console.error(C), console.error('Invalid state "'.concat(P[0], '", should be "outer loop"')));
                                    M = "vertex";
                                    break;
                                case "vertex":
                                    if ("vertex" === P[0]) S = new L.default.Vector(parseFloat(P[1]), parseFloat(P[2]), parseFloat(P[3])), T.vertices.push(S), T.uvs.push([
                                        0,
                                        0
                                    ]), k.push(T.vertices.indexOf(S));
                                    else {
                                        if ("endloop" !== P[0]) return void (console.error(C), console.error('Invalid state "'.concat(P[0], '", should be "vertex" or "endloop"')));
                                        T.faces.push(k), k = [], M = "endloop";
                                    }
                                    break;
                                case "endloop":
                                    if ("endfacet" !== P[0]) return void (console.error(C), console.error('Invalid state "'.concat(P[0], '", should be "endfacet"')));
                                    M = "endfacet";
                                    break;
                                case "endfacet":
                                    if ("endsolid" !== P[0]) {
                                        if ("facet" !== P[0] || "normal" !== P[1]) return void (console.error(C), console.error('Invalid state "'.concat(P[0], '", should be "endsolid" or "facet normal"')));
                                        w = new L.default.Vector(parseFloat(P[2]), parseFloat(P[3]), parseFloat(P[4])), T.vertexNormals.push(w, w, w), M = "facet normal";
                                    }
                                    break;
                                default:
                                    console.error('Invalid state "'.concat(M, '"'));
                            }
                        }
                        else console.warn("Sorry, ASCII STL loading only works in browsers that support TextDecoder (https://caniuse.com/#feat=textencoder)");
                    }
                }
                e1("./p5.Geometry"), L.default.prototype.loadModel = function(i, e1) {
                    L.default._validateParameters("loadModel", arguments);
                    var o, n, s = !1, a = !1, l = !1, t = i.slice(-4), u = (e1 && "object" === m(e1) ? (s = e1.normalize || !1, o = e1.successCallback, n = e1.failureCallback, t = e1.fileType || t, a = e1.flipU || !1, l = e1.flipV || !1) : "boolean" == typeof e1 ? (s = e1, o = arguments[2], n = arguments[3], void 0 !== arguments[4] && (t = arguments[4])) : (o = "function" == typeof e1 ? e1 : void 0, n = arguments[2], void 0 !== arguments[3] && (t = arguments[3])), new L.default.Geometry), c = (u.gid = "".concat(i, "|").concat(s), this);
                    function d() {
                        return (d = p(regeneratorRuntime.mark(function e1(t) {
                            var r, o, n, s;
                            return regeneratorRuntime.wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        for(r = [], o = 0; o < t.length; o++)(n = t[o].match(/^mtllib (.+)/)) && !function() {
                                            var o = "", e1 = n[1], t = i.split("/");
                                            o = 1 < t.length ? (t.pop(), t.join("/") + "/" + e1) : e1, r.push((function() {
                                                return h.apply(this, arguments);
                                            })(o).then(function(e1) {
                                                var t, r;
                                                return e1 ? (t = c, r = o, new Promise(function(n, e1) {
                                                    var s = null, i = {};
                                                    t.loadStrings(r, function(e1) {
                                                        for(var t = 0; t < e1.length; ++t){
                                                            var r, o = e1[t].trim().split(/\s+/);
                                                            "newmtl" === o[0] ? (r = o[1], i[s = r] = {}) : "Kd" === o[0] ? i[s].diffuseColor = [
                                                                parseFloat(o[1]),
                                                                parseFloat(o[2]),
                                                                parseFloat(o[3])
                                                            ] : "Ka" === o[0] ? i[s].ambientColor = [
                                                                parseFloat(o[1]),
                                                                parseFloat(o[2]),
                                                                parseFloat(o[3])
                                                            ] : "Ks" === o[0] ? i[s].specularColor = [
                                                                parseFloat(o[1]),
                                                                parseFloat(o[2]),
                                                                parseFloat(o[3])
                                                            ] : "map_Kd" === o[0] && (i[s].texturePath = o[1]);
                                                        }
                                                        n(i);
                                                    }, e1);
                                                })) : (console.warn("MTL file not found or error in parsing; proceeding without materials: ".concat(o)), {});
                                            }).catch(function(e1) {
                                                return console.warn("Error loading MTL file: ".concat(o), e1), {};
                                            }));
                                        }();
                                        return e1.prev = 2, e1.next = 5, Promise.all(r);
                                    case 5:
                                        return s = e1.sent, s = Object.assign.apply(Object, [
                                            {}
                                        ].concat(f(s))), e1.abrupt("return", s);
                                    case 10:
                                        return e1.prev = 10, e1.t0 = e1.catch(2), e1.abrupt("return", {});
                                    case 13:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1, null, [
                                [
                                    2,
                                    10
                                ]
                            ]);
                        }))).apply(this, arguments);
                    }
                    function h() {
                        return (h = p(regeneratorRuntime.mark(function e1(t) {
                            var r;
                            return regeneratorRuntime.wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        return e1.prev = 0, e1.next = 3, fetch(t, {
                                            method: "HEAD"
                                        });
                                    case 3:
                                        return r = e1.sent, e1.abrupt("return", r.ok);
                                    case 7:
                                        return e1.prev = 7, e1.t0 = e1.catch(0), e1.abrupt("return", !1);
                                    case 10:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1, null, [
                                [
                                    0,
                                    7
                                ]
                            ]);
                        }))).apply(this, arguments);
                    }
                    return t.match(/\.stl$/i) ? this.httpDo(i, "GET", "arrayBuffer", function(e1) {
                        g(u, e1), s && u.normalize(), a && u.flipU(), l && u.flipV(), c._decrementPreload(), "function" == typeof o && o(u);
                    }, n) : t.match(/\.obj$/i) ? this.loadStrings(i, function() {
                        var t = p(regeneratorRuntime.mark(function e1(t) {
                            var r;
                            return regeneratorRuntime.wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        return e1.prev = 0, e1.next = 3, function() {
                                            return d.apply(this, arguments);
                                        }(t);
                                    case 3:
                                        r = e1.sent, y(u, t, r), e1.next = 11;
                                        break;
                                    case 7:
                                        return e1.prev = 7, e1.t0 = e1.catch(0), n ? n(e1.t0) : L.default._friendlyError("Error during parsing: " + e1.t0.message), e1.abrupt("return");
                                    case 11:
                                        return e1.prev = 11, s && u.normalize(), a && u.flipU(), l && u.flipV(), u._makeTriangleEdges(), c._decrementPreload(), "function" == typeof o && o(u), e1.finish(11);
                                    case 19:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1, null, [
                                [
                                    0,
                                    7,
                                    11,
                                    19
                                ]
                            ]);
                        }));
                        return function(e1) {
                            return t.apply(this, arguments);
                        };
                    }(), n) : (L.default._friendlyFileLoadError(3, i), n ? n() : L.default._friendlyError("Sorry, the file type is invalid. Only OBJ and STL files are supported.")), u;
                }, L.default.prototype.model = function(e1) {
                    this._assert3d("model"), L.default._validateParameters("model", arguments), 0 < e1.vertices.length && (this._renderer.geometryInHash(e1.gid) || (e1._edgesToVertices(), this._renderer.createBuffers(e1.gid, e1)), this._renderer.drawBuffers(e1.gid));
                };
                var u = 0, n = (L.default.prototype.createModel = function(e1) {
                    var t, r, o = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : " ", n = 2 < arguments.length ? arguments[2] : void 0, s = (L.default._validateParameters("createModel", arguments), !1), i = !1, a = !1, n = (n && "object" === m(n) ? (s = n.normalize || !1, t = n.successCallback, r = n.failureCallback, i = n.flipU || !1, a = n.flipV || !1) : r = "boolean" == typeof n ? (s = n, t = arguments[3], arguments[4]) : (t = "function" == typeof arguments[2] ? arguments[2] : void 0, arguments[3]), new L.default.Geometry);
                    if (n.gid = "".concat(o, "|").concat(s, "|").concat(u++), o.match(/\.stl$/i)) try {
                        g(n, (new TextEncoder).encode(e1).buffer);
                    } catch (e1) {
                        return void (r ? r(e1) : L.default._friendlyError("Error during parsing: " + e1.message));
                    }
                    else if (o.match(/\.obj$/i)) try {
                        y(n, e1.split("\n"));
                    } catch (e1) {
                        return void (r ? r(e1) : L.default._friendlyError("Error during parsing: " + e1.message));
                    }
                    else L.default._friendlyFileLoadError(3, e1), r ? r() : L.default._friendlyError("Sorry, the file type is invalid. Only OBJ and STL files are supported.");
                    return s && n.normalize(), i && n.flipU(), a && n.flipV(), n._makeTriangleEdges(), "function" == typeof t && t(n), n;
                }, L.default);
                r.default = n;
            },
            {
                "../core/main": 283,
                "./p5.Geometry": 335,
                "core-js/modules/es.array.concat": 153,
                "core-js/modules/es.array.from": 162,
                "core-js/modules/es.array.index-of": 164,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.join": 166,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.array.splice": 171,
                "core-js/modules/es.object.assign": 183,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.promise": 191,
                "core-js/modules/es.regexp.exec": 195,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.set": 197,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.string.match": 201,
                "core-js/modules/es.string.split": 206,
                "core-js/modules/es.string.trim": 209,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/web.dom-collections.iterator": 246,
                "regenerator-runtime/runtime": 260
            }
        ],
        331: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var u = (s = e1("../core/main")) && s.__esModule ? s : {
                    default: s
                }, n = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                e1("./p5.Texture"), u.default.prototype.loadShader = function(e1, t, r, o) {
                    u.default._validateParameters("loadShader", arguments), o = o || console.error;
                    function n() {
                        i._decrementPreload(), r && r(s);
                    }
                    var s = new u.default.Shader, i = this, a = !1, l = !1;
                    return this.loadStrings(e1, function(e1) {
                        s._vertSrc = e1.join("\n"), l = !0, a && n();
                    }, o), this.loadStrings(t, function(e1) {
                        s._fragSrc = e1.join("\n"), a = !0, l && n();
                    }, o), s;
                }, u.default.prototype.createShader = function(e1, t, r) {
                    return u.default._validateParameters("createShader", arguments), new u.default.Shader(this._renderer, e1, t, r);
                }, u.default.prototype.createFilterShader = function(e1) {
                    u.default._validateParameters("createFilterShader", arguments);
                    var t = e1.includes("#version 300 es") ? "#version 300 es\n    uniform mat4 uModelViewMatrix;\n    uniform mat4 uProjectionMatrix;\n\n    in vec3 aPosition;\n    in vec2 aTexCoord;\n    out vec2 vTexCoord;\n\n    void main() {\n      // transferring texcoords for the frag shader\n      vTexCoord = aTexCoord;\n\n      // copy position with a fourth coordinate for projection (1.0 is normal)\n      vec4 positionVec4 = vec4(aPosition, 1.0);\n\n      // project to 3D space\n      gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n    }\n  " : "\n    uniform mat4 uModelViewMatrix;\n    uniform mat4 uProjectionMatrix;\n\n    attribute vec3 aPosition;\n    // texcoords only come from p5 to vertex shader\n    // so pass texcoords on to the fragment shader in a varying variable\n    attribute vec2 aTexCoord;\n    varying vec2 vTexCoord;\n\n    void main() {\n      // transferring texcoords for the frag shader\n      vTexCoord = aTexCoord;\n\n      // copy position with a fourth coordinate for projection (1.0 is normal)\n      vec4 positionVec4 = vec4(aPosition, 1.0);\n\n      // project to 3D space\n      gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n    }\n  ", t = new u.default.Shader(this._renderer, t, e1);
                    return this._renderer.GL ? t.ensureCompiledOnContext(this) : t.ensureCompiledOnContext(this._renderer.getFilterGraphicsLayer()), t;
                }, u.default.prototype.shader = function(e1) {
                    return this._assert3d("shader"), u.default._validateParameters("shader", arguments), e1.ensureCompiledOnContext(this), e1.isStrokeShader() ? this._renderer.userStrokeShader = e1 : (this._renderer.userFillShader = e1, this._renderer._useNormalMaterial = !1), e1.setDefaultUniforms(), this;
                }, u.default.prototype.baseMaterialShader = function() {
                    return this._assert3d("baseMaterialShader"), this._renderer.baseMaterialShader();
                }, u.default.prototype.baseNormalShader = function() {
                    return this._assert3d("baseNormalShader"), this._renderer.baseNormalShader();
                }, u.default.prototype.baseColorShader = function() {
                    return this._assert3d("baseColorShader"), this._renderer.baseColorShader();
                }, u.default.prototype.baseStrokeShader = function() {
                    return this._assert3d("baseStrokeShader"), this._renderer.baseStrokeShader();
                }, u.default.prototype.resetShader = function() {
                    return this._renderer.userFillShader = this._renderer.userStrokeShader = null, this;
                }, u.default.prototype.texture = function(e1) {
                    return this._assert3d("texture"), u.default._validateParameters("texture", arguments), e1.gifProperties && e1._animateGif(this), this._renderer.drawMode = n.TEXTURE, this._renderer._useNormalMaterial = !1, this._renderer._tex = e1, this._renderer._setProperty("_doFill", !0), this;
                }, u.default.prototype.textureMode = function(e1) {
                    e1 !== n.IMAGE && e1 !== n.NORMAL ? console.warn("You tried to set ".concat(e1, " textureMode only supports IMAGE & NORMAL ")) : this._renderer.textureMode = e1;
                }, u.default.prototype.textureWrap = function(e1) {
                    var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : e1, r = (this._renderer.textureWrapX = e1, this._renderer.textureWrapY = t, !0), o = !1, n = void 0;
                    try {
                        for(var s, i = this._renderer.textures.values()[Symbol.iterator](); !(r = (s = i.next()).done); r = !0)s.value.setWrapMode(e1, t);
                    } catch (e1) {
                        o = !0, n = e1;
                    } finally{
                        try {
                            r || null == i.return || i.return();
                        } finally{
                            if (o) throw n;
                        }
                    }
                }, u.default.prototype.normalMaterial = function() {
                    this._assert3d("normalMaterial");
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    return u.default._validateParameters("normalMaterial", t), this._renderer.drawMode = n.FILL, this._renderer._useSpecularMaterial = !1, this._renderer._useEmissiveMaterial = !1, this._renderer._useNormalMaterial = !0, this._renderer.curFillColor = [
                        1,
                        1,
                        1,
                        1
                    ], this._renderer._setProperty("_doFill", !0), this.noStroke(), this;
                }, u.default.prototype.ambientMaterial = function(e1, t, r) {
                    this._assert3d("ambientMaterial"), u.default._validateParameters("ambientMaterial", arguments);
                    var o = u.default.prototype.color.apply(this, arguments);
                    return this._renderer._hasSetAmbient = !0, this._renderer.curAmbientColor = o._array, this._renderer._useNormalMaterial = !1, this._renderer._enableLighting = !0, this._renderer._setProperty("_doFill", !0), this;
                }, u.default.prototype.emissiveMaterial = function(e1, t, r, o) {
                    this._assert3d("emissiveMaterial"), u.default._validateParameters("emissiveMaterial", arguments);
                    var n = u.default.prototype.color.apply(this, arguments);
                    return this._renderer.curEmissiveColor = n._array, this._renderer._useEmissiveMaterial = !0, this._renderer._useNormalMaterial = !1, this._renderer._enableLighting = !0, this;
                }, u.default.prototype.specularMaterial = function(e1, t, r, o) {
                    this._assert3d("specularMaterial"), u.default._validateParameters("specularMaterial", arguments);
                    var n = u.default.prototype.color.apply(this, arguments);
                    return this._renderer.curSpecularColor = n._array, this._renderer._useSpecularMaterial = !0, this._renderer._useNormalMaterial = !1, this._renderer._enableLighting = !0, this;
                }, u.default.prototype.shininess = function(e1) {
                    return this._assert3d("shininess"), u.default._validateParameters("shininess", arguments), this._renderer._useShininess = e1 = e1 < 1 ? 1 : e1, this;
                }, u.default.prototype.metalness = function(e1) {
                    this._assert3d("metalness");
                    e1 = 1 - Math.exp(-e1 / 100);
                    return this._renderer._useMetalness = e1, this;
                }, u.default.RendererGL.prototype._applyColorBlend = function(e1, t) {
                    var r = this.GL, o = this.drawMode === n.TEXTURE, t = t || this.userFillShader || this.userStrokeShader || this.userPointShader || o || this.curBlendMode !== n.BLEND || e1[e1.length - 1] < 1 || this._isErasing;
                    return t !== this._isBlending && (t || this.curBlendMode !== n.BLEND && this.curBlendMode !== n.ADD ? r.enable(r.BLEND) : r.disable(r.BLEND), r.depthMask(!0), this._isBlending = t), this._applyBlendMode(), e1;
                }, u.default.RendererGL.prototype._applyBlendMode = function() {
                    if (this._cachedBlendMode !== this.curBlendMode) {
                        var e1 = this.GL;
                        switch(this.curBlendMode){
                            case n.BLEND:
                                e1.blendEquation(e1.FUNC_ADD), e1.blendFunc(e1.ONE, e1.ONE_MINUS_SRC_ALPHA);
                                break;
                            case n.ADD:
                                e1.blendEquation(e1.FUNC_ADD), e1.blendFunc(e1.ONE, e1.ONE);
                                break;
                            case n.REMOVE:
                                e1.blendEquation(e1.FUNC_ADD), e1.blendFunc(e1.ZERO, e1.ONE_MINUS_SRC_ALPHA);
                                break;
                            case n.MULTIPLY:
                                e1.blendEquation(e1.FUNC_ADD), e1.blendFunc(e1.DST_COLOR, e1.ONE_MINUS_SRC_ALPHA);
                                break;
                            case n.SCREEN:
                                e1.blendEquation(e1.FUNC_ADD), e1.blendFunc(e1.ONE, e1.ONE_MINUS_SRC_COLOR);
                                break;
                            case n.EXCLUSION:
                                e1.blendEquationSeparate(e1.FUNC_ADD, e1.FUNC_ADD), e1.blendFuncSeparate(e1.ONE_MINUS_DST_COLOR, e1.ONE_MINUS_SRC_COLOR, e1.ONE, e1.ONE);
                                break;
                            case n.REPLACE:
                                e1.blendEquation(e1.FUNC_ADD), e1.blendFunc(e1.ONE, e1.ZERO);
                                break;
                            case n.SUBTRACT:
                                e1.blendEquationSeparate(e1.FUNC_REVERSE_SUBTRACT, e1.FUNC_ADD), e1.blendFuncSeparate(e1.ONE, e1.ONE, e1.ONE, e1.ONE_MINUS_SRC_ALPHA);
                                break;
                            case n.DARKEST:
                                this.blendExt ? (e1.blendEquationSeparate(this.blendExt.MIN || this.blendExt.MIN_EXT, e1.FUNC_ADD), e1.blendFuncSeparate(e1.ONE, e1.ONE, e1.ONE, e1.ONE)) : console.warn("blendMode(DARKEST) does not work in your browser in WEBGL mode.");
                                break;
                            case n.LIGHTEST:
                                this.blendExt ? (e1.blendEquationSeparate(this.blendExt.MAX || this.blendExt.MAX_EXT, e1.FUNC_ADD), e1.blendFuncSeparate(e1.ONE, e1.ONE, e1.ONE, e1.ONE)) : console.warn("blendMode(LIGHTEST) does not work in your browser in WEBGL mode.");
                                break;
                            default:
                                console.error("Oops! Somehow RendererGL set curBlendMode to an unsupported mode.");
                        }
                        this._isErasing || (this._cachedBlendMode = this.curBlendMode);
                    }
                };
                var s = u.default;
                r.default = s;
            },
            {
                "../core/constants": 272,
                "../core/main": 283,
                "./p5.Texture": 343,
                "core-js/modules/es.array.includes": 163,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.join": 166,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.string.includes": 199,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        332: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.math.hypot"), e1("core-js/modules/es.string.sub"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.math.hypot"), e1("core-js/modules/es.string.sub"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var j = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                j.default.prototype.camera = function() {
                    var e1;
                    this._assert3d("camera");
                    for(var t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return j.default._validateParameters("camera", r), (e1 = this._renderer._curCamera).camera.apply(e1, r), this;
                }, j.default.prototype.perspective = function() {
                    var e1;
                    this._assert3d("perspective");
                    for(var t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return j.default._validateParameters("perspective", r), (e1 = this._renderer._curCamera).perspective.apply(e1, r), this;
                }, j.default.prototype.linePerspective = function(e1) {
                    if (j.default._validateParameters("linePerspective", arguments), !(this._renderer instanceof j.default.RendererGL)) throw new Error("linePerspective() must be called in WebGL mode.");
                    if (void 0 === e1) return this._renderer._curCamera.useLinePerspective;
                    this._renderer._curCamera.useLinePerspective = e1;
                }, j.default.prototype.ortho = function() {
                    var e1;
                    this._assert3d("ortho");
                    for(var t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return j.default._validateParameters("ortho", r), (e1 = this._renderer._curCamera).ortho.apply(e1, r), this;
                }, j.default.prototype.frustum = function() {
                    var e1;
                    this._assert3d("frustum");
                    for(var t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return j.default._validateParameters("frustum", r), (e1 = this._renderer._curCamera).frustum.apply(e1, r), this;
                }, j.default.prototype.createCamera = function() {
                    this._assert3d("createCamera");
                    var e1 = new j.default.Camera(this._renderer);
                    return e1._computeCameraDefaultSettings(), e1._setDefaultCamera(), this._renderer._curCamera = e1;
                }, j.default.Camera = function() {
                    function t(e1) {
                        if (!(this instanceof t)) throw new TypeError("Cannot call a class as a function");
                        this._renderer = e1, this.cameraType = "default", this.useLinePerspective = !0, this.cameraMatrix = new j.default.Matrix, this.projMatrix = new j.default.Matrix, this.yScale = 1;
                    }
                    var e1, r, o;
                    return e1 = t, r = [
                        {
                            key: "perspective",
                            value: function(e1, t, r, o) {
                                this.cameraType = 0 < arguments.length ? "custom" : "default", void 0 === e1 ? (e1 = this.defaultCameraFOV, this.cameraFOV = e1) : this.cameraFOV = this._renderer._pInst._toRadians(e1), void 0 === t && (t = this.defaultAspectRatio), void 0 === r && (r = this.defaultCameraNear), void 0 === o && (o = this.defaultCameraFar), r <= 1e-4 && (r = .01, console.log("Avoid perspective near plane values close to or below 0. Setting value to 0.01.")), o < r && console.log("Perspective far plane value is less than near plane value. Nothing will be shown."), this.aspectRatio = t, this.cameraNear = r, this.cameraFar = o, this.projMatrix = j.default.Matrix.identity();
                                var e1 = 1 / Math.tan(this.cameraFOV / 2), n = 1 / (this.cameraNear - this.cameraFar);
                                this.projMatrix.set(e1 / t, 0, 0, 0, 0, -e1 * this.yScale, 0, 0, 0, 0, (o + r) * n, -1, 0, 0, 2 * o * r * n, 0), this._isActive() && this._renderer.uPMatrix.set(this.projMatrix);
                            }
                        },
                        {
                            key: "ortho",
                            value: function(e1, t, r, o, n, s) {
                                var i = this.fbo || this._renderer, i = (void 0 === e1 && (e1 = -i.width / 2), void 0 === t && (t = +i.width / 2), void 0 === r && (r = -i.height / 2), void 0 === o && (o = +i.height / 2), void 0 === n && (n = 0), void 0 === s && (s = Math.max(i.width, i.height) + 800), this.cameraNear = n, t - e1), a = o - r, l = (this.cameraFar = s) - n, u = 2 / i, c = 2 / a * this.yScale, d = -2 / l, t = -(t + e1) / i, e1 = -(o + r) / a, i = -(s + n) / l;
                                this.projMatrix = j.default.Matrix.identity(), this.projMatrix.set(u, 0, 0, 0, 0, -c, 0, 0, 0, 0, d, 0, t, e1, i, 1), this._isActive() && this._renderer.uPMatrix.set(this.projMatrix), this.cameraType = "custom";
                            }
                        },
                        {
                            key: "frustum",
                            value: function(e1, t, r, o, n, s) {
                                void 0 === e1 && (e1 = .05 * -this._renderer.width), void 0 === t && (t = .05 * +this._renderer.width), void 0 === r && (r = .05 * +this._renderer.height), void 0 === o && (o = .05 * -this._renderer.height), void 0 === n && (n = this.defaultCameraNear), void 0 === s && (s = this.defaultCameraFar), this.cameraNear = n;
                                var i = t - e1, a = o - r, l = (this.cameraFar = s) - n, u = 2 * n / i, c = 2 * n / a * this.yScale, d = -2 * s * n / l, t = (t + e1) / i, e1 = (o + r) / a, i = -(s + n) / l;
                                this.projMatrix = j.default.Matrix.identity(), this.projMatrix.set(u, 0, 0, 0, 0, -c, 0, 0, t, e1, i, -1, 0, 0, d, 0), this._isActive() && this._renderer.uPMatrix.set(this.projMatrix), this.cameraType = "custom";
                            }
                        },
                        {
                            key: "_rotateView",
                            value: function(e1, t, r, o) {
                                var n = this.centerX, s = this.centerY, i = this.centerZ, a = (n -= this.eyeX, s -= this.eyeY, i -= this.eyeZ, j.default.Matrix.identity(this._renderer._pInst)), e1 = (a.rotate(this._renderer._pInst._toRadians(e1), t, r, o), [
                                    n * a.mat4[0] + s * a.mat4[4] + i * a.mat4[8],
                                    n * a.mat4[1] + s * a.mat4[5] + i * a.mat4[9],
                                    n * a.mat4[2] + s * a.mat4[6] + i * a.mat4[10]
                                ]), t = (e1[0] += this.eyeX, e1[1] += this.eyeY, e1[2] += this.eyeZ, this.upX * a.mat4[0] + this.upY * a.mat4[4] + this.upZ * a.mat4[8]), r = this.upX * a.mat4[1] + this.upY * a.mat4[5] + this.upZ * a.mat4[9], o = this.upX * a.mat4[2] + this.upY * a.mat4[6] + this.upZ * a.mat4[10];
                                this.camera(this.eyeX, this.eyeY, this.eyeZ, e1[0], e1[1], e1[2], t, r, o);
                            }
                        },
                        {
                            key: "roll",
                            value: function(e1) {
                                var t = this._getLocalAxes(), e1 = j.default.Quat.fromAxisAngle(this._renderer._pInst._toRadians(e1), t.z[0], t.z[1], t.z[2]).rotateVector(new j.default.Vector(this.upX, this.upY, this.upZ));
                                this.camera(this.eyeX, this.eyeY, this.eyeZ, this.centerX, this.centerY, this.centerZ, e1.x, e1.y, e1.z);
                            }
                        },
                        {
                            key: "pan",
                            value: function(e1) {
                                var t = this._getLocalAxes();
                                this._rotateView(e1, t.y[0], t.y[1], t.y[2]);
                            }
                        },
                        {
                            key: "tilt",
                            value: function(e1) {
                                var t = this._getLocalAxes();
                                this._rotateView(e1, t.x[0], t.x[1], t.x[2]);
                            }
                        },
                        {
                            key: "lookAt",
                            value: function(e1, t, r) {
                                this.camera(this.eyeX, this.eyeY, this.eyeZ, e1, t, r, this.upX, this.upY, this.upZ);
                            }
                        },
                        {
                            key: "camera",
                            value: function(e1, t, r, o, n, s, i, a, l) {
                                void 0 === e1 && (e1 = this.defaultEyeX, t = this.defaultEyeY, r = this.defaultEyeZ, o = e1, n = t, a = 1, l = i = s = 0), this.eyeX = e1, this.eyeY = t, this.eyeZ = r, void 0 !== o && (this.centerX = o, this.centerY = n, this.centerZ = s), void 0 !== i && (this.upX = i, this.upY = a, this.upZ = l);
                                o = this._getLocalAxes(), this.cameraMatrix.set(o.x[0], o.y[0], o.z[0], 0, o.x[1], o.y[1], o.z[1], 0, o.x[2], o.y[2], o.z[2], 0, 0, 0, 0, 1), n = -e1;
                                return this.cameraMatrix.translate([
                                    n,
                                    -t,
                                    -r
                                ]), this._isActive() && this._renderer.uViewMatrix.set(this.cameraMatrix), this;
                            }
                        },
                        {
                            key: "move",
                            value: function(e1, t, r) {
                                var o = this._getLocalAxes(), e1 = [
                                    o.x[0] * e1,
                                    o.x[1] * e1,
                                    o.x[2] * e1
                                ], t = [
                                    o.y[0] * t,
                                    o.y[1] * t,
                                    o.y[2] * t
                                ], o = [
                                    o.z[0] * r,
                                    o.z[1] * r,
                                    o.z[2] * r
                                ];
                                this.camera(this.eyeX + e1[0] + t[0] + o[0], this.eyeY + e1[1] + t[1] + o[1], this.eyeZ + e1[2] + t[2] + o[2], this.centerX + e1[0] + t[0] + o[0], this.centerY + e1[1] + t[1] + o[1], this.centerZ + e1[2] + t[2] + o[2], this.upX, this.upY, this.upZ);
                            }
                        },
                        {
                            key: "setPosition",
                            value: function(e1, t, r) {
                                var o = e1 - this.eyeX, n = t - this.eyeY, s = r - this.eyeZ;
                                this.camera(e1, t, r, this.centerX + o, this.centerY + n, this.centerZ + s, this.upX, this.upY, this.upZ);
                            }
                        },
                        {
                            key: "set",
                            value: function(e1) {
                                for(var t = 0, r = [
                                    "eyeX",
                                    "eyeY",
                                    "eyeZ",
                                    "centerX",
                                    "centerY",
                                    "centerZ",
                                    "upX",
                                    "upY",
                                    "upZ",
                                    "cameraFOV",
                                    "aspectRatio",
                                    "cameraNear",
                                    "cameraFar",
                                    "cameraType",
                                    "yScale",
                                    "useLinePerspective"
                                ]; t < r.length; t++){
                                    var o = r[t];
                                    this[o] = e1[o];
                                }
                                this.cameraMatrix = e1.cameraMatrix.copy(), this.projMatrix = e1.projMatrix.copy(), this._isActive() && (this._renderer.uModelMatrix.reset(), this._renderer.uViewMatrix.set(this.cameraMatrix), this._renderer.uPMatrix.set(this.projMatrix));
                            }
                        },
                        {
                            key: "slerp",
                            value: function(e1, t, r) {
                                var o, n, s, i, a, l, u, c, d, h, f, p, m, y, g, v, b, _;
                                0 === r ? this.set(e1) : 1 === r ? this.set(t) : (0 !== this.projMatrix.mat4[15] && (this.projMatrix.mat4[0] = e1.projMatrix.mat4[0] * Math.pow(t.projMatrix.mat4[0] / e1.projMatrix.mat4[0], r), this.projMatrix.mat4[5] = e1.projMatrix.mat4[5] * Math.pow(t.projMatrix.mat4[5] / e1.projMatrix.mat4[5], r), this._isActive() && (this._renderer.uPMatrix.mat4 = this.projMatrix.mat4.slice())), i = new j.default.Vector(e1.eyeX, e1.eyeY, e1.eyeZ), a = new j.default.Vector(t.eyeX, t.eyeY, t.eyeZ), v = new j.default.Vector(e1.centerX, e1.centerY, e1.centerZ), _ = new j.default.Vector(t.centerX, t.centerY, t.centerZ), s = j.default.Vector.dist(i, v), o = j.default.Vector.dist(a, _), o = s * Math.pow(o / s, r), s = j.default.Vector.sub(i, a), n = 1, 1e-6 < (b = (y = i.copy().sub(a).sub(v).add(_)).magSq()) && (n = j.default.Vector.dot(s, y) / b, n = Math.max(0, Math.min(n, 1))), s = j.default.Vector.lerp(j.default.Vector.lerp(i, v, n), j.default.Vector.lerp(a, _, n), r), y = e1.cameraMatrix.createSubMatrix3x3(), b = t.cameraMatrix.createSubMatrix3x3(), i = y.row(2), v = b.row(2), a = y.row(1), _ = b.row(1), e1 = new j.default.Vector, t = new j.default.Vector, l = new j.default.Vector, u = new j.default.Vector, 1 - (c = .5 * ((y = (b = b.mult3x3(y.copy().transpose3x3())).diagonal())[0] + y[1] + y[2] - 1)) < 1e-7 ? (e1.set(j.default.Vector.lerp(i, v, r)).normalize(), l.set(e1).mult(n * o).add(s), u.set(e1).mult((n - 1) * o).add(s), t.set(j.default.Vector.lerp(a, _, r)).normalize()) : (v = 1 / (1 - c), _ = Math.max(y[0], y[1], y[2]), p = b.mat3[1] + b.mat3[3], m = b.mat3[2] + b.mat3[6], g = b.mat3[5] + b.mat3[7], _ = _ === y[0] ? (h = .5 * p * (v /= d = Math.sqrt((y[0] - c) * v)), f = .5 * m * v, .5 * (b.mat3[7] - b.mat3[5]) / d) : _ === y[1] ? (f = .5 * g * (v /= h = Math.sqrt((y[1] - c) * v)), d = .5 * p * v, .5 * (b.mat3[2] - b.mat3[6]) / h) : (d = .5 * m * (v /= f = Math.sqrt((y[2] - c) * v)), h = .5 * g * v, .5 * (b.mat3[3] - b.mat3[1]) / f), p = r * Math.atan2(_, c), m = Math.cos(p), y = Math.sin(p), (_ = new j.default.Matrix("mat3", [
                                    m + (g = 1 - m) * d * d,
                                    g * (v = d * h) + y * f,
                                    g * (b = f * d) - y * h,
                                    g * v - y * f,
                                    m + g * h * h,
                                    g * (r = h * f) + y * d,
                                    g * b + y * h,
                                    g * r - y * d,
                                    m + g * f * f
                                ])).multiplyVec3(i, e1), l.set(e1).mult(n * o).add(s), u.set(e1).mult((n - 1) * o).add(s), _.multiplyVec3(a, t)), this.camera(l.x, l.y, l.z, u.x, u.y, u.z, t.x, t.y, t.z));
                            }
                        },
                        {
                            key: "_computeCameraDefaultSettings",
                            value: function() {
                                this.defaultAspectRatio = this._renderer.width / this._renderer.height, this.defaultEyeX = 0, this.defaultEyeY = 0, this.defaultEyeZ = 800, this.defaultCameraFOV = 2 * Math.atan(this._renderer.height / 2 / this.defaultEyeZ), this.defaultCenterX = 0, this.defaultCenterY = 0, this.defaultCenterZ = 0, this.defaultCameraNear = .1 * this.defaultEyeZ, this.defaultCameraFar = 10 * this.defaultEyeZ;
                            }
                        },
                        {
                            key: "_setDefaultCamera",
                            value: function() {
                                this.cameraFOV = this.defaultCameraFOV, this.aspectRatio = this.defaultAspectRatio, this.eyeX = this.defaultEyeX, this.eyeY = this.defaultEyeY, this.eyeZ = this.defaultEyeZ, this.centerX = this.defaultCenterX, this.centerY = this.defaultCenterY, this.centerZ = this.defaultCenterZ, this.upX = 0, this.upY = 1, this.upZ = 0, this.cameraNear = this.defaultCameraNear, this.cameraFar = this.defaultCameraFar, this.perspective(), this.camera(), this.cameraType = "default";
                            }
                        },
                        {
                            key: "_resize",
                            value: function() {
                                "default" === this.cameraType && (this._computeCameraDefaultSettings(), this.cameraFOV = this.defaultCameraFOV, this.aspectRatio = this.defaultAspectRatio, this.perspective());
                            }
                        },
                        {
                            key: "copy",
                            value: function() {
                                var e1 = new j.default.Camera(this._renderer);
                                return e1.cameraFOV = this.cameraFOV, e1.aspectRatio = this.aspectRatio, e1.eyeX = this.eyeX, e1.eyeY = this.eyeY, e1.eyeZ = this.eyeZ, e1.centerX = this.centerX, e1.centerY = this.centerY, e1.centerZ = this.centerZ, e1.upX = this.upX, e1.upY = this.upY, e1.upZ = this.upZ, e1.cameraNear = this.cameraNear, e1.cameraFar = this.cameraFar, e1.cameraType = this.cameraType, e1.useLinePerspective = this.useLinePerspective, e1.cameraMatrix = this.cameraMatrix.copy(), e1.projMatrix = this.projMatrix.copy(), e1.yScale = this.yScale, e1;
                            }
                        },
                        {
                            key: "_getLocalAxes",
                            value: function() {
                                var e1 = this.eyeX - this.centerX, t = this.eyeY - this.centerY, r = this.eyeZ - this.centerZ, o = Math.sqrt(e1 * e1 + t * t + r * r), o = (0 !== o && (e1 /= o, t /= o, r /= o), this.upX), n = (a = this.upY) * r - (l = this.upZ) * t, s = -o * r + l * e1, i = o * t - a * e1, o = t * i - r * s, a = -e1 * i + r * n, l = e1 * s - t * n, u = Math.sqrt(n * n + s * s + i * i), u = (0 !== u && (n /= u, s /= u, i /= u), Math.sqrt(o * o + a * a + l * l));
                                return 0 !== u && (o /= u, a /= u, l /= u), {
                                    x: [
                                        n,
                                        s,
                                        i
                                    ],
                                    y: [
                                        o,
                                        a,
                                        l
                                    ],
                                    z: [
                                        e1,
                                        t,
                                        r
                                    ]
                                };
                            }
                        },
                        {
                            key: "_orbit",
                            value: function(e1, t, r) {
                                var o = this.eyeX - this.centerX, n = this.eyeY - this.centerY, s = this.eyeZ - this.centerZ, i = Math.hypot(o, n, s), o = new j.default.Vector(o, n, s).normalize(), n = new j.default.Vector(this.upX, this.upY, this.upZ).normalize(), s = j.default.Vector.cross(n, o).normalize(), a = j.default.Vector.cross(s, n), r = ((i = (i *= Math.pow(10, r)) < this.cameraNear ? this.cameraNear : i) > this.cameraFar && (i = this.cameraFar), Math.acos(Math.max(-1, Math.min(1, j.default.Vector.dot(o, n)))) + t), t = e1;
                                (r <= 0 || r >= Math.PI) && (this.upX *= -1, this.upY *= -1, this.upZ *= -1), n.mult(Math.cos(r)), a.mult(Math.cos(t) * Math.sin(r)), s.mult(Math.sin(t) * Math.sin(r)), o.set(n).add(a).add(s), this.eyeX = i * o.x + this.centerX, this.eyeY = i * o.y + this.centerY, this.eyeZ = i * o.z + this.centerZ, this.camera(this.eyeX, this.eyeY, this.eyeZ, this.centerX, this.centerY, this.centerZ, this.upX, this.upY, this.upZ);
                            }
                        },
                        {
                            key: "_orbitFree",
                            value: function(e1, t, r) {
                                var o = this.eyeX - this.centerX, n = this.eyeY - this.centerY, s = this.eyeZ - this.centerZ, i = Math.hypot(o, n, s), o = new j.default.Vector(o, n, s).normalize(), n = new j.default.Vector(this.upX, this.upY, this.upZ), s = j.default.Vector.cross(n, o).normalize(), a = j.default.Vector.cross(o, s), l = Math.atan2(t, e1), l = (a.mult(Math.sin(l)), s.mult(Math.cos(l)).add(a), Math.sqrt(e1 * e1 + t * t)), a = j.default.Vector.cross(o, s), e1 = ((i = (i *= Math.pow(10, r)) < this.cameraNear ? this.cameraNear : i) > this.cameraFar && (i = this.cameraFar), Math.cos(l)), t = Math.sin(l), r = n.dot(o), l = n.dot(s), u = r * e1 + l * t, r = -r * t + l * e1, l = n.dot(a);
                                n.x = u * o.x + r * s.x + l * a.x, n.y = u * o.y + r * s.y + l * a.y, n.z = u * o.z + r * s.z + l * a.z, s.mult(-t), o.mult(e1).add(s).mult(i), this.camera(o.x + this.centerX, o.y + this.centerY, o.z + this.centerZ, this.centerX, this.centerY, this.centerZ, n.x, n.y, n.z);
                            }
                        },
                        {
                            key: "_isActive",
                            value: function() {
                                return this === this._renderer._curCamera;
                            }
                        }
                    ], n(e1.prototype, r), o && n(e1, o), t;
                }(), j.default.prototype.setCamera = function(e1) {
                    this._renderer._curCamera = e1, this._renderer.uPMatrix.set(e1.projMatrix), this._renderer.uViewMatrix.set(e1.cameraMatrix);
                };
                e1 = j.default.Camera;
                r.default = e1;
            },
            {
                "../core/main": 283,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.math.hypot": 176,
                "core-js/modules/es.string.sub": 208
            }
        ],
        333: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.math.log2"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.math.log2"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                e1.default.DataArray = function() {
                    function o() {
                        var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 128, t = this, r = o;
                        if (!(t instanceof r)) throw new TypeError("Cannot call a class as a function");
                        this.length = 0, this.data = new Float32Array(e1), this.initialLength = e1;
                    }
                    var e1, t, r;
                    return e1 = o, t = [
                        {
                            key: "dataArray",
                            value: function() {
                                return this.subArray(0, this.length);
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                this.length = 0;
                            }
                        },
                        {
                            key: "rescale",
                            value: function() {
                                var e1;
                                this.length < this.data.length / 2 && (e1 = 1 << Math.ceil(Math.log2(this.length)), (e1 = new Float32Array(e1)).set(this.data.subarray(0, this.length), 0), this.data = e1);
                            }
                        },
                        {
                            key: "reset",
                            value: function() {
                                this.clear(), this.data = new Float32Array(this.initialLength);
                            }
                        },
                        {
                            key: "push",
                            value: function() {
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                this.ensureLength(this.length + t.length), this.data.set(t, this.length), this.length += t.length;
                            }
                        },
                        {
                            key: "slice",
                            value: function(e1, t) {
                                return this.data.slice(e1, Math.min(t, this.length));
                            }
                        },
                        {
                            key: "subArray",
                            value: function(e1, t) {
                                return this.data.subarray(e1, Math.min(t, this.length));
                            }
                        },
                        {
                            key: "ensureLength",
                            value: function(e1) {
                                for(; this.data.length < e1;){
                                    var t = new Float32Array(2 * this.data.length);
                                    t.set(this.data, 0), this.data = t;
                                }
                            }
                        }
                    ], n(e1.prototype, t), r && n(e1, r), o;
                }();
                e1 = e1.default.DataArray;
                r.default = e1;
            },
            {
                "../core/main": 283,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.math.log2": 177,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.typed-array.copy-within": 213,
                "core-js/modules/es.typed-array.every": 214,
                "core-js/modules/es.typed-array.fill": 215,
                "core-js/modules/es.typed-array.filter": 216,
                "core-js/modules/es.typed-array.find": 218,
                "core-js/modules/es.typed-array.find-index": 217,
                "core-js/modules/es.typed-array.float32-array": 219,
                "core-js/modules/es.typed-array.for-each": 221,
                "core-js/modules/es.typed-array.includes": 222,
                "core-js/modules/es.typed-array.index-of": 223,
                "core-js/modules/es.typed-array.iterator": 226,
                "core-js/modules/es.typed-array.join": 227,
                "core-js/modules/es.typed-array.last-index-of": 228,
                "core-js/modules/es.typed-array.map": 229,
                "core-js/modules/es.typed-array.reduce": 231,
                "core-js/modules/es.typed-array.reduce-right": 230,
                "core-js/modules/es.typed-array.reverse": 232,
                "core-js/modules/es.typed-array.set": 233,
                "core-js/modules/es.typed-array.slice": 234,
                "core-js/modules/es.typed-array.some": 235,
                "core-js/modules/es.typed-array.sort": 236,
                "core-js/modules/es.typed-array.subarray": 237,
                "core-js/modules/es.typed-array.to-locale-string": 238,
                "core-js/modules/es.typed-array.to-string": 239
            }
        ],
        334: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.reflect.get"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.uint8-clamped-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.uint8-clamped-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var f = (j = e1("../core/main")) && j.__esModule ? j : {
                    default: j
                }, a = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = l();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants")), n = e1("./p5.Texture"), p = e1("./p5.RendererGL");
                function l() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, l = function() {
                        return e1;
                    }, e1);
                }
                function u(e1, t) {
                    return function(e1) {
                        if (Array.isArray(e1)) return e1;
                    }(e1) || function(e1, t) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) {
                            var r = [], o = !0, n = !1, s = void 0;
                            try {
                                for(var i, a = e1[Symbol.iterator](); !(o = (i = a.next()).done) && (r.push(i.value), !t || r.length !== t); o = !0);
                            } catch (e1) {
                                n = !0, s = e1;
                            } finally{
                                try {
                                    o || null == a.return || a.return();
                                } finally{
                                    if (n) throw s;
                                }
                            }
                            return r;
                        }
                    }(e1, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance");
                    }();
                }
                function c(e1, t, r) {
                    return t in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function d(e1, t) {
                    if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function h(e1, t, r) {
                    t && s(e1.prototype, t), r && s(e1, r);
                }
                function m(e1, t, r) {
                    return (m = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e1, t, r) {
                        var e1 = function(e1, t) {
                            for(; !Object.prototype.hasOwnProperty.call(e1, t) && null !== (e1 = v(e1)););
                            return e1;
                        }(e1, t);
                        if (e1) return (e1 = Object.getOwnPropertyDescriptor(e1, t)).get ? e1.get.call(r) : e1.value;
                    })(e1, t, r || e1);
                }
                function y(e1, t) {
                    return (y = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                function g(r) {
                    return function() {
                        var e1, t = v(r), t = (e1 = function() {
                            if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                                if ("function" == typeof Proxy) return 1;
                                try {
                                    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                                } catch (e1) {}
                            }
                        }() ? (e1 = v(this).constructor, Reflect.construct(t, arguments, e1)) : t.apply(this, arguments), this);
                        if (!e1 || "object" !== i(e1) && "function" != typeof e1) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }
                        return e1;
                    };
                }
                function v(e1) {
                    return (v = Object.setPrototypeOf ? Object.getPrototypeOf : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    })(e1);
                }
                var b = function(e1) {
                    var t = o;
                    if ("function" != typeof e1 && null !== e1) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e1 && e1.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e1 && y(t, e1);
                    var r = g(o);
                    function o(e1) {
                        var t;
                        return d(this, o), (t = r.call(this, e1.target._renderer)).fbo = e1, t.yScale = -1, t;
                    }
                    return h(o, [
                        {
                            key: "_computeCameraDefaultSettings",
                            value: function() {
                                m(v(o.prototype), "_computeCameraDefaultSettings", this).call(this), this.defaultAspectRatio = this.fbo.width / this.fbo.height, this.defaultCameraFOV = 2 * Math.atan(this.fbo.height / 2 / this.defaultEyeZ);
                            }
                        }
                    ]), o;
                }(f.default.Camera), _ = (f.default.FramebufferCamera = b, function() {
                    function r(e1, t) {
                        d(this, r), this.framebuffer = e1, this.property = t;
                    }
                    return h(r, [
                        {
                            key: "rawTexture",
                            value: function() {
                                return this.framebuffer[this.property];
                            }
                        },
                        {
                            key: "width",
                            get: function() {
                                return this.framebuffer.width * this.framebuffer.density;
                            }
                        },
                        {
                            key: "height",
                            get: function() {
                                return this.framebuffer.height * this.framebuffer.density;
                            }
                        }
                    ]), r;
                }()), j = (f.default.FramebufferTexture = _, function() {
                    function s(e1) {
                        var t = this, r = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, o = (d(this, s), this.target = e1, this.target._renderer.framebuffers.add(this), this._isClipApplied = !1, this.pixels = [], this.format = r.format || a.UNSIGNED_BYTE, this.channels = r.channels || (e1._renderer._pInst._glAttributes.alpha ? a.RGBA : a.RGB), this.useDepth = void 0 === r.depth || r.depth, this.depthFormat = r.depthFormat || a.FLOAT, this.textureFiltering = r.textureFiltering || a.LINEAR, void 0 === r.antialias ? this.antialiasSamples = e1._renderer._pInst._glAttributes.antialias ? 2 : 0 : "number" == typeof r.antialias ? this.antialiasSamples = r.antialias : this.antialiasSamples = r.antialias ? 2 : 0, this.antialias = 0 < this.antialiasSamples, this.antialias && e1.webglVersion !== a.WEBGL2 && (console.warn("Antialiasing is unsupported in a WebGL 1 context"), this.antialias = !1), this.density = r.density || e1.pixelDensity(), e1._renderer.GL);
                        if (this.gl = o, r.width && r.height ? (n = e1._renderer._adjustDimensions(r.width, r.height), this.width = n.adjustedWidth, this.height = n.adjustedHeight, this._autoSized = !1) : (void 0 === r.width != (void 0 === r.height) && console.warn("Please supply both width and height for a framebuffer to give it a size. Only one was given, so the framebuffer will match the size of its canvas."), this.width = e1.width, this.height = e1.height, this._autoSized = !0), this._checkIfFormatsAvailable(), r.stencil && !this.useDepth && console.warn("A stencil buffer can only be used if also using depth. Since the framebuffer has no depth buffer, the stencil buffer will be ignored."), this.useStencil = this.useDepth && (void 0 === r.stencil || r.stencil), this.framebuffer = o.createFramebuffer(), !this.framebuffer) throw new Error("Unable to create a framebuffer");
                        if (this.antialias && (this.aaFramebuffer = o.createFramebuffer(), !this.aaFramebuffer)) throw new Error("Unable to create a framebuffer for antialiasing");
                        this._recreateTextures();
                        var n = this.target._renderer._curCamera;
                        this.defaultCamera = this.createCamera(), this.filterCamera = this.createCamera(), this.target._renderer._curCamera = n, this.draw(function() {
                            return t.target.clear();
                        });
                    }
                    return h(s, [
                        {
                            key: "resize",
                            value: function(e1, t) {
                                this._autoSized = !1;
                                var r = this.target._renderer._adjustDimensions(e1, t);
                                e1 = r.adjustedWidth, t = r.adjustedHeight, this.width = e1, this.height = t, this._handleResize();
                            }
                        },
                        {
                            key: "pixelDensity",
                            value: function(e1) {
                                if (!e1) return this.density;
                                this._autoSized = !1, this.density = e1, this._handleResize();
                            }
                        },
                        {
                            key: "autoSized",
                            value: function(e1) {
                                if (void 0 === e1) return this._autoSized;
                                this._autoSized = e1, this._handleResize();
                            }
                        },
                        {
                            key: "_checkIfFormatsAvailable",
                            value: function() {
                                var e1 = this.gl, e1 = (this.useDepth && this.target.webglVersion === a.WEBGL && !e1.getExtension("WEBGL_depth_texture") && (console.warn("Unable to create depth textures in this environment. Falling back to a framebuffer without depth."), this.useDepth = !1), this.useDepth && this.target.webglVersion === a.WEBGL && this.depthFormat === a.FLOAT && (console.warn("FLOAT depth format is unavailable in WebGL 1. Defaulting to UNSIGNED_INT."), this.depthFormat = a.UNSIGNED_INT), [
                                    a.UNSIGNED_BYTE,
                                    a.FLOAT,
                                    a.HALF_FLOAT
                                ].includes(this.format) || (console.warn("Unknown Framebuffer format. Please use UNSIGNED_BYTE, FLOAT, or HALF_FLOAT. Defaulting to UNSIGNED_BYTE."), this.format = a.UNSIGNED_BYTE), this.useDepth && ![
                                    a.UNSIGNED_INT,
                                    a.FLOAT
                                ].includes(this.depthFormat) && (console.warn("Unknown Framebuffer depth format. Please use UNSIGNED_INT or FLOAT. Defaulting to FLOAT."), this.depthFormat = a.FLOAT), (0, n.checkWebGLCapabilities)(this.target._renderer));
                                e1.float || this.format !== a.FLOAT || (console.warn("This environment does not support FLOAT textures. Falling back to UNSIGNED_BYTE."), this.format = a.UNSIGNED_BYTE), this.useDepth && !e1.float && this.depthFormat === a.FLOAT && (console.warn("This environment does not support FLOAT depth textures. Falling back to UNSIGNED_INT."), this.depthFormat = a.UNSIGNED_INT), e1.halfFloat || this.format !== a.HALF_FLOAT || (console.warn("This environment does not support HALF_FLOAT textures. Falling back to UNSIGNED_BYTE."), this.format = a.UNSIGNED_BYTE), this.channels === a.RGB && [
                                    a.FLOAT,
                                    a.HALF_FLOAT
                                ].includes(this.format) && (console.warn("FLOAT and HALF_FLOAT formats do not work cross-platform with only RGB channels. Falling back to RGBA."), this.channels = a.RGBA);
                            }
                        },
                        {
                            key: "_recreateTextures",
                            value: function() {
                                var e1 = this.gl, t = (this._updateSize(), e1.getParameter(e1.TEXTURE_BINDING_2D)), r = e1.getParameter(e1.FRAMEBUFFER_BINDING), o = e1.createTexture();
                                if (!o) throw new Error("Unable to create color texture");
                                e1.bindTexture(e1.TEXTURE_2D, o);
                                var n = this._glColorFormat();
                                if (e1.texImage2D(e1.TEXTURE_2D, 0, n.internalFormat, this.width * this.density, this.height * this.density, 0, n.format, n.type, null), this.colorTexture = o, e1.bindFramebuffer(e1.FRAMEBUFFER, this.framebuffer), e1.framebufferTexture2D(e1.FRAMEBUFFER, e1.COLOR_ATTACHMENT0, e1.TEXTURE_2D, o, 0), this.useDepth) {
                                    var o = e1.createTexture();
                                    if (!o) throw new Error("Unable to create depth texture");
                                    var s = this._glDepthFormat();
                                    e1.bindTexture(e1.TEXTURE_2D, o), e1.texImage2D(e1.TEXTURE_2D, 0, s.internalFormat, this.width * this.density, this.height * this.density, 0, s.format, s.type, null), e1.framebufferTexture2D(e1.FRAMEBUFFER, this.useStencil ? e1.DEPTH_STENCIL_ATTACHMENT : e1.DEPTH_ATTACHMENT, e1.TEXTURE_2D, o, 0), this.depthTexture = o;
                                }
                                this.antialias && (this.colorRenderbuffer = e1.createRenderbuffer(), e1.bindRenderbuffer(e1.RENDERBUFFER, this.colorRenderbuffer), e1.renderbufferStorageMultisample(e1.RENDERBUFFER, Math.max(0, Math.min(this.antialiasSamples, e1.getParameter(e1.MAX_SAMPLES))), n.internalFormat, this.width * this.density, this.height * this.density), this.useDepth && (s = this._glDepthFormat(), this.depthRenderbuffer = e1.createRenderbuffer(), e1.bindRenderbuffer(e1.RENDERBUFFER, this.depthRenderbuffer), e1.renderbufferStorageMultisample(e1.RENDERBUFFER, Math.max(0, Math.min(this.antialiasSamples, e1.getParameter(e1.MAX_SAMPLES))), s.internalFormat, this.width * this.density, this.height * this.density)), e1.bindFramebuffer(e1.FRAMEBUFFER, this.aaFramebuffer), e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.COLOR_ATTACHMENT0, e1.RENDERBUFFER, this.colorRenderbuffer), this.useDepth && e1.framebufferRenderbuffer(e1.FRAMEBUFFER, this.useStencil ? e1.DEPTH_STENCIL_ATTACHMENT : e1.DEPTH_ATTACHMENT, e1.RENDERBUFFER, this.depthRenderbuffer)), this.useDepth && (this.depth = new _(this, "depthTexture"), o = e1.NEAREST, this.depthP5Texture = new f.default.Texture(this.target._renderer, this.depth, {
                                    minFilter: o,
                                    magFilter: o
                                }), this.target._renderer.textures.set(this.depth, this.depthP5Texture)), this.color = new _(this, "colorTexture");
                                n = this.textureFiltering === a.LINEAR ? e1.LINEAR : e1.NEAREST;
                                this.colorP5Texture = new f.default.Texture(this.target._renderer, this.color, {
                                    minFilter: n,
                                    magFilter: n
                                }), this.target._renderer.textures.set(this.color, this.colorP5Texture), e1.bindTexture(e1.TEXTURE_2D, t), e1.bindFramebuffer(e1.FRAMEBUFFER, r);
                            }
                        },
                        {
                            key: "_glColorFormat",
                            value: function() {
                                var e1, t, r = this.gl, o = this.format === a.FLOAT ? r.FLOAT : this.format === a.HALF_FLOAT ? this.target.webglVersion === a.WEBGL2 ? r.HALF_FLOAT : r.getExtension("OES_texture_half_float").HALF_FLOAT_OES : r.UNSIGNED_BYTE, n = this.channels === a.RGBA ? r.RGBA : r.RGB;
                                return {
                                    internalFormat: this.target.webglVersion === a.WEBGL2 ? (c(t = {}, r.FLOAT, c({}, r.RGBA, r.RGBA32F)), c(t, r.HALF_FLOAT, c({}, r.RGBA, r.RGBA16F)), c(t, r.UNSIGNED_BYTE, (c(e1 = {}, r.RGBA, r.RGBA8), c(e1, r.RGB, r.RGB8), e1)), t[o][n]) : this.format === a.HALF_FLOAT ? r.RGBA : n,
                                    format: n,
                                    type: o
                                };
                            }
                        },
                        {
                            key: "_glDepthFormat",
                            value: function() {
                                var e1 = this.gl, t = this.useStencil ? this.depthFormat === a.FLOAT ? e1.FLOAT_32_UNSIGNED_INT_24_8_REV : this.target.webglVersion === a.WEBGL2 ? e1.UNSIGNED_INT_24_8 : e1.getExtension("WEBGL_depth_texture").UNSIGNED_INT_24_8_WEBGL : this.depthFormat === a.FLOAT ? e1.FLOAT : e1.UNSIGNED_INT, r = this.useStencil ? e1.DEPTH_STENCIL : e1.DEPTH_COMPONENT, e1 = this.useStencil ? this.depthFormat === a.FLOAT ? e1.DEPTH32F_STENCIL8 : this.target.webglVersion === a.WEBGL2 ? e1.DEPTH24_STENCIL8 : e1.DEPTH_STENCIL : this.target.webglVersion === a.WEBGL2 ? this.depthFormat === a.FLOAT ? e1.DEPTH_COMPONENT32F : e1.DEPTH_COMPONENT24 : e1.DEPTH_COMPONENT;
                                return {
                                    internalFormat: e1,
                                    format: r,
                                    type: t
                                };
                            }
                        },
                        {
                            key: "_updateSize",
                            value: function() {
                                this._autoSized && (this.width = this.target.width, this.height = this.target.height, this.density = this.target.pixelDensity());
                            }
                        },
                        {
                            key: "_canvasSizeChanged",
                            value: function() {
                                this._autoSized && this._handleResize();
                            }
                        },
                        {
                            key: "_handleResize",
                            value: function() {
                                var e1 = this.color, t = this.depth, r = this.colorRenderbuffer, o = this.depthRenderbuffer, e1 = (this._deleteTexture(e1), t && this._deleteTexture(t), this.gl);
                                r && e1.deleteRenderbuffer(r), o && e1.deleteRenderbuffer(o), this._recreateTextures(), this.defaultCamera._resize();
                            }
                        },
                        {
                            key: "createCamera",
                            value: function() {
                                var e1 = new b(this);
                                return e1._computeCameraDefaultSettings(), e1._setDefaultCamera(), this.target._renderer._curCamera = e1;
                            }
                        },
                        {
                            key: "_deleteTexture",
                            value: function(e1) {
                                this.gl.deleteTexture(e1.rawTexture()), this.target._renderer.textures.delete(e1);
                            }
                        },
                        {
                            key: "remove",
                            value: function() {
                                var e1 = this.gl;
                                this._deleteTexture(this.color), this.depth && this._deleteTexture(this.depth), e1.deleteFramebuffer(this.framebuffer), this.aaFramebuffer && e1.deleteFramebuffer(this.aaFramebuffer), this.depthRenderbuffer && e1.deleteRenderbuffer(this.depthRenderbuffer), this.colorRenderbuffer && e1.deleteRenderbuffer(this.colorRenderbuffer), this.target._renderer.framebuffers.delete(this);
                            }
                        },
                        {
                            key: "begin",
                            value: function() {
                                this.prevFramebuffer = this.target._renderer.activeFramebuffer(), this.prevFramebuffer && this.prevFramebuffer._beforeEnd(), this.target._renderer.activeFramebuffers.push(this), this._beforeBegin(), this.target.push(), this.target.setCamera(this.defaultCamera), this.target.resetMatrix(), this.target._renderer.uViewMatrix.set(this.target._renderer._curCamera.cameraMatrix), this.target._renderer.uModelMatrix.reset(), this.target._renderer._applyStencilTestIfClipping();
                            }
                        },
                        {
                            key: "_framebufferToBind",
                            value: function() {
                                return this.antialias ? this.aaFramebuffer : this.framebuffer;
                            }
                        },
                        {
                            key: "_beforeBegin",
                            value: function() {
                                var e1 = this.gl;
                                e1.bindFramebuffer(e1.FRAMEBUFFER, this._framebufferToBind()), this.target._renderer.viewport(this.width * this.density, this.height * this.density);
                            }
                        },
                        {
                            key: "_beforeEnd",
                            value: function() {
                                if (this.antialias) {
                                    var e1 = this.gl, t = (e1.bindFramebuffer(e1.READ_FRAMEBUFFER, this.aaFramebuffer), e1.bindFramebuffer(e1.DRAW_FRAMEBUFFER, this.framebuffer), [
                                        [
                                            e1.COLOR_BUFFER_BIT,
                                            this.colorP5Texture.glMagFilter
                                        ]
                                    ]);
                                    this.useDepth && t.push([
                                        e1.DEPTH_BUFFER_BIT,
                                        this.depthP5Texture.glMagFilter
                                    ]);
                                    for(var r = 0, o = t; r < o.length; r++){
                                        var n = u(o[r], 2), s = n[0], n = n[1];
                                        e1.blitFramebuffer(0, 0, this.width * this.density, this.height * this.density, 0, 0, this.width * this.density, this.height * this.density, s, n);
                                    }
                                }
                            }
                        },
                        {
                            key: "end",
                            value: function() {
                                var e1 = this.gl;
                                if (this.target.pop(), this.target._renderer.activeFramebuffers.pop() !== this) throw new Error("It looks like you've called end() while another Framebuffer is active.");
                                this._beforeEnd(), this.prevFramebuffer ? this.prevFramebuffer._beforeBegin() : (e1.bindFramebuffer(e1.FRAMEBUFFER, null), this.target._renderer.viewport(this.target._renderer._origViewport.width, this.target._renderer._origViewport.height)), this.target._renderer._applyStencilTestIfClipping();
                            }
                        },
                        {
                            key: "draw",
                            value: function(e1) {
                                this.begin(), e1(), this.end();
                            }
                        },
                        {
                            key: "loadPixels",
                            value: function() {
                                var e1 = this.gl, t = this.target._renderer.activeFramebuffer(), r = (e1.bindFramebuffer(e1.FRAMEBUFFER, this.framebuffer), this._glColorFormat());
                                this.pixels = (0, p.readPixelsWebGL)(this.pixels, e1, this.framebuffer, 0, 0, this.width * this.density, this.height * this.density, r.format, r.type), t ? e1.bindFramebuffer(e1.FRAMEBUFFER, t._framebufferToBind()) : e1.bindFramebuffer(e1.FRAMEBUFFER, null);
                            }
                        },
                        {
                            key: "get",
                            value: function(e1, t, r, o) {
                                f.default._validateParameters("p5.Framebuffer.get", arguments);
                                var n = this._glColorFormat();
                                if (void 0 === e1 && void 0 === t) t = e1 = 0, r = this.width, o = this.height;
                                else if (void 0 === r && void 0 === o) return (e1 < 0 || t < 0 || e1 >= this.width || t >= this.height) && (console.warn("The x and y values passed to p5.Framebuffer.get are outside of its range and will be clamped."), e1 = this.target.constrain(e1, 0, this.width - 1), t = this.target.constrain(t, 0, this.height - 1)), (0, p.readPixelWebGL)(this.gl, this.framebuffer, e1 * this.density, t * this.density, n.format, n.type);
                                e1 = this.target.constrain(e1, 0, this.width - 1), t = this.target.constrain(t, 0, this.height - 1), r = this.target.constrain(r, 1, this.width - e1), o = this.target.constrain(o, 1, this.height - t);
                                for(var s = (0, p.readPixelsWebGL)(void 0, this.gl, this.framebuffer, e1 * this.density, t * this.density, r * this.density, o * this.density, n.format, n.type), i = new Uint8ClampedArray(r * o * this.density * this.density * 4), a = (i.fill(255), n.type === this.gl.RGB ? 3 : 4), l = 0; l < o * this.density; l++)for(var u = 0; u < r * this.density; u++)for(var c = 0; c < 4; c++){
                                    var d, h = 4 * (l * r * this.density + u) + c;
                                    c < a && (d = 4 == a ? h : (l * r * this.density + u) * a + c, i[h] = s[d]);
                                }
                                e1 = new f.default.Image(r * this.density, o * this.density);
                                return e1.imageData = e1.canvas.getContext("2d").createImageData(e1.width, e1.height), e1.imageData.data.set(i), e1.pixels = e1.imageData.data, e1.updatePixels(), 1 !== this.density && e1.resize(r, o), e1;
                            }
                        },
                        {
                            key: "updatePixels",
                            value: function() {
                                var e1 = this.gl, t = (this.colorP5Texture.bindTexture(), this._glColorFormat()), r = t.format === e1.RGBA ? 4 : 3, r = this.width * this.height * this.density * this.density * r, o = t.type === e1.UNSIGNED_BYTE ? Uint8Array : Float32Array;
                                if (!(this.pixels instanceof o) || this.pixels.length !== r) throw new Error("The pixels array has not been set correctly. Please call loadPixels() before updatePixels().");
                                e1.texImage2D(e1.TEXTURE_2D, 0, t.internalFormat, this.width * this.density, this.height * this.density, 0, t.format, t.type, this.pixels), this.colorP5Texture.unbindTexture();
                                o = this.target._renderer.activeFramebuffer();
                                this.antialias ? (this.begin(), this.target.push(), this.target.imageMode(this.target.CENTER), this.target.resetMatrix(), this.target.noStroke(), this.target.clear(), this.target.image(this, 0, 0), this.target.pop(), this.useDepth && (e1.clearDepth(1), e1.clear(e1.DEPTH_BUFFER_BIT)), this.end()) : (e1.bindFramebuffer(e1.FRAMEBUFFER, this.framebuffer), this.useDepth && (e1.clearDepth(1), e1.clear(e1.DEPTH_BUFFER_BIT)), o ? e1.bindFramebuffer(e1.FRAMEBUFFER, o._framebufferToBind()) : e1.bindFramebuffer(e1.FRAMEBUFFER, null));
                            }
                        }
                    ]), s;
                }()), e1 = f.default.Framebuffer = j;
                r.default = e1;
            },
            {
                "../core/constants": 272,
                "../core/main": 283,
                "./p5.RendererGL": 341,
                "./p5.Texture": 343,
                "core-js/modules/es.array.fill": 156,
                "core-js/modules/es.array.includes": 163,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.get-prototype-of": 188,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.reflect.construct": 192,
                "core-js/modules/es.reflect.get": 193,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.includes": 199,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.typed-array.copy-within": 213,
                "core-js/modules/es.typed-array.every": 214,
                "core-js/modules/es.typed-array.fill": 215,
                "core-js/modules/es.typed-array.filter": 216,
                "core-js/modules/es.typed-array.find": 218,
                "core-js/modules/es.typed-array.find-index": 217,
                "core-js/modules/es.typed-array.float32-array": 219,
                "core-js/modules/es.typed-array.for-each": 221,
                "core-js/modules/es.typed-array.includes": 222,
                "core-js/modules/es.typed-array.index-of": 223,
                "core-js/modules/es.typed-array.iterator": 226,
                "core-js/modules/es.typed-array.join": 227,
                "core-js/modules/es.typed-array.last-index-of": 228,
                "core-js/modules/es.typed-array.map": 229,
                "core-js/modules/es.typed-array.reduce": 231,
                "core-js/modules/es.typed-array.reduce-right": 230,
                "core-js/modules/es.typed-array.reverse": 232,
                "core-js/modules/es.typed-array.set": 233,
                "core-js/modules/es.typed-array.slice": 234,
                "core-js/modules/es.typed-array.some": 235,
                "core-js/modules/es.typed-array.sort": 236,
                "core-js/modules/es.typed-array.subarray": 237,
                "core-js/modules/es.typed-array.to-locale-string": 238,
                "core-js/modules/es.typed-array.to-string": 239,
                "core-js/modules/es.typed-array.uint8-array": 242,
                "core-js/modules/es.typed-array.uint8-clamped-array": 243,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        335: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.flat"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.last-index-of"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.unscopables.flat"), e1("core-js/modules/es.array-buffer.constructor"), e1("core-js/modules/es.map"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.entries"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.set"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.sub"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.flat"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.last-index-of"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.unscopables.flat"), e1("core-js/modules/es.array-buffer.constructor"), e1("core-js/modules/es.map"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.entries"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.set"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.sub"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var F = (s = e1("../core/main")) && s.__esModule ? s : {
                    default: s
                }, m = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function c(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                function U(e1, t) {
                    return function(e1) {
                        if (Array.isArray(e1)) return e1;
                    }(e1) || function(e1, t) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) {
                            var r = [], o = !0, n = !1, s = void 0;
                            try {
                                for(var i, a = e1[Symbol.iterator](); !(o = (i = a.next()).done) && (r.push(i.value), !t || r.length !== t); o = !0);
                            } catch (e1) {
                                n = !0, s = e1;
                            } finally{
                                try {
                                    o || null == a.return || a.return();
                                } finally{
                                    if (n) throw s;
                                }
                            }
                            return r;
                        }
                    }(e1, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance");
                    }();
                }
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                F.default.Geometry = function() {
                    function o(e1, t, r) {
                        if (!(this instanceof o)) throw new TypeError("Cannot call a class as a function");
                        this.vertices = [], this.boundingBoxCache = null, this.lineVertices = new F.default.DataArray, this.lineTangentsIn = new F.default.DataArray, this.lineTangentsOut = new F.default.DataArray, this.lineSides = new F.default.DataArray, this.vertexNormals = [], this.faces = [], this.uvs = [], this.edges = [], this.vertexColors = [], this.vertexStrokeColors = [], this.lineVertexColors = new F.default.DataArray, this.detailX = void 0 !== e1 ? e1 : 1, this.detailY = void 0 !== t ? t : 1, this.dirtyFlags = {}, this._hasFillTransparency = void 0, this._hasStrokeTransparency = void 0, r instanceof Function && r.call(this);
                    }
                    var e1, t, r;
                    return e1 = o, t = [
                        {
                            key: "calculateBoundingBox",
                            value: function() {
                                if (!this.boundingBoxCache) {
                                    for(var e1 = new F.default.Vector(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE), t = new F.default.Vector(Number.MIN_VALUE, Number.MIN_VALUE, Number.MIN_VALUE), r = 0; r < this.vertices.length; r++){
                                        var o = this.vertices[r];
                                        e1.x = Math.min(e1.x, o.x), e1.y = Math.min(e1.y, o.y), e1.z = Math.min(e1.z, o.z), t.x = Math.max(t.x, o.x), t.y = Math.max(t.y, o.y), t.z = Math.max(t.z, o.z);
                                    }
                                    var n = new F.default.Vector(t.x - e1.x, t.y - e1.y, t.z - e1.z), s = new F.default.Vector((e1.x + t.x) / 2, (e1.y + t.y) / 2, (e1.z + t.z) / 2);
                                    this.boundingBoxCache = {
                                        min: e1,
                                        max: t,
                                        size: n,
                                        offset: s
                                    };
                                }
                                return this.boundingBoxCache;
                            }
                        },
                        {
                            key: "reset",
                            value: function() {
                                this._hasFillTransparency = void 0, this._hasStrokeTransparency = void 0, this.lineVertices.clear(), this.lineTangentsIn.clear(), this.lineTangentsOut.clear(), this.lineSides.clear(), this.vertices.length = 0, this.edges.length = 0, this.vertexColors.length = 0, this.vertexStrokeColors.length = 0, this.lineVertexColors.clear(), this.vertexNormals.length = 0, this.uvs.length = 0, this.dirtyFlags = {};
                            }
                        },
                        {
                            key: "hasFillTransparency",
                            value: function() {
                                if (void 0 === this._hasFillTransparency) {
                                    this._hasFillTransparency = !1;
                                    for(var e1 = 0; e1 < this.vertexColors.length; e1 += 4)if (this.vertexColors[e1 + 3] < 1) {
                                        this._hasFillTransparency = !0;
                                        break;
                                    }
                                }
                                return this._hasFillTransparency;
                            }
                        },
                        {
                            key: "hasStrokeTransparency",
                            value: function() {
                                if (void 0 === this._hasStrokeTransparency) {
                                    this._hasStrokeTransparency = !1;
                                    for(var e1 = 0; e1 < this.lineVertexColors.length; e1 += 4)if (this.lineVertexColors[e1 + 3] < 1) {
                                        this._hasStrokeTransparency = !0;
                                        break;
                                    }
                                }
                                return this._hasStrokeTransparency;
                            }
                        },
                        {
                            key: "clearColors",
                            value: function() {
                                return this.vertexColors = [], this;
                            }
                        },
                        {
                            key: "saveObj",
                            value: function() {
                                var r = this, e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "model.obj", o = "";
                                if (this.vertices.forEach(function(e1) {
                                    o += "v ".concat(e1.x, " ").concat(e1.y, " ").concat(e1.z, "\n");
                                }), this.uvs && 0 < this.uvs.length) for(var t = 0; t < this.uvs.length; t += 2)o += "vt ".concat(this.uvs[t], " ").concat(this.uvs[t + 1], "\n");
                                this.vertexNormals && 0 < this.vertexNormals.length && this.vertexNormals.forEach(function(e1) {
                                    o += "vn ".concat(e1.x, " ").concat(e1.y, " ").concat(e1.z, "\n");
                                }), this.faces.forEach(function(e1) {
                                    var t = "f";
                                    e1.forEach(function(e1) {
                                        t = t + " " + (e1 + 1), (0 < r.vertexNormals.length || 0 < r.uvs.length) && (t += "/", 0 < r.uvs.length && (t += e1 + 1), t += "/", 0 < r.vertexNormals.length && (t += e1 + 1));
                                    }), o += t + "\n";
                                });
                                var n = new Blob([
                                    o
                                ], {
                                    type: "text/plain"
                                });
                                F.default.prototype.downloadFile(n, e1, "obj");
                            }
                        },
                        {
                            key: "saveStl",
                            value: function() {
                                var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "model.stl", t = (1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}).binary, t = void 0 !== t && t, r = e1.substring(0, e1.lastIndexOf(".")), o = [], n = !0, s = !1, i = void 0;
                                try {
                                    for(var a, l = this.faces[Symbol.iterator](); !(n = (a = l.next()).done); n = !0){
                                        var u = a.value, c = F.default.Vector.sub(this.vertices[u[1]], this.vertices[u[0]]), d = F.default.Vector.sub(this.vertices[u[2]], this.vertices[u[0]]), h = c.y * d.z - c.z * d.y, f = c.z * d.x - c.x * d.z, p = c.x * d.y - c.y * d.x;
                                        o.push(new F.default.Vector(h, f, p).normalize());
                                    }
                                } catch (e1) {
                                    s = !0, i = e1;
                                } finally{
                                    try {
                                        n || null == l.return || l.return();
                                    } finally{
                                        if (s) throw i;
                                    }
                                }
                                if (t) {
                                    var m, y = 80, s = 2 * this.faces.length + 3 * this.faces.length * 16 + 80 + 4, i = new ArrayBuffer(s);
                                    (m = new DataView(i)).setUint32(y, this.faces.length, !0), y += 4;
                                    for(var g = 0, v = Object.entries(this.faces); g < v.length; g++){
                                        var b = U(v[g], 2), _ = b[0], b = b[1], _ = o[_], j = (m.setFloat32(y, _.x, !0), y += 4, m.setFloat32(y, _.y, !0), y += 4, m.setFloat32(y, _.z, !0), y += 4, !0), _ = !1, x = void 0;
                                        try {
                                            for(var w, S = b[Symbol.iterator](); !(j = (w = S.next()).done); j = !0){
                                                var I = w.value, T = this.vertices[I];
                                                m.setFloat32(y, T.x, !0), y += 4, m.setFloat32(y, T.y, !0), y += 4, m.setFloat32(y, T.z, !0), y += 4;
                                            }
                                        } catch (e1) {
                                            _ = !0, x = e1;
                                        } finally{
                                            try {
                                                j || null == S.return || S.return();
                                            } finally{
                                                if (_) throw x;
                                            }
                                        }
                                        m.setUint16(y, 0, !0), y += 2;
                                    }
                                } else {
                                    m = "solid " + r + "\n";
                                    for(var E = 0, M = Object.entries(this.faces); E < M.length; E++){
                                        var k = U(M[E], 2), O = k[0], k = k[1], O = o[O], C = (m = m + (" facet norm " + O.x + " " + O.y + " " + O.z + "\n") + "  outer loop\n", !0), O = !1, P = void 0;
                                        try {
                                            for(var A, L = k[Symbol.iterator](); !(C = (A = L.next()).done); C = !0){
                                                var D = A.value, R = this.vertices[D];
                                                m += "   vertex " + R.x + " " + R.y + " " + R.z + "\n";
                                            }
                                        } catch (e1) {
                                            O = !0, P = e1;
                                        } finally{
                                            try {
                                                C || null == L.return || L.return();
                                            } finally{
                                                if (O) throw P;
                                            }
                                        }
                                        m = m + "  endloop\n" + " endfacet\n";
                                    }
                                    m += "endsolid " + r + "\n";
                                }
                                t = new Blob([
                                    m
                                ], {
                                    type: "text/plain"
                                });
                                F.default.prototype.downloadFile(t, e1, "stl");
                            }
                        },
                        {
                            key: "flipU",
                            value: function() {
                                this.uvs = this.uvs.flat().map(function(e1, t) {
                                    return t % 2 == 0 ? 1 - e1 : e1;
                                });
                            }
                        },
                        {
                            key: "flipV",
                            value: function() {
                                this.uvs = this.uvs.flat().map(function(e1, t) {
                                    return t % 2 == 0 ? e1 : 1 - e1;
                                });
                            }
                        },
                        {
                            key: "computeFaces",
                            value: function() {
                                this.faces.length = 0;
                                for(var e1, t, r, o = this.detailX + 1, n = 0; n < this.detailY; n++)for(var s = 0; s < this.detailX; s++)t = (n + 1) * o + s + 1, this.faces.push([
                                    n * o + s,
                                    e1 = n * o + s + 1,
                                    r = (n + 1) * o + s
                                ]), this.faces.push([
                                    r,
                                    e1,
                                    t
                                ]);
                                return this;
                            }
                        },
                        {
                            key: "_getFaceNormal",
                            value: function(e1) {
                                var e1 = this.faces[e1], t = this.vertices[e1[0]], r = this.vertices[e1[1]], e1 = this.vertices[e1[2]], r = F.default.Vector.sub(r, t), e1 = F.default.Vector.sub(e1, t), t = F.default.Vector.cross(r, e1), o = F.default.Vector.mag(t), r = o / (F.default.Vector.mag(r) * F.default.Vector.mag(e1));
                                return 0 === r || isNaN(r) ? (console.warn("p5.Geometry.prototype._getFaceNormal:", "face has colinear sides or a repeated vertex"), t) : (1 < r && (r = 1), t.mult(Math.asin(r) / o));
                            }
                        },
                        {
                            key: "computeNormals",
                            value: function() {
                                var e1, s = this, t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : m.FLAT, r = (1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}).roundToPrecision, i = this.vertexNormals, o = this.vertices, n = this.faces;
                                if (t === m.SMOOTH) {
                                    for(var a = {}, l = [], u = Math.pow(10, void 0 === r ? 3 : r), c = function(e1) {
                                        return Math.round(e1 * u) / u;
                                    }, d = function(e1) {
                                        return "".concat(c(e1.x), ",").concat(c(e1.y), ",").concat(c(e1.z));
                                    }, h = 0; h < o.length; h++){
                                        var f = o[h], p = d(f);
                                        void 0 === a[p] && (a[p] = l.length, l.push(f));
                                    }
                                    n.forEach(function(e1) {
                                        for(var t = 0; t < 3; ++t){
                                            var r = e1[t], r = o[r], r = d(r);
                                            e1[t] = a[r];
                                        }
                                    }), this.edges.forEach(function(e1) {
                                        for(var t = 0; t < 2; ++t){
                                            var r = e1[t], r = o[r], r = d(r);
                                            e1[t] = a[r];
                                        }
                                    }), this.vertices = o = l;
                                }
                                for(e1 = i.length = 0; e1 < o.length; ++e1)i.push(new F.default.Vector);
                                for(n.forEach(function(e1, t) {
                                    for(var r = s._getFaceNormal(t), o = 0; o < 3; ++o){
                                        var n = e1[o];
                                        i[n].add(r);
                                    }
                                }), e1 = 0; e1 < o.length; ++e1)i[e1].normalize();
                                return this;
                            }
                        },
                        {
                            key: "averageNormals",
                            value: function() {
                                for(var e1 = 0; e1 <= this.detailY; e1++){
                                    var t = this.detailX + 1, r = F.default.Vector.add(this.vertexNormals[e1 * t], this.vertexNormals[e1 * t + this.detailX]), r = F.default.Vector.div(r, 2);
                                    this.vertexNormals[e1 * t] = r, this.vertexNormals[e1 * t + this.detailX] = r;
                                }
                                return this;
                            }
                        },
                        {
                            key: "averagePoleNormals",
                            value: function() {
                                for(var e1 = new F.default.Vector(0, 0, 0), t = 0; t < this.detailX; t++)e1.add(this.vertexNormals[t]);
                                for(var e1 = F.default.Vector.div(e1, this.detailX), r = 0; r < this.detailX; r++)this.vertexNormals[r] = e1;
                                e1 = new F.default.Vector(0, 0, 0);
                                for(var o = this.vertices.length - 1; o > this.vertices.length - 1 - this.detailX; o--)e1.add(this.vertexNormals[o]);
                                e1 = F.default.Vector.div(e1, this.detailX);
                                for(var n = this.vertices.length - 1; n > this.vertices.length - 1 - this.detailX; n--)this.vertexNormals[n] = e1;
                                return this;
                            }
                        },
                        {
                            key: "_makeTriangleEdges",
                            value: function() {
                                for(var e1 = this.edges.length = 0; e1 < this.faces.length; e1++)this.edges.push([
                                    this.faces[e1][0],
                                    this.faces[e1][1]
                                ]), this.edges.push([
                                    this.faces[e1][1],
                                    this.faces[e1][2]
                                ]), this.edges.push([
                                    this.faces[e1][2],
                                    this.faces[e1][0]
                                ]);
                                return this;
                            }
                        },
                        {
                            key: "_edgesToVertices",
                            value: function() {
                                this.lineVertices.clear(), this.lineTangentsIn.clear(), this.lineTangentsOut.clear(), this.lineSides.clear();
                                for(var e1, t = new Map, r = new Set, o = 0; o < this.edges.length; o++){
                                    var n, s = this.edges[o - 1], i = this.edges[o], a = this.vertices[i[0]], l = this.vertices[i[1]], u = 0 < this.vertexStrokeColors.length && s ? this.vertexStrokeColors.slice(4 * s[1], 4 * (s[1] + 1)) : [
                                        0,
                                        0,
                                        0,
                                        0
                                    ], c = 0 < this.vertexStrokeColors.length ? this.vertexStrokeColors.slice(4 * i[0], 4 * (i[0] + 1)) : [
                                        0,
                                        0,
                                        0,
                                        0
                                    ], d = 0 < this.vertexStrokeColors.length ? this.vertexStrokeColors.slice(4 * i[1], 4 * (i[1] + 1)) : [
                                        0,
                                        0,
                                        0,
                                        0
                                    ], h = l.copy().sub(a).normalize(), f = 0 < h.magSq();
                                    f && this._addSegment(a, l, c, d, h), 0 < o && s[1] === i[0] ? r.has(i[0]) || (r.add(i[0]), t.delete(i[0]), e1 && f && h.dot(e1) < 1 - 1e-8 && this._addJoin(a, e1, h, c)) : (f && !r.has(i[0]) && ((n = t.get(i[0])) ? (this._addJoin(a, n.dir, h, c), t.delete(i[0]), r.add(i[0])) : t.set(i[0], {
                                        point: a,
                                        dir: h.copy().mult(-1),
                                        color: c
                                    })), e1 && !r.has(s[1]) && ((n = t.get(s[1])) ? (this._addJoin(this.vertices[s[1]], e1, n.dir.copy().mult(-1), u), t.delete(s[1]), r.add(s[1])) : t.set(s[1], {
                                        point: this.vertices[s[1]],
                                        dir: e1,
                                        color: u
                                    }), e1 = void 0)), o !== this.edges.length - 1 || r.has(i[1]) || ((a = t.get(i[1])) ? (this._addJoin(l, h, a.dir.copy().mult(-1), d), t.delete(i[1]), r.add(i[1])) : t.set(i[1], {
                                        point: l,
                                        dir: h,
                                        color: d
                                    })), f && (e1 = h);
                                }
                                var p = !0, m = !1, y = void 0;
                                try {
                                    for(var g, v = t.values()[Symbol.iterator](); !(p = (g = v.next()).done); p = !0){
                                        var b = g.value, _ = b.point, j = b.dir, x = b.color;
                                        this._addCap(_, j, x);
                                    }
                                } catch (e1) {
                                    m = !0, y = e1;
                                } finally{
                                    try {
                                        p || null == v.return || v.return();
                                    } finally{
                                        if (m) throw y;
                                    }
                                }
                                return this;
                            }
                        },
                        {
                            key: "_addSegment",
                            value: function(e1, t, r, o, n) {
                                var e1 = e1.array(), t = t.array(), s = n.array();
                                this.lineSides.push(1, 1, -1, 1, -1, -1);
                                for(var i = 0, a = [
                                    this.lineTangentsIn,
                                    this.lineTangentsOut
                                ]; i < a.length; i++)for(var l = a[i], u = 0; u < 6; u++)l.push.apply(l, c(s));
                                return (n = this.lineVertices).push.apply(n, c(e1).concat(c(t), c(e1), c(t), c(t), c(e1))), (n = this.lineVertexColors).push.apply(n, c(r).concat(c(o), c(r), c(o), c(o), c(r))), this;
                            }
                        },
                        {
                            key: "_addCap",
                            value: function(e1, t, r) {
                                for(var o, n = e1.array(), s = t.array(), i = [
                                    0,
                                    0,
                                    0
                                ], a = 0; a < 6; a++)(o = this.lineVertices).push.apply(o, c(n)), (o = this.lineTangentsIn).push.apply(o, c(s)), (o = this.lineTangentsOut).push.apply(o, i), (o = this.lineVertexColors).push.apply(o, c(r));
                                return this.lineSides.push(-1, 2, -2, 1, 2, -1), this;
                            }
                        },
                        {
                            key: "_addJoin",
                            value: function(e1, t, r, o) {
                                for(var n, s = e1.array(), i = t.array(), a = r.array(), l = 0; l < 12; l++)(n = this.lineVertices).push.apply(n, c(s)), (n = this.lineTangentsIn).push.apply(n, c(i)), (n = this.lineTangentsOut).push.apply(n, c(a)), (n = this.lineVertexColors).push.apply(n, c(o));
                                return this.lineSides.push(-1, -3, -2, -1, 0, -3), this.lineSides.push(3, 1, 2, 3, 0, 1), this;
                            }
                        },
                        {
                            key: "normalize",
                            value: function() {
                                if (0 < this.vertices.length) {
                                    for(var e1 = this.vertices[0].copy(), t = this.vertices[0].copy(), r = 0; r < this.vertices.length; r++)e1.x = Math.max(e1.x, this.vertices[r].x), t.x = Math.min(t.x, this.vertices[r].x), e1.y = Math.max(e1.y, this.vertices[r].y), t.y = Math.min(t.y, this.vertices[r].y), e1.z = Math.max(e1.z, this.vertices[r].z), t.z = Math.min(t.z, this.vertices[r].z);
                                    for(var o = F.default.Vector.lerp(e1, t, .5), n = F.default.Vector.sub(e1, t), s = 200 / Math.max(Math.max(n.x, n.y), n.z), i = 0; i < this.vertices.length; i++)this.vertices[i].sub(o), this.vertices[i].mult(s);
                                }
                                return this;
                            }
                        }
                    ], n(e1.prototype, t), r && n(e1, r), o;
                }();
                var s = F.default.Geometry;
                r.default = s;
            },
            {
                "../core/constants": 272,
                "../core/main": 283,
                "core-js/modules/es.array-buffer.constructor": 152,
                "core-js/modules/es.array.concat": 153,
                "core-js/modules/es.array.flat": 160,
                "core-js/modules/es.array.for-each": 161,
                "core-js/modules/es.array.from": 162,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.last-index-of": 167,
                "core-js/modules/es.array.map": 168,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.array.unscopables.flat": 173,
                "core-js/modules/es.map": 175,
                "core-js/modules/es.number.constructor": 179,
                "core-js/modules/es.object.entries": 184,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.set": 197,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.string.sub": 208,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.for-each": 245,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        336: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var O = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                var s = Array, C = function(e1) {
                    return Array.isArray(e1);
                }, e1 = ("undefined" != typeof Float32Array && (s = Float32Array, C = function(e1) {
                    return Array.isArray(e1) || e1 instanceof Float32Array;
                }), O.default.Matrix = function() {
                    function r() {
                        var e1 = this, t = r;
                        if (e1 instanceof t) return arguments.length && ((e1 = arguments.length - 1) < 0 || arguments.length <= e1 ? void 0 : arguments[e1]) instanceof O.default && (this.p5 = (t = arguments.length - 1) < 0 || arguments.length <= t ? void 0 : arguments[t]), "mat3" === (arguments.length <= 0 ? void 0 : arguments[0]) ? this.mat3 = Array.isArray(arguments.length <= 1 ? void 0 : arguments[1]) ? arguments.length <= 1 ? void 0 : arguments[1] : new s([
                            1,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            1
                        ]) : this.mat4 = Array.isArray(arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 0 ? void 0 : arguments[0] : new s([
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1
                        ]), this;
                        throw new TypeError("Cannot call a class as a function");
                    }
                    var e1, t, o;
                    return e1 = r, o = [
                        {
                            key: "identity",
                            value: function(e1) {
                                return new O.default.Matrix(e1);
                            }
                        }
                    ], t = [
                        {
                            key: "reset",
                            value: function() {
                                return this.mat3 ? this.mat3.set([
                                    1,
                                    0,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    0,
                                    1
                                ]) : this.mat4 && this.mat4.set([
                                    1,
                                    0,
                                    0,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    0,
                                    0,
                                    1
                                ]), this;
                            }
                        },
                        {
                            key: "set",
                            value: function(e1) {
                                var t = arguments;
                                if (e1 instanceof O.default.Matrix ? t = e1.mat4 : C(e1) && (t = e1), 16 !== t.length) O.default._friendlyError("Expected 16 values but received ".concat(t.length, "."), "p5.Matrix.set");
                                else for(var r = 0; r < 16; r++)this.mat4[r] = t[r];
                                return this;
                            }
                        },
                        {
                            key: "get",
                            value: function() {
                                return new O.default.Matrix(this.mat4, this.p5);
                            }
                        },
                        {
                            key: "copy",
                            value: function() {
                                var e1;
                                return void 0 !== this.mat3 ? ((e1 = new O.default.Matrix("mat3", this.p5)).mat3[0] = this.mat3[0], e1.mat3[1] = this.mat3[1], e1.mat3[2] = this.mat3[2], e1.mat3[3] = this.mat3[3], e1.mat3[4] = this.mat3[4], e1.mat3[5] = this.mat3[5], e1.mat3[6] = this.mat3[6], e1.mat3[7] = this.mat3[7], e1.mat3[8] = this.mat3[8]) : ((e1 = new O.default.Matrix(this.p5)).mat4[0] = this.mat4[0], e1.mat4[1] = this.mat4[1], e1.mat4[2] = this.mat4[2], e1.mat4[3] = this.mat4[3], e1.mat4[4] = this.mat4[4], e1.mat4[5] = this.mat4[5], e1.mat4[6] = this.mat4[6], e1.mat4[7] = this.mat4[7], e1.mat4[8] = this.mat4[8], e1.mat4[9] = this.mat4[9], e1.mat4[10] = this.mat4[10], e1.mat4[11] = this.mat4[11], e1.mat4[12] = this.mat4[12], e1.mat4[13] = this.mat4[13], e1.mat4[14] = this.mat4[14], e1.mat4[15] = this.mat4[15]), e1;
                            }
                        },
                        {
                            key: "transpose",
                            value: function(e1) {
                                var t, r, o, n, s, i;
                                return e1 instanceof O.default.Matrix ? (t = e1.mat4[1], r = e1.mat4[2], o = e1.mat4[3], n = e1.mat4[6], s = e1.mat4[7], i = e1.mat4[11], this.mat4[0] = e1.mat4[0], this.mat4[1] = e1.mat4[4], this.mat4[2] = e1.mat4[8], this.mat4[3] = e1.mat4[12], this.mat4[4] = t, this.mat4[5] = e1.mat4[5], this.mat4[6] = e1.mat4[9], this.mat4[7] = e1.mat4[13], this.mat4[8] = r, this.mat4[9] = n, this.mat4[10] = e1.mat4[10], this.mat4[11] = e1.mat4[14], this.mat4[12] = o, this.mat4[13] = s, this.mat4[14] = i, this.mat4[15] = e1.mat4[15]) : C(e1) && (t = e1[1], r = e1[2], o = e1[3], n = e1[6], s = e1[7], i = e1[11], this.mat4[0] = e1[0], this.mat4[1] = e1[4], this.mat4[2] = e1[8], this.mat4[3] = e1[12], this.mat4[4] = t, this.mat4[5] = e1[5], this.mat4[6] = e1[9], this.mat4[7] = e1[13], this.mat4[8] = r, this.mat4[9] = n, this.mat4[10] = e1[10], this.mat4[11] = e1[14], this.mat4[12] = o, this.mat4[13] = s, this.mat4[14] = i, this.mat4[15] = e1[15]), this;
                            }
                        },
                        {
                            key: "invert",
                            value: function(e1) {
                                e1 instanceof O.default.Matrix ? (t = e1.mat4[0], r = e1.mat4[1], o = e1.mat4[2], n = e1.mat4[3], s = e1.mat4[4], i = e1.mat4[5], a = e1.mat4[6], l = e1.mat4[7], u = e1.mat4[8], c = e1.mat4[9], d = e1.mat4[10], h = e1.mat4[11], f = e1.mat4[12], p = e1.mat4[13], m = e1.mat4[14], y = e1.mat4[15]) : C(e1) && (t = e1[0], r = e1[1], o = e1[2], n = e1[3], s = e1[4], i = e1[5], a = e1[6], l = e1[7], u = e1[8], c = e1[9], d = e1[10], h = e1[11], f = e1[12], p = e1[13], m = e1[14], y = e1[15]);
                                var t, r, o, n, s, i, a, l, u, c, d, h, f, p, m, y, e1 = t * i - r * s, g = t * a - o * s, v = t * l - n * s, b = r * a - o * i, _ = r * l - n * i, j = o * l - n * a, x = u * p - c * f, w = u * m - d * f, S = u * y - h * f, T = c * m - d * p, E = c * y - h * p, M = d * y - h * m, k = e1 * M - g * E + v * T + b * S - _ * w + j * x;
                                return k ? (this.mat4[0] = (i * M - a * E + l * T) * (k = 1 / k), this.mat4[1] = (o * E - r * M - n * T) * k, this.mat4[2] = (p * j - m * _ + y * b) * k, this.mat4[3] = (d * _ - c * j - h * b) * k, this.mat4[4] = (a * S - s * M - l * w) * k, this.mat4[5] = (t * M - o * S + n * w) * k, this.mat4[6] = (m * v - f * j - y * g) * k, this.mat4[7] = (u * j - d * v + h * g) * k, this.mat4[8] = (s * E - i * S + l * x) * k, this.mat4[9] = (r * S - t * E - n * x) * k, this.mat4[10] = (f * _ - p * v + y * e1) * k, this.mat4[11] = (c * v - u * _ - h * e1) * k, this.mat4[12] = (i * w - s * T - a * x) * k, this.mat4[13] = (t * T - r * w + o * x) * k, this.mat4[14] = (p * g - f * b - m * e1) * k, this.mat4[15] = (u * b - c * g + d * e1) * k, this) : null;
                            }
                        },
                        {
                            key: "invert3x3",
                            value: function() {
                                var e1 = this.mat3[0], t = this.mat3[1], r = this.mat3[2], o = this.mat3[3], n = this.mat3[4], s = this.mat3[5], i = this.mat3[6], a = this.mat3[7], l = this.mat3[8], u = l * n - s * a, c = -l * o + s * i, d = a * o - n * i, h = e1 * u + t * c + r * d;
                                return h ? (this.mat3[0] = u * (h = 1 / h), this.mat3[1] = (-l * t + r * a) * h, this.mat3[2] = (s * t - r * n) * h, this.mat3[3] = c * h, this.mat3[4] = (l * e1 - r * i) * h, this.mat3[5] = (-s * e1 + r * o) * h, this.mat3[6] = d * h, this.mat3[7] = (-a * e1 + t * i) * h, this.mat3[8] = (n * e1 - t * o) * h, this) : null;
                            }
                        },
                        {
                            key: "transpose3x3",
                            value: function(e1) {
                                var t = (e1 = void 0 === e1 ? this.mat3 : e1)[1], r = e1[2], o = e1[5];
                                return this.mat3[0] = e1[0], this.mat3[1] = e1[3], this.mat3[2] = e1[6], this.mat3[3] = t, this.mat3[4] = e1[4], this.mat3[5] = e1[7], this.mat3[6] = r, this.mat3[7] = o, this.mat3[8] = e1[8], this;
                            }
                        },
                        {
                            key: "inverseTranspose",
                            value: function(e1) {
                                e1 = e1.mat4, void 0 === this.mat3 ? O.default._friendlyError("sorry, this function only works with mat3") : (this.mat3[0] = e1[0], this.mat3[1] = e1[1], this.mat3[2] = e1[2], this.mat3[3] = e1[4], this.mat3[4] = e1[5], this.mat3[5] = e1[6], this.mat3[6] = e1[8], this.mat3[7] = e1[9], this.mat3[8] = e1[10]), e1 = this.invert3x3();
                                if (e1) e1.transpose3x3(this.mat3);
                                else for(var t = 0; t < 9; t++)this.mat3[t] = 0;
                                return this;
                            }
                        },
                        {
                            key: "determinant",
                            value: function() {
                                var e1 = this.mat4[0] * this.mat4[5] - this.mat4[1] * this.mat4[4], t = this.mat4[0] * this.mat4[6] - this.mat4[2] * this.mat4[4], r = this.mat4[0] * this.mat4[7] - this.mat4[3] * this.mat4[4], o = this.mat4[1] * this.mat4[6] - this.mat4[2] * this.mat4[5], n = this.mat4[1] * this.mat4[7] - this.mat4[3] * this.mat4[5], s = this.mat4[2] * this.mat4[7] - this.mat4[3] * this.mat4[6], i = this.mat4[8] * this.mat4[13] - this.mat4[9] * this.mat4[12], a = this.mat4[8] * this.mat4[14] - this.mat4[10] * this.mat4[12], l = this.mat4[8] * this.mat4[15] - this.mat4[11] * this.mat4[12], u = this.mat4[9] * this.mat4[14] - this.mat4[10] * this.mat4[13], c = this.mat4[9] * this.mat4[15] - this.mat4[11] * this.mat4[13];
                                return e1 * (this.mat4[10] * this.mat4[15] - this.mat4[11] * this.mat4[14]) - t * c + r * u + o * l - n * a + s * i;
                            }
                        },
                        {
                            key: "mult",
                            value: function(e1) {
                                var t;
                                if (e1 === this || e1 === this.mat4) t = this.copy().mat4;
                                else if (e1 instanceof O.default.Matrix) t = e1.mat4;
                                else if (C(e1)) t = e1;
                                else {
                                    if (16 !== arguments.length) return;
                                    t = arguments;
                                }
                                var e1 = this.mat4[0], r = this.mat4[1], o = this.mat4[2], n = this.mat4[3];
                                return this.mat4[0] = e1 * t[0] + r * t[4] + o * t[8] + n * t[12], this.mat4[1] = e1 * t[1] + r * t[5] + o * t[9] + n * t[13], this.mat4[2] = e1 * t[2] + r * t[6] + o * t[10] + n * t[14], this.mat4[3] = e1 * t[3] + r * t[7] + o * t[11] + n * t[15], e1 = this.mat4[4], r = this.mat4[5], o = this.mat4[6], n = this.mat4[7], this.mat4[4] = e1 * t[0] + r * t[4] + o * t[8] + n * t[12], this.mat4[5] = e1 * t[1] + r * t[5] + o * t[9] + n * t[13], this.mat4[6] = e1 * t[2] + r * t[6] + o * t[10] + n * t[14], this.mat4[7] = e1 * t[3] + r * t[7] + o * t[11] + n * t[15], e1 = this.mat4[8], r = this.mat4[9], o = this.mat4[10], n = this.mat4[11], this.mat4[8] = e1 * t[0] + r * t[4] + o * t[8] + n * t[12], this.mat4[9] = e1 * t[1] + r * t[5] + o * t[9] + n * t[13], this.mat4[10] = e1 * t[2] + r * t[6] + o * t[10] + n * t[14], this.mat4[11] = e1 * t[3] + r * t[7] + o * t[11] + n * t[15], e1 = this.mat4[12], r = this.mat4[13], o = this.mat4[14], n = this.mat4[15], this.mat4[12] = e1 * t[0] + r * t[4] + o * t[8] + n * t[12], this.mat4[13] = e1 * t[1] + r * t[5] + o * t[9] + n * t[13], this.mat4[14] = e1 * t[2] + r * t[6] + o * t[10] + n * t[14], this.mat4[15] = e1 * t[3] + r * t[7] + o * t[11] + n * t[15], this;
                            }
                        },
                        {
                            key: "apply",
                            value: function(e1) {
                                var t;
                                if (e1 === this || e1 === this.mat4) t = this.copy().mat4;
                                else if (e1 instanceof O.default.Matrix) t = e1.mat4;
                                else if (C(e1)) t = e1;
                                else {
                                    if (16 !== arguments.length) return;
                                    t = arguments;
                                }
                                var e1 = this.mat4, r = e1[0], o = e1[4], n = e1[8], s = e1[12], r = (e1[0] = t[0] * r + t[1] * o + t[2] * n + t[3] * s, e1[4] = t[4] * r + t[5] * o + t[6] * n + t[7] * s, e1[8] = t[8] * r + t[9] * o + t[10] * n + t[11] * s, e1[12] = t[12] * r + t[13] * o + t[14] * n + t[15] * s, e1[1]), o = e1[5], n = e1[9], s = e1[13], r = (e1[1] = t[0] * r + t[1] * o + t[2] * n + t[3] * s, e1[5] = t[4] * r + t[5] * o + t[6] * n + t[7] * s, e1[9] = t[8] * r + t[9] * o + t[10] * n + t[11] * s, e1[13] = t[12] * r + t[13] * o + t[14] * n + t[15] * s, e1[2]), o = e1[6], n = e1[10], s = e1[14], r = (e1[2] = t[0] * r + t[1] * o + t[2] * n + t[3] * s, e1[6] = t[4] * r + t[5] * o + t[6] * n + t[7] * s, e1[10] = t[8] * r + t[9] * o + t[10] * n + t[11] * s, e1[14] = t[12] * r + t[13] * o + t[14] * n + t[15] * s, e1[3]), o = e1[7], n = e1[11], s = e1[15];
                                return e1[3] = t[0] * r + t[1] * o + t[2] * n + t[3] * s, e1[7] = t[4] * r + t[5] * o + t[6] * n + t[7] * s, e1[11] = t[8] * r + t[9] * o + t[10] * n + t[11] * s, e1[15] = t[12] * r + t[13] * o + t[14] * n + t[15] * s, this;
                            }
                        },
                        {
                            key: "scale",
                            value: function(e1, t, r) {
                                return e1 instanceof O.default.Vector ? (t = e1.y, r = e1.z, e1 = e1.x) : e1 instanceof Array && (t = e1[1], r = e1[2], e1 = e1[0]), this.mat4[0] *= e1, this.mat4[1] *= e1, this.mat4[2] *= e1, this.mat4[3] *= e1, this.mat4[4] *= t, this.mat4[5] *= t, this.mat4[6] *= t, this.mat4[7] *= t, this.mat4[8] *= r, this.mat4[9] *= r, this.mat4[10] *= r, this.mat4[11] *= r, this;
                            }
                        },
                        {
                            key: "rotate",
                            value: function(e1, t, r, o) {
                                t instanceof O.default.Vector ? (r = t.y, o = t.z, t = t.x) : t instanceof Array && (r = t[1], o = t[2], t = t[0]);
                                var n = Math.sqrt(t * t + r * r + o * o), n = (t *= 1 / n, r *= 1 / n, o *= 1 / n, this.mat4[0]), s = this.mat4[1], i = this.mat4[2], a = this.mat4[3], l = this.mat4[4], u = this.mat4[5], c = this.mat4[6], d = this.mat4[7], h = this.mat4[8], f = this.mat4[9], p = this.mat4[10], m = this.mat4[11], y = Math.sin(e1), e1 = Math.cos(e1), g = 1 - e1, v = t * t * g + e1, b = r * t * g + o * y, _ = o * t * g - r * y, j = t * r * g - o * y, x = r * r * g + e1, w = o * r * g + t * y, S = t * o * g + r * y, r = r * o * g - t * y, t = o * o * g + e1;
                                return this.mat4[0] = n * v + l * b + h * _, this.mat4[1] = s * v + u * b + f * _, this.mat4[2] = i * v + c * b + p * _, this.mat4[3] = a * v + d * b + m * _, this.mat4[4] = n * j + l * x + h * w, this.mat4[5] = s * j + u * x + f * w, this.mat4[6] = i * j + c * x + p * w, this.mat4[7] = a * j + d * x + m * w, this.mat4[8] = n * S + l * r + h * t, this.mat4[9] = s * S + u * r + f * t, this.mat4[10] = i * S + c * r + p * t, this.mat4[11] = a * S + d * r + m * t, this;
                            }
                        },
                        {
                            key: "translate",
                            value: function(e1) {
                                var t = e1[0], r = e1[1], e1 = e1[2] || 0;
                                this.mat4[12] += this.mat4[0] * t + this.mat4[4] * r + this.mat4[8] * e1, this.mat4[13] += this.mat4[1] * t + this.mat4[5] * r + this.mat4[9] * e1, this.mat4[14] += this.mat4[2] * t + this.mat4[6] * r + this.mat4[10] * e1, this.mat4[15] += this.mat4[3] * t + this.mat4[7] * r + this.mat4[11] * e1;
                            }
                        },
                        {
                            key: "rotateX",
                            value: function(e1) {
                                this.rotate(e1, 1, 0, 0);
                            }
                        },
                        {
                            key: "rotateY",
                            value: function(e1) {
                                this.rotate(e1, 0, 1, 0);
                            }
                        },
                        {
                            key: "rotateZ",
                            value: function(e1) {
                                this.rotate(e1, 0, 0, 1);
                            }
                        },
                        {
                            key: "perspective",
                            value: function(e1, t, r, o) {
                                var e1 = 1 / Math.tan(e1 / 2), n = 1 / (r - o);
                                return this.mat4[0] = e1 / t, this.mat4[1] = 0, this.mat4[2] = 0, this.mat4[3] = 0, this.mat4[4] = 0, this.mat4[5] = e1, this.mat4[6] = 0, this.mat4[7] = 0, this.mat4[8] = 0, this.mat4[9] = 0, this.mat4[10] = (o + r) * n, this.mat4[11] = -1, this.mat4[12] = 0, this.mat4[13] = 0, this.mat4[14] = 2 * o * r * n, this.mat4[15] = 0, this;
                            }
                        },
                        {
                            key: "ortho",
                            value: function(e1, t, r, o, n, s) {
                                var i = 1 / (e1 - t), a = 1 / (r - o), l = 1 / (n - s);
                                return this.mat4[0] = -2 * i, this.mat4[1] = 0, this.mat4[2] = 0, this.mat4[3] = 0, this.mat4[4] = 0, this.mat4[5] = -2 * a, this.mat4[6] = 0, this.mat4[7] = 0, this.mat4[8] = 0, this.mat4[9] = 0, this.mat4[10] = 2 * l, this.mat4[11] = 0, this.mat4[12] = (e1 + t) * i, this.mat4[13] = (o + r) * a, this.mat4[14] = (s + n) * l, this.mat4[15] = 1, this;
                            }
                        },
                        {
                            key: "multiplyVec4",
                            value: function(e1, t, r, o) {
                                var n = new Array(4), s = this.mat4;
                                return n[0] = s[0] * e1 + s[4] * t + s[8] * r + s[12] * o, n[1] = s[1] * e1 + s[5] * t + s[9] * r + s[13] * o, n[2] = s[2] * e1 + s[6] * t + s[10] * r + s[14] * o, n[3] = s[3] * e1 + s[7] * t + s[11] * r + s[15] * o, n;
                            }
                        },
                        {
                            key: "multiplyPoint",
                            value: function(e1) {
                                var t = e1.x, r = e1.y, e1 = e1.z, t = this.multiplyVec4(t, r, e1, 1);
                                return new O.default.Vector(t[0], t[1], t[2]);
                            }
                        },
                        {
                            key: "multiplyAndNormalizePoint",
                            value: function(e1) {
                                var t = e1.x, r = e1.y, e1 = e1.z, t = this.multiplyVec4(t, r, e1, 1);
                                return t[0] /= t[3], t[1] /= t[3], t[2] /= t[3], new O.default.Vector(t[0], t[1], t[2]);
                            }
                        },
                        {
                            key: "multiplyDirection",
                            value: function(e1) {
                                var t = e1.x, r = e1.y, e1 = e1.z, t = this.multiplyVec4(t, r, e1, 0);
                                return new O.default.Vector(t[0], t[1], t[2]);
                            }
                        },
                        {
                            key: "mult3x3",
                            value: function(e1) {
                                var t;
                                if (e1 === this || e1 === this.mat3) t = this.copy().mat3;
                                else if (e1 instanceof O.default.Matrix) t = e1.mat3;
                                else if (C(e1)) t = e1;
                                else {
                                    if (9 !== arguments.length) return;
                                    t = arguments;
                                }
                                var e1 = this.mat3[0], r = this.mat3[1], o = this.mat3[2];
                                return this.mat3[0] = e1 * t[0] + r * t[3] + o * t[6], this.mat3[1] = e1 * t[1] + r * t[4] + o * t[7], this.mat3[2] = e1 * t[2] + r * t[5] + o * t[8], e1 = this.mat3[3], r = this.mat3[4], o = this.mat3[5], this.mat3[3] = e1 * t[0] + r * t[3] + o * t[6], this.mat3[4] = e1 * t[1] + r * t[4] + o * t[7], this.mat3[5] = e1 * t[2] + r * t[5] + o * t[8], e1 = this.mat3[6], r = this.mat3[7], o = this.mat3[8], this.mat3[6] = e1 * t[0] + r * t[3] + o * t[6], this.mat3[7] = e1 * t[1] + r * t[4] + o * t[7], this.mat3[8] = e1 * t[2] + r * t[5] + o * t[8], this;
                            }
                        },
                        {
                            key: "column",
                            value: function(e1) {
                                return new O.default.Vector(this.mat3[3 * e1], this.mat3[3 * e1 + 1], this.mat3[3 * e1 + 2]);
                            }
                        },
                        {
                            key: "row",
                            value: function(e1) {
                                return new O.default.Vector(this.mat3[e1], this.mat3[e1 + 3], this.mat3[e1 + 6]);
                            }
                        },
                        {
                            key: "diagonal",
                            value: function() {
                                return void 0 !== this.mat3 ? [
                                    this.mat3[0],
                                    this.mat3[4],
                                    this.mat3[8]
                                ] : [
                                    this.mat4[0],
                                    this.mat4[5],
                                    this.mat4[10],
                                    this.mat4[15]
                                ];
                            }
                        },
                        {
                            key: "multiplyVec3",
                            value: function(e1, t) {
                                return (t = void 0 === t ? e1.copy() : t).x = this.row(0).dot(e1), t.y = this.row(1).dot(e1), t.z = this.row(2).dot(e1), t;
                            }
                        },
                        {
                            key: "createSubMatrix3x3",
                            value: function() {
                                var e1 = new O.default.Matrix("mat3");
                                return e1.mat3[0] = this.mat4[0], e1.mat3[1] = this.mat4[1], e1.mat3[2] = this.mat4[2], e1.mat3[3] = this.mat4[4], e1.mat3[4] = this.mat4[5], e1.mat3[5] = this.mat4[6], e1.mat3[6] = this.mat4[8], e1.mat3[7] = this.mat4[9], e1.mat3[8] = this.mat4[10], e1;
                            }
                        }
                    ], n(e1.prototype, t), o && n(e1, o), r;
                }(), O.default.Matrix);
                r.default = e1;
            },
            {
                "../core/main": 283,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.typed-array.copy-within": 213,
                "core-js/modules/es.typed-array.every": 214,
                "core-js/modules/es.typed-array.fill": 215,
                "core-js/modules/es.typed-array.filter": 216,
                "core-js/modules/es.typed-array.find": 218,
                "core-js/modules/es.typed-array.find-index": 217,
                "core-js/modules/es.typed-array.float32-array": 219,
                "core-js/modules/es.typed-array.for-each": 221,
                "core-js/modules/es.typed-array.includes": 222,
                "core-js/modules/es.typed-array.index-of": 223,
                "core-js/modules/es.typed-array.iterator": 226,
                "core-js/modules/es.typed-array.join": 227,
                "core-js/modules/es.typed-array.last-index-of": 228,
                "core-js/modules/es.typed-array.map": 229,
                "core-js/modules/es.typed-array.reduce": 231,
                "core-js/modules/es.typed-array.reduce-right": 230,
                "core-js/modules/es.typed-array.reverse": 232,
                "core-js/modules/es.typed-array.set": 233,
                "core-js/modules/es.typed-array.slice": 234,
                "core-js/modules/es.typed-array.some": 235,
                "core-js/modules/es.typed-array.sort": 236,
                "core-js/modules/es.typed-array.subarray": 237,
                "core-js/modules/es.typed-array.to-locale-string": 238,
                "core-js/modules/es.typed-array.to-string": 239
            }
        ],
        337: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function o(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                s.default.Quat = function() {
                    function n(e1, t, r, o) {
                        if (!(this instanceof n)) throw new TypeError("Cannot call a class as a function");
                        this.w = e1, this.vec = new s.default.Vector(t, r, o);
                    }
                    var e1, t, r;
                    return e1 = n, r = [
                        {
                            key: "fromAxisAngle",
                            value: function(e1, t, r, o) {
                                var n = Math.cos(e1 / 2), t = new s.default.Vector(t, r, o).normalize().mult(Math.sin(e1 / 2));
                                return new s.default.Quat(n, t.x, t.y, t.z);
                            }
                        }
                    ], t = [
                        {
                            key: "conjugate",
                            value: function() {
                                return new s.default.Quat(this.w, -this.vec.x, -this.vec.y, -this.vec.z);
                            }
                        },
                        {
                            key: "multiply",
                            value: function(e1) {
                                return new s.default.Quat(this.w * e1.w - this.vec.x * e1.vec.x - this.vec.y * e1.vec.y - this.vec.z - e1.vec.z, this.w * e1.vec.x + this.vec.x * e1.w + this.vec.y * e1.vec.z - this.vec.z * e1.vec.y, this.w * e1.vec.y - this.vec.x * e1.vec.z + this.vec.y * e1.w + this.vec.z * e1.vec.x, this.w * e1.vec.z + this.vec.x * e1.vec.y - this.vec.y * e1.vec.x + this.vec.z * e1.w);
                            }
                        },
                        {
                            key: "rotateVector",
                            value: function(e1) {
                                return new s.default.Vector.mult(e1, this.w * this.w - this.vec.dot(this.vec)).add(s.default.Vector.mult(this.vec, 2 * e1.dot(this.vec))).add(s.default.Vector.mult(this.vec, 2 * this.w).cross(e1)).clampToZero();
                            }
                        },
                        {
                            key: "rotateBy",
                            value: function(e1) {
                                return e1.multiply(this).multiply(e1.conjugate()).vec.clampToZero();
                            }
                        }
                    ], o(e1.prototype, t), r && o(e1, r), n;
                }();
                e1 = s.default.Quat;
                r.default = e1;
            },
            {
                "../core/main": 283
            }
        ],
        338: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.map"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function o(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                e1.default.RenderBuffer = function() {
                    function i(e1, t, r, o, n, s) {
                        if (!(this instanceof i)) throw new TypeError("Cannot call a class as a function");
                        this.size = e1, this.src = t, this.dst = r, this.attr = o, this._renderer = n, this.map = s;
                    }
                    var e1, t, r;
                    return e1 = i, t = [
                        {
                            key: "_prepareBuffer",
                            value: function(e1, t) {
                                var r, o, n, s = t.attributes, i = this._renderer.GL, a = e1.model || e1, s = s[this.attr];
                                s && (r = e1[this.dst], 0 < (o = a[this.src]).length ? ((n = !r) && (e1[this.dst] = r = i.createBuffer()), i.bindBuffer(i.ARRAY_BUFFER, r), !n && !1 === a.dirtyFlags[this.src] || (n = (e1 = this.map) ? e1(o) : o, this._renderer._bindBuffer(r, i.ARRAY_BUFFER, n), a.dirtyFlags[this.src] = !1), t.enableAttrib(s, this.size)) : -1 !== (e1 = s.location) && this._renderer.registerEnabled.has(e1) && (i.disableVertexAttribArray(e1), this._renderer.registerEnabled.delete(e1)));
                            }
                        }
                    ], o(e1.prototype, t), r && o(e1, r), i;
                }();
                e1 = e1.default.RenderBuffer;
                r.default = e1;
            },
            {
                "../core/main": 283,
                "core-js/modules/es.array.map": 168
            }
        ],
        339: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.find-index"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.map"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.find-index"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.map"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var l = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                }, h = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function f(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                e1("./p5.RenderBuffer"), l.default.RendererGL.prototype.beginShape = function(e1) {
                    return this.immediateMode.shapeMode = void 0 !== e1 ? e1 : h.TESS, this.immediateMode.geometry.reset(), this.immediateMode.contourIndices = [], this;
                };
                var u = {
                    vertices: 1,
                    vertexNormals: 1,
                    vertexColors: 4,
                    vertexStrokeColors: 4,
                    uvs: 2
                }, n = (l.default.RendererGL.prototype.beginContour = function() {
                    if (this.immediateMode.shapeMode !== h.TESS) throw new Error("WebGL mode can only use contours with beginShape(TESS).");
                    this.immediateMode.contourIndices.push(this.immediateMode.geometry.vertices.length);
                }, l.default.RendererGL.prototype.vertex = function(e1, t) {
                    if (this.immediateMode.shapeMode === h.QUADS && this.immediateMode.geometry.vertices.length % 6 == 3) for(var r in u){
                        var o = u[r], r = this.immediateMode.geometry[r];
                        r.push.apply(r, f(r.slice(r.length - 3 * o, r.length - 2 * o)).concat(f(r.slice(r.length - o, r.length))));
                    }
                    var n, s, i = n = s = 0, a = (3 === arguments.length ? i = arguments[2] : 4 === arguments.length ? (n = arguments[2], s = arguments[3]) : 5 === arguments.length && (i = arguments[2], n = arguments[3], s = arguments[4]), new l.default.Vector(e1, t, i)), a = (this.immediateMode.geometry.vertices.push(a), this.immediateMode.geometry.vertexNormals.push(this._currentNormal), this.curFillColor || [
                        .5,
                        .5,
                        .5,
                        1
                    ]), a = (this.immediateMode.geometry.vertexColors.push(a[0], a[1], a[2], a[3]), this.curStrokeColor || [
                        .5,
                        .5,
                        .5,
                        1
                    ]);
                    return this.immediateMode.geometry.vertexStrokeColors.push(a[0], a[1], a[2], a[3]), this.textureMode !== h.IMAGE || this.isProcessingVertices || (null !== this._tex ? 0 < this._tex.width && 0 < this._tex.height && (n /= this._tex.width, s /= this._tex.height) : void 0 === this.userFillShader && void 0 === this.userStrokeShader && void 0 === this.userPointShader && null === this._tex && 4 <= arguments.length && console.warn("You must first call texture() before using vertex() with image based u and v coordinates")), this.immediateMode.geometry.uvs.push(n, s), this.immediateMode._bezierVertex[0] = e1, this.immediateMode._bezierVertex[1] = t, this.immediateMode._bezierVertex[2] = i, this.immediateMode._quadraticVertex[0] = e1, this.immediateMode._quadraticVertex[1] = t, this.immediateMode._quadraticVertex[2] = i, this;
                }, l.default.RendererGL.prototype.normal = function(e1, t, r) {
                    return e1 instanceof l.default.Vector ? this._currentNormal = e1 : this._currentNormal = new l.default.Vector(e1, t, r), this;
                }, l.default.RendererGL.prototype.endShape = function(e1, t, r, o, n, s) {
                    var i, a = 6 < arguments.length && void 0 !== arguments[6] ? arguments[6] : 1;
                    return this.immediateMode.shapeMode === h.POINTS ? this._drawPoints(this.immediateMode.geometry.vertices, this.immediateMode.buffers.point) : (3 === this.immediateMode.geometry.vertices.length && this.immediateMode.shapeMode === h.TESS && (this.immediateMode.shapeMode = h.TRIANGLES), this.isProcessingVertices = !0, this._processVertices.apply(this, arguments), i = this.isProcessingVertices = !1, this.immediateMode.shapeMode !== h.LINE_STRIP && this.immediateMode.shapeMode !== h.LINES || (this.immediateMode.shapeMode = h.TRIANGLE_FAN, i = !0), this.immediateMode.shapeMode === h.QUADS ? this.immediateMode.shapeMode = h.TRIANGLES : this.immediateMode.shapeMode === h.QUAD_STRIP && (this.immediateMode.shapeMode = h.TRIANGLE_STRIP), this._doFill && !i && !this.geometryBuilder && 3 <= this.immediateMode.geometry.vertices.length && this._drawImmediateFill(a), this._doStroke && !this.geometryBuilder && 1 <= this.immediateMode.geometry.lineVertices.length && this._drawImmediateStroke(), this.geometryBuilder && this.geometryBuilder.addImmediate(), this.isBezier = !1, this.isQuadratic = !1, this.isCurve = !1, this.immediateMode._bezierVertex.length = 0, this.immediateMode._quadraticVertex.length = 0, this.immediateMode._curveVertex.length = 0), this;
                }, l.default.RendererGL.prototype._processVertices = function(e1) {
                    var t;
                    0 !== this.immediateMode.geometry.vertices.length && (t = this._doStroke, e1 = e1 === h.CLOSE, t && (this.immediateMode.geometry.edges = this._calculateEdges(this.immediateMode.shapeMode, this.immediateMode.geometry.vertices, e1), this.geometryBuilder || this.immediateMode.geometry._edgesToVertices()), t = this.immediateMode.shapeMode === h.TESS, e1 = 0 < this.immediateMode.contourIndices.length, this._doFill && (this.isBezier || this.isQuadratic || this.isCurve || t || e1) && this.immediateMode.shapeMode !== h.LINES && this._tesselateShape());
                }, l.default.RendererGL.prototype._calculateEdges = function(e1, t, r) {
                    var o = [], n = 0, s = this.immediateMode.contourIndices.slice(), i = 0;
                    switch(e1){
                        case h.TRIANGLE_STRIP:
                            for(n = 0; n < t.length - 2; n++)o.push([
                                n,
                                n + 1
                            ]), o.push([
                                n,
                                n + 2
                            ]);
                            o.push([
                                n,
                                n + 1
                            ]);
                            break;
                        case h.TRIANGLE_FAN:
                            for(n = 1; n < t.length - 1; n++)o.push([
                                0,
                                n
                            ]), o.push([
                                n,
                                n + 1
                            ]);
                            o.push([
                                0,
                                t.length - 1
                            ]);
                            break;
                        case h.TRIANGLES:
                            for(n = 0; n < t.length - 2; n += 3)o.push([
                                n,
                                n + 1
                            ]), o.push([
                                n + 1,
                                n + 2
                            ]), o.push([
                                n + 2,
                                n
                            ]);
                            break;
                        case h.LINES:
                            for(n = 0; n < t.length - 1; n += 2)o.push([
                                n,
                                n + 1
                            ]);
                            break;
                        case h.QUADS:
                            for(n = 0; n < t.length - 5; n += 6)o.push([
                                n,
                                n + 1
                            ]), o.push([
                                n + 1,
                                n + 2
                            ]), o.push([
                                n + 3,
                                n + 5
                            ]), o.push([
                                n + 4,
                                n + 5
                            ]);
                            break;
                        case h.QUAD_STRIP:
                            for(n = 0; n < t.length - 2; n += 2)o.push([
                                n,
                                n + 1
                            ]), o.push([
                                n,
                                n + 2
                            ]), o.push([
                                n + 1,
                                n + 3
                            ]);
                            o.push([
                                n,
                                n + 1
                            ]);
                            break;
                        default:
                            for(n = 0; n < t.length; n++)n + 1 < t.length && n + 1 !== s[0] ? o.push([
                                n,
                                n + 1
                            ]) : ((r || i) && o.push([
                                n,
                                i
                            ]), 0 < s.length && (i = s.shift()));
                    }
                    return e1 !== h.TESS && r && o.push([
                        t.length - 1,
                        0
                    ]), o;
                }, l.default.RendererGL.prototype._tesselateShape = function() {
                    for(var u = this, e1 = (this.immediateMode.shapeMode = h.TRIANGLES, [
                        []
                    ]), t = 0; t < this.immediateMode.geometry.vertices.length; t++)0 < this.immediateMode.contourIndices.length && this.immediateMode.contourIndices[0] === t && (this.immediateMode.contourIndices.shift(), e1.push([])), e1[e1.length - 1].push(this.immediateMode.geometry.vertices[t].x, this.immediateMode.geometry.vertices[t].y, this.immediateMode.geometry.vertices[t].z, this.immediateMode.geometry.uvs[2 * t], this.immediateMode.geometry.uvs[2 * t + 1], this.immediateMode.geometry.vertexColors[4 * t], this.immediateMode.geometry.vertexColors[4 * t + 1], this.immediateMode.geometry.vertexColors[4 * t + 2], this.immediateMode.geometry.vertexColors[4 * t + 3], this.immediateMode.geometry.vertexNormals[t].x, this.immediateMode.geometry.vertexNormals[t].y, this.immediateMode.geometry.vertexNormals[t].z);
                    for(var c, r = this._triangulate(e1), d = this.immediateMode.geometry.vertices, o = (this.immediateMode.geometry.vertices = [], this.immediateMode.geometry.vertexNormals = [], this.immediateMode.geometry.uvs = [], []), n = 0, s = r.length; n < s; n += l.default.RendererGL.prototype.tessyVertexSize)o.push.apply(o, f(r.slice(n + 5, n + 9))), this.normal.apply(this, f(r.slice(n + 9, n + 12))), this.vertex.apply(this, f(r.slice(n, n + 5)));
                    this.geometryBuilder && (c = new Map, this.immediateMode.geometry.edges = this.immediateMode.geometry.edges.map(function(e1) {
                        return e1.map(function(e1) {
                            if (!c.has(e1)) {
                                var t = d[e1], r = u.immediateMode.geometry.vertices.findIndex(function(e1) {
                                    return t.x === e1.x && t.y === e1.y && t.z === e1.z;
                                });
                                if (-1 === r) {
                                    for(var o = 1 / 0, n = 0, s = 0; s < u.immediateMode.geometry.vertices.length; s++){
                                        var i = u.immediateMode.geometry.vertices[s], a = t.x - i.x, l = t.y - i.y, i = t.z - i.z, a = a * a + l * l + i * i;
                                        a < o && (o = a, n = s);
                                    }
                                    r = n;
                                }
                                c.set(e1, r);
                            }
                            return c.get(e1);
                        });
                    })), this.immediateMode.geometry.vertexColors = o;
                }, l.default.RendererGL.prototype._drawImmediateFill = function() {
                    var e1, t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 1, r = this.GL, o = (this._useVertexColor = 0 < this.immediateMode.geometry.vertexColors.length, e1 = this._getImmediateFillShader(), this._setFillUniforms(e1), !0), n = !1, s = void 0;
                    try {
                        for(var i, a = this.immediateMode.buffers.fill[Symbol.iterator](); !(o = (i = a.next()).done); o = !0)i.value._prepareBuffer(this.immediateMode.geometry, e1);
                    } catch (e1) {
                        n = !0, s = e1;
                    } finally{
                        try {
                            o || null == a.return || a.return();
                        } finally{
                            if (n) throw s;
                        }
                    }
                    if (e1.disableRemainingAttributes(), this._applyColorBlend(this.curFillColor, this.immediateMode.geometry.hasFillTransparency()), 1 === t) r.drawArrays(this.immediateMode.shapeMode, 0, this.immediateMode.geometry.vertices.length);
                    else try {
                        r.drawArraysInstanced(this.immediateMode.shapeMode, 0, this.immediateMode.geometry.vertices.length, t);
                    } catch (e1) {
                        console.log("\uD83C\uDF38 p5.js says: Instancing is only supported in WebGL2 mode");
                    }
                    e1.unbindShader();
                }, l.default.RendererGL.prototype._drawImmediateStroke = function() {
                    var e1 = this.GL, t = (this._useLineColor = 0 < this.immediateMode.geometry.vertexStrokeColors.length, this._getImmediateStrokeShader()), r = (this._setStrokeUniforms(t), !0), o = !1, n = void 0;
                    try {
                        for(var s, i = this.immediateMode.buffers.stroke[Symbol.iterator](); !(r = (s = i.next()).done); r = !0)s.value._prepareBuffer(this.immediateMode.geometry, t);
                    } catch (e1) {
                        o = !0, n = e1;
                    } finally{
                        try {
                            r || null == i.return || i.return();
                        } finally{
                            if (o) throw n;
                        }
                    }
                    t.disableRemainingAttributes(), this._applyColorBlend(this.curStrokeColor, this.immediateMode.geometry.hasFillTransparency()), e1.drawArrays(e1.TRIANGLES, 0, this.immediateMode.geometry.lineVertices.length / 3), t.unbindShader();
                }, l.default.RendererGL);
                r.default = n;
            },
            {
                "../core/constants": 272,
                "../core/main": 283,
                "./p5.RenderBuffer": 338,
                "core-js/modules/es.array.concat": 153,
                "core-js/modules/es.array.fill": 156,
                "core-js/modules/es.array.find-index": 158,
                "core-js/modules/es.array.from": 162,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.map": 168,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.map": 175,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        340: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.some"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.uint16-array"), e1("core-js/modules/es.typed-array.uint32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.some"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.uint16-array"), e1("core-js/modules/es.typed-array.uint32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var a = (s = e1("../core/main")) && s.__esModule ? s : {
                    default: s
                }, n = (e1("./p5.RendererGL"), e1("./p5.RenderBuffer"), function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = l();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants")));
                function l() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, l = function() {
                        return e1;
                    }, e1);
                }
                a.default.RendererGL.prototype.freeGeometry = function(e1) {
                    e1.gid ? this._freeBuffers(e1.gid) : console.warn("The model you passed to freeGeometry does not have an id!");
                }, a.default.RendererGL.prototype._initBufferDefaults = function(e1) {
                    var t;
                    return this._freeBuffers(e1), 1e3 < Object.keys(this.retainedMode.geometry).length && (t = Object.keys(this.retainedMode.geometry)[0], this._freeBuffers(t)), this.retainedMode.geometry[e1] = {};
                }, a.default.RendererGL.prototype._freeBuffers = function(e1) {
                    var a, l = this.retainedMode.geometry[e1];
                    function t(e1) {
                        var t = !0, r = !1, o = void 0;
                        try {
                            for(var n, s = e1[Symbol.iterator](); !(t = (n = s.next()).done); t = !0){
                                var i = n.value;
                                l[i.dst] && (a.deleteBuffer(l[i.dst]), l[i.dst] = null);
                            }
                        } catch (e1) {
                            r = !0, o = e1;
                        } finally{
                            try {
                                t || null == s.return || s.return();
                            } finally{
                                if (r) throw o;
                            }
                        }
                    }
                    l && (delete this.retainedMode.geometry[e1], a = this.GL, l.indexBuffer && a.deleteBuffer(l.indexBuffer), t(this.retainedMode.buffers.stroke), t(this.retainedMode.buffers.fill));
                }, a.default.RendererGL.prototype.createBuffers = function(e1, t) {
                    var r, o, n, s = this.GL, e1 = this._initBufferDefaults(e1), i = (e1.model = t, e1.indexBuffer);
                    return t.faces.length ? (i = i || (e1.indexBuffer = s.createBuffer()), n = (o = (r = a.default.RendererGL.prototype._flatten(t.faces)).some(function(e1) {
                        return 65535 < e1;
                    })) ? Uint32Array : Uint16Array, this._bindBuffer(i, s.ELEMENT_ARRAY_BUFFER, r, n), e1.indexBufferType = o ? s.UNSIGNED_INT : s.UNSIGNED_SHORT, e1.vertexCount = 3 * t.faces.length) : (i && (s.deleteBuffer(i), e1.indexBuffer = null), e1.vertexCount = t.vertices ? t.vertices.length : 0), e1.lineVertexCount = t.lineVertices ? t.lineVertices.length / 3 : 0, e1;
                }, a.default.RendererGL.prototype.drawBuffers = function(e1) {
                    var t = this.GL, r = this.retainedMode.geometry[e1];
                    if (!this.geometryBuilder && this._doFill && 0 < this.retainedMode.geometry[e1].vertexCount) {
                        this._useVertexColor = 0 < r.model.vertexColors.length;
                        var o = this._getRetainedFillShader(), n = (this._setFillUniforms(o), !0), s = !1, i = void 0;
                        try {
                            for(var a, l = this.retainedMode.buffers.fill[Symbol.iterator](); !(n = (a = l.next()).done); n = !0)a.value._prepareBuffer(r, o);
                        } catch (e1) {
                            s = !0, i = e1;
                        } finally{
                            try {
                                n || null == l.return || l.return();
                            } finally{
                                if (s) throw i;
                            }
                        }
                        o.disableRemainingAttributes(), r.indexBuffer && this._bindBuffer(r.indexBuffer, t.ELEMENT_ARRAY_BUFFER), this._applyColorBlend(this.curFillColor, r.model.hasFillTransparency()), this._drawElements(t.TRIANGLES, e1), o.unbindShader();
                    }
                    if (!this.geometryBuilder && this._doStroke && 0 < r.lineVertexCount) {
                        this._useLineColor = 0 < r.model.vertexStrokeColors.length;
                        var u = this._getRetainedStrokeShader(), c = (this._setStrokeUniforms(u), !0), s = !1, i = void 0;
                        try {
                            for(var d, h = this.retainedMode.buffers.stroke[Symbol.iterator](); !(c = (d = h.next()).done); c = !0)d.value._prepareBuffer(r, u);
                        } catch (e1) {
                            s = !0, i = e1;
                        } finally{
                            try {
                                c || null == h.return || h.return();
                            } finally{
                                if (s) throw i;
                            }
                        }
                        u.disableRemainingAttributes(), this._applyColorBlend(this.curStrokeColor, r.model.hasStrokeTransparency()), this._drawArrays(t.TRIANGLES, e1), u.unbindShader();
                    }
                    return this.geometryBuilder && this.geometryBuilder.addRetained(r), this;
                }, a.default.RendererGL.prototype.drawBuffersScaled = function(e1, t, r, o) {
                    var n = this.uModelMatrix.copy();
                    try {
                        this.uModelMatrix.scale(t, r, o), this.drawBuffers(e1);
                    } finally{
                        this.uModelMatrix = n;
                    }
                }, a.default.RendererGL.prototype._drawArrays = function(e1, t) {
                    return this.GL.drawArrays(e1, 0, this.retainedMode.geometry[t].lineVertexCount), this;
                }, a.default.RendererGL.prototype._drawElements = function(e1, t) {
                    var t = this.retainedMode.geometry[t], r = this.GL;
                    if (t.indexBuffer) {
                        if (this._pInst.webglVersion !== n.WEBGL2 && t.indexBufferType === r.UNSIGNED_INT && !r.getExtension("OES_element_index_uint")) throw new Error("Unable to render a 3d model with > 65535 triangles. Your web browser does not support the WebGL Extension OES_element_index_uint.");
                        r.drawElements(r.TRIANGLES, t.vertexCount, t.indexBufferType, 0);
                    } else r.drawArrays(e1 || r.TRIANGLES, 0, t.vertexCount);
                }, a.default.RendererGL.prototype._drawPoints = function(e1, t) {
                    var r = this.GL, o = this._getImmediatePointShader();
                    if (Array.isArray(t)) {
                        var n = this.immediateMode.geometry, s = (n.vertices !== e1 && (n.vertices = e1, n.dirtyFlags.vertices = !0, 0 < n.vertexStrokeColors.length && (n.vertexStrokeColors.length = 0, n.dirtyFlags.vertexStrokeColors = !0)), this._setPointUniforms(o), !0), i = !1, a = void 0;
                        try {
                            for(var l, u = t[Symbol.iterator](); !(s = (l = u.next()).done); s = !0)l.value._prepareBuffer(n, o);
                        } catch (e1) {
                            i = !0, a = e1;
                        } finally{
                            try {
                                s || null == u.return || u.return();
                            } finally{
                                if (i) throw a;
                            }
                        }
                    } else this._setPointUniforms(o), this._bindBuffer(t, r.ARRAY_BUFFER, this._vToNArray(e1), Float32Array, r.STATIC_DRAW), o.enableAttrib(o.attributes.aPosition, 3);
                    this._applyColorBlend(this.curStrokeColor), r.drawArrays(r.POINTS, 0, e1.length), o.unbindShader();
                };
                var s = a.default.RendererGL;
                r.default = s;
            },
            {
                "../core/constants": 272,
                "../core/main": 283,
                "./p5.RenderBuffer": 338,
                "./p5.RendererGL": 341,
                "core-js/modules/es.array.fill": 156,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.some": 170,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.keys": 189,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.typed-array.copy-within": 213,
                "core-js/modules/es.typed-array.every": 214,
                "core-js/modules/es.typed-array.fill": 215,
                "core-js/modules/es.typed-array.filter": 216,
                "core-js/modules/es.typed-array.find": 218,
                "core-js/modules/es.typed-array.find-index": 217,
                "core-js/modules/es.typed-array.float32-array": 219,
                "core-js/modules/es.typed-array.for-each": 221,
                "core-js/modules/es.typed-array.includes": 222,
                "core-js/modules/es.typed-array.index-of": 223,
                "core-js/modules/es.typed-array.iterator": 226,
                "core-js/modules/es.typed-array.join": 227,
                "core-js/modules/es.typed-array.last-index-of": 228,
                "core-js/modules/es.typed-array.map": 229,
                "core-js/modules/es.typed-array.reduce": 231,
                "core-js/modules/es.typed-array.reduce-right": 230,
                "core-js/modules/es.typed-array.reverse": 232,
                "core-js/modules/es.typed-array.set": 233,
                "core-js/modules/es.typed-array.slice": 234,
                "core-js/modules/es.typed-array.some": 235,
                "core-js/modules/es.typed-array.sort": 236,
                "core-js/modules/es.typed-array.subarray": 237,
                "core-js/modules/es.typed-array.to-locale-string": 238,
                "core-js/modules/es.typed-array.to-string": 239,
                "core-js/modules/es.typed-array.uint16-array": 240,
                "core-js/modules/es.typed-array.uint32-array": 241,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        341: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.copy-within"), e1("core-js/modules/es.array.every"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.flat"), e1("core-js/modules/es.array.flat-map"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.some"), e1("core-js/modules/es.array.unscopables.flat"), e1("core-js/modules/es.array.unscopables.flat-map"), e1("core-js/modules/es.map"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.reflect.get"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.set"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.float64-array"), e1("core-js/modules/es.typed-array.int16-array"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.uint16-array"), e1("core-js/modules/es.typed-array.uint32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.copy-within"), e1("core-js/modules/es.array.every"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.flat"), e1("core-js/modules/es.array.flat-map"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.some"), e1("core-js/modules/es.array.unscopables.flat"), e1("core-js/modules/es.array.unscopables.flat-map"), e1("core-js/modules/es.map"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.set"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.float64-array"), e1("core-js/modules/es.typed-array.int16-array"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.uint16-array"), e1("core-js/modules/es.typed-array.uint32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.readPixelsWebGL = O, r.readPixelWebGL = C, r.default = void 0;
                var g = n(e1("../core/main")), l = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = d();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants")), a = n(e1("./GeometryBuilder")), u = n(e1("libtess")), c = (e1("./p5.Shader"), e1("./p5.Camera"), e1("../core/p5.Renderer"), e1("./p5.Matrix"), e1("./p5.Framebuffer"), e1("path"), e1("./p5.Texture"));
                function d() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, d = function() {
                        return e1;
                    }, e1);
                }
                function n(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function h(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                function f(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function p(e1, t, r) {
                    return (p = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e1, t, r) {
                        var e1 = function(e1, t) {
                            for(; !Object.prototype.hasOwnProperty.call(e1, t) && null !== (e1 = b(e1)););
                            return e1;
                        }(e1, t);
                        if (e1) return (e1 = Object.getOwnPropertyDescriptor(e1, t)).get ? e1.get.call(r) : e1.value;
                    })(e1, t, r || e1);
                }
                function m(e1, t) {
                    return (m = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                function y(o) {
                    return function() {
                        var e1, t, r = b(o);
                        return e1 = function() {
                            if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                                if ("function" == typeof Proxy) return 1;
                                try {
                                    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                                } catch (e1) {}
                            }
                        }() ? (e1 = b(this).constructor, Reflect.construct(r, arguments, e1)) : r.apply(this, arguments), r = this, !(t = e1) || "object" !== i(t) && "function" != typeof t ? v(r) : t;
                    };
                }
                function v(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }
                function b(e1) {
                    return (b = Object.setPrototypeOf ? Object.getPrototypeOf : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    })(e1);
                }
                function _(e1, t, r) {
                    t in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r;
                }
                function s(e1, t) {
                    T += "#define STROKE_CAP_".concat(e1, " ").concat(t, "\n"), w[l[e1]] = t;
                }
                function j(e1, t) {
                    T += "#define STROKE_JOIN_".concat(e1, " ").concat(t, "\n"), S[l[e1]] = t;
                }
                var x, w = {}, S = {}, T = "", e1 = (s("ROUND", 0), s("PROJECT", 1), s("SQUARE", 2), j("ROUND", 0), j("MITER", 1), j("BEVEL", 2), '#define PI 3.141592\n\nprecision highp float;\nprecision highp int;\n\nuniform mat4 uViewMatrix;\n\nuniform bool uUseLighting;\n\nuniform int uAmbientLightCount;\nuniform vec3 uAmbientColor[5];\nuniform mat3 uCameraRotation;\nuniform int uDirectionalLightCount;\nuniform vec3 uLightingDirection[5];\nuniform vec3 uDirectionalDiffuseColors[5];\nuniform vec3 uDirectionalSpecularColors[5];\n\nuniform int uPointLightCount;\nuniform vec3 uPointLightLocation[5];\nuniform vec3 uPointLightDiffuseColors[5];\t\nuniform vec3 uPointLightSpecularColors[5];\n\nuniform int uSpotLightCount;\nuniform float uSpotLightAngle[5];\nuniform float uSpotLightConc[5];\nuniform vec3 uSpotLightDiffuseColors[5];\nuniform vec3 uSpotLightSpecularColors[5];\nuniform vec3 uSpotLightLocation[5];\nuniform vec3 uSpotLightDirection[5];\n\nuniform bool uSpecular;\nuniform float uShininess;\nuniform float uMetallic;\n\nuniform float uConstantAttenuation;\nuniform float uLinearAttenuation;\nuniform float uQuadraticAttenuation;\n\n// setting from  _setImageLightUniforms()\n// boolean to initiate the calculateImageDiffuse and calculateImageSpecular\nuniform bool uUseImageLight;\n// texture for use in calculateImageDiffuse\nuniform sampler2D environmentMapDiffused;\n// texture for use in calculateImageSpecular\nuniform sampler2D environmentMapSpecular;\n\nconst float specularFactor = 2.0;\nconst float diffuseFactor = 0.73;\n\nstruct LightResult {\n  float specular;\n  float diffuse;\n};\n\nfloat _phongSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float shininess) {\n\n  vec3 R = reflect(lightDirection, surfaceNormal);\n  return pow(max(0.0, dot(R, viewDirection)), shininess);\n}\n\nfloat _lambertDiffuse(vec3 lightDirection, vec3 surfaceNormal) {\n  return max(0.0, dot(-lightDirection, surfaceNormal));\n}\n\nLightResult _light(vec3 viewDirection, vec3 normal, vec3 lightVector, float shininess, float metallic) {\n\n  vec3 lightDir = normalize(lightVector);\n\n  //compute our diffuse & specular terms\n  LightResult lr;\n  float specularIntensity = mix(1.0, 0.4, metallic);\n  float diffuseIntensity = mix(1.0, 0.1, metallic);\n  if (uSpecular)\n    lr.specular = (_phongSpecular(lightDir, viewDirection, normal, shininess)) * specularIntensity;\n    lr.diffuse = _lambertDiffuse(lightDir, normal) * diffuseIntensity;\n  return lr;\n}\n\n// converts the range of "value" from [min1 to max1] to [min2 to max2]\nfloat map(float value, float min1, float max1, float min2, float max2) {\n  return min2 + (value - min1) * (max2 - min2) / (max1 - min1);\n}\n\nvec2 mapTextureToNormal( vec3 v ){\n  // x = r sin(phi) cos(theta)   \n  // y = r cos(phi)  \n  // z = r sin(phi) sin(theta)\n  float phi = acos( v.y );\n  // if phi is 0, then there are no x, z components\n  float theta = 0.0;\n  // else \n  theta = acos(v.x / sin(phi));\n  float sinTheta = v.z / sin(phi);\n  if (sinTheta < 0.0) {\n    // Turn it into -theta, but in the 0-2PI range\n    theta = 2.0 * PI - theta;\n  }\n  theta = theta / (2.0 * 3.14159);\n  phi = phi / 3.14159 ;\n  \n  vec2 angles = vec2( fract(theta + 0.25), 1.0 - phi );\n  return angles;\n}\n\n\nvec3 calculateImageDiffuse(vec3 vNormal, vec3 vViewPosition, float metallic){\n  // make 2 separate builds \n  vec3 worldCameraPosition =  vec3(0.0, 0.0, 0.0);  // hardcoded world camera position\n  vec3 worldNormal = normalize(vNormal * uCameraRotation);\n  vec2 newTexCoor = mapTextureToNormal( worldNormal );\n  vec4 texture = TEXTURE( environmentMapDiffused, newTexCoor );\n  // this is to make the darker sections more dark\n  // png and jpg usually flatten the brightness so it is to reverse that\n  return mix(smoothstep(vec3(0.0), vec3(1.0), texture.xyz), vec3(0.0), metallic);\n}\n\nvec3 calculateImageSpecular(vec3 vNormal, vec3 vViewPosition, float shininess, float metallic){\n  vec3 worldCameraPosition =  vec3(0.0, 0.0, 0.0);\n  vec3 worldNormal = normalize(vNormal);\n  vec3 lightDirection = normalize( vViewPosition - worldCameraPosition );\n  vec3 R = reflect(lightDirection, worldNormal) * uCameraRotation;\n  vec2 newTexCoor = mapTextureToNormal( R );\n#ifdef WEBGL2\n  // In p5js the range of shininess is >= 1,\n  // Therefore roughness range will be ([0,1]*8)*20 or [0, 160]\n  // The factor of 8 is because currently the getSpecularTexture\n  // only calculated 8 different levels of roughness\n  // The factor of 20 is just to spread up this range so that,\n  // [1, max] of shininess is converted to [0,160] of roughness\n  float roughness = 20. / shininess;\n  vec4 outColor = textureLod(environmentMapSpecular, newTexCoor, roughness * 8.);\n#else\n  vec4 outColor = TEXTURE(environmentMapSpecular, newTexCoor);\n#endif\n  // this is to make the darker sections more dark\n  // png and jpg usually flatten the brightness so it is to reverse that\n  return mix(\n    pow(outColor.xyz, vec3(10)),\n    pow(outColor.xyz, vec3(1.2)),\n    metallic \n  );\n}\n\nvoid totalLight(\n  vec3 modelPosition,\n  vec3 normal,\n  float shininess,\n  float metallic,\n  out vec3 totalDiffuse,\n  out vec3 totalSpecular\n) {\n\n  totalSpecular = vec3(0.0);\n\n  if (!uUseLighting) {\n    totalDiffuse = vec3(1.0);\n    return;\n  }\n\n  totalDiffuse = vec3(0.0);\n\n  vec3 viewDirection = normalize(-modelPosition);\n\n  for (int j = 0; j < 5; j++) {\n    if (j < uDirectionalLightCount) {\n      vec3 lightVector = (uViewMatrix * vec4(uLightingDirection[j], 0.0)).xyz;\n      vec3 lightColor = uDirectionalDiffuseColors[j];\n      vec3 specularColor = uDirectionalSpecularColors[j];\n      LightResult result = _light(viewDirection, normal, lightVector, shininess, metallic);\n      totalDiffuse += result.diffuse * lightColor;\n      totalSpecular += result.specular * lightColor * specularColor;\n    }\n\n    if (j < uPointLightCount) {\n      vec3 lightPosition = (uViewMatrix * vec4(uPointLightLocation[j], 1.0)).xyz;\n      vec3 lightVector = modelPosition - lightPosition;\n      //calculate attenuation\n      float lightDistance = length(lightVector);\n      float lightFalloff = 1.0 / (uConstantAttenuation + lightDistance * uLinearAttenuation + (lightDistance * lightDistance) * uQuadraticAttenuation);\n      vec3 lightColor = lightFalloff * uPointLightDiffuseColors[j];\n      vec3 specularColor = lightFalloff * uPointLightSpecularColors[j];\n\n      LightResult result = _light(viewDirection, normal, lightVector, shininess, metallic);\n      totalDiffuse += result.diffuse * lightColor;\n      totalSpecular += result.specular * lightColor * specularColor;\n    }\n\n    if(j < uSpotLightCount) {\n      vec3 lightPosition = (uViewMatrix * vec4(uSpotLightLocation[j], 1.0)).xyz;\n      vec3 lightVector = modelPosition - lightPosition;\n    \n      float lightDistance = length(lightVector);\n      float lightFalloff = 1.0 / (uConstantAttenuation + lightDistance * uLinearAttenuation + (lightDistance * lightDistance) * uQuadraticAttenuation);\n\n      vec3 lightDirection = (uViewMatrix * vec4(uSpotLightDirection[j], 0.0)).xyz;\n      float spotDot = dot(normalize(lightVector), normalize(lightDirection));\n      float spotFalloff;\n      if(spotDot < uSpotLightAngle[j]) {\n        spotFalloff = 0.0;\n      }\n      else {\n        spotFalloff = pow(spotDot, uSpotLightConc[j]);\n      }\n      lightFalloff *= spotFalloff;\n\n      vec3 lightColor = uSpotLightDiffuseColors[j];\n      vec3 specularColor = uSpotLightSpecularColors[j];\n     \n      LightResult result = _light(viewDirection, normal, lightVector, shininess, metallic);\n      \n      totalDiffuse += result.diffuse * lightColor * lightFalloff;\n      totalSpecular += result.specular * lightColor * specularColor * lightFalloff;\n    }\n  }\n\n  if( uUseImageLight ){\n    totalDiffuse += calculateImageDiffuse(normal, modelPosition, metallic);\n    totalSpecular += calculateImageSpecular(normal, modelPosition, shininess, metallic);\n  }\n\n  totalDiffuse *= diffuseFactor;\n  totalSpecular *= specularFactor;\n}\n'), E = {
                    sphereMappingFrag: "#define PI 3.141592\n\nprecision highp float;\n  \nuniform sampler2D uSampler;\nuniform mat3 uNewNormalMatrix;\nuniform float uFovY;\nuniform float uAspect;\n\nvarying vec2 vTexCoord;\n  \nvoid main() {\n    float uFovX = uFovY * uAspect; \n    vec4 newTexColor = texture2D(uSampler, vTexCoord);\n    float angleY = mix(uFovY/2.0,  -uFovY/2.0, vTexCoord.y);\n    float angleX = mix(uFovX/2.0, -uFovX/2.0, vTexCoord.x);\n    vec3 rotatedNormal = vec3( angleX, angleY, 1.0 );\n    rotatedNormal = uNewNormalMatrix * normalize(rotatedNormal);\n    float temp = rotatedNormal.z;\n    rotatedNormal.z = rotatedNormal.x;\n    rotatedNormal.x = -temp;\n    vec2 suv;\n    suv.y = 0.5 + 0.5 * (-rotatedNormal.y);\n    suv.x = atan(rotatedNormal.z, rotatedNormal.x) / (2.0 * PI) + 0.5;\n    newTexColor = texture2D(uSampler, suv.xy);\n    gl_FragColor = newTexColor;\n}\n",
                    immediateVert: "IN vec3 aPosition;\nIN vec4 aVertexColor;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform float uResolution;\nuniform float uPointSize;\n\nOUT vec4 vColor;\nvoid main(void) {\n  vec4 positionVec4 = vec4(aPosition, 1.0);\n  gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n  vColor = aVertexColor;\n  gl_PointSize = uPointSize;\n}\n",
                    vertexColorVert: "IN vec3 aPosition;\nIN vec4 aVertexColor;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\n\nOUT vec4 vColor;\n\nvoid main(void) {\n  vec4 positionVec4 = vec4(aPosition, 1.0);\n  gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n  vColor = aVertexColor;\n}\n",
                    vertexColorFrag: "IN vec4 vColor;\nvoid main(void) {\n  OUT_COLOR = vec4(vColor.rgb, 1.) * vColor.a;\n}\n",
                    normalVert: "IN vec3 aPosition;\nIN vec3 aNormal;\nIN vec2 aTexCoord;\nIN vec4 aVertexColor;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform mat3 uNormalMatrix;\n\nuniform vec4 uMaterialColor;\nuniform bool uUseVertexColor;\n\nOUT vec3 vVertexNormal;\nOUT highp vec2 vVertTexCoord;\nOUT vec4 vColor;\n\nvoid main(void) {\n  HOOK_beforeVertex();\n  vec4 positionVec4 = vec4(HOOK_getWorldPosition(\n    (uModelViewMatrix * vec4(HOOK_getLocalPosition(aPosition), 1.0)).xyz\n  ), 1.);\n\n  gl_Position = uProjectionMatrix * positionVec4;\n\n  vVertexNormal = HOOK_getWorldNormal(normalize(uNormalMatrix * HOOK_getLocalNormal(aNormal)));\n  vVertTexCoord = HOOK_getUV(aTexCoord);\n  vColor = HOOK_getVertexColor(uUseVertexColor ? aVertexColor : uMaterialColor);\n  HOOK_afterVertex();\n}\n",
                    normalFrag: "IN vec3 vVertexNormal;\nvoid main(void) {\n  HOOK_beforeFragment();\n  OUT_COLOR = HOOK_getFinalColor(vec4(vVertexNormal, 1.0));\n  HOOK_afterFragment();\n}\n",
                    basicFrag: "IN vec4 vColor;\nvoid main(void) {\n  HOOK_beforeFragment();\n  OUT_COLOR = HOOK_getFinalColor(vec4(vColor.rgb, 1.) * vColor.a);\n  HOOK_afterFragment();\n}\n",
                    lightVert: e1 + "// include lighting.glgl\n\nIN vec3 aPosition;\nIN vec3 aNormal;\nIN vec2 aTexCoord;\nIN vec4 aVertexColor;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform mat3 uNormalMatrix;\n\nuniform bool uUseVertexColor;\nuniform vec4 uMaterialColor;\n\nOUT highp vec2 vVertTexCoord;\nOUT vec3 vDiffuseColor;\nOUT vec3 vSpecularColor;\nOUT vec4 vColor;\n\nvoid main(void) {\n\n  vec4 viewModelPosition = uModelViewMatrix * vec4(aPosition, 1.0);\n  gl_Position = uProjectionMatrix * viewModelPosition;\n\n  vec3 vertexNormal = normalize(uNormalMatrix * aNormal);\n  vVertTexCoord = aTexCoord;\n\n  totalLight(viewModelPosition.xyz, vertexNormal, vDiffuseColor, vSpecularColor);\n\n  for (int i = 0; i < 8; i++) {\n    if (i < uAmbientLightCount) {\n      vDiffuseColor += uAmbientColor[i];\n    }\n  }\n  \n  vColor = (uUseVertexColor ? aVertexColor : uMaterialColor);\n}\n",
                    lightTextureFrag: "uniform vec4 uTint;\nuniform sampler2D uSampler;\nuniform bool isTexture;\nuniform bool uEmissive;\n\nIN highp vec2 vVertTexCoord;\nIN vec3 vDiffuseColor;\nIN vec3 vSpecularColor;\nIN vec4 vColor;\n\nvoid main(void) {\n  if(uEmissive && !isTexture) {\n    OUT_COLOR = vColor;\n  }\n  else {\n    vec4 baseColor = isTexture\n      // Textures come in with premultiplied alpha. To apply tint and still have\n      // premultiplied alpha output, we need to multiply the RGB channels by the\n      // tint RGB, and all channels by the tint alpha.\n      ? TEXTURE(uSampler, vVertTexCoord) * vec4(uTint.rgb/255., 1.) * (uTint.a/255.)\n      // Colors come in with unmultiplied alpha, so we need to multiply the RGB\n      // channels by alpha to convert it to premultiplied alpha.\n      : vec4(vColor.rgb * vColor.a, vColor.a);\n    OUT_COLOR = vec4(baseColor.rgb * vDiffuseColor + vSpecularColor, baseColor.a);\n  }\n}\n",
                    phongVert: "precision highp int;\n\nIN vec3 aPosition;\nIN vec3 aNormal;\nIN vec2 aTexCoord;\nIN vec4 aVertexColor;\n\nuniform vec3 uAmbientColor[5];\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform mat3 uNormalMatrix;\nuniform int uAmbientLightCount;\n\nuniform bool uUseVertexColor;\nuniform vec4 uMaterialColor;\n\nOUT vec3 vNormal;\nOUT vec2 vTexCoord;\nOUT vec3 vViewPosition;\nOUT vec3 vAmbientColor;\nOUT vec4 vColor;\n\nvoid main(void) {\n  HOOK_beforeVertex();\n  vec4 viewModelPosition = vec4(HOOK_getWorldPosition(\n    (uModelViewMatrix * vec4(HOOK_getLocalPosition(aPosition), 1.0)).xyz\n  ), 1.);\n\n  // Pass varyings to fragment shader\n  vViewPosition = viewModelPosition.xyz;\n  gl_Position = uProjectionMatrix * viewModelPosition;  \n\n  vNormal = HOOK_getWorldNormal(uNormalMatrix * HOOK_getLocalNormal(aNormal));\n  vTexCoord = HOOK_getUV(aTexCoord);\n\n  // TODO: this should be a uniform\n  vAmbientColor = vec3(0.0);\n  for (int i = 0; i < 5; i++) {\n    if (i < uAmbientLightCount) {\n      vAmbientColor += uAmbientColor[i];\n    }\n  }\n  \n  vColor = HOOK_getVertexColor((uUseVertexColor ? aVertexColor : uMaterialColor));\n  HOOK_afterVertex();\n}\n",
                    phongFrag: e1 + "// include lighting.glsl\nprecision highp int;\n\nuniform bool uHasSetAmbient;\nuniform vec4 uSpecularMatColor;\nuniform vec4 uAmbientMatColor;\nuniform vec4 uEmissiveMatColor;\n\nuniform vec4 uTint;\nuniform sampler2D uSampler;\nuniform bool isTexture;\n\nIN vec3 vNormal;\nIN vec2 vTexCoord;\nIN vec3 vViewPosition;\nIN vec3 vAmbientColor;\nIN vec4 vColor;\n\nstruct ColorComponents {\n  vec3 baseColor;\n  float opacity;\n  vec3 ambientColor;\n  vec3 specularColor;\n  vec3 diffuse;\n  vec3 ambient;\n  vec3 specular;\n  vec3 emissive;\n};\n\nstruct Inputs {\n  vec3 normal;\n  vec2 texCoord;\n  vec3 ambientLight;\n  vec3 ambientMaterial;\n  vec3 specularMaterial;\n  vec3 emissiveMaterial;\n  vec4 color;\n  float shininess;\n  float metalness;\n};\n\nvoid main(void) {\n  HOOK_beforeFragment();\n\n  Inputs inputs;\n  inputs.normal = normalize(vNormal);\n  inputs.texCoord = vTexCoord;\n  inputs.ambientLight = vAmbientColor;\n  inputs.color = isTexture\n      // Textures come in with premultiplied alpha. To apply tint and still have\n      // premultiplied alpha output, we need to multiply the RGB channels by the\n      // tint RGB, and all channels by the tint alpha.\n      ? TEXTURE(uSampler, vTexCoord) * vec4(uTint.rgb/255., 1.) * (uTint.a/255.)\n      // Colors come in with unmultiplied alpha, so we need to multiply the RGB\n      // channels by alpha to convert it to premultiplied alpha.\n      : vec4(vColor.rgb * vColor.a, vColor.a);\n  inputs.shininess = uShininess;\n  inputs.metalness = uMetallic;\n  inputs.ambientMaterial = uHasSetAmbient ? uAmbientMatColor.rgb : inputs.color.rgb;\n  inputs.specularMaterial = uSpecularMatColor.rgb;\n  inputs.emissiveMaterial = uEmissiveMatColor.rgb;\n  inputs = HOOK_getPixelInputs(inputs);\n\n  vec3 diffuse;\n  vec3 specular;\n  totalLight(vViewPosition, inputs.normal, inputs.shininess, inputs.metalness, diffuse, specular);\n\n  // Calculating final color as result of all lights (plus emissive term).\n\n  vec2 texCoord = inputs.texCoord;\n  vec4 baseColor = inputs.color;\n  ColorComponents c;\n  c.opacity = baseColor.a;\n  c.baseColor = baseColor.rgb;\n  c.ambientColor = inputs.ambientMaterial;\n  c.specularColor = inputs.specularMaterial;\n  c.diffuse = diffuse;\n  c.ambient = inputs.ambientLight;\n  c.specular = specular;\n  c.emissive = inputs.emissiveMaterial;\n  OUT_COLOR = HOOK_getFinalColor(HOOK_combineColors(c));\n  HOOK_afterFragment();\n}\n",
                    fontVert: "IN vec3 aPosition;\nIN vec2 aTexCoord;\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\n\nuniform vec4 uGlyphRect;\nuniform float uGlyphOffset;\n\nOUT vec2 vTexCoord;\nOUT float w;\n\nvoid main() {\n  vec4 positionVec4 = vec4(aPosition, 1.0);\n\n  // scale by the size of the glyph's rectangle\n  positionVec4.xy *= uGlyphRect.zw - uGlyphRect.xy;\n\n  // Expand glyph bounding boxes by 1px on each side to give a bit of room\n  // for antialiasing\n  vec3 newOrigin = (uModelViewMatrix * vec4(0., 0., 0., 1.)).xyz;\n  vec3 newDX = (uModelViewMatrix * vec4(1., 0., 0., 1.)).xyz;\n  vec3 newDY = (uModelViewMatrix * vec4(0., 1., 0., 1.)).xyz;\n  vec2 pixelScale = vec2(\n    1. / length(newOrigin - newDX),\n    1. / length(newOrigin - newDY)\n  );\n  vec2 offset = pixelScale * normalize(aTexCoord - vec2(0.5, 0.5)) * vec2(1., -1.);\n  vec2 textureOffset = offset * (1. / vec2(\n    uGlyphRect.z - uGlyphRect.x,\n    uGlyphRect.w - uGlyphRect.y\n  ));\n\n  // move to the corner of the glyph\n  positionVec4.xy += uGlyphRect.xy;\n\n  // move to the letter's line offset\n  positionVec4.x += uGlyphOffset;\n\n  positionVec4.xy += offset;\n  \n  gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n  vTexCoord = aTexCoord + textureOffset;\n  w = gl_Position.w;\n}\n",
                    fontFrag: "#ifndef WEBGL2\n#extension GL_OES_standard_derivatives : enable\n#endif\n\n#if 0\n  // simulate integer math using floats\n\t#define int float\n\t#define ivec2 vec2\n\t#define INT(x) float(x)\n\n\tint ifloor(float v) { return floor(v); }\n\tivec2 ifloor(vec2 v) { return floor(v); }\n\n#else\n  // use native integer math\n\tprecision highp int;\n\t#define INT(x) x\n\n\tint ifloor(float v) { return int(v); }\n\tint ifloor(int v) { return v; }\n\tivec2 ifloor(vec2 v) { return ivec2(v); }\n\n#endif\n\nuniform sampler2D uSamplerStrokes;\nuniform sampler2D uSamplerRowStrokes;\nuniform sampler2D uSamplerRows;\nuniform sampler2D uSamplerColStrokes;\nuniform sampler2D uSamplerCols;\n\nuniform ivec2 uStrokeImageSize;\nuniform ivec2 uCellsImageSize;\nuniform ivec2 uGridImageSize;\n\nuniform ivec2 uGridOffset;\nuniform ivec2 uGridSize;\nuniform vec4 uMaterialColor;\n\nIN vec2 vTexCoord;\n\n// some helper functions\nint ROUND(float v) { return ifloor(v + 0.5); }\nivec2 ROUND(vec2 v) { return ifloor(v + 0.5); }\nfloat saturate(float v) { return clamp(v, 0.0, 1.0); }\nvec2 saturate(vec2 v) { return clamp(v, 0.0, 1.0); }\n\nint mul(float v1, int v2) {\n  return ifloor(v1 * float(v2));\n}\n\nivec2 mul(vec2 v1, ivec2 v2) {\n  return ifloor(v1 * vec2(v2) + 0.5);\n}\n\n// unpack a 16-bit integer from a float vec2\nint getInt16(vec2 v) {\n  ivec2 iv = ROUND(v * 255.0);\n  return iv.x * INT(128) + iv.y;\n}\n\nvec2 pixelScale;\nvec2 coverage = vec2(0.0);\nvec2 weight = vec2(0.5);\nconst float minDistance = 1.0/8192.0;\nconst float hardness = 1.05; // amount of antialias\n\n// the maximum number of curves in a glyph\nconst int N = INT(250);\n\n// retrieves an indexed pixel from a sampler\nvec4 getTexel(sampler2D sampler, int pos, ivec2 size) {\n  int width = size.x;\n  int y = ifloor(pos / width);\n  int x = pos - y * width;  // pos % width\n\n  return TEXTURE(sampler, (vec2(x, y) + 0.5) / vec2(size));\n}\n\nvoid calulateCrossings(vec2 p0, vec2 p1, vec2 p2, out vec2 C1, out vec2 C2) {\n\n  // get the coefficients of the quadratic in t\n  vec2 a = p0 - p1 * 2.0 + p2;\n  vec2 b = p0 - p1;\n  vec2 c = p0 - vTexCoord;\n\n  // found out which values of 't' it crosses the axes\n  vec2 surd = sqrt(max(vec2(0.0), b * b - a * c));\n  vec2 t1 = ((b - surd) / a).yx;\n  vec2 t2 = ((b + surd) / a).yx;\n\n  // approximate straight lines to avoid rounding errors\n  if (abs(a.y) < 0.001)\n    t1.x = t2.x = c.y / (2.0 * b.y);\n\n  if (abs(a.x) < 0.001)\n    t1.y = t2.y = c.x / (2.0 * b.x);\n\n  // plug into quadratic formula to find the corrdinates of the crossings\n  C1 = ((a * t1 - b * 2.0) * t1 + c) * pixelScale;\n  C2 = ((a * t2 - b * 2.0) * t2 + c) * pixelScale;\n}\n\nvoid coverageX(vec2 p0, vec2 p1, vec2 p2) {\n\n  vec2 C1, C2;\n  calulateCrossings(p0, p1, p2, C1, C2);\n\n  // determine on which side of the x-axis the points lie\n  bool y0 = p0.y > vTexCoord.y;\n  bool y1 = p1.y > vTexCoord.y;\n  bool y2 = p2.y > vTexCoord.y;\n\n  // could web be under the curve (after t1)?\n  if (y1 ? !y2 : y0) {\n    // add the coverage for t1\n    coverage.x += saturate(C1.x + 0.5);\n    // calculate the anti-aliasing for t1\n    weight.x = min(weight.x, abs(C1.x));\n  }\n\n  // are we outside the curve (after t2)?\n  if (y1 ? !y0 : y2) {\n    // subtract the coverage for t2\n    coverage.x -= saturate(C2.x + 0.5);\n    // calculate the anti-aliasing for t2\n    weight.x = min(weight.x, abs(C2.x));\n  }\n}\n\n// this is essentially the same as coverageX, but with the axes swapped\nvoid coverageY(vec2 p0, vec2 p1, vec2 p2) {\n\n  vec2 C1, C2;\n  calulateCrossings(p0, p1, p2, C1, C2);\n\n  bool x0 = p0.x > vTexCoord.x;\n  bool x1 = p1.x > vTexCoord.x;\n  bool x2 = p2.x > vTexCoord.x;\n\n  if (x1 ? !x2 : x0) {\n    coverage.y -= saturate(C1.y + 0.5);\n    weight.y = min(weight.y, abs(C1.y));\n  }\n\n  if (x1 ? !x0 : x2) {\n    coverage.y += saturate(C2.y + 0.5);\n    weight.y = min(weight.y, abs(C2.y));\n  }\n}\n\nvoid main() {\n\n  // calculate the pixel scale based on screen-coordinates\n  pixelScale = hardness / fwidth(vTexCoord);\n\n  // which grid cell is this pixel in?\n  ivec2 gridCoord = ifloor(vTexCoord * vec2(uGridSize));\n\n  // intersect curves in this row\n  {\n    // the index into the row info bitmap\n    int rowIndex = gridCoord.y + uGridOffset.y;\n    // fetch the info texel\n    vec4 rowInfo = getTexel(uSamplerRows, rowIndex, uGridImageSize);\n    // unpack the rowInfo\n    int rowStrokeIndex = getInt16(rowInfo.xy);\n    int rowStrokeCount = getInt16(rowInfo.zw);\n\n    for (int iRowStroke = INT(0); iRowStroke < N; iRowStroke++) {\n      if (iRowStroke >= rowStrokeCount)\n        break;\n\n      // each stroke is made up of 3 points: the start and control point\n      // and the start of the next curve.\n      // fetch the indices of this pair of strokes:\n      vec4 strokeIndices = getTexel(uSamplerRowStrokes, rowStrokeIndex++, uCellsImageSize);\n\n      // unpack the stroke index\n      int strokePos = getInt16(strokeIndices.xy);\n\n      // fetch the two strokes\n      vec4 stroke0 = getTexel(uSamplerStrokes, strokePos + INT(0), uStrokeImageSize);\n      vec4 stroke1 = getTexel(uSamplerStrokes, strokePos + INT(1), uStrokeImageSize);\n\n      // calculate the coverage\n      coverageX(stroke0.xy, stroke0.zw, stroke1.xy);\n    }\n  }\n\n  // intersect curves in this column\n  {\n    int colIndex = gridCoord.x + uGridOffset.x;\n    vec4 colInfo = getTexel(uSamplerCols, colIndex, uGridImageSize);\n    int colStrokeIndex = getInt16(colInfo.xy);\n    int colStrokeCount = getInt16(colInfo.zw);\n    \n    for (int iColStroke = INT(0); iColStroke < N; iColStroke++) {\n      if (iColStroke >= colStrokeCount)\n        break;\n\n      vec4 strokeIndices = getTexel(uSamplerColStrokes, colStrokeIndex++, uCellsImageSize);\n\n      int strokePos = getInt16(strokeIndices.xy);\n      vec4 stroke0 = getTexel(uSamplerStrokes, strokePos + INT(0), uStrokeImageSize);\n      vec4 stroke1 = getTexel(uSamplerStrokes, strokePos + INT(1), uStrokeImageSize);\n      coverageY(stroke0.xy, stroke0.zw, stroke1.xy);\n    }\n  }\n\n  weight = saturate(1.0 - weight * 2.0);\n  float distance = max(weight.x + weight.y, minDistance); // manhattan approx.\n  float antialias = abs(dot(coverage, weight) / distance);\n  float cover = min(abs(coverage.x), abs(coverage.y));\n  OUT_COLOR = vec4(uMaterialColor.rgb, 1.) * uMaterialColor.a;\n  OUT_COLOR *= saturate(max(antialias, cover));\n}\n",
                    lineVert: T + "/*\n  Part of the Processing project - http://processing.org\n  Copyright (c) 2012-15 The Processing Foundation\n  Copyright (c) 2004-12 Ben Fry and Casey Reas\n  Copyright (c) 2001-04 Massachusetts Institute of Technology\n  This library is free software; you can redistribute it and/or\n  modify it under the terms of the GNU Lesser General Public\n  License as published by the Free Software Foundation, version 2.1.\n  This library is distributed in the hope that it will be useful,\n  but WITHOUT ANY WARRANTY; without even the implied warranty of\n  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU\n  Lesser General Public License for more details.\n  You should have received a copy of the GNU Lesser General\n  Public License along with this library; if not, write to the\n  Free Software Foundation, Inc., 59 Temple Place, Suite 330,\n  Boston, MA  02111-1307  USA\n*/\n\n#define PROCESSING_LINE_SHADER\n\nprecision highp int;\nprecision highp float;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform float uStrokeWeight;\n\nuniform bool uUseLineColor;\nuniform vec4 uMaterialColor;\n\nuniform vec4 uViewport;\nuniform int uPerspective;\nuniform int uStrokeJoin;\n\nIN vec4 aPosition;\nIN vec3 aTangentIn;\nIN vec3 aTangentOut;\nIN float aSide;\nIN vec4 aVertexColor;\n\nOUT vec4 vColor;\nOUT vec2 vTangent;\nOUT vec2 vCenter;\nOUT vec2 vPosition;\nOUT float vMaxDist;\nOUT float vCap;\nOUT float vJoin;\nOUT float vStrokeWeight;\n\nvec2 lineIntersection(vec2 aPoint, vec2 aDir, vec2 bPoint, vec2 bDir) {\n  // Rotate and translate so a starts at the origin and goes out to the right\n  bPoint -= aPoint;\n  vec2 rotatedBFrom = vec2(\n    bPoint.x*aDir.x + bPoint.y*aDir.y,\n    bPoint.y*aDir.x - bPoint.x*aDir.y\n  );\n  vec2 bTo = bPoint + bDir;\n  vec2 rotatedBTo = vec2(\n    bTo.x*aDir.x + bTo.y*aDir.y,\n    bTo.y*aDir.x - bTo.x*aDir.y\n  );\n  float intersectionDistance =\n    rotatedBTo.x + (rotatedBFrom.x - rotatedBTo.x) * rotatedBTo.y /\n    (rotatedBTo.y - rotatedBFrom.y);\n  return aPoint + aDir * intersectionDistance;\n}\n\nvoid main() {\n  HOOK_beforeVertex();\n  // Caps have one of either the in or out tangent set to 0\n  vCap = (aTangentIn == vec3(0.)) != (aTangentOut == (vec3(0.)))\n    ? 1. : 0.;\n\n  // Joins have two unique, defined tangents\n  vJoin = (\n    aTangentIn != vec3(0.) &&\n    aTangentOut != vec3(0.) &&\n    aTangentIn != aTangentOut\n  ) ? 1. : 0.;\n\n  vec4 localPosition = vec4(HOOK_getLocalPosition(aPosition.xyz), 1.);\n  vec4 posp = vec4(HOOK_getWorldPosition((uModelViewMatrix * localPosition).xyz), 1.);\n  vec4 posqIn = posp + uModelViewMatrix * vec4(aTangentIn, 0);\n  vec4 posqOut = posp + uModelViewMatrix * vec4(aTangentOut, 0);\n  float strokeWeight = HOOK_getStrokeWeight(uStrokeWeight);\n  vStrokeWeight = strokeWeight;\n\n  float facingCamera = pow(\n    // The word space tangent's z value is 0 if it's facing the camera\n    abs(normalize(posqIn-posp).z),\n\n    // Using pow() here to ramp `facingCamera` up from 0 to 1 really quickly\n    // so most lines get scaled and don't get clipped\n    0.25\n  );\n\n  // Moving vertices slightly toward the camera\n  // to avoid depth-fighting with the fill triangles.\n  // A mix of scaling and offsetting is used based on distance\n  // Discussion here:\n  // https://github.com/processing/p5.js/issues/7200 \n\n  // using a scale <1 moves the lines towards nearby camera\n  // in order to prevent popping effects due to half of\n  // the line disappearing behind the geometry faces.\n  float zDistance = -posp.z; \n  float distanceFactor = smoothstep(0.0, 800.0, zDistance); \n  \n  // Discussed here:\n  // http://www.opengl.org/discussion_boards/ubbthreads.php?ubb=showflat&Number=252848  \n  float scale = mix(1., 0.995, facingCamera);\n  float dynamicScale = mix(scale, 1.0, distanceFactor); // Closer = more scale, farther = less\n\n  posp.xyz = posp.xyz * dynamicScale;\n  posqIn.xyz = posqIn.xyz * dynamicScale;\n  posqOut.xyz = posqOut.xyz * dynamicScale;\n\n  // Moving vertices slightly toward camera when far away \n  // https://github.com/processing/p5.js/issues/6956 \n  float zOffset = mix(0., -1., facingCamera);\n  float dynamicZAdjustment = mix(0.0, zOffset, distanceFactor); // Closer = less zAdjustment, farther = more\n\n  posp.z -= dynamicZAdjustment;\n  posqIn.z -= dynamicZAdjustment;\n  posqOut.z -= dynamicZAdjustment;\n  \n  vec4 p = uProjectionMatrix * posp;\n  vec4 qIn = uProjectionMatrix * posqIn;\n  vec4 qOut = uProjectionMatrix * posqOut;\n  vCenter = HOOK_getLineCenter(p.xy);\n\n  // formula to convert from clip space (range -1..1) to screen space (range 0..[width or height])\n  // screen_p = (p.xy/p.w + <1,1>) * 0.5 * uViewport.zw\n\n  // prevent division by W by transforming the tangent formula (div by 0 causes\n  // the line to disappear, see https://github.com/processing/processing/issues/5183)\n  // t = screen_q - screen_p\n  //\n  // tangent is normalized and we don't care which aDirection it points to (+-)\n  // t = +- normalize( screen_q - screen_p )\n  // t = +- normalize( (q.xy/q.w+<1,1>)*0.5*uViewport.zw - (p.xy/p.w+<1,1>)*0.5*uViewport.zw )\n  //\n  // extract common factor, <1,1> - <1,1> cancels out\n  // t = +- normalize( (q.xy/q.w - p.xy/p.w) * 0.5 * uViewport.zw )\n  //\n  // convert to common divisor\n  // t = +- normalize( ((q.xy*p.w - p.xy*q.w) / (p.w*q.w)) * 0.5 * uViewport.zw )\n  //\n  // remove the common scalar divisor/factor, not needed due to normalize and +-\n  // (keep uViewport - can't remove because it has different components for x and y\n  //  and corrects for aspect ratio, see https://github.com/processing/processing/issues/5181)\n  // t = +- normalize( (q.xy*p.w - p.xy*q.w) * uViewport.zw )\n\n  vec2 tangentIn = normalize((qIn.xy*p.w - p.xy*qIn.w) * uViewport.zw);\n  vec2 tangentOut = normalize((qOut.xy*p.w - p.xy*qOut.w) * uViewport.zw);\n\n  vec2 curPerspScale;\n  if(uPerspective == 1) {\n    // Perspective ---\n    // convert from world to clip by multiplying with projection scaling factor\n    // to get the right thickness (see https://github.com/processing/processing/issues/5182)\n\n    // The y value of the projection matrix may be flipped if rendering to a Framebuffer.\n    // Multiplying again by its sign here negates the flip to get just the scale.\n    curPerspScale = (uProjectionMatrix * vec4(1, sign(uProjectionMatrix[1][1]), 0, 0)).xy;\n  } else {\n    // No Perspective ---\n    // multiply by W (to cancel out division by W later in the pipeline) and\n    // convert from screen to clip (derived from clip to screen above)\n    curPerspScale = p.w / (0.5 * uViewport.zw);\n  }\n\n  vec2 offset;\n  if (vJoin == 1.) {\n    vTangent = normalize(tangentIn + tangentOut);\n    vec2 normalIn = vec2(-tangentIn.y, tangentIn.x);\n    vec2 normalOut = vec2(-tangentOut.y, tangentOut.x);\n    float side = sign(aSide);\n    float sideEnum = abs(aSide);\n\n    // We generate vertices for joins on either side of the centerline, but\n    // the \"elbow\" side is the only one needing a join. By not setting the\n    // offset for the other side, all its vertices will end up in the same\n    // spot and not render, effectively discarding it.\n    if (sign(dot(tangentOut, vec2(-tangentIn.y, tangentIn.x))) != side) {\n      // Side enums:\n      //   1: the side going into the join\n      //   2: the middle of the join\n      //   3: the side going out of the join\n      if (sideEnum == 2.) {\n        // Calculate the position + tangent on either side of the join, and\n        // find where the lines intersect to find the elbow of the join\n        vec2 c = (posp.xy/posp.w + vec2(1.,1.)) * 0.5 * uViewport.zw;\n        vec2 intersection = lineIntersection(\n          c + (side * normalIn * strokeWeight / 2.),\n          tangentIn,\n          c + (side * normalOut * strokeWeight / 2.),\n          tangentOut\n        );\n        offset = (intersection - c);\n\n        // When lines are thick and the angle of the join approaches 180, the\n        // elbow might be really far from the center. We'll apply a limit to\n        // the magnitude to avoid lines going across the whole screen when this\n        // happens.\n        float mag = length(offset);\n        float maxMag = 3. * strokeWeight;\n        if (mag > maxMag) {\n          offset *= maxMag / mag;\n        }\n      } else if (sideEnum == 1.) {\n        offset = side * normalIn * strokeWeight / 2.;\n      } else if (sideEnum == 3.) {\n        offset = side * normalOut * strokeWeight / 2.;\n      }\n    }\n    if (uStrokeJoin == STROKE_JOIN_BEVEL) {\n      vec2 avgNormal = vec2(-vTangent.y, vTangent.x);\n      vMaxDist = abs(dot(avgNormal, normalIn * strokeWeight / 2.));\n    } else {\n      vMaxDist = strokeWeight / 2.;\n    }\n  } else {\n    vec2 tangent = aTangentIn == vec3(0.) ? tangentOut : tangentIn;\n    vTangent = tangent;\n    vec2 normal = vec2(-tangent.y, tangent.x);\n\n    float normalOffset = sign(aSide);\n    // Caps will have side values of -2 or 2 on the edge of the cap that\n    // extends out from the line\n    float tangentOffset = abs(aSide) - 1.;\n    offset = (normal * normalOffset + tangent * tangentOffset) *\n      strokeWeight * 0.5;\n    vMaxDist = strokeWeight / 2.;\n  }\n  vPosition = HOOK_getLinePosition(vCenter + offset);\n\n  gl_Position.xy = p.xy + offset.xy * curPerspScale;\n  gl_Position.zw = p.zw;\n  \n  vColor = HOOK_getVertexColor(uUseLineColor ? aVertexColor : uMaterialColor);\n  HOOK_afterVertex();\n}\n",
                    lineFrag: T + "precision highp int;\nprecision highp float;\n\nuniform vec4 uMaterialColor;\nuniform int uStrokeCap;\nuniform int uStrokeJoin;\n\nIN vec4 vColor;\nIN vec2 vTangent;\nIN vec2 vCenter;\nIN vec2 vPosition;\nIN float vStrokeWeight;\nIN float vMaxDist;\nIN float vCap;\nIN float vJoin;\n\nfloat distSquared(vec2 a, vec2 b) {\n  vec2 aToB = b - a;\n  return dot(aToB, aToB);\n}\n\nstruct Inputs {\n  vec4 color;\n  vec2 tangent;\n  vec2 center;\n  vec2 position;\n  float strokeWeight;\n};\n\nvoid main() {\n  HOOK_beforeFragment();\n\n  Inputs inputs;\n  inputs.color = vColor;\n  inputs.tangent = vTangent;\n  inputs.center = vCenter;\n  inputs.position = vPosition;\n  inputs.strokeWeight = vStrokeWeight;\n  inputs = HOOK_getPixelInputs(inputs);\n\n  if (vCap > 0.) {\n    if (\n      uStrokeCap == STROKE_CAP_ROUND &&\n      HOOK_shouldDiscard(distSquared(inputs.position, inputs.center) > inputs.strokeWeight * inputs.strokeWeight * 0.25)\n    ) {\n      discard;\n    } else if (\n      uStrokeCap == STROKE_CAP_SQUARE &&\n      HOOK_shouldDiscard(dot(inputs.position - inputs.center, inputs.tangent) > 0.)\n    ) {\n      discard;\n    // Use full area for PROJECT\n    } else if (HOOK_shouldDiscard(false)) {\n      discard;\n    }\n  } else if (vJoin > 0.) {\n    if (\n      uStrokeJoin == STROKE_JOIN_ROUND &&\n      HOOK_shouldDiscard(distSquared(inputs.position, inputs.center) > inputs.strokeWeight * inputs.strokeWeight * 0.25)\n    ) {\n      discard;\n    } else if (uStrokeJoin == STROKE_JOIN_BEVEL) {\n      vec2 normal = vec2(-inputs.tangent.y, inputs.tangent.x);\n      if (HOOK_shouldDiscard(abs(dot(inputs.position - inputs.center, normal)) > vMaxDist)) {\n        discard;\n      }\n    // Use full area for MITER\n    } else if (HOOK_shouldDiscard(false)) {\n      discard;\n    }\n  }\n  OUT_COLOR = HOOK_getFinalColor(vec4(inputs.color.rgb, 1.) * inputs.color.a);\n  HOOK_afterFragment();\n}\n",
                    pointVert: "IN vec3 aPosition;\nIN vec4 aVertexColor;\nuniform float uPointSize;\nuniform bool uUseVertexColor;\nuniform vec4 uMaterialColor;\nOUT float vStrokeWeight;\nOUT vec4 vColor;\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\n\nvoid main() {\n  HOOK_beforeVertex();\n  vec4 viewModelPosition = vec4(HOOK_getWorldPosition(\n    (uModelViewMatrix * vec4(HOOK_getLocalPosition(aPosition), 1.0)).xyz\n  ), 1.);\n  gl_Position = uProjectionMatrix * viewModelPosition;  \n\n  float pointSize = HOOK_getPointSize(uPointSize);\n\n\tgl_PointSize = pointSize;\n\tvStrokeWeight = pointSize;\n\n  // Choose per-vertex stroke color when available; otherwise use uniform stroke color\n  vec4 baseColor = uUseVertexColor ? aVertexColor : uMaterialColor;\n  vColor = HOOK_getVertexColor(baseColor);\n  HOOK_afterVertex();\n}\n",
                    pointFrag: "precision mediump int;\nuniform vec4 uMaterialColor;\nIN float vStrokeWeight;\nIN vec4 vColor;\n\nvoid main(){\n  HOOK_beforeFragment();\n  float mask = 0.0;\n\n  // make a circular mask using the gl_PointCoord (goes from 0 - 1 on a point)\n  // might be able to get a nicer edge on big strokeweights with smoothstep but slightly less performant\n\n  mask = step(0.98, length(gl_PointCoord * 2.0 - 1.0));\n\n  // if strokeWeight is 1 or less lets just draw a square\n  // this prevents weird artifacting from carving circles when our points are really small\n  // if strokeWeight is larger than 1, we just use it as is\n\n  mask = mix(0.0, mask, clamp(floor(vStrokeWeight - 0.5),0.0,1.0));\n\n  // throw away the borders of the mask\n  // otherwise we get weird alpha blending issues\n\n  if(HOOK_shouldDiscard(mask > 0.98)){\n    discard;\n  }\n\n  // Use the interpolated vertex color (set in vertex shader)\n  vec4 baseColor = vColor;\n  OUT_COLOR = HOOK_getFinalColor(vec4(baseColor.rgb, 1.) * baseColor.a);\n  HOOK_afterFragment();\n}\n",
                    imageLightVert: "precision highp float;\nattribute vec3 aPosition;\nattribute vec3 aNormal;\nattribute vec2 aTexCoord;\n\nvarying vec3 localPos;\nvarying vec3 vWorldNormal;\nvarying vec3 vWorldPosition;\nvarying vec2 vTexCoord;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform mat3 uNormalMatrix;\n\nvoid main() {\n  // Multiply the position by the matrix.\n  vec4 viewModelPosition = uModelViewMatrix * vec4(aPosition, 1.0);\n  gl_Position = uProjectionMatrix * viewModelPosition;  \n  \n  // orient the normals and pass to the fragment shader\n  vWorldNormal = uNormalMatrix * aNormal;\n  \n  // send the view position to the fragment shader\n  vWorldPosition = (uModelViewMatrix * vec4(aPosition, 1.0)).xyz;\n  \n  localPos = vWorldPosition;\n  vTexCoord = aTexCoord;\n}\n\n\n/*\nin the vertex shader we'll compute the world position and world oriented normal of the vertices and pass those to the fragment shader as varyings.\n*/\n",
                    imageLightDiffusedFrag: "precision highp float;\nvarying vec3 localPos;\n\n// the HDR cubemap converted (can be from an equirectangular environment map.)\nuniform sampler2D environmentMap;\nvarying vec2 vTexCoord;\n\nconst float PI = 3.14159265359;\n\nvec2 nTOE( vec3 v ){\n  // x = r sin(phi) cos(theta)   \n  // y = r cos(phi)  \n  // z = r sin(phi) sin(theta)\n  float phi = acos( v.y );\n  // if phi is 0, then there are no x, z components\n  float theta = 0.0;\n  // else \n  theta = acos(v.x / sin(phi));\n  float sinTheta = v.z / sin(phi);\n  if (sinTheta < 0.0) {\n    // Turn it into -theta, but in the 0-2PI range\n    theta = 2.0 * PI - theta;\n  }\n  theta = theta / (2.0 * 3.14159);\n  phi = phi / 3.14159 ;\n  \n  vec2 angles = vec2( phi, theta );\n  return angles;\n}\n\nfloat random(vec2 p) {\n  vec3 p3  = fract(vec3(p.xyx) * .1031);\n  p3 += dot(p3, p3.yzx + 33.33);\n  return fract((p3.x + p3.y) * p3.z);\n}\n\nvoid main()\n{   \t \n\t// the sample direction equals the hemisphere's orientation\n  float phi = vTexCoord.x * 2.0 * PI;\n  float theta = vTexCoord.y * PI;\n  float x = sin(theta) * cos(phi);\n  float y = sin(theta) * sin(phi);\n  float z = cos(theta);\n  vec3 normal = vec3( x, y, z);\n\n\t// Discretely sampling the hemisphere given the integral's\n  // spherical coordinates translates to the following fragment code:\n\tvec3 irradiance = vec3(0.0);  \n\tvec3 up\t= vec3(0.0, 1.0, 0.0);\n\tvec3 right = normalize(cross(up, normal));\n\tup = normalize(cross(normal, right));\n\n\t//  We specify a fixed sampleDelta delta value to traverse\n  // the hemisphere; decreasing or increasing the sample delta\n  // will increase or decrease the accuracy respectively.\n\tconst float sampleDelta = 0.100;\n\tfloat nrSamples = 0.0;\n  float randomOffset = random(gl_FragCoord.xy) * sampleDelta;\n\tfor(float rawPhi = 0.0; rawPhi < 2.0 * PI; rawPhi += sampleDelta)\n\t{\n    float phi = rawPhi + randomOffset;\n    for(float rawTheta = 0.0; rawTheta < ( 0.5 ) * PI; rawTheta += sampleDelta)\n    {\n      float theta = rawTheta + randomOffset;\n      // spherical to cartesian (in tangent space) // tangent space to world // add each sample result to irradiance\n      float x = sin(theta) * cos(phi);\n      float y = sin(theta) * sin(phi);\n      float z = cos(theta);\n      vec3 tangentSample = vec3( x, y, z);\n      \n      vec3 sampleVec = tangentSample.x * right + tangentSample.y * up + tangentSample.z * normal;\n        irradiance += (texture2D(environmentMap, nTOE(sampleVec)).xyz) * cos(theta) * sin(theta);\n      nrSamples++;\n    }\n\t}\n\t// divide by the total number of samples taken, giving us the average sampled irradiance.\n\tirradiance = PI * irradiance * (1.0 / float(nrSamples )) ;\n  \n \n\tgl_FragColor = vec4(irradiance, 1.0);\n}",
                    imageLightSpecularFrag: "precision highp float;\r\nvarying vec3 localPos;\r\nvarying vec2 vTexCoord;\r\n\r\n// our texture\r\nuniform sampler2D environmentMap;\r\nuniform float roughness;\r\n\r\nconst float PI = 3.14159265359;\r\n\r\nfloat VanDerCorput(int bits);\r\nvec2 HammersleyNoBitOps(int i, int N);\r\nvec3 ImportanceSampleGGX(vec2 Xi, vec3 N, float roughness);\r\n\r\n\r\nvec2 nTOE( vec3 v ){\r\n  // x = r sin(phi) cos(theta)   \r\n  // y = r cos(phi)  \r\n  // z = r sin(phi) sin(theta)\r\n  float phi = acos( v.y );\r\n  // if phi is 0, then there are no x, z components\r\n  float theta = 0.0;\r\n  // else \r\n  theta = acos(v.x / sin(phi));\r\n  float sinTheta = v.z / sin(phi);\r\n  if (sinTheta < 0.0) {\r\n    // Turn it into -theta, but in the 0-2PI range\r\n    theta = 2.0 * PI - theta;\r\n  }\r\n  theta = theta / (2.0 * 3.14159);\r\n  phi = phi / 3.14159 ;\r\n  \r\n  vec2 angles = vec2( phi, theta );\r\n  return angles;\r\n}\r\n\r\n\r\nvoid main(){\r\n  const int SAMPLE_COUNT = 400; // 4096\r\n  int lowRoughnessLimit = int(pow(2.0,(roughness+0.1)*20.0));\r\n  float totalWeight = 0.0;\r\n  vec3 prefilteredColor = vec3(0.0);\r\n  float phi = vTexCoord.x * 2.0 * PI;\r\n  float theta = vTexCoord.y * PI;\r\n  float x = sin(theta) * cos(phi);\r\n  float y = sin(theta) * sin(phi);\r\n  float z = cos(theta);\r\n  vec3 N = vec3(x,y,z);\r\n  vec3 V = N;\r\n  for (int i = 0; i < SAMPLE_COUNT; ++i)\r\n  {\r\n    // break at smaller sample numbers for low roughness levels\r\n    if(i == lowRoughnessLimit)\r\n    {\r\n      break;\r\n    }\r\n    vec2 Xi = HammersleyNoBitOps(i, SAMPLE_COUNT);\r\n    vec3 H = ImportanceSampleGGX(Xi, N, roughness);\r\n    vec3 L = normalize(2.0 * dot(V, H) * H - V);\r\n\r\n    float NdotL = max(dot(N, L), 0.0);\r\n    if (NdotL > 0.0)\r\n    {\r\n      prefilteredColor += texture2D(environmentMap, nTOE(L)).xyz * NdotL;\r\n      totalWeight += NdotL;\r\n    }\r\n  }\r\n  prefilteredColor = prefilteredColor / totalWeight;\r\n\r\n  gl_FragColor = vec4(prefilteredColor, 1.0);\r\n}\r\n\r\nvec3 ImportanceSampleGGX(vec2 Xi, vec3 N, float roughness){\r\n  float a = roughness * roughness;\r\n\r\n  float phi = 2.0 * PI * Xi.x;\r\n  float cosTheta = sqrt((1.0 - Xi.y) / (1.0 + (a * a - 1.0) * Xi.y));\r\n  float sinTheta = sqrt(1.0 - cosTheta * cosTheta);\r\n  // from spherical coordinates to cartesian coordinates\r\n  vec3 H;\r\n  H.x = cos(phi) * sinTheta;\r\n  H.y = sin(phi) * sinTheta;\r\n  H.z = cosTheta;\r\n\r\n  // from tangent-space vector to world-space sample vector\r\n  vec3 up = abs(N.z) < 0.999 ? vec3(0.0, 0.0, 1.0) : vec3(1.0, 0.0, 0.0);\r\n  vec3 tangent = normalize(cross(up, N));\r\n  vec3 bitangent = cross(N, tangent);\r\n\r\n  vec3 sampleVec = tangent * H.x + bitangent * H.y + N * H.z;\r\n  return normalize(sampleVec);\r\n}\r\n\r\n\r\nfloat VanDerCorput(int n, int base)\r\n{\r\n#ifdef WEBGL2\r\n\r\n    uint bits = uint(n);\r\n    bits = (bits << 16u) | (bits >> 16u);\r\n    bits = ((bits & 0x55555555u) << 1u) | ((bits & 0xAAAAAAAAu) >> 1u);\r\n    bits = ((bits & 0x33333333u) << 2u) | ((bits & 0xCCCCCCCCu) >> 2u);\r\n    bits = ((bits & 0x0F0F0F0Fu) << 4u) | ((bits & 0xF0F0F0F0u) >> 4u);\r\n    bits = ((bits & 0x00FF00FFu) << 8u) | ((bits & 0xFF00FF00u) >> 8u);\r\n    return float(bits) * 2.3283064365386963e-10; // / 0x100000000\r\n\r\n#else\r\n\r\n  float invBase = 1.0 / float(base);\r\n  float denom = 1.0;\r\n  float result = 0.0;\r\n\r\n\r\n  for (int i = 0; i < 32; ++i)\r\n  {\r\n        if (n > 0)\r\n        {\r\n        denom = mod(float(n), 2.0);\r\n        result += denom * invBase;\r\n        invBase = invBase / 2.0;\r\n        n = int(float(n) / 2.0);\r\n        }\r\n  }\r\n\r\n\r\n  return result;\r\n\r\n#endif\r\n}\r\n\r\nvec2 HammersleyNoBitOps(int i, int N)\r\n{\r\n  return vec2(float(i) / float(N), VanDerCorput(i, 2));\r\n}\r\n"
                }, M = E.sphereMappingFrag;
                for(x in E)E[x] = "#ifdef WEBGL2\n\n#define IN in\n#define OUT out\n\n#ifdef FRAGMENT_SHADER\nout vec4 outColor;\n#define OUT_COLOR outColor\n#endif\n#define TEXTURE texture\n\n#else\n\n#ifdef FRAGMENT_SHADER\n#define IN varying\n#else\n#define IN attribute\n#endif\n#define OUT varying\n#define TEXTURE texture2D\n\n#ifdef FRAGMENT_SHADER\n#define OUT_COLOR gl_FragColor\n#endif\n\n#endif\n" + E[x];
                _(e1 = {}, l.GRAY, "precision highp float;\n\nvarying vec2 vTexCoord;\n\nuniform sampler2D tex0;\n\nfloat luma(vec3 color) {\n  // weighted grayscale with luminance values\n  return dot(color, vec3(0.2126, 0.7152, 0.0722));\n}\n\nvoid main() {\n  vec4 tex = texture2D(tex0, vTexCoord);\n  float gray = luma(tex.rgb);\n  gl_FragColor = vec4(gray, gray, gray, tex.a);\n}\n"), _(e1, l.ERODE, "// Reduces the bright areas in an image\n\nprecision highp float;\n\nvarying vec2 vTexCoord;\n\nuniform sampler2D tex0;\nuniform vec2 texelSize;\n\nfloat luma(vec3 color) {\n  // weighted grayscale with luminance values\n  // weights 77, 151, 28 taken from src/image/filters.js\n  return dot(color, vec3(0.300781, 0.589844, 0.109375));\n}\n\nvoid main() {\n  vec4 color = texture2D(tex0, vTexCoord);\n  float lum = luma(color.rgb);\n\n  // set current color as the darkest neighbor color\n\n  vec4 neighbors[4];\n  neighbors[0] = texture2D(tex0, vTexCoord + vec2( texelSize.x, 0.0));\n  neighbors[1] = texture2D(tex0, vTexCoord + vec2(-texelSize.x, 0.0));\n  neighbors[2] = texture2D(tex0, vTexCoord + vec2(0.0,  texelSize.y));\n  neighbors[3] = texture2D(tex0, vTexCoord + vec2(0.0, -texelSize.y));\n\n  for (int i = 0; i < 4; i++) {\n    vec4 neighborColor = neighbors[i];\n    float neighborLum = luma(neighborColor.rgb);\n\n    if (neighborLum < lum) {\n      color = neighborColor;\n      lum = neighborLum;\n    }\n  }\n\n  gl_FragColor = color;\n}\n"), _(e1, l.DILATE, "// Increase the bright areas in an image\n\nprecision highp float;\n\nvarying vec2 vTexCoord;\n\nuniform sampler2D tex0;\nuniform vec2 texelSize;\n\nfloat luma(vec3 color) {\n  // weighted grayscale with luminance values\n  // weights 77, 151, 28 taken from src/image/filters.js\n  return dot(color, vec3(0.300781, 0.589844, 0.109375));\n}\n\nvoid main() {\n  vec4 color = texture2D(tex0, vTexCoord);\n  float lum = luma(color.rgb);\n\n  // set current color as the brightest neighbor color\n\n  vec4 neighbors[4];\n  neighbors[0] = texture2D(tex0, vTexCoord + vec2( texelSize.x, 0.0));\n  neighbors[1] = texture2D(tex0, vTexCoord + vec2(-texelSize.x, 0.0));\n  neighbors[2] = texture2D(tex0, vTexCoord + vec2(0.0,  texelSize.y));\n  neighbors[3] = texture2D(tex0, vTexCoord + vec2(0.0, -texelSize.y));\n\n  for (int i = 0; i < 4; i++) {\n    vec4 neighborColor = neighbors[i];\n    float neighborLum = luma(neighborColor.rgb);\n\n    if (neighborLum > lum) {\n      color = neighborColor;\n      lum = neighborLum;\n    }\n  }\n\n  gl_FragColor = color;\n}\n"), _(e1, l.BLUR, "precision highp float;\n\n// Two-pass blur filter, unweighted kernel.\n// See also a similar blur at Adam Ferriss' repo of shader examples:\n// https://github.com/aferriss/p5jsShaderExamples/blob/gh-pages/4_image-effects/4-9_single-pass-blur/effect.frag\n\n\nuniform sampler2D tex0;\nvarying vec2 vTexCoord;\nuniform vec2 direction;\nuniform vec2 canvasSize;\nuniform float radius;\n\nfloat random(vec2 p) {\n  vec3 p3  = fract(vec3(p.xyx) * .1031);\n  p3 += dot(p3, p3.yzx + 33.33);\n  return fract((p3.x + p3.y) * p3.z);\n}\n\n// This isn't a real Gaussian weight, it's a quadratic weight. It's what the\n// CPU mode's blur uses though, so we also use it here to match.\nfloat quadWeight(float x, float e) {\n  return pow(e-abs(x), 2.);\n}\n\nvoid main(){\n  vec2 uv = vTexCoord;\n\n  // A reasonable maximum number of samples\n  const float maxSamples = 64.0;\n\n  float numSamples = floor(7. * radius);\n  if (fract(numSamples / 2.) == 0.) {\n    numSamples++;\n  }\n  vec4 avg = vec4(0.0);\n  float total = 0.0;\n\n  // Calculate the spacing to avoid skewing if numSamples > maxSamples\n  float spacing = 1.0;\n  if (numSamples > maxSamples) {\n    spacing = numSamples / maxSamples;\n    numSamples = maxSamples;\n  }\n\n  float randomOffset = (spacing - 1.0) * mix(-0.5, 0.5, random(gl_FragCoord.xy));\n  for (float i = 0.0; i < maxSamples; i++) {\n    if (i >= numSamples) break;\n\n    float sample = i * spacing - (numSamples - 1.0) * 0.5 * spacing + randomOffset;\n    vec2 sampleCoord = uv + vec2(sample, sample) / canvasSize * direction;\n    float weight = quadWeight(sample, (numSamples - 1.0) * 0.5 * spacing);\n\n    avg += weight * texture2D(tex0, sampleCoord);\n    total += weight;\n  }\n\n  avg /= total;\n  gl_FragColor = avg;\n}\n"), _(e1, l.POSTERIZE, "// Limit color space for a stylized cartoon / poster effect\n\nprecision highp float;\n\nvarying vec2 vTexCoord;\n\nuniform sampler2D tex0;\nuniform float filterParameter;\n\nvec3 quantize(vec3 color, float n) {\n  // restrict values to N options/bins\n  // and floor each channel to nearest value\n  //\n  // eg. when N = 5, values = 0.0, 0.25, 0.50, 0.75, 1.0\n  // then quantize (0.1, 0.7, 0.9) -> (0.0, 0.5, 1.0)\n\n  color = color * n;\n  color = floor(color);\n  color = color / (n - 1.0);\n  return color;\n}\n\nvoid main() {\n  vec4 color = texture2D(tex0, vTexCoord);\n\n  vec3 restrictedColor = quantize(color.rgb / color.a, filterParameter);\n\n  gl_FragColor = vec4(restrictedColor.rgb * color.a, color.a);\n}\n"), _(e1, l.OPAQUE, "// Set alpha channel to entirely opaque\n\nprecision highp float;\n\nvarying vec2 vTexCoord;\n\nuniform sampler2D tex0;\n\nvoid main() {\n  vec4 color = texture2D(tex0, vTexCoord);\n  gl_FragColor = vec4(color.rgb / color.a, 1.0);\n}\n"), _(e1, l.INVERT, "// Set each pixel to inverse value\n// Note that original INVERT does not change the opacity, so this follows suit\n\nprecision highp float;\n\nvarying vec2 vTexCoord;\n\nuniform sampler2D tex0;\n\nvoid main() {\nvec4 color = texture2D(tex0, vTexCoord);\nvec3 origColor = color.rgb / color.a;\nvec3 invertedColor = vec3(1.0) - origColor;\ngl_FragColor = vec4(invertedColor * color.a, color.a);\n}\n"), _(e1, l.THRESHOLD, "// Convert pixels to either white or black, \n// depending on if their luma is above or below filterParameter\n\nprecision highp float;\n\nvarying vec2 vTexCoord;\n\nuniform sampler2D tex0;\nuniform float filterParameter;\n\nfloat luma(vec3 color) {\n  // weighted grayscale with luminance values\n  return dot(color, vec3(0.2126, 0.7152, 0.0722));\n}\n\nvoid main() {\n  vec4 color = texture2D(tex0, vTexCoord);\n  float gray = luma(color.rgb / color.a);\n  // floor() used to match src/image/filters.js\n  float threshold = floor(filterParameter * 255.0) / 255.0;\n  float blackOrWhite = step(threshold, gray);\n  gl_FragColor = vec4(vec3(blackOrWhite) * color.a, color.a);\n}\n");
                var k = e1;
                function O(e1, t, r, o, n, s, i, a, l, u) {
                    var c = t.getParameter(t.FRAMEBUFFER_BINDING), r = (t.bindFramebuffer(t.FRAMEBUFFER, r), a === t.RGBA ? 4 : 3), d = s * i * r, h = l === t.UNSIGNED_BYTE ? Uint8Array : Float32Array;
                    if (e1 instanceof h && e1.length === d || (e1 = new h(d)), t.readPixels(o, u ? u - n - i : n, s, i, a, l, e1), t.bindFramebuffer(t.FRAMEBUFFER, c), u) for(var f = Math.floor(i / 2), p = new h(s * r), m = 0; m < f; m++){
                        var y = m * s * 4, g = (i - m - 1) * s * 4;
                        p.set(e1.subarray(y, y + 4 * s)), e1.copyWithin(y, g, g + 4 * s), e1.set(p, g);
                    }
                    return e1;
                }
                function C(e1, t, r, o, n, s, i) {
                    var a = e1.getParameter(e1.FRAMEBUFFER_BINDING), t = (e1.bindFramebuffer(e1.FRAMEBUFFER, t), n === e1.RGBA ? 4 : 3), t = new (s === e1.UNSIGNED_BYTE ? Uint8Array : Float32Array)(t);
                    return e1.readPixels(r, i ? i - o - 1 : o, 1, 1, n, s, t), e1.bindFramebuffer(e1.FRAMEBUFFER, a), Array.from(t);
                }
                g.default.prototype.setAttributes = function(e1, t) {
                    if (void 0 === this._glAttributes) console.log("You are trying to use setAttributes on a p5.Graphics object that does not use a WEBGL renderer.");
                    else {
                        var r = !0;
                        if (void 0 !== t ? (null === this._glAttributes && (this._glAttributes = {}), this._glAttributes[e1] !== t && (this._glAttributes[e1] = t, r = !1)) : e1 instanceof Object && this._glAttributes !== e1 && (this._glAttributes = e1, r = !1), this._renderer.isP3D && !r) {
                            if (!this._setupDone) {
                                for(var o in this._renderer.retainedMode.geometry)if (this._renderer.retainedMode.geometry.hasOwnProperty(o)) return void g.default._friendlyError("Sorry, Could not set the attributes, you need to call setAttributes() before calling the other drawing methods in setup()");
                            }
                            this.push(), this._renderer._resetContext(), this.pop(), this._renderer._curCamera && (this._renderer._curCamera._renderer = this._renderer);
                        }
                    }
                }, g.default.RendererGL = function(e1) {
                    var t = s;
                    if ("function" != typeof e1 && null !== e1) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e1 && e1.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e1 && m(t, e1);
                    var r, n = y(s);
                    function s(e1, t, r, o) {
                        if (this instanceof s) return (e1 = n.call(this, e1, t, r))._setAttributeDefaults(t), e1._initContext(), e1.isP3D = !0, e1.geometryBuilder = void 0, e1.GL = e1.drawingContext, e1._pInst._setProperty("drawingContext", e1.drawingContext), e1._isErasing = !1, e1._clipDepths = [], e1._isClipApplied = !1, e1._stencilTestOn = !1, e1._enableLighting = !1, e1.ambientLightColors = [], e1.mixedAmbientLight = [], e1.mixedSpecularColor = [], e1.specularColors = [
                            1,
                            1,
                            1
                        ], e1.directionalLightDirections = [], e1.directionalLightDiffuseColors = [], e1.directionalLightSpecularColors = [], e1.pointLightPositions = [], e1.pointLightDiffuseColors = [], e1.pointLightSpecularColors = [], e1.spotLightPositions = [], e1.spotLightDirections = [], e1.spotLightDiffuseColors = [], e1.spotLightSpecularColors = [], e1.spotLightAngle = [], e1.spotLightConc = [], e1.activeImageLight = null, e1.diffusedTextures = new Map, e1.specularTextures = new Map, e1.drawMode = l.FILL, e1.curFillColor = e1._cachedFillStyle = [
                            1,
                            1,
                            1,
                            1
                        ], e1.curAmbientColor = e1._cachedFillStyle = [
                            1,
                            1,
                            1,
                            1
                        ], e1.curSpecularColor = e1._cachedFillStyle = [
                            0,
                            0,
                            0,
                            0
                        ], e1.curEmissiveColor = e1._cachedFillStyle = [
                            0,
                            0,
                            0,
                            0
                        ], e1.curStrokeColor = e1._cachedStrokeStyle = [
                            0,
                            0,
                            0,
                            1
                        ], e1.curBlendMode = l.BLEND, e1.preEraseBlend = void 0, e1._cachedBlendMode = void 0, e1.webglVersion === l.WEBGL2 ? e1.blendExt = e1.GL : e1.blendExt = e1.GL.getExtension("EXT_blend_minmax"), e1._isBlending = !1, e1._hasSetAmbient = !1, e1._useSpecularMaterial = !1, e1._useEmissiveMaterial = !1, e1._useNormalMaterial = !1, e1._useShininess = 1, e1._useMetalness = 0, e1._useLineColor = !1, e1._useVertexColor = !1, e1.registerEnabled = new Set, e1._tint = [
                            255,
                            255,
                            255,
                            255
                        ], e1.constantAttenuation = 1, e1.linearAttenuation = 0, e1.quadraticAttenuation = 0, e1.uModelMatrix = new g.default.Matrix, e1.uViewMatrix = new g.default.Matrix, e1.uMVMatrix = new g.default.Matrix, e1.uPMatrix = new g.default.Matrix, e1.uNMatrix = new g.default.Matrix("mat3"), e1.curMatrix = new g.default.Matrix("mat3"), e1._currentNormal = new g.default.Vector(0, 0, 1), e1._curCamera = new g.default.Camera(v(e1)), e1._curCamera._computeCameraDefaultSettings(), e1._curCamera._setDefaultCamera(), e1.filterCamera = new g.default.Camera(v(e1)), e1.filterCamera._computeCameraDefaultSettings(), e1.filterCamera._setDefaultCamera(), e1.prevTouches = [], e1.zoomVelocity = 0, e1.rotateVelocity = new g.default.Vector(0, 0), e1.moveVelocity = new g.default.Vector(0, 0), e1.executeZoom = !1, e1.executeRotateAndMove = !1, e1.specularShader = void 0, e1.sphereMapping = void 0, e1.diffusedShader = void 0, e1._defaultLightShader = void 0, e1._defaultImmediateModeShader = void 0, e1._defaultNormalShader = void 0, e1._defaultColorShader = void 0, e1._defaultPointShader = void 0, e1.userFillShader = void 0, e1.userStrokeShader = void 0, e1.userPointShader = void 0, e1.retainedMode = {
                            geometry: {},
                            buffers: {
                                stroke: [
                                    new g.default.RenderBuffer(4, "lineVertexColors", "lineColorBuffer", "aVertexColor", v(e1)),
                                    new g.default.RenderBuffer(3, "lineVertices", "lineVerticesBuffer", "aPosition", v(e1)),
                                    new g.default.RenderBuffer(3, "lineTangentsIn", "lineTangentsInBuffer", "aTangentIn", v(e1)),
                                    new g.default.RenderBuffer(3, "lineTangentsOut", "lineTangentsOutBuffer", "aTangentOut", v(e1)),
                                    new g.default.RenderBuffer(1, "lineSides", "lineSidesBuffer", "aSide", v(e1))
                                ],
                                fill: [
                                    new g.default.RenderBuffer(3, "vertices", "vertexBuffer", "aPosition", v(e1), e1._vToNArray),
                                    new g.default.RenderBuffer(3, "vertexNormals", "normalBuffer", "aNormal", v(e1), e1._vToNArray),
                                    new g.default.RenderBuffer(4, "vertexColors", "colorBuffer", "aVertexColor", v(e1)),
                                    new g.default.RenderBuffer(3, "vertexAmbients", "ambientBuffer", "aAmbientColor", v(e1)),
                                    new g.default.RenderBuffer(2, "uvs", "uvBuffer", "aTexCoord", v(e1), e1._flatten)
                                ],
                                text: [
                                    new g.default.RenderBuffer(3, "vertices", "vertexBuffer", "aPosition", v(e1), e1._vToNArray),
                                    new g.default.RenderBuffer(2, "uvs", "uvBuffer", "aTexCoord", v(e1), e1._flatten)
                                ]
                            }
                        }, e1.immediateMode = {
                            geometry: new g.default.Geometry,
                            shapeMode: l.TRIANGLE_FAN,
                            contourIndices: [],
                            _bezierVertex: [],
                            _quadraticVertex: [],
                            _curveVertex: [],
                            buffers: {
                                fill: [
                                    new g.default.RenderBuffer(3, "vertices", "vertexBuffer", "aPosition", v(e1), e1._vToNArray),
                                    new g.default.RenderBuffer(3, "vertexNormals", "normalBuffer", "aNormal", v(e1), e1._vToNArray),
                                    new g.default.RenderBuffer(4, "vertexColors", "colorBuffer", "aVertexColor", v(e1)),
                                    new g.default.RenderBuffer(3, "vertexAmbients", "ambientBuffer", "aAmbientColor", v(e1)),
                                    new g.default.RenderBuffer(2, "uvs", "uvBuffer", "aTexCoord", v(e1), e1._flatten)
                                ],
                                stroke: [
                                    new g.default.RenderBuffer(4, "lineVertexColors", "lineColorBuffer", "aVertexColor", v(e1)),
                                    new g.default.RenderBuffer(3, "lineVertices", "lineVerticesBuffer", "aPosition", v(e1)),
                                    new g.default.RenderBuffer(3, "lineTangentsIn", "lineTangentsInBuffer", "aTangentIn", v(e1)),
                                    new g.default.RenderBuffer(3, "lineTangentsOut", "lineTangentsOutBuffer", "aTangentOut", v(e1)),
                                    new g.default.RenderBuffer(1, "lineSides", "lineSidesBuffer", "aSide", v(e1))
                                ],
                                point: [
                                    new g.default.RenderBuffer(3, "vertices", "pointVertexBuffer", "aPosition", v(e1), e1._vToNArray),
                                    new g.default.RenderBuffer(4, "vertexStrokeColors", "pointColorBuffer", "aVertexColor", v(e1))
                                ]
                            }
                        }, e1.curStrokeWeight = 1, e1.pointSize = e1.curStrokeWeight, e1.curStrokeCap = l.ROUND, e1.curStrokeJoin = l.ROUND, e1.textures = new Map, e1.framebuffers = new Set, e1.activeFramebuffers = [], e1.filterShader = void 0, e1.filterLayer = void 0, e1.filterLayerTemp = void 0, e1.defaultFilterShaders = {}, e1.textureMode = l.IMAGE, e1.textureWrapX = l.CLAMP, e1.textureWrapY = l.CLAMP, e1._tex = null, e1._curveTightness = 6, e1._lookUpTableBezier = [], e1._lookUpTableQuadratic = [], e1._lutBezierDetail = 0, e1._lutQuadraticDetail = 0, e1.isProcessingVertices = !1, e1._tessy = e1._initTessy(), e1.fontInfos = {}, e1._curShader = void 0, e1._pInst instanceof g.default.Graphics || !e1._pInst || "function" != typeof e1._pInst.registerMethod || e1._pInst.registerMethod("remove", e1.remove.bind(v(e1))), e1;
                        throw new TypeError("Cannot call a class as a function");
                    }
                    return t = s, e1 = [
                        {
                            key: "remove",
                            value: function() {
                                var e1 = [
                                    this._defaultLightShader,
                                    this._defaultImmediateModeShader,
                                    this._defaultNormalShader,
                                    this._defaultColorShader,
                                    this._defaultPointShader,
                                    this.userFillShader,
                                    this.userStrokeShader,
                                    this.userPointShader,
                                    this._curShader,
                                    this.specularShader,
                                    this.diffusedShader,
                                    this.filterShader
                                ];
                                if (this.defaultFilterShaders) for(var t in this.defaultFilterShaders)e1.push(this.defaultFilterShaders[t]);
                                for(var r = 0, o = e1; r < o.length; r++){
                                    var n = o[r];
                                    n && "function" == typeof n.remove && n.remove();
                                }
                                if (this.textures) {
                                    var s = !0, i = !1, a = void 0;
                                    try {
                                        for(var l, u = this.textures.values()[Symbol.iterator](); !(s = (l = u.next()).done); s = !0){
                                            var c = l.value;
                                            c && "function" == typeof c.remove && c.remove();
                                        }
                                    } catch (e1) {
                                        i = !0, a = e1;
                                    } finally{
                                        try {
                                            s || null == u.return || u.return();
                                        } finally{
                                            if (i) throw a;
                                        }
                                    }
                                    this.textures.clear();
                                }
                                if (this.framebuffers) {
                                    var d = !0, i = !1, a = void 0;
                                    try {
                                        for(var h, f = this.framebuffers[Symbol.iterator](); !(d = (h = f.next()).done); d = !0){
                                            var p = h.value;
                                            p && "function" == typeof p.remove && p.remove();
                                        }
                                    } catch (e1) {
                                        i = !0, a = e1;
                                    } finally{
                                        try {
                                            d || null == f.return || f.return();
                                        } finally{
                                            if (i) throw a;
                                        }
                                    }
                                    this.framebuffers.clear();
                                }
                                if (this.diffusedTextures) {
                                    var m = !0, i = !1, a = void 0;
                                    try {
                                        for(var y, g = this.diffusedTextures.values()[Symbol.iterator](); !(m = (y = g.next()).done); m = !0){
                                            var v = y.value;
                                            v && "function" == typeof v.remove && v.remove();
                                        }
                                    } catch (e1) {
                                        i = !0, a = e1;
                                    } finally{
                                        try {
                                            m || null == g.return || g.return();
                                        } finally{
                                            if (i) throw a;
                                        }
                                    }
                                    this.diffusedTextures.clear();
                                }
                                if (this.specularTextures) {
                                    var b = !0, i = !1, a = void 0;
                                    try {
                                        for(var _, j = this.specularTextures.values()[Symbol.iterator](); !(b = (_ = j.next()).done); b = !0){
                                            var x = _.value;
                                            x && "function" == typeof x.remove && x.remove();
                                        }
                                    } catch (e1) {
                                        i = !0, a = e1;
                                    } finally{
                                        try {
                                            b || null == j.return || j.return();
                                        } finally{
                                            if (i) throw a;
                                        }
                                    }
                                    this.specularTextures.clear();
                                }
                                if (this._emptyTexture && ("function" == typeof this._emptyTexture.remove && this._emptyTexture.remove(), this._emptyTexture = null), this.retainedMode && this.retainedMode.geometry) for(var w in this.retainedMode.geometry)this._freeBuffers(w);
                                this.filterLayer && "function" == typeof this.filterLayer.remove && (this.filterLayer.remove(), this.filterLayer = void 0), this.filterLayerTemp && "function" == typeof this.filterLayerTemp.remove && (this.filterLayerTemp.remove(), this.filterLayerTemp = void 0), this._defaultLightShader = void 0, this._defaultImmediateModeShader = void 0, this._defaultNormalShader = void 0, this._defaultColorShader = void 0, this._defaultPointShader = void 0, this.userFillShader = void 0, this.userStrokeShader = void 0, this.userPointShader = void 0, this._curShader = void 0, this.specularShader = void 0, this.diffusedShader = void 0, this.filterShader = void 0, this.defaultFilterShaders = {};
                            }
                        },
                        {
                            key: "beginGeometry",
                            value: function() {
                                if (this.geometryBuilder) throw new Error("It looks like `beginGeometry()` is being called while another p5.Geometry is already being build.");
                                this.geometryBuilder = new a.default(this);
                            }
                        },
                        {
                            key: "endGeometry",
                            value: function() {
                                var e1;
                                if (this.geometryBuilder) return e1 = this.geometryBuilder.finish(), this.geometryBuilder = void 0, e1;
                                throw new Error("Make sure you call beginGeometry() before endGeometry()!");
                            }
                        },
                        {
                            key: "buildGeometry",
                            value: function(e1) {
                                return this.beginGeometry(), e1(), this.endGeometry();
                            }
                        },
                        {
                            key: "_setAttributeDefaults",
                            value: function(e1) {
                                var t = {
                                    alpha: !0,
                                    depth: !0,
                                    stencil: !0,
                                    antialias: navigator.userAgent.toLowerCase().includes("safari"),
                                    premultipliedAlpha: !0,
                                    preserveDrawingBuffer: !0,
                                    perPixelLighting: !0,
                                    version: 2
                                };
                                null === e1._glAttributes ? e1._glAttributes = t : e1._glAttributes = Object.assign(t, e1._glAttributes);
                            }
                        },
                        {
                            key: "_initContext",
                            value: function() {
                                if (1 !== this._pInst._glAttributes.version && (this.drawingContext = this.canvas.getContext("webgl2", this._pInst._glAttributes)), this.webglVersion = this.drawingContext ? l.WEBGL2 : l.WEBGL, this._pInst._setProperty("webglVersion", this.webglVersion), this.drawingContext || (this.drawingContext = this.canvas.getContext("webgl", this._pInst._glAttributes) || this.canvas.getContext("experimental-webgl", this._pInst._glAttributes)), null === this.drawingContext) throw new Error("Error creating webgl context");
                                var e1 = this.drawingContext;
                                e1.enable(e1.DEPTH_TEST), e1.depthFunc(e1.LEQUAL), e1.viewport(0, 0, e1.drawingBufferWidth, e1.drawingBufferHeight), e1.pixelStorei(e1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0), this._viewport = this.drawingContext.getParameter(this.drawingContext.VIEWPORT);
                            }
                        },
                        {
                            key: "_getParam",
                            value: function() {
                                var e1 = this.drawingContext;
                                return e1.getParameter(e1.MAX_TEXTURE_SIZE);
                            }
                        },
                        {
                            key: "_adjustDimensions",
                            value: function(e1, t) {
                                this._maxTextureSize || (this._maxTextureSize = this._getParam());
                                var r = this._maxTextureSize, r = (g.default.prototype._maxAllowedPixelDimensions, Math.floor(r / this.pixelDensity())), o = Math.min(e1, r), r = Math.min(t, r);
                                return o === e1 && r === t || console.warn("Warning: The requested width/height exceeds hardware limits. " + "Adjusting dimensions to width: ".concat(o, ", height: ").concat(r, ".")), {
                                    adjustedWidth: o,
                                    adjustedHeight: r
                                };
                            }
                        },
                        {
                            key: "_resetContext",
                            value: function(e1, t) {
                                var r, o = this.width, n = this.height, s = this.canvas.id, i = this._pInst instanceof g.default.Graphics, s = (i ? ((r = this._pInst).canvas.parentNode.removeChild(r.canvas), r.canvas = document.createElement("canvas"), (r._pInst._userNode || document.body).appendChild(r.canvas), g.default.Element.call(r, r.canvas, r._pInst), r.width = o, r.height = n) : ((r = this.canvas) && r.parentNode.removeChild(r), (r = document.createElement("canvas")).id = s, (this._pInst._userNode || document.body).appendChild(r), this._pInst.canvas = r, this.canvas = r), new g.default.RendererGL(this._pInst.canvas, this._pInst, !i));
                                this._pInst._setProperty("_renderer", s), s.resize(o, n), s._applyDefaults(), i || this._pInst._elements.push(s), "function" == typeof t && setTimeout(function() {
                                    t.apply(window._renderer, e1);
                                }, 0);
                            }
                        },
                        {
                            key: "_update",
                            value: function() {
                                this.uModelMatrix.reset(), this.uViewMatrix.set(this._curCamera.cameraMatrix), this.ambientLightColors.length = 0, this.specularColors = [
                                    1,
                                    1,
                                    1
                                ], this.directionalLightDirections.length = 0, this.directionalLightDiffuseColors.length = 0, this.directionalLightSpecularColors.length = 0, this.pointLightPositions.length = 0, this.pointLightDiffuseColors.length = 0, this.pointLightSpecularColors.length = 0, this.spotLightPositions.length = 0, this.spotLightDirections.length = 0, this.spotLightDiffuseColors.length = 0, this.spotLightSpecularColors.length = 0, this.spotLightAngle.length = 0, this.spotLightConc.length = 0, this._enableLighting = !1, this._tint = [
                                    255,
                                    255,
                                    255,
                                    255
                                ], this.GL.clearStencil(0), this.GL.clear(this.GL.DEPTH_BUFFER_BIT | this.GL.STENCIL_BUFFER_BIT), this.GL.disable(this.GL.STENCIL_TEST);
                            }
                        },
                        {
                            key: "background",
                            value: function() {
                                var e1, t, r = arguments.length <= 0 ? void 0 : arguments[0], o = r instanceof g.default.Image || r instanceof g.default.Graphics || "undefined" != typeof HTMLImageElement && r instanceof HTMLImageElement || "undefined" != typeof HTMLVideoElement && r instanceof HTMLVideoElement || void 0 !== g.default.MediaElement && r instanceof g.default.MediaElement;
                                0 < arguments.length && o ? (this._pInst.clear(), this._pInst.push(), this._pInst.resetMatrix(), this._pInst.imageMode(this._pInst.CENTER), this._pInst.image(r, 0, 0, this._pInst.width, this._pInst.height), this._pInst.pop()) : (o = (r = (o = this._pInst).color.apply(o, arguments)).levels[0] / 255, e1 = r.levels[1] / 255, t = r.levels[2] / 255, r = r.levels[3] / 255, this.clear(o, e1, t, r));
                            }
                        },
                        {
                            key: "fill",
                            value: function(e1, t, r, o) {
                                var n = g.default.prototype.color.apply(this._pInst, arguments);
                                this.curFillColor = n._array, this.drawMode = l.FILL, this._useNormalMaterial = !1, this._tex = null;
                            }
                        },
                        {
                            key: "stroke",
                            value: function(e1, t, r, o) {
                                var n = g.default.prototype.color.apply(this._pInst, arguments);
                                this.curStrokeColor = n._array;
                            }
                        },
                        {
                            key: "strokeCap",
                            value: function(e1) {
                                this.curStrokeCap = e1;
                            }
                        },
                        {
                            key: "strokeJoin",
                            value: function(e1) {
                                this.curStrokeJoin = e1;
                            }
                        },
                        {
                            key: "getFilterLayer",
                            value: function() {
                                return this.filterLayer || (this.filterLayer = this._pInst.createFramebuffer()), this.filterLayer;
                            }
                        },
                        {
                            key: "getFilterLayerTemp",
                            value: function() {
                                return this.filterLayerTemp || (this.filterLayerTemp = this._pInst.createFramebuffer()), this.filterLayerTemp;
                            }
                        },
                        {
                            key: "matchSize",
                            value: function(e1, t) {
                                e1.width === t.width && e1.height === t.height || e1.resize(t.width, t.height), e1.pixelDensity() !== t.pixelDensity() && e1.pixelDensity(t.pixelDensity());
                            }
                        },
                        {
                            key: "filter",
                            value: function() {
                                var e1, t, r = this, o = this.getFilterLayer(), n = void 0, s = void 0, i = ("string" == typeof (arguments.length <= 0 ? void 0 : arguments[0]) ? (s = arguments.length <= 0 ? void 0 : arguments[0], _(e1 = {}, l.BLUR, 3), _(e1, l.POSTERIZE, 4), _(e1, l.THRESHOLD, .5), n = s in e1 && void 0 === (arguments.length <= 1 ? void 0 : arguments[1]) ? e1[s] : arguments.length <= 1 ? void 0 : arguments[1], s in this.defaultFilterShaders || (this.defaultFilterShaders[s] = new g.default.Shader(o._renderer, "uniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\n\nattribute vec3 aPosition;\n// texcoords only come from p5 to vertex shader\n// so pass texcoords on to the fragment shader in a varying variable\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\n\nvoid main() {\n  // transferring texcoords for the frag shader\n  vTexCoord = aTexCoord;\n\n  // copy position with a fourth coordinate for projection (1.0 is normal)\n  vec4 positionVec4 = vec4(aPosition, 1.0);\n\n  gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n}\n", k[s])), this.filterShader = this.defaultFilterShaders[s]) : this.filterShader = arguments.length <= 0 ? void 0 : arguments[0], this.activeFramebuffer() || this), a = (this.matchSize(o, i), o.draw(function() {
                                    return r._pInst.clear();
                                }), [
                                    1 / (i.width * i.pixelDensity()),
                                    1 / (i.height * i.pixelDensity())
                                ]);
                                s === l.BLUR ? (t = this.getFilterLayerTemp(), this.matchSize(t, i), this._pInst.push(), this._pInst.noStroke(), this._pInst.blendMode(l.BLEND), this._pInst.shader(this.filterShader), this.filterShader.setUniform("texelSize", a), this.filterShader.setUniform("canvasSize", [
                                    i.width,
                                    i.height
                                ]), this.filterShader.setUniform("radius", Math.max(1, n)), t.draw(function() {
                                    r.filterShader.setUniform("direction", [
                                        1,
                                        0
                                    ]), r.filterShader.setUniform("tex0", i), r._pInst.clear(), r._pInst.shader(r.filterShader), r._pInst.noLights(), r._pInst.plane(i.width, i.height);
                                }), o.draw(function() {
                                    r.filterShader.setUniform("direction", [
                                        0,
                                        1
                                    ]), r.filterShader.setUniform("tex0", t), r._pInst.clear(), r._pInst.shader(r.filterShader), r._pInst.noLights(), r._pInst.plane(i.width, i.height);
                                }), this._pInst.pop()) : o.draw(function() {
                                    r._pInst.noStroke(), r._pInst.blendMode(l.BLEND), r._pInst.shader(r.filterShader), r.filterShader.setUniform("tex0", i), r.filterShader.setUniform("texelSize", a), r.filterShader.setUniform("canvasSize", [
                                        i.width,
                                        i.height
                                    ]), r.filterShader.setUniform("filterParameter", n), r._pInst.noLights(), r._pInst.plane(i.width, i.height);
                                }), this._pInst.push(), this._pInst.noStroke(), this.clear(), this._pInst.push(), this._pInst.imageMode(l.CORNER), this._pInst.blendMode(l.BLEND), i.filterCamera._resize(), this._pInst.setCamera(i.filterCamera), this._pInst.resetMatrix(), this._pInst.image(o, -i.width / 2, -i.height / 2, i.width, i.height), this._pInst.clearDepth(), this._pInst.pop(), this._pInst.pop();
                            }
                        },
                        {
                            key: "pixelDensity",
                            value: function(e1) {
                                return e1 ? this._pInst.pixelDensity(e1) : this._pInst.pixelDensity();
                            }
                        },
                        {
                            key: "blendMode",
                            value: function(e1) {
                                e1 === l.DARKEST || e1 === l.LIGHTEST || e1 === l.ADD || e1 === l.BLEND || e1 === l.SUBTRACT || e1 === l.SCREEN || e1 === l.EXCLUSION || e1 === l.REPLACE || e1 === l.MULTIPLY || e1 === l.REMOVE ? this.curBlendMode = e1 : e1 !== l.BURN && e1 !== l.OVERLAY && e1 !== l.HARD_LIGHT && e1 !== l.SOFT_LIGHT && e1 !== l.DODGE || console.warn("BURN, OVERLAY, HARD_LIGHT, SOFT_LIGHT, and DODGE only work for blendMode in 2D mode.");
                            }
                        },
                        {
                            key: "erase",
                            value: function(e1, t) {
                                this._isErasing || (this.preEraseBlend = this.curBlendMode, this._isErasing = !0, this.blendMode(l.REMOVE), this._cachedFillStyle = this.curFillColor.slice(), this.curFillColor = [
                                    1,
                                    1,
                                    1,
                                    e1 / 255
                                ], this._cachedStrokeStyle = this.curStrokeColor.slice(), this.curStrokeColor = [
                                    1,
                                    1,
                                    1,
                                    t / 255
                                ]);
                            }
                        },
                        {
                            key: "noErase",
                            value: function() {
                                this._isErasing && (this.curFillColor = this._cachedFillStyle.slice(), this.curStrokeColor = this._cachedStrokeStyle.slice(), this.curBlendMode = this.preEraseBlend, this.blendMode(this.preEraseBlend), this._isErasing = !1, this._applyBlendMode());
                            }
                        },
                        {
                            key: "drawTarget",
                            value: function() {
                                return this.activeFramebuffers[this.activeFramebuffers.length - 1] || this;
                            }
                        },
                        {
                            key: "beginClip",
                            value: function() {
                                var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {}, e1 = (p(b(s.prototype), "beginClip", this).call(this, e1), this.drawTarget()._isClipApplied = !0, this.GL);
                                e1.clearStencil(0), e1.clear(e1.STENCIL_BUFFER_BIT), e1.enable(e1.STENCIL_TEST), this._stencilTestOn = !0, e1.stencilFunc(e1.ALWAYS, 1, 255), e1.stencilOp(e1.KEEP, e1.KEEP, e1.REPLACE), e1.disable(e1.DEPTH_TEST), this._pInst.push(), this._pInst.resetShader(), this._doFill && this._pInst.fill(0, 0), this._doStroke && this._pInst.stroke(0, 0);
                            }
                        },
                        {
                            key: "endClip",
                            value: function() {
                                this._pInst.pop();
                                var e1 = this.GL;
                                e1.stencilOp(e1.KEEP, e1.KEEP, e1.KEEP), e1.stencilFunc(this._clipInvert ? e1.EQUAL : e1.NOTEQUAL, 0, 255), e1.enable(e1.DEPTH_TEST), this._clipDepths.push(this._pushPopDepth), p(b(s.prototype), "endClip", this).call(this);
                            }
                        },
                        {
                            key: "_clearClip",
                            value: function() {
                                this.GL.clearStencil(1), this.GL.clear(this.GL.STENCIL_BUFFER_BIT), 0 < this._clipDepths.length && this._clipDepths.pop(), this.drawTarget()._isClipApplied = !1;
                            }
                        },
                        {
                            key: "strokeWeight",
                            value: function(e1) {
                                this.curStrokeWeight !== e1 && (this.pointSize = e1, this.curStrokeWeight = e1);
                            }
                        },
                        {
                            key: "_getPixel",
                            value: function(e1, t) {
                                var r = this.GL;
                                return C(r, null, e1, t, r.RGBA, r.UNSIGNED_BYTE, this._pInst.height * this._pInst.pixelDensity());
                            }
                        },
                        {
                            key: "loadPixels",
                            value: function() {
                                var e1, t, r = this._pixelsState;
                                !0 !== this._pInst._glAttributes.preserveDrawingBuffer ? console.log("loadPixels only works in WebGL when preserveDrawingBuffer is true.") : (e1 = this._pInst._pixelDensity, t = this.GL, r._setProperty("pixels", O(r.pixels, t, null, 0, 0, this.width * e1, this.height * e1, t.RGBA, t.UNSIGNED_BYTE, this.height * e1)));
                            }
                        },
                        {
                            key: "updatePixels",
                            value: function() {
                                var e1 = this._getTempFramebuffer();
                                e1.pixels = this._pixelsState.pixels, e1.updatePixels(), this._pInst.push(), this._pInst.resetMatrix(), this._pInst.clear(), this._pInst.imageMode(l.CENTER), this._pInst.image(e1, 0, 0), this._pInst.pop(), this.GL.clearDepth(1), this.GL.clear(this.GL.DEPTH_BUFFER_BIT);
                            }
                        },
                        {
                            key: "_getTempFramebuffer",
                            value: function() {
                                return this._tempFramebuffer || (this._tempFramebuffer = this._pInst.createFramebuffer({
                                    format: l.UNSIGNED_BYTE,
                                    useDepth: this._pInst._glAttributes.depth,
                                    depthFormat: l.UNSIGNED_INT,
                                    antialias: this._pInst._glAttributes.antialias
                                })), this._tempFramebuffer;
                            }
                        },
                        {
                            key: "geometryInHash",
                            value: function(e1) {
                                return void 0 !== this.retainedMode.geometry[e1];
                            }
                        },
                        {
                            key: "viewport",
                            value: function(e1, t) {
                                this._viewport = [
                                    0,
                                    0,
                                    e1,
                                    t
                                ], this.GL.viewport(0, 0, e1, t);
                            }
                        },
                        {
                            key: "resize",
                            value: function(t, r) {
                                g.default.Renderer.prototype.resize.call(this, t, r), this._origViewport = {
                                    width: this.GL.drawingBufferWidth,
                                    height: this.GL.drawingBufferHeight
                                }, this.viewport(this._origViewport.width, this._origViewport.height), this._curCamera._resize();
                                var t = this._pixelsState, e1 = (void 0 !== t.pixels && t._setProperty("pixels", new Uint8Array(this.GL.drawingBufferWidth * this.GL.drawingBufferHeight * 4)), !0), r = !1, t = void 0;
                                try {
                                    for(var o, n = this.framebuffers[Symbol.iterator](); !(e1 = (o = n.next()).done); e1 = !0)o.value._canvasSizeChanged();
                                } catch (e1) {
                                    r = !0, t = e1;
                                } finally{
                                    try {
                                        e1 || null == n.return || n.return();
                                    } finally{
                                        if (r) throw t;
                                    }
                                }
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                var e1 = (arguments.length <= 0 ? void 0 : arguments[0]) || 0, t = (arguments.length <= 1 ? void 0 : arguments[1]) || 0, r = (arguments.length <= 2 ? void 0 : arguments[2]) || 0, o = (arguments.length <= 3 ? void 0 : arguments[3]) || 0, n = this.activeFramebuffer();
                                n && n.format === l.UNSIGNED_BYTE && !n.antialias && 0 === o && (o = 1e-10), this.GL.clearColor(e1 * o, t * o, r * o, o), this.GL.clearDepth(1), this.GL.clear(this.GL.COLOR_BUFFER_BIT | this.GL.DEPTH_BUFFER_BIT);
                            }
                        },
                        {
                            key: "clearDepth",
                            value: function() {
                                this.GL.clearDepth(0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 1), this.GL.clear(this.GL.DEPTH_BUFFER_BIT);
                            }
                        },
                        {
                            key: "applyMatrix",
                            value: function(e1, t, r, o, n, s) {
                                16 === arguments.length ? g.default.Matrix.prototype.apply.apply(this.uModelMatrix, arguments) : this.uModelMatrix.apply([
                                    e1,
                                    t,
                                    0,
                                    0,
                                    r,
                                    o,
                                    0,
                                    0,
                                    0,
                                    0,
                                    1,
                                    0,
                                    n,
                                    s,
                                    0,
                                    1
                                ]);
                            }
                        },
                        {
                            key: "translate",
                            value: function(e1, t, r) {
                                return e1 instanceof g.default.Vector && (r = e1.z, t = e1.y, e1 = e1.x), this.uModelMatrix.translate([
                                    e1,
                                    t,
                                    r
                                ]), this;
                            }
                        },
                        {
                            key: "scale",
                            value: function(e1, t, r) {
                                return this.uModelMatrix.scale(e1, t, r), this;
                            }
                        },
                        {
                            key: "rotate",
                            value: function(e1, t) {
                                return void 0 === t ? this.rotateZ(e1) : (g.default.Matrix.prototype.rotate.apply(this.uModelMatrix, arguments), this);
                            }
                        },
                        {
                            key: "rotateX",
                            value: function(e1) {
                                return this.rotate(e1, 1, 0, 0), this;
                            }
                        },
                        {
                            key: "rotateY",
                            value: function(e1) {
                                return this.rotate(e1, 0, 1, 0), this;
                            }
                        },
                        {
                            key: "rotateZ",
                            value: function(e1) {
                                return this.rotate(e1, 0, 0, 1), this;
                            }
                        },
                        {
                            key: "push",
                            value: function() {
                                var e1 = g.default.Renderer.prototype.push.apply(this), t = e1.properties;
                                return t.uModelMatrix = this.uModelMatrix.copy(), t.uViewMatrix = this.uViewMatrix.copy(), t.uPMatrix = this.uPMatrix.copy(), t._curCamera = this._curCamera, this._curCamera = this._curCamera.copy(), t.ambientLightColors = this.ambientLightColors.slice(), t.specularColors = this.specularColors.slice(), t.directionalLightDirections = this.directionalLightDirections.slice(), t.directionalLightDiffuseColors = this.directionalLightDiffuseColors.slice(), t.directionalLightSpecularColors = this.directionalLightSpecularColors.slice(), t.pointLightPositions = this.pointLightPositions.slice(), t.pointLightDiffuseColors = this.pointLightDiffuseColors.slice(), t.pointLightSpecularColors = this.pointLightSpecularColors.slice(), t.spotLightPositions = this.spotLightPositions.slice(), t.spotLightDirections = this.spotLightDirections.slice(), t.spotLightDiffuseColors = this.spotLightDiffuseColors.slice(), t.spotLightSpecularColors = this.spotLightSpecularColors.slice(), t.spotLightAngle = this.spotLightAngle.slice(), t.spotLightConc = this.spotLightConc.slice(), t.userFillShader = this.userFillShader, t.userStrokeShader = this.userStrokeShader, t.userPointShader = this.userPointShader, t.pointSize = this.pointSize, t.curStrokeWeight = this.curStrokeWeight, t.curStrokeColor = this.curStrokeColor, t.curFillColor = this.curFillColor, t.curAmbientColor = this.curAmbientColor, t.curSpecularColor = this.curSpecularColor, t.curEmissiveColor = this.curEmissiveColor, t._hasSetAmbient = this._hasSetAmbient, t._useSpecularMaterial = this._useSpecularMaterial, t._useEmissiveMaterial = this._useEmissiveMaterial, t._useShininess = this._useShininess, t._useMetalness = this._useMetalness, t.constantAttenuation = this.constantAttenuation, t.linearAttenuation = this.linearAttenuation, t.quadraticAttenuation = this.quadraticAttenuation, t._enableLighting = this._enableLighting, t._useNormalMaterial = this._useNormalMaterial, t._tex = this._tex, t.drawMode = this.drawMode, t._currentNormal = this._currentNormal, t.curBlendMode = this.curBlendMode, t.activeImageLight = this.activeImageLight, t.textureMode = this.textureMode, e1;
                            }
                        },
                        {
                            key: "pop",
                            value: function() {
                                var e1;
                                0 < this._clipDepths.length && this._pushPopDepth === this._clipDepths[this._clipDepths.length - 1] && this._clearClip();
                                for(var t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                                (e1 = p(b(s.prototype), "pop", this)).call.apply(e1, [
                                    this
                                ].concat(r)), this._applyStencilTestIfClipping();
                            }
                        },
                        {
                            key: "_applyStencilTestIfClipping",
                            value: function() {
                                var e1 = this.drawTarget();
                                e1._isClipApplied !== this._stencilTestOn && (e1._isClipApplied ? (this.GL.enable(this.GL.STENCIL_TEST), this._stencilTestOn = !0) : (this.GL.disable(this.GL.STENCIL_TEST), this._stencilTestOn = !1));
                            }
                        },
                        {
                            key: "resetMatrix",
                            value: function() {
                                return this.uModelMatrix.reset(), this.uViewMatrix.set(this._curCamera.cameraMatrix), this;
                            }
                        },
                        {
                            key: "_getImmediateStrokeShader",
                            value: function() {
                                var e1 = this.userStrokeShader;
                                return e1 && e1.isStrokeShader() ? e1 : this._getLineShader();
                            }
                        },
                        {
                            key: "_getRetainedStrokeShader",
                            value: function() {
                                return this._getImmediateStrokeShader();
                            }
                        },
                        {
                            key: "_getSphereMapping",
                            value: function(e1) {
                                return this.sphereMapping || (this.sphereMapping = this._pInst.createFilterShader(M)), this.uNMatrix.inverseTranspose(this.uViewMatrix), this.uNMatrix.invert3x3(this.uNMatrix), this.sphereMapping.setUniform("uFovY", this._curCamera.cameraFOV), this.sphereMapping.setUniform("uAspect", this._curCamera.aspectRatio), this.sphereMapping.setUniform("uNewNormalMatrix", this.uNMatrix.mat3), this.sphereMapping.setUniform("uSampler", e1), this.sphereMapping;
                            }
                        },
                        {
                            key: "_getImmediateFillShader",
                            value: function() {
                                var e1 = this.userFillShader;
                                if (this._useNormalMaterial && (!e1 || !e1.isNormalShader())) return this._getNormalShader();
                                if (this._enableLighting) {
                                    if (!e1 || !e1.isLightShader()) return this._getLightShader();
                                } else if (this._tex) {
                                    if (!e1 || !e1.isTextureShader()) return this._getLightShader();
                                } else if (!e1) return this._getImmediateModeShader();
                                return e1;
                            }
                        },
                        {
                            key: "_getRetainedFillShader",
                            value: function() {
                                if (this._useNormalMaterial) return this._getNormalShader();
                                var e1 = this.userFillShader;
                                if (this._enableLighting) {
                                    if (!e1 || !e1.isLightShader()) return this._getLightShader();
                                } else if (this._tex) {
                                    if (!e1 || !e1.isTextureShader()) return this._getLightShader();
                                } else if (!e1) return this._getColorShader();
                                return e1;
                            }
                        },
                        {
                            key: "_getImmediatePointShader",
                            value: function() {
                                var e1 = this.userPointShader;
                                return e1 && e1.isPointShader() ? e1 : this._getPointShader();
                            }
                        },
                        {
                            key: "_getRetainedLineShader",
                            value: function() {
                                return this._getImmediateLineShader();
                            }
                        },
                        {
                            key: "baseMaterialShader",
                            value: function() {
                                if (this._pInst._glAttributes.perPixelLighting) return this._getLightShader();
                                throw new Error("The material shader does not support hooks without perPixelLighting. Try turning it back on.");
                            }
                        },
                        {
                            key: "_getLightShader",
                            value: function() {
                                return this._defaultLightShader || (this._pInst._glAttributes.perPixelLighting ? this._defaultLightShader = new g.default.Shader(this, this._webGL2CompatibilityPrefix("vert", "highp") + E.phongVert, this._webGL2CompatibilityPrefix("frag", "highp") + E.phongFrag, {
                                    vertex: {
                                        "void beforeVertex": "() {}",
                                        "vec3 getLocalPosition": "(vec3 position) { return position; }",
                                        "vec3 getWorldPosition": "(vec3 position) { return position; }",
                                        "vec3 getLocalNormal": "(vec3 normal) { return normal; }",
                                        "vec3 getWorldNormal": "(vec3 normal) { return normal; }",
                                        "vec2 getUV": "(vec2 uv) { return uv; }",
                                        "vec4 getVertexColor": "(vec4 color) { return color; }",
                                        "void afterVertex": "() {}"
                                    },
                                    fragment: {
                                        "void beforeFragment": "() {}",
                                        "Inputs getPixelInputs": "(Inputs inputs) { return inputs; }",
                                        "vec4 combineColors": "(ColorComponents components) {\n                vec4 color = vec4(0.);\n                color.rgb += components.diffuse * components.baseColor;\n                color.rgb += components.ambient * components.ambientColor;\n                color.rgb += components.specular * components.specularColor;\n                color.rgb += components.emissive;\n                color.a = components.opacity;\n                return color;\n              }",
                                        "vec4 getFinalColor": "(vec4 color) { return color; }",
                                        "void afterFragment": "() {}"
                                    }
                                }) : this._defaultLightShader = new g.default.Shader(this, this._webGL2CompatibilityPrefix("vert", "highp") + E.lightVert, this._webGL2CompatibilityPrefix("frag", "highp") + E.lightTextureFrag)), this._defaultLightShader;
                            }
                        },
                        {
                            key: "_getImmediateModeShader",
                            value: function() {
                                return this._defaultImmediateModeShader || (this._defaultImmediateModeShader = new g.default.Shader(this, this._webGL2CompatibilityPrefix("vert", "mediump") + E.immediateVert, this._webGL2CompatibilityPrefix("frag", "mediump") + E.vertexColorFrag)), this._defaultImmediateModeShader;
                            }
                        },
                        {
                            key: "baseNormalShader",
                            value: function() {
                                return this._getNormalShader();
                            }
                        },
                        {
                            key: "_getNormalShader",
                            value: function() {
                                return this._defaultNormalShader || (this._defaultNormalShader = new g.default.Shader(this, this._webGL2CompatibilityPrefix("vert", "mediump") + E.normalVert, this._webGL2CompatibilityPrefix("frag", "mediump") + E.normalFrag, {
                                    vertex: {
                                        "void beforeVertex": "() {}",
                                        "vec3 getLocalPosition": "(vec3 position) { return position; }",
                                        "vec3 getWorldPosition": "(vec3 position) { return position; }",
                                        "vec3 getLocalNormal": "(vec3 normal) { return normal; }",
                                        "vec3 getWorldNormal": "(vec3 normal) { return normal; }",
                                        "vec2 getUV": "(vec2 uv) { return uv; }",
                                        "vec4 getVertexColor": "(vec4 color) { return color; }",
                                        "void afterVertex": "() {}"
                                    },
                                    fragment: {
                                        "void beforeFragment": "() {}",
                                        "vec4 getFinalColor": "(vec4 color) { return color; }",
                                        "void afterFragment": "() {}"
                                    }
                                })), this._defaultNormalShader;
                            }
                        },
                        {
                            key: "baseColorShader",
                            value: function() {
                                return this._getColorShader();
                            }
                        },
                        {
                            key: "_getColorShader",
                            value: function() {
                                return this._defaultColorShader || (this._defaultColorShader = new g.default.Shader(this, this._webGL2CompatibilityPrefix("vert", "mediump") + E.normalVert, this._webGL2CompatibilityPrefix("frag", "mediump") + E.basicFrag, {
                                    vertex: {
                                        "void beforeVertex": "() {}",
                                        "vec3 getLocalPosition": "(vec3 position) { return position; }",
                                        "vec3 getWorldPosition": "(vec3 position) { return position; }",
                                        "vec3 getLocalNormal": "(vec3 normal) { return normal; }",
                                        "vec3 getWorldNormal": "(vec3 normal) { return normal; }",
                                        "vec2 getUV": "(vec2 uv) { return uv; }",
                                        "vec4 getVertexColor": "(vec4 color) { return color; }",
                                        "void afterVertex": "() {}"
                                    },
                                    fragment: {
                                        "void beforeFragment": "() {}",
                                        "vec4 getFinalColor": "(vec4 color) { return color; }",
                                        "void afterFragment": "() {}"
                                    }
                                })), this._defaultColorShader;
                            }
                        },
                        {
                            key: "pointShader",
                            value: function() {
                                return this._getPointShader();
                            }
                        },
                        {
                            key: "_getPointShader",
                            value: function() {
                                return this._defaultPointShader || (this._defaultPointShader = new g.default.Shader(this, this._webGL2CompatibilityPrefix("vert", "mediump") + E.pointVert, this._webGL2CompatibilityPrefix("frag", "mediump") + E.pointFrag, {
                                    vertex: {
                                        "void beforeVertex": "() {}",
                                        "vec3 getLocalPosition": "(vec3 position) { return position; }",
                                        "vec3 getWorldPosition": "(vec3 position) { return position; }",
                                        "float getPointSize": "(float size) { return size; }",
                                        "vec4 getVertexColor": "(vec4 color) { return color; }",
                                        "void afterVertex": "() {}"
                                    },
                                    fragment: {
                                        "void beforeFragment": "() {}",
                                        "vec4 getFinalColor": "(vec4 color) { return color; }",
                                        "bool shouldDiscard": "(bool outside) { return outside; }",
                                        "void afterFragment": "() {}"
                                    }
                                })), this._defaultPointShader;
                            }
                        },
                        {
                            key: "baseStrokeShader",
                            value: function() {
                                return this._getLineShader();
                            }
                        },
                        {
                            key: "_getLineShader",
                            value: function() {
                                return this._defaultLineShader || (this._defaultLineShader = new g.default.Shader(this, this._webGL2CompatibilityPrefix("vert", "mediump") + E.lineVert, this._webGL2CompatibilityPrefix("frag", "mediump") + E.lineFrag, {
                                    vertex: {
                                        "void beforeVertex": "() {}",
                                        "vec3 getLocalPosition": "(vec3 position) { return position; }",
                                        "vec3 getWorldPosition": "(vec3 position) { return position; }",
                                        "float getStrokeWeight": "(float weight) { return weight; }",
                                        "vec2 getLineCenter": "(vec2 center) { return center; }",
                                        "vec2 getLinePosition": "(vec2 position) { return position; }",
                                        "vec4 getVertexColor": "(vec4 color) { return color; }",
                                        "void afterVertex": "() {}"
                                    },
                                    fragment: {
                                        "void beforeFragment": "() {}",
                                        "Inputs getPixelInputs": "(Inputs inputs) { return inputs; }",
                                        "vec4 getFinalColor": "(vec4 color) { return color; }",
                                        "bool shouldDiscard": "(bool outside) { return outside; }",
                                        "void afterFragment": "() {}"
                                    }
                                })), this._defaultLineShader;
                            }
                        },
                        {
                            key: "_getFontShader",
                            value: function() {
                                return this._defaultFontShader || (this.webglVersion === l.WEBGL && this.GL.getExtension("OES_standard_derivatives"), this._defaultFontShader = new g.default.Shader(this, this._webGL2CompatibilityPrefix("vert", "highp") + E.fontVert, this._webGL2CompatibilityPrefix("frag", "highp") + E.fontFrag)), this._defaultFontShader;
                            }
                        },
                        {
                            key: "_webGL2CompatibilityPrefix",
                            value: function(e1, t) {
                                var r = "";
                                return this.webglVersion === l.WEBGL2 && (r += "#version 300 es\n#define WEBGL2\n"), "vert" === e1 ? r += "#define VERTEX_SHADER\n" : "frag" === e1 && (r += "#define FRAGMENT_SHADER\n"), t && (r += "precision ".concat(t, " float;\n")), r;
                            }
                        },
                        {
                            key: "_getEmptyTexture",
                            value: function() {
                                var e1;
                                return this._emptyTexture || ((e1 = new g.default.Image(1, 1)).set(0, 0, 255), this._emptyTexture = new g.default.Texture(this, e1)), this._emptyTexture;
                            }
                        },
                        {
                            key: "getTexture",
                            value: function(e1) {
                                e1 instanceof g.default.Framebuffer && (e1 = e1.color);
                                var t = this.textures.get(e1);
                                return t || (t = new g.default.Texture(this, e1), this.textures.set(e1, t), t);
                            }
                        },
                        {
                            key: "getDiffusedTexture",
                            value: function(e1) {
                                var t, r, o = this;
                                return null != this.diffusedTextures.get(e1) ? this.diffusedTextures.get(e1) : (t = Math.floor(e1.height / e1.width * 200), r = this._pInst.createFramebuffer({
                                    width: 200,
                                    height: t,
                                    density: 1
                                }), this.diffusedShader || (this.diffusedShader = this._pInst.createShader(E.imageLightVert, E.imageLightDiffusedFrag)), r.draw(function() {
                                    o._pInst.shader(o.diffusedShader), o.diffusedShader.setUniform("environmentMap", e1), o._pInst.noStroke(), o._pInst.rectMode(l.CENTER), o._pInst.noLights(), o._pInst.rect(0, 0, 200, t);
                                }), this.diffusedTextures.set(e1, r), r);
                            }
                        },
                        {
                            key: "getSpecularTexture",
                            value: function(r) {
                                var o = this;
                                if (null != this.specularTextures.get(r)) return this.specularTextures.get(r);
                                for(var e1, n = [], s = this._pInst.createFramebuffer({
                                    width: 512,
                                    height: 512,
                                    density: 1
                                }), i = Math.log(512) / Math.log(2), t = (this.specularShader || (this.specularShader = this._pInst.createShader(E.imageLightVert, E.imageLightSpecularFrag)), 512); 1 <= t; t /= 2)!function(e1) {
                                    s.resize(e1, e1);
                                    var t = 1 - Math.log(e1) / Math.log(2) / i;
                                    s.draw(function() {
                                        o._pInst.shader(o.specularShader), o._pInst.clear(), o.specularShader.setUniform("environmentMap", r), o.specularShader.setUniform("roughness", t), o._pInst.noStroke(), o._pInst.noLights(), o._pInst.plane(e1, e1);
                                    }), n.push(s.get().drawingContext.getImageData(0, 0, e1, e1));
                                }(t);
                                return s.remove(), e1 = new c.MipmapTexture(this, n, {}), this.specularTextures.set(r, e1), e1;
                            }
                        },
                        {
                            key: "activeFramebuffer",
                            value: function() {
                                return this.activeFramebuffers[this.activeFramebuffers.length - 1] || null;
                            }
                        },
                        {
                            key: "createFramebuffer",
                            value: function(e1) {
                                return new g.default.Framebuffer(this, e1);
                            }
                        },
                        {
                            key: "_setStrokeUniforms",
                            value: function(e1) {
                                e1.bindShader(), e1.setUniform("uUseLineColor", this._useLineColor), e1.setUniform("uMaterialColor", this.curStrokeColor), e1.setUniform("uStrokeWeight", this.curStrokeWeight), e1.setUniform("uStrokeCap", w[this.curStrokeCap]), e1.setUniform("uStrokeJoin", S[this.curStrokeJoin]);
                            }
                        },
                        {
                            key: "_setFillUniforms",
                            value: function(e1) {
                                var r = this, t = (e1.bindShader(), this.mixedSpecularColor = h(this.curSpecularColor), 0 < this._useMetalness && (this.mixedSpecularColor = this.mixedSpecularColor.map(function(e1, t) {
                                    return r.curFillColor[t] * r._useMetalness + e1 * (1 - r._useMetalness);
                                })), e1.setUniform("uUseVertexColor", this._useVertexColor), e1.setUniform("uMaterialColor", this.curFillColor), e1.setUniform("isTexture", !!this._tex), this._tex && e1.setUniform("uSampler", this._tex), e1.setUniform("uTint", this._tint), e1.setUniform("uHasSetAmbient", this._hasSetAmbient), e1.setUniform("uAmbientMatColor", this.curAmbientColor), e1.setUniform("uSpecularMatColor", this.mixedSpecularColor), e1.setUniform("uEmissiveMatColor", this.curEmissiveColor), e1.setUniform("uSpecular", this._useSpecularMaterial), e1.setUniform("uEmissive", this._useEmissiveMaterial), e1.setUniform("uShininess", this._useShininess), e1.setUniform("uMetallic", this._useMetalness), this._setImageLightUniforms(e1), e1.setUniform("uUseLighting", this._enableLighting), this.pointLightDiffuseColors.length / 3), t = (e1.setUniform("uPointLightCount", t), e1.setUniform("uPointLightLocation", this.pointLightPositions), e1.setUniform("uPointLightDiffuseColors", this.pointLightDiffuseColors), e1.setUniform("uPointLightSpecularColors", this.pointLightSpecularColors), this.directionalLightDiffuseColors.length / 3), t = (e1.setUniform("uDirectionalLightCount", t), e1.setUniform("uLightingDirection", this.directionalLightDirections), e1.setUniform("uDirectionalDiffuseColors", this.directionalLightDiffuseColors), e1.setUniform("uDirectionalSpecularColors", this.directionalLightSpecularColors), this.ambientLightColors.length / 3), t = (this.mixedAmbientLight = h(this.ambientLightColors), 0 < this._useMetalness && (this.mixedAmbientLight = this.mixedAmbientLight.map(function(e1) {
                                    e1 -= r._useMetalness;
                                    return Math.max(0, e1);
                                })), e1.setUniform("uAmbientLightCount", t), e1.setUniform("uAmbientColor", this.mixedAmbientLight), this.spotLightDiffuseColors.length / 3);
                                e1.setUniform("uSpotLightCount", t), e1.setUniform("uSpotLightAngle", this.spotLightAngle), e1.setUniform("uSpotLightConc", this.spotLightConc), e1.setUniform("uSpotLightDiffuseColors", this.spotLightDiffuseColors), e1.setUniform("uSpotLightSpecularColors", this.spotLightSpecularColors), e1.setUniform("uSpotLightLocation", this.spotLightPositions), e1.setUniform("uSpotLightDirection", this.spotLightDirections), e1.setUniform("uConstantAttenuation", this.constantAttenuation), e1.setUniform("uLinearAttenuation", this.linearAttenuation), e1.setUniform("uQuadraticAttenuation", this.quadraticAttenuation), e1.bindTextures();
                            }
                        },
                        {
                            key: "_setImageLightUniforms",
                            value: function(e1) {
                                var t;
                                e1.setUniform("uUseImageLight", null != this.activeImageLight), this.activeImageLight && (t = this.getDiffusedTexture(this.activeImageLight), e1.setUniform("environmentMapDiffused", t), t = this.getSpecularTexture(this.activeImageLight), e1.setUniform("environmentMapSpecular", t));
                            }
                        },
                        {
                            key: "_setPointUniforms",
                            value: function(e1) {
                                e1.bindShader(), e1.setUniform("uMaterialColor", this.curStrokeColor), e1.setUniform("uPointSize", this.pointSize * this._pInst._pixelDensity);
                                var t = this.immediateMode && this.immediateMode.geometry && this.immediateMode.geometry.vertexStrokeColors && 0 < this.immediateMode.geometry.vertexStrokeColors.length;
                                e1.setUniform("uUseVertexColor", !!t);
                            }
                        },
                        {
                            key: "_bindBuffer",
                            value: function(e1, t, r, o, n) {
                                t = t || this.GL.ARRAY_BUFFER, this.GL.bindBuffer(t, e1), void 0 !== r && ((e1 = r) instanceof g.default.DataArray ? e1 = r.dataArray() : e1 instanceof (o || Float32Array) || (e1 = new (o || Float32Array)(e1)), this.GL.bufferData(t, e1, n || this.GL.STATIC_DRAW));
                            }
                        },
                        {
                            key: "_arraysEqual",
                            value: function(e1, r) {
                                return e1.length === r.length && e1.every(function(e1, t) {
                                    return e1 === r[t];
                                });
                            }
                        },
                        {
                            key: "_isTypedArray",
                            value: function(t) {
                                return [
                                    Float32Array,
                                    Float64Array,
                                    Int16Array,
                                    Uint16Array,
                                    Uint32Array
                                ].some(function(e1) {
                                    return t instanceof e1;
                                });
                            }
                        },
                        {
                            key: "_flatten",
                            value: function(e1) {
                                return e1.flat();
                            }
                        },
                        {
                            key: "_vToNArray",
                            value: function(e1) {
                                return e1.flatMap(function(e1) {
                                    return [
                                        e1.x,
                                        e1.y,
                                        e1.z
                                    ];
                                });
                            }
                        },
                        {
                            key: "_bezierCoefficients",
                            value: function(e1) {
                                var t = e1 * e1, r = 1 - e1, o = r * r;
                                return [
                                    o * r,
                                    3 * o * e1,
                                    3 * r * t,
                                    t * e1
                                ];
                            }
                        },
                        {
                            key: "_quadraticCoefficients",
                            value: function(e1) {
                                var t = 1 - e1;
                                return [
                                    t * t,
                                    2 * t * e1,
                                    e1 * e1
                                ];
                            }
                        },
                        {
                            key: "_bezierToCatmull",
                            value: function(e1) {
                                return [
                                    e1[1],
                                    e1[1] + (e1[2] - e1[0]) / this._curveTightness,
                                    e1[2] - (e1[3] - e1[1]) / this._curveTightness,
                                    e1[2]
                                ];
                            }
                        },
                        {
                            key: "_initTessy",
                            value: function() {
                                var e1 = new u.default.GluTesselator;
                                return e1.gluTessCallback(u.default.gluEnum.GLU_TESS_VERTEX_DATA, function(e1, t) {
                                    var r = !0, o = !1, n = void 0;
                                    try {
                                        for(var s, i = e1[Symbol.iterator](); !(r = (s = i.next()).done); r = !0){
                                            var a = s.value;
                                            t.push(a);
                                        }
                                    } catch (e1) {
                                        o = !0, n = e1;
                                    } finally{
                                        try {
                                            r || null == i.return || i.return();
                                        } finally{
                                            if (o) throw n;
                                        }
                                    }
                                }), e1.gluTessCallback(u.default.gluEnum.GLU_TESS_BEGIN, function(e1) {
                                    e1 !== u.default.primitiveType.GL_TRIANGLES && console.log("expected TRIANGLES but got type: ".concat(e1));
                                }), e1.gluTessCallback(u.default.gluEnum.GLU_TESS_ERROR, function(e1) {
                                    console.log("error callback"), console.log("error number: ".concat(e1));
                                }), e1.gluTessCallback(u.default.gluEnum.GLU_TESS_COMBINE, function(e1, t, r) {
                                    for(var o = new Array(g.default.RendererGL.prototype.tessyVertexSize).fill(0), n = 0; n < r.length; n++)for(var s = 0; s < o.length; s++)0 !== r[n] && t[n] && (o[s] += t[n][s] * r[n]);
                                    return o;
                                }), e1.gluTessCallback(u.default.gluEnum.GLU_TESS_EDGE_FLAG, function(e1) {}), e1.gluTessProperty(u.default.gluEnum.GLU_TESS_WINDING_RULE, u.default.windingRule.GLU_TESS_WINDING_NONZERO), e1;
                            }
                        },
                        {
                            key: "_triangulate",
                            value: function(e1) {
                                var t = e1[0] ? e1[0][2] : void 0, r = !0, o = !0, n = !1, s = void 0;
                                try {
                                    for(var i, a = e1[Symbol.iterator](); !(o = (i = a.next()).done); o = !0)for(var l = i.value, u = 0; u < l.length; u += g.default.RendererGL.prototype.tessyVertexSize)if (l[u + 2] !== t) {
                                        r = !1;
                                        break;
                                    }
                                } catch (e1) {
                                    n = !0, s = e1;
                                } finally{
                                    try {
                                        o || null == a.return || a.return();
                                    } finally{
                                        if (n) throw s;
                                    }
                                }
                                r ? this._tessy.gluTessNormal(0, 0, 1) : this._tessy.gluTessNormal(0, 0, 0);
                                var n = [], c = (this._tessy.gluTessBeginPolygon(n), !0), s = !1, d = void 0;
                                try {
                                    for(var h, f = e1[Symbol.iterator](); !(c = (h = f.next()).done); c = !0){
                                        var p = h.value;
                                        this._tessy.gluTessBeginContour();
                                        for(var m = 0; m < p.length; m += g.default.RendererGL.prototype.tessyVertexSize){
                                            var y = p.slice(m, m + g.default.RendererGL.prototype.tessyVertexSize);
                                            this._tessy.gluTessVertex(y, y);
                                        }
                                        this._tessy.gluTessEndContour();
                                    }
                                } catch (e1) {
                                    s = !0, d = e1;
                                } finally{
                                    try {
                                        c || null == f.return || f.return();
                                    } finally{
                                        if (s) throw d;
                                    }
                                }
                                return this._tessy.gluTessEndPolygon(), n;
                            }
                        }
                    ], f(t.prototype, e1), r && f(t, r), s;
                }(g.default.Renderer), g.default.prototype._assert3d = function(e1) {
                    if (!this._renderer.isP3D) throw new Error("".concat(e1, "() is only supported in WEBGL mode. If you'd like to use 3D graphics and WebGL, see https://p5js.org/examples/3d-geometries/ for more information."));
                }, g.default.RendererGL.prototype.tessyVertexSize = 12;
                e1 = g.default.RendererGL;
                r.default = e1;
            },
            {
                "../core/constants": 272,
                "../core/main": 283,
                "../core/p5.Renderer": 286,
                "./GeometryBuilder": 327,
                "./p5.Camera": 332,
                "./p5.Framebuffer": 334,
                "./p5.Matrix": 336,
                "./p5.Shader": 342,
                "./p5.Texture": 343,
                "core-js/modules/es.array.concat": 153,
                "core-js/modules/es.array.copy-within": 154,
                "core-js/modules/es.array.every": 155,
                "core-js/modules/es.array.fill": 156,
                "core-js/modules/es.array.flat": 160,
                "core-js/modules/es.array.flat-map": 159,
                "core-js/modules/es.array.from": 162,
                "core-js/modules/es.array.includes": 163,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.map": 168,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.array.some": 170,
                "core-js/modules/es.array.unscopables.flat": 173,
                "core-js/modules/es.array.unscopables.flat-map": 172,
                "core-js/modules/es.map": 175,
                "core-js/modules/es.object.assign": 183,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.get-prototype-of": 188,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.reflect.construct": 192,
                "core-js/modules/es.reflect.get": 193,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.set": 197,
                "core-js/modules/es.string.includes": 199,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.typed-array.copy-within": 213,
                "core-js/modules/es.typed-array.every": 214,
                "core-js/modules/es.typed-array.fill": 215,
                "core-js/modules/es.typed-array.filter": 216,
                "core-js/modules/es.typed-array.find": 218,
                "core-js/modules/es.typed-array.find-index": 217,
                "core-js/modules/es.typed-array.float32-array": 219,
                "core-js/modules/es.typed-array.float64-array": 220,
                "core-js/modules/es.typed-array.for-each": 221,
                "core-js/modules/es.typed-array.includes": 222,
                "core-js/modules/es.typed-array.index-of": 223,
                "core-js/modules/es.typed-array.int16-array": 224,
                "core-js/modules/es.typed-array.iterator": 226,
                "core-js/modules/es.typed-array.join": 227,
                "core-js/modules/es.typed-array.last-index-of": 228,
                "core-js/modules/es.typed-array.map": 229,
                "core-js/modules/es.typed-array.reduce": 231,
                "core-js/modules/es.typed-array.reduce-right": 230,
                "core-js/modules/es.typed-array.reverse": 232,
                "core-js/modules/es.typed-array.set": 233,
                "core-js/modules/es.typed-array.slice": 234,
                "core-js/modules/es.typed-array.some": 235,
                "core-js/modules/es.typed-array.sort": 236,
                "core-js/modules/es.typed-array.subarray": 237,
                "core-js/modules/es.typed-array.to-locale-string": 238,
                "core-js/modules/es.typed-array.to-string": 239,
                "core-js/modules/es.typed-array.uint16-array": 240,
                "core-js/modules/es.typed-array.uint32-array": 241,
                "core-js/modules/es.typed-array.uint8-array": 242,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246,
                libtess: 255,
                path: 258
            }
        ],
        342: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.some"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.split"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.some"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.split"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var a = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function u(e1, t) {
                    return function(e1) {
                        if (Array.isArray(e1)) return e1;
                    }(e1) || function(e1, t) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) {
                            var r = [], o = !0, n = !1, s = void 0;
                            try {
                                for(var i, a = e1[Symbol.iterator](); !(o = (i = a.next()).done) && (r.push(i.value), !t || r.length !== t); o = !0);
                            } catch (e1) {
                                n = !0, s = e1;
                            } finally{
                                try {
                                    o || null == a.return || a.return();
                                } finally{
                                    if (n) throw s;
                                }
                            }
                            return r;
                        }
                    }(e1, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance");
                    }();
                }
                function o(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                a.default.Shader = function() {
                    function i(e1, t, r) {
                        var o = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : {}, n = this, s = i;
                        if (!(n instanceof s)) throw new TypeError("Cannot call a class as a function");
                        this._renderer = e1, this._vertSrc = t, this._fragSrc = r, this._vertShader = -1, this._fragShader = -1, this._glProgram = 0, this._loadedAttributes = !1, this.attributes = {}, this._loadedUniforms = !1, this.uniforms = {}, this._bound = !1, this.samplers = [], this.hooks = {
                            uniforms: o.uniforms || {},
                            declarations: o.declarations,
                            helpers: o.helpers || {},
                            vertex: o.vertex || {},
                            fragment: o.fragment || {},
                            modified: {
                                vertex: o.modified && o.modified.vertex || {},
                                fragment: o.modified && o.modified.fragment || {}
                            }
                        };
                    }
                    var e1, t, r;
                    return e1 = i, t = [
                        {
                            key: "shaderSrc",
                            value: function(e1, t) {
                                var r, o, n, s, i, e1 = u(e1.split("void main"), 2), a = e1[0], e1 = e1[1], l = "";
                                for(r in this.hooks.uniforms)l += "uniform ".concat(r, ";\n");
                                for(o in this.hooks.declarations && (l += this.hooks.declarations + "\n"), this.hooks[t].declarations && (l += this.hooks[t].declarations + "\n"), this.hooks.helpers)l += "".concat(o).concat(this.hooks.helpers[o], "\n");
                                for(n in this.hooks[t])"declarations" !== n && (s = (i = u(n.split(" "), 2))[0], i = i[1], this.hooks.modified[t][n] && (l += "#define AUGMENTED_HOOK_" + i + "\n"), l += s + " HOOK_" + i + this.hooks[t][n] + "\n");
                                return a + l + "void main" + e1;
                            }
                        },
                        {
                            key: "version",
                            value: function() {
                                var e1 = /#version (.+)$/.exec(this.vertSrc());
                                return e1 ? e1[1] : "100 es";
                            }
                        },
                        {
                            key: "vertSrc",
                            value: function() {
                                return this.shaderSrc(this._vertSrc, "vertex");
                            }
                        },
                        {
                            key: "fragSrc",
                            value: function() {
                                return this.shaderSrc(this._fragSrc, "fragment");
                            }
                        },
                        {
                            key: "inspectHooks",
                            value: function() {
                                for(var e1 in console.log("==== Vertex shader hooks: ===="), this.hooks.vertex)console.log((this.hooks.modified.vertex[e1] ? "[MODIFIED] " : "") + e1 + this.hooks.vertex[e1]);
                                for(var t in console.log(""), console.log("==== Fragment shader hooks: ===="), this.hooks.fragment)console.log((this.hooks.modified.fragment[t] ? "[MODIFIED] " : "") + t + this.hooks.fragment[t]);
                                for(var r in console.log(""), console.log("==== Helper functions: ===="), this.hooks.helpers)console.log(r + this.hooks.helpers[r]);
                            }
                        },
                        {
                            key: "modify",
                            value: function(e1) {
                                a.default._validateParameters("p5.Shader.modify", arguments);
                                var t, r = {
                                    vertex: {},
                                    fragment: {},
                                    helpers: {}
                                };
                                for(t in e1)"declarations" !== t && "uniforms" !== t && ("vertexDeclarations" === t ? r.vertex.declarations = (r.vertex.declarations || "") + "\n" + e1[t] : "fragmentDeclarations" === t ? r.fragment.declarations = (r.fragment.declarations || "") + "\n" + e1[t] : this.hooks.vertex[t] ? r.vertex[t] = e1[t] : this.hooks.fragment[t] ? r.fragment[t] = e1[t] : r.helpers[t] = e1[t]);
                                var o, n, s = Object.assign({}, this.hooks.modified.vertex), i = Object.assign({}, this.hooks.modified.fragment);
                                for(o in r.vertex || {})"declarations" !== o && (s[o] = !0);
                                for(n in r.fragment || {})"declarations" !== n && (i[n] = !0);
                                return new a.default.Shader(this._renderer, this._vertSrc, this._fragSrc, {
                                    declarations: (this.hooks.declarations || "") + "\n" + (e1.declarations || ""),
                                    uniforms: Object.assign({}, this.hooks.uniforms, e1.uniforms || {}),
                                    fragment: Object.assign({}, this.hooks.fragment, r.fragment || {}),
                                    vertex: Object.assign({}, this.hooks.vertex, r.vertex || {}),
                                    helpers: Object.assign({}, this.hooks.helpers, r.helpers || {}),
                                    modified: {
                                        vertex: s,
                                        fragment: i
                                    }
                                });
                            }
                        },
                        {
                            key: "init",
                            value: function() {
                                if (0 === this._glProgram) {
                                    var e1, t = this._renderer.GL;
                                    if (this._vertShader = t.createShader(t.VERTEX_SHADER), t.shaderSource(this._vertShader, this.vertSrc()), t.compileShader(this._vertShader), !t.getShaderParameter(this._vertShader, t.COMPILE_STATUS)) return e1 = t.getShaderInfoLog(this._vertShader), console.error(e1), null;
                                    if (this._fragShader = t.createShader(t.FRAGMENT_SHADER), t.shaderSource(this._fragShader, this.fragSrc()), t.compileShader(this._fragShader), !t.getShaderParameter(this._fragShader, t.COMPILE_STATUS)) return e1 = t.getShaderInfoLog(this._fragShader), console.error(e1), null;
                                    this._glProgram = t.createProgram(), t.attachShader(this._glProgram, this._vertShader), t.attachShader(this._glProgram, this._fragShader), t.linkProgram(this._glProgram), t.getProgramParameter(this._glProgram, t.LINK_STATUS) || a.default._friendlyError("Snap! Error linking shader program: ".concat(t.getProgramInfoLog(this._glProgram))), this._loadAttributes(), this._loadUniforms();
                                }
                                return this;
                            }
                        },
                        {
                            key: "setDefaultUniforms",
                            value: function() {
                                for(var e1 in this.hooks.uniforms){
                                    var t = u(e1.split(" "), 2)[1], e1 = this.hooks.uniforms[e1], r = void 0;
                                    null != (r = e1 instanceof Function ? e1() : e1) && this.setUniform(t, r);
                                }
                            }
                        },
                        {
                            key: "copyToContext",
                            value: function(e1) {
                                var t = new a.default.Shader(e1._renderer, this._vertSrc, this._fragSrc);
                                return t.ensureCompiledOnContext(e1), t;
                            }
                        },
                        {
                            key: "ensureCompiledOnContext",
                            value: function(e1) {
                                if (0 !== this._glProgram && this._renderer !== e1._renderer) throw new Error("The shader being run is attached to a different context. Do you need to copy it to this context first with .copyToContext()?");
                                0 === this._glProgram && (this._renderer = e1._renderer, this.init());
                            }
                        },
                        {
                            key: "_loadAttributes",
                            value: function() {
                                if (!this._loadedAttributes) {
                                    this.attributes = {};
                                    for(var e1 = this._renderer.GL, t = e1.getProgramParameter(this._glProgram, e1.ACTIVE_ATTRIBUTES), r = 0; r < t; ++r){
                                        var o = e1.getActiveAttrib(this._glProgram, r), n = o.name, s = e1.getAttribLocation(this._glProgram, n), i = {};
                                        i.name = n, i.location = s, i.index = r, i.type = o.type, i.size = o.size, this.attributes[n] = i;
                                    }
                                    this._loadedAttributes = !0;
                                }
                            }
                        },
                        {
                            key: "_loadUniforms",
                            value: function() {
                                if (!this._loadedUniforms) {
                                    for(var e1 = this._renderer.GL, t = e1.getProgramParameter(this._glProgram, e1.ACTIVE_UNIFORMS), r = 0, o = 0; o < t; ++o){
                                        var n = e1.getActiveUniform(this._glProgram, o), s = {}, i = (s.location = e1.getUniformLocation(this._glProgram, n.name), s.size = n.size, n.name);
                                        1 < n.size && (i = i.substring(0, i.indexOf("[0]"))), s.name = i, s.type = n.type, s._cachedData = void 0, s.type === e1.SAMPLER_2D && (s.samplerIndex = r, r++, this.samplers.push(s)), s.isArray = 1 < n.size || s.type === e1.FLOAT_MAT3 || s.type === e1.FLOAT_MAT4 || s.type === e1.FLOAT_VEC2 || s.type === e1.FLOAT_VEC3 || s.type === e1.FLOAT_VEC4 || s.type === e1.INT_VEC2 || s.type === e1.INT_VEC4 || s.type === e1.INT_VEC3, this.uniforms[i] = s;
                                    }
                                    this._loadedUniforms = !0;
                                }
                            }
                        },
                        {
                            key: "compile",
                            value: function() {}
                        },
                        {
                            key: "bindShader",
                            value: function() {
                                this.init(), this._bound || (this.useProgram(), this._bound = !0, this._setMatrixUniforms(), this.setUniform("uViewport", this._renderer._viewport));
                            }
                        },
                        {
                            key: "unbindShader",
                            value: function() {
                                return this._bound && (this.unbindTextures(), this._bound = !1), this;
                            }
                        },
                        {
                            key: "bindTextures",
                            value: function() {
                                var e1 = this._renderer.GL, t = !0, r = !1, o = void 0;
                                try {
                                    for(var n, s = this.samplers[Symbol.iterator](); !(t = (n = s.next()).done); t = !0){
                                        var i = n.value, a = i.texture;
                                        void 0 === a && (a = this._renderer._getEmptyTexture()), e1.activeTexture(e1.TEXTURE0 + i.samplerIndex), a.bindTexture(), a.update(), e1.uniform1i(i.location, i.samplerIndex);
                                    }
                                } catch (e1) {
                                    r = !0, o = e1;
                                } finally{
                                    try {
                                        t || null == s.return || s.return();
                                    } finally{
                                        if (r) throw o;
                                    }
                                }
                            }
                        },
                        {
                            key: "updateTextures",
                            value: function() {
                                var e1 = !0, t = !1, r = void 0;
                                try {
                                    for(var o, n = this.samplers[Symbol.iterator](); !(e1 = (o = n.next()).done); e1 = !0){
                                        var s = o.value.texture;
                                        s && s.update();
                                    }
                                } catch (e1) {
                                    t = !0, r = e1;
                                } finally{
                                    try {
                                        e1 || null == n.return || n.return();
                                    } finally{
                                        if (t) throw r;
                                    }
                                }
                            }
                        },
                        {
                            key: "unbindTextures",
                            value: function() {
                                var e1 = !0, t = !1, r = void 0;
                                try {
                                    for(var o, n = this.samplers[Symbol.iterator](); !(e1 = (o = n.next()).done); e1 = !0){
                                        var s = o.value;
                                        this.setUniform(s.name, this._renderer._getEmptyTexture());
                                    }
                                } catch (e1) {
                                    t = !0, r = e1;
                                } finally{
                                    try {
                                        e1 || null == n.return || n.return();
                                    } finally{
                                        if (t) throw r;
                                    }
                                }
                            }
                        },
                        {
                            key: "_setMatrixUniforms",
                            value: function() {
                                var e1 = this._renderer.uModelMatrix, t = this._renderer.uViewMatrix, r = this._renderer.uPMatrix, o = e1.copy().mult(t), n = (this._renderer.uMVMatrix = o).copy();
                                n.mult(r), this.isStrokeShader() && this.setUniform("uPerspective", this._renderer._curCamera.useLinePerspective ? 1 : 0), this.setUniform("uViewMatrix", t.mat4), this.setUniform("uProjectionMatrix", r.mat4), this.setUniform("uModelMatrix", e1.mat4), this.setUniform("uModelViewMatrix", o.mat4), this.setUniform("uModelViewProjectionMatrix", n.mat4), this.uniforms.uNormalMatrix && (this._renderer.uNMatrix.inverseTranspose(this._renderer.uMVMatrix), this.setUniform("uNormalMatrix", this._renderer.uNMatrix.mat3)), this.uniforms.uCameraRotation && (this._renderer.curMatrix.inverseTranspose(this._renderer.uViewMatrix), this.setUniform("uCameraRotation", this._renderer.curMatrix.mat3));
                            }
                        },
                        {
                            key: "useProgram",
                            value: function() {
                                var e1 = this._renderer.GL;
                                return this._renderer._curShader !== this && (e1.useProgram(this._glProgram), this._renderer._curShader = this), this;
                            }
                        },
                        {
                            key: "setUniform",
                            value: function(e1, t) {
                                var r = this.uniforms[e1];
                                if (r) {
                                    var o = this._renderer.GL;
                                    if (r.isArray) {
                                        if (r._cachedData && this._renderer._arraysEqual(r._cachedData, t)) return;
                                        r._cachedData = t.slice(0);
                                    } else {
                                        if (r._cachedData && r._cachedData === t) return;
                                        Array.isArray(t) ? r._cachedData = t.slice(0) : r._cachedData = t;
                                    }
                                    var n = r.location;
                                    switch(this.useProgram(), r.type){
                                        case o.BOOL:
                                            !0 === t ? o.uniform1i(n, 1) : o.uniform1i(n, 0);
                                            break;
                                        case o.INT:
                                            1 < r.size ? t.length && o.uniform1iv(n, t) : o.uniform1i(n, t);
                                            break;
                                        case o.FLOAT:
                                            1 < r.size ? t.length && o.uniform1fv(n, t) : o.uniform1f(n, t);
                                            break;
                                        case o.FLOAT_MAT3:
                                            o.uniformMatrix3fv(n, !1, t);
                                            break;
                                        case o.FLOAT_MAT4:
                                            o.uniformMatrix4fv(n, !1, t);
                                            break;
                                        case o.FLOAT_VEC2:
                                            1 < r.size ? t.length && o.uniform2fv(n, t) : o.uniform2f(n, t[0], t[1]);
                                            break;
                                        case o.FLOAT_VEC3:
                                            1 < r.size ? t.length && o.uniform3fv(n, t) : o.uniform3f(n, t[0], t[1], t[2]);
                                            break;
                                        case o.FLOAT_VEC4:
                                            1 < r.size ? t.length && o.uniform4fv(n, t) : o.uniform4f(n, t[0], t[1], t[2], t[3]);
                                            break;
                                        case o.INT_VEC2:
                                            1 < r.size ? t.length && o.uniform2iv(n, t) : o.uniform2i(n, t[0], t[1]);
                                            break;
                                        case o.INT_VEC3:
                                            1 < r.size ? t.length && o.uniform3iv(n, t) : o.uniform3i(n, t[0], t[1], t[2]);
                                            break;
                                        case o.INT_VEC4:
                                            1 < r.size ? t.length && o.uniform4iv(n, t) : o.uniform4i(n, t[0], t[1], t[2], t[3]);
                                            break;
                                        case o.SAMPLER_2D:
                                            if ("number" == typeof t) {
                                                if (t < o.TEXTURE0 || t > o.TEXTURE31 || t !== Math.ceil(t)) return console.log("\uD83C\uDF38 p5.js says: You're trying to use a number as the data for a texture.Please use a texture."), this;
                                                o.activeTexture(t), o.uniform1i(n, t);
                                            } else o.activeTexture(o.TEXTURE0 + r.samplerIndex), r.texture = t instanceof a.default.Texture ? t : this._renderer.getTexture(t), o.uniform1i(n, r.samplerIndex), r.texture.src.gifProperties && r.texture.src._animateGif(this._renderer._pInst);
                                            break;
                                        case o.SAMPLER_CUBE:
                                        case o.SAMPLER_3D:
                                        case o.SAMPLER_2D_SHADOW:
                                        case o.SAMPLER_2D_ARRAY:
                                        case o.SAMPLER_2D_ARRAY_SHADOW:
                                        case o.SAMPLER_CUBE_SHADOW:
                                        case o.INT_SAMPLER_2D:
                                        case o.INT_SAMPLER_3D:
                                        case o.INT_SAMPLER_CUBE:
                                        case o.INT_SAMPLER_2D_ARRAY:
                                        case o.UNSIGNED_INT_SAMPLER_2D:
                                        case o.UNSIGNED_INT_SAMPLER_3D:
                                        case o.UNSIGNED_INT_SAMPLER_CUBE:
                                        case o.UNSIGNED_INT_SAMPLER_2D_ARRAY:
                                            "number" == typeof t && (t < o.TEXTURE0 || t > o.TEXTURE31 || t !== Math.ceil(t) ? console.log("\uD83C\uDF38 p5.js says: You're trying to use a number as the data for a texture.Please use a texture.") : (o.activeTexture(t), o.uniform1i(n, t)));
                                    }
                                    return this;
                                }
                            }
                        },
                        {
                            key: "isLightShader",
                            value: function() {
                                return [
                                    this.attributes.aNormal,
                                    this.uniforms.uUseLighting,
                                    this.uniforms.uAmbientLightCount,
                                    this.uniforms.uDirectionalLightCount,
                                    this.uniforms.uPointLightCount,
                                    this.uniforms.uAmbientColor,
                                    this.uniforms.uDirectionalDiffuseColors,
                                    this.uniforms.uDirectionalSpecularColors,
                                    this.uniforms.uPointLightLocation,
                                    this.uniforms.uPointLightDiffuseColors,
                                    this.uniforms.uPointLightSpecularColors,
                                    this.uniforms.uLightingDirection,
                                    this.uniforms.uSpecular
                                ].some(function(e1) {
                                    return void 0 !== e1;
                                });
                            }
                        },
                        {
                            key: "isNormalShader",
                            value: function() {
                                return void 0 !== this.attributes.aNormal;
                            }
                        },
                        {
                            key: "isTextureShader",
                            value: function() {
                                return 0 < this.samplers.length;
                            }
                        },
                        {
                            key: "isColorShader",
                            value: function() {
                                return void 0 !== this.attributes.aVertexColor || void 0 !== this.uniforms.uMaterialColor;
                            }
                        },
                        {
                            key: "isTexLightShader",
                            value: function() {
                                return this.isLightShader() && this.isTextureShader();
                            }
                        },
                        {
                            key: "isStrokeShader",
                            value: function() {
                                return void 0 !== this.uniforms.uStrokeWeight;
                            }
                        },
                        {
                            key: "enableAttrib",
                            value: function(e1, t, r, o, n, s) {
                                var i;
                                return e1 && -1 !== (e1 = e1.location) && (i = this._renderer.GL, this._renderer.registerEnabled.has(e1) || (i.enableVertexAttribArray(e1), this._renderer.registerEnabled.add(e1)), this._renderer.GL.vertexAttribPointer(e1, t, r || i.FLOAT, o || !1, n || 0, s || 0)), this;
                            }
                        },
                        {
                            key: "disableRemainingAttributes",
                            value: function() {
                                var r = this, e1 = !0, t = !1, o = void 0;
                                try {
                                    for(var n, s = this._renderer.registerEnabled.values()[Symbol.iterator](); !(e1 = (n = s.next()).done); e1 = !0)!function() {
                                        var t = n.value;
                                        Object.keys(r.attributes).some(function(e1) {
                                            return r.attributes[e1].location === t;
                                        }) || (r._renderer.GL.disableVertexAttribArray(t), r._renderer.registerEnabled.delete(t));
                                    }();
                                } catch (e1) {
                                    t = !0, o = e1;
                                } finally{
                                    try {
                                        e1 || null == s.return || s.return();
                                    } finally{
                                        if (t) throw o;
                                    }
                                }
                            }
                        },
                        {
                            key: "remove",
                            value: function() {
                                var e1;
                                0 !== this._glProgram && (e1 = this._renderer.GL, this._bound && this.unbindShader(), -1 !== this._vertShader && (e1.detachShader(this._glProgram, this._vertShader), e1.deleteShader(this._vertShader), this._vertShader = -1), -1 !== this._fragShader && (e1.detachShader(this._glProgram, this._fragShader), e1.deleteShader(this._fragShader), this._fragShader = -1), e1.deleteProgram(this._glProgram), this._glProgram = 0, this._loadedAttributes = !1, this._loadedUniforms = !1, this.attributes = {}, this.uniforms = {}, this.samplers = []);
                            }
                        }
                    ], o(e1.prototype, t), r && o(e1, r), i;
                }();
                e1 = a.default.Shader;
                r.default = e1;
            },
            {
                "../core/main": 283,
                "core-js/modules/es.array.concat": 153,
                "core-js/modules/es.array.index-of": 164,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.array.slice": 169,
                "core-js/modules/es.array.some": 170,
                "core-js/modules/es.function.name": 174,
                "core-js/modules/es.object.assign": 183,
                "core-js/modules/es.object.keys": 189,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.regexp.exec": 195,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.string.split": 206,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        343: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.checkWebGLCapabilities = m, r.default = r.MipmapTexture = void 0;
                var s = (p = e1("../core/main")) && p.__esModule ? p : {
                    default: p
                }, a = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = l();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function l() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, l = function() {
                        return e1;
                    }, e1);
                }
                function u(e1, t) {
                    return (u = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                function c(r) {
                    return function() {
                        var e1, t = n(r), t = (e1 = function() {
                            if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                                if ("function" == typeof Proxy) return 1;
                                try {
                                    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                                } catch (e1) {}
                            }
                        }() ? (e1 = n(this).constructor, Reflect.construct(t, arguments, e1)) : t.apply(this, arguments), this);
                        if (!e1 || "object" !== i(e1) && "function" != typeof e1) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }
                        return e1;
                    };
                }
                function n(e1) {
                    return (n = Object.setPrototypeOf ? Object.getPrototypeOf : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    })(e1);
                }
                function d(e1, t) {
                    if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function h(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function f(e1, t, r) {
                    t && h(e1.prototype, t), r && h(e1, r);
                }
                s.default.Texture = function() {
                    function n(e1, t, r) {
                        d(this, n), this._renderer = e1;
                        var o = this._renderer.GL, r = (r = r || {}, this.src = t, this.glTex = void 0, this.glTarget = o.TEXTURE_2D, this.glFormat = r.format || o.RGBA, this.mipmaps = !1, this.glMinFilter = r.minFilter || o.LINEAR, this.glMagFilter = r.magFilter || o.LINEAR, this.glWrapS = r.wrapS || o.CLAMP_TO_EDGE, this.glWrapT = r.wrapT || o.CLAMP_TO_EDGE, this.glDataType = r.dataType || o.UNSIGNED_BYTE, m(e1)), e1 = (this.glFormat !== o.HALF_FLOAT || r.halfFloat || (console.log("This device does not support dataType HALF_FLOAT. Falling back to FLOAT."), this.glDataType = o.FLOAT), this.glFormat !== o.HALF_FLOAT || this.glMinFilter !== o.LINEAR && this.glMagFilter !== o.LINEAR || r.halfFloatLinear || (console.log("This device does not support linear filtering for dataType FLOAT. Falling back to NEAREST."), this.glMinFilter === o.LINEAR && (this.glMinFilter = o.NEAREST), this.glMagFilter === o.LINEAR && (this.glMagFilter = o.NEAREST)), this.glFormat !== o.FLOAT || r.float || (console.log("This device does not support dataType FLOAT. Falling back to UNSIGNED_BYTE."), this.glDataType = o.UNSIGNED_BYTE), this.glFormat !== o.FLOAT || this.glMinFilter !== o.LINEAR && this.glMagFilter !== o.LINEAR || r.floatLinear || (console.log("This device does not support linear filtering for dataType FLOAT. Falling back to NEAREST."), this.glMinFilter === o.LINEAR && (this.glMinFilter = o.NEAREST), this.glMagFilter === o.LINEAR && (this.glMagFilter = o.NEAREST)), this.isSrcMediaElement = void 0 !== s.default.MediaElement && t instanceof s.default.MediaElement, this._videoPrevUpdateTime = 0, this.isSrcHTMLElement = void 0 !== s.default.Element && t instanceof s.default.Element && !(t instanceof s.default.Graphics) && !(t instanceof s.default.Renderer), this.isSrcP5Image = t instanceof s.default.Image, this.isSrcP5Graphics = t instanceof s.default.Graphics, this.isSrcP5Renderer = t instanceof s.default.Renderer, this.isImageData = "undefined" != typeof ImageData && t instanceof ImageData, this.isFramebufferTexture = t instanceof s.default.FramebufferTexture, this._getTextureDataFromSource());
                        return this.width = e1.width, this.height = e1.height, this.init(e1), this;
                    }
                    return f(n, [
                        {
                            key: "_getTextureDataFromSource",
                            value: function() {
                                var e1;
                                return this.isFramebufferTexture ? e1 = this.src.rawTexture() : this.isSrcP5Image ? e1 = this.src.canvas : this.isSrcMediaElement || this.isSrcP5Graphics || this.isSrcP5Renderer || this.isSrcHTMLElement ? (this.src._ensureCanvas && this.src._ensureCanvas(), e1 = this.src.canvas || this.src.elt) : this.isImageData && (e1 = this.src), e1;
                            }
                        },
                        {
                            key: "init",
                            value: function(e1) {
                                var t, r = this._renderer.GL;
                                this.isFramebufferTexture || (this.glTex = r.createTexture()), this.glWrapS = this._renderer.textureWrapX, this.glWrapT = this._renderer.textureWrapY, this.setWrapMode(this.glWrapS, this.glWrapT), this.bindTexture(), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, this.glMagFilter), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, this.glMinFilter), this.isFramebufferTexture || (0 === this.width || 0 === this.height || this.isSrcMediaElement && !this.src.loadedmetadata ? (t = new Uint8Array([
                                    1,
                                    1,
                                    1,
                                    1
                                ]), r.texImage2D(this.glTarget, 0, r.RGBA, 1, 1, 0, this.glFormat, this.glDataType, t)) : r.texImage2D(this.glTarget, 0, this.glFormat, this.glFormat, this.glDataType, e1));
                            }
                        },
                        {
                            key: "update",
                            value: function() {
                                var e1, t, r, o = this.src;
                                return 0 !== o.width && 0 !== o.height && !this.isFramebufferTexture && (e1 = this._getTextureDataFromSource(), t = !1, r = this._renderer.GL, e1.width !== this.width || e1.height !== this.height ? (t = !0, this.width = e1.width || o.width, this.height = e1.height || o.height, this.isSrcP5Image ? o.setModified(!1) : (this.isSrcMediaElement || this.isSrcHTMLElement) && o.setModified(!0)) : this.isSrcP5Image ? o.isModified() && o.setModified((t = !0, false)) : this.isSrcMediaElement ? o.isModified() ? o.setModified((t = !0, false)) : o.loadedmetadata && this._videoPrevUpdateTime !== o.time() && (this._videoPrevUpdateTime = o.time(), t = !0) : this.isImageData ? o._dirty && (t = (o._dirty = !1, true)) : t = !0, t && (this.bindTexture(), r.texImage2D(this.glTarget, 0, this.glFormat, this.glFormat, this.glDataType, e1)), t);
                            }
                        },
                        {
                            key: "bindTexture",
                            value: function() {
                                return this._renderer.GL.bindTexture(this.glTarget, this.getTexture()), this;
                            }
                        },
                        {
                            key: "unbindTexture",
                            value: function() {
                                this._renderer.GL.bindTexture(this.glTarget, null);
                            }
                        },
                        {
                            key: "getTexture",
                            value: function() {
                                return this.isFramebufferTexture ? this.src.rawTexture() : this.glTex;
                            }
                        },
                        {
                            key: "setInterpolation",
                            value: function(e1, t) {
                                var r = this._renderer.GL;
                                this.glMinFilter = this.glFilter(e1), this.glMagFilter = this.glFilter(t), this.bindTexture(), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, this.glMinFilter), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, this.glMagFilter), this.unbindTexture();
                            }
                        },
                        {
                            key: "glFilter",
                            value: function(e1) {
                                var t = this._renderer.GL;
                                return e1 === a.NEAREST ? t.NEAREST : t.LINEAR;
                            }
                        },
                        {
                            key: "setWrapMode",
                            value: function(e1, t) {
                                function r(e1) {
                                    return 0 == (e1 & e1 - 1);
                                }
                                var o = this._renderer.GL, n = this._getTextureDataFromSource(), n = n.naturalWidth && n.naturalHeight ? (s = n.naturalWidth, n.naturalHeight) : (s = this.width, this.height), s = r(s), n = r(n);
                                e1 === a.REPEAT ? this._renderer.webglVersion === a.WEBGL2 || s && n ? this.glWrapS = o.REPEAT : (console.warn("You tried to set the wrap mode to REPEAT but the texture size is not a power of two. Setting to CLAMP instead"), this.glWrapS = o.CLAMP_TO_EDGE) : e1 === a.MIRROR ? this._renderer.webglVersion === a.WEBGL2 || s && n ? this.glWrapS = o.MIRRORED_REPEAT : (console.warn("You tried to set the wrap mode to MIRROR but the texture size is not a power of two. Setting to CLAMP instead"), this.glWrapS = o.CLAMP_TO_EDGE) : this.glWrapS = o.CLAMP_TO_EDGE, t === a.REPEAT ? this._renderer.webglVersion === a.WEBGL2 || s && n ? this.glWrapT = o.REPEAT : (console.warn("You tried to set the wrap mode to REPEAT but the texture size is not a power of two. Setting to CLAMP instead"), this.glWrapT = o.CLAMP_TO_EDGE) : t === a.MIRROR ? this._renderer.webglVersion === a.WEBGL2 || s && n ? this.glWrapT = o.MIRRORED_REPEAT : (console.warn("You tried to set the wrap mode to MIRROR but the texture size is not a power of two. Setting to CLAMP instead"), this.glWrapT = o.CLAMP_TO_EDGE) : this.glWrapT = o.CLAMP_TO_EDGE, this.bindTexture(), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_S, this.glWrapS), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_T, this.glWrapT), this.unbindTexture();
                            }
                        },
                        {
                            key: "remove",
                            value: function() {
                                this.isFramebufferTexture || void 0 === this.glTex || (this._renderer.GL.deleteTexture(this.glTex), this.glTex = void 0);
                            }
                        }
                    ]), n;
                }();
                var p = function(e1) {
                    var t = n;
                    if ("function" != typeof e1 && null !== e1) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e1 && e1.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e1 && u(t, e1);
                    var o = c(n);
                    function n(e1, t, r) {
                        d(this, n);
                        t = (e1 = o.call(this, e1, t, r))._renderer.GL;
                        return e1.glMinFilter === t.LINEAR && (e1.glMinFilter = t.LINEAR_MIPMAP_LINEAR), e1;
                    }
                    return f(n, [
                        {
                            key: "glFilter",
                            value: function(e1) {
                                return this._renderer.GL.LINEAR_MIPMAP_LINEAR;
                            }
                        },
                        {
                            key: "_getTextureDataFromSource",
                            value: function() {
                                return this.src;
                            }
                        },
                        {
                            key: "init",
                            value: function(e1) {
                                var t = this._renderer.GL;
                                this.glTex = t.createTexture(), this.bindTexture();
                                for(var r = 0; r < e1.length; r++)t.texImage2D(this.glTarget, r, this.glFormat, this.glFormat, this.glDataType, e1[r]);
                                this.glMinFilter = t.LINEAR_MIPMAP_LINEAR, t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, this.glMagFilter), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, this.glMinFilter), this.unbindTexture();
                            }
                        },
                        {
                            key: "update",
                            value: function() {}
                        }
                    ]), n;
                }(s.default.Texture);
                function m(e1) {
                    var t = e1.GL, e1 = e1.webglVersion, r = e1 === a.WEBGL2 ? t.getExtension("EXT_color_buffer_float") && t.getExtension("EXT_float_blend") : t.getExtension("OES_texture_float"), o = r && t.getExtension("OES_texture_float_linear"), e1 = e1 === a.WEBGL2 ? t.getExtension("EXT_color_buffer_float") : t.getExtension("OES_texture_half_float");
                    return {
                        float: r,
                        floatLinear: o,
                        halfFloat: e1,
                        halfFloatLinear: e1 && t.getExtension("OES_texture_half_float_linear")
                    };
                }
                r.MipmapTexture = p;
                e1 = s.default.Texture;
                r.default = e1;
            },
            {
                "../core/constants": 272,
                "../core/main": 283,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.get-prototype-of": 188,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.reflect.construct": 192,
                "core-js/modules/es.regexp.to-string": 196,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.typed-array.copy-within": 213,
                "core-js/modules/es.typed-array.every": 214,
                "core-js/modules/es.typed-array.fill": 215,
                "core-js/modules/es.typed-array.filter": 216,
                "core-js/modules/es.typed-array.find": 218,
                "core-js/modules/es.typed-array.find-index": 217,
                "core-js/modules/es.typed-array.for-each": 221,
                "core-js/modules/es.typed-array.includes": 222,
                "core-js/modules/es.typed-array.index-of": 223,
                "core-js/modules/es.typed-array.iterator": 226,
                "core-js/modules/es.typed-array.join": 227,
                "core-js/modules/es.typed-array.last-index-of": 228,
                "core-js/modules/es.typed-array.map": 229,
                "core-js/modules/es.typed-array.reduce": 231,
                "core-js/modules/es.typed-array.reduce-right": 230,
                "core-js/modules/es.typed-array.reverse": 232,
                "core-js/modules/es.typed-array.set": 233,
                "core-js/modules/es.typed-array.slice": 234,
                "core-js/modules/es.typed-array.some": 235,
                "core-js/modules/es.typed-array.sort": 236,
                "core-js/modules/es.typed-array.subarray": 237,
                "core-js/modules/es.typed-array.to-locale-string": 238,
                "core-js/modules/es.typed-array.to-string": 239,
                "core-js/modules/es.typed-array.uint8-array": 242,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ],
        344: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.sub"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.sub"), e1("core-js/modules/web.dom-collections.iterator");
                var n, B = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                }, E = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function G(e1, t) {
                    if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function V(e1, t, r) {
                    t && s(e1.prototype, t), r && s(e1, r);
                }
                e1("./p5.Shader"), e1("./p5.RendererGL.Retained"), B.default.RendererGL.prototype._applyTextProperties = function() {
                    this._setProperty("_textAscent", null), this._setProperty("_textDescent", null);
                }, B.default.RendererGL.prototype.textWidth = function(e1) {
                    return this._isOpenType() ? this._textFont._textWidth(e1, this._textSize) : 0;
                };
                var l = function() {
                    function r(e1, t) {
                        G(this, r), this.width = e1, this.height = t, this.infos = [];
                    }
                    return V(r, [
                        {
                            key: "findImage",
                            value: function(e1) {
                                var t, r, o = this.width * this.height;
                                if (o < e1) throw new Error("font is too complex to render in 3D");
                                for(var n = this.infos.length - 1; 0 <= n; --n){
                                    var s = this.infos[n];
                                    if (s.index + e1 < o) {
                                        r = (t = s).imageData;
                                        break;
                                    }
                                }
                                if (!t) {
                                    try {
                                        r = new ImageData(this.width, this.height);
                                    } catch (e1) {
                                        var i = document.getElementsByTagName("canvas")[0], a = !i, l = (i || ((i = document.createElement("canvas")).style.display = "none", document.body.appendChild(i)), i.getContext("2d"));
                                        l && (r = l.createImageData(this.width, this.height)), a && document.body.removeChild(i);
                                    }
                                    this.infos.push(t = {
                                        index: 0,
                                        imageData: r
                                    });
                                }
                                l = t.index;
                                return t.index += e1, r._dirty = !0, {
                                    imageData: r,
                                    index: l
                                };
                            }
                        }
                    ]), r;
                }();
                function z(e1, t, r, o, n) {
                    var s = e1.imageData.data, e1 = 4 * e1.index++;
                    s[e1++] = t, s[e1++] = r, s[e1++] = o, s[+e1] = n;
                }
                var H = Math.sqrt(3), M = function() {
                    function t(e1) {
                        G(this, t), this.font = e1, this.strokeImageInfos = new l(64, 64), this.colDimImageInfos = new l(64, 64), this.rowDimImageInfos = new l(64, 64), this.colCellImageInfos = new l(64, 64), this.rowCellImageInfos = new l(64, 64), this.glyphInfos = {};
                    }
                    return V(t, [
                        {
                            key: "getGlyphInfo",
                            value: function(e1) {
                                var t = this.glyphInfos[e1.index];
                                if (!t) {
                                    var r = e1.getBoundingBox(), o = r.x1, n = r.y1, s = r.x2 - o, i = r.y2 - n, a = e1.path.commands;
                                    if (0 == s || 0 == i || !a.length) return this.glyphInfos[e1.index] = {};
                                    for(var u = [], c = [], d = [], l = 8; 0 <= l; --l)d.push([]);
                                    for(l = 8; 0 <= l; --l)c.push([]);
                                    var h, f, p, m, D = function() {
                                        function n(e1, t, r, o) {
                                            G(this, n), this.p0 = e1, this.c0 = t, this.c1 = r, this.p1 = o;
                                        }
                                        return V(n, [
                                            {
                                                key: "toQuadratic",
                                                value: function() {
                                                    return {
                                                        x: this.p0.x,
                                                        y: this.p0.y,
                                                        x1: this.p1.x,
                                                        y1: this.p1.y,
                                                        cx: (3 * (this.c0.x + this.c1.x) - (this.p0.x + this.p1.x)) / 4,
                                                        cy: (3 * (this.c0.y + this.c1.y) - (this.p0.y + this.p1.y)) / 4
                                                    };
                                                }
                                            },
                                            {
                                                key: "quadError",
                                                value: function() {
                                                    return B.default.Vector.sub(B.default.Vector.sub(this.p1, this.p0), B.default.Vector.mult(B.default.Vector.sub(this.c1, this.c0), 3)).mag() / 2;
                                                }
                                            },
                                            {
                                                key: "split",
                                                value: function(e1) {
                                                    var t = B.default.Vector.lerp(this.p0, this.c0, e1), r = B.default.Vector.lerp(this.c0, this.c1, e1), o = B.default.Vector.lerp(t, r, e1), r = (this.c1 = B.default.Vector.lerp(this.c1, this.p1, e1), this.c0 = B.default.Vector.lerp(r, this.c1, e1), B.default.Vector.lerp(o, this.c0, e1)), e1 = new n(this.p0, t, o, r);
                                                    return this.p0 = r, e1;
                                                }
                                            },
                                            {
                                                key: "splitInflections",
                                                value: function() {
                                                    var e1 = B.default.Vector.sub(this.c0, this.p0), t = B.default.Vector.sub(B.default.Vector.sub(this.c1, this.c0), e1), r = B.default.Vector.sub(B.default.Vector.sub(B.default.Vector.sub(this.p1, this.c1), e1), B.default.Vector.mult(t, 2)), o = [], n = t.x * r.y - t.y * r.x;
                                                    return 0 !== n && 0 <= (e1 = (r = e1.x * r.y - e1.y * r.x) * r - 4 * n * (e1.x * t.y - e1.y * t.x)) && (n < 0 && (n = -n, r = -r), e1 = (-r + (t = Math.sqrt(e1))) / (2 * n), 0 < (r = (-r - t) / (2 * n)) && r < 1 && (o.push(this.split(r)), e1 = 1 - (1 - e1) / (1 - r)), 0 < e1 && e1 < 1 && o.push(this.split(e1))), o.push(this), o;
                                                }
                                            }
                                        ]), n;
                                    }(), y = !0, g = !1, v = void 0;
                                    try {
                                        for(var b, _ = a[Symbol.iterator](); !(y = (b = _.next()).done); y = !0){
                                            var j = b.value, x = (j.x - o) / s, w = (j.y - n) / i;
                                            if (!U(h, f, x, w)) {
                                                switch(j.type){
                                                    case "M":
                                                        p = x, m = w;
                                                        break;
                                                    case "L":
                                                        I(h, f, x, w);
                                                        break;
                                                    case "Q":
                                                        var S = (j.x1 - o) / s, T = (j.y1 - n) / i;
                                                        L([
                                                            h,
                                                            x,
                                                            S
                                                        ], [
                                                            f,
                                                            w,
                                                            T
                                                        ], {
                                                            x: h,
                                                            y: f,
                                                            cx: S,
                                                            cy: T
                                                        });
                                                        break;
                                                    case "Z":
                                                        U(h, f, p, m) ? u.push({
                                                            x: h,
                                                            y: f
                                                        }) : (I(h, f, p, m), u.push({
                                                            x: p,
                                                            y: m
                                                        }));
                                                        break;
                                                    case "C":
                                                        for(var E = function(e1, t, r, o, n, s, i, a) {
                                                            var e1 = new D(new B.default.Vector(e1, t), new B.default.Vector(r, o), new B.default.Vector(n, s), new B.default.Vector(i, a)).splitInflections(), l = [], u = 30 / H, c = !0, t = !1, r = void 0;
                                                            try {
                                                                for(var d, h = e1[Symbol.iterator](); !(c = (d = h.next()).done); c = !0){
                                                                    for(var f = d.value, p = [], m = void 0; !(.125 <= (m = u / f.quadError()));){
                                                                        var y = Math.pow(m, 1 / 3), g = f.split(y), v = f.split(1 - y / (1 - y));
                                                                        l.push(g), p.push(f), f = v;
                                                                    }
                                                                    m < 1 && l.push(f.split(.5)), l.push(f), Array.prototype.push.apply(l, p.reverse());
                                                                }
                                                            } catch (e1) {
                                                                t = !0, r = e1;
                                                            } finally{
                                                                try {
                                                                    c || null == h.return || h.return();
                                                                } finally{
                                                                    if (t) throw r;
                                                                }
                                                            }
                                                            return l;
                                                        }(h, f, (j.x1 - o) / s, (j.y1 - n) / i, (j.x2 - o) / s, (j.y2 - n) / i, x, w), M = 0; M < E.length; M++){
                                                            var k = E[M].toQuadratic();
                                                            L([
                                                                k.x,
                                                                k.x1,
                                                                k.cx
                                                            ], [
                                                                k.y,
                                                                k.y1,
                                                                k.cy
                                                            ], k);
                                                        }
                                                        break;
                                                    default:
                                                        throw new Error("unknown command type: ".concat(j.type));
                                                }
                                                h = x, f = w;
                                            }
                                        }
                                    } catch (e1) {
                                        g = !0, v = e1;
                                    } finally{
                                        try {
                                            y || null == _.return || _.return();
                                        } finally{
                                            if (g) throw v;
                                        }
                                    }
                                    for(var O = u.length, C = this.strokeImageInfos.findImage(O), F = C.index, P = 0; P < O; ++P){
                                        var A = u[P];
                                        z(C, R(A.x), R(A.y), R(A.cx), R(A.cy));
                                    }
                                    (t = this.glyphInfos[e1.index] = {
                                        glyph: e1,
                                        uGlyphRect: [
                                            r.x1,
                                            -r.y1,
                                            r.x2,
                                            -r.y2
                                        ],
                                        strokeImageInfo: C,
                                        strokes: u,
                                        colInfo: N(d, this.colDimImageInfos, this.colCellImageInfos),
                                        rowInfo: N(c, this.rowDimImageInfos, this.rowCellImageInfos)
                                    }).uGridOffset = [
                                        t.colInfo.dimOffset,
                                        t.rowInfo.dimOffset
                                    ];
                                }
                                return t;
                                function L(e1, t, r) {
                                    var o = u.length;
                                    function n(e1, t, r) {
                                        for(var o = e1.length; 0 < o--;){
                                            var n = e1[o];
                                            n < t && (t = n), r < n && (r = n);
                                        }
                                        return {
                                            min: t,
                                            max: r
                                        };
                                    }
                                    u.push(r);
                                    for(var r = n(e1, 1, 0), e1 = Math.max(Math.floor(9 * r.min - .5), 0), s = Math.min(Math.ceil(9 * r.max + .5), 9), i = e1; i < s; ++i)d[i].push(o);
                                    for(var r = n(t, 1, 0), e1 = Math.max(Math.floor(9 * r.min - .5), 0), a = Math.min(Math.ceil(9 * r.max + .5), 9), l = e1; l < a; ++l)c[l].push(o);
                                }
                                function R(e1) {
                                    var t, r;
                                    return (e1 = (r = 255) * e1) < (t = 0) ? t : r < e1 ? r : e1;
                                }
                                function I(e1, t, r, o) {
                                    L([
                                        e1,
                                        r
                                    ], [
                                        t,
                                        o
                                    ], {
                                        x: e1,
                                        y: t,
                                        cx: (e1 + r) / 2,
                                        cy: (t + o) / 2
                                    });
                                }
                                function U(e1, t, r, o) {
                                    return Math.abs(r - e1) < 1e-5 && Math.abs(o - t) < 1e-5;
                                }
                                function N(e1, t, r) {
                                    for(var o = e1.length, n = t.findImage(o), t = n.index, s = 0, i = 0; i < o; ++i)s += e1[i].length;
                                    for(var a = r.findImage(s), l = 0; l < o; ++l){
                                        var u = e1[l], c = u.length, d = a.index;
                                        z(n, d >> 7, 127 & d, c >> 7, 127 & c);
                                        for(var h = 0; h < c; ++h){
                                            var f = u[h] + F;
                                            z(a, f >> 7, 127 & f, 0, 0);
                                        }
                                    }
                                    return {
                                        cellImageInfo: a,
                                        dimOffset: t,
                                        dimImageInfo: n
                                    };
                                }
                            }
                        }
                    ]), t;
                }();
                B.default.RendererGL.prototype._renderText = function(e1, t, r, o, n) {
                    if (this._textFont && "string" != typeof this._textFont) {
                        if (!(n <= o) && this._doFill) {
                            if (this._isOpenType()) {
                                e1.push();
                                var n = this._doStroke, s = this.drawMode, i = (this._doStroke = !1, this.drawMode = E.TEXTURE, this._textFont.font), a = (a = this._textFont._fontInfo) || (this._textFont._fontInfo = new M(i)), r = this._textFont._handleAlignment(this, t, r, o), o = this._textSize / i.unitsPerEm, l = (this.translate(r.x, r.y, 0), this.scale(o, o, 1), this.GL), r = !this._defaultFontShader, u = this._getFontShader(), c = (u.init(), u.bindShader(), r && (u.setUniform("uGridImageSize", [
                                    64,
                                    64
                                ]), u.setUniform("uCellsImageSize", [
                                    64,
                                    64
                                ]), u.setUniform("uStrokeImageSize", [
                                    64,
                                    64
                                ]), u.setUniform("uGridSize", [
                                    9,
                                    9
                                ])), this._applyColorBlend(this.curFillColor), this.retainedMode.geometry.glyph), d = (c || ((o = this._textGeom = new B.default.Geometry(1, 1, function() {
                                    for(var e1 = 0; e1 <= 1; e1++)for(var t = 0; t <= 1; t++)this.vertices.push(new B.default.Vector(t, e1, 0)), this.uvs.push(t, e1);
                                })).computeFaces().computeNormals(), c = this.createBuffers("glyph", o)), !0), r = !1, o = void 0;
                                try {
                                    for(var h, f = this.retainedMode.buffers.text[Symbol.iterator](); !(d = (h = f.next()).done); d = !0)h.value._prepareBuffer(c, u);
                                } catch (e1) {
                                    r = !0, o = e1;
                                } finally{
                                    try {
                                        d || null == f.return || f.return();
                                    } finally{
                                        if (r) throw o;
                                    }
                                }
                                this._bindBuffer(c.indexBuffer, l.ELEMENT_ARRAY_BUFFER), u.setUniform("uMaterialColor", this.curFillColor), l.pixelStorei(l.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1);
                                try {
                                    var p = 0, m = null, y = i.stringToGlyphs(t), g = !0, v = !1, b = void 0;
                                    try {
                                        for(var _, j = y[Symbol.iterator](); !(g = (_ = j.next()).done); g = !0){
                                            var x, w, S = _.value, T = (m && (p += i.getKerningValue(m, S)), a.getGlyphInfo(S));
                                            T.uGlyphRect && (x = T.rowInfo, w = T.colInfo, u.setUniform("uSamplerStrokes", T.strokeImageInfo.imageData), u.setUniform("uSamplerRowStrokes", x.cellImageInfo.imageData), u.setUniform("uSamplerRows", x.dimImageInfo.imageData), u.setUniform("uSamplerColStrokes", w.cellImageInfo.imageData), u.setUniform("uSamplerCols", w.dimImageInfo.imageData), u.setUniform("uGridOffset", T.uGridOffset), u.setUniform("uGlyphRect", T.uGlyphRect), u.setUniform("uGlyphOffset", p), u.bindTextures(), l.drawElements(l.TRIANGLES, 6, this.GL.UNSIGNED_SHORT, 0)), p += S.advanceWidth, m = S;
                                        }
                                    } catch (e1) {
                                        v = !0, b = e1;
                                    } finally{
                                        try {
                                            g || null == j.return || j.return();
                                        } finally{
                                            if (v) throw b;
                                        }
                                    }
                                } finally{
                                    u.unbindShader(), this._doStroke = n, this.drawMode = s, l.pixelStorei(l.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0), e1.pop();
                                }
                            } else console.log("WEBGL: only Opentype (.otf) and Truetype (.ttf) fonts are supported. Make sure to set the font using textFont() before drawing text.");
                            return e1;
                        }
                    } else console.log("WEBGL: you must load and set a font before drawing text. See `loadFont` and `textFont` for more details.");
                };
            },
            {
                "../core/constants": 272,
                "../core/main": 283,
                "./p5.RendererGL.Retained": 340,
                "./p5.Shader": 342,
                "core-js/modules/es.array.iterator": 165,
                "core-js/modules/es.object.get-own-property-descriptor": 186,
                "core-js/modules/es.object.to-string": 190,
                "core-js/modules/es.regexp.exec": 195,
                "core-js/modules/es.string.iterator": 200,
                "core-js/modules/es.string.split": 206,
                "core-js/modules/es.string.sub": 208,
                "core-js/modules/es.symbol": 212,
                "core-js/modules/es.symbol.description": 210,
                "core-js/modules/es.symbol.iterator": 211,
                "core-js/modules/es.weak-map": 244,
                "core-js/modules/web.dom-collections.iterator": 246
            }
        ]
    }, {}, [
        267
    ])(267);
});


var $0f0d0cb2aeb32558$exports = {};
/*
 * Ben Postlethwaite
 * January 2013
 * License MIT
 */ 'use strict';
var $2dac8b613c9499d3$exports = {};
$2dac8b613c9499d3$exports = {
    "jet": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                131
            ]
        },
        {
            "index": 0.125,
            "rgb": [
                0,
                60,
                170
            ]
        },
        {
            "index": 0.375,
            "rgb": [
                5,
                255,
                255
            ]
        },
        {
            "index": 0.625,
            "rgb": [
                255,
                255,
                0
            ]
        },
        {
            "index": 0.875,
            "rgb": [
                250,
                0,
                0
            ]
        },
        {
            "index": 1,
            "rgb": [
                128,
                0,
                0
            ]
        }
    ],
    "hsv": [
        {
            "index": 0,
            "rgb": [
                255,
                0,
                0
            ]
        },
        {
            "index": 0.169,
            "rgb": [
                253,
                255,
                2
            ]
        },
        {
            "index": 0.173,
            "rgb": [
                247,
                255,
                2
            ]
        },
        {
            "index": 0.337,
            "rgb": [
                0,
                252,
                4
            ]
        },
        {
            "index": 0.341,
            "rgb": [
                0,
                252,
                10
            ]
        },
        {
            "index": 0.506,
            "rgb": [
                1,
                249,
                255
            ]
        },
        {
            "index": 0.671,
            "rgb": [
                2,
                0,
                253
            ]
        },
        {
            "index": 0.675,
            "rgb": [
                8,
                0,
                253
            ]
        },
        {
            "index": 0.839,
            "rgb": [
                255,
                0,
                251
            ]
        },
        {
            "index": 0.843,
            "rgb": [
                255,
                0,
                245
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                0,
                6
            ]
        }
    ],
    "hot": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                0
            ]
        },
        {
            "index": 0.3,
            "rgb": [
                230,
                0,
                0
            ]
        },
        {
            "index": 0.6,
            "rgb": [
                255,
                210,
                0
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                255,
                255
            ]
        }
    ],
    "spring": [
        {
            "index": 0,
            "rgb": [
                255,
                0,
                255
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                255,
                0
            ]
        }
    ],
    "summer": [
        {
            "index": 0,
            "rgb": [
                0,
                128,
                102
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                255,
                102
            ]
        }
    ],
    "autumn": [
        {
            "index": 0,
            "rgb": [
                255,
                0,
                0
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                255,
                0
            ]
        }
    ],
    "winter": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                255
            ]
        },
        {
            "index": 1,
            "rgb": [
                0,
                255,
                128
            ]
        }
    ],
    "bone": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                0
            ]
        },
        {
            "index": 0.376,
            "rgb": [
                84,
                84,
                116
            ]
        },
        {
            "index": 0.753,
            "rgb": [
                169,
                200,
                200
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                255,
                255
            ]
        }
    ],
    "copper": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                0
            ]
        },
        {
            "index": 0.804,
            "rgb": [
                255,
                160,
                102
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                199,
                127
            ]
        }
    ],
    "greys": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                0
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                255,
                255
            ]
        }
    ],
    "yignbu": [
        {
            "index": 0,
            "rgb": [
                8,
                29,
                88
            ]
        },
        {
            "index": 0.125,
            "rgb": [
                37,
                52,
                148
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                34,
                94,
                168
            ]
        },
        {
            "index": 0.375,
            "rgb": [
                29,
                145,
                192
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                65,
                182,
                196
            ]
        },
        {
            "index": 0.625,
            "rgb": [
                127,
                205,
                187
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                199,
                233,
                180
            ]
        },
        {
            "index": 0.875,
            "rgb": [
                237,
                248,
                217
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                255,
                217
            ]
        }
    ],
    "greens": [
        {
            "index": 0,
            "rgb": [
                0,
                68,
                27
            ]
        },
        {
            "index": 0.125,
            "rgb": [
                0,
                109,
                44
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                35,
                139,
                69
            ]
        },
        {
            "index": 0.375,
            "rgb": [
                65,
                171,
                93
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                116,
                196,
                118
            ]
        },
        {
            "index": 0.625,
            "rgb": [
                161,
                217,
                155
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                199,
                233,
                192
            ]
        },
        {
            "index": 0.875,
            "rgb": [
                229,
                245,
                224
            ]
        },
        {
            "index": 1,
            "rgb": [
                247,
                252,
                245
            ]
        }
    ],
    "yiorrd": [
        {
            "index": 0,
            "rgb": [
                128,
                0,
                38
            ]
        },
        {
            "index": 0.125,
            "rgb": [
                189,
                0,
                38
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                227,
                26,
                28
            ]
        },
        {
            "index": 0.375,
            "rgb": [
                252,
                78,
                42
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                253,
                141,
                60
            ]
        },
        {
            "index": 0.625,
            "rgb": [
                254,
                178,
                76
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                254,
                217,
                118
            ]
        },
        {
            "index": 0.875,
            "rgb": [
                255,
                237,
                160
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                255,
                204
            ]
        }
    ],
    "bluered": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                255
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                0,
                0
            ]
        }
    ],
    "rdbu": [
        {
            "index": 0,
            "rgb": [
                5,
                10,
                172
            ]
        },
        {
            "index": 0.35,
            "rgb": [
                106,
                137,
                247
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                190,
                190,
                190
            ]
        },
        {
            "index": 0.6,
            "rgb": [
                220,
                170,
                132
            ]
        },
        {
            "index": 0.7,
            "rgb": [
                230,
                145,
                90
            ]
        },
        {
            "index": 1,
            "rgb": [
                178,
                10,
                28
            ]
        }
    ],
    "picnic": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                255
            ]
        },
        {
            "index": 0.1,
            "rgb": [
                51,
                153,
                255
            ]
        },
        {
            "index": 0.2,
            "rgb": [
                102,
                204,
                255
            ]
        },
        {
            "index": 0.3,
            "rgb": [
                153,
                204,
                255
            ]
        },
        {
            "index": 0.4,
            "rgb": [
                204,
                204,
                255
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                255,
                255,
                255
            ]
        },
        {
            "index": 0.6,
            "rgb": [
                255,
                204,
                255
            ]
        },
        {
            "index": 0.7,
            "rgb": [
                255,
                153,
                255
            ]
        },
        {
            "index": 0.8,
            "rgb": [
                255,
                102,
                204
            ]
        },
        {
            "index": 0.9,
            "rgb": [
                255,
                102,
                102
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                0,
                0
            ]
        }
    ],
    "rainbow": [
        {
            "index": 0,
            "rgb": [
                150,
                0,
                90
            ]
        },
        {
            "index": 0.125,
            "rgb": [
                0,
                0,
                200
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                0,
                25,
                255
            ]
        },
        {
            "index": 0.375,
            "rgb": [
                0,
                152,
                255
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                44,
                255,
                150
            ]
        },
        {
            "index": 0.625,
            "rgb": [
                151,
                255,
                0
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                255,
                234,
                0
            ]
        },
        {
            "index": 0.875,
            "rgb": [
                255,
                111,
                0
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                0,
                0
            ]
        }
    ],
    "portland": [
        {
            "index": 0,
            "rgb": [
                12,
                51,
                131
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                10,
                136,
                186
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                242,
                211,
                56
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                242,
                143,
                56
            ]
        },
        {
            "index": 1,
            "rgb": [
                217,
                30,
                30
            ]
        }
    ],
    "blackbody": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                0
            ]
        },
        {
            "index": 0.2,
            "rgb": [
                230,
                0,
                0
            ]
        },
        {
            "index": 0.4,
            "rgb": [
                230,
                210,
                0
            ]
        },
        {
            "index": 0.7,
            "rgb": [
                255,
                255,
                255
            ]
        },
        {
            "index": 1,
            "rgb": [
                160,
                200,
                255
            ]
        }
    ],
    "earth": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                130
            ]
        },
        {
            "index": 0.1,
            "rgb": [
                0,
                180,
                180
            ]
        },
        {
            "index": 0.2,
            "rgb": [
                40,
                210,
                40
            ]
        },
        {
            "index": 0.4,
            "rgb": [
                230,
                230,
                50
            ]
        },
        {
            "index": 0.6,
            "rgb": [
                120,
                70,
                20
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                255,
                255
            ]
        }
    ],
    "electric": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                0
            ]
        },
        {
            "index": 0.15,
            "rgb": [
                30,
                0,
                100
            ]
        },
        {
            "index": 0.4,
            "rgb": [
                120,
                0,
                100
            ]
        },
        {
            "index": 0.6,
            "rgb": [
                160,
                90,
                0
            ]
        },
        {
            "index": 0.8,
            "rgb": [
                230,
                200,
                0
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                250,
                220
            ]
        }
    ],
    "alpha": [
        {
            "index": 0,
            "rgb": [
                255,
                255,
                255,
                0
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                255,
                255,
                1
            ]
        }
    ],
    "viridis": [
        {
            "index": 0,
            "rgb": [
                68,
                1,
                84
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                71,
                44,
                122
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                59,
                81,
                139
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                44,
                113,
                142
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                33,
                144,
                141
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                39,
                173,
                129
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                92,
                200,
                99
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                170,
                220,
                50
            ]
        },
        {
            "index": 1,
            "rgb": [
                253,
                231,
                37
            ]
        }
    ],
    "inferno": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                4
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                31,
                12,
                72
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                85,
                15,
                109
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                136,
                34,
                106
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                186,
                54,
                85
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                227,
                89,
                51
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                249,
                140,
                10
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                249,
                201,
                50
            ]
        },
        {
            "index": 1,
            "rgb": [
                252,
                255,
                164
            ]
        }
    ],
    "magma": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                4
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                28,
                16,
                68
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                79,
                18,
                123
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                129,
                37,
                129
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                181,
                54,
                122
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                229,
                80,
                100
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                251,
                135,
                97
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                254,
                194,
                135
            ]
        },
        {
            "index": 1,
            "rgb": [
                252,
                253,
                191
            ]
        }
    ],
    "plasma": [
        {
            "index": 0,
            "rgb": [
                13,
                8,
                135
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                75,
                3,
                161
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                125,
                3,
                168
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                168,
                34,
                150
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                203,
                70,
                121
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                229,
                107,
                93
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                248,
                148,
                65
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                253,
                195,
                40
            ]
        },
        {
            "index": 1,
            "rgb": [
                240,
                249,
                33
            ]
        }
    ],
    "warm": [
        {
            "index": 0,
            "rgb": [
                125,
                0,
                179
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                172,
                0,
                187
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                219,
                0,
                170
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                255,
                0,
                130
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                255,
                63,
                74
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                255,
                123,
                0
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                234,
                176,
                0
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                190,
                228,
                0
            ]
        },
        {
            "index": 1,
            "rgb": [
                147,
                255,
                0
            ]
        }
    ],
    "cool": [
        {
            "index": 0,
            "rgb": [
                125,
                0,
                179
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                116,
                0,
                218
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                98,
                74,
                237
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                68,
                146,
                231
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                0,
                204,
                197
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                0,
                247,
                146
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                0,
                255,
                88
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                40,
                255,
                8
            ]
        },
        {
            "index": 1,
            "rgb": [
                147,
                255,
                0
            ]
        }
    ],
    "rainbow-soft": [
        {
            "index": 0,
            "rgb": [
                125,
                0,
                179
            ]
        },
        {
            "index": 0.1,
            "rgb": [
                199,
                0,
                180
            ]
        },
        {
            "index": 0.2,
            "rgb": [
                255,
                0,
                121
            ]
        },
        {
            "index": 0.3,
            "rgb": [
                255,
                108,
                0
            ]
        },
        {
            "index": 0.4,
            "rgb": [
                222,
                194,
                0
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                150,
                255,
                0
            ]
        },
        {
            "index": 0.6,
            "rgb": [
                0,
                255,
                55
            ]
        },
        {
            "index": 0.7,
            "rgb": [
                0,
                246,
                150
            ]
        },
        {
            "index": 0.8,
            "rgb": [
                50,
                167,
                222
            ]
        },
        {
            "index": 0.9,
            "rgb": [
                103,
                51,
                235
            ]
        },
        {
            "index": 1,
            "rgb": [
                124,
                0,
                186
            ]
        }
    ],
    "bathymetry": [
        {
            "index": 0,
            "rgb": [
                40,
                26,
                44
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                59,
                49,
                90
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                64,
                76,
                139
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                63,
                110,
                151
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                72,
                142,
                158
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                85,
                174,
                163
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                120,
                206,
                163
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                187,
                230,
                172
            ]
        },
        {
            "index": 1,
            "rgb": [
                253,
                254,
                204
            ]
        }
    ],
    "cdom": [
        {
            "index": 0,
            "rgb": [
                47,
                15,
                62
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                87,
                23,
                86
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                130,
                28,
                99
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                171,
                41,
                96
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                206,
                67,
                86
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                230,
                106,
                84
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                242,
                149,
                103
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                249,
                193,
                135
            ]
        },
        {
            "index": 1,
            "rgb": [
                254,
                237,
                176
            ]
        }
    ],
    "chlorophyll": [
        {
            "index": 0,
            "rgb": [
                18,
                36,
                20
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                25,
                63,
                41
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                24,
                91,
                59
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                13,
                119,
                72
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                18,
                148,
                80
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                80,
                173,
                89
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                132,
                196,
                122
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                175,
                221,
                162
            ]
        },
        {
            "index": 1,
            "rgb": [
                215,
                249,
                208
            ]
        }
    ],
    "density": [
        {
            "index": 0,
            "rgb": [
                54,
                14,
                36
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                89,
                23,
                80
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                110,
                45,
                132
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                120,
                77,
                178
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                120,
                113,
                213
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                115,
                151,
                228
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                134,
                185,
                227
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                177,
                214,
                227
            ]
        },
        {
            "index": 1,
            "rgb": [
                230,
                241,
                241
            ]
        }
    ],
    "freesurface-blue": [
        {
            "index": 0,
            "rgb": [
                30,
                4,
                110
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                47,
                14,
                176
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                41,
                45,
                236
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                25,
                99,
                212
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                68,
                131,
                200
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                114,
                156,
                197
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                157,
                181,
                203
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                200,
                208,
                216
            ]
        },
        {
            "index": 1,
            "rgb": [
                241,
                237,
                236
            ]
        }
    ],
    "freesurface-red": [
        {
            "index": 0,
            "rgb": [
                60,
                9,
                18
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                100,
                17,
                27
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                142,
                20,
                29
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                177,
                43,
                27
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                192,
                87,
                63
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                205,
                125,
                105
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                216,
                162,
                148
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                227,
                199,
                193
            ]
        },
        {
            "index": 1,
            "rgb": [
                241,
                237,
                236
            ]
        }
    ],
    "oxygen": [
        {
            "index": 0,
            "rgb": [
                64,
                5,
                5
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                106,
                6,
                15
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                144,
                26,
                7
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                168,
                64,
                3
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                188,
                100,
                4
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                206,
                136,
                11
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                220,
                174,
                25
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                231,
                215,
                44
            ]
        },
        {
            "index": 1,
            "rgb": [
                248,
                254,
                105
            ]
        }
    ],
    "par": [
        {
            "index": 0,
            "rgb": [
                51,
                20,
                24
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                90,
                32,
                35
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                129,
                44,
                34
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                159,
                68,
                25
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                182,
                99,
                19
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                199,
                134,
                22
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                212,
                171,
                35
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                221,
                210,
                54
            ]
        },
        {
            "index": 1,
            "rgb": [
                225,
                253,
                75
            ]
        }
    ],
    "phase": [
        {
            "index": 0,
            "rgb": [
                145,
                105,
                18
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                184,
                71,
                38
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                186,
                58,
                115
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                160,
                71,
                185
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                110,
                97,
                218
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                50,
                123,
                164
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                31,
                131,
                110
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                77,
                129,
                34
            ]
        },
        {
            "index": 1,
            "rgb": [
                145,
                105,
                18
            ]
        }
    ],
    "salinity": [
        {
            "index": 0,
            "rgb": [
                42,
                24,
                108
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                33,
                50,
                162
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                15,
                90,
                145
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                40,
                118,
                137
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                59,
                146,
                135
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                79,
                175,
                126
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                120,
                203,
                104
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                193,
                221,
                100
            ]
        },
        {
            "index": 1,
            "rgb": [
                253,
                239,
                154
            ]
        }
    ],
    "temperature": [
        {
            "index": 0,
            "rgb": [
                4,
                35,
                51
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                23,
                51,
                122
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                85,
                59,
                157
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                129,
                79,
                143
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                175,
                95,
                130
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                222,
                112,
                101
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                249,
                146,
                66
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                249,
                196,
                65
            ]
        },
        {
            "index": 1,
            "rgb": [
                232,
                250,
                91
            ]
        }
    ],
    "turbidity": [
        {
            "index": 0,
            "rgb": [
                34,
                31,
                27
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                65,
                50,
                41
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                98,
                69,
                52
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                131,
                89,
                57
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                161,
                112,
                59
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                185,
                140,
                66
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                202,
                174,
                88
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                216,
                209,
                126
            ]
        },
        {
            "index": 1,
            "rgb": [
                233,
                246,
                171
            ]
        }
    ],
    "velocity-blue": [
        {
            "index": 0,
            "rgb": [
                17,
                32,
                64
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                35,
                52,
                116
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                29,
                81,
                156
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                31,
                113,
                162
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                50,
                144,
                169
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                87,
                173,
                176
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                149,
                196,
                189
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                203,
                221,
                211
            ]
        },
        {
            "index": 1,
            "rgb": [
                254,
                251,
                230
            ]
        }
    ],
    "velocity-green": [
        {
            "index": 0,
            "rgb": [
                23,
                35,
                19
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                24,
                64,
                38
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                11,
                95,
                45
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                39,
                123,
                35
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                95,
                146,
                12
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                152,
                165,
                18
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                201,
                186,
                69
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                233,
                216,
                137
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                253,
                205
            ]
        }
    ],
    "cubehelix": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                0
            ]
        },
        {
            "index": 0.07,
            "rgb": [
                22,
                5,
                59
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                60,
                4,
                105
            ]
        },
        {
            "index": 0.2,
            "rgb": [
                109,
                1,
                135
            ]
        },
        {
            "index": 0.27,
            "rgb": [
                161,
                0,
                147
            ]
        },
        {
            "index": 0.33,
            "rgb": [
                210,
                2,
                142
            ]
        },
        {
            "index": 0.4,
            "rgb": [
                251,
                11,
                123
            ]
        },
        {
            "index": 0.47,
            "rgb": [
                255,
                29,
                97
            ]
        },
        {
            "index": 0.53,
            "rgb": [
                255,
                54,
                69
            ]
        },
        {
            "index": 0.6,
            "rgb": [
                255,
                85,
                46
            ]
        },
        {
            "index": 0.67,
            "rgb": [
                255,
                120,
                34
            ]
        },
        {
            "index": 0.73,
            "rgb": [
                255,
                157,
                37
            ]
        },
        {
            "index": 0.8,
            "rgb": [
                241,
                191,
                57
            ]
        },
        {
            "index": 0.87,
            "rgb": [
                224,
                220,
                93
            ]
        },
        {
            "index": 0.93,
            "rgb": [
                218,
                241,
                142
            ]
        },
        {
            "index": 1,
            "rgb": [
                227,
                253,
                198
            ]
        }
    ]
};


var $47adcb215a7fbfed$exports = {};
function $47adcb215a7fbfed$var$lerp(v0, v1, t) {
    return v0 * (1 - t) + v1 * t;
}
$47adcb215a7fbfed$exports = $47adcb215a7fbfed$var$lerp;


$0f0d0cb2aeb32558$exports = $0f0d0cb2aeb32558$var$createColormap;
function $0f0d0cb2aeb32558$var$createColormap(spec) {
    /*
     * Default Options
     */ var indicies, fromrgba, torgba, nsteps, cmap, colormap, format, nshades, colors, alpha, i;
    if (!spec) spec = {};
    nshades = (spec.nshades || 72) - 1;
    format = spec.format || 'hex';
    colormap = spec.colormap;
    if (!colormap) colormap = 'jet';
    if (typeof colormap === 'string') {
        colormap = colormap.toLowerCase();
        if (!$2dac8b613c9499d3$exports[colormap]) throw Error(colormap + ' not a supported colorscale');
        cmap = $2dac8b613c9499d3$exports[colormap];
    } else if (Array.isArray(colormap)) cmap = colormap.slice();
    else throw Error('unsupported colormap option', colormap);
    if (cmap.length > nshades + 1) throw new Error(colormap + ' map requires nshades to be at least size ' + cmap.length);
    if (!Array.isArray(spec.alpha)) {
        if (typeof spec.alpha === 'number') alpha = [
            spec.alpha,
            spec.alpha
        ];
        else alpha = [
            1,
            1
        ];
    } else if (spec.alpha.length !== 2) alpha = [
        1,
        1
    ];
    else alpha = spec.alpha.slice();
    // map index points from 0..1 to 0..n-1
    indicies = cmap.map(function(c) {
        return Math.round(c.index * nshades);
    });
    // Add alpha channel to the map
    alpha[0] = Math.min(Math.max(alpha[0], 0), 1);
    alpha[1] = Math.min(Math.max(alpha[1], 0), 1);
    var steps = cmap.map(function(c, i) {
        var index = cmap[i].index;
        var rgba = cmap[i].rgb.slice();
        // if user supplies their own map use it
        if (rgba.length === 4 && rgba[3] >= 0 && rgba[3] <= 1) return rgba;
        rgba[3] = alpha[0] + (alpha[1] - alpha[0]) * index;
        return rgba;
    });
    /*
     * map increasing linear values between indicies to
     * linear steps in colorvalues
     */ var colors = [];
    for(i = 0; i < indicies.length - 1; ++i){
        nsteps = indicies[i + 1] - indicies[i];
        fromrgba = steps[i];
        torgba = steps[i + 1];
        for(var j = 0; j < nsteps; j++){
            var amt = j / nsteps;
            colors.push([
                Math.round($47adcb215a7fbfed$exports(fromrgba[0], torgba[0], amt)),
                Math.round($47adcb215a7fbfed$exports(fromrgba[1], torgba[1], amt)),
                Math.round($47adcb215a7fbfed$exports(fromrgba[2], torgba[2], amt)),
                $47adcb215a7fbfed$exports(fromrgba[3], torgba[3], amt)
            ]);
        }
    }
    //add 1 step as last value
    colors.push(cmap[cmap.length - 1].rgb.concat(alpha[1]));
    if (format === 'hex') colors = colors.map($0f0d0cb2aeb32558$var$rgb2hex);
    else if (format === 'rgbaString') colors = colors.map($0f0d0cb2aeb32558$var$rgbaStr);
    else if (format === 'float') colors = colors.map($0f0d0cb2aeb32558$var$rgb2float);
    return colors;
}
function $0f0d0cb2aeb32558$var$rgb2float(rgba) {
    return [
        rgba[0] / 255,
        rgba[1] / 255,
        rgba[2] / 255,
        rgba[3]
    ];
}
function $0f0d0cb2aeb32558$var$rgb2hex(rgba) {
    var dig, hex = '#';
    for(var i = 0; i < 3; ++i){
        dig = rgba[i];
        dig = dig.toString(16);
        hex += ('00' + dig).substr(dig.length);
    }
    return hex;
}
function $0f0d0cb2aeb32558$var$rgbaStr(rgba) {
    return 'rgba(' + rgba.join(',') + ')';
}


function* $df5bef30413a053b$export$d02631cccf789723(endExclusive) {
    for(let i = 0; i < endExclusive; i++)yield i;
}
function $df5bef30413a053b$export$f847671e70d229f9(arrayLength, filler) {
    return Array.from($df5bef30413a053b$export$d02631cccf789723(arrayLength)).map(filler);
}
function $df5bef30413a053b$export$842a2cf37af977e1(m, n) {
    return (m % n + n) % n;
}
function $df5bef30413a053b$export$82a8af9b11518516(errorMessage) {
    throw new Error(errorMessage);
}
function $df5bef30413a053b$export$19fa182fb736e81a(maxExclusive) {
    return Math.floor(Math.random() * maxExclusive);
}
function $df5bef30413a053b$export$4dc0b9eca0839ce2(minInclusive, maxInclusive) {
    const rangeSize = maxInclusive - minInclusive + 1;
    return $df5bef30413a053b$export$19fa182fb736e81a(rangeSize) + minInclusive;
}
function $df5bef30413a053b$export$395447ccdde518e(array) {
    return array[$df5bef30413a053b$export$19fa182fb736e81a(array.length)];
}
function $df5bef30413a053b$export$9cd59f9826255e47(obj) {
    return JSON.parse(JSON.stringify(obj));
}


const $ad2bcec7a0192558$var$COLORMAP_NAMES = Object.freeze([
    'bone',
    'cdom',
    'chlorophyll',
    'cool',
    'bathymetry',
    'blackbody',
    'density',
    'freesurface-red',
    'greys',
    'inferno',
    'jet',
    'magma',
    'picnic',
    'portland',
    'rainbow-soft',
    'rdbu',
    'salinity',
    'summer',
    'temperature',
    'velocity-blue',
    'viridis',
    'warm',
    'yignbu',
    'yiorrd'
]);
const $ad2bcec7a0192558$var$RULE_TO_TURN = Object.freeze({
    L: $ad2bcec7a0192558$var$left,
    R: $ad2bcec7a0192558$var$right,
    N: $ad2bcec7a0192558$var$noChange
});
const $ad2bcec7a0192558$var$AVAILABLE_RULES = Object.freeze(Object.keys($ad2bcec7a0192558$var$RULE_TO_TURN).sort());
const $ad2bcec7a0192558$var$CANVAS_SIZE = 800;
const $ad2bcec7a0192558$var$POTENTIAL_CELL_SIZES = [
    0.01,
    0.005
].map((percentage)=>$ad2bcec7a0192558$var$CANVAS_SIZE * percentage);
$ad2bcec7a0192558$var$POTENTIAL_CELL_SIZES.forEach((size)=>console.assert(Number.isInteger(size), `Cell size is not an integer: ${size}`));
function $ad2bcec7a0192558$var$generateConditions(colorConverter) {
    const cellSize = (0, $df5bef30413a053b$export$395447ccdde518e)($ad2bcec7a0192558$var$POTENTIAL_CELL_SIZES);
    const cellsPerSide = $ad2bcec7a0192558$var$CANVAS_SIZE / cellSize;
    const antCount = (0, $df5bef30413a053b$export$4dc0b9eca0839ce2)(1, 4);
    const randomCell = ()=>(0, $df5bef30413a053b$export$19fa182fb736e81a)(cellsPerSide);
    const initialAntPositions = (0, $df5bef30413a053b$export$f847671e70d229f9)(antCount, ()=>({
            row: randomCell(),
            col: randomCell()
        }));
    const rule = function() {
        function generateRule() {
            const ruleLength = (0, $df5bef30413a053b$export$4dc0b9eca0839ce2)(2, 8);
            return (0, $df5bef30413a053b$export$f847671e70d229f9)(ruleLength, ()=>(0, $df5bef30413a053b$export$395447ccdde518e)($ad2bcec7a0192558$var$AVAILABLE_RULES));
        }
        function isRuleValid(potentialRule) {
            return potentialRule.some((c)=>c === 'L') && potentialRule.some((c)=>c === 'R');
        }
        let potentialRule;
        do potentialRule = generateRule();
        while (!isRuleValid(potentialRule));
        return potentialRule;
    }();
    // `createColormap()` requires values for `nshades` larger than
    // the number of rules we often have, so multiply the number of colors
    // by a fixed amount to work around that problem.
    const COLOR_MAP_FACTOR = 10;
    const colorMap = (0, (/*@__PURE__*/$parcel$interopDefault($0f0d0cb2aeb32558$exports)))({
        nshades: rule.length * COLOR_MAP_FACTOR,
        colormap: (0, $df5bef30413a053b$export$395447ccdde518e)($ad2bcec7a0192558$var$COLORMAP_NAMES),
        format: 'hex'
    }).map(colorConverter);
    const backgroundColor = colorMap[0];
    const antColor = colorMap[colorMap.length - 1];
    const getColor = (colorIndex)=>colorMap[colorIndex * COLOR_MAP_FACTOR];
    const { incrementColorIndex: incrementColorIndex, turns: turns } = $ad2bcec7a0192558$var$parseRule(rule);
    const stepsPerFrame = (0, $df5bef30413a053b$export$4dc0b9eca0839ce2)(1, 40);
    return Object.freeze({
        antCount: antCount,
        initialAntPositions: initialAntPositions,
        cellsPerSide: cellsPerSide,
        cellSize: cellSize,
        rule: rule.join(''),
        incrementColorIndex: incrementColorIndex,
        turns: turns,
        backgroundColor: backgroundColor,
        antColor: antColor,
        getColor: getColor,
        stepsPerFrame: stepsPerFrame
    });
}
function $ad2bcec7a0192558$var$generateState(conditions) {
    const { initialAntPositions: initialAntPositions, cellsPerSide: cellsPerSide } = conditions;
    const ants = initialAntPositions.map((pos)=>({
            ...pos,
            direction: 0
        }));
    const grid = (0, $df5bef30413a053b$export$f847671e70d229f9)(cellsPerSide, ()=>(0, $df5bef30413a053b$export$f847671e70d229f9)(cellsPerSide, ()=>0));
    return {
        conditions: conditions,
        ants: ants,
        grid: grid,
        previousRender: (0, $df5bef30413a053b$export$9cd59f9826255e47)(grid)
    };
}
const $ad2bcec7a0192558$var$el = (id)=>document.getElementById(id);
new (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports)))((_)=>{
    let conditions;
    let state;
    const reset = ()=>{
        conditions = $ad2bcec7a0192558$var$generateConditions((hexColor)=>_.color(hexColor));
        state = $ad2bcec7a0192558$var$generateState(conditions);
        $ad2bcec7a0192558$var$el('rule').textContent = conditions.rule;
        _.background(conditions.backgroundColor);
    };
    function drawRect({ row: row, col: col }) {
        const { cellSize: cellSize } = conditions;
        _.rect(col * cellSize, row * cellSize, cellSize, cellSize);
    }
    function move(ant) {
        const { cellsPerSide: cellsPerSide } = conditions;
        const rowDelta = -Math.round(Math.sin(ant.direction));
        const colDelta = Math.round(Math.cos(ant.direction));
        ant.row = (0, $df5bef30413a053b$export$842a2cf37af977e1)(ant.row + rowDelta, cellsPerSide);
        ant.col = (0, $df5bef30413a053b$export$842a2cf37af977e1)(ant.col + colDelta, cellsPerSide);
    }
    function step() {
        const { incrementColorIndex: incrementColorIndex, turns: turns } = conditions;
        const { ants: ants, grid: grid } = state;
        for (const ant of ants){
            const { row: row, col: col, direction: direction } = ant;
            const currentColorIndex = grid[row][col];
            grid[row][col] = incrementColorIndex(currentColorIndex);
            ant.direction = turns[currentColorIndex](direction);
            move(ant);
        }
    }
    _.setup = function() {
        const renderer = _.createCanvas($ad2bcec7a0192558$var$CANVAS_SIZE, $ad2bcec7a0192558$var$CANVAS_SIZE);
        $ad2bcec7a0192558$var$el('canvasContainer').appendChild($ad2bcec7a0192558$var$el(renderer.id()));
        reset();
        setInterval(reset, 15000);
        _.strokeWeight(0);
    };
    _.draw = function() {
        const { antColor: antColor, getColor: getColor, stepsPerFrame: stepsPerFrame } = conditions;
        const { ants: ants, grid: grid, previousRender: previousRender } = state;
        for (const _ of (0, $df5bef30413a053b$export$d02631cccf789723)(stepsPerFrame))step();
        for (const [r, row] of grid.entries())for (const [c, colorIndex] of row.entries()){
            if (previousRender[r][c] === colorIndex) continue;
            _.fill(getColor(colorIndex));
            drawRect({
                row: r,
                col: c
            });
        }
        const currentRender = (0, $df5bef30413a053b$export$9cd59f9826255e47)(grid);
        _.fill(antColor);
        for (const ant of ants){
            drawRect(ant);
            currentRender[ant.row][ant.col] = -1;
        }
        state.previousRender = currentRender;
    };
});
const $ad2bcec7a0192558$var$QUARTER_CIRCLE = 0.5 * Math.PI;
const $ad2bcec7a0192558$var$FULL_CIRCLE = 2 * Math.PI;
function $ad2bcec7a0192558$var$left(direction) {
    return (0, $df5bef30413a053b$export$842a2cf37af977e1)(direction + $ad2bcec7a0192558$var$QUARTER_CIRCLE, $ad2bcec7a0192558$var$FULL_CIRCLE);
}
function $ad2bcec7a0192558$var$right(direction) {
    return (0, $df5bef30413a053b$export$842a2cf37af977e1)(direction - $ad2bcec7a0192558$var$QUARTER_CIRCLE, $ad2bcec7a0192558$var$FULL_CIRCLE);
}
function $ad2bcec7a0192558$var$noChange(direction) {
    return direction;
}
function $ad2bcec7a0192558$var$parseRule(rule) {
    const colorCount = rule.length;
    function incrementColorIndex(color) {
        return (0, $df5bef30413a053b$export$842a2cf37af977e1)(color + 1, colorCount);
    }
    const turns = rule.map((c)=>$ad2bcec7a0192558$var$RULE_TO_TURN[c] ?? (0, $df5bef30413a053b$export$82a8af9b11518516)(`Unknown rule ${c}`));
    return {
        incrementColorIndex: incrementColorIndex,
        turns: turns
    };
}


//# sourceMappingURL=repo.861d6730.js.map
